// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const sv = {
    login: {
        title: '[[TOK_0]] ComplianceOne',
        subtitle: 'Logga in på ditt konto',
        email: 'E-post',
        password: 'Lösenord',
        sign_in: 'Logga in',
        signing_in: 'Loggar in...',
        mfa_code: 'MFA-kod',
        mfa_placeholder: 'Ange 6-siffrig kod',
        mfa_instruction: 'Ange den 6-siffriga koden från din autentiseringsapp.',
        verify: 'Verifiera',
        verifying: 'Verifierar...',
        forgot_password: 'Glömt lösenord?',
        account_locked: 'Kontot är låst. Försök igen senare.',
        account_deactivated: 'Kontot har inaktiverats. Kontakta din administratör.',
        invalid_mfa: 'Ogiltig MFA-kod. Försök igen.',
        invalid_credentials: 'Ogiltig e-post eller lösenord.',
        login_failed: 'Inloggning misslyckades',
        session_expired: 'Din session har löpt ut. Ladda om sidan och försök igen.',
    },
    auth: {
        forgot_password: {
            title: 'Glömt Lösenord',
            subtitle: 'Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord.',
            send: 'Skicka Återställningslänk',
            sending: 'Skickar...',
            success: 'Om den e-postadressen finns har en länk för lösenordsåterställning skickats.',
            back_to_login: 'Tillbaka till Inloggning',
        },
        reset_password: {
            title: 'Återställ Lösenord',
            subtitle: 'Ange ditt nya lösenord nedan.',
            new_password: 'Nytt Lösenord',
            confirm_password: 'Bekräfta Lösenord',
            reset: 'Återställ Lösenord',
            resetting: 'Återställer...',
            success: 'Ditt lösenord har återställts.',
            go_to_login: 'Gå till Inloggning',
            password_mismatch: 'Lösenorden stämmer inte överens.',
            invalid_token: 'Ogiltig eller saknad återställningstoken. Begär en ny länk för lösenordsåterställning.',
            requirements_title: 'Lösenordskrav:',
            password_requirements: 'Lösenordet måste uppfylla följande krav:',
            rules: {
                min_length: 'Minst 12 tecken',
                uppercase: 'Minst en versal',
                lowercase: 'Minst en gemen',
                digit: 'Minst en siffra',
                special: 'Minst ett specialtecken',
            },
        },
        verify_email: {
            title: 'E-postverifiering',
            verifying: 'Verifierar din e-postadress...',
            success: 'Din e-post har verifierats.',
            invalid_token: 'Ogiltig eller saknad verifieringstoken.',
            failed: 'E-postverifiering misslyckades. Token kan vara ogiltig eller utgången.',
            go_to_login: 'Gå till Inloggning',
        },
        offline: {
            title: 'Du är offline',
            message: 'Det verkar som att du har förlorat din internetanslutning. Kontrollera ditt nätverk och försök igen.',
        },
    },
    intake: {
        title: 'Begäran om Datarättigheter',
        subtitle: 'Skicka in en begäran om datarättigheter till vår organisation',
        fields: {
            full_name: 'Fullständigt Namn',
            email: 'E-postadress',
            phone: 'Telefonnummer (valfritt)',
            request_type: 'Typ av Begäran',
            description: 'Beskriv Din Begäran',
            preferred_language: 'Föredraget Språk',
            consent: 'Jag samtycker till behandlingen av denna begäran',
        },
        submit: 'Skicka Begäran',
        validation: {
            name_required: 'Fullständigt namn krävs',
            email_required: 'En giltig e-postadress krävs',
            type_required: 'Vänligen välj en typ av begäran',
            description_required: 'Vänligen beskriv din begäran',
            consent_required: 'Du måste samtycka till behandlingen för att fortsätta',
        },
        error_title: 'Fel',
        config_load_error: 'Kunde inte ladda konfigurationen. Kontrollera webbadressen.',
        organization_label: 'Organisation',
        customer_reference: 'Kundreferensnummer',
        country: 'Land / Jurisdiktion',
        preferred_channel: 'Föredragen svarskanal',
        channels: {
            email: 'E-post',
            postal: 'Post',
            phone: 'Telefon',
            portal: 'Portalen',
        },
        confirmation: {
            title: 'Begäran Mottagen',
            message: 'Din begäran har registrerats. Ditt referensnummer är:',
            next_steps: 'Vi kommer att behandla din begäran så snart som möjligt i enlighet med tillämplig lag. Den förväntade handläggningstiden är 30 arbetsdagar.',
        },
    },
    request_types: {
        access: 'Tillgång (DSAR)',
        deletion: 'Radering',
        correction: 'Rättelse / Uppdatering',
        objection: 'Invändning',
        portability: 'Dataportabilitet',
        restriction: 'Begränsning av Behandling',
        consent_withdrawal: 'Återkallande av samtycke',
    },
    statuses: {
        new: 'Ny',
        in_review: 'Under Granskning',
        waiting_on_requester: 'Väntar på Sökande',
        waiting_on_internal_data: 'Väntar på Intern Data',
        approved: 'Godkänd',
        closed: 'Stängd',
        rejected: 'Avvisad',
    },
    admin: {
        nav: {
            rights_requests: 'Begäran om Rättigheter',
            templates: 'Mallar',
            response_templates: 'Svarsmallar',
            data_mapping: 'Datakartläggning',
            governance: 'Styrning',
            consent: 'Samtycke',
            assessments: 'Bedömningar',
            classification: 'Klassificering',
            monitoring: 'Övervakning',
            incidents: 'Incidenter',
            onboarding: 'Introduktion',
            connectors: 'Anslutningar',
            vendor_risk: 'Leverantörsrisk',
            deletion_orchestration: 'Raderingshantering',
            discovery: 'Dataupptäckt',
            incident_ops: 'Incidenthantering',
            program_governance: 'Programstyrning',
            access_accountability: 'Åtkomstansvar',
            consent_properties: 'Samtyckesegenskaper',
            localization: 'Lokalisering',
            partner_workspace: 'Partnerarbetsyta',
            audit_trail: 'Granskningslogg',
            forseti: 'Forseti',
            settings: 'Inställningar',
            help_center: 'Hjälpcenter',
            dashboard: 'Översikt',
            platform: 'Plattform',
            integrations: 'Integrationer',
            cmp_dsar_sync: 'CMP DSAR-synkronisering',
            cmp_integration: 'CMP-integration',
            purpose_mapping: 'Ändamålskoppling',
            webhook_config: 'Webhook-konfiguration',
            bulk_sync: 'Masssynkronisering',
            privacy_scanner: 'Integritetsskanner',
            privacy_monitoring: 'Integritetsövervakning',
            real_time_scanner: 'Realtidsskanner',
            compliance_forms: 'Efterlevnadsformulär',
            forms_dashboard: 'Formuläröversikt',
            form_templates: 'Mallar',
            form_catalog: 'Formulärkatalog',
            pack_catalog: 'Paketkatalog',
            org_groups: 'Organisationsgrupper',
            consolidation: 'Konsolidering',
            organizations: 'Organisationer',
            org_list: 'Alla Organisationer',
            intake_configs: 'Intagskonfigurationer',
            task_management: 'Uppgiftshantering',
            unified_audit: 'Samlad Revision',
            evidence_packs: 'Bevispaket',
            audit_periods: 'Revisionsperioder',
            regulatory_updates: 'Regelverksuppdateringar',
            departments: 'Avdelningar',
        },
        sidebar_category_data_privacy_rights: 'Dataskydd & Rättigheter',
        sidebar_category_vendor_third_party: 'Leverantörs- & Tredjepartshantering',
        sidebar_category_risk_assessment: 'Risk & Bedömning',
        sidebar_category_operations_automation: 'Drift & Automatisering',
        sidebar_category_task_workflow: 'Uppgifts- & Arbetsflödeshantering',
        sidebar_groups: {
            consent_cmp_webhooks: '[[TOK_0]] & Webhooks',
            data_mapping_ropa: 'RoPA Register',
            data_mapping_classification: 'Klassificering',
            data_mapping_governance: 'Styrning',
            access_live_monitoring: 'Liveövervakning',
            access_reviews_investigations: 'Recensioner & undersökningar',
            access_evidence_policies: 'Bevis och policyer',
            classification_taxonomies: 'Taxonomier och etiketter',
            classification_workflow: 'Arbetsflöde',
            classification_insights: 'Insikter',
            connectors_runtime: 'Körtid',
            connectors_due_diligence: 'Due Diligence',
            connectors_coverage: 'Täckning',
            cp_definitions: 'Definitioner',
            cp_lifecycle: 'Livscykel',
            cp_quality: 'Kvalitet och bevis',
            deletion_execution: 'Utförande',
            deletion_vendors: 'Försäljare',
            deletion_evidence: 'Bevis och integration',
            discovery_rules: 'Regler & mallar',
            discovery_scanning: 'Skanning',
            discovery_review: 'Granska arbetsflöde',
            discovery_insights: 'Insikter',
            governance_oversight: 'Tillsyn',
            governance_reporting: 'Rapportering',
            governance_vendors: 'Försäljare och gränsöverskridande',
            governance_lifecycle: 'Livscykel',
            incident_ops_dashboards: 'Instrumentbrädor',
            incident_ops_sla: '[[TOK_0]] Konfig',
            incident_ops_playbooks: 'Handlingsplaner',
            incident_ops_vendor_regulator: 'Försäljare & Regulator',
            incident_ops_evidence: 'Bevis och recension',
            incidents_workload: 'Arbetsbelastning',
            incidents_regulatory: 'Reglerande',
            incidents_reporting: 'Rapportering',
            localization_content: 'Innehåll',
            localization_regulatory: 'Reglerande',
            localization_observability: 'Observerbarhet',
            monitoring_metrics: 'Mätvärden',
            monitoring_programs: 'Program',
            monitoring_tasks: 'Uppgifter',
            monitoring_controls: 'Kontroller',
            org_entities: 'Entiteter',
            org_config: 'Konfiguration',
            org_frameworks: 'Frameworks & Rollup',
            partner_overview: 'Översikt',
            partner_partners: 'Partners',
            partner_delivery: 'Leverans',
            partner_support: 'Support',
            platform_identity: 'Identitet & roller',
            platform_access_control: 'Åtkomstkontroll',
            platform_auth_session: 'Autentisering och session',
            platform_access_reviews: 'Åtkomstgranskningar',
            platform_files: 'Filer',
            platform_notifications: 'Aviseringar',
            platform_module_config: 'Modulkonfiguration',
            platform_ops: 'Drift och loggar',
            pg_health: 'Program hälsa',
            pg_maturity: 'Mognad',
            pg_audit: 'Revision & bevis',
            pg_obligations: 'Skyldigheter',
            pg_documents: 'Dokument',
            vr_overview: 'Översikt',
            vr_onboarding: 'Onboarding',
            vr_assessment: 'Bedömning',
            vr_oversight: 'Tillsyn',
        },
        tickets: {
            title: 'Begäran om Rättigheter',
            create: 'Skapa Begäran',
            filters: 'Filtrera',
            search_placeholder: 'Sök ärenden...',
            export_csv: 'Exportera [[TOK_0]]',
            exporting: 'Exporterar...',
            bulk_export_failed: 'Massexport misslyckades',
            bulk_export: {
                label: 'Exportera',
                format: {
                    pdf: '[[TOK_0]] Sammanfattning',
                    zip: 'ZIP (bevispaket per ärende)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Detta kommer att generera ungefär [[TOK_1]] case-paket – kan ta flera minuter. Fortsätta?',
                blocked_over_500: 'Begränsa filtret till 500 eller färre fall innan du exporterar ZIP (nuvarande: [[TOK_1]]).',
                success: 'Massexport har sparats i filläsaren ([[TOK_1]] fall)',
                failed: 'Massexport misslyckades',
                continue: 'Fortsätt',
                cancel: 'Avbryt',
            },
            no_results: 'Inga begäranden hittades',
            ticket_id: 'Ärende-ID',
            request_type: 'Typ av Begäran',
            requester: 'Sökande',
            source: 'Källa',
            all_sources: 'Alla källor',
            assigned_to: 'Tilldelad Till',
            created: 'Skapad',
            load_error: 'Kunde inte ladda ärenden. Försök igen.',
            case_creation_failed: 'Skapa ärende misslyckades',
            business_unit: 'Affärsenhet',
            reference: 'Referens',
            sla: {
                title: 'SLA-status',
                on_track: '{days} dagar kvar',
                approaching: 'Närmar sig deadline',
                overdue: '{days} dagar försenad',
                ack_overdue: '{hours}t efter bekräftelsefristen',
                ack_warning: 'Bekräftelse snart förfallen',
                closed: 'Stängd',
                completed_in: 'Slutförd på {days} dagar',
            },
        },
        templates: {
            title: 'Svarsmallar',
            new: 'Ny Mall',
            edit: 'Redigera Mall',
            all_types: 'Alla Typer',
            all_locales: 'Alla Språk',
            type_access: 'Tillgång/DSAR',
            type_deletion: 'Radering',
            type_correction: 'Rättelse',
            type_objection: 'Invändning',
            type_portability: 'Portabilitet',
            type_other: 'Annat',
            type_restriction: 'Begränsning',
            type_all: 'Alla',
            locale_en: 'Engelska',
            locale_vi: 'Vietnamesiska',
            locale_all: 'Båda',
            name: 'Namn',
            request_type: 'Typ av Begäran',
            locale: 'Språk',
            subject: 'Ämne',
            body: 'Brödtext',
            name_placeholder: 'Mallnamn...',
            subject_placeholder: 'E-post-/brevämne...',
            body_placeholder: 'Mallens brödtext. Använd {{requester_name}}, {{ticket_id}}, {{request_type}}, {{org_name}}, {{response_date}} som platshållare.',
            available_placeholders: 'Tillgängliga platshållare:',
            create_template: 'Skapa Mall',
            preview: 'Förhandsgranska',
            close_preview: 'Stäng Förhandsgranskning',
            default_badge: 'Standard',
            no_templates: 'Inga mallar hittades',
            confirm_delete: 'Radera denna mall?',
            load_error: 'Kunde inte ladda mallar. Försök igen.',
            create_error: 'Kunde inte skapa mall',
            update_error: 'Kunde inte uppdatera mall',
            delete_error: 'Kunde inte radera mall',
            preview_error: 'Kunde inte förhandsgranska mall',
            response_templates_badge: 'Svarsmallar',
            browse_form_templates: 'Bläddra i Efterlevnadsformulärmallar',
            templates_loaded: 'Mallar laddade',
            sample_organization: 'Exempelorganisation',
        },
        detail: {
            requester_info: 'Information om Sökande',
            status: 'Tillstånd',
            assignment: 'Tilldelning',
            notes: 'Anteckningar',
            audit_trail: 'Granskningslogg',
            add_note: 'Lägg till Anteckning',
            case_not_found: 'Ärende hittades inte',
            load_error: 'Kunde inte ladda ärende. Försök igen.',
            note_error: 'Kunde inte lägga till anteckning. Försök igen.',
            submitted_from: 'Inskickad från',
            via_cmp: 'via [[TOK_1]] [[TOK_0]]',
            cmp_ticket: 'CMP-ärende:',
            select_template: 'Välj en mall',
            direction_inbound: '[[TOK_0]] → GRC',
            direction_outbound: 'GRC → [[TOK_0]]',
            tabs: {
                details: 'Detaljer',
                evidence: 'Bevisning',
                communications: 'Kommunikation',
                escalations: 'Eskaleringar',
                audit_trail: 'Granskningslogg',
                fulfillment: 'Uppfyllande',
                response: 'Svar',
                extension: 'Förlängning',
            },
            requester: {
                name: 'Namn',
                email: 'E-post',
                phone: 'Telefon',
                language: 'Språk',
                source: 'Källa',
                customer_ref: 'Kundreferens',
                country: 'Land',
                preferred_channel: 'Föredragen Kanal',
            },
            sla: {
                title: 'SLA',
                on_track: 'Inom Tidsram',
                due_soon: 'Snart Förfallen',
                overdue: 'Försenad',
                days_remaining: 'd kvar',
                due_date: 'Förfallodatum',
                breached: 'Överskriden',
                paused: 'Pausad',
                total_paused_days: 'Totalt Antal Pausade Dagar',
                days_elapsed: 'Förflutna Dagar',
                progress: 'Framsteg',
            },
            identity: {
                title: 'Identitetsverifiering',
                verified: 'Verifierad',
                not_verified: 'Ej verifierad',
                method: 'Metod',
                notes: 'Anteckningar',
                verified_by: 'Verifierad Av',
                verified_at: 'Verifierad Vid',
                warning: 'Identitet ännu inte verifierad.',
                verify_button: 'Verifiera Identitet',
                select_method: '-- Välj --',
                methods: {
                    email_confirmation: 'E-postbekräftelse',
                    id_document: 'ID-handling',
                    phone_call: 'Telefonsamtal',
                    in_person: 'Personligen',
                    other: 'Annat',
                },
            },
            closure: {
                reason: 'Avslutningsorsak',
                summary: 'Avslutningssammanfattning',
                summary_placeholder: 'Sammanfattning av hur begäran hanterades...',
                reason_required: 'Avslutningssammanfattning och orsak krävs',
                response_not_sent: 'Ett formellt svar måste skickas till den registrerade innan detta ärende kan avslutas',
                reasons: {
                    fulfilled: 'Uppfylld',
                    partially_fulfilled: 'Delvis Uppfylld',
                    unfounded: 'Ogrundad',
                    excessive: 'Överdriven',
                    withdrawn: 'Återkallad',
                    duplicate: 'Dubblett',
                    identity_unverified: 'Identitet Ej Verifierad',
                },
            },
            export_title: 'Exportera',
            export_pdf: 'Exportera PDF',
            export_zip: 'Exportera ZIP',
            case_file_pdf: 'Exportera [[TOK_0]] (ärendefil)',
            evidence_pack_zip: 'Exportera ZIP (Evidence Pack)',
            cross_border_warning: 'Gränsöverskridande överföring upptäckt - gränsöverskridande underlag krävs',
            breach: {
                flag_btn: 'Flagga som intrångsorsakande',
                modal: {
                    title: 'Flagga fall som orsakar intrång',
                    type_label: 'Typ av brott',
                    type: {
                        misdirected_response: 'Felriktat svar',
                        unauthorised_disclosure: 'Otillåtet avslöjande',
                        identity_mismatch: 'Identitetsfel överensstämmer',
                        other: 'Annat',
                    },
                    description: 'Beskrivning (valfritt)',
                    description_placeholder: 'Vad hände? (max 1000 tecken)',
                    confirm: 'Flagga och starta 72h arkiveringsklocka',
                    cancel: 'Avbryt',
                    flagging: 'Flaggar...',
                },
                banner: {
                    title: 'Överträdelse flaggad: [[TOK_1]]',
                    detected_at: 'Upptäcktes vid [[TOK_1]]',
                    filing_deadline: '72h [[TOK_2]] sista ansökningsdag: om [[TOK_1]] timmar',
                    overdue: '72h [[TOK_0]] deadline för anmälan: FÖRSENAD',
                },
                toasts: {
                    flagged: 'Fall flaggat som intrång - 72 timmars klocka startade',
                    flag_failed: 'Det gick inte att flagga ärendet som intrångsorsakande',
                },
            },
            export: {
                generating: 'Genererar... vänligen vänta',
                success: 'Exporten sparad till filläsaren',
                failed: 'Exporten misslyckades - kontrollera granskningsloggen',
            },
            no_notes: 'Inga anteckningar ännu',
            assign_placeholder: 'Användar-ID att tilldela...',
            reassign: 'Tilldela om',
            evidence: {
                checklist_title: 'Bevischecklista',
                complete_pct: '% klart',
                no_checklist: 'Inga checklistepunkter',
                attachments: 'Bilagor',
                upload_attachment: 'Ladda upp bilaga',
                upload_button: 'Ladda upp',
                uploading: 'Laddar upp...',
                attachment_uploaded: 'Bilaga uppladdad',
                upload_error: 'Uppladdning misslyckades',
                category: 'Kategori',
                categories: {
                    identity_proof: 'Identitetsbevis',
                    correspondence: 'Korrespondens',
                    internal_data: 'Intern data',
                    legal: 'Juridisk',
                    other: 'Övrigt',
                },
                no_attachments: 'Inga bilagor',
                references_title: 'Bevisreferenser',
                no_references: 'Inga referenser',
                add_reference: 'Lägg till Referens',
                ref_type: 'Typ',
                ref_value: 'Värde',
                ref_desc: 'Beskrivning',
                ref_value_placeholder: 'URL, e-post-ID eller referens...',
                ref_desc_placeholder: 'Beskrivning...',
                ref_types: {
                    url: 'URL',
                    email_id: 'E-post-ID',
                    crm_record: 'CRM-post',
                    ticket_ref: 'Ärendereferens',
                    other: 'Annat',
                },
            },
            communications: {
                title: 'Kommunikation',
                add: 'Lägg till Meddelande',
                no_records: 'Ingen kommunikation registrerad',
                direction: 'Riktning',
                channel: 'Kanal',
                visibility: 'Synlighet',
                subject: 'Ämne',
                body: 'Brödtext',
                send: 'Skicka',
                inbound: 'Inkommande',
                outbound: 'Utgående',
                internal: 'Intern',
                external: 'Externt',
                tab_all: 'All',
                tab_internal: 'Internt',
                tab_external: 'Externt',
                subject_placeholder: 'Ämne (valfritt)',
                body_placeholder: 'Meddelandetext...',
                channels: {
                    email: 'E-post',
                    portal: 'Portalen',
                    phone: 'Telefon',
                    postal: 'Post',
                    in_person: 'Personligen',
                },
                apply_template: 'Tillämpa Mall',
                select_template: 'Välj en mall...',
                no_templates: 'Inga mallar tillgängliga',
                template_applied: 'Mall tillämpad på svar.',
                template_apply_error: 'Kunde inte tillämpa mall.',
            },
            escalations: {
                title: 'Eskaleringshistorik',
                no_events: 'Inga eskaleringshändelser',
                tier: 'Nivå',
                threshold: 'Tröskelvärde',
                action: 'Åtgärd',
                target: 'Mål',
                triggered_at: 'Utlöst Vid',
            },
            cmp_sync: {
                title: 'AesirX CMP-synkronisering',
                sync_status: 'Synkroniseringsstatus',
                last_synced: 'Senast Synkroniserad',
                not_synced: 'Ej Synkroniserad',
                resync: 'Synkronisera om Nu',
                syncing: 'Synkroniserar...',
                sync_history: 'Synkroniseringshistorik (Senaste 10)',
                direction: 'Riktning',
                time: 'Tid',
                retries: 'Försök',
                error_col: 'Fel',
            },
            audit: {
                filter_event_placeholder: 'Filtrera efter händelsetyp...',
                filter_actor_placeholder: 'Filtrera efter aktör...',
            },
            fulfillment: {
                title: 'Avdelningsuppfyllande',
                assign_departments: 'Tilldela avdelningar',
                department: 'Avdelning',
                assignee: 'Tilldelad',
                deadline: 'Tidsfrist',
                evidence_count: 'Bevisning',
                signoff: 'Godkännande',
                signed_off: 'Godkänd',
                pending_signoff: 'Väntande',
                start_button: 'Starta',
                complete_button: 'Markera som klar',
                signoff_button: 'Logga av',
                no_tasks: 'Inga uppfyllandeuppgifter tilldelade ännu.',
                tasks_table: 'Uppfyllandeuppgifter',
                progress_label: 'Uppfyllandeförlopp',
                overdue: 'försenad',
                assigned_success: 'Avdelningsuppfyllandeuppgift tilldelad.',
                assign_error: 'Kunde inte tilldela uppfyllandeuppgift.',
                signoff_success: 'Avdelningsgodkännande registrerat.',
                signoff_error: 'Kunde inte registrera godkännande.',
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Lägg till bevis',
                evidence_uploaded: 'Bevis uppladdad och länkad',
                evidence_upload_error: 'Uppladdning av bevis misslyckades',
                suggest_data_stores: 'Föreslå datalager',
                suggest_error: 'Kunde inte ladda datalagringsförslag.',
                suggest_stores_title: 'Föreslagna datalagringar',
                suggest_stores_none: 'Inga datalager matchar detta fall. Konfigurera system i Data Mapping för att förbättra förslagen.',
                suggest_stores_add: 'Lägg till fodral',
                suggest_stores_added: 'Datalager har lagts till i fodralet',
                no_departments_title: 'Inga avdelningar konfigurerade',
                no_departments_body: 'Avdelningar låter dig dirigera DSR-uppfyllelseuppgifter till en funktion (sekretess, juridik, HR, IT-operationer). Installera exempelavdelningar eller be din administratör att konfigurera avdelningar i organisationsinställningarna.',
                no_departments_cta: 'Installera exempeldata',
                department_placeholder: 'Avdelningsnamn...',
                assignee_placeholder: 'Användar-ID att tilldela...',
                assign_button: 'Tilldela',
                status_pending: 'Väntande',
                status_in_progress: 'Pågår',
                status_completed: 'Slutförd',
                status_verified: 'Verifierad',
                confirm_approve: 'Är du säker på att du vill godkänna denna förlängning?',
                confirm_deny: 'Är du säker på att du vill neka denna förlängning?',
            },
            response: {
                title: 'Svarsgenerering',
                select_template: 'Svarsmall',
                choose_template: 'Välj en mall...',
                generate: 'Generera svar',
                preview: 'Svarsförhandsgranskning',
                send: 'Skicka svar',
                delivery_method: {
                    label: 'Leveransmetod',
                    email: 'E-post',
                    portal: 'Portal',
                    postal: 'Postpost',
                    in_person: 'Personligen',
                },
                recipient: {
                    email: 'Mottagarens e-post',
                    portal: 'Portal användar-ID',
                    address: 'Postadress',
                },
                auto_generate_btn: 'Generera och skicka svar',
                auto_generate_success: 'Respons genererad och levererad',
                auto_generate_missing_recipient: 'Ange en mottagare innan du skickar.',
                auto_fields: 'Automatiskt ifyllda fält',
                case_id: 'Ärende-ID',
                requester_name: 'Begärandens namn',
                rights_type: 'Rättighetstyp',
                history: 'Skickade svar',
                generated_at: 'Genererad',
                confirmation: 'Bekräftelse',
                sent_label: 'Skickad',
                draft_label: 'Utkast',
                generated_success: 'Svar genererat.',
                generate_error: 'Kunde inte generera svar.',
                sent_success: 'Svar skickat.',
                send_error: 'Kunde inte skicka svar.',
                load_error: 'Kunde inte ladda svarsmallar.',
                pdf_title: 'Svarsbrev till registrerad person',
                download_pdf: 'Ladda ner PDF',
                download_all: 'Ladda ner alla',
                download_error: 'Kunde inte ladda ner svar',
            },
            extension: {
                title: 'Tidsfritsförlängningar',
                acknowledgment_deadline: 'Bekräftelsefrist',
                fulfillment_deadline: 'Uppfyllandefrist',
                request_extension: 'Begär förlängning',
                reason: 'Orsak',
                reason_placeholder: 'Orsak till begäran om ytterligare tid...',
                additional_days: 'Ytterligare dagar',
                submit_request: 'Skicka förlängningsbegäran',
                history: 'Förlängningshistorik',
                requested_at: 'Begärd',
                approve: 'Godkänn',
                deny: 'Avslå',
                request_success: 'Förlängningsbegäran skickad.',
                request_error: 'Kunde inte skicka förlängningsbegäran.',
                approved_success: 'Förlängning godkänd.',
                denied_success: 'Förlängning avslagen.',
                decision_error: 'Kunde inte behandla förlängningsbeslut.',
                status_pending: 'Väntande',
                status_approved: 'Godkänd',
                status_denied: 'Nekad',
                confirm_approve: 'Är du säker på att du vill godkänna denna förlängningsbegäran?',
                confirm_deny: 'Är du säker på att du vill neka denna förlängningsbegäran?',
                decided_by: 'Beslutad av',
            },
        },
        audit: {
            export_csv: 'Exportera CSV',
            exporting: 'Exporterar...',
            search_placeholder: 'Sök granskningsdetaljer...',
            filter_by_actor: 'Filtrera efter aktör...',
            all_event_types: 'Alla Händelsetyper',
            seq: '#',
            timestamp: 'Tidsstämpel',
            event: 'Händelse',
            case_col: 'Ärende',
            actor: 'Aktör',
            summary: 'Sammanfattning',
            no_events: 'Inga granskningshändelser hittades',
            export_success: 'Granskningsspåret har exporterats.',
            export_error: 'Kunde inte exportera gransknings-CSV',
            load_error: 'Kunde inte ladda granskningslogg. Försök igen.',
            announce_loaded: 'Granskningslogg laddad',
            start_date: 'Startdatum',
            end_date: 'Slutdatum',
            per_page: '{count} / sida',
            unknown: 'Okänd',
            source_filter: {
                label: 'Källa',
                all: 'Alla',
                module: 'Modul',
                forseti: 'Forseti',
                aria_label: 'Filtrera granskningshändelser efter källa',
            },
            event_types: {
                case_created: 'Ärende Skapat',
                status_changed: 'Status Ändrad',
                case_assigned: 'Ärende Tilldelat',
                note_added: 'Anteckning Tillagd',
                attachment_added: 'Bilaga Tillagd',
                attachment_deleted: 'Bilaga Raderad',
                reference_added: 'Referens Tillagd',
                checklist_updated: 'Checklista Uppdaterad',
                identity_verified: 'Identitet Verifierad',
                closure_summary_added: 'Avslutningssammanfattning',
                approval_granted: 'Godkännande Beviljat',
                template_applied: 'Mall Tillämpad',
                export_generated: 'Export Genererad',
                sla_warning: 'SLA-varning',
                sla_overdue: 'SLA Försenad',
            },
            unified_audit: {
                title: 'Samlat Revisionsspår',
                module_filter: 'Modul',
                framework_filter: 'Ramverk',
                select_framework: 'Välj ett ramverk...',
                entity_type_filter: 'Entitetstyp',
                action_filter: 'Åtgärd',
                actor_filter: 'Aktör',
                select_actor: 'Välj en aktör...',
                search_filter: 'Sök',
                search_placeholder: 'Sök i revisionshändelser...',
                filters_heading: 'Filter',
                date_range: 'Datumintervall',
                no_events_found: 'Inga revisionshändelser hittades.',
                event_count: 'Antal händelser',
                action: 'Åtgärd',
                actor: 'Aktör',
                date_range_start: 'Startdatum för intervall',
                date_range_end: 'Slutdatum för intervall',
                filtering_events: 'Filtrerar revisionshändelser',
                framework_codes: 'Ramverkskoder',
                entity_type_col: 'Enhetstyp',
                aria_table: 'Samlade revisionshändelser',
                page_of: 'Sida {page} av {total}',
                entity_types: {
                    user: 'Användare',
                    case: 'Fall',
                    incident: 'Incident',
                    assessment: 'Bedömning',
                    vendor: 'Försäljare',
                    consent: 'Samtycke',
                    policy: 'Policy',
                    data_map: 'Datakarta',
                },
                actions: {
                    create: 'Skapa',
                    update: 'Uppdatering',
                    delete: 'Ta bort',
                    view: 'Visa',
                    export: 'Exportera',
                    status_change: 'Statusändring',
                },
            },
            evidence_packs: {
                title: 'Revisionsbevispaket',
                assemble_pack: 'Sammanställ Bevispaket',
                framework: 'Ramverk',
                select_framework: 'Välj ett ramverk...',
                framework_code_label: 'Ramverkskod',
                entity_types: 'Entitetstyper',
                select_entity_types: 'Välj entitetstyper...',
                period: 'Period',
                period_start: 'Periodstart',
                period_end: 'Periodslut',
                completeness: 'Fullständighet',
                no_packs_found: 'Inga bevispaket hittades.',
                verify: 'Verifiera',
                export_pack: 'Exportera',
                exporting: 'Exporterar...',
                pack_assembled: 'Bevispaket sammanställt',
                pack_exported: 'Bevispaket exporterat',
                aria_table: 'Revisionsbevispaket',
                aria_export_pack: 'Exportera paket',
                export_format: 'Exportformat',
                export_in_progress: 'Export pågår...',
                status_draft: 'Utkast',
                status_assembled: 'Sammanställt',
                status_verified: 'Verifierat',
                status_submitted: 'Inskickat',
                entity_type_labels: {
                    user: 'Användare',
                    case: 'Fall',
                    incident: 'Incident',
                    assessment: 'Bedömning',
                    vendor: 'Försäljare',
                    consent: 'Samtycke',
                    policy: 'Policy',
                    data_map: 'Datakarta',
                },
                template_id: 'Mall-ID',
                csv_headers: {
                    module: 'Modul',
                    action: 'Åtgärd',
                    actor_id: 'Skådespelare',
                    entity_type: 'Enhetstyp',
                    entity_id: 'Enhets-ID',
                    summary: 'Sammanfattning',
                    timestamp: 'Tidsstämpel',
                    framework_code: 'Ramverk',
                },
                export_header_framework: 'Evidenspaket — Ramverk: {framework}',
                export_header_period: 'Period: {start} till {end}',
                export_header_completeness: 'Fullständighet: {score}%',
                export_header_status: 'Status: [[TOK_1]]',
            },
            audit_periods: {
                title: 'Revisionsperioder',
                create_period: 'Skapa Revisionsperiod',
                framework_code_label: 'Ramverkskod',
                select_framework: 'Välj ett ramverk...',
                period_label: 'Periodetikett',
                period_start: 'Periodstart',
                period_end: 'Periodslut',
                start: 'Starta',
                end: 'Slut',
                framework: 'Ramverk',
                retention_days: 'Lagringsdagar',
                no_periods_found: 'Inga revisionsperioder hittades.',
                period_created: 'Revisionsperiod skapad',
                aria_table: 'Revisionsperioder',
                suggested_boundaries: 'Föreslagna gränser',
                suggested_boundaries_info: 'Föreslagna periodgränser härleds från varje ramverks regulatoriska rapporteringscykel. Justera efter behov för din organisation.',
                reporting_cycle: 'Rapporteringscykel',
                suggested_start: 'Föreslagen start',
                suggested_end: 'Föreslagen slut',
                suggested_next: 'Föreslagen nästa period',
                cycle_monthly: 'Månadsvis',
                cycle_quarterly: 'Kvartalsvis',
                cycle_semi_annual: 'Halvårsvis',
                cycle_annual: 'Årlig',
                cycle_custom: 'Anpassad',
                period_deleted: 'Revisionsperiod raderad',
            },
        },
        create_case: {
            customer_ref: 'Kundreferens',
            country: 'Land / Jurisdiktion',
            preferred_channel: 'Föredragen Kanal',
            channels: {
                email: 'E-post',
                postal: 'Post',
                phone: 'Telefon',
                portal: 'Portalen',
            },
            source: 'Källa',
            sources: {
                admin_manual: 'Administratörsmanual',
                public_form: 'Offentlig form',
                cmp_gateway: '[[TOK_0]] Gateway',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Telefon mottagen',
                postal_received: 'Post mottagen',
                email_received: 'E-post mottaget',
                in_person: 'In-Person',
                legacy_import: 'Äldre import',
            },
            required_fields: 'Begärantyp, namn och e-post krävs',
            create_error: 'Kunde inte skapa ärende',
        },
        settings: {
            title: 'Inställningar',
            request_types: 'Typer av Begäran',
            request_types_desc: 'Konfigurera vilka begärantyper som är aktiverade för det publika intaget.',
            notifications: 'Aviseringar',
            ticket_numbering: 'Ärendenumrering',
            ticket_format: 'Aktuellt format',
            ticket_prefix: 'Förled',
            ticket_prefix_note: 'ej konfigurerbart i Sprint 1.0.0',
            sla_deadlines: 'SLA-tidsfrister',
            sla_desc: 'Ange maximal svarstid (i kalenderdagar) för varje begärantyp. Ärenden som närmar sig tröskelvärdet kommer att visa varningar.',
            days: 'dagar',
            warning_threshold: 'Varningströskel',
            escalation_label: 'Aktivera automatisk eskalering vid SLA-överträdelse',
            save_sla: 'Spara SLA-konfiguration',
            saving: 'Sparar...',
            saved: 'Sparades',
            announce_loaded: 'Inställningar laddade',
            email_on_creation: 'E-postavisering vid skapande av ärende',
            send_confirmation: 'Skicka bekräftelsemail till sökande',
            users: 'Användare',
            roles: 'Roller',
            api_keys: '[[TOK_0]] Nycklar',
            mfa: 'MFA',
            sessions: 'Sessioner',
            webhooks: 'Webhooks',
            modules: 'Moduler',
            deadline_labels: {
                access: 'Tillgång (DSAR)',
                deletion: 'Radering',
                correction: 'Rättelse',
                portability: 'Portabilitet',
                objection: 'Invändning',
                restriction: 'Begränsning',
                consent_withdrawal: 'Återkallande av samtycke',
            },
        },
        section_assignments: {
            title: 'Avsnittsinföranden',
            assign_section: 'Tilldela avsnitt',
            section_ref: 'Avsnittsnummer',
            section_label: 'Avsnittsetikett',
            department_id: 'Avdelning',
            assignee_id: 'Tilldelad',
            mandatory: 'Obligatorisk',
            assign: 'Tilldela',
            no_assignments: 'Inga avsnittsinföranden',
            status: 'Status',
            completion: 'Slutförande',
            mark_complete: 'Slutför',
        },
        consolidation: {
            title: 'Konsolideringsframsteg',
            add_child: 'Lägg till underuppgift',
            child_task_id: 'Underuppgifts-id',
            department_id: 'Avdelning',
            link: 'Länk',
            overall_completion: 'Totalt slutförande',
            departments_complete: 'Avdelningar klara',
            overdue: 'Försenad',
            ready: 'Redo',
            not_ready: 'Inte redo',
            master_status: 'Övergripande status',
            department_breakdown: 'Avdelningsöversikt',
            department: 'Avdelning',
            status: 'Status',
            completion: 'Slutförande',
            due_date: 'Förfallodatum',
            overdue_flag: 'Försenad',
            child_tasks: 'Underuppgifter',
            task: 'Uppgift',
        },
        conflict_detection: {
            title: 'Konfliktidentifiering',
            unresolved: 'olöst',
            no_conflicts: 'Inga konflikter hittades',
            section: 'Avsnitt',
            field: 'Fält',
            dept_a: 'Avdelning A',
            value_a: 'Värde A',
            dept_b: 'Avdelning B',
            value_b: 'Värde B',
            severity: 'Allvarlighet',
            status: 'Status',
            resolved: 'Löst',
            open: 'Öppen',
            resolve: 'Lös',
        },
        org_maturity: {
            title: 'Organisatorisk Mognad',
            departments: 'Avdelningar',
            department_hierarchy: 'Avdelningshierarki',
            create_department: 'Skapa Avdelning',
            department_name: 'Avdelningsnamn',
            department_code: 'Kod',
            level: 'Nivå',
            division: 'Division',
            department: 'Avdelning',
            team: 'Team',
            parent_department: 'Överordnad Avdelning',
            head_user: 'Avdelningschef',
            no_departments: 'Inga avdelningar konfigurerade.',
            user_mappings: 'Användartilldelningar',
            map_user: 'Tilldela Användare',
            user_id: 'Användar-ID',
            role: 'Roll',
            no_users: 'Inga användare tilldelade denna avdelning.',
            remove: 'Ta bort',
            framework_assignments: 'Ramverkstilldelningar',
            assign_framework: 'Tilldela Ramverk',
            entity_id: 'Enhets-ID',
            entity_type: 'Enhetstyp',
            framework_id: 'Ramverks-ID',
            framework_code: 'Ramverkskod',
            no_assignments: 'Inga ramverkstilldelningar.',
            compliance_rollup: 'Efterlevnadssammanställning',
            entity_name: 'Enhet',
            total_assessments: 'Totala Bedömningar',
            completed: 'Slutförda',
            completion_pct: 'Slutförande %',
            open_gaps: 'Öppna Brister',
            critical_gaps: 'Kritiska',
            compliance_score: 'Poäng',
            no_rollup: 'Ingen data för efterlevnadssammanställning tillgänglig.',
            entity_summary: 'Enhetens Efterlevnadssammanfattning',
            frameworks_assigned: 'Ramverk',
            overall_score: 'Övergripande Poäng',
            load_departments_error: 'Kunde inte ladda avdelningar',
            load_users_error: 'Kunde inte ladda användare',
            department_created: 'Avdelning skapad',
            department_created_announce: 'Avdelning skapad',
            create_department_error: 'Kunde inte skapa avdelning',
            user_mapped: 'Användare mappad',
            user_mapped_announce: 'Användare mappad till avdelning',
            map_user_error: 'Kunde inte koppla användare',
            user_removed: 'Användare borttagen',
            load_rollup_error: 'Kunde inte ladda sammanfattning',
            load_assignments_error: 'Kunde inte ladda tilldelningar',
            framework_assigned: 'Ramverk tilldelat',
            framework_assigned_announce: 'Ramverk tilldelat till enhet',
            assign_framework_error: 'Kunde inte tilldela ramverk',
            assignment_removed: 'Tilldelning borttagen',
            enter_entity_id_placeholder: 'Ange enhets-ID för att visa tilldelningar',
            entity_type_organization: 'Organisation',
            entity_type_department: 'Avdelning',
        },
        onboarding_maturity: {
            title: 'Onboarding Mognad',
            quick_starts: 'Snabbstarter',
            progress: 'Onboarding Framsteg',
            personas: 'Personas vägar',
            persona_onboarding: 'Persona Onboarding',
            quick_start_scenarios: 'Snabbstartsscenarier',
            start: 'Starta',
            restart: 'Starta om',
            estimated_minutes: 'Beräknade minuter',
            steps: 'Steg',
            scenario: 'Scenario',
            no_scenarios: 'Inga snabbstartsscenarier tillgängliga.',
            persona_id: 'Person-ID',
            persona_label: 'Persona',
            role_description: 'Rollbeskrivning',
            primary_modules: 'Primära moduler',
            recommended_tours: 'Rekommenderade turer',
            sample_data_modules: 'Exempel på datamoduler',
            quick_start_scenario: 'Snabbstartsscenario',
            no_personas: 'Inga personliga sökvägar tillgängliga.',
            framework_setup: 'Regulatoriska ramverk',
            framework_code: 'Ramkod',
            framework_name: 'Ramnamn',
            related_modules: 'Relaterade moduler',
            persona_relevance: 'Relevanta personas',
            no_frameworks: 'Inga ramverksinställningar tillgängliga.',
            tier_config: 'Konfiguration av nivåmodul',
            tier: 'Tier',
            available_modules: 'Tillgängliga moduler',
            module_count: 'Antal moduler',
            overall_completion: 'Totalt slutförande',
            wizard_completed: 'Wizard slutförd',
            tours_completed: 'Turer avslutade',
            quick_starts_completed: 'Snabbstarter slutförda',
            selected_frameworks: 'Valda ramar',
            no_progress: 'Ingen information om introduktionsförlopp tillgänglig.',
            detected_persona: 'Upptäckt persona',
            current_tier: 'Nuvarande nivå',
            completion_pct: 'Slutförande',
            progress_page: {
                loaded: 'Framsteg laddat',
                no_progress: 'Inga onboarding-framstegsdata tillgängliga.',
                overall: 'Övergripande framsteg',
                detected_persona: 'Identifierad persona',
                tier: 'Nivå',
                modules: 'moduler',
                wizard: 'Guide',
                completed: 'Slutförd',
                pending: 'Väntande',
                tours: 'Rundturer',
                quick_starts: 'Snabbstarter',
                frameworks: 'Valda ramverk',
                no_frameworks: 'Inga ramverk valda.',
                go_to_wizard: 'Slutför installationsguiden',
                framework_selection: 'Ramverksval',
                framework_toggle: 'Aktivera eller inaktivera ramverk för ditt efterlevnadsprogram.',
                framework_updated: 'Ramverksval uppdaterat.',
                view_tours: 'Visa rundturer',
                view_quick_starts: 'Visa snabbstarter',
            },
            persona_page: {
                description: 'Välj en persona för att se rekommenderade moduler, rundturer och snabbstartsscenarier.',
                no_personas: 'Inga personavägar tillgängliga.',
                modules: 'Moduler',
                tours: 'Rundturer',
                quick_start: 'Snabbstart',
                details: 'Detaljer',
                primary_modules: 'Primära moduler',
                recommended_tours: 'Rekommenderade rundturer',
                framework_options: 'Regulatoriska ramverk',
                no_frameworks: 'Inga alternativ för ramverksinställning tillgängliga.',
                framework_code: 'Ramverkskod',
                framework_label: 'Etikett',
                region: 'Region',
                category: 'Kategori',
                enabled: 'Aktiverad',
                disabled: 'Inaktiverad',
                tier_modules: 'Nivåmodulkonfiguration',
                tiers_loaded: 'Nivåkonfigurationer laddade',
                no_tier_config: 'Ingen nivåkonfiguration tillgänglig.',
                view_tours: 'Visa modulrundturer',
                view_quick_start: 'Starta snabbstart',
                toggle_framework: 'Växla ramverk',
                framework_updated: 'Ramverksval uppdaterat.',
                tier_desc_light: 'Grundläggande integritetsfunktioner — PDPL-efterlevnadsgrunder',
                tier_desc_standard: 'Komplett efterlevnadssvit — alla moduler med arbetsflöden',
                tier_desc_enterprise: 'Avancerad styrning och automatisering — multi-entitet, grupprapportering',
                persona_highlight: 'Dina moduler',
                aria_go_to_module: '[[TOK_1]] — gå till modulen',
                aria_start_tour: 'Starta [[TOK_1]]',
                aria_quick_start: 'Snabbstart: [[TOK_1]]',
                aria_help_article: 'Hjälpartikel: [[TOK_1]]',
                aria_view_framework: '[[TOK_2]][[TOK_3]] – visa ramdetaljer',
                aria_primary_for_persona: '[[TOK_1]] (primärt för denna person)',
                primary_for_persona_suffix: ' (primär för denna person)',
                aria_view_in_persona_paths: '[[TOK_1]] – visa i Persona Paths',
                progress_of_total: '[[TOK_2]] av [[TOK_3]] slutförda',
            },
            quick_starts_page: {
                description: 'Öva vanliga arbetsflöden med guidade snabbstartsscenarier.',
                no_scenarios: 'Inga snabbstartsscenarier tillgängliga.',
                started: 'Snabbstart startad',
                status_completed: 'Slutförd',
                status_in_progress: 'Pågående',
                status_not_started: 'Ej startad',
                minutes: 'min',
                steps: 'steg',
                step: 'Steg',
                restart: 'Starta om',
                start: 'Starta',
                go_to_module: 'Gå till modul',
                next_step: 'Nästa steg',
                complete: 'Slutför',
                reset: 'Återställ',
                step_of: 'av',
                action_navigate: 'Navigera',
                action_form_fill: 'Fyll i formulär',
                action_review: 'Granska',
                action_confirm: 'Bekräfta',
                step_changed: 'Steg {current} av {total}: {title}',
                completed_message: 'Snabbstart slutförd!',
                reset_message: 'Snabbstarten har återställts.',
            },
            persona_p_vn_01_label: 'Enterprise [[TOK_0]]',
            persona_p_vn_01_description: 'Dataskyddsombud hanterar företagsomfattande efterlevnadsprogram',
            persona_p_vn_02_label: 'Avdelningsägare',
            persona_p_vn_02_description: 'Avdelningsledare ansvarig för sektionsrapportering',
            persona_p_vn_03_label: 'E-handelsefterlevnad',
            persona_p_vn_03_description: 'Compliance officer fokuserade på e-handelsdataskydd och samtycke',
            persona_p_vn_04_label: 'Telekom DPO',
            persona_p_vn_04_description: 'Telekomsektorn DPO hanterar abonnentdata och incidentrapportering',
            persona_p_vn_05_label: 'Ledare för datastyrning',
            persona_p_vn_05_description: 'Ansvarig för datakartläggning, klassificering och styrning',
            persona_p_vn_06_label: 'Cybersäkerhet och juridiska operationer',
            persona_p_vn_06_description: 'Cybersäkerhetsansvarig som hanterar incidentrespons och leverantörsrisk',
            persona_p_vn_07_label: 'AI Ledare för ledning',
            persona_p_vn_07_description: 'Leda som övervakar AI systemstyrning, riskbedömningar och klassificering',
            persona_p_vn_08_label: 'Cross-Border & Vendor Gov',
            persona_p_vn_08_description: 'Tjänsteman som hanterar gränsöverskridande överföringar och leverantörsstyrning',
            persona_p_vn_09_label: 'Breach Response Lead',
            persona_p_vn_09_description: 'Leda koordinering av överträdelsemeddelanden och incidentrespons',
            persona_p_vn_10_label: 'Ledare för internrevision',
            persona_p_vn_10_description: 'Ansvarig för efterlevnadsrevision och granskning av programstyrning',
            persona_p_vn_11_label: 'HR- & medarbetardata-ansvarig',
            persona_p_vn_11_description: 'HR-chef som hanterar medarbetarsamtyckeregister och interna DSAR-ärenden',
            persona_p_vn_12_label: 'Compliance-ansvarig för multinationellt dotterbolag',
            persona_p_vn_12_description: 'Dataskyddsombud i vietnamesiskt dotterbolag till utländskt företag som behöver lokalt compliance-lager',
            persona_p_vn_13_label: 'Compliance-ansvarig för utbildning',
            persona_p_vn_13_description: 'Compliance-ansvarig vid utländsk skola som hanterar dataskydd för elever och vårdnadshavare',
            qs_hr_consent_title: 'Registrera medarbetarsamtycken',
            qs_hr_consent_description: 'Genomgång av registrering av medarbetarsamtycke och generering av täckningsrapport.',
            qs_subsidiary_dpia_title: 'Skapa DPIA-bedömning för dotterbolag',
            qs_subsidiary_dpia_description: 'Genomgång av skapande av DPIA för en behandlingsaktivitet i dotterbolag.',
            qs_student_consent_title: 'Konfigurera insamling av elevsamtycke',
            qs_student_consent_description: 'Genomgång av skapande av vårdnadshavarsamtyckespolicyer för elevdata.',
            persona_p_vn_14_label: 'Extern juridisk rådgivare',
            persona_p_vn_14_description: 'Senior advokatbyråpartner som ger råd till flera kundorganisationer om PDPL efterlevnad',
            persona_p_vn_15_label: 'Verksamhetschef för advokatbyrån',
            persona_p_vn_15_description: 'Kundengagemangskoordinator som hanterar leveransspårning och deadlinekoordinering',
            persona_p_vn_16_label: 'Företagsägare / CEO',
            persona_p_vn_16_description: 'CEO eller GM som juridiskt är personuppgiftsansvarig enligt PDPL, ansvarig för efterlevnadsinvesteringar',
            qs_dpia_filing_title: 'Slutför din första DPIA-fil',
            qs_dept_compliance_title: 'Skicka in ditt första avsnitt om efterlevnad av avdelningen',
            qs_ecommerce_consent_title: 'Konfigurera insamling av samtycke för e-handel',
            qs_telecom_data_title: 'Ställ in datahantering för telekomabonnenter',
            qs_data_flow_title: 'Kartlägg ditt första dataflöde',
            qs_incident_response_title: 'Konfigurera arbetsflöde för incidentrespons',
            qs_ai_risk_title: 'Kör en AI systemriskbedömning',
            qs_cross_border_title: 'Bedöm en gränsöverskridande dataöverföring',
            qs_breach_notification_title: 'Simulera ett arbetsflöde för meddelande om intrång',
            qs_audit_trail_title: 'Granska ett spår för efterlevnadsrevision',
            qs_legal_advisor_portfolio_title: 'Granska efterlevnadsportfölj för flera klienter',
            qs_legal_advisor_portfolio_description: 'Granska efterlevnadsstatus för flera kundorganisationer.',
            qs_law_firm_ops_title: 'Spåra kundleveransstatus',
            qs_law_firm_ops_description: 'Övervaka framsteg inom rådgivning och kundengagemang.',
            qs_ceo_dashboard_title: 'Se instrumentpanelen för efterlevnad av chefer',
            qs_ceo_dashboard_description: 'Granska överensstämmelsestatus och investeringsstatistik på hög nivå.',
        },
        rights_requests: {
            response_templates: {
                title: 'Svarsmallar',
                subtitle: 'Hantera DSR-svarsbrevsmallarna som ResponseGenerator använder för att formulera svar till registrerade.',
                create_btn: 'Ny mall',
                edit_btn: 'Redigera mall',
                filter_right_type: 'Filtrera efter rätt typ',
                filter_locale: 'Filtrera efter språk',
                filter_status: 'Filtrera efter status',
                all_right_types: 'Alla rätt typer',
                any_right_type: 'Alla (gäller alla typer)',
                all_locales: 'Alla lokaler',
                all_statuses: 'Alla',
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                empty_state: 'Inga mallar matchar de aktuella filtren.',
                columns: {
                    template_id: 'Mall-ID',
                    outcome: 'Resultat',
                    locale: 'Plats',
                    right_type: 'Rätt typ',
                    is_active: 'Status',
                    last_updated: 'Senast uppdaterad',
                    actions: 'Åtgärder',
                },
                actions: {
                    edit: 'Redigera',
                    clone: 'Klona',
                    deactivate: 'Inaktivera',
                    reactivate: 'Återaktivera',
                    preview: 'Förhandsgranska',
                },
                form: {
                    template_id: 'Mall-ID',
                    template_id_help: 'Gemener identifierare, t.ex. dsr_access_fulfilled_vi',
                    outcome: 'Resultat',
                    locale: 'Plats',
                    right_type: 'Rätt typ',
                    subject: 'Ämne',
                    body: 'Kroppsmall',
                    body_help: 'Använd platshållare som [[TOK_3]], [[TOK_4]], [[TOK_5]]. Minst 15 rader för flersektionsbokstäver.',
                    is_active: 'Aktiv',
                    official_form_id: 'Officiellt formulär-ID (valfritt)',
                },
                outcomes: {
                    fulfilled: 'Uppfyllt',
                    partially_fulfilled: 'Delvis uppfylld',
                    denied: 'Nekad',
                },
                clone_modal_title: 'Klon mall',
                clone_target_locale: 'Målplats',
                clone_help: 'En ny mall kommer att skapas i mållokalen med denna mall som utgångspunkt.',
                preview_modal_title: 'Förhandsgranskning av mall',
                preview_note: 'Förhandsvisningen använder democase DSR-DEMO-0020 platshållare. Verklig leverans ersätter live case-data.',
                preview_unavailable: 'Förhandsgranskning kräver ett befintligt fall. Bifoga den här mallen till ett ärende och använd åtgärden Utkast till svar på ärendets detaljsida.',
                deactivate_confirm: 'Inaktivera den här mallen? Det kommer att fortsätta att gälla för befintliga fall som hänvisar till det.',
                toasts: {
                    created: 'Mall skapad',
                    updated: 'Mall uppdaterad',
                    deactivated: 'Mall avaktiverad',
                    reactivated: 'Mall återaktiverad',
                    cloned: 'Mall klonad',
                    load_error: 'Det gick inte att läsa in mallar',
                    save_error: 'Det gick inte att spara mallen',
                    clone_error: 'Det gick inte att klona mallen',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Avdelningar',
                subtitle: 'Hantera avdelningarna som dirigerar DSR-ärenden, [[TOK_0]] uppgifter och efterlevnadsarbetsflöden.',
                create_btn: 'Ny avdelning',
                edit_btn: 'Redigera avdelning',
                columns: {
                    name: 'Namn',
                    description: 'Beskrivning',
                    active_cases: 'Aktiva fall',
                    members: 'Medlemmar',
                    status: 'Status',
                    actions: 'Åtgärder',
                },
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                form: {
                    name: 'Namn',
                    description: 'Beskrivning',
                },
                actions: {
                    edit: 'Redigera',
                    deactivate: 'Inaktivera',
                    reactivate: 'Återaktivera',
                    delete: 'Ta bort',
                    manage_members: 'Hantera medlemmar',
                },
                delete_modal_title: 'Ta bort avdelning',
                delete_warning: 'Denna avdelning har fortfarande aktiva ärenden. Välj en avdelning att tilldela dem till innan de tas bort.',
                delete_no_cases: 'Denna avdelning har inga aktiva ärenden och kan tas bort på ett säkert sätt.',
                reassign_prompt: 'Tilldela om aktiva ärenden till:',
                reassign_none_available: 'Inga andra aktiva avdelningar tillgängliga. Skapa en annan avdelning först.',
                member_section_title: 'Medlemmar',
                add_member: 'Lägg till medlem',
                remove_member: 'Ta bort',
                member_role: 'Roll',
                no_members: 'Inga medlemmar mappade till denna avdelning.',
                toasts: {
                    created: 'Avdelning skapad',
                    updated: 'Avdelningen uppdaterad',
                    deactivated: 'Avdelningen avaktiverad',
                    reactivated: 'Avdelningen återaktiverad',
                    deleted: 'Avdelningen raderad',
                    reassigned_count: '[[TOK_1]] ärenden har omtilldelats',
                    member_added: 'Medlem har lagts till',
                    member_removed: 'Medlem borttagen',
                    load_error: 'Det gick inte att ladda avdelningar',
                    save_error: 'Det gick inte att spara avdelningen',
                    delete_error: 'Det gick inte att ta bort avdelningen',
                },
            },
            retention_policies: {
                title: 'Lagringspolicyer',
                subtitle: 'Konfigurera lagringsfönster per måltyp. Identitetsverifieringsdokument använder detta för att stämpla retention_expires_at på framtida uppladdningar.',
                create_btn: 'Ny policy',
                edit_btn: 'Redigera policy',
                columns: {
                    target_type: 'Måltyp',
                    retention_days: 'Retention (dagar)',
                    owner: 'Försäkringsägare',
                    effective_from: 'Gäller från',
                    last_reviewed: 'Senast granskad',
                    status: 'Status',
                    actions: 'Åtgärder',
                },
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                form: {
                    target_type: 'Måltyp',
                    target_type_help: 'Vilken datakategori lagringsfönstret gäller. För närvarande stöds endast DSR-identitetsverifieringsdokument.',
                    retention_days: 'Retentionsperiod (dagar)',
                    retention_days_help: 'Mellan 1 och 3650 dagar (max 10 år).',
                    owner: 'Försäkringsägare',
                    owner_help: 'Vanligtvis [[TOK_0]]. Ansvarig för beslutet om kvarhållande enligt DG-2.',
                    effective_from: 'Gäller från',
                },
                target_types: {
                    dsr_identity_verification_document: 'DSR-dokument för identitetsverifiering',
                },
                deactivate_notice: 'Inaktivering påverkar inte redan stämplade bilagor – bara framtida uppladdningar kommer inte längre att få en lagringsperiod.',
                deactivate_confirm: 'Inaktivera denna lagringspolicy?',
                toasts: {
                    created: 'Lagringspolicy skapad',
                    updated: 'Lagringspolicy uppdaterad',
                    deactivated: 'Lagringspolicy inaktiverad',
                    load_error: 'Det gick inte att läsa in lagringspolicyer',
                    save_error: 'Det gick inte att spara lagringspolicyn',
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'System',
            categories: 'Datakategorier',
            registry: 'Dataregistret',
            purposes: 'Bearbetningsändamål',
            retention: 'Lagring',
            flows: 'Dataflöden',
            activities: 'Behandlingar',
            evidence: 'Bevisning',
            exports: 'Exporter',
            attestation: 'Attestationscykler',
            governance: 'Styrning',
            review: 'Granskningsuppgifter',
            inventory: 'Inventering',
            exceptions: 'Undantag',
            history: 'Historik',
            ropa_completeness: 'ROPA Fullständighet',
        },
        ropa_completeness_autofix: {
            ask_button: 'Fråga Forseti',
            drafting: 'Utarbetar...',
            accept: 'Acceptera',
            reject: 'Avvisa',
            accepted: 'Godkänd — ansök via aktivitetsredigeraren.',
            rejected: 'Avvisad.',
            needs_human_input: 'Forseti behöver mer aktivitetskontext (t.ex. ett dokumenterat syfte) innan det här fältet utarbetas.',
        },
        ropa_completeness: {
            title: 'ROPA fullständighetsrapport',
            subtitle: 'Hygiengranskning per fält av dina register över bearbetningsaktiviteter, inom ramen för regelverket.',
            framework_label: 'Ramverk',
            kpi_total: 'Poängsatta aktiviteter',
            kpi_critical: 'Kritisk',
            kpi_high: 'Hög',
            kpi_conditional: 'Villkorligt',
            field_chart_heading: 'Saknade fält efter frekvens',
            drilldown_heading: 'Aktiviteter med luckor',
            col_activity: 'Aktivitet',
            col_field: 'Fält',
            col_severity: 'Allvarlighet',
            col_condition: 'Skick',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Kritisk',
            severity_high: 'Hög',
            severity_conditional: 'Villkorligt',
            severity_informational: 'Informationsinformation',
            include_informational: 'Inkludera information (ISO 27701)',
            export_csv: 'Ladda ner [[TOK_0]]',
            exporting: 'Exporterar...',
            loading: 'Laddar…',
            empty_state: 'Alla aktiva aktiviteter har fullständiga ROPA-poster för detta ramverk.',
            error_fetch: 'Det gick inte att läsa in fullständighetsrapporten.',
            error_unsupported_framework: 'Detta ramverk stöds inte.',
            error_framework_not_installed: 'Detta ramverk är inte installerat för din organisation.',
            no_misses_for_field: 'Inga aktiviteter saknar detta fält.',
            framework_PDPL: '[[TOK_0]] (lag 91/2025 + dekret 356)',
            framework_GDPR: '[[TOK_0]] Artikel 30',
            framework_DECREE_165: 'Dekret 165 (Vietnams datalag)',
            framework_ISO_27701: 'ISO 27701 (information)',
        },
        registry: {
            page: {
                title: 'Dataregistret',
                subtitle: 'Personliga dataelement som din organisation har, organiserade under Datakategorier.',
                empty_state: 'Inga registerobjekt ännu. Lägg till en vara manuellt eller importera från ett regulatoriskt register.',
                empty_filter_state: 'Inga objekt matchar dina filter.',
            },
            filter: {
                category: 'Kategori',
                sensitivity: 'Känslighet',
                data_subject: 'registrerad',
                status: 'Status',
                data_tier: 'Datanivå',
                cross_border: 'Gränsöverskridande',
                has_owner: 'Har ägare',
                has_form_source: 'Importerad från formulär',
                search_placeholder: 'Sök namn, beskrivning eller fältidentifierare...',
                clear: 'Rensa filter',
                option_all: 'Alla',
            },
            col: {
                name: 'Namn',
                category: 'Kategori',
                sensitivity: 'Känslighet',
                data_subjects: 'registrerade',
                systems: 'System',
                activities: 'Aktiviteter',
                owner: 'Ägare',
                retention: 'Retention',
                data_tier: 'Datanivå',
                status: 'Status',
                last_reviewed: 'Senast granskad',
                actions: 'Åtgärder',
            },
            action: {
                add_manual: 'Lägg till objekt',
                add_from_form: 'Lägg till från regulatoriska register',
                import_history: 'Importera tidigare inlämningar',
                export: 'Exportera',
                archive: 'Arkiv',
                restore: 'Återställ',
                edit: 'Redigera',
                assign_owner: 'Tilldela ägare',
                attach_evidence: 'Bifoga bevis',
                open_lineage: 'Öppen härstamning',
            },
            modal_editor: {
                section_identity: 'Identitet',
                section_classification: 'Klassificering',
                section_subjects: 'Ämnen & Volym',
                section_location: 'Plats & Transfer',
                section_systems: 'System & Aktiviteter',
                section_retention: 'Retention & Juridisk',
                section_governance: 'Styrning',
                section_notes: 'Anteckningar',
                hint_inherited: '(ärvt från kategori)',
                hint_overridden: '(åsidosatt)',
                placeholder_field_identifiers: 't.ex. kunder.primary_email, hris.employee_id',
                validation_name_required: 'Namn krävs',
                validation_category_required: 'Kategori krävs',
                validation_data_subjects_required: 'Minst en registrerad typ krävs',
                label_data_type: 'Datatyp',
                label_field_identifiers: 'Fältidentifierare (kommaseparerade)',
                label_data_subject_types: 'Typer av registrerade',
                label_volume_band: 'Volymband',
                label_storage_locations: 'Lagringsplatser (kommaseparerade)',
                placeholder_storage_locations: 'ISO-3166 koder eller fritext (t.ex. VN, Hetzner EU)',
                label_cross_border: 'Gränsöverskridande överföring',
                label_source_systems: 'Källsystem',
                label_processing_activities: 'Bearbetningsaktiviteter',
                label_collection_method: 'Insamlingsmetod',
                label_legal_basis: 'Rättslig grund',
                label_purposes: 'Ändamål',
                hint_multi_select: 'Håll ned Cmd/Ctrl för att välja flera.',
                option_inherit_category: '— (ärv från kategori)',
                option_dash: '—',
            },
            modal_import: {
                dry_run_heading: 'Importera förhandsgranskning',
                label_to_create: 'Att skapa',
                label_to_update: 'Att uppdatera',
                label_skipped_archived: 'Hoppat över (arkiverad)',
                label_conflicts: 'Konflikter',
                commit: 'Importera',
                cancel: 'Avbryt',
                conflict_row: '[[TOK_3]] — behåll din redigering ([[TOK_4]]); kartläggare sökes [[TOK_5]].',
            },
            drawer: {
                section_category: 'Kategori',
                section_systems: 'Källsystem',
                section_activities: 'Bearbetningsaktiviteter',
                section_flows: 'Dataflöden',
                section_retention: 'Effektiv retention',
                section_governance: 'Styrning',
                section_evidence: 'Bevis',
                section_audit: 'Senaste revisionsspår',
                section_source_form: 'Inlämning av källformulär',
                badge_inherited: 'Ärvt',
                badge_overridden: 'Åsidosatt',
            },
            toast: {
                created: 'Registerobjekt skapat.',
                updated: 'Registerobjekt uppdaterat.',
                archived: 'Registerobjektet arkiverat.',
                imported: '[[TOK_1]] objekt importerade.',
                conflict_warning: '[[TOK_1]] fält(en) behöll dina ändringar — se konfliktlista.',
            },
        },
        systems: {
            title: 'Systeminventering',
            new: 'Nytt System',
            edit: 'Redigera System',
            name: 'Namn',
            owner: 'Ägare',
            criticality: 'Kritikalitet',
            dpa_status: 'Status Personuppgiftsbiträdesavtal',
            location: 'Plats',
            system_type: 'Systemtyp',
            metadata: 'Metadata (JSON-format)',
            department: 'Avdelning',
            hosting_location: 'Värdplats',
            hosting_provider: 'Värdleverantör',
            data_residency_country: 'Land för Datalagring',
            hosting: 'Värd',
            no_systems: 'Inga system hittades',
            confirm_archive: 'Arkivera system "{name}"?',
            count: 'system',
            count_one: 'system',
            type_internal: 'Intern',
            type_external: 'Extern',
            type_cloud_service: 'Molntjänst',
            type_on_premise: 'Lokal',
            type_hybrid: 'Hybridläge',
            status_active: 'Aktiv',
            status_decommissioning: 'Avveckling',
            status_decommissioned: 'Avvecklad',
            status_planned: 'Planerad',
            dpa_not_required: 'Ej Krävd',
            dpa_required_missing: 'Krävd Saknas',
            dpa_in_progress: 'Pågående',
            dpa_signed: 'Signerad',
            all_criticalities: 'Alla Kritikalitetsnivåer',
        },
        categories: {
            title: 'Datakategorier',
            new: 'Ny Kategori',
            edit: 'Redigera Kategori',
            name: 'Namn',
            sensitivity: 'Känslighet',
            tags: 'Taggar',
            used_in: 'Används I',
            examples: 'Exempel',
            examples_hint: 'Exempel (kommaseparerad)',
            default: 'Standard',
            all_sensitivities: 'Alla Känslighetsnivåer',
            all_statuses: 'Alla statusar',
            no_categories: 'Inga kategorier hittades',
            confirm_delete: 'Radera kategori "{name}"?',
            count: 'kategorier',
            count_one: 'kategori',
            status_draft: 'Utkast',
            status_proposed: 'Föreslagen',
            status_under_review: 'Under granskning',
            status_approved: 'Godkänd',
            status_deprecated: 'Föråldrad',
            status_updated: 'Kategoristatus uppdaterad',
            propose: 'Föreslå',
            approve: 'Godkänn',
            deprecate: 'Föråldra',
        },
        purposes: {
            title: 'Behandlingsändamål',
            new: 'Nytt Ändamål',
            edit: 'Redigera Ändamål',
            name: 'Namn',
            legal_basis: 'Rättslig Grund',
            retention_period: 'Lagringsperiod (dagar)',
            justification: 'Motivering av Berättigat Intresse',
            legal_basis_detail: 'Detalj Rättslig Grund',
            all_legal_bases: 'Alla Rättsliga Grunder',
            no_purposes: 'Inga ändamål hittades',
            confirm_delete: 'Radera "{name}"?',
            default: 'Standard',
            count: '{count} ändamål',
            count_one: '{count} ändamål',
            basis_consent: 'Samtycke',
            basis_contract: 'Kontrakt',
            basis_legal_obligation: 'Rättslig Förpliktelse',
            basis_vital_interest: 'Vitalt Intresse',
            basis_public_interest: 'Allmänt Intresse',
            basis_legitimate_interest: 'Berättigat Intresse',
        },
        retention: {
            title: 'Lagringspolicyer',
            new: 'Ny Policy',
            edit: 'Redigera Policy',
            name: 'Namn',
            retention_days: 'Lagringsdagar',
            disposal_method: 'Gallringsmetod',
            data_categories: 'Datakategorier',
            activities: 'Behandlingar',
            review_frequency: 'Granskningsfrekvens',
            review_frequency_days: 'Granskningsfrekvens (dagar)',
            no_policies: 'Inga lagringspolicyer hittades',
            confirm_delete: 'Radera "{name}"?',
            count: '{count} policyer',
            count_one: '[[TOK_1]] policy',
            days: 'dagar',
            disposal_deletion: 'Radering',
            disposal_anonymization: 'Anonymisering',
            disposal_archival: 'Arkivering',
            review_overdue: 'Granskning försenad',
            review_status: 'Granskningsstatus',
            review_ok: 'I fas',
            department: 'Avdelning',
            all_departments: 'Alla avdelningar',
        },
        flows: {
            view_tabs_aria: 'Flödesvy',
            view_list: 'Lista',
            view_map: 'Karta',
            title: 'Dataflöden',
            new: 'Nytt Flöde',
            edit: 'Redigera Flöde',
            name: 'Namn',
            from_system: 'Från System',
            to_system: 'Till System',
            flow_type: 'Flödestyp',
            cross_border: 'Gränsöverskridande',
            risk_level: 'Risknivå',
            mechanism: 'Mekanism',
            transfer_mechanism: 'Överföringsmekanism',
            frequency: 'Frekvens',
            source_country: 'Källand',
            destination_country: 'Destinationsland',
            transfer_safeguard: 'Överföringsskydd',
            all_risk_levels: 'Alla Risknivåer',
            no_flows: 'Inga dataflöden hittades',
            confirm_archive: 'Arkivera "{name}"?',
            count: '{count} flöden',
            count_one: '{count} flöde',
            status_active: 'Aktiv',
            status_inactive: 'Inaktiv',
            status_under_review: 'Under Granskning',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Filöverföring',
            mechanism_database_replication: 'Databasreplikering',
            mechanism_manual: 'Manuell',
            mechanism_email: 'E-post',
            mechanism_other: 'Annat',
            frequency_real_time: 'Realtid',
            frequency_hourly: 'Varje Timme',
            frequency_daily: 'Dagligen',
            frequency_weekly: 'Veckovis',
            frequency_monthly: 'Månadsvis',
            frequency_on_demand: 'På Begäran',
            frequency_one_time: 'Engångs',
            safeguard_adequacy_decision: 'Adekvansbeslutt',
            safeguard_standard_contractual_clauses: 'Standardavtalsklausuler',
            safeguard_binding_corporate_rules: 'Bindande Företagsregler',
            safeguard_explicit_consent: 'Uttryckligt Samtycke',
            safeguard_legal_obligation: 'Rättslig Förpliktelse',
            safeguard_none: 'Ingen',
            safeguard_other: 'Annat',
        },
        activities: {
            title: 'Behandlingar',
            new: 'Ny Behandling',
            edit: 'Redigera Behandling',
            activity_title: 'Titel',
            category: 'Kategori',
            legal_basis: 'Rättslig Grund',
            dpa_required: 'Personuppgiftsbiträdesavtal Krävs',
            ropa_generated: 'Behandlingsregister Genererat',
            version: 'Utgåva',
            generate_ropa: 'Generera Behandlingsregister',
            controller: 'Personuppgiftsansvarig',
            controller_name: 'Namn på Personuppgiftsansvarig',
            controller_contact: 'Kontakt Personuppgiftsansvarig',
            legal_basis_detail: 'Detalj Rättslig Grund',
            organization_info: 'Organisationsinformation (Bilaga I)',
            org_address: 'Organisationsadress',
            tax_code: 'Skattekod',
            contact_person: 'Kontaktperson',
            contact_email: 'Kontakt-e-post',
            contact_phone: 'Kontakttelefon',
            select_entity: 'Välj...',
            no_entities: 'Inga föremål hittades',
            dpo_name: 'DPO-namn',
            dpo_contact: 'DPO-kontakt',
            processor_name: 'Biträdesnamn',
            processor_contact: 'Biträdeskontakt',
            data_subjects: 'Registrerade',
            data_subjects_hint: 'Registrerade (kommaseparerad)',
            recipients: 'Mottagare',
            recipients_hint: 'Mottagare (kommaseparerad)',
            security_measures: 'Säkerhetsåtgärder',
            dpia_reference: 'DPIA-referens',
            no_activities: 'Inga behandlingar hittades',
            confirm_archive: 'Arkivera "{name}"?',
            count: '{count} behandlingar',
            count_one: '{count} behandling',
            ropa_success: 'Behandlingsregister har genererats. Gå till Exporter för att ladda ned det.',
            ropa_error: 'Kunde inte generera behandlingsregister',
            required_label: 'Krävs',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_under_review: 'Under Granskning',
            status_archived: 'Arkiverad',
            decree_165_heading: 'Dekret 165 datanivå (Vietnam Data Law)',
            decree_165_helper: 'Klassificera de uppgifter som denna aktivitet behandlar enligt Vietnamdekret 165. Regelbundna data får baslinjen för gränsöverskridande regler; viktiga och kärndata utlöser ytterligare skyldigheter.',
            data_tier_label: 'Datanivå',
            data_tier_help: 'Dekret 165 klassificerar data som vanliga, viktiga eller kärnor – se hjälpartikeln för vägledning.',
            data_tier_column_header: 'Datanivå',
            data_tier_regular: 'Vanligt',
            data_tier_important: 'Viktigt',
            data_tier_core: 'Kärna',
            transfer_mechanism_label: 'Gränsöverskridande överföringsmekanism',
            transfer_mechanism_placeholder: 'till exempel Standardavtalsklausuler, beslut om lämplighet',
            security_assessment_reference_label: 'Säkerhetsbedömningsreferens',
            security_assessment_reference_placeholder: 't.ex. [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Bevisvalv',
            new: 'Ny Bevisning',
            edit: 'Redigera Bevisning',
            name: 'Namn',
            evidence_type: 'Bevistyp',
            linked_entities: 'Länkade Entiteter',
            uploaded: 'Uppladdad',
            expiry: 'Utgångsdatum',
            file_url: 'Fil-URL',
            source_mode_label: 'Beviskälla',
            source_mode_file: 'Ladda upp fil',
            source_mode_url: 'Länka extern URL',
            attachment_label: 'Bilaga',
            link_to: 'Länka Bevisning Till',
            entity_type: 'Entitetstyp',
            entity_id: 'Entitets-ID',
            no_evidence: 'Inga bevishandlingar hittades',
            manage_links: 'Hantera länkar',
            unlink: 'Ta bort länken',
            confirm_delete: 'Radera bevishandling "{name}"?',
            count: '{count} poster',
            count_one: '{count} post',
            type_document: 'Dokument',
            type_screenshot: 'Skärmbild',
            type_policy: 'Regel',
            type_contract: 'Kontrakt',
            type_assessment: 'Bedömning',
            type_correspondence: 'Korrespondens',
            type_other: 'Annat',
            linked_type_system: 'System',
            linked_type_data_flow: 'Dataflöde',
            linked_type_processing_activity: 'Bearbetningsaktivitet',
            linked_type_data_category: 'Datakategori',
            linked_type_purpose: 'Syfte',
            linked_type_retention_policy: 'Lagringspolicy',
            link_entity: 'Länk till enhet',
            link_success: 'Enheten har länkats',
            confirm_unlink: 'Är du säker på att du vill ta bort länken till denna enhet?',
            unlink_success: 'Entitet har tagits bort',
            no_linked_entities: 'Inga länkade enheter',
            select_entity: 'Välj...',
            no_entities: 'Inga föremål',
        },
        exports: {
            title: 'Dataexporter',
            recent: 'Senaste Exporter',
            export_type: 'Exporttyp',
            format: 'Filformat',
            requested_by: 'Begärd Av',
            requested_at: 'Begärd Vid',
            download: 'Ladda ner',
            csv_export: 'CSV-export',
            csv_description: 'Ladda ner data i CSV-format för kalkylbladsanalys.',
            pdf_reports: 'PDF-rapporter',
            pdf_description: 'Generera formaterade rapporter för efterlevnadsdokumentation.',
            csv_systems: 'Systeminventering',
            csv_categories: 'Datakategorier',
            csv_flows: 'Dataflöden',
            csv_activities: 'Behandlingar',
            csv_cross_border: 'Gränsöverskridande Flöden',
            csv_retention_policies: 'Lagringspolicyer',
            csv_evidence: 'Bevisobjekt',
            csv_governance_assignments: 'Styrningsuppdrag',
            pdf_ropa: 'Behandlingsregister',
            pdf_systems: 'Systemrapport',
            pdf_cross_border: 'Gränsöverskridande Rapport',
            pdf_flow_map: 'Flödeskartsdata',
            export_failed: 'Exporten misslyckades',
            pdf_generated: 'PDF genererades.',
            ropa: 'RoPA Register',
            retention_policies: 'Lagringspolicyer',
            governance_assignments: 'Styrningsuppdrag',
            col_entity: 'Export Entitet',
            col_description: 'Beskrivning',
            desc_ropa: 'Fullständigt ROPA-register över alla bearbetningsaktiviteter med rättslig grund, [[TOK_0]] status och kontroller.',
            desc_systems: 'Systeminventering med ägare, datakategoritaggar och efterlevnadsstatus.',
            desc_activities: 'Individuell behandlingsverksamhet med registeransvarig, rättslig grund och [[TOK_0]] klassificering.',
            desc_categories: 'Datakategorier och känslighetsnivåer som används över klassificering och revisioner.',
            desc_purposes: 'Behandlingsändamål med rättslig grund hänvisningar enligt dekret 13/2023 och telekommunikationslag 2023.',
            desc_flows: 'Dataflöden mellan system, inklusive interna och gränsöverskridande rutter.',
            desc_cross_border: 'Endast gränsöverskridande flöden, med överföringsmekanism och riskbedömning.',
            desc_retention_policies: 'Retentionspolicyer, kasseringsmetoder och granskningsfrekvens.',
            desc_evidence: 'Bevis kopplade till bearbetningsaktiviteter: certifikat, DPA-kontrakt, [[TOK_0]] rapporter.',
            desc_governance_assignments: 'Styrningsuppdrag: ägare, godkännare och ISO 27001-referenser.',
            unified_heading: 'Exportera enheter',
            unified_description: 'Exportera vilken datamappningsenhet som helst i formatet [[TOK_0]], [[TOK_3]], [[TOK_2]] eller [[TOK_1]]. Alla exporter sparas i filläsaren.',
            export_button_label: 'Exportera',
            csv_download_success: 'CSV laddades ner.',
        },
        attestation: {
            title: 'Attestationscykler',
            create: 'Ny cykel',
            name: 'Cykelnamn',
            year: 'År',
            deadline: 'Tidsfrist',
            scope: 'Omfattning',
            status: 'Status',
            tasks: 'Avdelningsuppgifter',
            assign_tasks: 'Tilldela uppgifter',
            department: 'Avdelning',
            assignee: 'Tilldelad',
            progress: 'Framsteg',
            stale_entries: 'Föråldrade poster',
            detect_stale: 'Hitta föråldrade',
            export_bundle: 'Exportera paket',
            no_cycles: 'Inga attestationscykler ännu.',
            create_success: 'Attestationscykel skapad.',
            assign_success: 'Uppgifter tilldelade.',
            complete_success: 'Uppgift slutförd.',
            stale_detected: 'Föråldrade poster hittade.',
            stale_systems: 'Föråldrade system',
            stale_flows: 'Föråldrade flöden',
            no_stale: 'Inga föråldrade poster hittade.',
            stale_name: 'Namn',
            stale_announcement: 'Hittade {0} föråldrade system och {1} föråldrade flöden',
            last_updated: 'Senast uppdaterad',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_completed: 'Slutförd',
            task_status_pending: 'Väntar',
            task_status_in_progress: 'Pågår',
            task_status_completed: 'Slutförd',
            scope_systems: 'System',
            scope_flows: 'Dataflöden',
            scope_activities: 'Aktiviteter',
            scope_categories: 'Kategorier',
            scope_purposes: 'Ändamål',
            scope_retention: 'Lagring',
        },
        governance: {
            title: 'Styrningsuppdrag',
            assign: 'Tilldela ägarskap',
            entity_type: 'Entitetstyp',
            entity: 'Entitet',
            role: 'Roll',
            assigned_by: 'Tilldelad av',
            assigned_at: 'Tilldelad den',
            remove: 'Ta bort',
            no_assignments: 'Inga styrningsuppdrag.',
            assign_success: 'Ägarskap tilldelat.',
            remove_success: 'Uppdrag borttaget.',
            assignee: 'Tilldelad',
            department: 'Avdelning',
            all_departments: 'Alla avdelningar',
            roles: {
                data_owner: 'Dataägare',
                data_steward: 'Dataförvaltare',
                data_custodian: 'Dataväktare',
                informed: 'Informerad',
            },
            entity_types: {
                system: 'System',
                flow: 'Dataflöde',
                activity: 'Aktivitet',
                category: 'Kategori',
                purpose: 'Ändamål',
                retention_policy: 'Lagringspolicy',
            },
        },
        risk_assessment: {
            title: 'Riskbedömning',
            create: 'Ny bedömning',
            safeguard_type: 'Skyddstyp',
            adequacy_status: 'Adekvans',
            risk_factors: 'Riskfaktorer',
            mitigations: 'Åtgärder',
            reviewer: 'Granskare',
            decision: 'Beslut',
            approve: 'Godkänn',
            reject: 'Avslå',
            no_assessments: 'Inga riskbedömningar.',
            create_success: 'Riskbedömning skapad.',
            approve_success: 'Bedömning godkänd.',
            reject_success: 'Bedömning avslagen.',
            one_per_line: 'En per rad',
            safeguard_adequacy_decision: 'Adekvansbesked',
            safeguard_standard_contractual_clauses: 'Standardavtalsklausuler',
            safeguard_binding_corporate_rules: 'Bindande företagsregler',
            safeguard_explicit_consent: 'Uttryckligt samtycke',
            safeguard_legal_obligation: 'Rättslig förpliktelse',
            safeguard_none: 'Ingen',
            safeguard_other: 'Annat',
            adequacy_adequate: 'Adekvat',
            adequacy_inadequate: 'Otillräcklig',
            adequacy_under_review: 'Under granskning',
            adequacy_not_assessed: 'Ej bedömd',
            decision_approved: 'Godkänd',
            decision_rejected: 'Avvisad',
        },
        review: {
            title: 'Granskningsuppgifter',
            description: 'Granskningsuppgifter skapas automatiskt när en datakategori föreslås. För att skapa en ny uppgift, gå till Datakategorier och klicka på Föreslå på en utkastskategori.',
            count: 'granskningsuppgifter',
            summary: 'Granskningsöversikt',
            pending: 'Väntande',
            resolved_today: 'Lösta idag',
            escalated: 'Eskalerade',
            overdue: 'Försenade (>5 dagar)',
            all_statuses: 'Alla statusar',
            status_pending: 'Väntande',
            status_resolved: 'Löst',
            status_escalated: 'Eskalerad',
            category_name: 'Kategori',
            system_name: 'System',
            owner: 'Ägare',
            resolve: 'Lös',
            resolve_task: 'Lös granskningsuppgift',
            resolution: 'Lösning',
            resolution_approve: 'Godkänn',
            resolution_modify: 'Ändra och godkänn',
            resolution_reject: 'Avvisa',
            resolution_escalate: 'Eskalera',
            notes: 'Lösningsanteckningar',
            notes_required: 'Anteckningar krävs (minst 10 tecken) för Ändra, Avvisa eller Eskalera',
            resolved_success: 'Granskningsuppgift löst',
            bulk_approve: 'Massgodkännande',
            bulk_reject: 'Massavvisning',
            bulk_success: '{count} uppgifter behandlade',
            no_tasks: 'Inga granskningsuppgifter hittades',
        },
        inventory: {
            title: 'Klassificeringsinventering',
            count: 'system',
            summary: 'Inventeringsöversikt',
            total_systems: 'Totalt system',
            total_labels: 'Totalt etiketter',
            system_name: 'System',
            label_count: 'Etiketter',
            approved_count: 'Godkända',
            pending_count: 'Väntande',
            no_items: 'Inga inventeringsartiklar hittades',
        },
        exceptions: {
            title: 'Klassificeringsundantag',
            count: 'undantag',
            all_severities: 'Alla allvarlighetsnivåer',
            all_statuses: 'Alla statusar',
            system_name: 'System',
            severity_label: 'Allvarlighet',
            status_open: 'Öppen',
            status_resolved: 'Löst',
            status_accepted_risk: 'Accepterad risk',
            resolve: 'Lös',
            resolve_exception: 'Lös undantag',
            resolution_type: 'Lösningstyp',
            notes: 'Anteckningar',
            justification_required: 'Motivering krävs (minst 10 tecken) för accepterad risk',
            resolved_success: 'Undantag löst',
            no_exceptions: 'Inga undantag hittades',
        },
        history: {
            title: 'Klassificeringshistorik',
            count: 'händelser',
            actor: 'Aktör',
            action: 'Åtgärd',
            entity_type: 'Entitetstyp',
            changes: 'Ändringar',
            view_lineage: 'Visa härkomst',
            lineage_title: 'Klassificeringshärkomst',
            no_events: 'Inga historiska händelser hittades',
            no_lineage: 'Ingen härkomstdata tillgänglig',
            modified: 'Ändrad',
            created: 'Skapad',
            removed: 'Borttagen',
            action_created: 'Skapad',
            action_updated: 'Uppdaterad',
            action_archived: 'Arkiverad',
            action_approved: 'Godkänd',
            action_deprecated: 'Föråldrad',
            entity_label: 'Etikett',
            entity_taxonomy: 'Taxonomi',
            entity_review_task: 'Granskningsuppgift',
            entity_exception: 'Undantag',
            before: 'Före',
            after: 'Efter',
        },
    },
    governance: {
        audit_trail_title: 'Revisionsspår för styrning',
        audit_trail_subtitle: 'Korsentitets revisionsström för styrningsåtgärder — godkännanden, playbook-körningar, beviskopplingar och mer.',
        audit_trail_item_count: 'revisionshändelser',
        audit_trail_fetch_error: 'Kunde inte hämta revisionshändelser.',
        audit_trail_no_events: 'Inga revisionshändelser hittades för de aktuella filtren.',
        audit_trail_entity_type: 'Entitetstyp',
        audit_trail_entity_id: 'Entitets-ID',
        audit_trail_action: 'Åtgärd',
        audit_trail_actor: 'Utförare',
        audit_trail_timestamp: 'Tidsstämpel',
        audit_trail_date_from: 'Från',
        audit_trail_date_to: 'Till',
        audit_trail_no_rows_to_export: 'Inga rader att exportera.',
        nav: {
            vendors: 'Leverantörer',
            subprocessors: 'Underbiträden',
            cross_border: 'Gränsöverskridande',
            drift: 'Avvikelseövervakning',
            scores: 'Efterlevnadspoäng',
            playbooks: 'Handlingsplaner',
            approvals: 'Godkännanden',
            audit_trail: 'Revisionsspår',
            board_report: 'Styrelserapport',
            evidence: 'Bevisning',
            onboarding: 'Onboarding-pipeline',
            dpa_reviews: 'DPA-granskningar',
            periodic_reviews: 'Periodiska granskningar',
            offboarding: 'Avregistrering',
        },
        vendors: {
            title: 'Leverantörsregister',
            new: 'Ny Leverantör',
            edit: 'Redigera Leverantör',
            name: 'Namn',
            jurisdiction: 'Jurisdiktion',
            dpa_status: 'Status Personuppgiftsbiträdesavtal',
            risk_level: 'Risknivå',
            onboarding_status: 'Introduktionsstatus',
            contact_email: 'Kontakt-e-post',
            contact_name: 'Kontaktnamn',
            contact_phone: 'Kontakttelefon',
            website: 'Webbplats',
            services_csv: 'Tjänster (kommaseparerad)',
            country: 'Land',
            country_placeholder: 't.ex. SE',
            last_reviewed: 'Senast Granskad',
            offboard: 'Avsluta',
            offboard_vendor: 'Avsluta Leverantör',
            offboard_reason: 'Anledning till avslutning',
            no_vendors: 'Inga leverantörer hittades',
            vendor_count: '{count} leverantör(er)',
            all_dpa_status: 'Alla DPA-statusar',
            all_risk_levels: 'Alla Risknivåer',
            all_onboarding: 'Alla Introduktionsstatusar',
            fetch_error: 'Misslyckades. Försök igen.',
            save_error: 'Kunde inte spara leverantör',
            offboard_error: 'Kunde inte avsluta',
        },
        vendor_types: {
            processor: 'Personuppgiftsbiträde',
            sub_processor: 'Underbiträde',
            controller: 'Personuppgiftsansvarig',
            joint_controller: 'Gemensamt Personuppgiftsansvarig',
        },
        onboarding_statuses: {
            pending_review: 'Inväntar Granskning',
            approved: 'Godkänd',
            active: 'Aktiv',
            suspended: 'Avstängd',
            offboarded: 'Avslutad',
        },
        dpa_statuses: {
            not_required: 'Ej Krävd',
            required_missing: 'Krävd Saknas',
            draft: 'Utkast',
            under_review: 'Under Granskning',
            signed: 'Signerad',
            expired: 'Utgången',
        },
        risk_levels: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medel',
            low: 'Låg',
        },
        approval_statuses: {
            pending: 'Väntande',
            approved: 'Godkänd',
            rejected: 'Avvisad',
            expired: 'Utgången',
        },
        approval_action_types: {
            vendor_onboarding: 'Leverantörsanslutning',
            vendor_offboarding: 'Leverantörsavslutning',
            cross_border_acceptance: 'Gränsöverskridande Godkännande',
            playbook_activation: 'Playbook-aktivering',
            drift_accept_risk: 'Avvikelse Accepterad Risk',
            activity_activation: 'Aktivitetsaktivering',
        },
        drift_check_types: {
            dpa_expiry: 'DPA-utgång',
            dpa_missing: 'DPA Saknas',
            review_overdue: 'Granskning Förfallen',
            cross_border_gap: 'Gränsöverskridande Brist',
            sub_processor_chain: 'Underbiträdeskedja',
            risk_assessment_overdue: 'Riskbedömning Förfallen',
            retention_policy_missing: 'Lagringspolicy Saknas',
            evidence_expiring: 'Dokumentation Utgår',
        },
        drift_statuses: {
            open: 'Öppen',
            acknowledged: 'Bekräftad',
            in_progress: 'Pågående',
            resolved: 'Löst',
            accepted_risk: 'Accepterad Risk',
        },
        drift_entity_types: {
            vendor: 'Leverantör',
            system: 'Systemet',
            data_flow: 'Dataflöde',
            processing_activity: 'Behandlingsaktivitet',
            evidence_item: 'Dokumentation',
        },
        playbook_statuses: {
            draft: 'Utkast',
            active: 'Aktiv',
            archived: 'Arkiverad',
        },
        playbook_action_types: {
            delete_data: 'Radera Data',
            verify_deletion: 'Verifiera Radering',
            notify_vendor: 'Meddela Leverantör',
            confirm_receipt: 'Bekräfta Mottagande',
            document_evidence: 'Dokumentera',
            other: 'Annat',
        },
        playbook_target_types: {
            system: 'Systemet',
            vendor: 'Leverantör',
        },
        dpa_chain_statuses: {
            complete: 'Komplett',
            incomplete: 'Ofullständig',
            unknown: 'Okänd',
        },
        sub_processor_statuses: {
            active: 'Aktiv',
            terminated: 'Avslutad',
        },
        evidence_types: {
            dpa_agreement: 'DPA-avtal',
            risk_assessment: 'Riskbedömning',
            audit_report: 'Revisionsrapport',
            certification: 'Certifiering',
            deletion_confirmation: 'Raderingsbekräftelse',
            training_record: 'Utbildningsjournal',
            incident_report: 'Incidentrapport',
            document: 'Dokument',
            screenshot: 'Skärmbild',
            policy: 'Regel',
            contract: 'Kontrakt',
            assessment: 'Bedömning',
            correspondence: 'Korrespondens',
            other: 'Annat',
        },
        linkable_entity_types: {
            vendor: 'Leverantör',
            transfer_mechanism: 'Överföringsmekanism',
            playbook: 'Spelbok',
            execution: 'Utförande',
            system: 'Systemet',
            activity: 'Aktivitet',
        },
        subprocessors: {
            title: 'Underbiträdesrelationer',
            new: 'Ny Koppling',
            vendor: 'Leverantör',
            subprocessor: 'Underbiträde',
            relationship_type: 'Relationstyp',
            countries: 'Länder',
            countries_csv: 'Länder (kommaseparerad)',
            dpa_chain: 'DPA-kedja',
            dpa_chain_status: 'DPA-kedjestatus',
            no_processors: 'Inga biträden hittades.',
            no_subprocessors: 'Inga underbiträden hittades.',
            processor_vendor: 'Biträdesleverantör',
            select_processor: 'Välj Biträde',
            select_vendor: 'Välj Leverantör',
            services: 'Tjänster',
            sub_processor_vendor_id: 'Underbiträdes Leverantörs-ID',
            terminate: 'Avsluta',
            confirm_terminate: 'Är du säker på att du vill avsluta denna relation?',
            create_error: 'Kunde inte skapa koppling.',
            fetch_error: 'Kunde inte hämta underbiträden.',
            processor: 'Biträde',
            services_csv: 'Tjänster (kommaseparerad)',
            terminate_error: 'Kunde inte avsluta.',
            version_history_heading: 'Ändra version av underprocessor',
            change_tracking_note: 'Alla ändringar av underprocessorrelationen är versionerade. Varje modifiering registrerar före/efter-tillståndet för revisionsspår.',
            history_retention_note: 'Ändringshistoriken sparas under hela datalagringsperioden. Granska ändringsloggar via leverantörens detaljvy.',
            vendor_risk_cross_view_heading: 'Underbiträdesregister (Vendor Risk)',
            vendor_risk_cross_view_source: 'Källa: Vendor Risk-register',
            vendor_risk_cross_view_empty: 'Inga poster i Vendor Risk-registret.',
        },
        cross_border: {
            title: 'Gränsöverskridande Styrningsrapport',
            flows: 'Gränsöverskridande Flöden',
            transfers: 'Gränsöverskridande Överföringar',
            detected_gaps: 'Upptäckta Brister',
            safeguards: 'Skyddsåtgärder',
            cross_border_vendors: 'Gränsöverskridande Leverantörer',
            destination: 'Mål',
            no_cross_border_vendors: 'Inga gränsöverskridande leverantörer hittades.',
            no_safeguard: 'Ingen skyddsåtgärd',
            processing_locations: 'Behandlingsplatser',
            export_error: 'Kunde inte exportera rapport.',
            export_pdf: 'Exportera PDF',
            export_success: 'Rapporten exporterades.',
            exporting: 'Exporterar...',
            fetch_error: 'Kunde inte hämta gränsöverskridande data.',
            source: 'Källa',
            pdpl_p2_heading: '[[TOK_0]]-P2 Överensstämmelse med gränsöverskridande överföring',
            dossier_prep_note: 'Förberedelse av underlag: sammanställ konsekvensbedömning, rättslig grund och skyddsdokumentation före inlämning.',
            filing_tracking_note: 'Registreringsspårning: övervaka inlämningsstatus med myndigheten (PDPC) från första ansökan till godkännande.',
            supplement_loop_note: 'Tilläggsslinga: svara på förfrågningar om myndighetsinformation och skicka in ändrade underlag igen vid behov.',
            official_forms_note: 'Officiella formulär: använd Mau so 01a (Ansökan), Mau so 01b (Kompletterande information) och Mau so 09 (Transfer Impact Assessment) enligt [[TOK_0]]-P2-bestämmelser.',
            vendor_search_label: 'Leverantörssökning',
            vendor_search_placeholder: 'Sök efter leverantörsnamn…',
            jurisdiction_filter_label: 'Jurisdiktion',
            filings_section_heading: 'Gränsöverskridande anmälningar',
            filings_empty: 'Inga anmälningar ännu. Skapa en för att starta ett underlag.',
            filings_create_button: 'Ny arkivering',
            filings_table_id: 'Arkiv-ID',
            filings_table_jurisdiction: 'Jurisdiktion',
            filings_table_type: 'Formulärtyp',
            filings_table_status: 'Status',
            filings_table_updated: 'Uppdaterad',
            filings_table_open: 'Öppna',
            filings_detail_title: 'Gränsöverskridande arkivering',
            filings_back_to_list: 'Tillbaka till Cross-Border',
            filings_status_heading: 'Livscykel',
            filings_evidence_heading: 'Bevis',
            filings_history_heading: 'Revisionsspår',
            filings_field_filing_id: 'Arkiv-ID',
            filings_field_jurisdiction: 'Jurisdiktion',
            filings_field_type: 'Formulärtyp',
            filings_field_status: 'Status',
            filings_field_reference: 'Myndighetsreferens',
            filings_field_mps_receipt: '[[TOK_0]] kvitto',
            filings_field_submitted_at: 'Inlämnad kl',
            filings_field_acknowledged_at: 'Erkändes kl',
            filings_field_archived_at: 'Arkiverad på',
            filings_field_version: 'Version',
            filings_field_notes: 'Anteckningar',
            filings_action_advance: 'Förhandsstatus',
            filings_action_reject: 'Avvisa',
            filings_action_archive: 'Arkiv',
            filings_action_submit: 'Mark inlämnat',
            filings_action_acknowledge: 'Mark kvitterade',
            filings_action_resume_draft: 'Återuppta som utkast',
            filings_status_draft: 'Utkast',
            filings_status_assessed: 'Bedömd',
            filings_status_pending_review: 'Väntar på granskning',
            filings_status_ready_to_file: 'Klar att arkivera',
            filings_status_submitted: 'Inlämnad',
            filings_status_acknowledged: 'Erkänt',
            filings_status_rejected: 'Avvisad',
            filings_status_archived: 'Arkiverad',
            filings_type_mau_01a: 'Mẫu 01a — Överföringsansökan',
            filings_type_mau_03a: 'Mẫu 03a — Tilläggsunderlag',
            filings_type_mau_09: 'Mẫu 09 — Överföringskonsekvensbedömning',
            filings_new_dialog_title: 'Ny gränsöverskridande arkivering',
            filings_new_form_jurisdiction: 'Jurisdiktion (t.ex. VN-[[TOK_0]])',
            filings_new_form_type: 'Formulärtyp',
            filings_new_form_notes: 'Anteckningar (valfritt)',
            filings_new_submit: 'Skapa',
            filings_new_cancel: 'Avbryt',
            filings_reason_label: 'Anledning',
            filings_reference_label: 'Myndighetens referensnummer',
            filings_mps_receipt_label: '[[TOK_0]] kvittoreferens',
            filings_create_error: 'Det gick inte att skapa arkivering.',
            filings_create_success: 'Arkiv skapat.',
            filings_update_error: 'Det gick inte att uppdatera arkivet.',
            filings_update_success: 'Arkivet uppdaterat.',
            filings_fetch_error: 'Det gick inte att hämta anmälningar.',
            filings_archive_confirm: 'Arkivera denna arkivering? Detta kan inte ångras.',
            filings_status_rejected_detour: 'Anmälan avslogs efter granskning. Återuppta som utkast för att starta om flödet.',
            recent_exports_heading: 'Senaste exporten',
            recent_exports_empty: 'Ingen export ännu. Klicka på "Exportera [[TOK_0]]" för att skapa en.',
        },
        drift: {
            title: 'Avvikelseövervakning för Konfiguration',
            drift_type: 'Avvikelsetyp',
            severity: 'Allvarlighetsgrad',
            detected_at: 'Upptäckt Vid',
            resolve: 'Åtgärda',
            all_check_types: 'Alla Kontrolltyper',
            all_entity_types: 'Alla Entitetstyper',
            event_count: 'Antal Händelser',
            accept_risk: 'Acceptera Risk',
            acknowledge: 'Bekräfta',
            assign_error: 'Kunde inte tilldela.',
            assign_event: 'Tilldela',
            assigned: 'Tilldelad',
            enter_resolution_notes: 'Ange åtgärdsanteckningar...',
            enter_user_id: 'Ange användar-ID...',
            entity: 'Entitet',
            fetch_error: 'Kunde inte hämta avvikelsehändelser.',
            no_events: 'Inga avvikelsehändelser hittades.',
            resolution_notes: 'Åtgärdsanteckningar',
            update_status_error: 'Kunde inte uppdatera status.',
        },
        scores: {
            title: 'Översikt Efterlevnadspoäng',
            overall: 'Övergripande Efterlevnadspoäng',
            breakdown: 'Poängfördelning per Modul',
            trend: 'Historisk Trend',
            module: 'Modul',
            score: 'Poäng',
            grade: 'Betyg',
            calculated_at: 'Beräknad Vid',
            generate_board_report: 'Generera Styrelseberättelse',
            lang_english: 'Engelska',
            lang_vietnamese: 'Vietnamesiska',
            fetch_error: 'Kunde inte hämta efterlevnadspoäng.',
            generate_report: 'Generera Rapport',
            generating: 'Genererar...',
            recommendations: 'Rekommendationer',
            report_error: 'Kunde inte generera rapport.',
            factor_owner_assigned: 'Ägare tilldelad',
            factor_data_categories_linked: 'Datakategorier länkade',
            factor_purposes_linked: 'Ändamål länkade',
            factor_data_flows_documented: 'Dataflöden dokumenterade',
            factor_processing_activity_linked: 'Behandlingsaktivitet länkad',
            factor_dpa_status: 'DPA-status',
            factor_retention_policy_linked: 'Lagringspolicy länkad',
            factor_last_reviewed: 'Senast granskad inom tröskelvärde',
            factor_risk_assessment_current: 'Riskbedömning aktuell',
            factor_sub_processors_documented: 'Underbiträden dokumenterade',
            factor_cross_border_safeguards: 'Gränsöverskridande skyddsåtgärder',
            factor_contact_info_complete: 'Kontaktuppgifter fullständiga',
            factor_onboarding_approved: 'Onboarding godkänd',
            factor_avg_system_score: 'Genomsnittlig systempoäng',
            factor_avg_vendor_score: 'Genomsnittlig leverantörspoäng',
            factor_processing_activity_coverage: 'Täckning av behandlingsaktiviteter',
            factor_ropa_completeness: 'RoPA-fullständighet',
            factor_open_drift_events: 'Öppna avvikelsehändelser',
        },
        playbooks: {
            title: 'Raderingshandlingsplaner',
            new: 'Ny Handlingsplan',
            edit: 'Redigera Handlingsplan',
            steps: 'Steg',
            add_step: 'Lägg till Steg',
            remove_step: 'Ta bort Steg',
            data_categories_csv: 'Datakategorier (kommaseparerad)',
            estimated_duration: 'Beräknad Varaktighet',
            estimated_duration_label: 'Beräknad Varaktighet',
            evidence_description: 'Bevisbeskrivning',
            no_playbooks: 'Inga handlingsplaner hittades.',
            playbook_count: 'Antal Handlingsplaner',
            requires_evidence: 'Kräver Bevisning',
            step_label: 'Stegetikett',
            target_name: 'Målnamn',
            target_type: 'Måltyp',
            action_type: 'Åtgärdstyp',
            archive_error: 'Kunde inte arkivera.',
            confirm_archive: 'Är du säker på att du vill arkivera denna handlingsplan?',
            data_categories: 'Datakategorier',
            days: 'dagar',
            fetch_error: 'Kunde inte hämta handlingsplaner.',
            sla_days: 'SLA (dagar)',
            target_id: 'Mål-ID',
            template_class_heading: 'Mallklassificering',
            official: 'Officiell',
            internal: 'Internt',
            classification: 'Klassificering',
            official_note: 'Officiella: mallar som är beordrade av myndighet i linje med [[TOK_1]], [[TOK_0]], eller sektorspecifika krav.',
            internal_note: 'Internt: organisationsspecifika procedurer som inte härrör från regulatoriska mallar.',
            active_executions_heading: 'Aktiva körningar',
            no_active_executions: 'Inga aktiva körningar.',
            playbook_label: 'Playbook',
            ticket_id_label: 'Ärende',
            progress_label: 'Framsteg',
            actions_label: 'Åtgärder',
            view_steps_label: 'Visa steg',
            execution_detail_title: 'Körningsdetaljer',
            playbook_missing: 'Playbook hittades inte.',
            evidence_required_label: 'Bevis krävs',
            upload_evidence_label: 'Ladda upp bevis',
            mark_complete_label: 'Markera som klart',
            evidence_required_toast: 'Bevis krävs innan steget kan slutföras.',
            evidence_blocking_message: 'Bifoga en bevisfil för att fortsätta.',
            step_completed_toast: 'Steg slutfört.',
            executions_fetch_error: 'Kunde inte läsa in körningar.',
            step_evidence_default_name: 'Bevis för körningssteg',
            attached_evidence_label: 'Bifogade bevis',
        },
        approvals: {
            title: 'Godkännandeflöden',
            new: 'Nytt Godkännande',
            edit: 'Redigera Godkännande',
            request_type: 'Typ av Begäran',
            requester: 'Sökande',
            approve: 'Godkänn',
            reject: 'Avvisa',
            justification: 'Motivering',
            all_action_types: 'Alla Åtgärdstyper',
            decided_by: 'Beslutat Av',
            no_approvals: 'Inga godkännanden hittades.',
            approval_count: 'Antal Godkännanden',
            approval_notes_optional: 'Anteckningar (valfritt)',
            approve_error: 'Kunde inte godkänna.',
            approve_request: 'Godkänn Begäran',
            decision: 'Beslut',
            entity: 'Entitet',
            fetch_error: 'Kunde inte hämta godkännanden.',
            reject_error: 'Kunde inte avvisa.',
            reject_request: 'Avvisa Begäran',
            rejection_notes_required: 'Avvisningsanteckningar krävs',
            rejection_notes_required_msg: 'Ange en anledning till avvisningen.',
            requested_at: 'Begärd Vid',
            multi_step_heading: 'Arbetsflöde för godkännande i flera steg',
            legal_review_note: 'Steg 1 — Juridisk granskning: Juridisk råd granskar begäran om regelefterlevnad.',
            dpo_review_note: 'Steg 2 — [[TOK_0]] Granskning: Dataskyddsombudet validerar dataskyddskonsekvenserna.',
            management_review_note: 'Steg 3 — Management Sign-Off: Högsta ledningen ger slutlig auktorisering.',
            supporting_evidence_label: 'Stödjande bevis (valfritt)',
            decision_evidence_name: 'Beslutsbevis',
        },
        evidence: {
            title: 'Styrningsbevisning',
            new: 'Ny Bevisning',
            link_to: 'Länka Till',
            entity_id_placeholder: 'Entitets-ID',
            file_path_placeholder: '/sökväg/till/fil',
            evidence_label: 'Bevisetikett',
            file_path: 'Filsökväg',
            source_mode_label: 'Beviskälla',
            source_mode_file: 'Ladda upp fil',
            source_mode_url: 'Länka extern URL',
            attachment_label: 'Bilaga',
            item_count: 'Antal Poster',
            link_button: 'Länka Bevisning',
            confirm_delete: 'Är du säker på att du vill radera denna bevisning?',
            enter_entity_id: 'Ange entitets-ID...',
            entity_id: 'Entitets-ID',
            entity_type: 'Entitetstyp',
            expires: 'Utgår',
            expires_at: 'Utgår Vid',
            fetch_error: 'Kunde inte hämta bevisning.',
            link_error: 'Kunde inte länka bevisning.',
            no_evidence: 'Ingen bevisning hittades.',
            tags_csv: 'Taggar (kommaseparerad)',
            uploaded: 'Uppladdad',
            url: 'URL',
            framework_tag_heading: 'Rammärkta bevis',
            framework_tag_note: 'Varje bevispost fångar ramkod, aktör och tidsstämpel. Filtrera efter ramverk för att isolera revisionsrelevanta poster.',
            framework_code: 'Ramkod',
            filter_by_framework: 'Filtrera efter ramkod...',
            actor: 'Skådespelare',
        },
        certification: {
            not_applicable: 'Ej tillämpligt',
            not_certified: 'Ej certifierad',
            pending: 'Väntar',
            certified: 'Certifierad',
            revoked: 'Återkallad',
        },
        onboarding_pipeline: {
            title: 'Onboarding-pipeline',
            new_workflow: 'Nytt onboarding-arbetsflöde',
            vendor_id: 'Leverantörs-ID',
            stages: 'Steg',
            current_stage: 'Nuvarande steg',
            advance: 'Avancera steg',
            advance_success: 'Steget har avancerats',
            workflow_status: 'Arbetsflödesstatus',
            initiated: 'Påbörjad',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            cancelled: 'Avbruten',
            no_workflows: 'Inga onboarding-arbetsflöden hittades',
            stages_placeholder: 'Steg 1, Steg 2, Steg 3',
            assigned_to: 'Tilldelad till',
            notes: 'Anteckningar',
            pdpl_lifecycle_heading: '[[TOK_0]] Leverantörlivscykel — Onboarding',
            due_diligence_note: 'Due diligence-stadiet är obligatoriskt innan någon processor tas med under [[TOK_0]]. Verifiera databehandlingens omfattning, rättslig grund och säkerhetsåtgärder.',
            contract_review_note: 'Kontraktsgranskning måste bekräfta DPA-klausuler, begränsningar för datalagring och begränsningar för underbehandlare.',
            create_dpa_review_cta: 'Skapa DPA-granskning',
            dpa_review_linked: 'DPA-granskning länkad',
        },
        dpa_review: {
            title: 'DPA-granskningar',
            new_review: 'Ny DPA-granskning',
            review_type: 'Granskningstyp',
            findings: 'Resultat',
            outcome: 'Utfall',
            complete_review: 'Slutför granskning',
            complete_success: 'Granskning slutförd',
            link_assessment: 'Länka säkerhetsbedömning',
            link_success: 'Bedömning länkad',
            assessment_id: 'Bedömnings-ID',
            combined_title: 'Kombinerad bedömning',
            no_reviews: 'Inga DPA-granskningar hittades',
            telecom_disclosure_heading: 'Telecom Disclosure Governance',
            disclosure_trigger_note: 'Avslöjandeutlösta recensioner fångar datadelningshändelser för telekomabonnenter enligt VN Telecom Law.',
            telecom_t2_note: 'TELECOM-T2 nivågodkännande krävs innan abonnentdata avslöjas till myndigheter.',
            quarterly_log_note: 'Använd kvartalsloggen för att dokumentera alla avslöjande händelser och upprätthålla ett kontinuerligt revisionsspår.',
        },
        periodic_review: {
            title: 'Periodiska granskningar',
            new_review: 'Ny periodisk granskning',
            review_type: 'Granskningstyp',
            due_date: 'Förfallodatum',
            next_review: 'Nästa granskningsdatum',
            trigger_reassessment: 'Utlös ombedömning',
            reassessment_reason: 'Orsak till ombedömning',
            reassessment_success: 'Ombedömning utlöst',
            complete_success: 'Granskning slutförd',
            scheduled: 'Schemalagd',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            overdue: 'Försenad',
            material_change: 'Väsentlig förändring',
            no_reviews: 'Inga periodiska granskningar hittades',
            mark_complete: 'Markera som slutförd',
            pdpl_periodic_heading: '[[TOK_0]] Leverantörens livscykel – periodiska granskningar',
            scheduled_review_note: 'Periodiska granskningar måste schemaläggas minst årligen för alla aktiva processorer. Försenade recensioner utlöser efterlevnadsvarningar.',
            material_change_note: 'Väsentliga förändringar i databehandling kräver omedelbar omprövning oavsett tidsplan.',
            overdue_badge: 'Försenad',
            overdue_aria: 'Försenad granskning',
            only_overdue_filter: 'Endast försenade',
        },
        offboarding: {
            title: 'Leverantörs-avregistrering',
            initiate: 'Påbörja avregistrering',
            initiate_success: 'Avregistrering påbörjad',
            reason: 'Orsak till avregistrering',
            data_return_required: 'Dataåterlämning krävs',
            verify_data: 'Verifiera dataåterlämning',
            verify_success: 'Dataåterlämning verifierad',
            sign_off: 'Godkänn',
            sign_off_success: 'Avregistrering godkänd',
            status_initiated: 'Påbörjad',
            status_data_pending: 'Väntar på dataåterlämning',
            status_data_verified: 'Dataåterlämning verifierad',
            status_completed: 'Slutförd',
            status_cancelled: 'Avbruten',
            task_id: 'Uppgifts-ID',
            no_tasks: 'Inga avregistreringsuppgifter hittades',
            evidence_id: 'Bevisnings-ID',
            pdpl_offboarding_heading: '[[TOK_0]] Leverantörslivscykel — Offboarding och radering',
            deletion_capture_note: 'Offboarding måste hämta bekräftelse på radering av data från leverantören. Verifiera dataretur innan avloggning.',
            evidence_attachment_note: 'Bifoga raderingsbevis (certifikat, skärmdumpar, leverantörsbekräftelser) för att slutföra offboard-posten.',
            verify_mode_label: 'Verifieringsmetod',
            verify_mode_upload: 'Ladda upp ny fil',
            verify_mode_link: 'Länka befintligt bevis',
            verify_mode_none: 'Inga data att återlämna',
            upload_data_return_evidence: 'Ladda upp bevis för dataåterlämning',
            no_data_justification_label: 'Motivering',
            no_data_justification_placeholder: 'Förklara varför inga data behöver återlämnas',
            no_data_justification_hint: 'Minst 20 tecken',
            upload_required_toast: 'Bifoga en fil för att fortsätta',
            evidence_link_required_toast: 'Välj ett bevis för att fortsätta',
            no_data_justification_required_toast: 'Ange en motivering på minst 20 tecken',
            data_return_evidence_name: 'Bevis för dataåterlämning',
        },
        dpa_review_types: {
            initial: 'Inledande',
            annual: 'Årlig',
            renewal: 'Förnyelse',
            incident_triggered: 'Incidentutlöst',
        },
        periodic_review_types: {
            initial: 'Inledande',
            annual: 'Årlig',
            renewal: 'Förnyelse',
            incident_triggered: 'Incidentutlöst',
            material_change: 'Väsentlig ändring',
            disclosure_triggered: 'Upplysningsutlöst',
            quarterly_log: 'Kvartalslogg',
        },
        dpa_review_statuses: {
            pending: 'Väntande',
            in_progress: 'Pågående',
            completed: 'Avslutad',
            cancelled: 'Avbruten',
        },
        onboarding_stage_names: {
            due_diligence: 'Förundersökning',
            contract_review: 'Avtalsgranskning',
            security_assessment: 'Säkerhetsbedömning',
            data_mapping: 'Datakartläggning',
            approval: 'Godkännande',
            integration: 'Integration',
        },
        access_denied_title: 'Åtkomst nekad',
        access_denied: 'Du har inte behörighet att visa denna sida. Kontakta din administratör.',
    },
    consent: {
        nav: {
            policies: 'Policyer',
            purposes: 'Ändamålskatalog',
            workflows: 'Arbetsflöden',
            snapshots: 'CMP-ögonblicksbilder',
            change_awareness: 'Ändringsmedvetenhet',
            audit: 'Samtyckesgranskning',
        },
        gap_analysis: {
            nav_label: 'Gapanalys',
            page_title: 'Analys av samtyckesgap',
            page_subtitle: 'Forseti kontrollerar dina aktiva samtyckesändamål mot kraven på installerade ramar ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) och ytar luckor med hänvisning + föreslagen åtgärd.',
            framework_picker_label: 'Ramar',
            org_flags_label: 'Organisationssammanhang',
            flag_withdrawal: 'Har en global uttagsmekanism dokumenterad',
            flag_parental: 'Har föräldrarnas samtycke för personer under 16 år',
            flag_cross_border: 'Har registrerat gränsöverskridande arkivering',
            run_label: 'Kör gapanalys',
            running_label: 'Kör...',
            requires_advisor_label: 'Kräver ai_advisor:chattbehörighet.',
            results_heading: 'Luckor uppstod ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            empty_label: 'Inga luckor upptäcktes för de valda ramarna.',
            remediation_label: 'Föreslagen åtgärd:',
            dismiss_label: 'Avvisa som inte tillämpligt',
            resolve_label: 'Lös',
            dismissed_label: 'Avvisas som ej tillämplig',
            resolved_label: 'Löst',
        },
        import: {
            title: 'Importera samtyckesarbetsflöden',
            nav_title: 'Massimport',
            description: 'Ladda upp en CSV-fil för att massimportera samtyckesarbetsflöden.',
            select_file: 'Välj CSV-fil',
            file_help: 'CSV med rubriker som matchar arbetsflödesfält.',
            required_columns_help: 'Obligatoriska kolumner: Arbetsflödestyp, Registrerad, Kanal.',
            file_too_large: 'Filen är för stor. Maximal storlek är 2MB.',
            preview: 'Förhandsgranska',
            columns_detected: 'Kolumner hittade: {count}',
            column_mapping: 'Kolumnmappning',
            import_button: 'Importera',
            import_complete: 'Import slutförd',
            import_error: 'Import misslyckades',
            result: 'Importresultat',
            total: 'Totalt',
            imported: 'Importerade',
            skipped: 'Överhoppade',
            failed: 'Misslyckade',
            errors: 'Fel',
            error_row: 'Rad',
            error_field: 'Fält',
            error_message: 'Meddelande',
            history: 'Importhistorik',
            no_history: 'Ingen importhistorik.',
            history_file: 'Filnamn',
            history_date: 'Datum',
            create_profiles_label: 'Skapa Registrerade-profiler för nya subjekt',
            create_profiles_help: 'Import utan en matchande profil skapar automatiskt en. Avmarkera för att endast importera arbetsflöden.',
            profiles_created: 'Profiler skapade',
            profiles_matched: 'Profiler matchade',
            subject_kind_help: 'Valfria kolumner: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Ogiltig e-post i subject_email-kolumnen.',
            error_subject_unknown_kind: 'Okänt subject_kind-värde. Förväntat: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key krävs när subject_kind=external_ref',
        },
        policies: {
            title: 'Samtyckespolicyer',
            new: 'Ny Policy',
            edit: 'Redigera Policy',
            name: 'Namn',
            version: 'Utgåva',
            policy_text: 'Policytext',
            publish: 'Publicera',
            versions: 'Versioner',
            hide_versions: 'Dölj Versioner',
            submit_for_review: 'Skicka för Granskning',
            suspend: 'Pausa',
            retire: 'Avveckla',
            jurisdictions: 'Jurisdiktioner',
            jurisdictions_csv: 'Jurisdiktioner (kommaseparerade)',
            approval_mode: 'Godkännandeläge',
            reviewer_ids: 'Granskare-ID (kommaseparerade)',
            tags_csv: 'Taggar (kommaseparerade)',
            effective_date: 'Ikraftträdandedatum',
            review_date: 'Granskningsdatum',
            consent_model_statement: 'Samtyckesmodellförklaring',
            consent_model_placeholder: 'Valfri samtyckesmodellförklaring...',
            default_settings: 'Standardinställningar (JSON)',
            changes: 'Ändringar',
            fetch_error: 'Kunde inte hämta samtyckespolicyer. Försök igen.',
            save_error: 'Kunde inte spara samtyckespolicy. Försök igen.',
            submit_review_error: 'Kunde inte skicka policy för granskning. Försök igen.',
            activate_error: 'Kunde inte aktivera policy. Försök igen.',
            suspend_error: 'Kunde inte pausa policy. Försök igen.',
            retire_error: 'Kunde inte avveckla policy. Försök igen.',
            submit_review_success: 'Policy har skickats in för granskning.',
            activate_success: 'Policy aktiverad.',
            suspend_success: 'Politiken avstängd.',
            retire_success: 'Politiken gick i pension.',
            versions_error: 'Kunde inte hämta policyversioner. Försök igen.',
            invalid_json: 'Ogiltig JSON i fältet Standardinställningar. Försök igen.',
            page_title: 'Samtyckespolicyer',
            version_updated: 'Uppdaterad',
            version_initial: 'Ursprunglig version',
            json_format: '[[TOK_0]] format',
            sensitive: 'Känslig',
            flag_sensitive: 'Flagga känslig',
            flag_sensitive_title: 'Flagga policy som känslig',
            require_enhanced_review: 'Kräv förbättrad granskning',
            enhanced_review_success: 'Krav på förbättrad granskning har aktiverats.',
            select_categories: 'Välj tillämpliga [[TOK_0]] artikel 2 känsliga datakategorier:',
            no_policies: 'Inga samtyckespolicyer hittades. Skapa din första policy för att komma igång.',
            approval_success: 'Policy godkänd.',
            reviewers_label: 'Granskare',
            enhanced_review_title: 'Utökad granskning krävs',
            enhanced_review_badge: 'Utökad granskning krävs',
            enhanced_review_status_pending: 'Granskning väntar',
            enhanced_review_status_approved: 'Granskning godkänd',
            enhanced_review_status_rejected: 'Granskning avvisad',
            enhanced_review_reviewed_by: 'Granskad av',
            enhanced_review_notes: 'Granskningsanteckningar',
            enhanced_review_approve: 'Godkänn granskning',
            enhanced_review_reject: 'Avvisa granskning',
            enhanced_review_notes_required: 'Granskningsanteckningar krävs',
            enhanced_review_approved: 'Utökad granskning godkänd',
            enhanced_review_rejected: 'Utökad granskning avvisad — policy återställd till utkast',
            enhanced_review_reset_to_draft: 'Utökad granskning avvisad — policy återställd till utkast',
            enhanced_review_reject_warning: 'Avvisning återställer denna policy till Utkast-status. DPO måste skicka in på nytt för granskning efter att ha åtgärdat problemen.',
            submitted_modal_title: 'Inskickad för utökad granskning',
            submitted_modal_body: 'Denna policy har skickats in. En Juridisk/Integritetsgranskare måste godkänna den innan den kan aktiveras.',
        },
        sensitive_categories: {
            health: 'Halsodata',
            biometric: 'Biometriska data',
            political: 'Politiska asikter',
            ethnic: 'Etniskt ursprung',
            genetic: 'Genetiska data',
            criminal: 'Brottsregister',
        },
        purposes: {
            title: 'Ändamålskatalog',
            new: 'Nytt Ändamål',
            edit: 'Redigera Ändamål',
            name: 'Namn',
            legal_basis: 'Rättslig Grund',
            retention_days: 'Lagringsperiod (dagar)',
            is_active: 'Aktiv',
            filter_by_category: 'Filtrera efter kategori',
            policy_ids: 'Policy-ID (kommaseparerade)',
            ropa_activity_ids: 'ROPA-aktivitets-ID (kommaseparerade)',
            policies: 'Policyer',
            deprecate: 'Fasas ut',
            fetch_error: 'Kunde inte hämta samtyckesändamål. Försök igen.',
            save_error: 'Kunde inte spara samtyckesändamål. Försök igen.',
            deprecate_error: 'Kunde inte fasa ut samtyckesändamål. Försök igen.',
            page_title: 'Ändamålskatalog',
            no_purposes: 'Inga samtyckesändamål hittades. Skapa ditt första ändamål för att komma igång.',
            category_personal_data: 'Personuppgifter',
            category_sensitive_data: 'Känsliga data',
            category_health_data: 'Hälsodata',
            category_financial_data: 'Finansiella data',
            category_biometric_data: 'Biometriska data',
            category_children_data: 'Barns data',
            category_location_data: 'Platsdata',
            category_communications_data: 'Kommunikationsdata',
            category_other: 'Annat',
        },
        workflows: {
            title: 'Samtyckesarbetsflöden',
            new: 'Nytt Arbetsflöde',
            edit: 'Redigera Arbetsflöde',
            workflow_type: 'Arbetsflödestyp',
            user_id: 'Användar-ID',
            purpose_id: 'Ändamåls-ID',
            purpose_ids_csv: 'Ändamåls-ID (kommaseparerade)',
            reason: 'Anledning',
            process: 'Bearbeta',
            data_subject_ref: 'Referens för Registrerad',
            data_subject: 'Registrerad',
            channel: 'Kanal',
            policy_id: 'Policy-ID',
            scope: 'Omfattning',
            legal_grounds: 'Rättslig Grund',
            assessment: 'Bedömning',
            select_outcome: 'Välj Resultat',
            partially_approved: 'Delvis Godkänd',
            denied: 'Nekad',
            outcome_upheld: 'Bekräftad',
            outcome_pending: 'Väntar',
            outcome_denied: 'Nekad',
            status_count: 'Statusantal',
            channel_filter: 'Filtrera efter kanal',
            add_action: '+ Åtgärd',
            by_type: 'Per Typ',
            by_status: 'Per Status',
            downstream_actions: 'Efterföljande Åtgärder',
            downstream_actions_for: 'Efterföljande Åtgärder för {subject} ({type})',
            add_downstream_action: 'Lägg till Efterföljande Åtgärd',
            assigned_to: 'Tilldelad Till',
            fetch_error: 'Kunde inte hämta samtyckesarbetsflöden. Försök igen.',
            dashboard_error: 'Kunde inte hämta arbetsflödesöversikt. Försök igen.',
            save_error: 'Kunde inte spara samtyckesarbetsflöde. Försök igen.',
            status_update_error: 'Kunde inte uppdatera arbetsflödesstatus. Försök igen.',
            assessment_error: 'Kunde inte uppdatera arbetsflödesbedömning. Försök igen.',
            add_action_error: 'Kunde inte lägga till arbetsflödesåtgärd. Försök igen.',
            update_action_error: 'Kunde inte uppdatera arbetsflödesåtgärd. Försök igen.',
            type_refusal: 'Avslag',
            type_withdrawal: 'Återkallande',
            type_restriction: 'Begränsning',
            type_objection: 'Invändning',
            status_received: 'Mottagen',
            status_processing: 'Bearbetas',
            status_under_assessment: 'Under Bedömning',
            status_implemented: 'Genomförd',
            evidence_button: 'Bevis',
            evidence_modal_title: 'Arbetsflödesbevis',
            no_evidence: 'Inga bevis kopplade till detta arbetsflöde.',
            upload_evidence_label: 'Ladda upp arbetsflödesbevis',
            completed_at: 'Avslutad kl',
            effective_date: 'Ikraftträdande datum',
            page_title: 'Arbetsflöden för samtycke',
            no_workflows: 'Inga samtyckesarbetsflöden hittades. Arbetsflöden skapas när registrerade utövar sina rättigheter.',
            type_grant: 'Beviljande',
            propagation_none: 'Ingen',
            propagation_pending: 'Väntar',
            propagation_pending_warning: 'Kan inte slutföra — återkallelsepropagering är fortfarande väntande',
            propagation_completed: 'Slutförd',
            propagation_partial: 'Delvis',
            propagation_incomplete_error: 'Kan inte slutföra arbetsflödet medan återkallelsepropagering fortfarande väntar',
            propagation_status: 'Propageringsstatus',
        },
        snapshots: {
            title: 'CMP-ögonblicksbilder',
            new: 'Ny Ögonblicksbild',
            label: 'Etikett',
            snapshot_date: 'Datum för Ögonblicksbild',
            purposes_count: 'Antal Ändamål',
            compare: 'Jämför',
            snapshot_data: 'Ögonblicksdata (JSON)',
            select_left: 'Välj Vänster Ögonblicksbild',
            select_right: 'Välj Höger Ögonblicksbild',
            comparison_results: 'Jämförelseresultat',
            field: 'Fält',
            left: 'Vänster',
            right: 'Höger',
            close_comparison: 'Stäng Jämförelse',
            trigger: 'Utlösare',
            trigger_manual: 'Manuell',
            trigger_policy_approval: 'Policygodkännande',
            cmp_version: 'CMP-version',
            policy_version_id: 'Policyversions-ID',
            banner_config: 'Bannerkonfiguration (JSON)',
            active_purposes: 'Aktiva Ändamål (JSON)',
            active_legal_bases: 'Aktiva Rättsliga Grunder (JSON)',
            domain_scope: 'Domänomfattning',
            domain_scope_csv: 'Domänomfattning (kommaseparerade)',
            raw_config: 'Råkonfiguration (JSON)',
            checksum: 'Kontrollsumma',
            created: 'Skapad',
            fetch_error: 'Kunde inte hämta CMP-ögonblicksbilder. Försök igen.',
            save_error: 'Kunde inte spara CMP-ögonblicksbild. Försök igen.',
            compare_error: 'Kunde inte jämföra ögonblicksbilder. Försök igen.',
            page_title: 'Ögonblicksbilder av samtycke',
            json_format: '[[TOK_0]] format',
            json_array_format: '[[TOK_0]] arrayformat',
            manual_snapshot_note: 'Endast för administratörer/utvecklare. I normalt drift skapas ögonblicksbilder automatiskt via CMP-webhook eller vid policygodkännande. Klistra in JSON exporterad från din CMP-leverantör (t.ex. OneTrust, Cookiebot).',
            banner_config_hint: 'Klistra in bannerkonfigurationsobjektet från din CMP-export.',
            active_purposes_hint: 'JSON-array av aktiva ändamålsobjekt kopierade från din CMP-export.',
            active_legal_bases_hint: 'JSON-array av aktiva rättsliga grunder-objekt kopierade från din CMP-export.',
            raw_config_hint: 'Fullständig rå konfigurations-JSON från din CMP. Andra JSON-fält extraheras härifrån. En SHA-256-kontrollsumma beräknas automatiskt.',
            changed_field: 'Ändrat fält:',
            no_snapshots: 'Inga CMP-ögonblicksbilder hittades. Ögonblicksbilder skapas när policyer godkänns eller utlöses manuellt.',
            detail_title: 'Ögonblicksbildedetalj',
            view_snapshot_detail: 'Visa ögonblicksbildedetalj',
            policy_version: 'Policyversion',
            removed: 'Innan',
            added: 'Efter',
        },
        change_awareness: {
            title: 'Ändringsmedvetenhet för Samtycke',
            change_type: 'Ändringstyp',
            entity_type: 'Entitetstyp',
            entity_id: 'Entitets-ID',
            detected_at: 'Upptäckt Vid',
            acknowledge: 'Bekräfta',
            new_alert: 'Ny Varning',
            new_alert_form: 'Ny Ändringsmedvetenhetsvarning',
            total_open: 'Totalt Öppna',
            by_severity: 'Per Allvarlighetsgrad',
            snapshot_id: 'Ögonblicksbilds-ID',
            update_status: 'Uppdatera Status',
            resolution_notes: 'Lösningsanteckningar',
            resolution_required: 'Lösningsanteckningar (obligatoriskt)',
            resolution_required_msg: 'Lösningsanteckningar krävs vid åtgärdande av ett ärende.',
            status_open: 'Öppen',
            status_under_review: 'Under Granskning',
            status_resolved: 'Åtgärdad',
            status_accepted: 'Accepterad',
            severity_informational: 'Informativ',
            severity_requires_review: 'Kräver Granskning',
            severity_policy_violation: 'Policyöverträdelse',
            create_reconciliation: 'Skapa avstämningsuppgift',
            reconciliation_created: 'Avstämningsuppgiften har skapats.',
            reconciliation_error: 'Det gick inte att skapa avstämningsuppgift. Försök igen.',
            fetch_error: 'Kunde inte hämta ändringsmedvetenhetsposter. Försök igen.',
            dashboard_error: 'Kunde inte hämta ändringsmedvetenhetsöversikt. Försök igen.',
            create_error: 'Kunde inte skapa ändringsmedvetenhetspost. Försök igen.',
            status_update_error: 'Kunde inte uppdatera ändringsmedvetenhetsstatus. Försök igen.',
            page_title: 'Ändra medvetenhet',
            no_items: 'Inga ändringsmedvetenhetsartiklar hittades. Artiklar skapas när förändringar i samtyckeskonfigurationen upptäcks.',
        },
        audit: {
            title: 'Granskningslogg för Samtycke',
            event_type: 'Händelsetyp',
            user_id: 'Användar-ID',
            timestamp: 'Tidsstämpel',
            details: 'Detaljer',
            actor: 'Aktör',
            filter_by_entity_type: 'Filtrera efter entitetstyp',
            filter_by_action: 'Filtrera efter åtgärd',
            fetch_error: 'Kunde inte hämta samtyckesgranskning. Försök igen.',
            page_title: 'Samtyckesrevision',
            export_csv: 'Exportera [[TOK_0]]',
            exporting: 'Exporterar...',
            export_success: 'Granskningsspåret har exporterats.',
            export_error: 'Det gick inte att exportera granskningsspår för samtycke. Försök igen.',
            no_entries: 'Inga granskningsposter hittades. Granskningshändelser registreras automatiskt när samtyckedata ändras.',
            entity_policy: 'Policy',
            entity_purpose: 'Ändamål',
            entity_workflow: 'Arbetsflöde',
            entity_consent_record: 'Samtyckepost',
            entity_change_awareness: 'Ändringsmedvetenhet',
            entity_cmp_snapshot: 'CMP-ögonblicksbild',
            action_created: 'Skapad',
            action_updated: 'Uppdaterad',
            action_status_changed: 'Status ändrad',
            action_drift_detected: 'Avvikelse upptäckt',
            action_snapshot_created: 'Ögonblicksbild skapad',
            action_approval_submitted: 'Godkännande inskickat',
            action_archived: 'Arkiverad',
            action_purpose_auto_mapped: 'Ändamål automatiskt kopplat',
            action_purpose_mapping_updated: 'Ändamålskoppling uppdaterad',
            action_webhook_configured: 'Webhook konfigurerad',
            entity_propagation: 'Förökning',
            entity_reconciliation: 'Försoning',
            action_propagation_confirmed: 'Förökning bekräftad',
            action_propagation_failed: 'Förökningen misslyckades',
            action_consent_captured: 'Samtycke fångat',
            action_reconciliation_created: 'Avstämning skapad',
            action_reconciliation_resolved: 'Avstämning löst',
            action_submitted_for_review: 'Inskickad för granskning',
            action_activated: 'Aktiverad',
            action_suspended: 'Avstängd',
            action_retired: 'Avvecklad',
            action_enhanced_review_required: 'Förbättrad granskning krävs',
            action_enhanced_review_approved: 'Utökad granskning godkänd',
            action_enhanced_review_rejected: 'Utökad granskning avvisad — policy återställd till utkast',
            action_consented: 'Samtyckt',
            action_consented_customize: 'Samtycke anpassat',
            action_revoked: 'Återkallad',
            action_rejected: 'Avvisad',
        },
        web_records: {
            title: 'Web Consent Records',
            page_title: 'Web Consent Records',
            domain: 'Domän',
            visitor_id: 'Besökar-ID',
            consent_action: 'Åtgärd för samtycke',
            received_at: 'Mottaget kl',
            admin_status: 'Admin Status',
            revoke: 'Återkalla',
            reject: 'Avvisa',
            reason: 'Anledning',
            reason_placeholder: 'Anledning till denna åtgärd (valfritt)',
            revoke_confirm: 'Återkalla denna samtyckespost?',
            reject_confirm: 'Vill du avvisa denna samtyckespost?',
            override_success: 'Poststatus har uppdaterats.',
            override_error: 'Det gick inte att uppdatera poststatus.',
            no_records: 'Inga webbsamtyckesposter hittades.',
            fetch_error: 'Det gick inte att ladda webbsamtyckesposter.',
            filter_by_domain: 'Filtrera efter domän',
            filter_by_action: 'Filtrera efter åtgärd',
            active: 'Aktiv',
        },
        legal_bases: {
            all: 'Alla Rättsliga Grunder',
            consent: 'Samtycke',
            legitimate_interest: 'Berättigat Intresse',
            contract: 'Avtal',
            legal_obligation: 'Rättslig Förpliktelse',
            vital_interest: 'Vitalt Intresse',
            public_interest: 'Allmänt Intresse',
        },
        common_statuses: {
            suspended: 'Pausad',
            retired: 'Avvecklad',
            deprecated: 'Utfasad',
        },
        approval_modes: {
            all: 'Alla',
            any: 'Någon',
        },
        cmp_integration: {
            title: 'AesirX CMP-integration',
            back_to_consent: 'Tillbaka till Samtycke',
            back_to_integration: 'Tillbaka till Integration',
            webhook_status: 'Webhook-status',
            events_received: 'Mottagna Händelser',
            web_consent_records: 'Webbsamtyckesposter',
            unmapped_purposes: 'Okopplade Ändamål',
            integration_management: 'Integrationshantering',
            webhook_configuration: 'Webhook-konfiguration',
            webhook_config_desc: 'Konfigurera CMP-webhookens slutpunkt och hantera HMAC-hemligheten.',
            purpose_mapping: 'Ändamålskoppling',
            purpose_mapping_desc: 'Koppla CMP-ändamålsidentifierare till GRC:s samtyckeskatalogändamål.',
            bulk_sync: 'Masssynkronisering',
            bulk_sync_desc: 'Tillämpa ändamålskopplingar igen på alla okopplade samtyckesposter.',
            consent_analytics: 'Webbsamtyckesanalys (Senaste 30 Dagarna)',
            consent_grant_rate: 'Samtyckesbeviljningsgrad',
            top_domain: 'Toppdomän',
            records: 'poster',
            banner_interactions: 'Bannerinteraktioner',
            consent_actions: 'Samtycksåtgärder',
            opt_in_trend: 'Opt-in/Opt-out-trend',
            records_by_domain: 'Poster per domän',
            date: 'Datum',
            grants: 'Beviljanden',
            denials: 'Avslag',
            not_configured: 'Ej Konfigurerad',
            load_error: 'Kunde inte ladda integrationsdata',
            webhook_not_configured: 'Webhook ej konfigurerad.',
            webhook_not_configured_msg: 'Vänligen {link} först.',
            configure_webhook_link: 'konfigurera webhooken',
            setup_wizard: 'Installationsguide',
            step_configure_webhook: 'Konfigurera Webhook',
            step_map_purposes: 'Koppla Ändamål',
            step_run_sync: 'Kör Initial Masssynkronisering',
            step_verify_data: 'Verifiera Data i Översikten',
            configure: 'Konfigurera',
            view_dashboard: 'Visa Översikt',
            syncing: 'Synkroniserar...',
            sync_now: 'Synkronisera Nu',
            sync_completed: 'Synkronisering klar: {imported} importerade, {skipped} överhoppade, {failed} misslyckade.',
            sync_failed: 'Synkronisering misslyckades',
            last_sync_result: 'Senaste Synkroniseringsresultat',
            imported: 'Importerade',
            skipped: 'Överhoppade',
            errors: 'Fel',
            index: 'Innehållsförteckning',
            error: 'Fel',
            sync_history: 'Synkroniseringshistorik',
            no_sync_jobs: 'Inga synkroniseringsjobb registrerade ännu.',
            load_sync_error: 'Kunde inte ladda synkroniseringsdata',
            purpose_mapping_title: 'CMP-ändamålskoppling',
            auto_mapping: 'Automatisk koppling...',
            auto_map_purposes: 'Automatisk Ändamålskoppling',
            unmapped_warning: '{count} okopplat/okopplade ändamål -- dessa CMP-ändamål behöver kopplas till GRC-ändamål.',
            mapping_saved: 'Koppling sparad.',
            mapping_deleted: 'Koppling raderad.',
            auto_map_complete: 'Automatisk koppling klar: {mapped} kopplade, {unmatched} omatchade.',
            auto_map_failed: 'Automatisk koppling misslyckades',
            save_mapping_error: 'Kunde inte spara koppling',
            delete_mapping_error: 'Kunde inte radera koppling',
            load_data_error: 'Kunde inte ladda data',
            cmp_purpose: 'CMP-ändamål',
            grc_purpose: 'GRC-ändamål',
            select_grc_purpose: '-- Välj GRC-ändamål --',
            auto_mapped: 'Automatiskt Kopplad',
            mapped: 'Kopplad',
            unmapped: 'Okopplad',
            no_mappings: 'Inga ändamålskopplingar hittades. Kopplingar skapas automatiskt när samtyckeshändelser tas emot.',
            total_mappings: 'Totalt: {count} koppling(ar)',
            webhook_config_title: 'Webhook-konfiguration',
            current_configuration: 'Aktuell Konfiguration',
            setup_webhook: 'Konfigurera Webhook',
            setup_webhook_desc: 'Konfigurera AesirX CMP-webhooken för att ta emot samtyckeshändelser.',
            allowed_domains: 'Tillåtna Domäner (en per rad)',
            webhook_secret_warning: 'Webhook-hemlighet (spara denna nu -- den visas inte igen):',
            last_event: 'Senaste Händelse',
            none_received: 'Ingen',
            update_domains: 'Uppdatera Domäner',
            pause_webhook: 'Pausa Webhook',
            resume_webhook: 'Återuppta Webhook',
            regenerate_secret: 'Återskapa Hemlighet',
            configuring: 'Konfigurerar...',
            create_webhook_config: 'Skapa Webhook-konfiguration',
            webhook_endpoint: 'Webhook-slutpunkt',
            webhook_endpoint_desc: 'Konfigurera din AesirX CMP att skicka samtyckeshändelser till:',
            webhook_signature_note: 'Inkludera HMAC-SHA256-signaturen i {header}-headern.',
            configured_success: 'Webhook konfigurerad.',
            config_updated: 'Konfiguration uppdaterad.',
            config_error: 'Kunde inte konfigurera webhook',
            update_error: 'Kunde inte uppdatera konfiguration',
            toggle_error: 'Kunde inte växla webhook',
            deactivated: 'Webhook inaktiverad.',
            deactivate_error: 'Kunde inte inaktivera webhook',
            page_title: '[[TOK_0]] Integration',
            webhook_config_page_title: '[[TOK_0]] Webhook-konfiguration',
            bulk_sync_page_title: 'Mappa om poster',
            purpose_mapping_page_title: 'Syfteskartläggning',
            data_loaded: '[[TOK_0]] integrationsdata har laddats',
            sync_all: 'Synkronisera alla',
            sync_selected: 'Synkronisera valda',
            sync_status: 'Synkroniseringsstatus',
            last_sync: 'Senaste synkronisering',
            no_records: 'Inga poster hittades.',
            sync_in_progress: 'Synkronisering pågår...',
            sync_complete: 'Synkronisering klar.',
            sync_error: 'Synkroniseringen misslyckades. Försök igen.',
            map_purpose: 'Tilldela ändamål',
            unmap: 'Ta bort tilldelning',
            mapping_status: 'Tilldelningsstatus',
            save_mapping: 'Spara tilldelning',
            remap_unmapped_records: 'Kartlägga omappade poster',
            remap_records: 'Mappa om poster',
            add_mappings_first: 'Lägg till målmappningar först (steg 2)',
            remap_result: 'Ommappningsresultat',
            remap_result_desc: 'Bearbetade alla samtyckesposter med omappade eller delvis mappade syften.',
            total_processed: 'Totalt bearbetat',
            newly_mapped: 'Nyligen kartlagt',
            still_unmapped_label: 'Fortfarande omartad',
            still_unmapped_msg: '[[TOK_2]] post(er) har fortfarande omappade syften. [[TOK_3]] klicka sedan på Kartlägga igen.',
            add_more_mappings: 'Lägg till fler mappningar',
            remap_complete: 'Omkartläggning klar: [[TOK_2]] nyligen mappad, [[TOK_3]] fortfarande omappad.',
            add_mapping: 'Lägg till mappning',
            cmp_purpose_id_label: '[[TOK_0]] Syftes-ID *',
            cmp_purpose_id_required: '[[TOK_0]] Syftes-ID krävs',
            cmp_purpose_name_label: '[[TOK_0]] Syftesnamn',
            grc_purpose_label: 'GRC Syfte',
        },
        propagation: {
            title: 'Återkallelsespridning',
            systems: 'Länkade system',
            status: 'Status',
            confirmed: 'Bekräftad',
            pending: 'Väntande',
            failed: 'Misslyckad',
            confirm: 'Bekräfta återkallelse',
            fail: 'Markera som misslyckad',
            failure_reason: 'Felorsak',
            can_close: 'Alla system bekräftade — arbetsflödet kan stängas',
            cannot_close: 'Väntar på systembekräftelser',
            no_tasks: 'Inga spridningsuppgifter.',
            confirm_success: 'Systemåterkallelse bekräftad.',
            fail_success: 'System markerat som misslyckat.',
            propagate_success: 'Återkallelse spridd till länkade system.',
            propagate: 'Spridning till system',
            add_system: 'Lägg till system',
            remove_system: 'Ta bort',
            system_id: 'System-ID',
            system_name: 'Systemnamn',
            owner_id: 'Ägar-ID',
            propagate_error: 'Det gick inte att sprida uttag. Försök igen.',
            no_systems: 'Lägg till minst ett system.',
            page_title: 'Uttagsförökning',
            workflow_id: 'Välj Arbetsflöde för uttag',
            system_id_hint: 't.ex. crm-001, erp-prod',
            owner_id_hint: 'Systemägare',
            elapsed: 'Förfluten',
        },
        sensitive: {
            title: 'Känsliga datapolicyer',
            flag: 'Markera som känslig',
            categories: 'Känsliga kategorier',
            enhanced_review: 'Kräv utökad granskning',
            enhanced_review_success: 'Utökad granskning krävs.',
            flag_success: 'Policy markerad som känslig.',
            no_sensitive: 'Inga känsliga datapolicyer.',
        },
        reconciliation: {
            title: 'Avvikelseavstämning',
            create: 'Ny avstämningsuppgift',
            system: 'System',
            owner: 'Ägare',
            description: 'Beskrivning',
            resolution: 'Lösning',
            resolve: 'Lös',
            update_grc: 'Uppdatera GRC',
            update_cmp: 'Uppdatera CMP',
            accept_difference: 'Acceptera skillnad',
            escalate: 'Eskalera',
            resolution_notes: 'Lösningsanteckningar',
            no_tasks: 'Inga avstämningsuppgifter.',
            resolve_success: 'Avstämningsuppgift löst.',
            create_success: 'Avstämningsuppgift skapad.',
            open: 'Öppen',
            resolved: 'Löst',
            escalated: 'Eskalerad',
            dashboard_open: 'Öppna uppgifter',
            dashboard_resolved: 'Lösta uppgifter',
            dashboard_escalated: 'Eskalerade uppgifter',
            page_title: 'Missmatch avstämning',
            my_tasks: 'Mina uppgifter',
            all_tasks: 'Alla uppgifter',
            severity: 'Allvarlighet',
        },
        sync: {
            title: 'CMP-synkronisering',
            direction: 'Riktning',
            cmp_to_grc: '[[TOK_0]] → GRC',
            grc_to_cmp: 'GRC → [[TOK_0]]',
            conflict: 'Konflikt',
            resolve_conflict: 'Lös konflikt',
            no_events: 'Inga synkroniseringshändelser.',
            resolve_success: 'Synkroniseringskonflikt löst.',
            create_success: 'Synkroniseringshändelse registrerad.',
            page_title: '[[TOK_0]] Synk',
            detect_drift: 'Upptäck konflikter',
            detecting: 'Upptäcker...',
            drift_result: '[[TOK_2]] konflikt(er) upptäckts av [[TOK_3]] syfte(n) jämfört.',
            no_drift: 'Inga nya konflikter upptäcktes.',
            drift_error: 'Det gick inte att köra konfliktdetektering.',
            resolve_modal_title: 'Lös konflikt',
            resolve_field: 'Fält',
            resolve_grc_value: 'GRC-värde',
            resolve_cmp_value: '[[TOK_0]] Värde',
            accept_cmp: 'Acceptera [[TOK_0]] värde',
            accept_cmp_desc: 'Uppdatera GRC för att matcha [[TOK_0]] — värdet [[TOK_1]] blir det nya GRC-värdet.',
            keep_grc: 'Behåll GRC-värdet',
            keep_grc_desc: 'Stäng den här konflikten utan att ändra GRC – meddela [[TOK_0]]-ägaren att anpassa sig.',
            resolve_applied: 'Konflikt löst. GRC-ändamålet har uppdaterats för att matcha [[TOK_0]].',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Den här beredskapsrapporten är rådgivande. Den godkänner, sammanställer, materialiserar, lämnar in eller skickar inte dossiern.',
            run_label: 'Kör före flygning',
            running: 'Kör före flygning...',
            assemble_label: 'Automonteringspaket',
            assembling: 'Montering...',
            verdict_label: 'Domslut före flygningen',
            tokens_label: '≈ [[TOK_1]] tokens',
            remediation_label: 'Sanering',
            no_gaps: 'Inga luckor före flygning upptäcktes. Arkivet är redo att monteras.',
            override_label: 'Åsidosätt blockdom – montering kommer att revisionsstämplas.',
            accept_label: 'Acceptera rapporten',
            reject_label: 'Avvisa rapporten',
            assembled_label: 'Inlämningspaketet monterat',
            package_id_label: 'Paket-id',
            package_filename_label: 'Filnamn',
            package_hash_label: 'Pakethash',
            evidence_count_label: '[[TOK_1]] bevisföremål paketerade',
            error_generic: 'Kunde inte köra pre-flight eller sätta ihop paketet. Försök igen eller kontrollera arkiveringsstatusen.',
        },
        errors: {
            fetch: 'Kunde inte ladda bedömningar.',
            save: 'Kunde inte spara bedömning.',
            fetch_gap_report_failed: 'Kunde inte hämta bristrapport.',
            fetch_transfers_failed: 'Kunde inte hämta överföringar.',
            save_transfer_failed: 'Kunde inte spara överföring.',
            submit_review_failed: 'Kunde inte skicka för granskning.',
            process_decision_failed: 'Kunde inte behandla beslut.',
            deprecate_failed: 'Kunde inte fasa ut.',
            evaluate_risk_failed: 'Kunde inte utvärdera risk.',
            fetch_safeguards_failed: 'Kunde inte hämta skyddsåtgärder.',
            save_safeguard_failed: 'Kunde inte spara skyddsåtgärd.',
            update_safeguard_status_failed: 'Kunde inte uppdatera skyddsåtgärdsstatus.',
        },
        nav: {
            dpias: 'Konsekvensbedömningar',
            transfers: 'Överföringsbedömningar',
            dashboard: 'Översikt',
            gap_report: 'Bristrapport',
        },
        risk_level_critical: 'Kritisk risk',
        risk_level_high: 'Hög risk',
        risk_level_medium: 'Medelhög risk',
        risk_level_low: 'Låg risk',
        severity_critical: 'Kritisk allvarlighet',
        severity_high: 'Hög allvarlighet',
        severity_medium: 'Medelhög allvarlighet',
        severity_low: 'Låg allvarlighet',
        overdue: 'Försenad',
        framework_filter_label: 'Ramverk',
        aria_filter_by_framework: 'Filtrera efter ramverk',
        dashboard: {
            title: 'Bedömningsöversikt',
            page_title: 'Bedömningspanel',
            announce_loaded: 'Bedömningspanel laddad',
            announce_chart_view: 'Visar diagramvy',
            announce_table_view: 'Visar datatabellvy',
            aria_metrics_table: 'Bedömningsmätvärden',
            metric_col: 'Mätvärde',
            value_col: 'Värde',
            dpia_prefix: 'DPIA',
            transfer_prefix: 'Överföring',
            risk_prefix: 'Risk',
            aria_dpias_by_status: 'DPIA efter status',
            aria_transfers_by_status: 'Överföringar efter status',
            aria_top_risks: 'Toprisker',
            aria_top_risks_table: 'Toprisker bland DPIAer',
            overdue_dpias_attention: '{count} försenade DPIA-bedömningar kräver uppmärksamhet',
            no_overdue_dpias: 'Inga försenade DPIA-bedömningar',
            overdue_transfers_attention: '{count} försenade överföringsbedömningar kräver uppmärksamhet',
            no_overdue_transfers: 'Inga försenade överföringsbedömningar',
            dpias_overview: 'Översikt Konsekvensbedömningar',
            transfers_overview: 'Översikt Överföringsbedömningar',
            overdue_items: 'Försenade Poster',
            overdue_dpias: 'Försenade konsekvensbedömningar',
            overdue_transfers: 'Försenade överföringsbedömningar',
            count: 'Antal',
            no_data: 'Ingen data tillgänglig.',
            no_risks: 'Inga risker hittades.',
            no_dashboard_data: 'Ingen översiktsdata tillgänglig.',
            fetch_error: 'Kunde inte hämta översiktsdata. Försök igen.',
        },
        dpias: {
            page_title: 'DPIAer',
            announce_submitted_for_review: 'DPIA inskickad för granskning',
            announce_deprecated: 'DPIA föråldrad',
            announce_risks_loaded: '{count} risk(er) laddade',
            announce_mitigations_loaded: '{count} åtgärd(er) laddade',
            announce_risk_deleted: 'Risk borttagen',
            announce_mitigation_status_updated: 'Åtgärdsstatus uppdaterad',
            aria_filter: 'Filtrera DPIAer',
            aria_filter_by_status: 'Filtrera efter status',
            aria_filter_by_lead: 'Filtrera efter bedömningsledare',
            aria_table: 'Dataskyddskonsekvenbedömningar',
            announce_found: '{count} DPIA(er) hittade',
            announce_decision: '[[TOK_2]] [[TOK_1]]',
            mitigation_start: 'Starta',
            mitigation_mark_implemented: 'Markera implementerad',
            mitigation_verify: 'Verifiera',
            title: 'Konsekvensbedömningar avseende Dataskydd',
            new: 'Ny Konsekvensbedömning',
            edit: 'Redigera Konsekvensbedömning',
            dpia_title: 'Titel',
            activity: 'Behandling',
            risk_score: 'Riskpoäng',
            risks: 'Risker',
            mitigations: 'Åtgärder',
            add_risk: 'Lägg till Risk',
            add_mitigation: 'Lägg till Åtgärd',
            necessity: 'Nödvändighet / Proportionalitet',
            likelihood: 'Sannolikhet',
            impact: 'Konsekvens',
            severity_label: 'Allvarlighetsgrad',
            purpose: 'Syfte',
            consultation_notes: 'Samrådsanteckningar',
            dpo_opinion: 'DPO-yttrande',
            processing_activity_ids: 'Behandlingsaktivitets-ID (kommaseparerade)',
            system_ids: 'System-ID (kommaseparerade)',
            vendor_ids: 'Leverantörs-ID (kommaseparerade)',
            data_types: 'Datatyper (kommaseparerade)',
            data_types_short: 'Datatyper',
            data_subjects: 'Registrerade (kommaseparerade)',
            assessment_lead_id: 'Bedömningsansvarig-ID',
            assessment_lead: 'Bedömningsansvarig',
            dpo_id: 'DPO-ID',
            reviewer_ids: 'Granskare-ID (kommaseparerade)',
            approval_mode: 'Godkännandeläge',
            approval_all: 'Alla',
            approval_any: 'Någon',
            require_dpo_signoff: 'Kräv DPO-godkännande',
            review_date: 'Granskningsdatum',
            submit_for_review: 'Skicka för Granskning',
            approve_reject: 'Godkänn/Avvisa',
            deprecate: 'Fasa ut',
            deprecated: 'Utfasad',
            hide_risks: 'Dölj Risker',
            hide_mitigations: 'Dölj Åtgärder',
            comments: 'Kommentarer',
            submit_decision: 'Skicka Beslut',
            category_label: 'Kategori',
            category_data_breach: 'Dataintrång',
            category_unauthorized_access: 'Obehörig Åtkomst',
            category_function_creep: 'Funktionsglidning',
            category_re_identification: 'Återidentifiering',
            category_discrimination: 'Diskriminering',
            category_surveillance: 'Övervakning',
            category_other: 'Annat',
            affected_rights: 'Berörda Rättigheter (kommaseparerade)',
            no_risks: 'Inga risker hittades.',
            no_mitigations: 'Inga åtgärder hittades.',
            no_dpias: 'Inga DPIA:er hittades.',
            mitigation_type: 'Typ',
            mitigation_technical: 'Teknisk',
            mitigation_organizational: 'Organisatorisk',
            mitigation_contractual: 'Avtalsmässig',
            risk_ids: 'Risk-ID (kommaseparerade)',
            responsible_party: 'Ansvarig Part',
            responsible_party_placeholder: 'Eller ange namn manuellt',
            affected_rights_placeholder: 'Valda rättigheter visas här',
            affected_rights_freetext_placeholder: 'Ange påverkade rättigheter (kommaseparerade)',
            responsible: 'Ansvarig',
            target_date: 'Måldatum',
            created: 'Skapad',
            fetch_error: 'Kunde inte hämta DPIA:er. Försök igen.',
            save_error: 'Kunde inte spara DPIA. Försök igen.',
            submit_review_error: 'Kunde inte skicka DPIA för granskning. Försök igen.',
            decision_error: 'Kunde inte behandla beslut. Försök igen.',
            deprecate_error: 'Kunde inte fasa ut DPIA. Försök igen.',
            fetch_risks_error: 'Kunde inte hämta risker. Försök igen.',
            save_risk_error: 'Kunde inte spara risk. Försök igen.',
            delete_risk_error: 'Kunde inte radera risk. Försök igen.',
            fetch_mitigations_error: 'Kunde inte hämta åtgärder. Försök igen.',
            save_mitigation_error: 'Kunde inte spara åtgärd. Försök igen.',
            update_mitigation_status_error: 'Kunde inte uppdatera åtgärdsstatus. Försök igen.',
            link_form_template: 'Länkföreskriftsformulärmall',
            link_form_template_placeholder: 'Välj en [[TOK_0]] formulärmall (valfritt)',
            link_form_template_none: 'Inga',
            linked_form: 'Länkat formulär',
            linked_form_creating: 'Skapar länkat formulär...',
            linked_form_error: 'Det gick inte att skapa länkad formulärinstans. [[TOK_0]] skapades utan ett länkat formulär.',
            view_linked_form: 'Visa formulär',
            announce_created_with_form: '[[TOK_0]] skapad med länkad formulärinstans',
            creation_mode: '[[TOK_0]] Skapande läge',
            mode_standard: 'Standard [[TOK_0]]',
            mode_template: 'Använd mall för föreskriftsformulär',
            select_form_template: 'Välj Formulärmall',
            create_and_fill_form: 'Skapa och fyll i formulär',
            template_sections_title: 'Mallsektioner',
            field_singular: 'fältet',
            field_plural: 'fält',
            no_sections: 'Inga avsnitt hittades i denna mall.',
            template_mode_hint: 'Efter skapandet kommer du att omdirigeras till att fylla i det fullständiga regleringsformuläret.',
            linked_dossier_filings: 'Länkade dossierarkiveringar',
            no_linked_dossier_filings: 'Inga dossierarkiveringar länkade till denna DPIA.',
            view_dossier_filing: 'Visa arkivering',
            hide_dossier_filings: 'Dölj dossierarkiveringar',
            supporting_evidence: 'Stödjande bevis',
            hide_supporting_evidence: 'Dölj bevis',
            no_supporting_evidence: 'Inga stödjande bevis bifogas.',
            upload_supporting_evidence: 'Ladda upp stödjande bevis',
            view_form_responses: 'Visa formulärsvar',
            regulatory_framework: 'Regelverk',
            all_frameworks: 'Alla regelverk',
            no_templates_for_market: 'Inga mallar tillgängliga för den valda marknaden. Välj en annan marknad eller skapa en mall.',
        },
        transfers: {
            page_title: 'Dataöverföringar',
            announce_found: '{count} överföringsbedömning(ar) hittade',
            announce_submitted_for_review: 'Överföring inskickad för granskning',
            announce_deprecated: 'Överföring föråldrad',
            announce_decision: 'Överföring {decision}',
            announce_risk_eval_completed: 'Riskbedömning slutförd',
            announce_safeguard_status_updated: 'Skyddsstatus uppdaterad',
            announce_safeguards_loaded: '{count} skyddsåtgärd(er) laddade',
            aria_filter: 'Filtrera överföringsbedömningar',
            aria_filter_by_status: 'Filtrera efter status',
            aria_filter_by_mechanism: 'Filtrera efter överföringsmekanism',
            aria_table: 'Dataöverföringsbedömningar',
            title: 'Gränsöverskridande Överföringsbedömningar',
            new: 'Ny Överföring',
            edit: 'Redigera Överföring',
            name: 'Namn',
            from_country: 'Från Land',
            to_country: 'Till Land',
            safeguards: 'Skyddsåtgärder',
            risk_level: 'Risknivå',
            assessment_notes: 'Bedömningsanteckningar',
            mechanism: 'Mekanism',
            transfer_mechanism: 'Överföringsmekanism',
            transfer_mechanism_detail: 'Detalj Överföringsmekanism',
            all_mechanisms: 'Alla Mekanismer',
            mechanism_adequacy_decision: 'Adekvansbeslut',
            mechanism_sccs: 'SCC:er',
            mechanism_bcrs: 'BCR:er',
            mechanism_consent: 'Samtycke',
            mechanism_derogation: 'Undantag',
            mechanism_other: 'Annat',
            data_types: 'Datatyper (kommaseparerade)',
            data_subjects: 'Registrerade (kommaseparerade)',
            purpose: 'Syfte',
            recipient_name: 'Mottagarnamn',
            create_success: 'Överföringsbedömning skapad.',
            update_success: 'Överföringsbedömning uppdaterad.',
            recipient_details: 'Mottagaruppgifter',
            recipient_details_placeholder: 'Mottagarens roll, plats och system samt uppgifter om vidareöverföring',
            vendor_id: 'Leverantörs-ID',
            processing_activity_ids: 'Behandlingsaktivitets-ID (kommaseparerade)',
            reviewer_ids: 'Granskare-ID (kommaseparerade)',
            approval_mode: 'Godkännandeläge',
            approval_all: 'Alla',
            approval_any: 'Någon',
            require_dpo_signoff: 'Kräv DPO-godkännande',
            review_date: 'Granskningsdatum',
            created: 'Skapad',
            deprecated: 'Utfasad',
            submit_for_review: 'Skicka för Granskning',
            approve_reject: 'Godkänn/Avvisa',
            deprecate: 'Fasa ut',
            risk_eval: 'Riskbedömning',
            hide_safeguards: 'Dölj Skyddsåtgärder',
            mechanism_proof: 'Mekanism bevis',
            hide_mechanism_proof: 'Dölj mekanismbevis',
            mechanism_proof_hint: 'Ladda upp den undertecknade överföringsmekanismen (SCC:er, BCR:er, beslut om lämplighet, etc.) som bevisar denna överföringsbedömning.',
            no_mechanism_proof: 'Inget mekanismbevis bifogat.',
            upload_mechanism_proof: 'Ladda upp mekanismbevis',
            comments: 'Kommentarer',
            submit_decision: 'Skicka Beslut',
            data_sensitivity: 'Datakänslighet (1-5)',
            country_risk: 'Landsrisk (1-5)',
            safeguard_adequacy: 'Skyddsåtgärdsadekvans (1-5)',
            volume_factor: 'Volymfaktor (1-5)',
            evaluate: 'Utvärdera',
            add_safeguard: 'Lägg till Skyddsåtgärd',
            responsible_party: 'Ansvarig Part',
            responsible_party_placeholder: 'Eller ange namn manuellt',
            responsible: 'Ansvarig',
            implementation_date: 'Implementeringsdatum',
            implementation: 'Implementering',
            expiry_date: 'Utgångsdatum',
            expiry: 'Utgång',
            expire: 'Löp ut',
            no_safeguards: 'Inga skyddsåtgärder hittades.',
            no_transfers: 'Inga överföringsbedömningar hittades.',
            fetch_error: 'Kunde inte hämta överföringsbedömningar. Försök igen.',
            save_error: 'Kunde inte spara överföringsbedömning. Försök igen.',
            submit_review_error: 'Kunde inte skicka för granskning. Försök igen.',
            decision_error: 'Kunde inte behandla beslut. Försök igen.',
            deprecate_error: 'Kunde inte fasa ut överföring. Försök igen.',
            risk_eval_error: 'Kunde inte utvärdera risk. Försök igen.',
            fetch_safeguards_error: 'Kunde inte hämta skyddsåtgärder. Försök igen.',
            save_safeguard_error: 'Kunde inte spara skyddsåtgärd. Försök igen.',
            update_safeguard_status_error: 'Kunde inte uppdatera skyddsåtgärdsstatus. Försök igen.',
            safeguard_type_encryption_in_transit: 'Kryptering under Överföring',
            safeguard_type_encryption_at_rest: 'Kryptering i Vila',
            safeguard_type_access_controls: 'Åtkomstkontroller',
            safeguard_type_contractual_clauses: 'Avtalsklausuler',
            safeguard_type_data_minimization: 'Dataminimering',
            safeguard_type_pseudonymization: 'Pseudonymisering',
            safeguard_type_audit_rights: 'Revisionsrättigheter',
            safeguard_type_breach_notification: 'Incidentanmälan',
            safeguard_type_data_localization: 'Datalokalisering',
            safeguard_type_other: 'Annat',
            activate: 'Aktivera',
            all_statuses: 'Alla statusar',
            any: 'Någon',
            mechanism_detail: 'Mekanismdetalj',
            mechanisms: {
                adequacy_decision: 'Adekvansbeslut',
                sccs: 'SCC:er',
                bcr: 'BCR',
                bcrs: 'BCR:er',
                derogation: 'Undantag',
                consent: 'Samtycke',
                other: 'Annat',
            },
            safeguard_types: {
                encryption_in_transit: 'Kryptering under överföring',
                encryption_at_rest: 'Kryptering i vila',
                access_controls: 'Åtkomstkontroller',
                contractual_clauses: 'Avtalsklausuler',
                data_minimization: 'Dataminimering',
                pseudonymization: 'Pseudonymisering',
                audit_rights: 'Revisionsrättigheter',
                breach_notification: 'Intrångsavisering',
                data_localization: 'Datalokalisering',
                other: 'Annat',
            },
        },
        gap_report: {
            page_title: 'Gaprapport för bedömningar',
            announce_loaded: 'Gaprapport laddad. {count} gap hittade',
            aria_activities_without_dpia: 'Aktiviteter utan DPIA-bedömning',
            aria_activities_unclassified: 'Aktiviteter med oklassificerat DPIA-krav',
            activities_unclassified_section_title: 'Aktiviteter med oklassificerat DPIA-krav',
            activities_unclassified_description: 'Dessa aktiviteter har inte granskats för att avgöra om en DPIA är lagstadgad. Klassificera var och en för att ta bort signalen.',
            activities_unclassified_empty: 'Alla aktiva aktiviteter har klassificerats.',
            aria_unmitigated_risks: 'Ej åtgärdade höga och kritiska risker',
            aria_transfers_without_safeguards: 'Överföringar utan tillräckliga skyddsåtgärder',
            aria_expired_assessments: 'Utgångna bedömningar som kräver förnyelse',
            title: 'Bristrapport för Bedömningar',
            no_dpia: 'Behandlingar utan Konsekvensbedömning',
            no_assessment: 'Överföringar utan Bedömning',
            unmitigated: 'Konsekvensbedömningar med Oåtgärdade Risker',
            activity_id: 'Aktivitets-ID',
            dpia_id: 'DPIA-ID',
            assessment_id: 'Bedömnings-ID',
            expired_assessments: 'Utgångna Bedömningar',
            no_gaps_activities: 'Inga brister hittades. Alla aktiviteter har DPIA:er.',
            no_unmitigated_risks: 'Inga oåtgärdade höga/kritiska risker hittades.',
            no_gaps_safeguards: 'Inga brister hittades. Alla överföringar har adekvata skyddsåtgärder.',
            no_expired: 'Inga utgångna bedömningar hittades.',
            no_report_data: 'Ingen bristrapportsdata tillgänglig.',
            fetch_error: 'Kunde inte hämta bristrapport. Försök igen.',
            no_expired_assessments: 'Inga utgångna bedömningar.',
            no_gaps_dpia: 'Inga DPIA-brister hittades.',
            no_data: 'Ingen data tillgänglig.',
        },
        dossier_filings: {
            page_title_detail: 'Dossieranmälningsdetalj',
            page_title_list: 'Dossieranmälningsärenden',
            announce_filings_found: '{count} anmälning(ar) hittade',
            announce_results: '{count} resultat',
            aria_filter_by_status: 'Filtrera efter status',
            title: 'Dokumentärende',
            nav_label: 'Dokumentationshandlingar',
            create: 'Skapa dossierarkivering',
            form_type: 'Formtyp',
            phu_luc_i_label: 'Mẫu số 02a (Standard [[TOK_0]], dekret 356)',
            phu_luc_ii_label: 'Mẫu số 02b (gränsöverskridande / högrisk [[TOK_0]], dekret 356)',
            dpia_reference: '[[TOK_0]] Referens',
            submitted_date: 'Inlämningsdatum',
            outcome: 'Resultat',
            parent_filing: 'Förälder',
            no_filings: 'Inga handlingar hittades.',
            fetch_error: 'Det gick inte att hämta underlag. Försök igen.',
            save_error: 'Det gick inte att skapa underlagsarkivering. Försök igen.',
            created: 'Dossierarkivering skapat.',
            loaded: 'Dokumentationsarkivet laddat.',
            not_found: 'Dossierarkivering hittades inte.',
            back_to_list: 'Tillbaka till listan',
            section_assignments: 'Avsnittsuppgifter',
            assign_sections: 'Tilldela sektioner',
            section_id: 'avsnitt',
            department: 'Avdelning',
            assignee: 'Uppdragstagare',
            deadline: 'Deadline',
            no_assignments: 'Inga avsnittsuppgifter ännu.',
            sections_assigned_msg: 'Avsnitt tilldelade.',
            assign_error: 'Det gick inte att tilldela avsnitt. Försök igen.',
            lifecycle: 'Arkiveringslivscykel',
            submission: 'Inlämningsdetaljer',
            submission_channel: 'Inlämningskanal',
            mps_portal: '[[TOK_0]] Portal',
            in_person: 'Personligen',
            postal: 'Post',
            confirmation_number: 'Bekräftelsenummer',
            submit_for_review: 'Skicka för granskning',
            submitted_for_review: 'Inlämnad för intern granskning.',
            submit_review_error: 'Det gick inte att skicka in för granskning. Försök igen.',
            legal_signoff: 'Juridisk signoff',
            legal_signoff_done: 'Juridisk signering slutförd.',
            legal_signoff_error: 'Det gick inte att slutföra juridisk signering. Försök igen.',
            approve: 'Godkänn',
            approved_msg: 'Anmälan godkänd.',
            approve_error: 'Det gick inte att godkänna arkiveringen. Försök igen.',
            materialisation_status_column: 'Inlämningsartefakt',
            materialisation_na: 'Ej tillämpligt',
            materialisation_pending: 'Väntar',
            materialisation_success: 'Materialiserad',
            materialisation_failed: 'Misslyckades',
            materialisation_banner_title: 'Inlämningsartefakten kunde inte skapas',
            materialisation_banner_body: 'Ansökningen godkändes, men den underliggande dossierposten kunde inte skapas. Export av följebrev och inlämning är inte tillgängliga förrän du försöker igen.',
            materialisation_retry_button: 'Försök igen',
            materialisation_retry_count: 'Tidigare försök igen:',
            materialisation_retry_success: 'Inlämningsartefakt materialiserades framgångsrikt.',
            materialisation_retry_announce: 'Försök igen lyckades',
            filter_materialisation_failed: 'Visa endast materialiseringsfel',
            column_title: 'Titel',
            column_form_type: 'Form',
            submit_to_mps: 'Skicka till [[TOK_0]]',
            submitted_to_mps_msg: 'Skickat till [[TOK_0]].',
            submit_mps_error: 'Det gick inte att skicka till [[TOK_0]]. Försök igen.',
            supplement_request: 'Tilläggsbegäran',
            supplement_requests: 'Tilläggsförfrågningar',
            supplement_response: 'Kompletteringssvar',
            record_supplement: 'Registrera tilläggsbegäran',
            supplement_recorded: 'Tilläggsbegäran registrerad.',
            supplement_error: 'Det gick inte att registrera tilläggsbegäran. Försök igen.',
            submit_supplement: 'Skicka tilläggssvar',
            supplement_submitted_msg: 'Kompletterande svar inlämnat.',
            supplement_submit_error: 'Det gick inte att skicka tilläggssvar. Försök igen.',
            response_status: 'Svarsstatus',
            response_notes: 'Svarsanteckningar',
            resubmit: 'Skicka in igen',
            resubmitted_msg: 'Dokumentationen har skickats in på nytt.',
            resubmit_error: 'Det gick inte att skicka in underlaget igen. Försök igen.',
            record_outcome: 'Spela in resultat',
            outcome_recorded: 'Resultatet registrerats.',
            outcome_error: 'Det gick inte att registrera resultatet. Försök igen.',
            accepted: 'Accepterad',
            rejected: 'Avvisad',
            close: 'Stäng',
            closed_msg: 'Arkivet stängt.',
            close_error: 'Det gick inte att stänga arkivet. Försök igen.',
            change_filing: 'Skapa ändringsarkivering',
            change_filing_created: 'Ändra arkivering skapad.',
            change_filing_error: 'Det gick inte att skapa ändringsarkivering. Försök igen.',
            change_reason: 'Anledning till förändring',
            filing_lineage: 'Arkivering härstamning',
            timers: 'Aktiva timers',
            timer_mps_review: '[[TOK_0]] Recension',
            timer_supplement: 'Deadline för tillägg',
            timer_resubmission: 'Deadline för återinlämning',
            timer_department: 'Avdelningens deadline',
            days_remaining: 'dagar kvar',
            days_overdue: 'dagar försenad',
            cover_letter: 'Följebrev',
            checklist: 'Checklista',
            evidence_index: 'Evidensindex',
            status_draft: 'Utkast',
            status_sections_assigned: 'Avsnitt tilldelade',
            status_internal_review: 'Intern granskning',
            status_legal_signoff: 'Juridisk signoff',
            status_approved: 'Godkänd',
            status_submitted_to_mps: 'Skickat till [[TOK_0]]',
            status_supplement_requested: 'Komplettering begärd',
            status_supplement_submitted: 'Tillägg inlämnat',
            status_resubmitted: 'Återinskickad',
            status_accepted: 'Godkänd',
            status_rejected: 'Avvisad',
            status_closed: 'Stängd',
            linked_dpia: 'Länkad DPIA',
            linked_dpia_none: 'Ingen DPIA länkad till denna arkivering.',
            view_linked_dpia: 'Visa DPIA',
            linked_dpia_label: 'Denna dossierarkivering är länkad till följande DPIA:',
        },
        materialisation_health: {
            nav_label: 'Inlämning artefakt hälsa',
            page_title: 'Inlämning Artefakt hälsa',
            page_description: 'Upptäck och åtgärda problem med materialisering av underlag. Listor är anpassade till din organisation.',
            failed_title: 'Misslyckade materialiseringar',
            failed_empty: 'Inga misslyckade materialiseringar - bra.',
            pending_title: 'Godkänd men inte genomförd',
            pending_empty: 'Alla godkända ansökningar har ett underlag.',
            orphan_title: 'Föräldralösa ärenden',
            orphan_description: 'Dossier skapade av materialisering som inte längre refereras av någon arkivering - vanligtvis förloraren av en samtidig ras. Listad för utredning; rengöring är manuell.',
            orphan_empty: 'Inga föräldralösa dossierer upptäcktes.',
            materialise_button: 'Materialisera nu',
            column_failure_reason: 'Orsak till misslyckande',
            column_failed_at: 'Misslyckades kl',
            column_retries: 'Försöker igen',
            column_approved_at: 'Godkänd kl',
            column_dossier_id: 'Dokumentations-ID',
            column_source_filing_id: 'Källarkivering',
            column_dossier_type: 'Typ',
            column_created_at: 'Skapad på',
        },
    },
    classification: {
        access_denied_title: 'Åtkomst nekad',
        access_denied: 'Du har inte de nödvändiga behörigheterna för att komma åt klassificeringsmodulen. Kontakta din administratör.',
        nav: {
            taxonomies: 'Taxonomier',
            labeling: 'Märkning',
            lifecycle: 'Livscykel',
            gaps: 'Bristrapport',
            exports: 'Exporter',
        },
        exports: {
            title: 'Klassificeringsexporter',
            csv_section: 'CSV-exporter',
            pdf_section: 'PDF-rapporter',
            inventory: 'Inventering',
            classification_register: 'Klassificeringsregister',
            raci: 'RACI-matris',
            exceptions: 'Undantag',
            evidence_pack: 'Bevispaket',
            delta_report: 'Deltarapport',
            executive_summary: 'Sammanfattning',
            exporting: 'Exporterar…',
            export_success: 'Export genomförd.',
            export_error: 'Exporten misslyckades. Försök igen.',
            csv_download: 'CSV-nedladdning klar.',
            pdf_download: 'PDF-generering startad.',
            no_data: 'Inga data tillgängliga för export.',
        },
        delta: {
            title: 'Ändringsdetaljer',
            added: 'Tillagda',
            removed: 'Borttagna',
            changed: 'Ändrade',
            added_count: 'Tillagda ({count})',
            removed_count: 'Borttagna ({count})',
            changed_count: 'Ändrade ({count})',
            object_id: 'Objekt-ID',
            object_type: 'Objekttyp',
            taxonomy: 'Taxonomi',
            level: 'Nivå',
            previous: 'Föregående',
            current: 'Nuvarande',
            no_records: 'Inga poster i detta avsnitt.',
            empty_section: 'Detta avsnitt är tomt.',
        },
        schedule: {
            title: 'Schemalägg upptäcktscykel',
            enabled: 'Aktiverad',
            interval_days: 'Intervall (dagar)',
            interval_label: 'Kör var N:e dag',
            manual_only: 'Endast manuell',
            every_n_days: 'Var {n}:e dag',
            save: 'Spara schema',
            cancel: 'Avbryt',
            schedule_updated: 'Schema uppdaterat.',
        },
        taxonomies: {
            title: 'Klassificeringstaxonomier',
            new: 'Ny Taxonomi',
            edit: 'Redigera Taxonomi',
            name: 'Namn',
            levels: 'Klassificeringsnivåer',
            seed_defaults: 'Initiera standardvärden',
            scope: 'Omfattning',
            scope_organization: 'Organisation',
            scope_module_specific: 'Modul Specifik',
            deprecate: 'Fasa ut',
            hide_levels: 'Dölj Nivåer',
            versions: 'Versioner',
            hide_versions: 'Dölj Versioner',
            add_level: 'Add Nivå',
            new_level: 'Ny Nivå',
            edit_level: 'Redigera Nivå',
            code: 'Kod',
            label: 'Etikett',
            color: 'Färg',
            ordinal: 'Ordningstal',
            handling_requirements: 'Hantering Krav',
            version_history: 'Version Historik',
            changes: 'Ändringar',
            failed_fetch: 'Kunde inte hämta taxonomier. Försök igen.',
            failed_save: 'Kunde inte spara taxonomi. Försök igen.',
            failed_activate: 'Kunde inte aktivera taxonomi. Försök igen.',
            failed_deprecate: 'Kunde inte fasa ut taxonomi. Försök igen.',
            failed_seed: 'Kunde inte initiera standardtaxonomier. Försök igen.',
            failed_fetch_levels: 'Kunde inte hämta taxonominivåer. Försök igen.',
            failed_save_level: 'Kunde inte spara taxonominivå. Försök igen.',
            failed_delete_level: 'Kunde inte radera taxonominivå. Försök igen.',
            failed_fetch_versions: 'Kunde inte hämta taxonomiversioner. Försök igen.',
            loaded_count: 'Laddade {count} taxonomier',
            defaults_seeded: 'Standardtaxonomier initialiserade.',
            no_levels: 'Inga klassificeringsnivåer definierade — lägg till nivåer för att bygga din klassificeringshierarki.',
            no_versions: 'Ingen versionshistorik ännu — versioner skapas när en aktiv taxonomi uppdateras.',
        },
        labeling: {
            title: 'Datamärkning',
            new: 'Ny Etikett',
            edit: 'Redigera Etikett',
            entity_type: 'Entitetstyp',
            entity_id: 'Entitets-ID',
            taxonomy: 'Taxonomi',
            classification_level: 'Klassificeringsnivå',
            applied_by: 'Tillämpad Av',
            applied_at: 'Tillämpad Vid',
            bulk_apply: 'Massapplicera',
            bulk_remove: 'Massta bort',
            all_taxonomies: 'Alla Taxonomier',
            system: 'Systemet',
            dataset: 'Datamängd',
            level_code_placeholder: 'Nivå kod...',
            select_taxonomy: 'Välj taxonomi...',
            select_level: 'Välj nivå...',
            rationale: 'Motivering',
            review_date: 'Granskning Datum',
            review: 'Granskning',
            selected: 'vald',
            select_all_labels: 'Välj alla etiketter',
            loaded_count: 'Laddade {count} etiketter',
            hide_stale_labels: 'Dölj inaktuella etiketter',
            show_conflicts: 'Visa Konflikter',
            hide_conflicts: 'Dölj Konflikter',
            label_conflicts: 'Etikett Konflikter',
            conflict_reason: 'Konflikt Anledning',
            labels: 'Etiketter',
            failed_fetch: 'Kunde inte hämta etiketter. Försök igen.',
            failed_fetch_taxonomies: 'Kunde inte hämta taxonomier. Försök igen.',
            failed_fetch_levels: 'Kunde inte hämta taxonominivåer. Försök igen.',
            failed_save: 'Kunde inte spara etikett. Försök igen.',
            failed_review: 'Kunde inte granska etikett. Försök igen.',
            failed_bulk: 'Kunde inte massetikkettera. Försök igen.',
            failed_stale: 'Kunde inte hämta inaktuella etiketter. Försök igen.',
            failed_conflicts: 'Kunde inte hämta etikettkonflikter. Försök igen.',
            review_permission_denied: 'Du har inte behörighet att granska denna etikett.',
            review_not_found: 'Etikett hittades inte — den kan ha raderats.',
            approve_selected: 'Godkänn valda',
            reject_selected: 'Avvisa valda',
            approved: 'Godkänd',
            rejected: 'Avvisad',
            labels_count: 'etiketter',
            failed_count: 'misslyckades',
            confirm_approve: 'Bekräfta godkännande',
            confirm_reject: 'Bekräfta avvisande',
            approve_n_labels: 'Godkänn {count} etiketter?',
            reject_n_labels: 'Avvisa {count} etiketter?',
            submit_for_review: 'Skicka för granskning',
            approve: 'Godkänn',
            reject: 'Avvisa',
            parent_system: 'Overordnat system',
            parent_system_placeholder: 'Valj overordnat system...',
            parent_system_help: 'Anvands for konfliktdetektering.',
            dataset_level: 'Datamangdsniva',
            parent_level: 'Overordnad niva',
            bulk_created: '{created} etikett(er) skapad(e)',
            bulk_skipped: '{skipped} hoppade over',
            bulk_all_skipped: 'Alla {skipped} hoppades over',
            ids_hint: 'Ange IDn separerade med kommatecken',
            delete_confirm: 'Ta bort etikett for "{id}"?',
        },
        lifecycle: {
            title: 'Övervakning av Datalivscykel',
            new: 'Ny Post',
            current_stage: 'Nuvarande Fas',
            last_transition: 'Senaste Övergång',
            transition: 'Övergång',
            view_history: 'Visa Historik',
            stages: {
                creation: 'Skapande',
                collection: 'Insamling',
                processing: 'Behandling',
                storage: 'Lagring',
                retention: 'Bevarande',
                disposal: 'Gallring',
                archived: 'Arkiverad',
                active: 'Aktiv',
                pending_deletion: 'Väntande Radering',
                deleted: 'Borttagen',
                on_hold: 'På Spärr',
            },
            all_stages: 'Alla Faser',
            object_id: 'Objekt ID',
            object_type: 'Objekt Typ',
            policy_reference: 'Policy Referens',
            retention_period_days: 'Lagringsperiod (dagar)',
            retention_basis: 'Lagring Grund',
            deletion_method: 'Radering Metod',
            deletion_secure_erase: 'Säker Radering',
            deletion_anonymization: 'Anonymisering',
            deletion_physical_destruction: 'Fysisk Destruktion',
            deletion_other: 'Övrigt',
            responsible_party: 'Ansvarig Part',
            responsible_user_id: 'Ansvarig Användare ID',
            retention_expiry: 'Lagring Förfallodatum',
            hold_reason: 'Spärr Anledning',
            hold: 'Håll kvar',
            release: 'Släpp',
            hide_events: 'Dölj Händelser',
            events_timeline: 'Händelser Tidslinje',
            add_event: 'Add Händelse',
            event_type: 'Händelse Typ',
            create_event: 'Skapa Händelse',
            from_stage: 'Från Fas',
            to_stage: 'Till Fas',
            actor: 'Aktör',
            reason_placeholder: 'Anledning...',
            go: 'Go',
            show_expired_retentions: 'Visa utgångna lagringsperioder',
            hide_expired_retentions: 'Dölj utgångna lagringsperioder',
            expired_retentions_alert: 'Larm för utgångna lagringsperioder',
            failed_fetch: 'Kunde inte hämta livscykelposter. Försök igen.',
            failed_save: 'Kunde inte spara livscykelpost. Försök igen.',
            failed_transition: 'Kunde inte övergå livscykelfas. Försök igen.',
            failed_hold: 'Kunde inte placera spärr. Försök igen.',
            failed_release: 'Kunde inte frigöra spärr. Försök igen.',
            failed_fetch_events: 'Kunde inte hämta livscykelhändelser. Försök igen.',
            failed_create_event: 'Kunde inte skapa livscykelhändelse. Försök igen.',
            failed_expired: 'Kunde inte hämta utgångna lagringsperioder. Försök igen.',
            hold_reason_prompt: 'Ange anledning till spärr:',
            loaded_count: 'Laddade {count} livscykelposter',
            stage_transition_for: 'Fasövergång för {id}',
            event_created: 'Skapad',
            event_updated: 'Uppdaterad',
            event_approved: 'Godkänd',
            event_deprecated: 'Föråldrad',
            event_proposed: 'Föreslagen',
            event_reviewed: 'Granskad',
            event_archived: 'Arkiverad',
            event_restored: 'Återställd',
        },
        gap_report: {
            title: 'Bristrapport för Klassificering',
            unlabeled: 'Omärkt Data',
            missing_lifecycle: 'Saknad Livscykel',
            stale_labels: 'Inaktuella Etiketter',
            run_detection: 'Körning Brist Detektering',
            detecting: 'Detekterar...',
            detection_complete: 'Bristdetektering slutförd. {count} brist(er) upptäckt(a).',
            detection_failed: 'Brist detektering misslyckade.',
            by_severity: 'Per Allvarlighetsgrad',
            by_gap_type: 'Per Brist Typ',
            all_gap_types: 'Alla Brist Typer',
            conflicting_labels: 'Motstridiga Etiketter',
            expired_retention: 'Utgångna Lagring',
            missing_handling: 'Saknade Hantering',
            info: 'Info',
            gap_type: 'Brist Typ',
            object_id: 'Objekt ID',
            object_type: 'Objekt Typ',
            detected_at: 'Upptäckt Vid',
            open: 'Öppen',
            acknowledged: 'Bekräftad',
            remediated: 'Åtgärdad',
            accepted: 'Accepterad',
            acknowledge: 'Bekräfta',
            remediate: 'Åtgärda',
            accept_risk: 'Acceptera Risk',
            accept_risk_prompt: 'Ange risk acceptans motivering:',
            failed_fetch: 'Kunde inte hämta brister. Försök igen.',
            failed_acknowledge: 'Kunde inte bekräfta brist. Försök igen.',
            failed_remediate: 'Kunde inte åtgärda brist. Försök igen.',
            failed_accept_risk: 'Kunde inte acceptera bristrisk. Försök igen.',
            failed_detect: 'Kunde inte köra bristdetektering. Försök igen.',
            loaded_count: 'Laddade {count} klassificeringsbrister',
            related_object_id: 'Relaterat objekt-ID',
            related_object_type: 'Relaterad objekttyp',
            gap_types: {
                unlabeled_asset: 'Omarkt tillgang',
                missing_lifecycle: 'Saknad livscykel',
                expired_retention: 'Utgangen lagring',
                extended_pending_deletion: 'Forlangd vantande radering',
            },
        },
        label_workflow: {
            title: 'Etikettarbetsflöde',
            proposed: 'Föreslagen',
            under_review: 'Under granskning',
            approved: 'Godkänd',
            deprecated: 'Utfasad',
            submit_review: 'Skicka för granskning',
            approve: 'Godkänn etikett',
            deprecate: 'Fasa ut',
            bulk_approve: 'Massgodkänn',
            bulk_approve_success: 'Etiketter godkända.',
            submit_success: 'Etikett skickad för granskning.',
            approve_success: 'Etikett godkänd.',
            deprecate_success: 'Etikett utfasad.',
        },
        review_tasks: {
            title: 'Granskningsuppgifter',
            create: 'Ny granskningsuppgift',
            system: 'System',
            owner: 'Ägare',
            description: 'Beskrivning',
            resolution: 'Lösning',
            resolve: 'Lös',
            approve: 'Godkänn',
            modify: 'Ändra',
            reject: 'Avvisa',
            escalate: 'Eskalera',
            escalated: 'Eskalerade uppgifter',
            no_tasks: 'Inga granskningsuppgifter.',
            resolve_success: 'Granskningsuppgift löst.',
            status_pending: 'Väntande',
            status_resolved: 'Löst',
            status_escalated: 'Eskalerad',
            notes: 'Anteckningar',
            create_success: 'Granskningsuppgift skapad.',
            no_tasks_detail: 'Inga granskningsuppgifter ännu — skapa en uppgift för att tilldela etikettgranskningar till systemägare.',
            label_id: 'Etikett-ID',
            system_id: 'System-ID',
            system_name: 'Systemnamn',
            owner_id: 'Ägare-ID',
            resolution_col: 'Losning',
            notes_col: 'Anteckningar',
        },
        exceptions: {
            title: 'Undantagskö',
            create: 'Nytt undantag',
            severity: 'Allvarlighet',
            system: 'System',
            owner: 'Ägare',
            resolve: 'Lös',
            no_exceptions: 'Inga undantag hittades.',
            resolve_success: 'Undantag löst.',
            dashboard_open: 'Öppna undantag',
            dashboard_resolved: 'Lösta undantag',
            dashboard_total: 'Totalt',
            dashboard_by_severity: 'Efter allvarlighet',
            status_open: 'Öppen',
            status_resolved: 'Löst',
            status_accepted_risk: 'Accepterad risk',
            create_success: 'Undantag skapat.',
            no_exceptions_detail: 'Inga undantag ännu — undantag skapas från allvarliga brister som kräver särskild hantering.',
            gap_id: 'Brist-ID',
            system_id: 'System-ID',
            system_name: 'Systemnamn',
            owner_id: 'Ägare-ID',
            resolution_notes: 'Lösningsanteckningar',
            resolution_notes_placeholder: 'Beskriv hur detta undantag löstes...',
        },
        enterprise_map: {
            title: 'Företagsdatakarta',
            inventory: 'Datainventering',
            total_systems: 'Totalt antal system',
            total_labels: 'Totalt antal etiketter',
            approved_count: 'Godkända etiketter',
            proposed_count: 'Föreslagna etiketter',
            no_data: 'Ingen klassificeringsdata tillgänglig.',
            no_approved_labels: 'Inga godkända etiketter ännu — etiketter måste granskas och godkännas innan de visas på datakartan.',
            loaded_count: 'Laddad företagsdatakarta',
        },
        discovery: {
            title: 'Upptäcktscykler',
            create: 'Ny cykel',
            cycle_name: 'Cykelnamn',
            run_delta: 'Kör deltadetektering',
            delta_success: 'Deltadetektering slutförd.',
            create_success: 'Upptäcktscykel skapad.',
            no_cycles: 'Inga upptäcktscykler.',
            status_created: 'Skapad',
            status_scanning: 'Skanning',
            status_review: 'Granska',
            status_approved: 'Godkänd',
            status_published: 'Publicerad',
            status_draft: 'Utkast',
            running: 'Körs',
            completed: 'Slutförd',
            cancelled: 'Avbruten',
            delta_result_summary: 'Hittade {added} tillagda, {removed} borttagna, {changed} ändrade etiketter.',
            delta_results: 'Deltaresultat',
            view_results: 'Visa resultat',
            scope_type: 'Omfattning Typ',
            scope_type_all: 'Alla',
            scope_type_systems: 'System',
            scope_type_datasets: 'Datauppsättningar',
            scope_ids: 'Omfattnings-ID',
            scope_ids_placeholder: 'Ange ID:n separerade med kommatecken',
            cycle_explanation: 'En upptäcktscykel skannar din datainfrastruktur för att identifiera, klassificera och spåra datatillgångar. Konfigurera omfattningen för att rikta in sig på specifika system eller datauppsättningar.',
            empty_state_title: 'Inga upptäcktscykler än',
            empty_state_description: 'Skapa din första upptäcktscykel för att börja skanna och klassificera dina datatillgångar.',
            empty_state_cta: 'Skapa första cykeln',
            validation_name_required: 'Cykelnamn krävs',
            validation_scope_type_required: 'Omfattningstyp krävs',
            validation_scope_ids_required: 'Minst ett scope-ID krävs',
        },
        regulatory: {
            sensitivity_importance_info: 'Datalagen (lag [[TOK_0]], krav 18e4bfd1) kräver klassificering efter både känslighet och betydelse som separata dimensioner. Skapa en taxonomi för varje dimension för att uppfylla detta krav.',
            handling_rules_info: 'Varje klassificeringsnivå bör definiera hanteringsregler per begäran. b89981ac ("Definiera hanteringsregler efter klassificeringsnivå").',
            template_internal_ids_info: 'Alla klassificeringsmallar använder interna ID:n (t.ex. vn_data_law_data_classification_record). Ingen mall presenteras som en officiell departementsblankett.',
            ai_risk_tiers_info: '[[TOK_0]] Lag (lag [[TOK_3]], krav 3a87ad63) definierar fyra [[TOK_1]] systemrisknivåer: minimal, begränsad, hög och oacceptabel. Skapa en [[TOK_2]] risktaxonomi med dessa nivåer.',
            ai_risk_tier_minimal: 'Minimal',
            ai_risk_tier_limited: 'Begransad',
            ai_risk_tier_high: 'Hog',
            ai_risk_tier_unacceptable: 'Oacceptabel',
            ai_register_info: '[[TOK_0]] klassificeringsposter bör länka till en [[TOK_1]] systemregisterpost (req. 0f4475d3) som fångar: systemnamn, ägare, syfte, implementeringskontext, risknivå, leverantörsinblandning.',
            ai_template_internal_info: '[[TOK_0]] klassificeringsmallar använder interna ID:n (t.ex. [[TOK_1]]-RISK-01). Inga officiella [[TOK_2]] platshållar-ID ([[TOK_3]]-HC-01 till [[TOK_4]]-HC-08) används.',
            ai_audit_trail_info: '[[TOK_0]] klassificeringsändringar ger ett versionsförsök per UC-VN-06: aktör, tidsstämpel, tidigare värde, nytt värde och motivering.',
            lifecycle_data_d1_info: 'Livscykelövergångar mappar till datalagsprocedur DATA-D1 steg: katalogisera, klassificera, definiera hanteringsregler, fånga bevis, schemagranskning.',
            lifecycle_deletion_link_info: 'En klassificerad datatillgång som når slutet av sin livslängd bör utlösa en raderingsschemapost via modulen Deletion Orchestration.',
            lifecycle_evidence_info: 'Varje livscykeltillståndsändring (utkast, aktiv, undergranskning, arkiverad, raderad) fångar aktör, tidsstämpel och motivering som en revisionsspårpost.',
            escalation_timers_info: 'UC-VN-10 deadlines för eskalering: 5 arbetsdagar för ägargranskning, 48 timmar för eskalering av undantag, 72 timmar för högrisk/känsliga föremål.',
            escalation_owner_review: '5 arbetsdagar',
            escalation_exception: '48 timmar',
            escalation_high_risk: '72 timmar',
            gap_risk_areas_info: 'Datalagskrav. f6c3060a ("Datariskbedömning") kräver gapanalys över fyra riskområden: integritet, cybersäkerhet, åtkomstkontroll och operativ risk.',
            gap_risk_area_privacy: 'Integritet',
            gap_risk_area_cybersecurity: 'Cybersakerhet',
            gap_risk_area_access: 'Atkomstkontroll',
            gap_risk_area_operational: 'Operativ',
            gap_framework_filter_info: 'Filtrera luckor efter regelverk (VN_DATA_LAW eller VN_AI_LAW_2026) för att se relevanta luckor för varje regelverk.',
            framework_vn_data_law: 'VN Datalag',
            framework_vn_ai_law: 'VN AI-lag 2026',
            enterprise_map_approved_info: 'Denna datakarta visar endast godkända klassificeringsposter per UC-VN-10 arbetsflödessteg 10 ("Godkända etiketter blir den aktuella företagets sanning"). Utkast och föreslagna poster är undantagna.',
            exports_bundle_info: 'Exportpaket inkluderar: klassificeringsregister, hanteringsregler, ägande/RACI och bevispaket – matchande UC-VN-10 exportkrav och DATA-EVD-01 bevisbladsformat.',
        },
    },
    monitoring: {
        no_permission_title: 'Otillrackliga behorigheter',
        no_permission_message: 'Du har inte behorighet att komma at denna overvakningsmodul.',
        errors: {
            fetch: 'Kunde inte ladda.',
            save: 'Kunde inte spara.',
            fetch_programs_failed: 'Kunde inte hämta program.',
            fetch_kpi_failed: 'Kunde inte hämta KPI-data.',
            create_snapshot_failed: 'Kunde inte skapa ögonblicksbild.',
            fetch_periods_failed: 'Kunde inte hämta perioder.',
            create_period_failed: 'Kunde inte skapa period.',
            auto_generate_failed: 'Kunde inte autogenerera perioder.',
            start_period_failed: 'Kunde inte starta period.',
            close_period_failed: 'Kunde inte stänga period.',
            save_program_failed: 'Kunde inte spara program.',
            activate_program_failed: 'Kunde inte aktivera program.',
            pause_program_failed: 'Kunde inte pausa program.',
            complete_program_failed: 'Kunde inte slutföra program.',
            archive_program_failed: 'Kunde inte arkivera program.',
            fetch_ric_templates_failed: 'Kunde inte hämta RIC-mallar.',
            fetch_ric_cases_failed: 'Kunde inte hämta RIC-ärenden.',
            create_ric_case_failed: 'Kunde inte skapa RIC-ärende.',
            transition_ric_failed: 'Kunde inte övergå RIC-ärende.',
            add_follow_up_failed: 'Kunde inte lägga till uppföljning.',
            respond_follow_up_failed: 'Kunde inte svara på uppföljning.',
            link_evidence_failed: 'Kunde inte länka bevis.',
            fetch_task_templates_failed: 'Kunde inte hämta uppgiftsmallar.',
            save_task_template_failed: 'Kunde inte spara uppgiftsmall.',
            delete_task_template_failed: 'Kunde inte radera uppgiftsmall.',
            delete_framework_link_failed: 'Kunde inte radera ramverkslänk.',
            seed_defaults_failed: 'Kunde inte initiera standardvärden.',
            fetch_tasks_failed: 'Kunde inte hämta uppgifter.',
            create_task_failed: 'Kunde inte skapa uppgift.',
            instantiate_tasks_failed: 'Kunde inte instansiera uppgifter.',
            start_task_failed: 'Kunde inte starta uppgift.',
            complete_task_failed: 'Kunde inte slutföra uppgift.',
            defer_task_failed: 'Kunde inte skjuta upp uppgift.',
            block_task_failed: 'Kunde inte blockera uppgift.',
            override_complete_failed: 'Kunde inte åsidosätta slutförande.',
            assign_task_failed: 'Kunde inte tilldela uppgift.',
            update_checklist_failed: 'Kunde inte uppdatera checklista.',
        },
        nav: {
            programs: 'Program',
            periods: 'Perioder',
            task_templates: 'Uppgiftsmallar',
            tasks: 'Uppgifter',
            kpi: 'KPI-översikt',
            ric: 'Tillsynsärenden',
            framework_link: 'Ramövervakning',
            authority_readiness: 'Myndighetsberedskap',
            change_review: 'Ändringsgranskning',
            raci: 'RACI-matris',
        },
        programs: {
            page_title: 'Övervakningsprogram',
            title: 'Övervakningsprogram',
            new: 'Nytt Program',
            edit: 'Redigera Program',
            name: 'Namn',
            scope: 'Omfattning',
            frequency: 'Frekvens',
            owner: 'Ägare',
            activate: 'Aktivera',
            pause: 'Pausa',
            resume: 'Återuppta',
            complete: 'Slutför',
            archive: 'Arkivera',
            custom_frequency_days: 'Anpassad frekvens (dagar)',
            select_user: 'Välj användare…',
            assign_training: 'Tilldela utbildning',
            linked_forms: 'Länkade formulär',
            linked_forms_none: 'Inga länkade formulär ännu',
            loaded_count: 'Laddade {0} program',
            scope_labels: {
                full: 'Fullständig',
                partial: 'Delvis',
                targeted: 'Riktad',
                consent: 'Samtycke',
                dpia: 'DPIA',
                vendors: 'Leverantörer',
                classification: 'Klassificering',
                rights_requests: 'Rättighetsbegäranden',
                data_mapping: 'Datakartläggning',
                transfers: 'Överföringar',
                security_monitoring: 'Säkerhetsövervakning',
                authority_response: 'Myndighetssvar',
                evidence_preservation: 'Bevarande av bevis',
                localization_review: 'Lokaliseringsgranskning',
                ai_system_registration: '[[TOK_0]] Systemregistrering',
                ai_pre_deployment: '[[TOK_0]] Utvärdering före implementering',
                ai_transparency: '[[TOK_0]] Transparenskontroll',
                ai_incident_review: '[[TOK_0]] Incidentgranskning',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Övervakningsperioder',
            title: 'Granskningsperioder',
            new: 'Ny Period',
            label: 'Periodetikett',
            start_date: 'Startdatum',
            end_date: 'Slutdatum',
            reviewers: 'Granskare',
            auto_generate: 'Autogenerera Perioder',
            start: 'Starta',
            close: 'Stäng',
            change_digest: 'Ändringssammanfattning',
            no_digest: 'Inga sammanfattning tillgängliga.',
            reviewers_count: 'Antal granskare',
            select_program: 'Välj Program',
            select_program_prompt: 'Välj ett program för att visa perioder.',
            hide_digest: 'Dölj Sammanfattning',
            loaded_count: 'Laddade {0} perioder',
            periods_auto_generated: 'Perioder autogenererade',
            label_placeholder: 't.ex. 2026-K1',
        },
        task_templates: {
            page_title: 'Uppgiftsmallar',
            title: 'Uppgiftsmallar',
            new: 'Ny Mall',
            edit: 'Redigera Mall',
            category: 'Kategori',
            priority: 'Prioritet',
            checklist_items: 'Checklistepunkter',
            effort: 'Beräknad Insats (timmar)',
            pre_seeded: 'Fördefinierad',
            seed_defaults: 'Skapa Standardvärden',
            add_checklist: 'Lägg till Checklistepunkt',
            guidance: 'Vägledning',
            all_categories: 'Alla Kategorier',
            loaded_count: 'Laddade {0} uppgiftsmallar',
            defaults_seeded: 'Standarduppgiftsmallar skapade',
            checklist_item_label: 'Checklistepunkt {0}',
            remove_checklist_item: 'Ta bort checklistepunkt {0}',
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Granskningsuppgifter',
            title: 'Granskningsuppgifter',
            new: 'Ny Uppgift',
            assigned_to: 'Tilldelad Till',
            due_date: 'Förfallodatum',
            checklist: 'Checklista',
            start: 'Starta',
            complete: 'Slutför',
            defer: 'Skjut upp',
            block: 'Blockera',
            override_complete: 'Tvångsslutför',
            link_evidence: 'Länka Bevisning',
            direct_upload_label: 'Ladda upp bevisfil',
            instantiate: 'Skapa från Mallar',
            defer_reason: 'Anledning till uppskov',
            override_justification: 'Motivering för tvångsslutförande',
            filter_assignee: 'Filtrera per tilldelad',
            select_period: 'Välj Period',
            select_program: 'Välj Program',
            select_program_period_prompt: 'Välj ett program och en period för att visa uppgifter.',
            assign_placeholder: 'Tilldela to...',
            loaded_count: 'Laddade {0} uppgifter',
            tasks_instantiated: 'Uppgifter skapade från mallar',
            overdue: 'Försenad',
            checklist_for: 'checklista för',
            manage_checklist: 'Hantera checklista',
            add_checklist_item: 'Lägg till objekt',
            checklist_item_label: 'Objekt',
            checklist_item_description: 'Beskrivning',
            remove_checklist_item: 'Ta bort objekt',
            save_checklist: 'Spara checklista',
            no_checklist_items: 'Inga checklisteobjekt ännu.',
            confirm_delete_attachment: 'Är du säker på att du vill ta bort den här bevisfilen? Detta kan inte ångras.',
        },
        kpi: {
            page_title: 'KPI-översikt',
            title: 'KPI-översikt',
            kpi_name: 'KPI-namn',
            current_value: 'Aktuellt Värde',
            target: 'Mål',
            trends: 'Trender',
            capture_snapshot: 'Fånga Ögonblicksbild',
            select_program: 'Välj Program',
            select_program_prompt: 'Välj ett program för att visa KPI:er.',
            snapshot: 'Ögonblicksbild',
            kpi_labels: {
                on_track: 'På Spår',
                at_risk: 'Vid Risk',
                behind: 'Bakom',
                rights_request_sla_rate: 'SLA-frekvens för rättighetsbegäranden',
                vendor_review_currency: 'Leverantörsgranskning aktualitet',
                dpia_completion_rate: 'DPIA-slutförandegrad',
                classification_coverage: 'Klassificeringstäckning',
                consent_policy_currency: 'Samtyckespolicy aktualitet',
                security_event_detection_rate: 'Detektionshastighet för säkerhetshändelser',
                evidence_preservation_compliance_rate: 'Överensstämmelsegrad för bevisbevarande',
                authority_response_timeliness: 'Myndighetens svar i aktualitet',
                localization_readiness_score: 'Betyg för lokaliseringsberedskap',
                ai_register_completeness: '[[TOK_0]] Systemregistrets fullständighet',
                pre_deployment_gate_pass_rate: 'Före-distribution Gate Pass Rate',
                transparency_disclosure_coverage: 'Täckning av öppenhet',
                ai_incident_readiness_score: '[[TOK_0]] Incidentberedskapspoäng',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: 'KPI:er för cybersäkerhetslagar: Upptäcktsfrekvens för säkerhetshändelser, efterlevnadsgrad för bevisbevarande, aktualitet för myndighetens svar, poäng för lokaliseringsberedskap.',
            ai_law_kpi_info: '[[TOK_0]] Lag-KPI:er: [[TOK_1]] Systemregistrets fullständighet, gatepassfrekvens före implementering, täckning för öppenhet, [[TOK_2]] Incidentberedskapspoäng.',
            no_data: 'Inga data tillgängliga.',
            snapshot_date: 'Ögonblicksbild Datum',
            loaded_count: 'Laddade {0} KPI-ögonblicksbilder',
            snapshot_captured: 'KPI-ögonblicksbild tagen',
            showing_chart: 'Visar diagramvy',
            showing_table: 'Visar datatabellvy',
            aria_current_values: 'KPI aktuella värden',
            kpi_label: 'KPI',
            actual: 'Faktisk',
            trend: 'Trend',
            notes: 'Anteckningar',
            trend_up: 'Stigande',
            trend_down: 'Fallande',
            trend_stable: 'Stabil',
        },
        ric: {
            page_title: 'RIC-ärenden',
            title: 'Tillsynsmyndighetens Ärenden',
            new: 'Nytt Tillsynsärende',
            reference: 'Referens',
            regulator: 'Tillsynsmyndighet',
            inquiry_type: 'Typ av Förfrågan',
            deadline: 'Svarsfrist',
            lead: 'Ansvarig',
            follow_ups: 'Uppföljningar',
            add_follow_up: 'Lägg till Uppföljning',
            respond: 'Svara',
            question: 'Fråga',
            response: 'Svar',
            asked_at: 'Frågad Vid',
            no_follow_ups: 'Inga follow-ups ännu.',
            received_date: 'Mottagningsdatum',
            responded_at: 'Besvarad den',
            hide_follow_ups: 'Dölj Uppföljningar',
            inquiry_types: {
                general: 'Allmänt',
                investigation: 'Utredning',
                audit: 'Revision',
                complaint: 'Klagomål',
                general_audit: 'Allmän revision',
                rights_requests_review: 'Granskning av rättighetsbegäranden',
                cross_border_transfer_review: 'Granskning av gränsöverskridande överföringar',
                vendor_governance_review: 'Granskning av leverantörsstyrning',
                consent_management_review: 'Granskning av samtyckehantering',
                data_mapping_ropa_review: 'Granskning av datakartläggning / ROPA',
                incident_readiness_review: 'Granskning av incidentberedskap',
                security_access_control_review: 'Granskning av säkerhet och åtkomstkontroll',
                targeted_processing_review: 'Granskning av riktad behandling',
                bank_readiness_pack: 'Bankberedskapspaket',
            },
            link_evidence: 'Länka Bevis',
            loaded_count: 'Laddade {0} RIC-ärenden',
            to_follow_up: 'till uppföljningsfråga',
            overdue: 'Försenad',
            overdue_indicator: 'Svarstiden har överskridits',
            template_info: 'RIC-mallar är interna plattformsmallar. De är inte officiella formulär som krävs av myndigheter.',
            status_labels: {
                received: 'Mottagen',
                in_triage: 'Under triage',
                evidence_gathering: 'Bevisinsamling',
                response_drafting: 'Svarsutkast',
                internal_review: 'Intern granskning',
                submitted: 'Inskickad',
                follow_up: 'Uppföljning',
                closed: 'Stängd',
            },
        },
        framework_link: {
            title: 'Ramlänkad övervakning',
            link_program: 'Länka program till ram',
            framework_code: 'Ramkod',
            select_framework: 'Välj ett ramverk...',
            select_program: 'Välj ett program...',
            readiness_score: 'Beredskapspoäng',
            no_links: 'Inga ramlänkade program hittades',
            seed_defaults: 'Skapa standardmallar',
            program_id: 'Program-ID',
            program: 'Program',
        },
        authority_readiness: {
            title: 'Myndighetsbegäransberedskap',
            create_entry: 'Ny beredskapspost',
            select_framework: 'Välj ett ramverk...',
            framework_code: 'Ramverk',
            readiness_status: 'Beredskapsstatus',
            readiness_package: 'Beredskapspaket',
            run_drill: 'Kör beredskapsövning',
            drill_success: 'Beredskapsövning registrerad',
            last_drill: 'Senaste övning',
            never_drilled: 'Aldrig',
            no_readiness: 'Ingen myndighetsberedskapsdata hittades',
            entry_created: 'Beredskapspost skapad',
            ready: 'Redo',
            partial: 'Delvis',
            not_ready: 'Inte redo',
            items: 'objekt',
        },
        change_review: {
            title: 'Regulatorisk ändringsgranskning',
            new_review: 'Ny ändringsgranskning',
            change_id: 'Ändrings-ID',
            select_change: 'Välj en ändring...',
            select_framework: 'Välj ett ramverk...',
            impact_assessment: 'Konsekvensbedömning',
            decision: 'Beslut',
            no_action: 'Ingen åtgärd',
            internal_update: 'Intern uppdatering',
            authority_filing: 'Myndighetsanmälan',
            no_reviews: 'Inga ändringsgranskningar hittades',
            auto_cycle: 'Automatisk granskningscykel',
            cadence: 'Granskningsfrekvens',
            framework: 'Ramverk',
        },
        export_csv: 'Exportera [[TOK_0]]',
        exporting: 'Exporterar...',
        export_success: '[[TOK_0]] exporterades framgångsrikt.',
        export_failed: '[[TOK_0]] export misslyckades.',
        export_attestation_pack: 'Exportera attestpaket',
        staleness: {
            badge_label: '[[TOK_1]] inaktuella föremål',
            days_since: '[[TOK_1]] dagar sedan senaste uppdateringen',
            detail_title: 'Inaktuella föremål',
            accept_justification: 'Acceptera med motivering',
            justification_label: 'Motivering',
            no_stale: 'Inga inaktuella föremål hittades.',
            threshold_label: 'Stålhetströskel (dagar)',
            threshold_min: 'Minst 30 dagar',
            threshold_max: 'Max 730 dagar',
            threshold_saved: 'Tröskeln för staleness uppdaterad.',
        },
        csv_columns: {
            name: 'Namn',
            status: 'Status',
            owner: 'Ägare',
            created_at: 'Skapad på',
            updated_at: 'Uppdaterad kl',
            scope: 'Omfattning',
            frameworks: 'Ramar',
            period_label: 'Periodetikett',
            start_date: 'Startdatum',
            end_date: 'Slutdatum',
            task_count: 'Uppgiftsräkning',
            completion_rate: 'Genomförandefrekvens',
            title: 'Titel',
            assigned_to: 'Tilldelad till',
            due_date: 'Förfallodatum',
            priority: 'Prioritet',
            completed_at: 'Avslutad kl',
            kpi_code: '[[TOK_0]] Kod',
            kpi_label: '[[TOK_0]] Etikett',
            target: 'Mål',
            actual: 'Faktiskt',
            trend: 'Trend',
            reference: 'Referens',
            regulator: 'Regulator',
            inquiry_type: 'Förfrågningstyp',
            lead: 'Bly',
            received_date: 'Mottaget datum',
            deadline: 'Deadline',
            framework_code: 'Ramkod',
            readiness_status: 'Beredskapsstatus',
            package_count: 'Antal paket',
            change_id: 'Byt ID',
            impact_assessment: 'Konsekvensbedömning',
            decision: 'Beslut',
            program: 'Program',
            readiness_score: 'Beredskapspoäng',
            category: 'Kategori',
            checklist_count: 'Checklistaräkning',
            effort_hours: 'Ansträngning (timmar)',
            version: 'Version',
            department: 'Avdelning',
            function_area: 'Funktionsområde',
            role: 'Roll',
            assignee: 'Uppdragstagare',
            frequency: 'Frekvens',
        },
        raci: {
            page_title: 'Styrning RACI Matrix',
            title: 'Styrning RACI Matrix',
            department: 'Avdelning',
            function_area: 'Funktionsområde',
            responsible: 'Ansvarig',
            accountable: 'Ansvarig',
            consulted: 'Konsulterad',
            informed: 'Informerad',
            assign_role: 'Tilldela RACI-roll',
            select_program: 'Välj Program',
            select_program_prompt: 'Välj ett program för att visa RACI-matrisen.',
            no_assignments: 'Inga RACI-tilldelningar hittades.',
            role_updated: 'RACI-uppdraget uppdaterat.',
            role_labels: {
                R: 'Ansvarig',
                A: 'Ansvarig',
                C: 'Konsulterad',
                I: 'Informerad',
            },
            loaded_count: 'Laddade [[TOK_1]] RACI-uppdrag',
            single_accountability_warning: 'Endast en ansvarig (A) roll är tillåten per funktionsområde. Att tilldela en ny ansvarig roll kommer att ersätta den befintliga.',
            cybersec_function_areas: 'Cybersäkerhetslagstiftningens funktionsområden: incidenthantering, bevisbevarande, myndighetssamverkan och lokaliseringsgranskning.',
            ai_law_function_areas: '[[TOK_0]] Juridiska funktionsområden: Systemregistrering, Pre-Deployment Assessment, Transparens, Incidenthantering.',
            suggested_function_areas: 'Föreslagna funktionsområden',
        },
        prior_cycle: {
            link_label: 'Länk till föregående cykel',
            select_prior: 'Välj föregående cykel...',
            linked: 'År för år',
            no_prior: 'Inga tidigare cykler tillgängliga.',
            linked_success: 'Tidigare cykel länkad.',
        },
        digest_table: {
            module: 'Modul',
            entity_type: 'Enhetstyp',
            change_type: 'Ändra typ',
            description: 'Beskrivning',
            changed_at: 'Ändrade kl',
        },
        view_related_ric: 'Visa relaterade RIC-fall',
        linked_program: 'Länkat program',
        nav_raci: 'RACI-matris',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Utkast till svar',
            drafting: 'Utarbetar...',
            results_heading: 'Utkast till svar ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            counsel_label: 'Juristgranskning krävs:',
            counsel_default: 'Minst ett svar kräver juristgranskning innan det skickas.',
            requires_counsel_label: 'Kräver juristgranskning.',
            accept_label: 'Acceptera utkast',
            reject_label: 'Avvisa utkastet',
            error_generic: 'Det gick inte att skriva svaret. Försök igen eller förfina förfrågningstexten.',
        },
        breach_timeline: {
            compute_label: 'Beräkna tidslinje för meddelande om brott',
            computing: 'Dator...',
            results_heading: 'Överträdelse av tidsfrister för meddelanden ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            handoff_label: 'Forseti föreslår:',
            empty_label: 'Inga tillämpliga ramverk för de berörda jurisdiktionerna.',
            mandatory_label: 'Obligatoriska fält:',
            draft_label: 'Utkast till anmälan',
            remaining_label: '[[TOK_1]]h kvar',
            overdue_label: 'FÖRSENAD av',
            acknowledge_label: 'Bekräfta — uppgifter skapade externt',
            acknowledging: 'Erkänner...',
            error_generic: 'Det gick inte att beräkna tidslinjen för intrång. Försök igen.',
        },
        breach_determination: {
            confirmed_breach: 'Bekräftad Intrång',
            suspected_breach: 'Misstänkt Intrång',
            not_a_breach: 'Inte en Intrång',
            pending: 'Väntande',
        },
        errors: {
            fetch: 'Kunde inte ladda incidenter.',
            save: 'Kunde inte spara incident.',
            fetch_failed: 'Kunde inte hämta incidenter.',
            save_failed: 'Kunde inte spara incident.',
            transition_failed: 'Kunde inte övergå incident.',
            close_failed: 'Kunde inte stänga incident.',
            fetch_timeline_failed: 'Kunde inte hämta tidslinje.',
            fetch_decisions_failed: 'Kunde inte hämta beslut.',
            triage_failed: 'Kunde inte uppdatera triage.',
            impact_update_failed: 'Kunde inte uppdatera konsekvensbedömning.',
            breach_update_failed: 'Kunde inte uppdatera intrångsbedömning.',
            create_timeline_failed: 'Kunde inte skapa tidslinjepost.',
            create_decision_failed: 'Kunde inte skapa beslut.',
            notification_update_failed: 'Kunde inte uppdatera avisering.',
            fetch_tasks_failed: 'Kunde inte hämta uppgifter.',
            create_task_failed: 'Kunde inte skapa uppgift.',
            update_task_status_failed: 'Kunde inte uppdatera uppgiftsstatus.',
            update_checklist_failed: 'Kunde inte uppdatera checklista.',
            assign_task_failed: 'Kunde inte tilldela uppgift.',
            escalate_task_failed: 'Kunde inte eskalera uppgift.',
            fetch_templates_failed: 'Kunde inte hämta mallar.',
            permission_denied: 'Du har inte behorighet att komma at denna sektion. Kontakta din administrator for att begara atkomst.',
        },
        harm_likelihood: {
            unlikely: 'Osannolik',
            possible: 'Möjlig',
            likely: 'Trolig',
            very_likely: 'Mycket troligt',
        },
        reported_via: {
            email: 'E-post',
            phone: 'Telefon',
            internal_system: 'Intern System',
            third_party: 'Tredje Part',
            automated_detection: 'Automatiserad Detektering',
        },
        task_transition_labels: {
            start: 'Starta',
            complete: 'Slutför',
            block: 'Blockera',
            defer: 'Skjut upp',
        },
        transition_labels: {
            start: 'Starta',
            complete: 'Slutför',
            block: 'Blockera',
            defer: 'Skjut upp',
        },
        nav: {
            all: 'Alla Incidenter',
            tasks: 'Åtgärdsuppgifter',
            reports: 'Rapporter',
            breach_notifications: 'Intrångsmeddelanden',
            supplements: 'Tillägg',
            remediation: 'Åtgärder',
            authority_requests: 'Myndighetsförfrågningar',
            disclosure_register: 'Offentliggöranderegister',
        },
        list: {
            page_title: 'Incidenter',
            title: 'Incidenter',
            new: 'Ny Incident',
            edit: 'Redigera Incident',
            incident_title: 'Titel',
            severity: 'Allvarlighetsgrad',
            reported_at: 'Rapporterad Vid',
            reported_by: 'Rapporterad Av',
            assigned_to: 'Tilldelad Till',
            view_detail: 'Visa Detaljer',
            reference: 'Referens',
            lead: 'Ledare',
            reported_via: 'Rapporterad Via',
            discovery_date: 'Upptäckt Datum',
            hide_details: 'Dölj Detaljer',
            close_incident: 'Stäng Incident',
            close_justification_prompt: 'Ange en motivering för att stänga denna incident.',
            justification: 'Motivering',
            lead_id: 'Ledare ID',
            contact: 'Kontakt',
            category: 'Kategori',
            not_assessed: 'Ej bedömd',
        },
        detail: {
            page_title: 'Incident detalj',
            title: 'Incidentdetaljer',
            tabs: {
                overview: 'Översikt',
                triage: 'Prioritering',
                impact: 'Konsekvensbedömning',
                breach: 'Bedömning av Personuppgiftsincident',
                timeline: 'Tidslinje',
                decisions: 'Beslut',
                evidence: 'Bevis',
                audit_trail: 'Revisionsspår',
            },
            evidence_upload_label: 'Bifoga bevisfil',
            evidence_uploaded: 'Bevis uppladdat',
            evidence_deleted: 'Bevis borttaget',
            evidence_delete_error: 'Kunde inte ta bort bevis',
            evidence_uploaded_at: 'Uppladdad',
            evidence_empty: 'Inga bevisfiler kopplade till denna incident.',
            evidence_size: 'Storlek',
            triage_notes: 'Prioriteringsanteckningar',
            initial_classification: 'Initial Klassificering',
            individuals_affected: 'Antal Berörda Individer',
            data_categories: 'Berörda Datakategorier',
            systems_compromised: 'Komprometterade System',
            geographic_scope: 'Geografiskt Omfång',
            breach_determination: 'Bedömning av Dataintrång',
            notification_required: 'Anmälan Krävs',
            notification_deadline: 'Anmälningsfrist',
            pdpc_reportable: 'Rapporterbar till Tillsynsmyndighet',
            add_timeline: 'Lägg till Tidslinjeinlägg',
            add_decision: 'Lägg till Beslut',
            not_found: 'Incident hittades inte.',
            team_members: 'Team Medlemmar',
            checklist: 'Checklista',
            completed: 'Slutförd',
            impact_severity_score: 'Beräknad allvarlighetspoäng för konsekvenser',
            records_affected: 'Poster Berörda',
            potential_consequences: 'Potentiella Konsekvenser',
            harm_likelihood: 'Skada Sannolikhet',
            legal_basis: 'Rättslig grund',
            jurisdictions: 'Jurisdiktioner',
            jurisdictions_comma: 'Jurisdiktioner (kommaseparerade)',
            jurisdiction: 'Jurisdiktion',
            authority_status: 'Myndighet Status',
            subject_status: 'Ämne Status',
            authority_deadline: 'Myndighet Deadline',
            subject_deadline: 'Ämne Deadline',
            mark_authority_done: 'Markera myndighet klar',
            mark_subject_done: 'Markera ämne klart',
            not_assessed: 'Ej bedömd',
            event_type: 'Händelse Typ',
            timestamp: 'Tidsstämpel',
            actor: 'Aktör',
            no_timeline_events: 'Inga tidslinje händelser ännu.',
            decision_type: 'Beslut Typ',
            decision: 'Beslut',
            rationale: 'Motivering',
            decision_made: 'Beslut fattat',
            no_decisions: 'Inga decisions recorded ännu.',
            jurisdictions_comma_separated: 'VN, SG, EU',
            no_audit_events: 'Inga revisionshändelser registrerade ännu.',
            export_pdf: 'Exportera PDF',
            pdf_title: 'Incidentsammanfattning',
            description: 'Beskrivning',
            linked_records: 'Länkade Poster',
        },
        tasks: {
            page_title: 'Incident Response uppgifter',
            title: 'Åtgärdsuppgifter vid Incident',
            new: 'Ny Uppgift',
            edit: 'Redigera Uppgift',
            task_type: 'Uppgiftstyp',
            assignee: 'Tilldelad',
            due_date: 'Förfallodatum',
            dependencies: 'Beroenden',
            mark_complete: 'Markera som Slutförd',
            templates: 'Uppgiftsmallar',
            select_incident: 'Välj Incident',
            all_statuses: 'Alla Statusar',
            all_categories: 'Alla Kategorier',
            new_response_task: 'Ny Åtgärdsuppgift',
            category: 'Kategori',
            priority: 'Prioritet',
            depends_on: 'Beroende av (kommaseparerade uppgifts-ID)',
            checklist_items: 'Checklistepunkter',
            remove: 'Ta bort',
            add: 'Lägg till',
            new_checklist_item: 'Ny checklistepunkt',
            no_templates: 'Inga mallar tillgängliga.',
            assign_task: 'Tilldela Uppgift',
            assign_to: 'Tilldela Till',
            assign: 'Tilldela',
            select_incident_prompt: 'Vänligen välj en incident för att visa dess åtgärdsuppgifter.',
            checklist: 'Checklista',
            hide_checklist: 'Dölj Checklista',
            escalate: 'Eskalera',
            escalations: 'Eskaleringar',
            no_checklist_items: 'Inga checklistepunkter.',
        },
        reports: {
            page_title: 'Incidentrapporter',
            title: 'Incidentrapporter',
            summary: 'Sammanfattande Statistik',
            by_severity: 'Per Allvarlighetsgrad',
            by_status: 'Per Status',
            recent: 'Senaste Incidenter',
            total_incidents: 'Totalt Antal Incidenter',
            open: 'Öppna',
            closed: 'Stängda',
            export_csv: 'Exportera CSV',
            export_pdf: 'Exportera PDF',
            export_success: 'Rapport exporterad.',
            export_error: 'Kunde inte exportera rapport.',
            reference: 'Referens',
            view_report: 'Visa Rapport',
        },
        statuses: {
            reported: 'Rapporterad',
            triage: 'Prioritering',
            contained: 'Begränsad',
            investigation: 'Utredning',
            remediation: 'Åtgärd',
            closed: 'Stängd',
            false_positive: 'Falskt Positivt',
        },
        task_statuses: {
            pending: 'Väntande',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            blocked: 'Blockerad',
            cancelled: 'Avbruten',
        },
        severity: {
            low: 'Låg',
            medium: 'Medel',
            high: 'Hög',
            critical: 'Kritisk',
        },
        task_types: {
            containment: 'Begränsning',
            investigation: 'Utredning',
            remediation: 'Åtgärd',
            communication: 'Kommunikation',
            documentation: 'Dokumentation',
            notification: 'Anmälan',
        },
        categories: {
            data_breach: 'Data Intrång',
            unauthorized_access: 'Obehörig Åtkomst',
            data_loss: 'Data Förlust',
            system_compromise: 'System Kompromiss',
            malware: 'Skadlig kod',
            phishing: 'Nätfiske',
            insider_threat: 'Insiderhot',
            other: 'Övrigt',
        },
        reported_via_options: {
            email: 'E-post',
            phone: 'Telefon',
            internal_system: 'Intern System',
            third_party: 'Tredje Part',
            automated_detection: 'Automatiserad Detektering',
        },
        harm_likelihood_options: {
            unlikely: 'Osannolik',
            possible: 'Möjlig',
            likely: 'Trolig',
            very_likely: 'Mycket troligt',
        },
        breach_determination_options: {
            confirmed_breach: 'Bekräftad Intrång',
            suspected_breach: 'Misstänkt Intrång',
            not_a_breach: 'Inte en Intrång',
            pending: 'Väntande',
        },
        timeline_event_types: {
            detection: 'Detektering',
            escalation: 'Eskalering',
            containment: 'Inneslutning',
            investigation_start: 'Utredning Start',
            evidence_collected: 'Bevis Insamlad',
            notification_sent: 'Avisering Skickad',
            remediation_action: 'Åtgärdande Åtgärd',
            status_change: 'Status Ändrings',
            communication: 'Kommunikation',
            other: 'Övrigt',
        },
        decision_types: {
            containment: 'Inneslutning',
            notification: 'Avisering',
            remediation: 'Åtgärdande',
            escalation: 'Eskalering',
            closure: 'Stängning',
            other: 'Övrigt',
        },
        task_transitions: {
            start: 'Starta',
            complete: 'Slutför',
            block: 'Blockera',
            cancel: 'Avbryt',
            unblock: 'Avblockera',
        },
        announce: {
            loaded: '[[TOK_1]] incidenter laddade',
            reports_loaded: '[[TOK_1]] incidentrapporter har laddats',
            tasks_loaded: '[[TOK_1]] uppgifter har laddats',
            created: 'Incidenten skapades framgångsrikt',
            updated: 'Incidenten har uppdaterats',
            closed: 'Incidenten avslutades',
            status_changed: 'Incidentstatus ändrad',
            triage_completed: 'Triage slutfördes framgångsrikt',
            impact_updated: 'Konsekvensbedömningen uppdaterad',
            breach_updated: 'Överträdelsebedömning uppdaterad',
            timeline_added: 'Tidslinjehändelse har lagts till',
            decision_recorded: 'Beslut antecknat',
            notification_updated: 'Aviseringsstatus uppdaterad',
            task_created: 'Uppgiften har skapats',
            task_status_changed: 'Uppgiftsstatus ändrad',
            checklist_completed: 'Checklista är klar',
            checklist_unchecked: 'Checklista avmarkerad',
            task_assigned: 'Uppgiften tilldelas framgångsrikt',
            task_escalated: 'Uppgiften eskalerade',
            export_initiated: 'Export påbörjad',
        },
        breach_notifications: {
            page_title: 'Aviseringar om brott',
            title: 'Aviseringar om brott',
            new_notification: 'Ny anmälan',
            no_notifications: 'Inga intrångsmeddelanden hittades',
            status: 'Status',
            submit_to_mps: 'Skicka till [[TOK_0]]',
            decision: 'Beslut',
            decision_maker: 'beslutsfattare',
            notify: 'Meddela',
            do_not_notify: 'Meddela inte',
            rationale: 'Motivering',
            filing_deadline: 'Sista anmälningsdag',
            overdue: 'Försenad',
            due_soon: 'Snart förfallen',
            on_track: 'I fas',
            legal_review: 'Juridisk granskning',
            incident_id: 'Incident ID',
            notification_statuses: {
                assessment: 'Bedömning',
                decision_to_notify: 'Beslut att anmäla',
                notification_drafted: 'Anmälan utarbetad',
                legal_review: 'Juridisk granskning',
                submitted_to_mps: 'Skickat till [[TOK_0]]',
                supplement_requested: 'Tillägg begärs',
                supplement_submitted: 'Tillägg inlämnat',
                acknowledged: 'Erkänt',
                closed: 'Stängt',
            },
        },
        supplements: {
            page_title: 'Tilläggsförfrågningar',
            title: 'Tilläggsförfrågningar',
            new_supplement: 'Nytt tillägg',
            no_supplements: 'Inga tilläggsförfrågningar hittades',
            request_details: 'Begär detaljer',
            response_package: 'Svarspaket',
            submit_response: 'Skicka svar',
            deadline: 'Deadline',
            notification_id: 'Aviserings-ID',
            enter_notification_id: 'Ange ett aviserings-ID för att se tillägg.',
            supplement_statuses: {
                requested: 'Begärt',
                drafting: 'Utformning',
                submitted: 'Inlämnad',
                accepted: 'Godkänd',
                rejected: 'Avvisad',
            },
        },
        remediation: {
            page_title: 'Saneringsåtgärder',
            title: 'Saneringsåtgärder',
            new_action: 'Ny åtgärd',
            no_actions: 'Inga korrigeringsåtgärder hittades',
            description: 'Beskrivning',
            owner: 'Ägare',
            department: 'Avdelning',
            deadline: 'Deadline',
            statuses: {
                planned: 'Planerad',
                in_progress: 'Pågår',
                completed: 'Slutförd',
                verified: 'Verifierad',
            },
            verify: 'Verifiera',
            incident_id: 'Incident ID',
            enter_incident_id: 'Ange ett incident-ID för att se åtgärdsåtgärder.',
            start: 'Starta',
            complete_action: 'Slutför',
        },
        authority_requests: {
            page_title: 'Myndighetsförfrågningar',
            title: 'Myndighetsförfrågningar',
            new_request: 'Ny förfrågan',
            no_requests: 'Inga myndighetsbegäranden hittades',
            authority_name: 'Myndighetsnamn',
            request_details: 'Begär detaljer',
            response_package: 'Svarspaket',
            submission_channel: 'Inlämningskanal',
            submit_response: 'Skicka svar',
            deadline: 'Deadline',
            confirmation: 'Bekräftelse',
            incident_id_optional: 'Incident-ID (valfritt)',
            response_context_label: 'Svarskontext (för materialisering av inlämningsdokument)',
            response_context_none: '(hoppa över materialisering)',
            response_context_supplement: 'Kompletterande svar',
            response_context_information: 'Svar på informationsbegäran',
            response_context_inspection: 'Svar på inspektion',
            materialisation_status_column: 'Inlämningsdokument',
            materialisation_pending: 'Väntar',
            materialisation_success: 'Materialiserat',
            materialisation_failed: 'Misslyckades',
            materialisation_retry_button: 'Försök igen',
            ar_statuses: {
                received: 'Mottaget',
                verified: 'Verifierad',
                assembling: 'Montering',
                submitted: 'Inskickad',
                closed: 'Stängt',
            },
        },
        disclosure_register: {
            page_title: 'Upplysningsregister',
            title: 'Upplysningsregister',
            new_entry: 'Nytt inlägg',
            no_entries: 'Inga avslöjande registerposter hittades',
            disclosure_type: 'Typ av avslöjande',
            disclosure_date: 'Offentliggörande datum',
            recipient: 'Mottagare',
            authority_name: 'Myndighetsnamn',
            channel: 'Kanal',
            content_summary: 'Sammanfattning av innehåll',
            incident_id_optional: 'Incident-ID (valfritt)',
        },
    },
    onboarding: {
        nav: {
            wizard: 'Installationsguide',
            tours: 'Modulguider',
            sample_data: 'Exempeldata',
        },
        wizard: {
            title: 'Installationsguide',
            welcome: 'Välkommen till AesirX ComplianceOne',
            welcome_message: 'Låt oss konfigurera din organisation. Den här guiden leder dig genom den inledande konfigurationen.',
            setup_complete: 'Installation Slutförd',
            skipped_message: 'Installationsguiden hoppades över. Du kan köra den när som helst för att konfigurera din organisation.',
            start_setup: 'Starta Installation',
            skip_wizard: 'Hoppa över Guiden',
            go_to_admin: 'Gå till Admin',
            skip_for_now: 'Hoppa över för Nu',
            next_step: 'Nästa Steg',
            previous_step: 'Föregående Steg',
            finish_setup: 'Slutför Installation',
            rerun: 'Kör Installationsguiden Igen',
            step_label: 'Steg {number}',
            validation_org_name_required: 'Organisationsnamn krävs.',
            validation_admin_email_required: 'Administratörens e-post krävs.',
            validation_admin_email_invalid: 'Ange en giltig e-postadress.',
            validation_cmp_endpoint_required: 'CMP-slutpunkt krävs när CMP är aktiverat.',
            steps: {
                license_activation: 'Licensaktivering',
                org_profile: 'Organisationsprofil',
                module_selection: 'Modulval',
                cmp_integration: 'CMP-integration',
                notification_preferences: 'Aviseringar',
                review: 'Granska & Bekräfta',
            },
            step_descriptions: {
                license_activation: 'Ange din licensnyckel för att aktivera ditt paket och avgöra vilka moduler som är tillgängliga.',
                org_profile: 'Konfigurera organisationsnamn, jurisdiktion, bransch, storlek och föredraget språk.',
                module_selection: 'Välj vilka efterlevnadsmoduler som ska aktiveras för din organisation.',
                cmp_integration: 'Konfigurera integration med Consent Management Platform (valfritt).',
                notification_preferences: 'Konfigurera hur du tar emot aviseringar för compliancehändelser.',
                review: 'Granska din konfiguration och slutför installationen.',
            },
            license_step: {
                validate_button: 'Validera licens',
                skip_warning: 'Modulåtkomst kommer att begränsas till standardpaketnivån. Du kan aktivera en licens senare i Plattform > Licensinställningar.',
            },
            module_descriptions: {
                rights_requests: 'Hantera begäranden om åtkomst till och radering av personuppgifter.',
                data_mapping: 'Kartlägg system, dataflöden och behandlingsaktiviteter.',
                governance: 'Hantera leverantörsefterlevnad och raderingsprocesser.',
                consent: 'Hantera samtyckespolicyer och ändamålskataloger.',
                consent_properties: 'Hantera samtycke över flera digitala egendomar.',
                assessments: 'Genomför konsekvensbedömningar och gränsöverskridande dataöverföringar.',
                classification: 'Klassificera och märk datatillgångar med livscykelspårning.',
                monitoring: 'Schemalagda efterlevnadsgranskningar och KPI-spårning.',
                incidents: 'Rapportera och hantera säkerhets- och integritetsincidenter.',
                connectors: 'Anslut till externa system för automatiserat datautbyte.',
                vendor_risk: 'Poängsätt leverantörer, spåra avtal och hantera due diligence.',
                deletion_orchestration: 'Koordinera dataradering över system och leverantörer.',
                discovery: 'Upptäck och klassificera data över din infrastruktur.',
                incident_ops: 'Avancerade incidentplaner, SLA-spårning och eskaleringar.',
                program_governance: 'Mognadsbedömningar, ledningsrapportering och revisionsredo.',
                access_accountability: 'Övervaka användaråtkomst, sessioner och motiveringsflöden.',
                localization: 'Marknadsspecifika compliancepaket och regulatoriska ramverk.',
                partner_workspace: 'Partner- och återförsäljararbetsyta.',
                privacy_scanner: 'Realtidsövervakning av integritet för digitala egendomar.',
                onboarding: 'Installationsguide, guidade turer och hantering av exempeldata.',
                compliance_forms: 'Interaktiva compliancemallar och dokumentgenerering.',
                audit_trail: 'Omfattande oföränderlig revisionsloggning och arkivering.',
                organizations: 'Multiorganisations- och grupphantering.',
                task_management: 'Enhetlig uppgiftsplanering, arbetsflödesmotor och kalendervyer.',
            },
            module_categories: {
                data_privacy_rights: 'Datasekretess och rättigheter',
                vendor_third_party: 'Leverantörs- och tredjepartshantering',
                risk_assessment: 'Risk & bedömning',
                operations_automation: 'Drift & Automation',
                platform_admin: 'Plattform & Administration',
            },
            package_tier_label: 'Ditt Paket',
            package_module_unavailable: 'Ingår inte i ditt paket',
            select_all: 'Välj Alla',
            deselect_all: 'Avmarkera Alla',
            load_sample_data: 'Ladda exempeldata efter installation',
            load_sample_data_description: 'Installera realistisk demodata (Lotus Financial Services) för att utforska plattformen. Kan tas bort senare från Onboarding > Exempeldata.',
            language_label: 'Föredraget Språk',
            language_description: 'Välj standardspråk för din organisation.',
            admin_account_title: 'Administratörskonto',
            admin_account_created: 'Administratörskonto skapat',
            admin_full_name: 'Fullständigt namn',
            admin_email: 'E-postadress',
            admin_password: 'Lösenord',
            admin_confirm_password: 'Bekräfta lösenord',
            admin_show_password: 'Visa lösenord',
            admin_hide_password: 'Dölj lösenord',
            admin_name_placeholder: 't.ex. Jane Smith',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Minst 8 tecken',
            admin_password_confirm_placeholder: 'Ange lösenord igen',
            validation_admin_name_required: 'Administratörsnamn krävs',
            validation_admin_password_required: 'Lösenord krävs',
            validation_admin_password_min_length: 'Lösenordet måste vara minst 8 tecken',
            validation_passwords_mismatch: 'Lösenorden matchar inte',
            notification_email_enabled: 'Aktivera E-postaviseringar',
            notification_email_description: 'Ta emot e-postaviseringar om uppgiftstilldelning, SLA-överträdelser och compliancehändelser.',
            notification_digest_frequency: 'Sammandragsfrekvens',
            notification_digest_daily: 'Dagligen',
            notification_digest_weekly: 'Veckovis',
            notification_digest_none: 'Inget sammandrag',
            notification_in_app_enabled: 'Aktivera Plattformsaviseringar',
            notification_in_app_description: 'Visa aviseringsbricka och aviseringspanel för realtidsvarningar.',
            jurisdictions: {
                vietnam: 'Vietnam',
                asean: 'ASEAN',
                eu_eea: 'EU/EES',
                global: 'Global',
            },
            languages: {
                en: 'engelska',
                vi: 'Tiếng Việt',
                da: 'Dansk',
                sv: 'Svenska',
                nb: 'Norsk bokmål',
                nn: 'Norsk nynorsk',
                de: 'Deutsch',
                fi: 'Suomi',
                nl: 'Nederlands',
                fr: 'Français',
                lb: 'Lëtzebuergesch',
                ga: 'Gaeilge',
                es: 'Español',
                ca: 'Català',
                eu: 'Euskara',
                pt: 'Português',
            },
            industries: {
                financial_services: 'Finansiella tjänster',
                healthcare: 'Hälsovård',
                technology: 'Teknik',
                telecommunications: 'Telekommunikation',
                government: 'Offentlig sektor',
                education: 'Utbildning',
                manufacturing: 'Tillverkning',
                retail: 'Detaljhandel',
                other: 'Övrigt',
            },
            placeholders: {
                org_name: 't.ex. Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'användare1@företag.vn, användare2@företag.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Organisationsnamn',
                jurisdiction: 'Jurisdiktion',
                industry: 'Bransch',
                org_size: 'Organisationsstorlek',
                language: 'Föredraget Språk',
                admin_email: 'Administratörs E-post',
                team_emails: 'Teammedlemmars E-post (kommaseparerade)',
                enable_cmp: 'Aktivera CMP-integration',
                cmp_endpoint: 'CMP API-slutpunkt',
                email_notifications: 'E-postaviseringar',
                in_app_notifications: 'Plattformsaviseringar',
                digest_frequency: 'Sammandragsfrekvens',
            },
        },
        tours: {
            title: 'Modulintroduktionsguider',
            start: 'Starta Guide',
            continue_tour: 'Fortsätt Guide',
            replay: 'Spela om Guide',
            exit: 'Avsluta Guide',
            skip: 'Hoppa över Guide',
            next: 'Nästa',
            previous: 'Föregående',
            finish: 'Avsluta Guide',
            step_of: 'Steg {current} av {total}',
            info: 'Ta guidade turer av varje modul för att lära dig viktiga funktioner och arbetsflöden. Guider kan spelas om när som helst.',
            autoplay: 'Automatisk uppspelning',
            interactive: 'Interaktiv',
            play_all: 'Spela alla',
            search_tours: 'Sök rundturer...',
            duration: 'Varaktighet',
            steps_label: '[[TOK_1]] steg',
            mode: 'Läge',
            pause: 'Pausa',
            resume: 'Återuppta',
            speed: 'Hastighet',
            restart: 'Starta om',
            reset: 'Återställ',
            reset_success: 'Turförloppet har återställts.',
            category_core_privacy: 'Kärnskydd',
            category_governance: 'Styrning',
            category_operations: 'Verksamhet',
            category_platform: 'Plattform',
            category_advanced: 'Avancerat',
            category_data_privacy_rights: 'Datasekretess och rättigheter',
            category_vendor_third_party: 'Leverantörs- och tredjepartshantering',
            category_risk_assessment: 'Risk & bedömning',
            category_operations_automation: 'Drift & Automation',
            category_platform_admin: 'Plattform & Administration',
            steps_count: '[[TOK_1]] steg',
        },
        sample_data: {
            title: 'Hantering av Exempeldata',
            select_modules: 'Välj Moduler',
            current_status: 'Aktuell Status',
            operation_history: 'Operationshistorik',
            load: 'Ladda Exempeldata',
            clear: 'Rensa Exempeldata',
            processing: 'Bearbetar...',
            loaded: 'Laddad',
            not_loaded: 'Ej Laddad',
            records: 'Exempelposter',
            confirm_clear: 'Är du säker på att du vill rensa all exempeldata för de valda modulerna?',
            confirm_clear_title: 'Rensa exempeldata',
            confirm_load_title: 'Ladda exempeldata',
            confirm_load: 'Är du säker på att du vill ladda exempeldata för de valda modulerna?',
            action_load: 'Ladda',
            action_clear: 'Rensa',
            info: 'Ladda realistisk demodata för utbildning och demonstrationer med det fiktiva företaget "Lotus Financial Services". Exempeldata är taggad och kan tas bort säkert utan att påverka verklig data.',
        },
        help: {
            title: 'Hjälpcenter',
            search: 'Sök',
            search_placeholder: 'Sök hjälpartiklar...',
            clear: 'Rensa',
            all_categories: 'Alla Kategorier',
            all_modules: 'Alla Moduler',
            back: 'Tillbaka till Hjälpcenter',
            callout_important: 'Viktigt',
            callout_tip: 'Tips',
            no_results: 'Inga artiklar hittades som matchar din sökning.',
            no_articles: 'Inga hjälpartiklar tillgängliga ännu. Artiklar visas här när innehåll läggs till.',
            results_for: '{count} resultat för "{query}"',
            quick_links: {
                getting_started: 'Kom Igång',
                getting_started_desc: 'Installation, konfiguration och snabbstartsguide.',
                user_guide: 'Användarhandbok',
                user_guide_desc: 'Dokumentation modul för modul.',
                admin_guide: 'Administratörshandbok',
                admin_guide_desc: 'Konfiguration, underhåll och felsökning.',
                faq: 'Vanliga Frågor',
                faq_desc: 'Vanliga frågor och svar.',
            },
            search_articles_aria: 'Sök hjälpartiklar',
            article_metadata_aria: 'Artikelmetadata',
            articles_list_aria: 'Hjälpartiklar',
            category_nav_aria: 'Kategorinavigering',
            quick_links_aria: 'Snabblänkar till hjälpkategorier',
            returned_to_list: 'Tillbaka till artikellistan',
            opening_article: 'Öppnar artikel: {title}',
            read_article_aria: 'Läs artikel: {title}',
            pagination_nav_aria: 'Artikelpaginering',
            error_unavailable: 'Hjälpcentret är för närvarande inte tillgängligt. Försök igen senare.',
            retry: 'Försök igen',
        },
    },
    common: {
        save: 'Spara',
        cancel: 'Avbryt',
        system_actor: 'System',
        delete: 'Radera',
        edit: 'Redigera',
        create: 'Skapa',
        update: 'Uppdatera',
        loading: 'Laddar...',
        error: 'Ett fel uppstod',
        success: 'Lyckades',
        logout: 'Logga ut',
        actions: 'Åtgärder',
        retrying: 'Försöker igen...',
        permission_denied: 'Du har inte tillgång till den här sidan.',
        status: 'Tillstånd',
        description: 'Beskrivning',
        name: 'Namn',
        created_at: 'Skapad Vid',
        updated_at: 'Uppdaterad Vid',
        yes: 'Ja',
        no: 'Nej',
        confirm: 'Bekräfta',
        back: 'Tillbaka',
        next: 'Nästa',
        previous: 'Föregående',
        search: 'Sök',
        filter: 'Filtrera',
        page_x_of_y: 'Sida [[TOK_2]] av [[TOK_3]]',
        pagination_label: 'Paginering',
        view_mode_label: 'Visningsläge',
        export: 'Exportera',
        exporting: 'Exporterar...',
        sidebar_navigation: 'Admin sidofältsnavigering',
        items_count: '[[TOK_1]] objekt',
        items_count_one: '[[TOK_1]] objekt',
        export_success: 'Dokumentet har skapats framgångsrikt.',
        generate_pdf: 'Skapa PDF',
        import: 'Importera',
        download: 'Ladda ner',
        upload: 'Ladda upp',
        view: 'Visa',
        close: 'Stäng',
        submit: 'Skicka',
        saved: 'Sparat',
        saving: 'Sparar...',
        submitting: 'Skickar...',
        created: 'Skapad',
        all: 'Alla',
        none: 'Inga',
        select: 'Välj',
        select_user: 'Välj användare...',
        custom_input: 'Ange manuellt',
        required: 'Obligatoriskt',
        optional: 'Valfritt',
        notes: 'Anteckningar',
        tags: 'Taggar',
        archive: 'Arkivera',
        clone: 'Klona',
        refresh: 'Uppdatera',
        retry: 'Försök igen',
        reset: 'Återställ',
        add: 'Lägg till',
        remove: 'Ta bort',
        removing: 'Tar bort…',
        attachment: 'Bilaga',
        upload_file: 'Ladda upp fil',
        upload_file_required: 'Ladda upp fil (obligatoriskt)',
        select_entity_type_first: 'Välj först en entitetstyp',
        failed_to_remove_file: 'Det gick inte att ta bort filen.',
        entity_type_label: 'Entitetstyp',
        entity_label: 'Entitet',
        entity_reference: 'Entitetsreferens',
        failed_to_load_entities: 'Det gick inte att läsa in entiteter',
        enable: 'Aktivera',
        disable: 'Inaktivera',
        no_data: 'Inga data hittades',
        confirm_delete: 'Är du säker på att du vill radera detta objekt?',
        confirm_action: 'Är du säker på att du vill fortsätta?',
        save_success: 'Sparades',
        save_error: 'Kunde inte spara',
        delete_success: 'Raderades',
        delete_error: 'Kunde inte radera',
        hour: 'timme',
        hours: 'timmar',
        load_error: 'Kunde inte ladda data',
        operation_error: 'Åtgärden misslyckades',
        something_went_wrong: 'Något gick fel',
        go_home: 'Gå till Översikt',
        access_denied: 'Åtkomst Nekad',
        no_permission: 'Du har inte behörighet att komma åt denna sida.',
        no_permission_title: 'Otillräckliga behörigheter',
        no_permission_message: 'Du har inte behörighet att komma åt denna sida.',
        unknown: 'Okand',
        back_to_dashboard: 'Tillbaka till Översikt',
        id: 'ID',
        type: 'Typ',
        date: 'Datum',
        created_by: 'Skapad Av',
        updated_by: 'Uppdaterad Av',
        page_of: 'Sida {page} av {total}',
        showing_items: 'Visar {count} objekt',
        items_per_page: 'Objekt per sida',
        no_results: 'Inga poster matchar dina filter',
        no_items: 'Inga objekt hittades',
        sort_by: 'Sortera efter',
        ascending: 'Stigande',
        descending: 'Fallande',
        all_statuses: 'Alla Statusar',
        all_types: 'Alla Typer',
        all_categories: 'Alla Kategorier',
        all_severities: 'Alla Allvarlighetsgrader',
        date_range: 'Datumintervall',
        from_date: 'Från',
        to_date: 'Till',
        clear_filters: 'Rensa Filter',
        apply_filters: 'Tillämpa Filter',
        save_changes: 'Spara Ändringar',
        discard_changes: 'Förkasta Ändringar',
        confirm_discard: 'Du har osparade ändringar. Vill du förkasta dem?',
        copy: 'Kopiera',
        duplicate: 'Duplicera',
        move: 'Flytta',
        assign: 'Tilldela',
        unassign: 'Ta bort Tilldelning',
        approve: 'Godkänn',
        reject: 'Avvisa',
        deleting: 'Raderar...',
        processing: 'Bearbetar...',
        loading_page: 'Laddar sida...',
        operation_success: 'Åtgärden slutfördes',
        operation_failed: 'Åtgärden misslyckades. Försök igen.',
        empty_dash: '—',
        network_error: 'Nätverksfel. Kontrollera din anslutning.',
        session_expired: 'Sessionen har gått ut. Logga in igen.',
        test: 'Testa',
        pause: 'Pausa',
        resume: 'Återuppta',
        activate: 'Aktivera',
        last_sync: 'Senaste Synkronisering',
        health: 'Hälsa',
        email: 'E-post',
        role: 'Roll',
        title: 'Titel',
        owner: 'Ägare',
        priority: 'Prioritet',
        category: 'Kategori',
        details: 'Detaljer',
        overview: 'Översikt',
        configuration: 'Konfiguration',
        history: 'Historik',
        new_item: 'Ny',
        edit_item: 'Redigera',
        select_option: 'Välj...',
        total: 'Totalt',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        enabled: 'Aktiverad',
        disabled: 'Inaktiverad',
        last_login: 'Senaste Inloggning',
        never: 'Aldrig',
        password_changed: 'Lösenord ändrat. Du kommer att loggas ut.',
        password_change_failed: 'Kunde inte ändra lösenord',
        passwords_mismatch: 'Lösenorden stämmer inte överens',
        install: 'Installera',
        uninstall: 'Avinstallera',
        installed: 'Installerad',
        available: 'Tillgänglig',
        catalog: 'Katalog',
        published: 'Publicerad',
        version: 'Utgåva',
        market: 'Marknad',
        language: 'Språk',
        framework: 'Ramverk',
        template: 'Mall',
        connector_type: 'Anslutningstyp',
        polling_interval: 'Pollningsintervall (minuter)',
        new_instance: 'Ny Instans',
        change_password: 'Ändra Lösenord',
        current_password: 'Nuvarande Lösenord',
        new_password: 'Nytt Lösenord',
        confirm_password: 'Bekräfta Lösenord',
        comments: 'Kommentarer',
        completed: 'Slutförd',
        contact: 'Kontakt',
        hide: 'Dölj',
        hide_details: 'Dölj Detaljer',
        label: 'Etikett',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'Visar',
        page: 'Sida',
        preview: 'Förhandsgranskning',
        print: 'Skriv ut',
        show: 'Visa',
        status_active: 'Aktiv',
        status_completed: 'Slutförd',
        status_draft: 'Utkast',
        status_in_progress: 'Pågående',
        status_pending: 'Väntande',
        view_details: 'Visa Detaljer',
        all_priorities: 'Alla prioriteringar',
        pipeline: 'Rörledning',
        all_requests: 'Alla Begäranden',
        schedule: 'Schema',
        deploy: 'Distribuera',
        rollback: 'Återställning',
        advance_stage: 'Avancera Fas',
        submit_for_approval: 'Skicka in för godkännande',
        approval_log: 'Godkännande Logg',
        approver: 'Godkännare',
        decision: 'Beslut',
        decided_at: 'Besluttet At',
        rollout_stages: 'Utrullning Faser',
        approval_comment: 'Godkännande Kommentar',
        optional_comment: 'Valfritt kommentar...',
        impact_summary: 'Konsekvens Sammanfattning',
        target_property_ids: 'Målegenskaps-ID:n (kommaseparerade)',
        policy_id: 'Policy-ID',
        target_version: 'Mål Version',
        target_version_placeholder: 't.ex. 2.0.0',
        scheduled_label: 'Schemalagd',
        scheduled_start: 'Schemalagd start',
        scheduled_end: 'Schemalagd slut',
        properties_count: '{count} egenskaper',
        results: 'Resultat',
        comparison_results: 'Jämförelse Resultat',
        past_comparison_reports: 'Tidigare jämförelserapporter',
        scanning: 'Skannar...',
        run_inconsistency_scan: 'Körning Inkonsekvens Skanning',
        property_ids_label: 'Egenskaps-ID:n (kommaseparerade, min 2)',
        comparison_type: 'Jämförelse Typ',
        golden_template_id: 'Gyllene mall-ID (valfritt)',
        leave_blank_compare: 'Lämna tomt för att jämföra egenskaper mot varandra',
        add_notes_placeholder: 'Lägg till dina analysanteckningar här...',
        covered_of_active: '{covered} av {active} aktiva egenskaper täckta',
        fetch_error: 'Kunde inte hämta data. Försök igen.',
        run_comparison_error: 'Kunde inte köra jämförelse. Försök igen.',
        save_notes_error: 'Kunde inte spara anteckningar. Försök igen.',
        scan_complete: 'Inkonsekvenskontroll slutförd.',
        scan_error: 'Kunde inte köra inkonsekvenskontroll. Försök igen.',
        min_two_properties: 'Ange minst 2 egenskaps-ID:n för jämförelse.',
        comma_separated: 'kommaseparerad',
        language_english: 'Engelska',
        language_vietnamese: 'Vietnamesiska',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Författare',
        dependencies: 'Beroenden',
        checksum: 'Checksumma',
        changelog: 'Ändringslogg',
        tier: 'Nivå',
        phone: 'Telefon',
        launch: 'Starta',
        complete: 'Slutför',
        back_to_list: 'Tillbaka till lista',
        clear_selection: 'Rensa Val',
        deactivate: 'Inaktivera',
        scope: 'Omfattning',
        deadline: 'Tidsfrist',
        progress: 'Framsteg',
        frequency: 'Frekvens',
        reviewer: 'Granskare',
        user: 'Användare',
        campaign: 'Kampanj',
        items: 'Objekt',
        next_run: 'Nästa Körning',
        last_run: 'Senaste Körning',
        overdue: 'FÖRSENAD',
        creating: 'Skapar...',
        launching: 'Startar...',
        loaded: 'loaded',
        page_size: 'Sidstorlek',
        per_page: '/ sida',
        urgent: 'Brådskande',
        pagination: 'Paginering',
        metric: 'Metrisk',
        value: 'Värde',
        country: 'Land',
        showing_chart_view: 'Visar diagramvy',
        showing_table_view: 'Visar datatabellvy',
        policies: 'Policyer',
        select_content_type: 'Vänligen välj minst en innehållstyp.',
        compliant: 'Överensstämmer',
        non_compliant_status: 'Icke-kompatibel',
        all_data: 'Alla data',
        sr_urgent: 'Brådskande',
        n_per_page: '[[TOK_1]] / sida',
        select_user_placeholder: '-- Välj användare --',
        field_required: 'Detta fält är obligatoriskt',
        results_found: 'resultat hittade',
        select_placeholder: '-- Välj --',
        unknown_user: 'Okänd användare',
        export_csv: 'Exportera CSV',
        not_applicable: 'Ej tillämpligt',
        aria_overdue_since: 'Försenad sedan {date}',
        placeholders: {
            enter_justification: 'Ange motivering',
            justification: 'Motivering',
            campaign_name_example: 'Q1 2026 Åtkomst Granskning',
            optional_description: 'Valfritt beskrivning',
            enter_user_id: 'Ange granskarens användar-ID',
            enter_user_id_short: 'Ange användare ID',
            schedule_name_example: 'Kvartalsvis åtkomstattestering',
            enter_property_id: 'Ange egenskap ID',
            enter_policy_id: 'Ange policy-ID',
            property_or_group_id: 'Egenskap eller grupp ID',
            describe_template_purpose: 'Beskriv the mall syfte...',
            step_title: 'Steg titel...',
            detailed_instructions: 'Detaljerad instruktioner...',
            filter_by_taxonomy_id: 'Filter per Taxonomi ID...',
            describe_classification_rule: 'Beskriv klassificeringsregeln...',
            describe_dedup_rule: 'Beskriv dedupliceringsregeln...',
            describe_import_template: 'Beskriv the importera mall...',
            reason_for_rejection: 'Anledning till avvisning...',
            jurisdiction_codes_example: 'VN, SG, EU',
            filter_by_locale: 'Filter per språkinställning...',
            filter_by_event_type: 'Filter per händelse typ',
            filter_by_actor_id: 'Filtrera per aktörs-ID',
            filter_by_market_code: 'Filter per marknad kod...',
            filter_by_framework_id: 'Filter per ramverk ID...',
            add_comment: 'Add en kommentar...',
            provide_rejection_reason: 'Ange en anledning för att avvisa denna inskickning...',
            filter_by_jurisdiction: 'Filtrera per jurisdiktionskod...',
            enter_report_title: 'Ange rapport titel',
            enter_name: 'Ange namn',
            enter_description: 'Ange beskrivning',
            enter_org_id: 'Ange Org ID to lägg till',
            describe_evidence_gap: 'Beskriv the bevis brist...',
            expected_evidence: 'Vilka bevis förväntas',
            entity_identifier: 'Entitet identifierare',
            remediation_steps: 'Steg för att åtgärda denna brist',
            user_id_or_name: 'Användare ID eller namn',
            reporting_period_id: 'Rapporteringsperiod-ID',
            maturity_model_id: 'Mognad modell ID',
            describe_maturity_model: 'Beskriv denna mognadsmodell...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Ange en anledning för att neka denna begäran',
            describe_emergency: 'Beskriv nödsituationen som kräver förhöjd åtkomst (minst 20 tecken)',
            enter_delegate_id: 'Ange användare ID of the delegera',
            provide_delegation_reason: 'Ange en anledning för denna delegering',
            client_identifier: 'Klient identifierare',
            client_secret: 'Klient hemlighet',
            time_format: 'TT:MM',
            describe_sod_rule: 'Beskriv syftet med denna SoD-regel...',
            enter_role_id: 'Ange roll-ID',
            explain_exception: 'Förklara varför detta undantag behövs...',
            describe_compensating_controls: 'Beskriv kompenserande kontroller...',
            full_name: 'Fullständig namn',
            min_chars: 'Min 12 tecken',
            enter_override_justification: 'Ange motivering för att åsidosätta denna grindsutvärdering',
            enter_evidence_id: 'Ange bevis-ID för att länka:',
            date_format: 'DD/MM/ÅÅÅÅ',
            describe_pack_contents: 'Beskriv paketets innehåll och syfte',
            select_reviewers: 'Välj granskare...',
        },
        aria_previous_page: 'Föregående sida',
        aria_next_page: 'Nästa sida',
        aria_results_per_page: 'Resultat per sida',
        per_page_25: '25/sida',
        per_page_50: '50/sida',
        per_page_100: '100/sida',
        select_language: 'Välj språk',
        today: 'Idag',
        tomorrow: 'Imorgon',
        dashboard_load_error: 'Kunde inte ladda instrumentpanelen. Försök igen.',
        enum_grade: {
            red: 'Röd',
            amber: 'Amber',
            yellow: 'Gul',
            green: 'Grönt',
        },
        enum_severity: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medium',
            low: 'Låg',
        },
        enum_priority: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medium',
            low: 'Låg',
        },
        enum_status: {
            pending: 'Väntande',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            blocked: 'Blockerad',
            escalated: 'Eskalerad',
            cancelled: 'Avbruten',
            overdue: 'Försenad',
            not_started: 'Inte startat',
            new: 'Nytt',
            open: 'Öppna',
            closed: 'Stängt',
            acknowledged: 'Erkänt',
            resolved: 'Löst',
        },
        enum_department: {
            unassigned: 'Otilldelad',
        },
        enum_form_category: {
            assessment: 'Bedömning',
            assessment_report: 'Bedömningsrapport',
            dpia: '[[TOK_0]]',
            authority_submission: 'Myndighetsinlämning',
            cross_border_transfer: 'Överföring över gränserna',
            vendor: 'Försäljare',
            breach: 'Brott',
            consent: 'Samtycke',
            governance: 'Styrning',
            register: 'Registrera dig',
            monitoring: 'Övervakning',
            dpa: 'DPA',
            dsr: 'DSR',
            privacy: 'Sekretess',
            incident: 'Incident',
            org: 'Organisation',
            sector: 'Sektor',
            classification: 'Klassificering',
            discovery: 'Upptäckt',
        },
        enum_module: {
            rights_requests: 'Rättighetsbegäranden',
            assessments: 'Bedömningar',
            incidents: 'Incidenter',
            incident_ops: 'Incident Ops',
            monitoring: 'Övervakning',
            vendor_risk: 'Leverantörsrisk',
            governance: 'Styrning',
            deletion_orchestration: 'Radering',
            access_review: 'Åtkomstgranskning',
            consent: 'Samtycke',
            consent_properties: 'Samtyckesegenskaper',
            forms: 'Blanketter',
            localization: 'Lokalisering',
            program_governance: 'Programstyrning',
            privacy_scanner: 'Sekretessskanner',
            classification: 'Klassificering',
            discovery: 'Upptäckt',
            manual: 'Manuell',
            data_mapping: 'Datakartläggning',
        },
        enum_risk_level: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medium',
            low: 'Låg',
        },
        enum_request_type: {
            all: 'All',
            access: 'Åtkomst ([[TOK_0]])',
            deletion: 'Radering',
            correction: 'Rättelse',
            objection: 'Invändning',
            portability: 'Bärbarhet',
            restriction: 'Begränsning',
            consent_withdrawal: 'Återkallande av samtycke',
        },
        enum_locale: {
            en: 'engelska',
            vi: 'vietnamesiska',
            all: 'Båda',
        },
        enum_event_type: {
            case_created: 'Ärende skapat',
            status_changed: 'Status ändrad',
            case_assigned: 'Fall tilldelat',
            note_added: 'Anmärkning tillagd',
            attachment_added: 'Bilaga tillagd',
            attachment_deleted: 'Bilaga raderad',
            reference_added: 'Referens tillagd',
            checklist_updated: 'Checklista uppdaterad',
            identity_verified: 'Identitet verifierad',
            closure_summary_added: 'Sammanfattning av stängning',
            approval_granted: 'Godkännande beviljat',
            template_applied: 'Mall tillämpad',
            export_generated: 'Export genererad',
            sla_warning: '[[TOK_0]] Varning',
            sla_overdue: '[[TOK_0]] Försenad',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Borttagen',
        draft: 'Utkast',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        pending: 'Väntande',
        in_progress: 'Pågående',
        completed: 'Slutförd',
        archived: 'Arkiverad',
        published: 'Publicerad',
        approved: 'Godkänd',
        rejected: 'Avvisad',
        cancelled: 'Avbruten',
        blocked: 'Blockerad',
        deferred: 'Uppskjuten',
        not_started: 'Ej Påbörjad',
        dismissed: 'Avfärdad',
        failed: 'Misslyckad',
        in_review: 'I Granskning',
        deprecated: 'Utfasad',
        scheduled: 'Schemalagd',
        deploying: 'Distribuerar',
        deployed: 'Distribuerad',
        paused: 'Pausad',
        rolled_back: 'Tillbakarullad Tillbaka',
        received: 'Mottagen',
        processing: 'Bearbetar',
        under_assessment: 'Under bedömning',
        implemented: 'Genomförd',
        pending_approval: 'Väntande Godkännande',
        pending_deletion: 'Väntande Radering',
        on_hold: 'På Spärr',
        deleted: 'Borttagen',
        expired: 'Utgångna',
        outdated: 'Föråldrad',
        drifted: 'Avvikande',
        decommissioned: 'Avvecklad',
        match: 'Matchning',
        different: 'Annorlunda',
        missing: 'Saknade',
        confirmed: 'Bekräftad',
        revoked: 'Återkallad',
        escalated: 'Eskalerad',
        system: 'Systemet',
        custom: 'Anpassad',
        warning: 'Varning',
        blocking: 'Blockerande',
        analyst: 'Analytiker',
        viewer: 'Visare',
        daily: 'Dagligen',
        weekly: 'Veckovis',
        policies: 'Policyer',
        denied: 'Nekad',
        verified: 'Verifierad',
        detected: 'Upptäckt',
        ignored: 'Ignorerade',
        open: 'Öppna',
        resolved: 'Löst',
        suspended: 'Avstängd',
        retired: 'Pensionerad',
        review: 'Granska',
        generated: 'Genererad',
        exported: 'Exporterad',
    },
    severity: {
        low: 'Låg',
        medium: 'Medel',
        high: 'Hög',
        critical: 'Kritisk',
    },
    sensitivity: {
        standard: 'Standardnivå',
        sensitive: 'Känslig',
        special_category: 'Särskild Kategori',
        badge_sensitive: 'Känslig',
    },
    change_types: {
        policy_update: 'Policy Uppdatering',
        new_binding: 'Ny Bindning',
        remove_binding: 'Ta bort Bindande',
        configuration_change: 'Konfiguration Ändrings',
        banner_update: 'Banner Uppdatera',
    },
    comparison_types: {
        full: 'Fullständig',
        banner_only: 'Banner Endast',
        purposes_only: 'Syften Endast',
        legal_bases_only: 'Endast rättsliga grunder',
        consent_settings: 'Samtycke Indstillinger',
    },
    lifecycle_stages: {
        active: 'Aktiv',
        archived: 'Arkiverad',
        pending_deletion: 'Väntande Radering',
        deleted: 'Borttagen',
        on_hold: 'På Spärr',
    },
    object_types: {
        personal_data: 'Personuppgifter',
        consent_record: 'Samtycke Post',
        user_account: 'Användare Konto',
        audit_log: 'Revision Logg',
        document: 'Dokument',
        backup: 'Säkerhetskopia',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Beslut om adekvans',
        standard_contractual_clauses: 'Standardavtalsklausuler',
        binding_corporate_rules: 'Bindande företagsregler',
        explicit_consent: 'Uttryckligt Samtycke',
        public_interest: 'Offentlig Intresse',
        legal_claims: 'Juridiska anspråk',
        vital_interests: 'Vitala intressen',
    },
    risk_categories: {
        data_breach: 'Data Intrång',
        unauthorized_access: 'Obehörig Åtkomst',
        data_loss: 'Data Förlust',
        regulatory_non_compliance: 'Regulatorisk Bristande efterlevnad',
        third_party_risk: 'Tredjepartsts Risk',
        operational: 'Operativ',
        technical: 'Teknisk',
        legal: 'Juridisk',
    },
    mitigation_types: {
        technical: 'Teknisk',
        organizational: 'Organisatorisk',
        contractual: 'Kontraktsenlig',
        procedural: 'Processuell',
    },
    safeguard_types: {
        encryption_in_transit: 'Kryptering i transit',
        encryption_at_rest: 'Kryptering i vila',
        access_controls: 'Åtkomstkontroller',
        contractual_clauses: 'Avtalsklausuler',
        data_minimization: 'Dataminimering',
        pseudonymization: 'Pseudonymisering',
        audit_rights: 'Revisionsrättigheter',
        breach_notification: 'Avisering om intrång',
        data_localization: 'Datalokalisering',
        other: 'Annat',
    },
    scoring_methods: {
        weighted_average: 'Viktat genomsnitt',
        simple_average: 'Enkelt genomsnitt',
        maximum: 'Maximalt',
        manual: 'Manuell',
    },
    dpa_status: {
        not_required: 'Ej Nödvändigt',
        required: 'Krävs',
        in_progress: 'Pågående',
        completed: 'Slutförd',
        signed: 'Signerat',
    },
    disposal_methods: {
        anonymize: 'Anonymisera',
        pseudonymize: 'Pseudonymisera',
        aggregate: 'Aggregera',
        delete: 'Radera',
    },
    dashboard: {
        title: 'Översikt',
        no_data: 'Ingen översiktsdata tillgänglig.',
        no_data_heading: 'Ingen realtidsdata ännu',
        no_data_detail: 'Widgetarna nedan visar layouten. Data fylls i när backend är ansluten till databasen.',
        consent_coverage: 'Samtyckestäckning',
        ctia_filings: 'CTIA-anmälningar',
        next_dpia_review: 'Nästa DPIA-granskning',
        next_review_none: 'Ingen schemalagd',
        incident_mps_filings: 'MPS-anmälningar för incident',
        compliance_score: 'Efterlevnadspoäng',
        grade: 'Betyg',
        no_score: 'Ingen efterlevnadspoäng beräknad ännu.',
        rights_requests: 'Begäran om Rättigheter',
        open: 'Öppna',
        sla_breached: 'SLA Överskriden',
        sla_approaching: 'SLA Närmar sig',
        closed_month: 'Stängda (Månad)',
        incidents: 'Incidenter & Dataintrång',
        active: 'Aktiva',
        breaches: 'Dataintrång',
        overdue_tasks: 'Försenade Uppgifter',
        breach_72h_notice: '72-timmars regulatorisk anmälningsfrist gäller för aktiva överträdelser',
        recommendations: 'Rekommendationer',
        take_action: 'Vidta åtgärder',
        drift_events: 'Avvikelser & Godkännanden',
        open_events: 'Öppna Händelser',
        pending_approvals: 'Väntande Godkännanden',
        monitoring: 'Övervakningsuppgifter',
        programs: 'Program',
        overdue: 'Försenade',
        pending: 'Väntande',
        ric_cases: 'Tillsynsärenden',
        coverage: 'Datatäckning',
        systems: 'System',
        activities: 'Behandlingar',
        vendors: 'Leverantörer',
        dpias: 'Konsekvensbedömningar',
        open_gaps: 'öppna brister',
        view_as_table: 'Visa som tabell',
        view_as_chart: 'Visa som diagram',
        table_metric_header: 'Matetal',
        table_value_header: 'Varde',
        announce_chart_view: 'Visar diagramvy',
        announce_table_view: 'Visar tabellvy',
        section_core_metrics: 'Karnmatetal',
        section_task_management: 'Uppgiftshantering',
        section_compliance_insights: 'Efterlevnadsinsikter',
        configure_dashboard: 'Konfigurera instrumentpanel',
        config_col_active: 'Aktiv',
        config_col_widget: 'Widget',
        collapse_section: 'Foll ihop',
        expand_section: 'Expandera',
        reset_to_defaults: 'Återställ till standard',
        preferences_saved: 'Instrumentpanelens inställningar sparade',
        preferences_reset: 'Instrumentpanelen återställd till rollstandard',
        preferences_load_error: 'Kunde inte läsa in instrumentpanelens inställningar',
        factor_avg_system_score: 'Genomsnittlig systempoäng',
        factor_avg_vendor_score: 'Genomsnittlig leverantörspoäng',
        factor_processing_coverage: 'Bearbetningsaktivitet täckning',
        factor_ropa_completeness: 'RoPA fullständighet',
        factor_drift_penalty: 'Drifthändelser straff',
        rec_improve_system_gov: 'Förbättra systemstyrningsdokumentationen',
        rec_improve_vendor_gov: 'Förbättra leverantörsstyrningsdokumentationen',
        rec_document_processing: 'Dokumentbehandlingsaktiviteter för avtäckta system',
        rec_generate_ropa: 'Generera RoPA-poster för aktiva bearbetningsaktiviteter',
        rec_resolve_drift: 'Lös öppna kritiska och allvarliga drifthändelser',
        score_good: 'Bra',
        score_fair: 'Godkänd',
        score_poor: 'Dålig',
        score_critical: 'Kritisk',
        drag_to_reorder: 'Dra för att ordna om',
        widget_moved: 'Widget flyttad',
        press_space_to_grab: 'Tryck på mellanslag för att greppa, piltangenter för att flytta, mellanslag för att släppa',
        reorder_instructions: 'Använd dra och släpp eller tangentbordsgenvägar för att ordna om widgetar',
        task_widgets: {
            tasks_overview: 'Uppgifter Översikt',
            pending: 'Väntar',
            in_progress: 'Pågår',
            overdue: 'Försenad',
            done_7d: 'Klar (7d)',
            by_priority: 'Efter prioritet',
            view_all_tasks: 'Visa alla uppgifter',
            upcoming_tasks: 'Kommande uppgifter (kommande 7 dagarna)',
            no_upcoming: 'Inga uppgifter kommer att ske under de kommande 7 dagarna.',
            view_calendar: 'Visa kalender',
            overdue_alerts: 'Försenad',
            no_overdue: 'Inga försenade uppgifter. Allt är på rätt spår.',
            assigned_to: 'Tilldelad till',
            view_all_overdue: 'Visa alla försenade',
            notifications: 'Senaste meddelanden',
            unread: 'unread',
            no_notifications: 'Inga aviseringar. Ni är alla ikapp!',
            view_all_notifications: 'Visa alla aviseringar',
            load_error: 'Kunde inte ladda data.',
            day_late: 'dag sent',
            days_late_plural: 'dagar för sent',
            due_today: 'Förfaller idag',
            just_now: 'just nu',
            minutes_short: 'm',
            hours_short: 'h',
            days_short: 'd',
            cross_org_stats: 'Statistik över organisationer',
            by_organization: 'Efter organisation',
            overdue_across_orgs: 'förfallna uppgifter mellan organisationer',
            total: 'Totalt',
            tasks: 'tasks',
            organization: 'Organisation',
            current_org: 'Nuvarande organisation',
            all_orgs: 'Alla organisationer',
            all_organizations: 'Alla organisationer',
            filter_by_org: 'Filtrera efter organisation',
            cross_org: 'Cross-org',
            empty_calendar: 'Inga uppgifter för denna period. Skapa din första uppgift eller kontrollera dina filter.',
            empty_my_tasks: 'Du har inga uppgifter tilldelade. Bra jobbat!',
            empty_overdue: 'Inga försenade uppgifter. Allt är på rätt spår.',
            empty_notifications: 'Inga aviseringar. Ni är alla ikapp!',
            empty_workflows: 'Inga arbetsflöden har konfigurerats. Bläddra bland mallar för att komma igång.',
        },
        my_tasks_widget: {
            title: 'Mina Uppgifter',
            no_tasks: 'Inga uppgifter tilldelade till dig.',
            load_error: 'Kunde inte läsa in uppgifter.',
            overdue: 'försenad',
            remaining: 'kvar',
            view_all: 'Visa Alla Uppgifter',
        },
        my_section_status_widget: {
            title: 'Min Sektionsstatus',
            overall_completion: 'Totalt',
            sections_count: 'Sektioner',
            no_sections: 'Inga sektioner tilldelade till din avdelning.',
            load_error: 'Kunde inte läsa in sektionsstatus.',
        },
        revision_requests_widget: {
            title: 'Revisionsförfrågningar',
            no_revisions: 'Inga revisionsförfrågningar. Alla sektioner är på rätt spår.',
            load_error: 'Kunde inte läsa in revisionsförfrågningar.',
        },
        consent_summary: {
            title: 'Samtycke',
            active: 'Aktiv',
            withdrawn_30d: 'Återkallad (30d)',
            expiring_7d: 'Utgår (7d)',
        },
        transfer_assessments: {
            title: 'Överföringsbedömningar',
            open: 'Öppna',
            approved: 'Godkänd',
            gaps_flagged: 'Luckor flaggade',
        },
        breach_notifications: {
            title: 'Aviseringar om brott',
            deadline_72h: '72h deadline',
            submitted: 'Inlämnad',
            pending: 'Väntar',
        },
        authority_requests: {
            title: 'Myndighetsförfrågningar',
            pending: 'Väntar',
            overdue: 'Försenad',
            responded_30d: 'Svarade (30d)',
        },
        data_subjects_widget: {
            title: 'registrerade',
            total: 'Totalt',
            high_risk: 'Hög risk',
            active_30d: 'Aktiv (30d)',
        },
        audit_activity_summary: {
            title: 'Revisionsaktivitet',
            events_today: 'Händelser idag',
            events_7d: 'Händelser (7d)',
            unique_actors_30d: 'Unika skådespelare (30d)',
        },
        onboarding_progress: {
            title: 'Onboarding Framsteg',
            completion_pct: 'Komplett',
            status_label: 'Status',
            current_step: 'Aktuellt steg',
            status: {
                in_progress: 'Pågår',
                completed: 'Avslutad',
                skipped: 'Hoppade över',
                not_started: 'Inte startat',
            },
        },
        sector_overlay_reports_due: {
            title: 'Sektorrapporter med kommande deadline',
        },
        persona_widgets: {
            framework_filter: 'Filtrera efter ramverk',
            all_frameworks: 'Alla ramverk',
            filing_lifecycle: 'Inlämningslivscykel',
            filing_pipeline: 'Inlämningspipeline',
            draft: 'Utkast',
            internal_review: 'Intern granskning',
            approved: 'Godkänd',
            submitted: 'Inlämnad',
            supplement_requested: 'Tillägg begärs',
            resubmitted: 'Skickat på nytt',
            accepted: 'Godkänd',
            rejected: 'Avvisad',
            closed: 'Stängt',
            deadline: 'Deadline',
            days_remaining: 'dagar kvar',
            days_overdue: 'dagar försenade',
            no_filings: 'Inga aktiva inlämningar.',
            department_consolidation: 'Avdelningskonsolidering',
            departments_completed: 'Avdelningar slutförda',
            departments_pending: 'Avdelningar väntande',
            departments_overdue: 'Avdelningar försenade',
            no_consolidation_cases: 'Inga tväravdelningsärenden pågår.',
            vendor_risk: 'Leverantörs- och tredjepartsrisk',
            pending_assessment: 'Väntande bedömning',
            overdue_questionnaires: 'Försenade enkäter',
            dpa_review_queue: 'DPA-granskningskö',
            risk_distribution: 'Riskfördelning',
            total_vendors: 'Totala leverantörer',
            by_risk_level: 'Efter risknivå',
            no_vendor_data: 'Inga leverantörsriskdata tillgängliga.',
            discovery_summary: 'Upptäckt av data',
            discovery_classification: 'Dataupptäckt och klassificering',
            active_scans: 'Aktiva skanningar',
            labels_pending: 'Etiketter väntar på granskning',
            exceptions_unresolved: 'Undantag olösta',
            pending_review: 'Väntande granskning',
            exceptions: 'Undantag',
            approved_labels: 'Godkända etiketter',
            total_classified: 'Totalt klassificerat',
            no_discovery_data: 'Inga upptäcktsdata tillgängliga.',
            ai_governance: 'AI-systemstyrning',
            systems_inventory: 'System i inventering',
            systems_in_inventory: 'System i inventariet',
            classification_breakdown: 'Klassificeringsfördelning',
            dossier_completion: 'Dossierfärdigställande',
            by_classification: 'Efter klassificering',
            labeling_status: 'Etiketteringsstatus',
            not_started: 'Inte påbörjad',
            no_ai_data: 'Inga AI-styrningsdata tillgängliga.',
            breach_response: 'Intrångs- och incidentrespons',
            active_breaches: 'Aktiva intrång',
            notification_status: 'Aviseringsstatus',
            remediation_progress: 'Åtgärdsframsteg',
            supplement_loops: 'Kompletteringsloopar',
            no_breach_data: 'Inga aktiva intrångsärenden.',
            audit_readiness: 'Revisions- och bedömningsberedskap',
            assessments: 'Bedömningar',
            gap_findings: 'Bristfynd',
            evidence_completion: 'Bevisfärdigställande',
            export_ready: 'Redo för export',
            not_ready: 'Inte redo',
            no_audit_data: 'Inga revisionsberedskapsdata tillgängliga.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Cyberskerhet 2018',
            framework_label_vn_ecommerce: 'VN E-handel 2023',
            framework_label_vn_telecom: 'VN Telekommunikation 2023',
            framework_label_vn_ai: 'VN AI-lag 2025',
            framework_label_gdpr: 'GDPR',
            framework_label_unspecified: 'Ospecificerat',
            my_department: 'Min avdelning',
            my_tasks: 'Mina uppgifter',
            section_status: 'Avsnittsstatus',
            revision_requests: 'Revisionsförfrågningar',
            completion: 'Färdigställande',
            reason: 'Anledning',
            requested_at: 'Begärd den',
            no_tasks_assigned: 'Inga uppgifter tilldelade dig.',
            no_sections: 'Inga avsnitt tilldelade din avdelning.',
            no_revisions: 'Inga revisionsförfrågningar.',
            load_error: 'Det gick inte att ladda data.',
        },
    },
    connectors: {
        nav: {
            instances: 'Instanser',
            credentials: 'Autentiseringsvalv',
            event_bus: 'Händelsebuss',
            definitions: 'Definitioner',
            brds: 'BRD-insamling',
            security_reviews: 'Säkerhetsgranskningar',
            poc_scorecards: 'POC-styrkort',
            automation_planning: 'Automatiseringsplanering',
            system_inventory: 'Systeminventering',
            traceability_matrix: 'Spårbarhetsmatris',
            gap_register: 'Gap-register',
        },
        instances: {
            title: 'Anslutningsinstanser',
            page_title: 'Anslutningar',
            add: 'Lägg till Instans',
            test: 'Testa Anslutning',
            sync_now: 'Synkronisera Nu',
            new_instance: 'Ny Koppling Instans',
            no_instances: 'Inga koppling instanser hittades',
            instance_count: '{count} instans(er)',
            confirm_delete: 'Radera kopplingsinstans "{name}"?',
            all_connector_types: 'Alla Koppling Typer',
            select_connector: 'Välj en koppling...',
            fetch_error: 'Kunde inte hämta kopplingsinstanser. Försök igen.',
            fetch_definitions_error: 'Kunde inte hämta kopplingsdefinitioner. Försök igen.',
            create_error: 'Kunde inte skapa kopplingsinstans',
            test_error: 'Kunde inte testa koppling. Försök igen.',
            status_error: 'Kunde inte uppdatera kopplingsstatus. Försök igen.',
            delete_error: 'Kunde inte radera kopplingsinstans. Försök igen.',
        },
        credentials: {
            title: 'Autentiseringsvalv',
            page_title: 'Anslutningsuppgifter',
            add: 'Lägg till Autentisering',
            rotate: 'Rotera',
            expired: 'Utgången',
            expiring: 'Snart Utgående',
            orphaned: 'Föräldralös',
            new_credential: 'Ny Autentiseringsuppgift',
            no_credentials: 'Inga credentials hittades',
            no_expiry: 'Inga förfallodatum',
            linked_connectors: 'Länkade Kopplingar',
            expires_at: 'Utgår den',
            value_label: 'Värde * (skrivskyddad)',
            confirm_delete_title: 'Bekräfta radering',
            confirm_delete_message: 'Radera denna autentiseringsuppgift? Länkade anslutningar förlorar åtkomst.',
            rotate_title: 'Rotera autentiseringsuppgift',
            new_credential_value: 'Nytt autentiseringsuppgiftsvärde',
            fetch_error: 'Kunde inte ladda autentiseringsuppgifter. Försök igen.',
            health_error: 'Kunde inte ladda hälsa. Försök igen.',
            create_error: 'Kunde inte skapa autentiseringsuppgifter',
            rotate_error: 'Kunde inte rotera autentiseringsuppgifter',
            delete_error: 'Kunde inte radera autentiseringsuppgifter',
        },
        event_bus: {
            title: 'Händelsebuss',
            page_title: 'Händelsebuss',
            events: 'Händelser',
            subscriptions: 'Prenumerationer',
            dlq: 'Kö för Misslyckade Meddelanden',
            publish: 'Publicera Händelse',
            retry: 'Försök igen',
            dismiss: 'Avfärda',
            search_events: 'Sök händelser...',
            filter_event_type: 'Filter per händelse typ...',
            event_type: 'Händelse Typ',
            source_module: 'Källa Modul',
            timestamp: 'Tidsstämpel',
            delivery_status: 'Leverans Status',
            correlation_id: 'Korrelation ID',
            tracking_id: 'Spårnings-ID',
            delivery_status_hint: 'Leveransstatus uppdateras automatiskt allteftersom händelser bearbetas.',
            no_events: 'Inga händelser hittades',
            total_with_count: '{count} totalt',
            prev: 'Föregående',
            new_subscription: '+ Ny prenumeration',
            subscriber_type: 'Prenumerant Typ',
            subscriber_id: 'Prenumerant ID',
            event_type_pattern: 'Händelse Typ Mönster',
            event_type_pattern_placeholder: 't.ex. incident.*',
            filter_expression: 'Filter Uttryck',
            filter_expression_placeholder: 'Valfritt filter',
            subscriber_type_hint: 'Välj hur händelser levereras: webhook skickar HTTP-förfrågningar, e-post skickar aviseringar, kö dirigerar till en meddelandekö.',
            subscriber_id_hint: 'Ange destinationen för händelser. För webhooks, använd en URL. För e-post, använd en adress. För köer, använd könamnet.',
            event_type_pattern_hint: 'Matcha händelser efter typ med jokertecken. Använd * för att matcha valfritt segment (t.ex. incident.* matchar incident.created, incident.resolved).',
            filter_expression_hint: 'Valfritt. Filtrera händelser ytterligare efter innehåll (t.ex. severity=high).',
            subscriber_id_placeholder_webhook: 't.ex. https://din-app.com/webhook',
            subscriber_id_placeholder_email: 't.ex. larm@ditt-foretag.com',
            subscriber_id_placeholder_queue: 't.ex. handelse-ko',
            event_pattern: 'Händelse Mönster',
            filter: 'Filtrera',
            enabled: 'Aktiverad',
            delivery_stats: 'Leverans Statistik',
            no_subscriptions: 'Inga prenumerationer hittades',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} levererade / {failed} misslyckade',
            confirm_delete_subscription: 'Radera denna prenumeration?',
            unresolved: 'Olöst',
            resolved: 'Löst',
            event_id: 'Händelse ID',
            subscription_id: 'Prenumeration ID',
            error_code: 'Fel Kod',
            error_message: 'Fel Meddelande',
            attempts: 'Försök',
            last_failed: 'Senaste Misslyckade',
            no_dlq_entries: 'Inga döda brev poster hittades',
            dlq_count: '{count} post(er) totalt',
            fetch_events_error: 'Kunde inte hämta händelser. Försök igen.',
            fetch_subscriptions_error: 'Kunde inte hämta prenumerationer. Försök igen.',
            fetch_dlq_error: 'Kunde inte hämta DLQ-poster. Försök igen.',
            create_subscription_error: 'Kunde inte skapa prenumeration',
            toggle_subscription_error: 'Kunde inte växla prenumeration',
            delete_subscription_error: 'Kunde inte radera prenumeration',
            retry_error: 'Omförsök misslyckade',
            dismiss_error: 'Avfärda misslyckade',
            event_published: 'Händelse publicerad',
            publish_event_error: 'Kunde inte publicera händelsen. Försök igen.',
            priority_label: 'Prioritet',
            priority_low: 'Låg',
            priority_normal: 'Normal',
            priority_high: 'Hög',
            payload_helper_text: 'Ange händelsedata som JSON. Exempel: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Prenumeration skapad',
            subscription_toggled: 'Prenumeration växlade',
            subscription_deleted: 'Prenumeration raderad',
            dlq_retried: 'DLQ-meddelande försökte igen',
            dlq_dismissed: 'DLQ-meddelande avvisades',
        },
        definitions: {
            title: 'Anslutningsdefinitioner',
            page_title: 'Anslutnigsdefinitioner',
            add: 'Lägg till definition',
            new_definition: 'Ny anslutningsdefinition',
            edit_definition: 'Redigera anslutningsdefinition',
            no_definitions: 'Inga anslutningsdefinitioner hittades',
            definition_count: '[[TOK_1]] definition(er)',
            all_categories: 'Alla kategorier',
            select_category: 'Välj en kategori...',
            capabilities: 'Förmågor',
            capabilities_hint: 'Funktioner (kommaseparerade)',
            capabilities_placeholder: 't.ex. läsa, skriva, synkronisera',
            created: 'Anslutningsdefinition skapad',
            updated: 'Anslutningsdefinitionen uppdaterad',
            fetch_error: 'Det gick inte att hämta anslutningsdefinitioner. Försök igen.',
            create_error: 'Det gick inte att skapa anslutningsdefinition',
            update_error: 'Kunde inte uppdatera anslutningsdefinition',
        },
        brds: {
            title: 'BRD-insamling',
            page_title: 'BRD-registrering',
            create_brd: 'Skapa BRD',
            brd_title: 'BRD-titel',
            description: 'Beskrivning',
            requirements: 'Krav',
            status: 'Status',
            stakeholders: 'Intressenter',
            connector_label: 'Anslutning',
            select_connector: 'Välj en anslutning...',
            approval: 'Godkännande',
            no_brds_found: 'Inga BRD:er hittades',
            decision_records: 'Beslutsregister',
            create_decision: 'Skapa beslut',
            alternatives_considered: 'Övervägda alternativ',
            alternative_name: 'Alternativnamn',
            reason_rejected: 'Anledning till avslag',
            add_alternative: 'Lägg till alternativ',
            remove_alternative: 'Ta bort alternativ {name}',
            alternatives: 'Alternativ',
            rationale: 'Motivering',
            selected_connector: 'Vald anslutning',
            comma_separated_names: 'Kommaseparerade namn',
            brd_created: 'BRD skapad',
            decision_record_created: 'Beslutspost skapad',
            no_decision_records_found: 'Inga beslutsposter hittades',
            aria_brds_table: 'BRD:er',
            aria_decision_records_table: 'Beslutsposter',
            aria_approve: 'Godkänn {name}',
            aria_archive: 'Arkivera {name}',
            brd_title_help: 'Ett kort, mänskligt läsbart namn för denna BRD — t.ex. "Jira ticketing integration", "Okta SSO utrullning".',
            brd_title_placeholder: 't.ex. Jira biljettintegration',
            description_help: 'Affärsproblemet som denna anslutning löser. Vilket resultat förväntar du dig när det är live?',
            description_placeholder: 't.ex. Automatisera incidentbiljettskapande från övervakningsvarningar så att jourhavande blir sökt inom 60-talet.',
            connector_help: 'Valfritt. Välj en kontakt som denna BRD är till för - lämna tom om kontakten inte har valts ännu.',
            requirements_help: 'Kommaseparerad lista över nödvändiga funktioner — t.ex. "OAuth2-inloggning, webhook-leverans, revisionsexport".',
            requirements_placeholder: 'OAuth2-inloggning, webhook-leverans, revisionsexport',
            stakeholders_help: 'Kommaseparerade namn eller e-postadresser för personer som måste logga ut.',
            selected_connector_help: 'Välj den kontakt som detta beslut gäller.',
            rationale_help: 'Varför denna kontakt valdes. Täck de avgörande faktorerna så att en framtida läsare förstår uppmaningen.',
            rationale_placeholder: 't.ex. Valde Jira eftersom den redan har vår biljetthistorik och laget är utbildad på den.',
            alternatives_considered_help: 'Andra kontakter utvärderade och varför de inte valdes. Lägger till försvarbarhet för revision.',
            alternative_name_placeholder: 't.ex. ServiceNu',
            reason_rejected_placeholder: 'till exempel Kostnad 3× högre, ingen fördel för vårt användningsfall',
        },
        security_reviews: {
            title: 'Säkerhetsgranskningar',
            page_title: 'Säkerhetsgranskningar',
            create_review: 'Skapa granskning',
            connector_name: 'Anslutningsnamn',
            connector_label: 'Anslutning',
            select_connector: 'Välj en anslutning...',
            reviewer: 'Granskare',
            select_reviewer: 'Välj en granskare...',
            findings: 'Resultat (en per rad)',
            risk_level: 'Risknivå',
            risk_level_placeholder: 't.ex. hög, medel, låg',
            notes: 'Anteckningar',
            review_status: 'Granskningsstatus',
            checklist: 'Checklista',
            privacy_impact: 'Integritetspåverkan',
            approval_gate: 'Godkännandeport',
            no_reviews_found: 'Inga granskningar hittades',
            review_created: 'Säkerhetsgranskning skapad',
            create_control_mapping: 'Skapa kontrollmappning',
            control_mapping_created: 'Kontrollmappning skapad',
            connector_id_label: 'Anslutnings-ID',
            control_id_label: 'Kontroll-ID',
            control_name_label: 'Kontrollnamn',
            aria_approve: 'Godkänn {name}',
            aria_reject: 'Avvisa {name}',
            scan_imported: 'Skanning importerad',
            import_scan: 'Importera skanning',
            scan_format: 'Skanningsformat',
            scan_data: 'Skanningsdata',
            import_results: 'Importresultat',
            recommendations: 'Rekommendationer',
            auto_populated_from: 'Fylls i automatiskt från [[TOK_1]]',
            manual_entry: 'Manuell inmatning',
            automation_type: 'Automationstyp',
            select_automation_type: 'Välj automatiseringstyp...',
            automation_full: 'Full — anslutning automatiserar denna kontroll helt',
            automation_partial: 'Partiell — kontakten bidrar med bevis; människor agerar fortfarande',
            automation_monitoring: 'Endast övervakning — kontakten observerar, verkställer inte',
            control_id_help: 'Använd koden från ditt efterlevnadsschema (t.ex. ISO-27001-A.12.1, SOC2-CC6.1 eller ditt internkontroll-ID).',
            control_name_help: 'Kort mänskligt läsbart namn (t.ex. "Begränsning av nätverksåtkomst").',
            description_label: 'Beskrivning',
            load_sarif_example: 'Ladda SARIF exempel',
            load_json_example: 'Ladda anpassat [[TOK_0]] exempel',
            scan_format_help: 'SARIF är OASIS-standarden som sänds ut av de flesta skannrar (Snyk, CodeQL, Semgrep). Använd anpassad [[TOK_0]] för verktyg som inte avger SARIF.',
            scan_data_help: 'Klistra in hela skanningen, ladda upp en .sarif/.json-fil eller klicka på knappen Ladda exempel för att se formen.',
            upload_file_label: 'Ladda upp .sarif- eller .json-fil',
            invalid_scan_json: 'Kunde inte analysera skannade data som [[TOK_0]]. Kontrollera om det finns syntaxfel nära det markerade tecknet.',
            save_as_review: 'Spara som säkerhetsgranskning',
            discard_preview: 'Släng förhandsgranskningen',
            preview_hint: 'Det här är en förhandsgranskning — inget har sparats ännu. Klicka på "Spara som säkerhetsgranskning" för att skapa en väntande granskning förifylld med dessa värden.',
            reviewer_required_for_save: 'Välj en granskare för att spara den här skanningen som en säkerhetsgranskning.',
        },
        poc_scorecards: {
            title: 'POC-styrkort',
            page_title: 'POC-styrkort',
            create_scorecard: 'Skapa styrkort',
            connector_label: 'Anslutning',
            select_connector: 'Välj en anslutning...',
            vendor_name: 'Leverantörsnamn',
            recommendation: 'Rekommendation',
            recommendation_placeholder: 't.ex. Fortsätt, Fortsätt inte, Behöver ytterligare utvärdering',
            criteria: 'Utvärderingskriterier',
            criterion_name: 'Kriterienamn',
            score: 'Poäng',
            max_score: 'Max poäng',
            notes: 'Anteckningar',
            add_criterion: 'Lägg till kriterium',
            remove_criterion: 'Ta bort kriterium {name}',
            total_score: 'Totalpoäng',
            api_quality: 'API-kvalitet',
            reliability: 'Tillförlitlighet',
            support_quality: 'Supportkvalitet',
            cost_score: 'Kostnadspoäng',
            overall_score: 'Totalpoäng',
            evidence: 'Bevisning',
            no_scorecards_found: 'Inga styrkort hittades',
            scorecard_created: 'POC-styrkort skapat',
            connector_help: 'Välj den kontakt som denna POC-utvärdering är till för.',
            vendor_name_help: 'Säljaren eller produkten som utvärderas — t.ex. "Okta", "Datadog", "Snöflinga".',
            vendor_name_placeholder: 't.ex. Okta, Datadog, Snowflake',
            recommendation_help: 'Ditt sista samtal efter utvärderingen. Håll det kort och beslutsamt.',
            criteria_help: 'Betyg leverantören på varje utvärderingskriterium. Lägg till en rad per kriterium ([[TOK_0]] kvalitet, tillförlitlighet, support, kostnad, etc.).',
            criterion_name_help: 'Vad du gör poäng — t.ex. "[[TOK_0]] Kvalitet", "Tillförlitlighet", "Support", "Kostnad".',
            criterion_name_placeholder: 't.ex. [[TOK_0]] Kvalitet',
            score_help: 'Poäng tilldelas för detta kriterium. Får inte överstiga maxpoäng.',
            max_score_help: 'Högsta poäng tillgängligt för detta kriterium. Använd samma skala över raderna så att summorna är jämförbara.',
            notes_help: 'Valfritt. Lägg till bevis, varningar eller länkar - allt som förklarar poängen.',
        },
        common_labels: {
            aria_filter_instances: 'Filtrera anslutningsinstanser',
            aria_filter_definitions: 'Filtrera anslutnigsdefinitioner',
            aria_filter_credentials: 'Filtrera autentiseringsuppgifter',
            aria_filter_events: 'Filtrera händelser',
            aria_filter_dlq: 'Filtrera kö för misslyckade meddelanden',
            aria_instance_summary: 'Sammanfattning av anslutningsinstans',
            aria_active_connectors: 'Aktiva anslutningar',
            aria_error_connectors: 'Anslutningar med fel',
            aria_credential_health: 'Sammanfattning av autentiseringstatus',
            aria_items_per_page: 'Objekt per sida',
            show_password: 'Visa lösenord',
            hide_password: 'Dölj lösenord',
            payload_json_label: 'Nyttolast (JSON)',
            payload_invalid_json: 'Nyttolasten måste vara giltig JSON',
            placeholder_event_type: 't.ex. incident.created',
            placeholder_source_module: 't.ex. monitoring',
            placeholder_version: 't.ex. 1.0',
        },
        statuses: {
            configuring: 'Konfigurerar',
            testing: 'Testning',
            active: 'Aktiv',
            paused: 'Pausad',
            error: 'Fel',
            disabled: 'Inaktiverad',
            draft: 'Utkast',
            approved: 'Godkänd',
            archived: 'Arkiverad',
            pending: 'Väntar',
            rejected: 'Avvisad',
        },
        system_types: {
            application: 'Applikation',
            database: 'Databas',
            middleware: 'Mellanvara',
            infrastructure: 'Infrastruktur',
            saas: 'SaaS',
            other: 'Övrigt',
        },
        hosting_types: {
            on_premise: 'På plats',
            cloud: 'Moln',
            hybrid: 'Hybrid',
            managed: 'Hanterad',
        },
        system_statuses: {
            active: 'Aktiv',
            decommissioned: 'Avvecklad',
            planned: 'Planerad',
            under_review: 'Under granskning',
        },
        automation_statuses: {
            planning: 'Planering',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            on_hold: 'Pausad',
        },
        gap_types: {
            functional: 'Funktionell',
            technical: 'Tekniska',
            security: 'Säkerhet',
            compliance: 'Efterlevnad',
            process: 'Process',
        },
        severity_labels: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medel',
            low: 'Låg',
        },
        gap_statuses: {
            open: 'Öppen',
            in_progress: 'Pågående',
            mitigated: 'Mitigerad',
            closed: 'Stängd',
            accepted: 'Godtagen',
        },
        verification_statuses: {
            not_started: 'Ej påbörjad',
            in_progress: 'Pågående',
            verified: 'Verifierad',
            failed: 'Misslyckad',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Intern',
            email: 'E-post',
            queue: 'Kö',
        },
        credential_types: {
            password: 'Lösenord',
            api_key: 'API-nyckel',
            oauth2_client: 'OAuth2-klient',
            certificate: 'Certifikat',
            token: 'Token',
            ssh_key: 'SSH-nyckel',
            imap_credentials: 'IMAP-uppgifter',
        },
        categories: {
            hr: 'HR',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Moln',
            security: 'Säkerhet',
            itsm: 'ITSM',
            custom: 'Anpassad',
        },
        delivery_statuses: {
            pending: 'Väntande',
            delivered: 'Levererad',
            partial: 'Delvis',
            failed: 'Misslyckad',
        },
        automation_planning: {
            title: 'Automatiseringsplanering',
            page_title: 'Automatiseringsplanering',
            program_name: 'Programnamn',
            program_status: 'Status',
            description: 'Beskrivning',
            linked_artifacts: 'Länkade artefakter',
            create_program: 'Skapa program',
            edit_program: 'Redigera program',
            no_programs_found: 'Inga program hittades',
            program_created: 'Program skapat',
            program_updated: 'Program uppdaterat',
            target_date: 'Måldatum',
            owner: 'Ägare',
            select_status: 'Välj status...',
            aria_programs_table: 'Automatiseringsprogram',
            aria_edit: 'Redigera {name}',
            export_programs: 'Exportera program',
            title_label: 'Programtitel',
            title_help: 'Ett kort, mänskligt läsbart namn på automationsprogrammet — t.ex. "Q3 incident-to-Jira rollout", "[[TOK_0]] automatisering av åtkomstbegäran".',
            title_placeholder: 't.ex. Q3 incident-to-Jira lansering',
            description_help: 'Vad det här programmet omfattar och resultatet du förväntar dig när det är live. Valfritt men rekommenderas.',
            description_placeholder: 't.ex. Koppla in övervakningsvarningar till Jira så att jourhavande ringer inom 60-talet.',
            owner_label: 'Programägare',
            owner_help: 'Den person som är ansvarig för detta program. De kommer att få meddelanden om framsteg och grindar.',
            select_owner: 'Välj en ägare...',
            frameworks_in_scope: 'Ramar i omfattning',
            frameworks_in_scope_help: 'Efterlevnadsramverk som detta program stöder. Hjälper revisionsspåret att visa vilka regelverk automatiseringen styrs av.',
            select_frameworks: 'Välj ramar...',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_completed: 'Avslutad',
            status_archived: 'Arkiverad',
            change_status: 'Ändra status',
            status_updated: 'Status uppdaterad',
            aria_change_status: 'Ändra status för [[TOK_1]]',
        },
        system_inventory: {
            title: 'Systeminventering',
            page_title: 'Systeminventering',
            system_name: 'Systemnamn',
            system_type: 'Systemtyp',
            hosting: 'Värdskap',
            status: 'Status',
            description: 'Beskrivning',
            create_system: 'Skapa system',
            edit_system: 'Redigera system',
            no_systems_found: 'Inga system hittades',
            system_created: 'System skapat',
            system_updated: 'System uppdaterat',
            select_type: 'Välj typ...',
            select_hosting: 'Välj hosting...',
            select_status: 'Välj status...',
            owner: 'Ägare',
            department: 'Avdelning',
            data_categories: 'Datakategorier',
            data_categories_placeholder: 'Kommaseparerade, t.ex. PII, Financial, Health',
            jurisdiction: 'Jurisdiktion',
            jurisdiction_placeholder: 't.ex. EU, US, Global',
            interfaces: 'Gränssnitt',
            interfaces_placeholder: 'Kommaseparerade, t.ex. REST API, SFTP, JDBC',
            owner_placeholder: 'Välj en ansvarig ägare...',
            department_placeholder: 'Välj ansvarig organisationsenhet...',
            system_name_hint: 'Använd det företagskända systemet eller applikationsnamnet.',
            system_type_hint: 'Klassificera systemet så att rapportering kan gruppera liknande tillgångar.',
            hosting_hint: 'Identifiera var systemet körs för uppehållstillstånd, säkerhet och leverantörsgranskning.',
            status_hint: 'Ställ in livscykelstatus som används av granskningar, exporter och revisionsbevis.',
            owner_hint: 'Välj den aktiva användaren som är ansvarig för systemstyrning och uppföljningsuppgifter.',
            department_hint: 'Använd den organisationsenhet som ansvarar för att driva eller styra detta system.',
            data_categories_hint: 'Lista de dataklasser som behandlas av detta system, separerade med kommatecken.',
            jurisdiction_hint: 'Registrera den huvudsakliga juridiska eller värdjurisdiktionen för efterlevnadskartläggning.',
            interfaces_hint: 'Lista anslutnings- eller integrationsvägar som används för att utbyta data.',
            description_hint: 'Sammanfatta vad systemet gör och varför det är viktigt för datakartan.',
            owner_department_required: 'Ägare och avdelning krävs.',
            aria_systems_table: 'Systeminventering',
            aria_edit: 'Redigera {name}',
            export_systems: 'Exportera system',
        },
        traceability_matrix: {
            title: 'Spårbarhetsmatris',
            page_title: 'Spårbarhetsmatris',
            brd_selector: 'Välj BRD',
            requirement: 'Krav',
            linked_artifact: 'Länkad artefakt',
            verification_status: 'Verifieringsstatus',
            verified_by: 'Verifierad av',
            create_entry: 'Skapa post',
            edit_entry: 'Redigera post',
            no_entries_found: 'Inga poster hittades',
            entry_created: 'Post skapad',
            entry_updated: 'Post uppdaterad',
            select_brd: 'Välj en BRD...',
            select_status: 'Välj status...',
            aria_matrix_table: 'Spårbarhetsmatris',
            aria_edit: 'Redigera post för {name}',
            export_matrix: 'Exportera matris',
        },
        gap_register: {
            title: 'Gap-register',
            page_title: 'Gap-register',
            gap_title: 'Gap-titel',
            gap_type: 'Gap-typ',
            severity: 'Allvarlighetsgrad',
            status: 'Status',
            description: 'Beskrivning',
            remediation_plan: 'Åtgärdsplan',
            assigned_to: 'Tilldelad till',
            due_date: 'Förfallodatum',
            create_gap: 'Skapa gap',
            edit_gap: 'Redigera gap',
            no_gaps_found: 'Inga gap hittades',
            gap_created: 'Gap skapat',
            gap_updated: 'Gap uppdaterat',
            select_type: 'Välj typ...',
            select_severity: 'Välj allvarlighetsgrad...',
            select_status: 'Välj status...',
            aria_gaps_table: 'Gap-register',
            aria_edit: 'Redigera {name}',
            export_gaps: 'Exportera gap',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Ramverkskoppling',
            framework_linkage_placeholder: 't.ex. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Ramverksomfång',
            framework_scope_placeholder: 't.ex. GDPR, PCI-DSS',
            procedure_linkage: 'Procedurkoppling',
            procedure_linkage_placeholder: 't.ex. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Reglerande källa',
            regulatory_source_placeholder: 't.ex. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Kontrollmappning',
            control_mappings_section: 'Styr mappningar',
            no_control_mappings: 'Inga kontrollmappningar ännu. Klicka på "Skapa kontrollmappning" för att lägga till en.',
            automation_type_col: 'Automation',
        },
        gap_register_extra: {
            framework_filter: 'Ramverk',
            framework_id: 'Ramverks-ID',
            framework_id_placeholder: 't.ex. GDPR, ISO 27001',
            all_frameworks: 'Alla ramverk',
        },
        poc_scorecards_extra: {
            criteria_count: 'Kriterier',
        },
        export_labels: {
            export_brds: 'Exportera BRD',
            export_decision_records: 'Exportera beslutsregister',
            export_security_reviews: 'Exportera säkerhetsgranskningar',
            export_poc_scorecards: 'Exportera POC-poängkort',
            export_instances: 'Exportera instanser',
            export_definitions: 'Exportdefinitioner',
            export_credentials: 'Exportera inloggningsuppgifter',
            export_events: 'Exportera händelser',
            exporting: 'Exporterar...',
            export_success: 'Export slutförd',
            export_error: 'Export misslyckades',
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Utkast till resonemang',
            drafting: 'Förbereder resonemang...',
            results_heading: '[[TOK_2]]-utkast till resonemang ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            narrative_label: 'Motiveringsberättelse',
            controls_heading: 'Kompenserande kontroller',
            no_controls: 'Inga kompenserande kontroller föreslås.',
            citations_label: 'Citat',
            accept_label: 'Acceptera resonemang',
            reject_label: 'Avvisa utkastet',
            accept_hint: 'Accept registrerar resonemanget om det kvarstående utkastet för IAT-härstamning. Berättelsen + kontrollerna uppdaterar inte acceptansposten automatiskt – operatören måste klistra tillbaka.',
            resolve_summary: 'Upplösning: [[TOK_1]]',
            error_generic: 'Kunde inte formulera ett resonemang. Försök igen eller kontrollera riskacceptansstatus.',
        },
        redline_assistant: {
            run_label: 'Redline med bibliotek',
            running: 'Kör redline...',
            results_heading: 'Redline-förslag ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_suggestions: 'Inga luckor i standardklausulen upptäcktes.',
            jurisdiction_label: 'Jurisdiktion',
            col_kind: 'Snäll',
            col_severity: 'Allvarlighet',
            col_title: 'Förslag',
            col_excerpt: 'Matchat utdrag',
            col_apply: 'Ansök',
            kind_missing: 'Saknar standard',
            kind_weaker: 'Svagare än standard',
            kind_jurisdiction: 'Jurisdiktionsöverlägg',
            proposed_label: 'Föreslagen text',
            citations_label: 'Citat',
            accept_label: 'Acceptera valt',
            reject_label: 'Avvisa rapporten',
            partial_label: 'Tillämpa urval',
            accept_hint: 'Tillämpa urval registrerar de valda förslagen på utkastet för IAT-härstamning. Ingen automatisk redigering tillämpas på kontraktstexten – operatören kör rödlinjen.',
            resolve_summary: 'Upplösning: [[TOK_2]] · [[TOK_3]] förslag tillämpas',
            error_generic: 'Det gick inte att skapa en röd linje. Försök igen eller kontrollera kontraktets status.',
            clause_library_link: 'Hantera klausulbibliotek',
        },
        clause_library: {
            page_title: 'Klausul bibliotek',
            add_label: 'Lägg till klausul',
            edit_label: 'Redigera',
            delete_label: 'Ta bort',
            slug_label: 'Snigel',
            title_label: 'Titel',
            body_label: 'Kropp',
            jurisdiction_label: 'Jurisdiktion',
            tags_label: 'Taggar (kommaseparerade)',
            must_contain_label: 'Måste innehålla markörer (kommaseparerade)',
            severity_label: 'Allvarlighet när den saknas',
            no_clauses: 'Inga klausuler ännu. Lägg till en för att skapa redline-assistenten.',
            save_label: 'Spara',
            cancel_label: 'Avbryt',
            load_error: 'Det gick inte att läsa in satsbiblioteket.',
            save_error: 'Det gick inte att spara klausulen.',
            delete_error: 'Kunde inte ta bort klausul.',
            delete_confirm: 'Ta bort klausul "[[TOK_1]]"? Detta kan inte ångras.',
        },
        obligation_extraction: {
            extract_label: 'Extrahera skyldigheter',
            extracting: 'Extraherar...',
            results_heading: 'Extraherade förpliktelser ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_obligations: 'Inga förpliktelser har upptäckts i denna avtalstext.',
            col_class: 'Klass',
            col_summary: 'Sammanfattning (redigerbar)',
            col_excerpt: 'Klausulutdrag',
            col_due_date: 'Förfallodatum (redigerbart)',
            col_priority: 'Prioritet',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Uppsägningstid',
            class_audit: 'Revisionsrätt',
            class_insurance: 'Försäkring',
            class_sla: 'Svar [[TOK_0]]',
            class_breach: 'Avisering om brott',
            class_renewal: 'Förnyelsefönster',
            citations_label: 'Citat',
            accept_hint: 'Accept skapar en uppgift per skyldighet (tak 8) med prioritet + förfallodatum.',
            accept_label: 'Acceptera skyldigheter',
            reject_label: 'Avvisa rapporten',
            resolve_summary: 'Upplösning: [[TOK_2]] · [[TOK_3]] uppgift(er) skapade',
            error_generic: 'Kunde inte utvinna skyldigheter. Försök igen eller kontrollera kontraktstexten.',
        },
        subprocessor_impact: {
            assess_label: 'Bedöm påverkan',
            assessing: 'Bedömer effekten...',
            results_heading: 'Inverkan på underprocessor ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            risk_delta_label: 'Risk delta',
            notification_heading: 'Kundmeddelande',
            subject_label: 'Ämne',
            deadline_label: 'Tidsfrist för anmälan',
            body_label: 'Anmälningsorgan',
            required_fields_label: 'Obligatoriska fält i artikel 28(4).',
            mitigation_heading: 'Begränsande steg',
            citations_label: 'Citat',
            accept_label: 'Acceptera bedömning',
            reject_label: 'Avvisa bedömning',
            accept_hint: 'Acceptera skapar en kundaviseringsuppgift med [[TOK_0]] deadline som förfallodatum.',
            resolve_summary: 'Upplösning: [[TOK_2]][[TOK_3]]',
            error_generic: 'Det gick inte att bedöma denna ändring av underbehandlare. Försök igen eller kontrollera ändringsposten.',
        },
        onboarding_evidence: {
            collect_label: 'Kör [[TOK_0]] bevisinsamling',
            collecting: 'Samlar bevis...',
            results_heading: 'Bevisinsamling ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            findings_heading: 'Befintliga bevis',
            missing_heading: 'Saknade artefakter',
            no_findings: 'Inga befintliga bevis upptäcktes.',
            no_missing: 'Inga obligatoriska artefakter saknas för denna risknivå.',
            next_step_label: 'Nästa steg',
            class_dpa: 'Databehandlingsavtal',
            class_soc2: 'SOC 2-rapport',
            class_iso27001: 'ISO 27001-certifikat',
            class_insurance: 'Cyberförsäkring',
            class_incident_history: 'Tidigare incident',
            accept_hint: 'Acceptera skapar uppgifter för varje saknad artefakt (högst 5). Resultaten förblir utkast tills du bifogar dem som bevis.',
            accept_label: 'Acceptera rapporten',
            reject_label: 'Avvisa rapporten',
            resolve_summary: 'Upplösning: [[TOK_2]] · [[TOK_3]] uppgift(er) skapade',
            error_generic: 'Could not run [[TOK_0]] evidence collection. Try again or check the onboarding case status.',
        },
        no_permission_title: 'Otillräckliga behörigheter',
        no_permission_message: 'Du har inte behörighet att komma åt leverantörsriskhantering.',
        unknown_vendor: 'Okänd säljare',
        nav: {
            dashboard: 'Risköversikt',
            scoring: 'Riskbedömning',
            questionnaires: 'Frågeformulär',
            contracts: 'Avtal',
            gates: 'Godkännandegrindar',
            reviews: 'Leverantörsgranskningar',
            signals: 'Risksignaler',
            reassessments: 'Omvärderingar',
            portfolio: 'Riskportfölj',
            acceptances: 'Riskacceptans',
            review_routing: 'Granskningsdirigering',
            onboarding_cases: 'Onboarding-ärenden',
            sub_processor_register: 'Register över underbiträden',
        },
        dashboard: {
            title: 'Leverantörsrisköversikt',
            page_title: 'Översikt för leverantörsrisk',
            loading: 'Laddar instrumentpanelsdata...',
            risk_tier_header: 'Risknivå',
            count_header: 'Räkna',
            percentage_header: 'Procentandel',
            sections_nav: 'Sektioner för säljarrisk',
            urgent_expiry: 'Brådskande: löper ut inom 14 dagar',
            no_previous_tier: 'Ingen tidigare nivå',
            view_as_chart: 'Visa som diagram',
            view_as_table: 'Visa som tabell',
            showing_chart: 'Visar diagramvy',
            showing_table: 'Visar datatabellvy',
            load_error: 'Kunde inte ladda leverantörsriskinstrumentpanel',
            risk_distribution: 'Risikofordelingsoversigt',
            recent_tier_changes: 'Senaste Nivå Ändringar',
            no_tier_changes: 'Inga senaste nivåändringar.',
            review_kpis: 'Granskning KPI:er',
            total_vendors_reviewed: 'Totalt antal granskade leverantörer',
            reviews_by_outcome: 'Granskningar per Utfall',
            contract_coverage: 'Kontrakt Täckning',
            total_vendors: 'Totalt Leverantörer',
            with_active_dpa: 'Med Aktiva DPA',
            without_dpa: 'Utan DPA',
            dpa_coverage: 'DPA Täckning',
            active_contracts_by_type: 'Aktiva Kontrakt per Typ',
            expiring_contracts: 'Utgående kontrakt (nästa 90 dagar)',
            no_expiring_contracts: 'Inga kontrakt utgår inom de närmaste 90 dagarna.',
            vendor: 'Leverantör',
            previous_tier: 'Föregående Nivå',
            current_tier: 'Aktuell Nivå',
            changed_at: 'Ändrad den',
            expires_at: 'Utgår den',
            days_remaining: 'Dagar kvar',
            days: 'dagar',
            vendors_label: 'leverantörer',
            no_data: 'Inga data',
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medel',
            low: 'Låg',
            expiring_acceptances_heading: 'Utgående riskacceptanser',
            expiring_30d_label: 'Går ut om 30 dagar',
            expiring_60d_label: 'Går ut om 60 dagar',
            expiring_90d_label: 'Går ut om 90 dagar',
        },
        scoring: {
            title: 'Riskbedömning',
            page_title: 'Leverantörsriskpoäng',
            filter_scores: 'Filtrera riskpoäng',
            filter_by_tier: 'Filtrera efter risknivå',
            scores_pagination: 'Riskpoäng paginering',
            config_dimensions: 'Konfiguration av poängmått',
            scores_loaded: '[[TOK_1]] riskpoäng laddade',
            weight_must_equal_100: 'Totalvikt måste vara 100 (nuvarande: [[TOK_1]])',
            out_of_10: 'av 10, betygsatt [[TOK_1]]',
            dimension_name: 'Namn på dimension [[TOK_1]]',
            dimension_weight: '[[TOK_1]] vikt (procent)',
            must_equal_100: 'måste vara 100',
            config_title: 'Poängsättning Konfiguration',
            scores_title: 'Leverantör Risk Poäng',
            new_score_title: 'Poäng en Leverantör',
            new: 'Ny Poäng',
            vendor_id: 'Leverantör ID',
            risk_tier: 'Risk Nivå',
            score: 'Poäng',
            scored_at: 'Scoret At',
            no_scores: 'Inga risk poäng hittades.',
            all_tiers: 'Alla Nivåer',
            load_config_error: 'Kunde inte ladda riskpoängskonfiguration',
            update_config: 'Uppdatera poängkonfiguration',
            update_config_error: 'Kunde inte uppdatera riskpoängskonfiguration',
            load_scores_error: 'Kunde inte ladda leverantörsriskpoäng',
            calculate_error: 'Kunde inte beräkna leverantörsriskpoäng',
            weight: 'vikt',
            score_range: 'Poäng (1-5)',
            method: 'Metod',
        },
        questionnaires: {
            title: 'Frågeformulär',
            page_title: 'Leverantörsfrågeformulär',
            filter_questionnaires: 'Frågeformulär filter',
            questionnaire_views: 'Enkätsynpunkter',
            templates_list: 'Lista med frågeformulärmallar',
            instances_list: 'Lista över frågeformulärinstanser',
            filter_by_status: 'Filtrera efter frågeformulärstatus',
            templates_per_page: 'Mallar per sida',
            instances_per_page: 'Förekomster per sida',
            select_template: 'Välj enkätmall',
            template_category: 'Mallkategori',
            templates_tab: 'Mallar',
            instances_tab: 'Instanser',
            new: 'Ny Enkät',
            new_template: 'Ny mall',
            new_instance: 'Ny instans',
            vendor_id: 'Leverantör ID',
            template_id: 'Mall ID',
            assigned_to: 'Tilldelad Till',
            due_date: 'Due Datum',
            responses: 'Svar',
            risk_score: 'Slutförande',
            no_questionnaires: 'Inga enkäter hittades.',
            load_templates_error: 'Kunde inte ladda enkätmallar',
            load_instances_error: 'Kunde inte ladda enkäter',
            create_template_error: 'Kunde inte skapa enkätmall',
            initiate_error: 'Kunde inte initiera enkät',
            submit_error: 'Kunde inte skicka in enkät',
            review_error: 'Kunde inte granska enkät',
            resubmit: 'Skicka in igen',
            approve_error: 'Det gick inte att godkänna enkäten',
            reject_error: 'Det gick inte att avvisa enkäten',
            resubmit_error: 'Det gick inte att skicka in enkäten igen',
            templates_loaded: '[[TOK_1]] frågeformulärsmallar laddade',
            instances_loaded: '[[TOK_1]] frågeformulärsinstanser laddade',
            fill_responses_cta: 'Fyll i svar',
            fill_responses_title: 'Fyll i frågeformulärssvar',
            template_missing: 'Mall hittades inte.',
            responses_saved: 'Svar sparade.',
            load_template_error: 'Kunde inte läsa in mall.',
            version_history: 'Versionshistorik',
            download_previous_version: 'Ladda ner tidigare version',
            trigger: 'Utlösare',
            template_label: 'Mall',
            reviewer: 'Recensent',
            reviewer_required: 'En granskare måste tilldelas för [[TOK_1]] frågeformulär (separation of arbetsuppgifter).',
            select_option: 'Välj ett alternativ',
            multi_choice_hint: 'Välj allt som stämmer',
            category_initial_onboarding: 'Första onboarding',
            category_annual_review: 'Årlig granskning',
            category_incident_triggered: 'Incident-utlöst',
            category_contract_renewal: 'Kontraktsförnyelse',
            template_editor: {
                page_title: 'Redigera enkätmall',
                preview_page_title: 'Förhandsgranska frågeformulärmall',
                edit_structure: 'Redigera struktur',
                preview: 'Förhandsgranska',
                actions: 'Åtgärder',
                back_to_list: 'Tillbaka till mallar',
                load_error: 'Det gick inte att läsa in mallen',
                save_error: 'Det gick inte att spara mallstrukturen',
                saved: 'Mallstrukturen har sparats.',
                sections_heading: 'Avsnitt',
                questions_heading: 'Frågor',
                add_section: 'Lägg till avsnitt',
                edit_section: 'Redigera avsnitt',
                delete_section: 'Ta bort avsnitt',
                move_section_up: 'Flytta avsnittet uppåt',
                move_section_down: 'Flytta avsnittet nedåt',
                confirm_delete_section: 'Vill du ta bort avsnittet "[[TOK_1]]"? Alla dess frågor kommer att tas bort.',
                section_title: 'Avsnittstitel',
                section_description: 'Avsnittsbeskrivning',
                section_id: 'Sektions-ID',
                section_id_hint: 'Automatiskt genererad om du inte ställer in en uttryckligen.',
                no_sections: 'Inga avsnitt ännu. Lägg till ett avsnitt för att börja.',
                no_questions: 'Inga frågor i detta avsnitt ännu.',
                add_question: 'Lägg till fråga',
                edit_question: 'Redigera fråga',
                delete_question: 'Ta bort fråga',
                move_question_up: 'Flytta frågan uppåt',
                move_question_down: 'Flytta frågan nedåt',
                confirm_delete_question: 'Ta bort frågan "[[TOK_1]]"?',
                question_text: 'Frågetext',
                question_type: 'Frågetyp',
                question_id: 'Fråge-ID',
                evidence_required: 'Bevis krävs',
                risk_weight: 'Riskvikt',
                scoring_map: 'Poängkarta',
                scoring_map_json_hint: '[[TOK_0]] objekt mappar svarsvärden till numeriska poäng.',
                scoring_map_invalid_json: 'Poängkartan måste vara giltig [[TOK_0]].',
                options_heading: 'Svarsalternativ',
                add_option: 'Lägg till alternativ',
                remove_option: 'Ta bort alternativ',
                option_label: 'Etikett',
                option_value: 'Värde',
                option_risk_weight: 'Riskvikt',
                min_options_error: 'Valfrågor måste ha minst 2 alternativ.',
                option_label_required: 'Varje alternativ behöver en etikett.',
                option_value_required: 'Varje alternativ behöver ett värde.',
                option_value_unique: 'Alternativvärden måste vara unika.',
                branching_rules_heading: 'Förgreningsregler',
                branching_rules_hint: 'Visa eller dölj den här frågan baserat på svaret på en tidigare fråga.',
                add_branching_rule: 'Lägg till förgreningsregel',
                remove_branching_rule: 'Ta bort förgreningsregeln',
                branching_condition_question: 'Om fråga',
                branching_condition_value: 'har värde',
                branching_action: 'sedan',
                branching_action_show: 'visa denna fråga',
                branching_action_hide: 'dölj denna fråga',
                branching_select_condition_question: 'Välj tidigare fråga',
                branching_select_condition_value: 'Välj värde',
                save: 'Spara struktur',
                saving: 'Sparar...',
                cancel: 'Avbryt',
                close: 'Stäng',
                question_text_required: 'Frågetext krävs.',
                section_title_required: 'Avsnittstitel krävs.',
                type_single_choice: 'Enstaka val',
                type_multi_choice: 'Flerval',
                type_free_text: 'Fri text',
                type_numeric: 'Numerisk',
                type_date: 'Datum',
                type_file_upload: 'Filuppladdning',
                type_yes_no: 'Ja/Nej',
                preview_heading: 'Förhandsgranskning av mall',
                preview_subtitle: 'Skrivskyddad förhandsvisning av hur frågeformuläret ser ut för en leverantör.',
                preview_no_content: 'Den här mallen har inga avsnitt eller frågor ännu.',
                preview_branching_notice: 'Förgreningsregler utvärderas vid ifyllning; förhandsgranskning visar varje fråga.',
            },
            review_modal: {
                title: 'Granska enkätsvaren',
                open_cta: 'Granska',
                loading: 'Laddar frågeformulär...',
                template_missing: 'Mallen hittades inte.',
                load_error: 'Det gick inte att läsa in frågeformuläret för granskning.',
                annotation_heading: 'Anteckningar',
                annotation_placeholder: 'Lägg till en recensionskommentar för den här frågan...',
                annotation_status_label: 'Anteckningsstatus',
                annotation_status_acceptable: 'Acceptabelt',
                annotation_status_concern: 'Oro',
                annotation_status_requires_action: 'Kräver åtgärd',
                review_comments_label: 'Övergripande recensionskommentarer',
                review_comments_placeholder: 'Sammanfatta dina granskningsresultat...',
                justification_label: 'Beslutsmotivering',
                justification_placeholder: 'Förklara skälen till ditt beslut...',
                reject_requires_comments: 'Att avvisa ett frågeformulär kräver granskningskommentarer.',
                decision_heading: 'Beslut',
                decision: {
                    approved: 'Godkänn',
                    rejected: 'Avvisa',
                    additional_info_requested: 'Begär ytterligare information',
                },
                submit: 'Skicka recension',
                submitting: 'Skickar recension...',
                cancel: 'Avbryt',
                submit_success: 'Recension skickad.',
                submit_error: 'Det gick inte att skicka recension.',
                separation_of_duties_error: 'Du kan inte granska ett frågeformulär som du fått i uppdrag att fylla i. Fördelning av arbetsuppgifter kräver en annan granskare.',
                decision_required: 'Välj ett granskningsbeslut.',
                announce_opened: 'Granskningsmodal öppnad.',
                announce_submitted: 'Recension skickad.',
            },
            instance_detail: {
                submitted_at: 'Inlämnad',
                reviewed_at: 'Recenserad',
                reviewer: 'Recensent',
                review_decision: 'Beslut',
                review_comments: 'Granska kommentarer',
                decision_approved: 'Godkänd',
                decision_rejected: 'Avvisad',
                decision_additional_info_requested: 'Mer information efterfrågas',
                decision_pending: 'Väntar på granskning',
                expand_comments: 'Visa fullständiga kommentarer',
                collapse_comments: 'Dölj fullständiga kommentarer',
                no_reviewer: 'Ingen granskare tilldelas',
            },
            export: {
                portfolio_label: 'Exportportfölj',
                instance_label: 'Exportera',
                portfolio_success: 'Portföljexport redo.',
                instance_success: 'Frågeformulärexport klar.',
                portfolio_error: 'Det gick inte att exportera frågeformulärsportföljen.',
                instance_error: 'Det gick inte att exportera frågeformuläret.',
            },
            branching: {
                hidden_notice: 'Vissa frågor är dolda av förgreningsregler.',
                cycle_warning: 'En cykel upptäcktes i förgreningsregler. Berörda frågor är som standard synliga.',
            },
        },
        contracts: {
            title: 'Avtal',
            page_title: 'Leverantörskontrakt',
            new: 'Ny Kontrakt',
            vendor_id: 'Leverantör ID',
            filter_contracts: 'Filtrera kontrakt',
            filter_by_document_type: 'Filtrera efter dokumenttyp',
            filter_by_status: 'Filtrera efter kontraktsstatus',
            per_page: 'Kontrakt per sida',
            expired_notice: 'Detta kontrakt har löpt ut',
            document_type: 'Dokument Typ',
            expiry_date: 'Förfallodatum Datum',
            no_contracts: 'Inga kontrakt hittades.',
            all_document_types: 'Alla Dokument Typer',
            load_error: 'Kunde inte ladda kontrakt',
            create_error: 'Kunde inte skapa kontrakt',
            delete_error: 'Kunde inte radera kontrakt',
            update_error: 'Kunde inte uppdatera status',
            confirm_delete: 'Radera kontrakt "{title}"?',
            renewal_date: 'Förnyelse Datum',
            effective_date: 'Gällande Datum',
            parties: 'Parter',
            summary: 'Sammanfattning',
            n_contracts: '{count} kontrakt',
            n_contract: '{count} kontrakt',
            contracts_loaded: '{count} kontrakt laddade',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Säkerhetstillägg',
            doc_type_scc_annex: 'SCC-bilaga',
            doc_type_sub_processor_list: 'Underbiträdeslista',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Övrigt',
            status_draft: 'Utkast',
            status_under_negotiation: 'Under förhandling',
            status_pending_signature: 'Väntar på signatur',
            status_active: 'Aktiv',
            status_expired: 'Utgången',
            status_terminated: 'Avslutad',
            status_superseded: 'Ersatt',
        },
        gates: {
            title: 'Godkännandegrindar',
            page_title: 'Gate utvärderingar',
            new: 'Ny Grind Utvärdering',
            vendor_id: 'Leverantör ID',
            gate_name: 'Grind Namn',
            outcome: 'Utfall',
            evaluator: 'Utvärderare',
            no_gates: 'Inga grind utvärderingar hittades.',
            load_error: 'Kunde inte ladda grindsutvärderingar',
            evaluate_error: 'Kunde inte utvärdera leverantörsgrind',
            detail_error: 'Kunde inte hämta utvärderingsdetalj',
            override_error: 'Kunde inte åsidosätta grindsutvärdering',
            criteria_results: 'Kriterier Resultat',
            evaluate_form: 'Utvärdera leverantörsporten',
            per_page: 'Utvärderingar per sida',
            passed: 'Godkänd',
            failed: 'Misslyckad',
            override: 'Åsidosätt',
            override_justification: 'Åsidosättning Motivering',
            override_placeholder: 'Ange motivering för att åsidosätta denna grindsutvärdering',
            approval_id: 'Godkännande ID',
            overall_passed: 'Godkänd',
            overall_failed: 'Underkänd',
            overall_overridden: 'Åsidosatt',
            evaluations_loaded: '{count} portutvärderingar laddade',
            create_approval_cta: 'Skapa godkännande',
        },
        reviews: {
            title: 'Leverantörsgranskningar',
            page_title: 'Leverantörsrecensioner',
            new: 'Ny Granskning',
            vendor_id: 'Leverantör ID',
            filter_by_outcome: 'Filtrera efter granskningsresultat',
            per_page: 'Recensioner per sida',
            kpi_summary: 'Granska [[TOK_0]] sammanfattning',
            review_outcome_label: 'Granska resultatet',
            edit_outcome: 'Redigera recensionsresultat',
            reviews_loaded: '[[TOK_1]] leverantörsrecensioner har laddats',
            reviewer: 'Granskare',
            review_type: 'Granskning Typ',
            outcome: 'Utfall',
            findings: 'Resultat',
            no_reviews: 'Inga leverantör granskningar hittades.',
            load_kpis_error: 'Kunde inte hämta leverantörsgranskning-KPI:er',
            load_error: 'Kunde inte hämta leverantörsgranskningar',
            update_error: 'Det gick inte att uppdatera leverantörsrecensionen',
            create_error: 'Kunde inte skapa leverantörsgranskning',
            total_reviewed: 'Totalt antal granskade leverantörer',
            total_reviews: 'Totalt Granskningar',
            satisfactory: 'Tillfredsställande',
            concerns_identified: 'Identifierade problem',
            remediation_required: 'Åtgärdande Obligatorisk',
            escalated: 'Eskalerad',
            program_id: 'Program-ID',
            period_id: 'Period-ID',
            task_id: 'Uppgift ID',
            recommendations: 'Rekommendationer',
        },
        risk_signals: {
            title: 'Risksignaler',
            page_title: 'Risksignaler',
            new_signal: 'Ny risksignal',
            signal_type: 'Signaltyp',
            severity: 'Allvarlighetsgrad',
            description: 'Beskrivning',
            source: 'Källa',
            vendor_id: 'Leverantörs-ID',
            certification_expiry: 'Certifieringsutgång',
            breach_notification: 'Intrångsmeddelande',
            financial_instability: 'Finansiell instabilitet',
            compliance_change: 'Efterlevnadsändring',
            custom: 'Anpassad',
            active: 'Aktiv',
            acknowledged: 'Bekräftad',
            resolved: 'Löst',
            no_signals: 'Inga risksignaler hittades',
            source_external_feed: 'Externt flöde',
            source_manual: 'Manuell',
            source_integration: 'Integration',
            source_regulatory: 'Regulatorisk',
            source_media: 'Media',
            trigger_reassessment_prompt: 'Denna signal är hög allvarlighetsgrad. Starta en leverantörsomprövning nu?',
            reassessment_triggered: 'Omprövning startad.',
            reassessment_trigger_error: 'Kunde inte starta omprövning.',
        },
        reassessments: {
            title: 'Omvärderingsuppgifter',
            page_title: 'Omvärderingsuppgifter',
            trigger: 'Utlös omvärdering',
            trigger_success: 'Omvärdering utlöst framgångsrikt',
            reason: 'Anledning',
            deadline: 'Tidsfrist',
            assigned_to: 'Tilldelad till',
            vendor_id: 'Leverantörs-ID',
            outcome: 'Resultat',
            new_risk_level: 'Ny risknivå',
            complete: 'Slutför omvärdering',
            complete_success: 'Omvärdering slutförd framgångsrikt',
            pending: 'Väntande',
            in_progress: 'Pågår',
            completed: 'Slutförd',
            cancelled: 'Avbruten',
            no_tasks: 'Inga omvärderingsuppgifter hittades',
            risk_trend: 'Risktrend',
            notes: 'Anteckningar',
        },
        portfolio: {
            title: 'Riskportfölj',
            page_title: 'Riskportfölj',
            dashboard: 'Portföljöversikt',
            vendor_id: 'Leverantörs-ID',
            total_vendors: 'Totalt antal leverantörer',
            average_score: 'Genomsnittlig riskpoäng',
            high_risk_count: 'Högrisk-leverantörer',
            trend_direction: 'Trendriktning',
            improved: 'Förbättrad',
            stable: 'Stabil',
            degraded: 'Försämrad',
            vendor_trend: 'Leverantörstrend',
            outstanding_questionnaires: 'Utestående frågeformulär',
            overdue_assessments: 'Förfallna bedömningar',
            no_outstanding: 'Inga utestående frågeformulär',
            no_overdue: 'Inga förfallna bedömningar',
            due_date: 'Förfallodatum',
        },
        risk_acceptance: {
            title: 'Riskacceptansregister',
            page_title: 'Riskacceptansregister',
            new_acceptance: 'Ny riskacceptans',
            vendor_id: 'Leverantörs-ID',
            risk_level: 'Risknivå',
            conditions: 'Villkor',
            justification: 'Motivering',
            expiry_date: 'Utgångsdatum',
            create_success: 'Riskacceptans skapad framgångsrikt',
            review_condition: 'Granska villkor',
            condition_met: 'Villkor uppfyllt',
            condition_not_met: 'Villkor ej uppfyllt',
            review_success: 'Villkor granskat framgångsrikt',
            export_register: 'Exportera register',
            active: 'Aktiv',
            expired: 'Utgången',
            revoked: 'Återkallad',
            no_acceptances: 'Ingen riskacceptans hittades',
            met_count: '[[TOK_2]]/[[TOK_3]] uppfyllda',
        },
        review_routing: {
            title: 'Granskningsdirigering',
            page_title: 'Granska routing',
            route_to_reviewers: 'Skicka till granskare',
            route_success: 'Skickad till granskare framgångsrikt',
            vendor_id: 'Leverantörs-ID',
            reviewer_id: 'Granskar-ID',
            reviewer_role: 'Granskarroll',
            questionnaire_id: 'Frågeformulär-ID',
            review_status: 'Granskningsstatus',
            reviewers_label: 'Granskare (user_id, roll per rad)',
            pending: 'Väntande',
            in_review: 'Under granskning',
            completed: 'Slutförd',
            no_routing: 'Ingen granskningsdirigering hittades',
            primary_reviewer: 'Primär granskare',
            secondary_reviewer: 'Sekundär granskare',
            approver: 'Godkännare',
        },
        onboarding: {
            title: 'Onboarding-ärenden för leverantörer',
            page_title: 'Onboarding-ärenden för leverantörer',
            new_case: 'Nytt onboarding-ärende',
            case_detail: 'Onboarding-ärende',
            open_mps_dossier_filing: 'Öppna MPS-inlämning',
            dossier_filing_description: 'Skapar en ny MPS-inlämning förifylld från detta onboardingfall. Inlämningen länkas tillbaka till fallet.',
            dossier_filing_dpia_id: 'DPIA-ID',
            dossier_filing_dpia_id_placeholder: 't.ex. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Inlämningstitel',
            dossier_filing_form_type: 'Formulärtyp',
            dossier_filing_submit: 'Skapa inlämning',
            dossier_filing_validation_error: 'DPIA-ID och titel krävs.',
            dossier_filing_created: 'MPS-inlämning skapad',
            dossier_filing_error: 'Kunde inte skapa MPS-inlämning.',
            linked_questionnaire_due_date: 'Förfallodatum',
            linked_questionnaire_assignee: 'Tilldelad',
            linked_questionnaire_submitted_at: 'Inskickad',
            score_last_scored: 'Senast betygsatt',
            score_dimensions: 'Dimensioner',
            linked_contract_document_type: 'Dokumenttyp',
            linked_contract_effective_date: 'Startdatum',
            linked_contract_expiry_date: 'Utgångsdatum',
            linked_sub_processor_countries: 'Behandlingsländer',
            linked_sub_processor_last_assessment: 'Senaste bedömning',
            linked_sub_processor_next_assessment: 'Nästa bedömning',
            case_id: 'Ärende-ID',
            vendor: 'Leverantör',
            case_type: 'Ärendetyp',
            service_description: 'Tjänstebeskrivning',
            data_categories: 'Datakategorier',
            systems_accessed: 'Åtkomna system',
            jurisdiction: 'Jurisdiktion',
            hosting_model: 'Värdmodell',
            controller_role: 'Personuppgiftsansvarig/Biträde-roll',
            status_pipeline: 'Statuspipeline',
            tabs_label: 'Onboarding-ärendesektioner',
            per_page: 'Ärenden per sida',
            filter_cases: 'Filtrera onboarding-ärenden',
            cases_count: 'ärenden',
            cases_loaded: 'onboarding-ärenden laddade',
            no_cases: 'Inga onboarding-ärenden hittades.',
            vendor_lookup_placeholder: 'Ange leverantörs-ID',
            data_categories_placeholder: 't.ex., personuppgifter, finansiella, hälsa',
            systems_placeholder: 't.ex., CRM, ERP, HR-system',
            status_open: 'Öppen',
            status_in_progress: 'Pågående',
            status_awaiting_approval: 'Inväntar godkännande',
            status_approved: 'Godkänd',
            status_remediation_required: 'Åtgärd krävs',
            status_closed: 'Stängd',
            type_new_vendor: 'Ny leverantör',
            type_service_change: 'Tjänsteändring',
            type_renewal: 'Förnyelse',
            type_reassessment: 'Omvärdering',
            tab_overview: 'Översikt',
            tab_due_diligence: 'Tillbörlig aktsamhet',
            tab_security_assessment: 'Säkerhetsbedömning',
            tab_contractual_controls: 'Avtalskontroller',
            tab_sub_processors: 'Underbiträden',
            tab_approval_gates: 'Godkännandeportar',
            tab_evidence: 'Bevis',
            tab_placeholder: 'Innehållet i detta avsnitt fylls i under onboarding-processen.',
            completion_not_started: 'Ej påbörjad',
            completion_in_progress: 'Pågående',
            completion_completed: 'Slutförd',
            completion_requiring_attention: 'Kräver uppmärksamhet',
            gate_name: 'Portnamn',
            approver: 'Godkännare',
            decision: 'Beslut',
            comments: 'Kommentarer',
            decide: 'Fatta beslut',
            decision_approved: 'Godkänd',
            decision_rejected: 'Avslagen',
            decision_deferred: 'Uppskjuten',
            no_approvals: 'Inga godkännandeportar konfigurerade för detta ärende.',
            approval_success: 'Godkännandebeslut registrerat',
            approval_error: 'Kunde inte registrera godkännandebeslut',
            transition_status: 'Ändra status',
            confirm_transition: 'Ändra ärende från "{from}" till "{to}"?',
            transition_success: 'Ärendestatus ändrad',
            transition_error: 'Kunde inte ändra ärendestatus',
            create_success: 'Onboarding-ärende skapat',
            create_error: 'Kunde inte skapa onboarding-ärende',
            load_error: 'Kunde inte ladda onboarding-ärenden',
            detail_error: 'Kunde inte ladda ärendedetaljer',
            export: 'Exportera',
            export_error: 'Kunde inte exportera onboarding-ärende',
            evidence_tab_description: 'Ladda upp och exportera bevis för onboarding-ärendet.',
            upload_evidence_label: 'Ladda upp bevis',
            attached_evidence_heading: 'Bifogade bevis',
            no_evidence_attached: 'Inga bevis bifogade ännu.',
            export_bundle_button: 'Exportera bevispaket',
            load_attachments_error: 'Kunde inte läsa in bevis.',
            linked_questionnaires_heading: 'Länkade frågeformulär',
            no_linked_questionnaires: 'Inga länkade frågeformulär.',
            linked_scores_heading: 'Länkade riskpoäng',
            no_linked_scores: 'Inga länkade poäng.',
            latest_score_label: 'Senaste poäng',
            linked_contracts_heading: 'Länkade kontrakt',
            no_linked_contracts: 'Inga länkade kontrakt.',
            linked_sub_processors_heading: 'Länkade underbiträden',
            no_linked_sub_processors: 'Inga länkade underbiträden.',
        },
        sub_processors: {
            title: 'Register över underbiträden',
            page_title: 'Register över underbiträden',
            new_record: 'Nytt underbiträde',
            edit_record: 'Redigera underbiträde',
            onboarding_case: 'Onboarding-ärende',
            services: 'Tillhandahållna tjänster',
            data_categories: 'Datakategorier',
            processing_countries: 'Behandlingsländer',
            dpa_chain_status: 'DPA-kedjestatus',
            certifications: 'Certifieringar',
            last_assessment: 'Senaste bedömning',
            next_assessment: 'Nästa bedömning',
            change_history: 'Ändringshistorik',
            history: 'Historik',
            changed_by: 'Ändrad av',
            comma_separated: 'Kommaseparerade värden',
            filter_records: 'Filtrera poster',
            filter_by_dpa: 'Filtrera efter DPA-kedjestatus',
            all_dpa_statuses: 'Alla DPA-statusar',
            per_page: 'Poster per sida',
            records_count: 'underbiträden',
            records_loaded: 'poster laddade',
            no_records: 'Inga underbiträden hittades.',
            no_history: 'Ingen ändringshistorik tillgänglig.',
            dpa_active: 'Aktiv',
            dpa_pending: 'Väntande',
            dpa_expired: 'Utgången',
            dpa_not_required: 'Ej krävd',
            create_success: 'Underbiträde skapat',
            create_error: 'Kunde inte skapa underbiträde',
            update_success: 'Underbiträde uppdaterat',
            update_error: 'Kunde inte uppdatera underbiträde',
            load_error: 'Kunde inte ladda registret',
            history_error: 'Kunde inte ladda ändringshistorik',
            export_csv: 'Exportera CSV',
            export_json: 'Exportera JSON',
            export_error: 'Kunde inte exportera data',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Orkestreringsöversikt',
            runs: 'Orkestreringskörningar',
            tasks: 'Utförandeuppgifter',
            templates: 'Checklistemallar',
            vendor_requests: 'Leverantörsförfrågningar',
            proof_chain: 'Beviskedja',
            dsr_integration: 'DSR-integration',
            vendor_verification: 'Leverantörsverifiering',
            completeness: 'Fullständighetsöversikt',
        },
        dashboard: {
            title: 'Orkestreringsöversikt',
            loading: 'Laddar instrumentpanelsdata...',
            active_runs: 'Aktiva Körningar',
            completion_rate: 'Slutförande Frekvens',
            avg_completion_time: 'Gns. Slutförande Tid',
            overdue_tasks: 'Försenade Uppgifter',
            vendor_compliance: 'Leverantör Efterlevnad',
            recent_runs: 'Senaste Körningar',
            no_recent_runs: 'Inga recent orchestration runs.',
            run_id: 'Körning ID',
            ticket_id: 'Ärende ID',
            progress: 'Framsteg',
            systems: 'System',
            vendors: 'Leverantörer',
            load_error: 'Det gick inte att läsa in instrumentpanelen för orkestrering. Försök igen.',
            aria_table: 'Senaste orkestreringskörningar',
        },
        runs: {
            title: 'Orkestreringskörningar',
            new: 'Ny Körning',
            run_id: 'Körning ID',
            ticket_id: 'Ärende ID',
            progress: 'Framsteg',
            systems: 'System',
            vendors: 'Leverantörer',
            data_subject_ref: 'Data Ämne Ref',
            data_categories: 'Data Kategorier',
            enable_proof_chain: 'Aktivera Bevis Kedja',
            start: 'Starta',
            started: 'Löpningen började',
            mark_ready: 'Markera redo',
            marked_ready: 'Kör markerad som klar',
            complete: 'Komplett',
            complete_exceptions: 'Komplett med undantag',
            pause: 'Pausa',
            resume: 'Återuppta',
            cancel: 'Avbryt',
            no_runs: 'Inga orchestration runs hittades.',
            load_error: 'Det gick inte att ladda orkestreringskörningar. Försök igen.',
            create_error: 'Det gick inte att skapa orkestreringskörning',
            aria_filter_status: 'Filtrera efter körstatus',
            aria_table: 'Orchestration körs',
            placeholder_ticket_id: 't.ex. TKT-000123',
            placeholder_data_subject_ref: 't.ex. DS-REF-001',
            placeholder_data_categories: 't.ex. personal_data, ekonomi, hälsa',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: 'Utförandeuppgifter',
            task_id: 'Uppgift ID',
            run_id: 'Körning ID',
            system_name: 'System Namn',
            assigned_to: 'Tilldelad Till',
            sla_deadline: 'SLA-tidsfrist',
            progress: 'Framsteg',
            enter_run_id: 'Ange Körning ID to filtrera...',
            select_run: 'Välj en körning för att se uppgifter',
            unassigned: 'Ej tilldelad',
            overdue: 'Försenad',
            assign_task: 'Tilldela Uppgift',
            assignee_id: 'Tilldelad-ID',
            update_status: 'Uppdatering Status',
            new_status: 'Ny Status',
            no_transitions: 'Den här uppgiften är i ett slutligt tillstånd och kan inte ändras.',
            select_status_placeholder: 'Välj en ny status',
            skip_justification: 'Motivering för överhoppning',
            failure_reason: 'Orsak till misslyckande',
            no_tasks: 'Inga exekvering uppgifter hittades.',
            new_task: 'Ny uppgift',
            system_id: 'System-ID',
            data_classification: 'Dataklassificering',
            load_error: 'Kunde inte läsa in execution tasks. Försök igen.',
            assign_error: 'Kunde inte assign task',
            status_error: 'Kunde inte uppdatera uppgiftsstatus',
            no_tasks_for_run: 'Denna raderingskörning har inga körningsuppgifter ännu.',
            aria_filter_run_id: 'Filtrera efter körnings-ID',
            aria_filter_status: 'Filtrera efter uppgiftsstatus',
            aria_table: 'Utförande uppgifter',
            view_steps: 'Visa steg',
            steps_modal_title: 'Utförandesteg',
            step_title: 'Steg',
            step_status: 'Stegstatus',
            step_notes: 'Anteckningar',
            step_evidence: 'Bevisfiler',
            step_evidence_required: 'Bevis krävs för detta steg',
            step_evidence_missing: 'Inga bevis uppladdade än',
            step_save: 'Spara steg',
            step_saved: 'Steg uppdaterat',
            step_save_error: 'Kunde inte uppdatera steget',
            create_success: 'Körningsuppgift skapad',
            create_error: 'Det gick inte att skapa körningsuppgiften',
            step_upload_label: 'Bifoga bevis',
        },
        templates: {
            title: 'Checklistemallar',
            new: 'Ny Mall',
            template_id: 'Mall ID',
            system_type: 'System Typ',
            est_duration: 'Ber.. Varaktighet',
            steps: 'Steg',
            action_type: 'Åtgärd Typ',
            instructions: 'Instruktioner',
            mandatory: 'Obligatorisk',
            add_step: 'Add Steg',
            step_n: 'Steg',
            no_templates: 'Inga checklista mallar hittades.',
            all_system_types: 'Alla System Typer',
            load_error: 'Det gick inte att läsa in checklistmallar. Försök igen.',
            create_error: 'Det gick inte att skapa checklistamall',
            aria_filter_system_type: 'Filtrera efter systemtyp',
            aria_filter_status: 'Filtrera efter mallstatus',
            aria_table: 'Checklista mallar',
            placeholder_name: 't.ex. checklista för radering av databas',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Mallen har uppdaterats',
            create_success_msg: 'Mallen har skapats',
            update_error: 'Kunde inte uppdatera mallen',
            activate_success: 'Mallen har aktiverats',
            activate_error: 'Kunde inte aktivera mallen',
            archive_success: 'Mallen har arkiverats',
            archive_error: 'Kunde inte arkivera mallen',
            clone_success: 'Mallen har klonats',
            clone_error: 'Kunde inte klona mallen',
        },
        vendor_requests: {
            title: 'Leverantör Radering Begäranden',
            new: 'Ny Begäran',
            request_id: 'Begäran ID',
            vendor_name: 'Leverantör Namn',
            vendor_id: 'Leverantör ID',
            data_subject_ref: 'Data Ämne Ref',
            data_categories: 'Data Kategorier',
            legal_basis: 'Rättslig grund',
            sla_days: 'SLA Dagar',
            requested_completion: 'Begärd slutförande',
            communications: 'Kommunikationer',
            total_requests: 'Totalt Begäranden',
            no_requests: 'Inga leverantör radering begäranden hittades.',
            filter_vendor_id: 'Filter per Leverantör ID...',
            change_status: 'Ändra Status',
            new_status: 'Ny Status',
            actions: 'Åtgärder',
            load_error: 'Det gick inte att läsa in begäran om borttagning från leverantör. Försök igen.',
            create_error: 'Det gick inte att skapa begäran om borttagning av leverantör',
            dashboard_error: 'Det gick inte att läsa in instrumentpanelen för borttagning av leverantör. Försök igen.',
            aria_filter_status: 'Filtrera efter begäran status',
            aria_filter_vendor_id: 'Filtrera efter leverantörs-ID',
            aria_table: 'Förfrågningar om borttagning av leverantörer',
            placeholder_vendor_id: 't.ex. VND-001',
            placeholder_vendor_name: 't.ex. Acme Analytics',
            placeholder_data_subject_ref: 't.ex. DS-REF-001',
            placeholder_data_categories: 't.ex. personal_data, analyser',
            placeholder_legal_basis: 't.ex. [[TOK_0]] Artikel 19',
        },
        proof_chain: {
            title: 'Bevis Kedja Visare',
            enter_run_id: 'Ange Körning ID...',
            load_chain: 'Ladda Kedja',
            verify_chain: 'Verifiera Kedja',
            verifying: 'Verifierar...',
            chain_valid: 'Kedjan är giltig',
            chain_invalid: 'Kedja är bruten',
            chain_length: 'Kedja Längd',
            broken_at_index: 'Bruten vid index',
            no_proof_records: 'Inga proof records found for this run.',
            proof_id: 'Bevis ID',
            entity_type: 'Entitet Typ',
            entity_id: 'Entitet ID',
            event_hash: 'Händelse Hash',
            previous_hash: 'Föregående Hash',
            attestation: 'Attestering',
            attestation_actor: 'Utförd av',
            attestation_signed_at: 'Signerad',
            attestation_signature: 'Signatur',
            attestation_evidence_refs: 'Bevisreferenser',
            run_field_label: 'Raderingskörning',
            select_run: 'Välj en raderingskörning…',
            aria_select_run: 'Raderingskörning för sökning i beviskedjan',
            chain_broken_here: 'Kedja bruten här',
            load_error: 'Det gick inte att ladda säkra kedjan. Försök igen.',
            verify_error: 'Det gick inte att verifiera beviskedjan. Försök igen.',
            aria_run_id: 'Kör ID för att kontrollera kedjan',
        },
        dsr_integration: {
            change_status: 'Ändra status',
            request_type: 'Begärandetyp',
            data_subject_hint: 'Identifierare för den registrerade vars data raderas (t.ex. e-post eller kund-ID). Matchar vanligtvis begäraren i det valda DSR-ärendet.',
            title: 'DSR-raderingsintegration',
            create_run: 'Skapa DSR-raderingskörning',
            dsr_case_id: 'DSR-ärende-ID',
            data_subject_id: 'Registrerades ID',
            systems: 'Målsystem',
            route_to_department: 'Skicka till avdelning',
            confirm_deletion: 'Bekräfta radering',
            no_runs: 'Inga DSR-raderingskörningar hittades',
            status: 'Raderingsstatus',
            deadline: 'Deadline',
        },
        vendor_verification: {
            title: 'Leverantörsraderingsverifiering',
            create_followup: 'Skapa uppföljning',
            deadline: 'Bekräftelsefrist',
            escalation_contact: 'Eskaleringskontakt',
            record_confirmation: 'Registrera bekräftelse',
            overdue: 'Försenade raderingar',
            escalate: 'Eskalera',
            confirm_escalation: 'Är du säker på att du vill eskalera denna leverantörsraderingsförfrågan?',
            no_followups: 'Inga leverantörsuppföljningar hittades',
            no_overdue: 'Inga försenade leverantörsraderingar',
            vendor_request: 'Säljarförfrågan',
            vendor: 'Leverantör',
            unknown_vendor: 'Okänd leverantör',
            overdue_badge: 'Försenad',
            mark_confirmed: 'Markera som bekräftad',
            mark_confirmed_for: 'Markera radering som bekräftad för {vendor}',
            confirm_confirmation: 'Markera denna leverantörsradering som bekräftad?',
            confirmation_success: 'Leverantörsradering bekräftad',
            confirmation_failed: 'Det gick inte att bekräfta leverantörsradering',
            select_request: 'Välj en säljarförfrågan…',
            escalation_contact_placeholder: 't.ex. dpo@vendor.example',
            create_success: 'Leverantörsuppföljning skapades',
            create_failed: 'Det gick inte att skapa leverantörsuppföljning',
            deadline_hint: 'Den här sidan visar endast uppföljningar vars tidsfrist redan har passerat.',
            deadline_future_warning: 'Den här tidsfristen ligger i framtiden, så uppföljningen visas inte i listan över försenade förrän datumet har passerat.',
            escalation_success: 'Borttagning av leverantör eskalerade framgångsrikt',
            escalation_failed: 'Det gick inte att eskalera borttagning av leverantör',
        },
        completeness: {
            title: 'Raderingsfullständighet',
            check_conflicts: 'Kontrollera lagringskonflikter',
            no_conflicts: 'Inga lagringskonflikter hittades',
            conflict_resolution: 'Konfliktlösning',
            extend_retention: 'Förläng lagring',
            proceed_deletion: 'Fortsätt med radering',
            escalate_conflict: 'Eskalera',
            resolve: 'Lös konflikt',
            data_subject_id: 'Den registrerade ID',
            placeholder_data_subject_id: 'Ange registrerad ID',
            data_subject_hint: 'Identifierare för personen vars radering du verifierar (t.ex. e-post, kund-ID eller DSR-referens). Välj ett känt subjekt eller skriv ett.',
            guidance: 'Ange eller välj ett registrerat-ID, välj eventuellt system och kör kontrollen för att se raderingens fullständighet och lagringskonflikter.',
            completion: 'Raderingsgrad',
            pending_items: 'Väntande objekt',
            system: 'System',
            policy: 'Policy',
            retention_end: 'Retention End',
            completed_items: 'Slutförda Objekt',
            last_review_label: 'Senaste recension',
            days_ago: 'dagar sedan',
            review_overdue: 'Granskningscykeln har överskridits. Omprövning krävs.',
        },
        run_status_labels: {
            pending: 'Väntar',
            planning: 'Planering',
            ready: 'Redo',
            in_progress: 'Pågående',
            paused: 'Pausad',
            completed: 'Slutförd',
            completed_with_exceptions: 'Slutförd med Undantag',
            cancelled: 'Avbruten',
        },
        task_status_labels: {
            pending: 'Väntande',
            assigned: 'Tilldelad',
            in_progress: 'Pågående',
            awaiting_verification: 'Väntar på Verifiering',
            verified: 'Verifierad',
            failed: 'Misslyckad',
            skipped: 'Överhoppad',
        },
        system_type_labels: {
            database: 'Databas',
            saas_application: 'SaaS-applikation',
            file_storage: 'Fillagring',
            email_system: 'E-postsystem',
            analytics_platform: 'Analysplattform',
            backup_system: 'Backupsystem',
            vendor_managed: 'Leverantörshanterad',
            custom: 'Anpassad',
        },
        template_status_labels: {
            draft: 'Utkast',
            active: 'Aktiv',
        },
        action_type_labels: {
            manual_check: 'Manuell Kontroll',
            api_call: 'API-anrop',
            sql_query: 'SQL-fråga',
            script_execution: 'Skriptkörning',
            file_deletion: 'Filradering',
            verification: 'Verifiering',
            notification: 'Avisering',
            approval: 'Godkännande',
        },
        request_status_labels: {
            draft: 'Utkast',
            sent: 'Skickad',
            acknowledged: 'Bekräftad',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            overdue: 'Försenad',
            escalated: 'Eskalerad',
            disputed: 'Bestridd',
        },
        event_type_labels: {
            initiation: 'Initiering',
            data_deletion: 'Dataradering',
            completion: 'Slutförande',
            verification: 'Verifiering',
            rollback: 'Återställning',
        },
        count_labels: {
            one_template: '1 mall',
            n_templates: '{n} mallar',
            one_run: '1 körning',
            n_runs: '{n} körningar',
            one_task: '1 uppgift',
            n_tasks: '{n} uppgifter',
            one_request: '1 begäran',
            n_requests: '{n} begäranden',
        },
        aria: {
            completion_rate: 'Slutförandegrad: {pct}%',
            vendor_compliance: 'Leverantörsefterlevnad: {pct}%',
            run_progress: 'Körningsframsteg: {pct}%',
            run_progress_systems: 'Framsteg: {completed} av {total} system bearbetade',
            chain_broken: 'Kedja bruten vid denna post',
            chain_valid: 'Kedja giltig vid denna post',
            chain_unknown: 'Kedjestatus okänd',
            escalate_vendor: 'Eskalera {id}',
            resolve_conflict: 'Lös konflikt för {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'Borttagningens fullständighet måste granskas minst var 365:e dag. Poster som överskrider detta tröskelvärde flaggas för obligatorisk ny granskning för att upprätthålla regelefterlevnad.',
            runs_data_d1_lifecycle_info: 'Orkestereringskörningstillstånd mappar till DATA-D1 livscykel: planering = katalog, klar = klassificera, in_progress = tillämpa regler, slutförd = bevis genererat, completed_with_exceptions = granskning krävs. Varje övergång registreras i beviskedjan.',
            vendor_record_linkage_info: 'Varje begäran om borttagning av leverantör är länkad till dess leverantörspost via vendor_id. Slutförandebekräftelse kräver kryptografiska bevis från beviskedjan innan begäran kan markeras som slutförd.',
            templates_internal_classification_info: 'Alla mallar för raderingschecklistor klassificeras som interna organisationsdokument. De har inga officiella ID:n för regulatoriska formulär och bör inte skickas in som regulatoriska ansökningar.',
            proof_chain_evidence_info: 'Varje bevispost fångar den registrerade personen/kategorin, tidsstämpeln, aktören, rättslig grund och en SHA-256 hash. Tillsammans producerar dessa fält kryptografiska raderingsbevis som uppfyller regulatoriska revisionskrav.',
            retention_data_law_info: 'Lagringsscheman på den här instrumentpanelen härleds från datalagsklassificeringen som tilldelats varje datakategori. När en klassificering ändras uppdateras länkade lagringsregler automatiskt för att säkerställa regelanpassning.',
            dsr_erasure_route_info: 'DSR-raderingskörningar är kopplade till det ursprungliga Rights Request-ärendet. Den lagstadgade tidsfristen (vanligtvis 30 dagar enligt [[TOK_0]] artikel 17) spåras automatiskt. Försenade ärenden flaggas för eskalering.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Upptäcktsöversikt',
            scans: 'Upptäcktsskanningar',
            staging_area: 'Mellanlagringsområde',
            dedup_rules: 'Dedupliceringsregler',
            classification_rules: 'Klassificeringsregler',
            suggestions: 'Förslagskö',
            analytics: 'Förslagsanalys',
            import_templates: 'Importmallar',
            connectors: 'Anslutningshantering',
            discovery_cycles: 'Upptäcktscykler',
            owner_review: 'Ägargranskning',
            classification_lineage: 'Klassificeringshistorik',
        },
        dashboard: {
            title: 'Upptäcktsöversikt',
            loading: 'Laddar instrumentpanelsdata...',
            total_scans: 'Totalt Skanningar',
            active_scans: 'Aktiva Skanningar',
            completed_30d: 'Slutförda (30d)',
            failed_30d: 'Misslyckade (30d)',
            systems_discovered: 'Upptäckta system',
            pending_staged_records: 'Väntande mellanlagrade poster',
            recent_scans: 'Senaste Skanningar',
            no_recent_scans: 'Inga senaste skanningar.',
            scan_id: 'Skanning ID',
            discovered: 'Upptäckt',
            view_all_scans: 'Visa Alla Skanningar',
            staging_area: 'Mellanlagringsområde',
            suggestion_queue: 'Förslag Kö',
            records_reviewed: 'Granskade poster',
            records_approved: 'Godkända poster',
            exceptions_pending: 'Väntande undantag',
            view_as_chart: 'Visa som diagram',
            view_as_table: 'Visa som tabell',
        },
        scans: {
            title: 'Upptäcktsskanningar',
            new: 'Ny Skanning',
            scan_id: 'Skanning ID',
            scan_type: 'Skanning Typ',
            progress: 'Framsteg',
            discovered: 'Upptäckt',
            no_scans: 'Inga upptäckt skanningar hittades.',
            all_scan_types: 'Alla Skanning Typer',
            source_config: 'Källa Konfiguration (JSON)',
            invalid_json: 'Ogiltig JSON in källa konfiguration',
            load_error: 'Kunde inte ladda upptäcktsskanningar. Försök igen.',
            create_error: 'Kunde inte skapa upptäcktsskanning',
            change_status: 'Ändra status',
            new_status: 'Ny status',
            actions: 'Åtgärder',
            type_endpoint: 'Slutpunkt',
            type_spreadsheet_import: 'Kalkylbladsimport',
            type_cmdb_sync: 'CMDB-synkronisering',
            type_cloud_sync: 'Molnsynkronisering',
            status_pending: 'Väntande',
            status_running: 'Körs',
            status_completed: 'Slutförd',
            status_failed: 'Misslyckad',
            status_cancelled: 'Avbruten',
            source_config_placeholder: '{"host": "...", "port": 443}',
        },
        staging_area: {
            title: 'Mellanlagringsområde',
            record_id: 'Post ID',
            source_scan: 'Källa Skanning',
            entity_type: 'Entitet Typ',
            suggested_name: 'Föreslagen Namn',
            confidence: 'Tillförlitlighet',
            no_records: 'Inga staged records hittades.',
            promote: 'Befordra',
            discard: 'Kassera',
            review: 'Granskning',
            merge: 'Sammanfoga',
            merge_title: 'Slå samman post',
            merge_target_id: 'Sammanfoga Mål ID',
            reject_reason_placeholder: 'Anledning till avvisning...',
            promotion_status: 'Befordran Status',
            dedup_status: 'Deduplicering Status',
            all_source_types: 'Alla Källa Typer',
            all_promotion_statuses: 'Alla Befordran Statusar',
            all_dedup_statuses: 'Alla Deduplicering Statusar',
            load_error: 'Kunde inte ladda mellanlagrade poster. Försök igen.',
            promote_error: 'Kunde inte befordra post',
            reject_error: 'Kunde inte avvisa post',
            merge_error: 'Kunde inte sammanfoga post',
            review_error: 'Kunde inte markera post för granskning',
            bulk_promote_error: 'Kunde inte massbefordra records',
            bulk_reject_error: 'Kunde inte massavvisa records',
            service_type_web_server: 'Webbserver',
            service_type_database: 'Databas',
            service_type_api_gateway: 'API-gateway',
            service_type_storage: 'Lagring',
            service_type_authentication: 'Autentisering',
            service_type_analytics: 'Analys',
            service_type_unknown: 'Okänd',
            source_type_endpoint_scan: 'Slutpunktsskanning',
            source_type_spreadsheet: 'Kalkylblad',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Molninventering',
            promotion_status_new: 'Ny',
            promotion_status_under_review: 'Under granskning',
            promotion_status_promoted: 'Befordrad',
            promotion_status_rejected: 'Avvisad',
            promotion_status_merged: 'Sammanfogad',
            dedup_status_unmatched: 'Ingen matchning',
            dedup_status_potential_match: 'Möjlig matchning',
            dedup_status_exact_match: 'Exakt matchning',
            dedup_status_resolved: 'Löst',
            confirm_bulk_reject: 'Är du säker på att du vill avvisa de valda posterna?',
            scan_batch_id: 'Batch-ID',
            promote_to_registry_title: 'Befordra till dataregistret',
            promote_modal_instructions: 'Skapar ett dataregisterobjekt med collection_method: observerad och härkomstlänkning till denna upptäcktspost. Objektet börjar i utkaststatus för granskning.',
            promote_label_category: 'Kategori',
            promote_label_name_override: 'Namn (valfri åsidosättning)',
            placeholder_name_override: 'Förinställer upptäcktspostens namn/värdnamn',
            promote_label_sensitivity: 'Föreslagen känslighet',
            inherit_from_category: 'Ärv från kategori',
        },
        dedup_rules: {
            title: 'Dedupliceringsregler',
            new: 'Ny Regel',
            rule_name: 'Regel Namn',
            match_fields: 'Matchningsfält',
            threshold: 'Tröskelvärde',
            no_rules: 'Inga deduplicering regler hittades.',
            seed_defaults: 'Initiera standardvärden',
            match_type: 'Matchningstyp',
            similarity_threshold: 'Likhet Tröskelvärde',
            field_name: 'Fält Namn',
            load_error: 'Kunde inte ladda dedupliceringsregler. Försök igen.',
            create_error: 'Kunde inte skapa dedupliceringsregel',
            toggle_error: 'Kunde inte växla dedupliceringsregel',
            seed_error: 'Kunde inte initiera standardvärden',
            priority: 'Prioritet',
            enabled_status: 'Aktiverad',
            disabled_status: 'Inaktiverad',
            default_badge: 'Standard',
            enable: 'Aktivera',
            disable: 'Inaktivera',
            match_type_exact: 'Exakt',
            match_type_fuzzy: 'Ungefärlig',
            match_type_regex: 'Regex',
            match_type_ip_range: 'IP-intervall',
        },
        classification_rules: {
            title: 'Klassificeringsregler',
            new: 'Ny Regel',
            rule_name: 'Regel Namn',
            pattern: 'Mönster',
            classification: 'Klassificering',
            no_rules: 'Inga classification rules hittades.',
            seed_defaults: 'Initiera standardvärden',
            run_rules_now: 'Kör regler nu',
            run_rules_success: 'Genererade [[TOK_1]] nya klassificeringsförslag',
            run_rules_no_results: 'Inga nya förslag har genererats – alla matchande regler har redan väntande förslag',
            run_rules_error: 'Det gick inte att köra klassificeringsregler. Försök igen.',
            taxonomy_id: 'Taxonomi ID',
            level_id: 'Nivå ID',
            condition_logic: 'Villkor Logik',
            weight: 'Vikt',
            conditions: 'Villkor',
            condition_field: 'Fält',
            condition_operator: 'Operatör',
            condition_value: 'Värde',
            effectiveness: 'Effektivitet',
            match_count: 'Matchningar',
            approval_count: 'Godkännanden',
            rejection_count: 'Avvisningar',
            filter_taxonomy: 'Filter per Taxonomi ID...',
            load_error: 'Kunde inte ladda klassificeringsregler. Försök igen.',
            create_error: 'Kunde inte skapa klassificeringsregel',
            seed_error: 'Kunde inte initiera standardvärden',
            toggle_error: 'Kunde inte växla regel. Försök igen.',
            priority: 'Prioritet',
            enabled_status: 'Aktiverad',
            disabled_status: 'Inaktiverad',
            enable: 'Aktivera',
            disable: 'Inaktivera',
            logic_and: 'OCH',
            logic_or: 'ELLER',
            operator_equals: 'Lika med',
            operator_contains: 'Innehåller',
            operator_matches_regex: 'Matchar Regex',
            operator_in_list: 'I listan',
            operator_not_equals: 'Inte lika med',
            operator_not_contains: 'Innehåller inte',
            enabled_label: 'Aktiverad',
            disabled_label: 'Inaktiverad',
            taxonomy_label: 'Taxonomi',
            operator_label: 'Operatör',
            value_label: 'Värde',
        },
        suggestions: {
            title: 'Förslagskö',
            entity_type: 'Entitet Typ',
            suggested_name: 'Föreslagen Namn',
            source: 'Källa',
            confidence: 'Tillförlitlighet',
            accept: 'Acceptera',
            reject: 'Avvisa',
            no_suggestions: 'Inga förslag i kö.',
            modify_approve: 'Ändra & Godkänn',
            delegate: 'Delegera',
            delegate_user_id: 'Delegera Användare ID',
            new_level_id: 'Ny Nivå ID',
            reject_reason_placeholder: 'Anledning till avvisning...',
            current_level: 'Aktuell Nivå',
            suggested_level: 'Föreslagen Nivå',
            filter_taxonomy: 'Filter per Taxonomi ID...',
            all_confidence: 'Alla Tillförlitlighet Band',
            load_error: 'Kunde inte ladda förslag. Försök igen.',
            approve_error: 'Kunde inte godkänna förslag',
            reject_error: 'Kunde inte avvisa förslag',
            modify_error: 'Kunde inte ändra och godkänna förslag',
            delegate_error: 'Kunde inte delegera förslag',
            bulk_approve_error: 'Kunde inte massgodkänna förslag',
            bulk_reject_error: 'Kunde inte massavvisa förslag',
            suggestion_type_new_label: 'Ny etikett',
            suggestion_type_validation: 'Validering',
            suggestion_type_reclassification: 'Omklassificering',
            status_pending: 'Väntande',
            status_approved: 'Godkänd',
            status_rejected: 'Avvisad',
            status_superseded: 'Ersatt',
            confidence_high: 'Hög',
            confidence_medium: 'Medel',
            confidence_low: 'Låg',
            confirm_bulk_reject: 'Är du säker på att du vill avvisa de valda förslagen?',
        },
        analytics: {
            title: 'Förslagsanalys',
            total_suggestions: 'Totalt Förslag',
            accepted: 'Accepterad',
            rejected: 'Avvisad',
            pending: 'Väntande',
            acceptance_rate: 'Acceptans Frekvens',
            by_entity_type: 'Per Entitet Typ',
            by_source: 'Per Källa',
            avg_decision_time: 'Gns. Beslut Tid',
            rule_effectiveness: 'Regel Effektivitet',
            by_status: 'Per Status',
            by_confidence: 'Per Tillförlitlighet Band',
            load_error: 'Kunde inte ladda förslagsanalys. Försök igen.',
            confidence_high: 'Hög',
            confidence_medium: 'Medel',
            confidence_low: 'Låg',
            by_confidence_band: 'Efter konfidensnivå',
            approval_rate: 'Godkännandegrad',
            by_label_state: 'Efter etikettstatus',
        },
        import_templates: {
            title: 'Importmallar',
            new: 'Ny Mall',
            template_name: 'Mall Namn',
            file_format: 'Fil Format',
            column_mappings: 'Kolumn Mappningar',
            no_templates: 'Inga import mallar hittades.',
            source_column: 'Källa Kolumn',
            target_field: 'Mål Fält',
            transform: 'Transformera',
            source_column_label: 'Källkolumn',
            target_field_label: 'Målfält',
            transform_label: 'Förvandla',
            confirm_delete: 'Är du säker på att du vill radera denna importmall?',
            load_error: 'Kunde inte ladda importmallar. Försök igen.',
            save_error: 'Kunde inte spara importmall',
            delete_error: 'Kunde inte radera importmall',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Anslutningshantering',
            new: 'Ny Koppling',
            connector_name: 'Koppling Namn',
            connector_type: 'Typ',
            last_sync: 'Senaste Synkronisering',
            no_connectors: 'Inga kopplingar hittades.',
            cmdb_syncs: 'CMDB Synkroniseringar',
            cloud_syncs: 'Moln Synkroniseringar',
            new_sync: 'Ny Synkronisering',
            no_syncs: 'Inga synkroniseringar hittades.',
            cmdb_error: 'Kunde inte ladda CMDB-skanningar. Försök igen.',
            cloud_error: 'Kunde inte ladda molnskanningar. Försök igen.',
            trigger_error: 'Kunde inte utlösa synkronisering',
            trigger_sync_error: 'Kunde inte trigger {type}',
            cmdb_section_title: 'CMDB-synkroniseringar',
            cloud_section_title: 'Molnsynkroniseringar',
            column_connector: 'Koppling',
            action_start: 'Starta',
            confirm_cancel_sync: 'Avbryta denna synkronisering?',
            start_error: 'Det gick inte att starta synkronisering',
            cancel_error: 'Det gick inte att avbryta synkronisering',
            type_endpoint: 'Slutpunktsskanning',
            type_spreadsheet_import: 'Kalkylbladsimport',
            type_cmdb_sync: 'CMDB-synkronisering',
            type_cloud_sync: 'Molnsynkronisering',
        },
        discovery_cycles: {
            title: 'Upptäcktscykler',
            new_cycle: 'Ny upptäcktscykel',
            cycle_name: 'Cykelnamn',
            scope_type: 'Omfångstyp',
            scope_ids: 'Omfångs-ID',
            cadence_days: 'Kadens (dagar)',
            status: 'Status',
            no_cycles: 'Inga upptäcktscykler hittades',
            compare: 'Jämför cykler',
            delta_report: 'Ändringsrapport',
            new_records: 'Nya poster',
            changed_records: 'Ändrade poster',
            removed_records: 'Borttagna poster',
            schedule: 'Schemalägg skanning',
            scope_organization: 'Organisation',
            scope_department: 'Avdelning',
            scope_system: 'System',
            scope_systems: 'System',
            bulk_actions: 'Massåtgärder',
            selected: '{count} markerade',
            bulk_create: 'Masskapa',
            bulk_assign_scope: 'Masstilldela omfattning',
            bulk_advance: 'Massavancera status',
            confirm_bulk_action: 'Bekräfta massåtgärd',
            bulk_confirm_message: 'Är du säker på att du vill utföra denna åtgärd?',
            cycles_affected: '{count} cykler kommer att påverkas',
            select_all: 'Markera alla',
            select_cycle: 'Välj cykel {name}',
            from_template: 'från mall',
            bulk_results: 'Massresultat',
            failed_label: 'misslyckades',
            template_id: 'Mall-ID',
            count: 'Antal',
            advance_to: 'Målstatus',
            bulk_success: 'Massåtgärd slutförd',
        },
        owner_review: {
            title: 'Ägargranskningsuppgifter',
            assign_owner: 'Tilldela till ägare',
            owner_id: 'Ägare',
            decision: 'Beslut',
            approve: 'Godkänn',
            modify: 'Ändra',
            reject: 'Avvisa',
            escalate: 'Eskalera',
            no_tasks: 'Inga granskningsuppgifter hittades',
            bulk_resolve: 'Masslösning',
            exceptions: 'Undantagsposter',
            no_exceptions: 'Inga undantagsposter hittades',
            record_id_label: 'Record ID',
            selected: 'vald',
            notes: 'Anteckningar',
            select_all: 'Välj Alla',
            select: 'Välj',
            confirm_resolve: 'Bekräfta',
        },
        classification_lineage: {
            title: 'Klassificeringshistorik',
            link_suggestion: 'Länka till föreslagen etikett',
            suggestion_id: 'Förslag',
            proposed_label_id: 'Föreslagen etikett',
            no_lineage: 'Ingen historikdata hittades',
            full_lineage: 'Fullständig historik',
            record_id_label: 'Record ID',
            staged_record_label: 'iscensatt rekord',
            enter_staged_record_id: 'Ange etapp-ID',
            scan_id_label: 'Skanna ID',
            select_record: 'Välj en post',
            select_suggestion: 'Välj ett förslag',
            select_label: 'Välj en etikett',
        },
        common_labels: {
            n_rules: '[[TOK_1]] regler',
            one_rule: '1 regel',
            n_scans: '[[TOK_1]] skannar',
            one_scan: '1 skanning',
            n_syncs: '[[TOK_1]] synkroniseras',
            one_sync: '1 synk',
            n_records: '[[TOK_1]] poster',
            one_record: '1 rekord',
            n_templates: '[[TOK_1]] mallar',
            one_template: '1 mall',
            n_suggestions: '[[TOK_1]] förslag',
            one_suggestion: '1 förslag',
            n_selected: '[[TOK_1]] har valts',
            dashboard_loaded: 'Discovery-instrumentpanelen har laddats',
            n_scans_loaded: '[[TOK_1]] skanningar laddade',
            n_staged_records_loaded: '[[TOK_1]] iscensatta poster laddade',
            confirm_delete_import_template: 'Är du säker på att du vill ta bort den här importmallen?',
            invalid_json_source_config: 'Ogiltig [[TOK_0]] i source_config',
            scope_organization: 'Organisation',
            scope_department: 'Avdelning',
            scope_system: 'System',
            aria_filter_scans: 'Filterskanningar',
            aria_filter_staged_records: 'Filtrera iscensatta poster',
            aria_filter_suggestions: 'Filter',
            aria_filter_by_taxonomy_id: 'Filtrera efter taxonomi-ID',
            aria_filter_by_enabled_status: 'Filtrera efter aktiverad status',
            aria_filter_by_source_type: 'Filtrera efter källtyp',
            aria_filter_by_promotion_status: 'Filtrera efter kampanjstatus',
            aria_filter_by_dedup_status: 'Filtrera efter dedup-status',
            aria_filter_by_scan_type: 'Filtrera efter skanningstyp',
            aria_filter_by_status: 'Filtrera efter status',
            aria_filter_by_confidence: 'Filtrera efter konfidensband',
            aria_select_all_records: 'Välj alla poster',
            aria_select_record: 'Välj post [[TOK_1]]',
            aria_select_all_suggestions: 'Välj alla förslag',
            aria_select_suggestion: 'Välj förslag [[TOK_1]]',
            aria_promote_record: 'Marknadsför rekord [[TOK_1]]',
            aria_discard_record: 'Släng post [[TOK_1]]',
            aria_merge_record: 'Slå samman post [[TOK_1]]',
            aria_review_record: 'Granska posten [[TOK_1]]',
            aria_accept_suggestion: 'Acceptera förslag [[TOK_1]]',
            aria_reject_record: 'Avvisa post',
            aria_merge_record_dialog: 'Slå samman post',
            aria_create_new_scan: 'Skapa ny skanning',
            aria_sync_progress: 'Synkroniseringsförlopp: [[TOK_2]] av [[TOK_3]] objekt bearbetade',
            aria_scan_progress: 'Skanningsförlopp: [[TOK_2]] av [[TOK_3]] objekt bearbetade',
            aria_confidence: 'Förtroende: [[TOK_1]]%',
            aria_effectiveness: 'Effektivitet: [[TOK_1]]',
            aria_promote_n_records: 'Marknadsför [[TOK_1]] valda poster',
            aria_discard_n_records: 'Släng [[TOK_1]] valda poster',
            placeholder_pii_detection_rule: 't.ex. PII-detekteringsregel',
            placeholder_tax_id: 't.ex. TAX-001',
            placeholder_lvl_id: 't.ex. LVL-001',
            placeholder_service_type: 't.ex. service_type',
            placeholder_database: 't.ex. databas',
            placeholder_hostname_match: 't.ex. Exakt matchning av värdnamn',
            placeholder_hostname: 't.ex. värdnamn',
            placeholder_hr_systems_csv: 't.ex. HR Systems [[TOK_0]] import',
            placeholder_server_name: 't.ex. servernamn',
            placeholder_hostname_field: 't.ex. värdnamn',
            placeholder_lowercase: 't.ex. gemener',
            placeholder_source_config: '{"host": "...", "port": 443}',
            placeholder_stg_id: 't.ex. STG-000123',
            placeholder_lvl_002: 't.ex. LVL-002',
            placeholder_usr_id: 't.ex. USR-000123',
            decision_for: 'Beslut för [[TOK_1]]',
        },
        exports: {
            title: 'Exportera',
            inventory: 'Datainventering',
            classification_register: 'Klassificeringsregister',
            raci: 'RACI-matris',
            exceptions: 'Undantagsrapport',
            evidence_pack: 'Bevispaket',
            delta_report: 'Ändringsrapport',
            executive_summary: 'Ledningssammanfattning',
            export_button: 'Exportera',
            downloading: 'Laddar ner...',
            download_complete: 'Nedladdning klar.',
            download_error: 'Kunde inte ladda ner export. Försök igen.',
        },
        flags: {
            title: 'Nedströmsmarkeringar',
            pending: 'Väntande markeringar',
            cross_border_review_needed: 'Gränsöverskridande granskning krävs',
            sharing_disclosure_needed: 'Delningsupplysning krävs',
            dpia_review_needed: 'DPIA-granskning krävs',
            acknowledge: 'Bekräfta',
            resolve: 'Lös',
            no_flags: 'Inga nedströmsmarkeringar.',
        },
        delta: {
            title: 'Ändringsöversikt',
            new_count: '{n} nya',
            removed_count: '{n} borttagna',
            changed_count: '{n} ändrade',
            re_review_triggered: 'Omgranskning utlöst',
            create_re_review: 'Skapa omgranskning',
            recent_alerts: 'Senaste ändringsvarningar',
            no_alerts: 'Inga senaste ändringsvarningar.',
            threshold_exceeded: 'Ändringströskel överskriden (>10 %)',
        },
        regulatory: {
            dashboard_governance_info: 'Den här instrumentbrädan visar förvaltningsstatus på cykelnivå: system som skannats, poster arrangerade, granskade poster, godkända poster och väntande undantag. Detta matchar framgångskriterierna för styrning av leads: "livsöversikt över vem som har uppdaterat sin inventering, klassificering och delningsloggar" (P-VN-05).',
            export_artifacts_info: 'Upptäcktsexporter inkluderar alla nödvändiga artefakttyper per UC-VN-10 och DATA-EVD-01: godkänd datainventering, klassificeringsregister, ägande/RACI-mappning, undantagskö, sammanfattning, bevispaket och deltarapport.',
            scan_inventory_pipeline_info: 'Varje genomförd skanning producerar poster som är kompatibla med mallen vn_data_law_data_inventory_register (krav 88dd9877). Upptäckta datatillgångar fyller automatiskt i datainventeringsregistret för att uppfylla datalagens skyldighet att upprätthålla en digital datainventering.',
            connector_linkage_info: 'Varje anslutningskonfiguration måste inkludera: systemtyp (t.ex. [[TOK_0]], molnplattform), datalagerreferens (databas, filarkiv, SaaS) och affärsprocesslänkning (UC-VN-10 krävs stödjande poster). Dessa fält säkerställer att upptäckta tillgångar kan spåras till deras källsystem och affärssammanhang.',
            owner_routing_info: 'Granskningsuppgifter dirigeras till rätt avdelning eller applikationsägare baserat på system-/dataägande (UC-VN-10 steg 5). Routing använder systemets ägarregister, inte ad hoc-tilldelning.',
            owner_actions_audit_info: 'Ägare kan godkänna, ändra, avvisa eller eskalera varje klassificering (UC-VN-10 steg 6). Varje åtgärd fångar aktör, tidsstämpel och skäl, och producerar händelser för styrning av revisionsbevis enligt krav f12fc090 (Årligt styrningsintyg). Revisionsspåret visar vem som granskade, vad som ändrades och när.',
            escalation_timers_info: 'Eskaleringstimer: deadline för ägarens recension är 5 arbetsdagar; eskalering av undantag är 48 timmar (UC-VN-10 timers). Olösta objekt eskalerar automatiskt när tidsfristen går ut. Timers kan konfigureras enligt organisationens policy.',
            original_suggestion_preserved_info: 'Det ursprungliga maskin-/systemklassificeringsförslaget bevaras tillsammans med varje åsidosättande av ägaren (UC-VN-10 beviskrav). Det ursprungliga förslaget skrivs aldrig över och förblir synligt för revisionsändamål.',
            dedup_lineage_info: 'Dedupliceringsregler förhindrar dubbletter av inventeringsposter när samma datatillgång upptäcks över flera skanningar eller kopplingar. Den senaste skanningsmetadatan bevaras som den primära posten samtidigt som det bibehålls härstamningsreferenser till alla tidigare upptäckter för granskningsspårbarhet.',
            label_states_info: 'Analytics särskiljer fyra etiketttillstånd för förvaltningsgranskning: maskinföreslagen (väntande), ägaregodkänd, ägaremodifierad och avvisad. Dessa tillstånd gör det möjligt för revisorer att bedöma automatiseringsnoggrannhet och ägarnas engagemang.',
            import_pipeline_info: 'Importmallar måste producera poster som är kompatibla med upptäcktspipelinen. Importerade poster går in i fas med samma metadatakrav som skannade poster: källsystemidentifiering, batch-ID och tidsstämpel. Kolumnmappningar bör riktas mot fält definierade i vn_data_law_data_inventory_register.',
            lineage_full_path_info: 'Klassificeringslinjen spårar hela vägen: skanna/importera -> iscensättning -> ägarens recension -> godkänd etikett -> registerinmatning (UC-VN-10 steg 1-10). Varje steg visar post-ID, aktör, tidsstämpel och tillståndsövergång för fullständig granskningsspårbarhet.',
            staging_workflow_info: 'Etapperade poster särskiljs visuellt från godkända lagerposter genom deras kampanjstatusmärke (UC-VN-10 steg 3). Varje post behåller härkomstmetadata: källsystem, skanningsbatch-ID och upptäcktstidsstämpel för fullständig granskningsspårbarhet.',
            suggestion_data_d1_info: 'Förslag överensstämmer med datalagsklassificeringsproceduren DATA-D1: (1) katalogisera datatillgångar, (2) klassificera efter känslighetsnivå, (3) definiera hanteringsregler. Varje förslag inkluderar känslighets- och betydelsedimensioner per krav 18e4bfd1.',
            downstream_flags_info: 'Objekt som flaggats för delning, gränsöverskridande överföring eller högriskbehandling utlöser länkade nedströmsarbetsflöden: bedömning av gränsöverskridande överföring, bedömning av riskdelning och [[TOK_0]] granskning (UC-VN-10 steg 8).',
            delta_detection_info: 'Upptäcktscykler stöder deltadetektering per UC-VN-10 steg 11: varje cykel visar vilka poster som är nya, ändrade eller borttagna sedan den senast godkända baslinjen. Materialförändringar (>10 % delta) utlöser automatiskt arbetsflöden för ny granskning.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Kunde inte ladda.',
            save: 'Kunde inte spara.',
            fetch_escalation_log_failed: 'Kunde inte hämta eskaleringslogg.',
            fetch_activations_failed: 'Kunde inte hämta aktiveringar.',
            deactivate_failed: 'Kunde inte inaktivera.',
            complete_activation_failed: 'Kunde inte slutföra activation.',
            fetch_playbook_templates_failed: 'Kunde inte hämta spelboksmallar.',
            create_playbook_template_failed: 'Kunde inte skapa spelboksmall.',
            clone_template_failed: 'Kunde inte klona mall.',
            update_status_failed: 'Kunde inte uppdatera status.',
            deprecate_template_failed: 'Kunde inte fasa ut mall.',
            seed_defaults_failed: 'Kunde inte initiera standardvärden.',
            fetch_regulator_exports_failed: 'Kunde inte hämta myndighetsexporter.',
            create_regulator_export_failed: 'Kunde inte skapa myndighetsexport.',
            update_submission_status_failed: 'Kunde inte uppdatera inlämningsstatus.',
            fetch_response_metrics_failed: 'Kunde inte hämta svarsmått.',
            fetch_sla_dashboard_failed: 'Kunde inte hämta SLA-instrumentpanel.',
            fetch_sla_definitions_failed: 'Kunde inte hämta SLA-definitioner.',
            create_sla_definition_failed: 'Kunde inte skapa SLA-definition.',
            seed_sla_defaults_failed: 'Kunde inte initiera SLA-standardvärden.',
            fetch_vendor_coordination_failed: 'Kunde inte hämta leverantörskoordinering.',
            fetch_vendor_detail_failed: 'Kunde inte hämta leverantörsdetalj.',
            create_vendor_coordination_failed: 'Kunde inte skapa leverantörskoordinering.',
            add_communication_failed: 'Kunde inte lägga till kommunikation.',
            add_info_request_failed: 'Kunde inte lägga till infobegäran.',
            add_action_request_failed: 'Kunde inte lägga till åtgärdsbegäran.',
        },
        nav: {
            playbooks: 'Handlingsplanmallar',
            sla_definitions: 'SLA-definitioner',
            sla_dashboard: 'SLA-översikt',
            escalation_log: 'Eskaleringslogg',
            regulator_exports: 'Myndighetsexporter',
            deadlines: 'Avisering Deadlines',
            vendor_coordination: 'Leverantörssamordning',
            metrics: 'Svarsmått',
            playbook_links: 'Spelbokslänkar',
            regulatory_sla: 'Regulatorisk SLA',
            coordination_dashboard: 'Samordning',
            evidence_chain: 'Beviskedja',
            post_review: 'Efterincidentgranskning',
        },
        playbooks: {
            page_title: 'Playbook mallar',
            activations_page_title: 'Playbook-aktiveringar',
            title: 'Handlingsplanmallar',
            new: 'Ny Mall',
            seed_defaults: 'Initiera standardvärden',
            scenario_type: 'Scenario Typ',
            severity_applicability: 'Allvarlighetsgrad Tillämplighet',
            all_scenario_types: 'Alla Scenario Typer',
            new_playbook: 'Ny Spelbok Mall',
            clone: 'Klona',
            clone_template: 'Klona Mall',
            template_name: 'Mall namn',
            deprecate: 'Fasa ut',
            confirm_deprecate: 'Fasa ut mall "{name}"?',
            create_template: 'Skapa Mall',
            update_status: 'Uppdatering Status',
            no_templates: 'Inga spelbok mallar hittades',
            deactivation_reason_placeholder: 'Anledning till inaktivering...',
            description_placeholder: 'Spelbok beskrivning...',
            name_placeholder: 'Spelbok namn...',
        },
        sla_definitions: {
            page_title: 'SLA-definitioner',
            title: 'SLA-definitioner',
            new: 'Ny SLA-definition',
            sla_name: 'SLA Namn',
            target_hours: 'Mål Timmar',
            escalation_after: 'Eskalering efter',
            applies_to: 'Gäller för',
            no_definitions: 'Inga sla definitions hittades.',
            target_value_placeholder: 'Mål värde',
            name_placeholder: 'SLA namn...',
            threshold_hours_label: 'Tröskeltimmar',
            severity_label: 'Allvarlighetsgrad',
            all_types: 'Alla typer',
            all_severities: 'Alla allvarlighetsgrader',
            default_label: 'Standard',
        },
        sla_dashboard: {
            compliant: 'Överensstämmer',
            page_title: 'SLA-översikt',
            title: 'SLA-översikt',
            loading: 'Laddar SLA-data...',
            compliance_rate: 'Efterlevnad Frekvens',
            breached: 'Överträdd',
            at_risk: 'Vid Risk',
            on_track: 'På Spår',
            by_severity: 'Per Allvarlighetsgrad',
            total_records: 'Totalt antal poster',
            met: 'Uppfylld',
            sla_records: 'SLA-poster',
            sla_reference: 'SLA-referens',
            record_id: 'Post-ID',
            metric_type: 'Mätningstyp',
            severity: 'Allvarlighet',
            elapsed: 'Förfluten',
            clock_start: 'Klockstart',
        },
        escalation_log: {
            page_title: 'Eskaleringslogg',
            title: 'Eskaleringslogg',
            incident_id: 'Incident-ID',
            escalated_by: 'Eskalerade Per',
            escalated_to: 'Eskalerade Till',
            reason: 'Anledning',
            escalated_at: 'Eskalerade Vid',
            no_escalations: 'Inga eskaleringar hittades.',
            filter_incident_id: 'Filter per Incident ID',
            escalation_id: 'Eskalerings-ID',
            level: 'Nivå',
            level_range: 'Nivå (L1–L4)',
            create_escalation: 'Skapa eskalering',
            incident_id_placeholder: 't.ex. INC-001',
            target_role_placeholder: 't.ex. dpo, incident_manager',
            select_placeholder: '— välj —',
        },
        regulator_exports: {
            page_title: 'Tillsynsmyndighetsexporter',
            title: 'Myndighetsexporter',
            new: 'Ny Export',
            incident_id: 'Incident-ID',
            regulator: 'Tillsynsmyndighet',
            export_format: 'Filformat',
            exported_at: 'Exporterad den',
            no_exports: 'Inga regulator exports hittades.',
            enter_incident_id: 'Ange Incident ID',
            export_id: 'Export-ID',
            watermark: 'Vattenstämpel',
            submission_status: 'Inlämningsstatus',
            all_jurisdictions: 'Alla jurisdiktioner',
            no_transitions: 'Inga ytterligare övergångar tillgängliga från',
            select_new_status: '— välj ny status —',
            sections_included: 'Inkluderade sektioner',
            form_classification: 'Klassificering',
            submission_channel: 'Kanal',
        },
        deadlines: {
            title: 'Avisering Deadlines',
            incident_id: 'Incident-ID',
            deadline: 'Tidsfrist',
            regulator: 'Tillsynsmyndighet',
            remaining: 'Återstående',
            no_deadlines: 'Inga avisering deadlines hittades.',
        },
        vendor_coordination: {
            page_title: 'Leverantörssamordning',
            title: 'Leverantörssamordning',
            new: 'Ny Koordinering',
            incident_id: 'Incident-ID',
            vendor_name: 'Leverantör Namn',
            contact: 'Kontakt',
            coordination_status: 'Koordinering Status',
            no_items: 'Inga leverantör koordinering objekt hittades.',
            assessment_placeholder: 'Initial bedömning från leverantör...',
            coordination_id: 'Samordnings-ID',
            communications: 'Kommunikationer',
            info_requests: 'Infoförfrågningar',
            action_requests: 'Åtgärdsbegäranden',
            direction: 'Riktning',
            channel_label: 'Kanal',
            no_transitions: 'Inga ytterligare övergångar tillgängliga.',
            vendor_ref_number: 'Referensnummer',
            report_date: 'Rapportdatum',
            contact_email: 'E-post',
            contact_phone: 'Telefon',
            channel_email: 'E-post',
            channel_meeting: 'Möte',
            channel_phone: 'Telefon',
            channel_portal: 'Portalen',
            incident_id_placeholder: 'Filter per Incident ID...',
            priority_critical: 'Kritisk',
            priority_high: 'Hög',
            priority_low: 'Low',
            priority_medium: 'Medel',
            vendor_id_placeholder: 'Filter per Leverantör ID...',
            description_placeholder: 'Beskrivning...',
            filter_vendor_id: 'Filter per Leverantör ID',
            inbound: 'Inkommande',
            outbound: 'Utgående',
            summary_placeholder: 'Sammanfattning...',
            priority_label: 'Prioritet',
            due_date_label: 'Förfallodatum',
            info_request_desc: 'Beskrivning av informationsförfrågan',
            action_request_desc: 'Beskrivning av åtgärdsbegäran',
            content_label: 'Innehåll',
            select_incident: 'Välj Incident',
            select_vendor: 'Välj Leverantör',
            discovery_date: 'Upptäckt Datum',
        },
        metrics: {
            page_title: 'Svarsmätningar',
            title: 'Svarsmått',
            loading: 'Laddar måttdata...',
            avg_response_time: 'Gns. Svar Tid',
            avg_resolution_time: 'Gns. Lösning Tid',
            total_incidents: 'Totalt Incidenter',
            by_severity: 'Per Allvarlighetsgrad',
            by_status: 'Per Status',
            trend: 'Tendens',
            start_sla_clock: 'Starta SLA-klocka',
            sla_records: '[[TOK_0]] Rekord',
            no_sla_records: 'Inga SLA-poster ännu.',
            record_id: 'Record ID',
            severity: 'Allvarlighet',
            progress: 'Framsteg',
            incident_id_required: 'Incident-ID krävs',
            sla_definition_required: 'SLA-definition krävs',
            metric_type_required: 'Mätningstyp krävs',
            threshold_required: 'Tröskeltimmar krävs',
            sla_clock_started: 'SLA-klocka startad',
            sla_definition: 'SLA-definition',
            no_definitions: 'Inga SLA-definitioner hittades.',
            select_definition: 'Välj SLA-definition...',
            select_metric_type: 'Välj mätningstyp...',
            select_severity: 'Välj allvarlighetsgrad...',
            threshold_hours: 'Tröskel (timmar)',
            warning_threshold_pct: 'Varningströskel (%)',
            start_clock: 'Starta klocka',
            starting: 'Startar...',
            metric_label: 'Mätning',
            value_label: 'Värde',
            incident_id: 'Incident-ID',
            threshold_placeholder: 't.ex. 24',
            metric_types: {
                triage_time: 'Triagetid',
                containment_time: 'Begränsningstid',
                notification_time: 'Notifieringstid',
                resolution_time: 'Lösningstid',
            },
            severities: {
                critical: 'Kritisk',
                high: 'Hög',
                medium: 'Medel',
                low: 'Low',
            },
        },
        playbook_links: {
            page_title: 'Playbooklänkar',
            title: 'Spelbok-aviseringslänkar',
            new_link: 'Länka spelbok till avisering',
            activation_id: 'Aktiverings-ID',
            notification_id: 'Aviserings-ID',
            select_activation: 'Välj en aktivering...',
            select_notification: 'Välj en avisering...',
            no_links: 'Inga spelbokslänkar hittades',
            seed_pdpl: 'Initiera PDPL-spelböcker',
            created: 'Playbook-länk skapad',
            seeded: '[[TOK_0]] lekböcker seedade',
            create_failed: 'Det gick inte att skapa länk till spelboken',
            seed_failed: 'Det gick inte att se [[TOK_0]] spelböcker',
        },
        regulatory_sla: {
            page_title: 'Regulatoriska SLA-mappningar',
            title: 'Regulatoriska SLA-mappningar',
            new_mapping: 'Ny SLA-mappning',
            sla_definition: 'SLA-definition',
            select_sla_definition: 'Välj en SLA-definition...',
            framework_code: 'Ramverkskod',
            deadline_type: 'Tidsfristtyp',
            deadline_hours: 'Tidsfrist i timmar',
            auto_escalate: 'Autoeskalering',
            seed_pdpl: 'Initiera PDPL-standardvärden',
            no_mappings: 'Inga regulatoriska SLA-mappningar hittades',
            dashboard: 'Regulatorisk SLA-översikt',
            deadline_types: {
                initial_notification: 'Första meddelande',
                supplement_response: 'Komplettera svar',
                authority_response: 'Myndighetssvar',
                remediation_report: 'Saneringsrapport',
            },
            statutory_reference: 'Laghänvisning',
        },
        coordination_dashboard: {
            page_title: 'Samordningsöversikt',
            title: 'Samordningsöversikt',
            incident_id: 'Incident-ID',
            select_incident: 'Välj en incident...',
            team_role: 'Teamroll',
            members: 'Medlemmar',
            tasks: 'Uppgifter',
            sla_status: 'SLA-status',
            no_teams: 'Inga samordningsteam hittades',
            new_team: 'Nytt samordningsteam',
            enter_incident_id: 'Ange ett incident-ID för att visa samordningsteam.',
            member_ids_placeholder: 'användare1, användare2',
            edit_team: 'Redigera team',
            task_count: 'Uppgiftsräkning',
            tasks_completed: 'Slutförda',
            team_roles: {
                security: 'Säkerhet',
                legal: 'Juridik',
                it: 'IT',
                management: 'Ledning',
                department_owner: 'Avdelningsägare',
                external: 'Extern',
            },
        },
        evidence_chain: {
            page_title: 'Beviskedja',
            title: 'Beviskedja',
            new_entry: 'Ny bevispost',
            select_incident: 'Välj en incident...',
            actor: 'Aktör',
            select_actor: 'Välj en aktör...',
            evidence_id: 'Bevis-ID',
            action: 'Åtgärd',
            recipient: 'Mottagare',
            no_entries: 'Inga beviskedjeposter hittades',
            enter_incident_id: 'Ange ett incident-ID för att visa beviskedja.',
            evidence_id_placeholder: 't.ex. EVD-2026-0001',
            evidence_id_help: 'En unik referens till bevismaterialet – en loggfil, en diskavbildning eller en skärmbild. Ett förslag är förifyllt; redigera det så att det matchar din beviskatalog.',
            select_incident_first: 'Välj en incident ovan innan du lägger till en bevispost.',
            for_incident: 'För incident',
            actions: {
                collected: 'Samlade',
                shared: 'Delad',
                exported: 'Exporterad',
                archived: 'Arkiverad',
            },
        },
        post_review: {
            page_title: 'Efterincidentgranskning',
            title: 'Efterincidentgranskning',
            new_review: 'Ny granskning',
            select_incident: 'Välj en incident...',
            lessons_learned: 'Lärdomar',
            recommendations: 'Rekommendationer',
            improvement_actions: 'Förbättringsåtgärder',
            submit_for_review: 'Skicka för granskning',
            aria_submit_review: 'Skicka granskning {name} för granskning',
            aria_sign_off: 'Godkänn granskning {name}',
            sign_off: 'Godkännande',
            no_reviews: 'Inga efterincidentgranskningar hittades',
            enter_incident_id: 'Ange ett incident-ID för att visa efterincidentgranskning.',
            one_per_line: 'En per rad',
            statuses: {
                draft: 'Utkast',
                in_review: 'Under granskning',
                signed_off: 'Godkänd',
                closed: 'Stängd',
            },
        },
        activations: {
            title: 'Playbook-aktiveringar',
            activation_id: 'Aktiverings-ID',
            phases: 'Faser',
            activated_at: 'Aktiverad kl',
            activated_by: 'Aktiverad av',
            deactivate: 'Inaktivera',
            complete: 'Slutför',
            deactivation_reason: 'Anledning till inaktivering',
            evidence_button: 'Bevis',
            evidence_modal_title: 'Aktiveringsbevis',
            no_evidence: 'Inga bevis kopplade till denna aktivering.',
            upload_evidence_label: 'Ladda upp aktiveringsbevis',
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Led mig genom luckor',
            running: 'Glappar...',
            results_heading: 'Förbättring färdplan ([[TOK_2]] gap[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_gaps: 'Inga luckor upptäcktes – alla domäner vid eller över målet.',
            col_priority: 'Prioritet',
            col_domain: 'Domän',
            col_levels: 'Aktuell → Mål',
            col_severity: 'Allvarlighet',
            col_actions: 'Saneringsåtgärder',
            citations_label: 'Citat',
            accept_label: 'Acceptera färdplanen',
            reject_label: 'Avvisa utkastet',
            export_label: 'Exportera [[TOK_0]]',
            exported_label: 'Färdkarta exporterad',
            accept_hint: 'Acceptera registrerar färdplanen på det kvarstående utkastet. Använd Exportera [[TOK_0]] för att generera leveransen; operatören klistrar tillbaka improvement_actions i bedömningen.',
            resolve_summary: 'Upplösning: [[TOK_1]]',
            error_generic: 'Kunde inte köra gap walkthrough. Försök igen eller kontrollera bedömningsstatusen.',
        },
        policy_gap: {
            run_label: 'Upptäck politiska luckor',
            running: 'Upptäcker luckor...',
            results_heading: 'Policyluckor ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_gaps: 'Inga täckningsluckor upptäcktes.',
            col_severity: 'Allvarlighet',
            col_kind: 'Snäll',
            col_clause: 'Klausul/krav',
            kind_missing: 'Saknas klausul',
            kind_weak: 'Svag täckning',
            kind_stale: 'Inaktuell (recension försenad)',
            remediation_label: 'Föreslagen sanering',
            citations_label: 'Citat',
            accept_label: 'Acceptera gaprapport',
            reject_label: 'Avvisa rapporten',
            export_label: 'Exportera [[TOK_0]]',
            accept_hint: 'Acceptera registrerar luckrapporten om det kvarstående utkastet. Använd Exportera [[TOK_0]] för att skapa en policyrevisionsrapport; operatören driver själva policyredigeringen.',
            resolve_summary: 'Upplösning: [[TOK_1]]',
            error_generic: 'Kunde inte upptäcka politiska luckor. Försök igen eller kontrollera dokumentets status.',
        },
        remediation_plan_generator: {
            run_label: 'Skapa plan från luckor',
            running: 'Skapar plan...',
            results_heading: 'Saneringsplan ([[TOK_2]] fas[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            phase_label: 'Fas [[TOK_1]]',
            window_label: 'Fönster',
            owner_label: 'Ägarroll',
            evidence_label: 'Bevistyper krävs',
            tasks_label: 'Uppgifter',
            no_phases: 'Inga faser produceras — input gap-set kan vara tomt.',
            citations_label: 'Citat',
            accept_label: 'Acceptera planen',
            reject_label: 'Avvisa plan',
            export_label: 'Exportera [[TOK_0]]',
            accept_hint: 'Acceptera skapar fasuppgifter kopplade till planposten. Använd Exportera [[TOK_0]] för hela leveransen. Platshållare för ägarroller behöver operatörsuppföljning.',
            resolve_summary: 'Upplösning: [[TOK_2]] · [[TOK_3]] uppgift(er) skapade',
            error_generic: 'Det gick inte att skapa saneringsplan. Försök igen eller kontrollera gap-set-ingången.',
            source_picker_label: 'Källa',
            source_all: 'Alla',
            source_consent: 'Analys av samtyckesgap',
            source_policy: 'Identifiering av policygap',
            source_vendor: 'Introduktion av leverantörer',
            load_upstream_label: 'Ladda från uppströms',
            loading_upstream: 'Laddar...',
            upstream_count: '[[TOK_1]] luck(ar) laddade',
        },
        nav: {
            maturity_models: 'Mognadsmodeller',
            maturity_assessments: 'Mognadsbedömningar',
            trend_dashboard: 'Trendöversikt',
            reporting_periods: 'Rapporteringsperioder',
            executive_summaries: 'Sammanfattningar',
            audit_readiness: 'Granskningsberedskap',
            evidence_gaps: 'Bevisluckor',
            program_health: 'Programhälsa',
            obligation_mappings: 'Skyldighetskopplingar',
            governance_documents: 'Styrningsdokument',
            remediation_plans: 'Åtgärdsplaner',
            governance_model: 'Styrningsmodell',
            document_drafting: 'Dokumentutkast',
            document_issuance: 'Dokumentutgivning',
            acknowledgment_tracking: 'Bekräftelsespårning',
            change_log: 'Ändringslogg',
            review_cadence: 'Granskningskadans',
        },
        maturity_models: {
            title: 'Mognadsmodeller',
            new: 'Ny Modell',
            seed_defaults: 'Initiera standardvärden',
            domains: 'Domäner',
            activate: 'Aktivera',
            no_models: 'Inga mognad modeller hittades',
            new_maturity_model: 'Ny Mognad Modell',
            create_model: 'Skapa modell',
            load_error: 'Kunde inte ladda mognadsmodeller. Försök igen.',
            create_error: 'Kunde inte skapa mognadsmodell',
            status_error: 'Kunde inte uppdatera modellstatus',
            seed_error: 'Kunde inte generera standardvärden',
            aria_seed_defaults: 'Generera standardmognadsmodeller',
            aria_create_new: 'Skapa ny mognadsmodell',
            loading_sr: 'Laddar mognadsmodeller',
            model_name_placeholder: 't.ex., Integritetsmognadsmodell',
            status_changed: 'Modellstatus ändrad till {status}',
        },
        maturity_assessments: {
            title: 'Mognadsbedömningar',
            new: 'Ny Bedömning',
            model: 'Modell',
            assessor: 'Bedömare',
            overall_score: 'Övergripande Poäng',
            overall_score_help: 'Ett viktat mognadsbetyg från 0–5 som beräknas automatiskt när en bedömning slutförs. Öka det genom att ge varje domän högre poäng under utvärderingen och sedan föra bedömningen genom Skicka för granskning → Slutför.',
            assessed_at: 'Bedömd den',
            no_assessments: 'Inga mognad bedömningar hittades.',
            load_error: 'Kunde inte ladda mognadsbedömningar. Försök igen.',
            create_error: 'Kunde inte skapa bedömning',
            start_error: 'Kunde inte starta bedömning',
            archive_error: 'Kunde inte arkivera bedömning',
            eval_error: 'Kunde inte ladda bedömning för utvärdering',
            eval_min_score: 'Betygsätt minst en domän',
            eval_save_error: 'Kunde inte spara domänbedömningar',
            review_error: 'Kunde inte skicka för granskning',
            finalize_error: 'Kunde inte slutföra bedömning',
            start: 'Starta',
            start_confirm_title: 'Starta bedömning',
            start_confirm_message: 'Är du säker på att du vill starta denna bedömning?',
            archive_confirm_title: 'Arkivera bedömning',
            archive_confirm_message: 'Är du säker på att du vill arkivera denna bedömning?',
            evaluate_domains: 'Utvärdera',
            evaluate_domains_title: 'Utvärdera domäner',
            submit_for_review: 'Skicka för granskning',
            finalize: 'Slutför',
            archive: 'Arkivera',
            all_reviewers: 'Alla granskare måste godkänna',
            any_reviewer: 'Vilken granskare som helst kan godkänna',
            select_level: 'Välj mognadsnivå...',
            findings_placeholder: 'Resultat, anteckningar, bevisreferenser...',
            no_domains: 'Inga domäner hittades för denna modell.',
        },
        trend_dashboard: {
            title: 'Trendöversikt',
            loading: 'Laddar trenddata...',
            score_trend: 'Poäng Trend',
            domain_comparison: 'Domän Jämförelse',
            period: 'Tidsperiod',
            load_error: 'Kunde inte ladda trendsammanfattning. Försök igen.',
            metrics_load_error: 'Kunde inte ladda trendmätningar. Försök igen.',
            module: 'Modul',
            metric: 'Mätning',
            value: 'Värde',
            trend: 'Trend',
            aria_filters: 'Filter för trendmätningar',
            showing_chart: 'Visar diagramvy',
            showing_table: 'Visar datatabellvy',
        },
        reporting_periods: {
            title: 'Rapporteringsperioder',
            new: 'Ny Period',
            period_name: 'Period Namn',
            start_date: 'Start Datum',
            end_date: 'End Datum',
            no_periods: 'Inga reporting periods hittades.',
            load_error: 'Kunde inte ladda rapporteringsperioder. Försök igen.',
            create_error: 'Kunde inte skapa rapporteringsperiod',
            auto_generate_error: 'Kunde inte autogenerera rapporteringsperioder',
            status_error: 'Kunde inte uppdatera periodstatus',
            start_collecting: 'Börja samla in',
            mark_as_draft: 'Markera som utkast',
            submit_for_review: 'Skicka för granskning',
            publish: 'Publicera',
            auto_generate: 'Autogenerera rapporteringsperioder',
            period_label_placeholder: 't.ex., K1 2026',
            status_updated: 'Periodstatus uppdaterad',
        },
        executive_summaries: {
            title: 'Sammanfattningar',
            new: 'Ny Sammanfattning',
            period: 'Tidsperiod',
            generated_at: 'Genererad Vid',
            generated_by: 'Genererad Per',
            no_summaries: 'Inga lednings sammanfattningar hittades.',
            generate: 'Generera',
            load_error: 'Kunde inte ladda ledningssammanfattningar. Försök igen.',
            generate_error: 'Kunde inte generera ledningssammanfattning',
            save_error: 'Kunde inte spara ledningssammanfattning',
        },
        audit_readiness: {
            title: 'Granskningsberedskap',
            loading: 'Laddar revisionsberedskapsdata...',
            overall_readiness: 'Övergripande Beredskap',
            by_domain: 'Per Domän',
            evidence_coverage: 'Bevis Täckning',
            gaps: 'Brister',
            load_error: 'Kunde inte ladda senaste beredskap. Försök igen.',
            history_error: 'Kunde inte ladda beredskapshistorik. Försök igen.',
            calculate_error: 'Kunde inte beräkna revisionsberedskap',
            aria_recalculate: 'Beräkna om revisionsberedskapspoäng',
            aria_current_readiness: 'Nuvarande revisionsberedskap',
            aria_history: 'Historik för beredskapspoäng',
            recalculated: 'Revisionsberedskap omberäknad',
            loading_sr: 'Laddar revisionsberedskapsdata',
        },
        evidence_gaps: {
            title: 'Bevisluckor',
            domain: 'Domän',
            control: 'Kontroll',
            gap_type: 'Brist Typ',
            severity: 'Allvarlighetsgrad',
            no_gaps: 'Inga bevis brister hittades.',
            load_error: 'Kunde inte ladda bevisbrister. Försök igen.',
            stats_error: 'Kunde inte ladda briststatistik. Försök igen.',
            create_error: 'Kunde inte skapa bevisbrist',
            update_error: 'Kunde inte uppdatera bevisbrist',
            status_error: 'Kunde inte uppdatera status',
            aria_create_new: 'Skapa ny bevisbrist',
            aria_statistics: 'Bevisbriststatistik',
            loading_sr: 'Laddar bevisbrister',
            status_updated: 'Briststatus uppdaterad',
            entity_type_placeholder: 't.ex., leverantör, system',
            all_modules: 'Alla domäner',
            all_severities: 'Alla allvarlighetsgrader',
        },
        program_health: {
            title: 'Programhälsa',
            loading: 'Laddar programhälsodata...',
            overall_health: 'Övergripande Hälsa',
            by_module: 'Per Modul',
            risk_areas: 'Riskområden',
            recommendations: 'Rekommendationer',
            load_error: 'Kunde inte ladda programhälsodata. Försök igen.',
            aria_key_metrics: 'Nyckelmätningar för programhälsa',
            aria_module_scorecard: 'Modulstyrkortuppdelning',
            loading_sr: 'Laddar programhälsodata',
            trending_up: 'Stigande trend',
            trending_down: 'Sjunkande trend',
            trending_stable: 'Stabil',
            data_loaded: 'Programhälsodata laddad',
        },
        obligation_mappings: {
            title: 'Skyldighetskopplingar',
            create_mapping: 'Skapa skyldighetskoppling',
            framework: 'Ramverk',
            select_framework: 'Välj ett ramverk...',
            obligation: 'Skyldighet',
            obligation_ref: 'Skyldighetsreferens',
            obligation_description: 'Skyldighetsbeskrivning',
            role: 'Roll',
            assigned_role: 'Tilldelad roll',
            assigned_department: 'Tilldelad avdelning',
            select_department: 'Välj en avdelning...',
            control_ids: 'Kontroll-ID',
            raci_assignments: 'RACI-tilldelningar',
            create_raci: 'Skapa RACI-tilldelning',
            activity: 'Aktivitet',
            activity_name: 'Aktivitetsnamn',
            activity_description: 'Aktivitetsbeskrivning',
            responsible: 'Ansvarig',
            select_users: 'Välj användare...',
            accountable: 'Redovisningsskyldig',
            select_user: 'Välj en användare...',
            consulted: 'Konsulterad',
            informed: 'Informerad',
            review_frequency: 'Granskningsfrekvens',
            frequency_monthly: 'Månadsvis',
            frequency_quarterly: 'Kvartalsvis',
            frequency_semi_annual: 'Halvårsvis',
            frequency_annual: 'Årsvis',
            no_mappings_found: 'Inga skyldighetskopplingar hittades.',
            no_raci_found: 'Inga RACI-tilldelningar hittades.',
            mapping_created: 'Förpliktelsetilldelning skapad',
            mapping_updated: 'Skyldighetskoppling uppdaterad',
            mapping_deleted: 'Skyldighetskoppling borttagen',
            raci_created: 'RACI-tilldelning skapad',
            raci_updated: 'RACI-tilldelning uppdaterad',
            raci_deleted: 'RACI-tilldelning borttagen',
            aria_edit_mapping: 'Redigera koppling {name}',
            aria_delete_mapping: 'Ta bort koppling {name}',
            aria_edit_raci: 'Redigera RACI {name}',
            aria_delete_raci: 'Ta bort RACI {name}',
            confirm_delete_mapping: 'Ta bort denna skyldighetskoppling?',
            confirm_delete_raci: 'Ta bort denna RACI-tilldelning?',
            table_view: 'Tabellvy',
            matrix_view: 'Matrisvy',
            print_export: 'Skriv ut / Exportera',
            filter_framework: 'Filtrera efter ramverk',
            no_matrix_data: 'Inga RACI-tilldelningar att visa i matrisvyn.',
            aria_print_export: 'Skriv ut eller exportera RACI-matris',
        },
        governance_documents: {
            title: 'Styrningsdokument',
            create_document: 'Skapa styrningsdokument',
            document_title: 'Dokumenttitel',
            document_type: 'Dokumenttyp',
            content_url: 'Innehålls-URL',
            content_url_placeholder: 'https://...',
            framework_codes: 'Ramverkskoder',
            select_frameworks: 'Välj ramverk...',
            effective_date: 'Giltighetsdatum',
            review_date: 'Granskningsdatum',
            status: 'Status',
            version: 'Version',
            acknowledgments: 'Bekräftelser',
            acknowledge: 'Bekräfta',
            acknowledged_by: 'Bekräftad av',
            department: 'Avdelning',
            no_documents_found: 'Inga styrningsdokument hittades.',
            draft: 'Utkast',
            review: 'Granskning',
            approved: 'Godkänd',
            issued: 'Utfärdad',
            superseded: 'Ersatt',
            document_created: 'Dokument skapat',
            document_acknowledged: 'Dokument bekräftat',
            policy: 'Policy',
            procedure: 'Procedur',
            standard: 'Standard',
            guideline: 'Riktlinje',
        },
        governance_model: {
            title: 'Styrningsmodell',
            create_model: 'Styrningsmodell',
            edit_model: 'Styrningsmodell',
            model_name: 'Model',
            description: 'Beskrivning',
            governance_type: 'Type',
            type_centralized: 'Centraliserad',
            type_federated: 'Federerat',
            type_hybrid: 'Hybrid',
            framework_codes: 'Framework',
            select_frameworks: '...',
            review_frequency: 'Frequency',
            freq_monthly: 'Månadsvis',
            freq_quarterly: 'Kvartalsvis',
            freq_semi_annual: 'Halvårsvis',
            freq_annual: 'Årlig',
            committees: 'kommittéer',
            committee_name: 'Name',
            committee_members: 'Members',
            committee_mandate: 'Mandat',
            add_committee: '+',
            no_committees: '—',
            delegation_rules: 'Delegation',
            from_role: 'From',
            to_role: 'To',
            scope: 'Omfattning',
            add_delegation_rule: '+',
            control_owner_summary: 'RACI',
            no_raci_data: '—',
            activity: 'Aktivitet',
            responsible: 'R',
            accountable: 'A',
            consulted: 'C',
            informed: 'I',
            no_models_found: '—',
            model_created: 'OK',
            model_updated: 'OK',
            model_deleted: 'OK',
            confirm_delete: '?',
            expand: '+',
            collapse: '-',
            aria_expand: '{name}',
            aria_edit: '{name}',
            aria_delete: '{name}',
            aria_export_csv: '{name} CSV',
            aria_export_json: '{name} JSON',
            framework_read_permission_warning: 'Du behöver regulatory_framework:läsbehörighet för att välja ramverk. Be en administratör att bevilja det.',
            select_members: 'Utvalda kommittémedlemmar',
            select_from_role: 'Välj delegerande roll',
            select_to_role: 'Välj mottagande roll',
            mandate_markdown_hint: 'Markdown stöds: **fet**, listor, länkar.',
            scope_tab_obligation: 'Skyldighet',
            scope_tab_framework: 'Ramverk',
            scope_tab_free_text: 'Fri text',
            select_obligation: 'Välj en skyldighet',
            select_framework: 'Välj ett ramverk',
            aria_remove_committee: 'Ta bort kommitté {n}',
            aria_remove_delegation_rule: 'Ta bort delegeringsregel {n}',
            no_frameworks_available: 'Inga ramverk tillgängliga. Lägg till regelverk först.',
        },
        document_drafting: {
            title: 'Dokumentutkast',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Status',
            drafter: 'Författare',
            deadline: 'Deadline',
            assign_drafter: 'Tilldela',
            select_drafter: '...',
            assign: 'Tilldela',
            submit_for_review: 'Skicka in',
            legal_review: 'Juridisk granskning',
            reviewer: 'Recensent',
            select_reviewer: '...',
            comments: 'Kommentarer',
            review_action: 'Åtgärd',
            approve: 'Godkänn',
            request_changes: 'Begär ändringar',
            submit_review: 'Skicka in',
            executive_approval: 'Godkännande',
            no_drafts_found: '—',
            drafter_assigned: 'OK',
            status_updated: 'OK',
            review_approved: 'OK',
            changes_requested: 'OK',
            document_approved: 'OK',
            aria_assign: '{name}',
            aria_submit_review: '{name}',
            aria_review: '{name}',
            aria_approve: '{name}',
        },
        document_issuance: {
            title: 'Dokumentutgivning',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Status',
            version: 'Version',
            effective_date: 'Date',
            distribution_scope: 'Distribution',
            distribution_placeholder: '...',
            issuance_number: 'Number',
            issuance_number_placeholder: 'ISS-2026-001',
            supersedes: 'Supersedes',
            none: '—',
            issue_document: 'Issue',
            ready_for_issuance: 'Ready',
            issued_documents: 'Issued',
            no_issued_documents: '—',
            view_lineage: 'Lineage',
            supersession_lineage: 'Supersession',
            document_issued: 'OK',
            document_superseded: 'OK',
            aria_issue: '{name}',
            aria_view_lineage: '{name}',
        },
        acknowledgment_tracking: {
            title: 'Bekräftelsespårning',
            document_title: 'Dokument',
            acknowledged_count: 'Erkänt',
            pending_count: 'Väntar',
            percentage: '%',
            details: 'Detaljer',
            send_reminder: 'Remind',
            acknowledgment_details: 'Details',
            user: 'Användare',
            department: 'Avdelning',
            acknowledged_at: 'Date',
            status: 'Status',
            acknowledged: 'OK',
            no_issued_documents: '—',
            no_acknowledgments: '—',
            reminder_sent: 'OK',
            aria_expand: '{name}',
            aria_send_reminder: '{name}',
        },
        change_log: {
            title: 'Ändringslogg',
            date: 'Datum',
            document: 'Dokument',
            change_type: 'Type',
            actor: 'Skådespelare',
            summary: 'Sammanfattning',
            export_csv: 'Exportera [[TOK_0]]',
            filters: 'Filters',
            filter_document: 'Document',
            all_documents: 'All',
            filter_change_type: 'Type',
            all_types: 'All',
            date_from: 'From',
            date_to: 'To',
            version_history: 'History',
            version_archive: 'Archive',
            no_entries: '—',
            no_history: '—',
            exported: 'OK',
            aria_export: 'CSV',
            aria_view_history: '{name}',
        },
        review_cadence: {
            title: 'Granskningskadans',
            configure_cadence: 'Granskningskadans',
            edit_cadence: 'Granskningskadans',
            document: 'Dokument',
            select_document: '...',
            review_frequency: 'Frequency',
            freq_30: '30',
            freq_60: '60',
            freq_90: '90',
            freq_180: '180',
            freq_365: '365',
            last_reviewed: 'Last',
            next_review: 'Next',
            status: 'Status',
            overdue: 'Försenad',
            on_track: 'OK',
            days: 'days',
            horizon: 'Horizon',
            overdue_warning: 'Overdue',
            overdue_count: '{count}',
            no_cadences: '—',
            cadence_created: 'OK',
            cadence_updated: 'OK',
            aria_edit: '{name}',
        },
        remediation_plans: {
            title: 'Åtgärdsplaner',
            create_plan: 'Skapa åtgärdsplan',
            gap_id: 'Bristreferens',
            select_gap: 'Välj en brist...',
            plan_title: 'Titel',
            description: 'Beskrivning',
            priority: 'Prioritet',
            priority_critical: 'Kritisk',
            priority_high: 'Hög',
            priority_medium: 'Medel',
            priority_low: 'Låg',
            assigned_to: 'Tilldelad till',
            select_user: 'Välj en användare...',
            target_date: 'Måldatum',
            framework_code: 'Ramverk',
            select_framework: 'Välj ett ramverk...',
            gap_finding: 'Bristfynd',
            action_items: 'Åtgärdspunkter',
            owner: 'Ägare',
            deadline: 'Tidsfrist',
            planned: 'Planerad',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            verified: 'Verifierad',
            no_plans_found: 'Inga åtgärdsplaner hittades.',
            evidence: 'Bevis',
            plan_created: 'Åtgärdsplan skapad',
            action_items_hint: 'Åtgärdspunkter (en per rad)',
        },
        statuses: {
            identified: 'Identifierad',
            assigned: 'Tilldelad',
            in_remediation: 'I Sanering',
            resolved: 'Löst',
            accepted_risk: 'Accepterad risk',
            planned: 'Planerad',
            in_progress: 'Pågår',
            under_review: 'Under granskning',
            finalized: 'Avslutade',
            archived: 'Arkiverad',
            draft: 'Utkast',
            active: 'Aktiv',
            upcoming: 'Kommande',
            collecting: 'Samlar',
            published: 'Publicerad',
            review: 'Granska',
            approved: 'Godkänd',
            issued: 'Utfärdat',
            superseded: 'Ersatt',
            completed: 'Avslutad',
            verified: 'Verifierad',
        },
        severities: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medium',
            low: 'Low',
        },
        priorities: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medium',
            low: 'Low',
        },
        gap_types: {
            missing: 'Saknas',
            expired: 'Utgått',
            insufficient: 'Otillräcklig',
        },
        document_types: {
            policy: 'Policy',
            procedure: 'Förfarande',
            standard: 'Standard',
            guideline: 'Riktlinje',
            template: 'Mall (intern)',
        },
        maturity_levels: {
            level_1: 'Nivå 1 — Initial',
            level_2: 'Nivå 2 — Utvecklas',
            level_3: 'Nivå 3 — Definierat',
            level_4: 'Nivå 4 — Hanterad',
            level_5: 'Nivå 5 — Optimering',
        },
        grades: {
            excellent: 'Utmärkt',
            good: 'Bra',
            fair: 'Rättvist',
            poor: 'Stackars',
            critical: 'Kritisk',
            needs_improvement: 'Behöver förbättring',
            not_assessed: 'Ej bedömd',
        },
        modules: {
            data_mapping: 'Datakartläggning',
            consent: 'Samtycke',
            governance: 'Styrning',
            incidents: 'Incidenter',
            monitoring: 'Övervakning',
            classification: 'Klassificering',
            vendor_risk: 'Leverantörsrisk',
            discovery: 'Upptäckt',
            deletion: 'Radering',
        },
        cadences: {
            monthly: 'Månadsvis',
            quarterly: 'Kvartalsvis',
            semi_annual: 'Halvårsvis',
            annual: 'Årlig',
        },
        section_labels: {
            opening: 'Öppning',
            key_metrics: 'Nyckelmått',
            highlights: 'Höjdpunkter',
            concerns: 'Bekymmer',
            recommendations: 'Rekommendationer',
            outlook: 'Outlook',
        },
        out_of_100: '/ 100',
        count_gaps: '[[TOK_1]] mellanrum',
        count_gaps_plural: '[[TOK_1]] luckor',
        count_summaries: '[[TOK_1]] sammanfattning',
        count_summaries_plural: '[[TOK_1]] sammanfattningar',
        count_assessments: '[[TOK_1]] bedömning',
        count_assessments_plural: '[[TOK_1]] bedömningar',
        count_models: '[[TOK_1]] modell',
        count_models_plural: '[[TOK_1]] modeller',
        count_periods: '[[TOK_1]] period',
        count_periods_plural: '[[TOK_1]] punkter',
        count_metrics: '[[TOK_1]] mätvärde',
        count_metrics_plural: '[[TOK_1]] mätvärden',
        unknown_user: 'Okänd användare',
        unknown_gap: 'Okänt gap',
        no_permission_title: 'Otillräckliga behörigheter',
        no_permission_message: 'Du har inte behörighet att komma åt den här sidan.',
        ac_vn_frameworks_title: 'VN Framework Täckning',
        ac_vn_frameworks_body: 'Mognadsbedömningar omfattar alla 6 vietnamesiska regelverk: [[TOK_0]], datalag, telekomlag, cybersäkerhetslagstiftning, [[TOK_1]] lag och e-handelslag – var och en med ramspecifika bedömningskriterier.',
        ac_controller_processor_title: 'Styrenhet kontra processor',
        ac_controller_processor_body: 'Skyldighetskartläggningar skiljer mellan personuppgiftsansvarig och databehandlaransvar. Tilldela roller med hjälp av RACI-matrisen för att säkerställa att varje skyldighet har en tydlig ägare, oavsett om organisationen agerar som registeransvarig eller processor.',
        ac_versioned_evidence_title: 'Versionerat bevisspår',
        ac_versioned_evidence_body: 'Varje statusövergång (utkast, granskning, godkänd, utfärdad) skapar en tidsstämplad, versionerad post som fungerar som revisionsbart bevis. Ändringsloggen fångar hela dokumentets livscykelhistorik.',
        ac_remediation_gap_link_title: 'Kopplad till Assessment Gaps',
        ac_remediation_gap_link_body: 'Varje saneringsplan länkar direkt till en identifierad bedömningslucka. Tilldela en ägare och ställ in en måltidsfrist för att spåra upplösningens framsteg från lucka till stängning.',
        ac_annual_attestation_title: 'Årlig intygscykel',
        ac_annual_attestation_body: 'Rapporteringsperioderna överensstämmer med det årliga intygskravet för vietnamesisk datalag. Använd den "årliga" kadensen (365-dagarscykel) för att automatiskt generera intygsanpassade perioder.',
        ac_evidence_per_obligation_title: 'Bevis per ramförpliktelse',
        ac_evidence_per_obligation_body: 'Bevisluckor identifierar saknade, utgångna eller otillräckliga bevis för varje ramkrav. Filtrera efter domän för att se vilka regulatoriska krav som saknar stödjande bevis.',
        ac_cross_framework_title: 'Fullständighet över flera regelverk',
        ac_cross_framework_body: 'Revisionsberedskap ger en helhetsvy över ramarna. Komponentpoäng återspeglar täckning över alla kartlagda ramverk, och belyser områden som behöver uppmärksammas innan en revision.',
        ac_cadence_default_title: 'Standardfrekvens för granskning',
        ac_cadence_default_body: 'Standard granskningsfrekvens är 180 dagar. Försenade recensioner flaggas automatiskt. Justera frekvensen per dokument efter behov – alternativen sträcker sig från 30 till 365 dagar.',
        ac_templates_internal_title: 'Mallklassificering',
        ac_templates_internal_body: 'Mallar klassificeras som interna dokument. Använd dokumenttypen "Mall" för att markera återanvändbara styrningsartefakter med enbart intern distribution.',
    },
    mcp_pending: {
        title: 'MCP — Väntande skrivningar',
        subtitle: 'Externa Claude-klienter föreslår skrivningar här. Godkänn eller avslå varje post — Forseti utför först efter administratörens godkännande.',
        no_pending: 'Inga väntande skrivningar.',
        col_tool: 'Verktyg',
        col_preview: 'Förhandsvisning',
        col_key: '[[TOK_0]]-tangenten',
        col_requested: 'Begärd',
        col_expires: 'Upphör',
        col_status: 'Status',
        status_pending: 'Väntar',
        status_approved: 'Godkänd',
        status_declined: 'Avslagen',
        status_expired: 'Förfallen',
        status_executed: 'Utförd',
        approve_label: 'Godkänn',
        decline_label: 'Avslå',
        refresh_label: 'Uppdatera',
        error_generic: 'Det gick inte att läsa in väntande skrivningar.',
        confirm_approve: 'Godkännande kommer att utföra verktyget på din organisation med API key-innehavarens behörigheter. Fortsätt?',
        confirm_decline: 'Avslå denna väntande skrivning? Detta kan inte ångras.',
        advisory_banner: 'Väntande skrivningar förfaller 24 timmar efter att de skapats. Den timvisa GC-svepningen avslår förfallna poster automatiskt.',
    },
    audit_walkthrough: {
        title: 'Forseti — Generator för revisionsgenomgång',
        subtitle: 'Generera en strukturerad genomgång inför en revisionsstart: öppningsfråga per kontroll, förväntade bevis, uppföljningsfrågor, potentiella luckor.',
        audit_picker_label: 'Revision',
        audit_picker_hint: 'Välj en planerad revision för att generera en genomgång.',
        run_label: 'Generera genomgång',
        running: 'Genererar…',
        results_heading: 'Genomgång — {count} kontroll(er)',
        tokens_label: '≈ [[TOK_1]] tokens',
        no_controls: 'Inga kontroller i omfattningen. Lägg till kontroller i revisionsposten.',
        col_control: 'Kontroll',
        col_question: 'Öppningsfråga',
        col_evidence: 'Bevis',
        col_gaps: 'Potentiella luckor',
        expected_evidence_label: 'Förväntade bevis',
        followup_probes_label: 'Uppföljningsfrågor',
        accept_label: 'Godkänn genomgång',
        reject_label: 'Avvisa',
        export_label: 'Exportera DOCX',
        resolve_summary: 'Resultat: {status}',
        error_generic: 'Det gick inte att generera genomgången. Försök igen eller kontrollera revisionens status.',
    },
    privilege_creep: {
        title: 'Forseti — Detektering av behörighetsutvidgning',
        subtitle: 'Periodisk genomsökning av rolltilldelningar. Fynd är rådgivande — Forseti återkallar aldrig automatiskt.',
        run_label: 'Skanna nu',
        running: 'Skannar…',
        findings_heading: '{count} fynd',
        no_findings: 'Ingen behörighetsutvidgning flaggad.',
        col_user: 'Användare',
        col_job_function: 'Jobbfunktion',
        col_severity: 'Allvarlighetsgrad',
        col_unexpected: 'Oväntade behörigheter',
        col_remediation: 'Föreslagen åtgärd',
        col_status: 'Status',
        severity_critical: 'Kritisk',
        severity_high: 'Hög',
        severity_medium: 'Medel',
        severity_low: 'Låg',
        status_open: 'Öppen',
        status_dismissed: 'Avfärdad',
        status_remediated: 'Åtgärdad',
        dismiss_label: 'Avfärda',
        remediate_label: 'Markera som åtgärdad',
        note_label: 'Anteckning (valfritt)',
        error_generic: 'Det gick inte att skanna behörighetsutvidgning. Försök igen senare.',
        advisory_banner: 'Dessa fynd är rådgivande. Forseti återkallar aldrig behörigheter automatiskt — granska med rollägaren innan du agerar.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Automappning av efterlevnadsregel',
            subtitle: 'Forseti går igenom ett installerat regelverk och föreslår nya eller uppdaterade efterlevnadsregler grundade i källartiklarna.',
            pack_picker_label: 'Föreskriftspaket',
            pack_picker_hint: 'Välj ett installerat paket att kartlägga.',
            run_label: 'Karta från förpackning',
            running: 'Kartläggning...',
            results_heading: '[[TOK_1]] förslag',
            tokens_label: '≈ [[TOK_1]] tokens från din månatliga hink',
            no_suggestions: 'Inga förslag – förpackningens innehåll kanske redan täcks helt av befintliga regler.',
            kind_new: 'Ny regel',
            kind_refresh: 'Uppdatera befintliga',
            kind_no_change: 'Ingen förändring krävs',
            col_kind: 'Snäll',
            col_title: 'Föreslagen titel',
            col_existing: 'Befintlig regel',
            col_source: 'Källa',
            proposed_body_label: 'Föreslagna organ',
            source_quote_label: 'Källcitat',
            accept_selected: 'Acceptera valt',
            reject_all: 'Avvisa alla',
            accept_all: 'Acceptera alla',
            resolve_summary: 'Upplösning: [[TOK_2]] · [[TOK_3]] regler skapade',
            error_generic: 'Det gick inte att köra regelmappning. Försök igen eller kontrollera paketkoden.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Sessionsöversikt',
            access_log: 'Åtkomstlogg',
            justification_review: 'Motiveringsöversyn',
            investigations: 'Utredningar',
            pattern_analysis: 'Mönsteranalys',
            anchoring_status: 'Förankringsstatus',
            configuration: 'Konfiguration',
            access_policies: 'Åtkomstpolicyer',
            review_campaigns: 'Granskningskampanjer',
            evidence_packages: 'Bevispaket',
        },
        session_dashboard: {
            title: 'Sessionsöversikt',
            loading: 'Laddar instrumentpanelsdata...',
            total_sessions: 'Totalt Sessioner',
            active_sessions: 'Aktiva Sessioner',
            avg_duration: 'Gns. Varaktighet',
            concurrent_peak: 'Samtidiga Topp',
            auth_method_breakdown: 'Autentisering Metod Fördelning',
            geo_country_breakdown: 'Geografisk landsfördelning',
            recent_session_events: 'Senaste Session Händelser',
            user_id: 'Användare ID',
            session_id: 'Sessions-ID',
            ip_address: 'IP-adress',
            auth_method: 'Autentisering Metod',
            started_at: 'Startad den',
            event_type: 'Händelse Typ',
            all_event_types: 'Alla Händelse Typer',
            filter_by_user: 'Filter per Användare ID...',
            no_active_sessions: 'Inga aktiva sessioner',
            no_session_events: 'Inga sessionshändelser hittades',
            revoke: 'Återkalla',
            revoke_session: 'Återkalla Session',
            revoke_reason: 'Anledning',
            revoke_placeholder: 'Ange en anledning för att återkalla denna session...',
            session_label: 'Sessionen:',
            load_failed: 'Kunde inte ladda sessionsinstrumentpanel. Försök igen.',
            events_load_failed: 'Kunde inte ladda sessionshändelser. Försök igen.',
            revoke_failed: 'Kunde inte återkalla session',
            session_events_loaded: '{n} session events laddade',
            event_types: {
                session_created: 'Session skapad',
                session_refreshed: 'Session uppdaterad',
                session_expired: 'Session har löpt ut',
                session_revoked: 'Session återkallad',
                session_terminated: 'Session avslutad',
                login_success: 'Inloggning lyckad',
                login_failure: 'Inloggningsfel',
                logout: 'Logga ut',
                token_refresh: 'Token Refresh',
                mfa_challenge: 'MFA utmaning',
            },
        },
        access_log: {
            title: 'Åtkomstlogg',
            user_id: 'Användare ID',
            resource: 'Resurs',
            action: 'Åtgärd',
            ip_address: 'IP-adress',
            timestamp: 'Tidsstämpel',
            no_logs: 'Inga åtkomst logg poster hittades.',
            filter_by_user: 'Filter per Användare ID...',
            load_failed: 'Kunde inte ladda åtkomstlogg. Försök igen.',
            export_success: 'Export initierad',
            export_failed: 'Kunde inte exportera åtkomstlogg',
            record_count: 'post',
            record_count_plural: 'poster',
            unclassified: 'Oklassificerad',
            classification_missing: 'Klassificering saknas',
            response_code: 'Svarskod',
            classification_levels: {
                public: 'Offentligt',
                internal: 'Internt',
                confidential: 'Konfidentiellt',
                restricted: 'Begränsad',
                unclassified: 'Oklassificerad',
            },
        },
        justification_review: {
            title: 'Motiveringsöversyn',
            user_id: 'Användare ID',
            resource: 'Resurs',
            justification: 'Motivering',
            submitted_at: 'Inskickad At',
            reviewer: 'Granskare',
            no_reviews: 'Inga motivering granskningar hittades.',
            load_failed: 'Kunde inte ladda motiveringar. Försök igen.',
            review_failed: 'Kunde inte granska motivering',
            decline_failed: 'Kunde inte avböja åtkomst',
            justification_count: 'motivering',
            justification_count_plural: 'motiveringar',
            reviewed: 'Granskad',
            concerning: 'Oroande',
            escalated: 'Eskalerad',
            link_investigation_placeholder: 'Länka till en utredning (valfritt)',
            review_queue: 'Granskning Kö',
            access_id_label: 'Åtkomst-ID',
            access_id_placeholder: 'ID för åtkomstloggpost',
            select_user_placeholder: 'Välj användare (valfritt)',
            resource_type_label: 'Resurstyp',
            resource_type_placeholder: 't.ex. document, database',
            resource_id_label: 'Resurs-ID',
            resource_id_placeholder: 'Resursidentifierare',
            reason_placeholder: 'Anledning till åtkomst av denna resurs...',
            create_failed: 'Kunde inte create justification',
            unclassified: 'Oklassificerad',
            review_statuses: {
                pending: 'Väntar',
                reviewed: 'Recenserad',
                concerning: 'Angående',
                escalated: 'Eskalerad',
            },
            reason_codes: {
                business_need: 'Affärsbehov',
                legal_obligation: 'Juridisk skyldighet',
                data_subject_request: 'Begäran från den registrerade',
                audit_requirement: 'Revisionskrav',
                incident_response: 'Incident Response',
                research: 'Forskning',
                administrative: 'Administrativt',
                other: 'Annat',
            },
        },
        investigations: {
            title: 'Utredning Arbetsyta',
            new: 'Ny Utredning',
            subject: 'Ämne',
            investigator: 'Utredare',
            opened_at: 'Öppnad den',
            findings: 'Resultat',
            no_investigations: 'Inga utredningar hittades.',
            load_failed: 'Kunde inte ladda utredningar. Försök igen.',
            create_failed: 'Kunde inte skapa utredning',
            timeline_add_failed: 'Kunde inte lägga till tidslinjepost',
            link_access_failed: 'Kunde inte länka åtkomst-ID:n',
            link_justification_failed: 'Kunde inte länka motiverings-ID:n',
            close_failed: 'Kunde inte stänga utredning',
            export_success: 'Export initierad',
            export_failed: 'Kunde inte exportera utredning',
            refresh_failed: 'Kunde inte uppdatera utredningsdetalj. Försök igen.',
            update_failed: 'Kunde inte uppdatera utredning',
            investigation_count: 'utredning',
            investigation_count_plural: 'utredningar',
            title_placeholder: 'Utredning titel',
            description_placeholder: 'Detaljerad beskrivning av utredning...',
            assignee_placeholder: 'Användar-ID för tilldelad (valfritt)',
            timeline_action_placeholder: 't.ex. Granskade åtkomstloggar',
            timeline_note_placeholder: 'Valfritt anteckning',
            access_ids_placeholder: 'åtkomst-id-1, åtkomst-id-2',
            justification_ids_placeholder: 'motivering-id-1, motivering-id-2',
            findings_placeholder: 'Sammanfatta utredningens resultat...',
            by_actor: 'by',
            close_investigation: 'Stäng Utredning',
            add_timeline_failed: 'Kunde inte lägga till tidslinjepost.',
            fetch_failed: 'Kunde inte hämta utredningar.',
            change_status: 'Ändra utredningsstatus',
            details: 'Utredningsdetaljer',
            link_evidence: 'Länka bevis',
            link_justifications: 'Länka motiveringar',
            access_ids_label: 'Åtkomst-IDn',
            justification_ids_label: 'Motiverings-IDn',
            access_ids_link_placeholder: 'åtkomst-id-1, åtkomst-id-2',
            justification_ids_link_placeholder: 'motivering-id-1, motivering-id-2',
            investigations_loaded: '{n} investigations laddade',
            status_changed_to: 'Status ändrad till {status}',
            add_timeline_entry: 'Lägg till tidslinjepost',
            add_access_ids: 'Lägg till åtkomst-IDn',
            add_justification_ids: 'Lägg till motiverings-IDn',
            investigation_types: {
                anomaly_review: 'Anomali granskning',
                complaint_driven: 'Klagomålsdriven',
                scheduled_review: 'Schemalagd granskning',
                whistleblower_report: 'Whistleblower Rapport',
            },
            severity_labels: {
                low: 'Låg',
                medium: 'Medium',
                high: 'Hög',
                critical: 'Kritisk',
            },
            status_labels: {
                open: 'Öppna',
                in_progress: 'Pågår',
                pending_review: 'Väntar på granskning',
                closed_substantiated: 'Stängd (underbyggd)',
                closed_unsubstantiated: 'Stängd (omotiverad)',
                closed_inconclusive: 'Stängt (inte avgörande)',
            },
            disposition_labels: {
                substantiated: 'Underbyggd',
                unsubstantiated: 'Ounderbyggd',
                inconclusive: 'Oöverskådlig',
            },
        },
        pattern_analysis: {
            title: 'Mönsteranalys',
            loading: 'Laddar mönsterdata...',
            anomalies_detected: 'Avvikelser upptäckta',
            patterns: 'Mönster',
            by_user: 'Per Användare',
            by_resource: 'Per Resurs',
            time_range: 'Tid Intervall',
            load_failed: 'Kunde inte analysera mönster. Försök igen.',
            top_resources: 'Topp 10',
            access_by_hour: 'Åtkomst per Timme av Dag',
            access_by_day: 'Åtkomst per Dag av Vecka',
            fetch_failed: 'Kunde inte hämta mönsteranalys.',
            analysis_loaded: 'Mönsteranalys laddad för {user}, {n} sessioner hittade',
            date_format_placeholder: 'DD/MM/ÅÅÅÅ',
            access_by_hour_heading: 'Åtkomst per tid på dygnet',
            access_by_day_heading: 'Åtkomst per veckodag',
            by_classification: 'Per klassificeringsnivå',
            top_accessed_resources: 'Mest åtkomna resurser',
            user_access_summary: 'Användaråtkomstsammanfattning',
            days: {
                sunday: 'Söndag',
                monday: 'Måndag',
                tuesday: 'Tisdag',
                wednesday: 'Onsdag',
                thursday: 'Torsdag',
                friday: 'Fredag',
                saturday: 'Lördag',
            },
            linked_access_logs: 'Länkade åtkomstloggar',
            linked_access_logs_desc: 'Få åtkomst till loggposter som är kopplade till de upptäckta mönstren för denna användare.',
        },
        anchoring_status: {
            title: 'Förankringsstatus',
            loading: 'Laddar förankringsdata...',
            anchored: 'Förankrad',
            pending: 'Väntande',
            failed: 'Misslyckad',
            last_anchor: 'Senaste Förankring',
            no_records: 'Inga anchoring records hittades.',
            status_load_failed: 'Kunde inte ladda förankringsstatus. Försök igen.',
            proofs_load_failed: 'Kunde inte ladda åtkomstbevis. Försök igen.',
            verify_failed: 'Kunde inte verifiera beviskedja. Försök igen.',
            anchor_failed: 'Kunde inte förankra åtkomstbevis',
            batch_anchor_failed: 'Kunde inte batchförankra åtkomstbevis',
            proof_count: 'bevis',
            proof_count_plural: 'bevis',
            anchor_single: 'Förankra enstaka',
            anchor_batch: 'Förankring Batch',
            access_id_placeholder: 'Ange åtkomst-ID för förankring',
            batch_ids_placeholder: 'åtkomst-id-1, åtkomst-id-2, åtkomst-id-3',
            verify_chain: 'Verifiera Kedja',
            chain_breaks: 'Kedja Brott',
            total_checked: 'Totalt kontrollerade',
            anchor_placeholder: 'Ange åtkomst-ID för förankring',
            fetch_failed: 'Kunde inte hämta förankringsstatus.',
            fetch_proofs_failed: 'Kunde inte hämta bevis.',
            access_id: 'Åtkomst-ID',
            chain_sequence: 'Kedjesekvens',
            proof_hash_label: 'Bevishash',
            batch_id: 'Batch-ID',
            proofs_loaded: '{n} access proofs laddade',
            anchor_statuses: {
                pending: 'Väntar',
                submitted: 'Inlämnad',
                confirmed: 'Bekräftad',
                failed: 'Misslyckades',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Kedja',
                blockchain_anchor: 'Blockchain Anchor',
                zkp_stub: 'ZKP Stub',
            },
        },
        configuration: {
            title: 'Konfiguration',
            session_settings: 'Session Inställningar',
            log_retention: 'Logglagring (dagar)',
            anomaly_threshold: 'Avvikelse Tröskelvärde',
            anchoring_enabled: 'Förankring aktiverad',
            save_config: 'Spara konfiguration',
            load_failed: 'Kunde inte ladda konfiguration. Försök igen.',
            save_success: 'Konfiguration sparad',
            save_failed: 'Kunde inte spara konfiguration. Försök igen.',
            justification_rules: 'Motivering Regler',
            reason_codes: 'Anledning Koder',
            anchoring_settings: 'Förankringsinställningar',
            anchoring_method: 'Förankringsmetod',
            anchoring_frequency: 'Förankringsfrekvens',
            batch_interval: 'Batchintervall (minuter)',
            eligibility_criteria: 'Berättigande Kriterier',
            add_criterion_placeholder: 'Lägg till behörighetskriterium...',
            retention_settings: 'Lagring Inställningar',
            standard_retention: 'Standardlagring (dagar)',
            sensitive_retention: 'Känslig lagring (dagar)',
            working_hours: 'Arbets Timmar',
            work_start: 'Start Tid',
            work_end: 'End Tid',
            timezone: 'Tidszon',
            timezone_placeholder: 't.ex. Asia/Ho_Chi_Minh',
            working_days: 'Arbets Dagar',
            concurrent_sessions: 'Samtidiga Session Gränser',
            concurrent_threshold: 'Samtidiga Session Tröskelvärde',
            classification_level: 'Klassificeringsnivå',
            prompt_mode: 'Promptläge',
            grace_period: 'Nåd Period (s)',
            code_placeholder: 'kod',
            is_custom: 'Anpassad',
            label_placeholder: 'Etikett',
            description_placeholder: 'Beskrivning',
            custom: 'Anpassad',
            fetch_failed: 'Kunde inte hämta konfiguration.',
            classification_levels: {
                public: 'Offentligt',
                internal: 'Internt',
                confidential: 'Konfidentiellt',
                restricted: 'Begränsad',
                unclassified: 'Oklassificerad',
            },
            prompt_modes: {
                reason_only: 'Endast anledning',
                reason_text: 'Orsak + text',
                reason_text_supervisor: 'Orsak + Text + Handledare',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Kedja',
                blockchain_anchor: 'Blockchain Anchor',
                zkp_stub: 'ZKP Stub',
            },
            anchoring_frequencies: {
                realtime: 'Realtid',
                batched: 'Batchad',
                on_demand: 'På begäran',
            },
        },
        access_policies: {
            title: 'Åtkomstpolicyer',
            create_policy: 'Skapa åtkomstpolicy',
            policy_name: 'Policynamn',
            framework_code: 'Ramverk',
            select_framework: 'Välj ett ramverk...',
            review_frequency: 'Granskningsfrekvens',
            scope: 'Omfattning',
            no_policies_found: 'Inga åtkomstpolicyer hittades.',
            policy_created: 'Åtkomstpolicy skapad',
            frequency_labels: {
                monthly: 'Månadsvis',
                quarterly: 'Kvartalsvis',
                semi_annual: 'Halvårsvis',
                annual: 'Årlig',
            },
        },
        review_campaigns: {
            title: 'Åtkomstgranskningskampanjer',
            create_campaign: 'Skapa granskningskampanj',
            reviewer: 'Granskare',
            due_date: 'Förfallodatum',
            certify: 'Intyga',
            no_campaigns_found: 'Inga åtkomstgranskningskampanjer hittades.',
            status_open: 'Öppen',
            status_in_review: 'Under granskning',
            status_completed: 'Slutförd',
            campaign_created: 'Granskningskampanj skapad',
            review_certified: 'Åtkomstgranskning certifierad',
            certify_campaign: 'Certifiera kampanj {id}',
            policy_id: 'Policy-ID',
            select_policy: 'Välj en policy...',
            reviewer_ids_label: 'Granskare',
            select_reviewers: 'Välj granskare...',
            status_labels: {
                open: 'Öppen',
                in_review: 'Under granskning',
                completed: 'Slutförd',
            },
            evidence_package_id: 'Bevispaket-ID',
        },
        evidence_packages: {
            title: 'Bevispaket',
            generate_package: 'Generera bevispaket',
            export_type: 'Exporttyp',
            package_type: 'Pakettyp',
            framework_scope: 'Ramverksomfattning',
            period: 'Period',
            generated_by: 'Genererad av',
            generated_at: 'Genererad den',
            no_packages_found: 'Inga bevispaket hittades.',
            package_generated: 'Bevispaket genererat',
            export_type_full: 'Fullständig export',
            export_type_summary: 'Sammanfattning',
            export_type_certification_only: 'Endast certifiering',
            package_type_access_review: 'Åtkomstgranskning',
            package_type_investigation: 'Utredning',
            package_type_certification: 'Certifiering',
            package_type_authority_request: 'Myndighetsförfrågan',
            period_start: 'Periodstart',
            period_end: 'Periodslut',
            select_frameworks: 'Välj ramverk...',
            completeness_col: 'Fullständighet',
            status_col: 'Status',
            generated_by_col: 'Genererad av',
        },
        evidence_package_detail: {
            title: 'Bevispaketdetaljer',
            not_found: 'Bevispaket hittades inte.',
            package_metadata: 'Paketmetadata',
            status: 'Status',
            item_count: 'Antal objekt',
            disposition: 'Disposition',
            closed_at: 'Stängt',
            completeness_dashboard: 'Fullständighetsöversikt',
            no_completeness_data: 'Ingen fullständighetsdata tillgänglig.',
            controls_covered: 'kontroller täckta',
            missing: 'Saknas',
            sign_off_tracker: 'Godkännandespårning',
            stage_framework_owner: 'Ramverksägare',
            stage_legal_compliance: 'Juridik och efterlevnad',
            stage_internal_audit: 'Internrevision',
            approved: 'Godkänt',
            returned: 'Returnerat',
            pending: 'Väntar',
            approve: 'Godkänn',
            return_btn: 'Returnera',
            sign_off_submitted: 'Godkännande skickat',
            artifacts: 'Artefakter',
            no_artifacts: 'Inga artefakter hittades.',
            template_id: 'Mall-ID',
            description: 'Beskrivning',
            classification: 'Klassificering',
            evidence_type: 'Bevistyp',
            framework_section: 'Ramverksavsnitt',
            history: 'Godkännandehistorik',
            expand: 'Expandera',
            collapse: 'Fäll ihop',
            action: 'Åtgärd',
            actor: 'Aktör',
            timestamp: 'Tidsstämpel',
            comment: 'Kommentar',
            close_case: 'Stäng ärende',
            confirm_close: 'Bekräfta stängning',
            closure_notes: 'Stängningsanteckningar',
            disposition_compliant: 'Överensstämmande',
            disposition_non_compliant: 'Ej överensstämmande',
            disposition_partial: 'Delvis',
            case_closed: 'Bevispaket stängt',
            export_package: 'Exportera paket',
            export_complete: 'Bevispaket exporterat',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Översikt',
            properties: 'Egenskaper',
            groups: 'Grupper',
            bindings: 'Bindningar',
            change_requests: 'Ändringsförfrågningar',
            comparison: 'Jämförelse',
            inconsistencies: 'Avvikelser',
            snapshot_schedules: 'Ögonblicksscheman',
            golden_templates: 'Gyllene mallar',
            evidence_packs: 'Bevispaket',
            audit: 'Granskning',
        },
        select_property: 'Välj egenskap…',
        select_policy: 'Välj policy…',
        select_properties: 'Välj egenskaper…',
        select_target_properties: 'Välj målegenskaper…',
        select_owner: 'Välj ägare…',
        select_technical_contact: 'Välj teknisk kontakt…',
        property_statuses: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
            pending: 'Väntande',
            decommissioned: 'Avvecklad',
        },
        dashboard: {
            title: 'Övergripande egenskapsöversikt',
            loading: 'Laddar instrumentpanelsdata...',
            total_properties: 'Totalt Egenskaper',
            active_properties: 'Aktiva Egenskaper',
            snapshot_coverage: 'Snapshot-täckning',
            properties_covered: 'egenskaper täckta',
            total_bindings: 'Totalt antal bindningar',
            deployed_bindings: 'Distribuerad',
            pending_bindings: 'Väntande distribution',
            deployment_progress: 'Distributionsprogress',
            on_target: 'På mål',
            below_target: 'Under mål',
            target_label: 'Mål',
            total_groups: 'Totalt Grupper',
            pending_changes: 'Väntande Ändringar',
            inconsistencies: 'Inkonsekvenser',
            recent_activity: 'Senaste Aktivitet',
            no_recent_activity: 'Inga senaste aktivitet.',
            fetch_error: 'Kunde inte ladda dashboard. Försök igen.',
        },
        properties: {
            title: 'Egenskapsregister',
            new: 'Ny Egenskap',
            edit: 'Redigera Egenskap',
            property_name: 'Namn',
            property_type: 'Typ',
            identifier: 'Identifierare',
            environment: 'Miljö',
            owner_id: 'Ägare ID',
            technical_contact_id: 'Teknisk Kontakt ID',
            decommission: 'Avveckla',
            confirm_decommission: 'Är du säker på att du vill avveckla denna egenskap?',
            no_properties: 'Inga egenskaper hittades.',
            all_environments: 'Alla Miljöer',
            all_types: 'Alla Typer',
            cmp_instance_id: '[[TOK_0]] Förekomst-ID',
            deployment_date: 'Implementeringsdatum',
            identifier_placeholder: 't.ex. www.example.com eller com.example.app',
            owner_name: 'Ägare',
            technical_contact_name: 'Teknisk kontakt',
            sensitive_data_categories: 'Känsliga datakategorier',
            sensitive_data_categories_placeholder: 'Välj känsliga datakategorier',
            requires_enhanced_review: 'Kräver förbättrad granskning',
            sensitive_review_status: 'Granskning av känsliga data',
            sensitive_review_pending: 'Väntar på granskning',
            sensitive_review_approved: 'Godkänd',
            sensitive_review_rejected: 'Avvisad',
            sensitive_review_submit: 'Skicka recension',
            sensitive_review_approve: 'Godkänn',
            sensitive_review_reject: 'Avvisa',
            sensitive_review_notes: 'Granska anteckningar',
            sensitive_review_notes_placeholder: 'Ange recensionsanteckningar...',
            record_withdrawal: 'Rekorduttag',
            withdrawal_subject_id: 'Ämnes-ID',
            withdrawal_consent_id: 'Samtyckes-ID',
            withdrawal_reason: 'Anledning',
            withdrawal_downstream_systems: 'Nedströms system',
            withdrawal_downstream_placeholder: 'system-1, system-2',
            withdrawal_success: 'Uttag spreds framgångsrikt.',
            withdrawal_error: 'Det gick inte att sprida uttag.',
            withdrawal_data_subject_id: 'Den registrerade ID',
            withdrawal_data_subject_id_placeholder: 't.ex. usr_abc123',
            withdrawal_consent_record_id: 'ID för samtyckespost',
            withdrawal_consent_record_id_placeholder: 't.ex. consent_xyz789',
            withdrawal_purposes: 'Återdragna syften',
            withdrawal_purposes_placeholder: 'Välj syften för att återkalla samtycke för...',
            withdrawal_withdrawn_at: 'Uttagsdatum',
            withdrawal_tasks_created: 'Uppgifter skapade',
            withdrawal_affected_bindings: 'Berörda bindningar',
            withdrawal_affected_activities: 'Berörda bearbetningsaktiviteter',
            withdrawal_history: 'Uttagshistorik',
        },
        groups: {
            title: 'Egenskapsgrupper',
            new: 'Ny Grupp',
            group_name: 'Grupp Namn',
            member_count: 'Medlemmar',
            no_groups: 'Inga egenskap grupper hittades.',
            policies: 'Policyer',
            confirm_delete: 'Är du säker på att du vill ta bort den här gruppen?',
        },
        bindings: {
            title: 'Bindningsmatris',
            property: 'Egenskap',
            purpose: 'Syfte',
            legal_basis: 'Rättslig grund',
            bound: 'Bunden',
            no_bindings: 'Inga bindings hittades.',
            bind_policy: 'Bindningspolicy',
            bulk_bind: 'Bulkbindning',
            bind_policy_to_property: 'Bind policy till egendom',
            bulk_bind_policy: 'Bulkbindningspolicy',
            unbound: 'Obundet',
            policy_id: 'Policy-ID',
            version_placeholder: 't.ex. 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Bindning',
            property_name: 'Egenskapsnamn',
            policy_name: 'Policynamn',
            bindings_list: 'Bindningslista',
            binding_actions: {
                start_deploy: 'Starta driftsättning',
                mark_deployed: 'Markera som driftsatt',
                rollback: 'Återställ',
            },
        },
        change_requests: {
            title: 'Ändringsförfrågningsprocess',
            new: 'Ny Ändrings Begäran',
            requester: 'Begärande',
            change_type: 'Ändrings Typ',
            property: 'Egenskap',
            submitted_at: 'Inskickad At',
            no_requests: 'Inga ändrings begäranden hittades.',
            fetch_pipeline_error: 'Kunde inte hämta pipeline. Försök igen.',
            fetch_list_error: 'Kunde inte hämta ändringsbegäranden. Försök igen.',
            create_error: 'Kunde inte skapa ändringsbegäran. Försök igen.',
            action_error: 'Kunde inte utföra åtgärd. Försök igen.',
            approver_name: 'Godkännare',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Alla',
            view_my_properties: 'Mina Egenskaper',
            stage_requests: '{stage}-förfrågningar',
        },
        comparison: {
            title: 'Jämförelsearbetsyta',
            select_properties: 'Välj egenskaper att jämföra',
            compare: 'Jämför',
            no_comparison: 'Välj minst två egenskaper att jämföra.',
            fetch_error: 'Kunde inte hämta jämförelserapporter. Försök igen.',
            run_error: 'Kunde inte köra jämförelse. Försök igen.',
            save_notes_error: 'Kunde inte spara anteckningar. Försök igen.',
            scan_complete: 'Inkonsekvenskontroll slutförd.',
            scan_error: 'Kunde inte köra inkonsekvenskontroll. Försök igen.',
            min_two_properties: 'Ange minst 2 egenskaps-ID:n för jämförelse.',
            view_inconsistencies: 'Visa inkonsekvenser',
            click_to_select: 'Klicka för att välja två eller fler egenskaper',
            no_properties_available: 'Inga egenskaper tillgängliga',
            no_matching_properties: 'Inga matchande egenskaper',
            select_at_least_two_props: 'Välj minst två egenskaper från rullgardinsmenyn ovan.',
            no_differences_found: 'Inga skillnader hittades mellan de valgte egenskaperna.',
            found_inconsistencies: 'Hittade {count} inkonsekvenser i {properties} egenskaper och {bindings} bindningar.',
        },
        inconsistencies: {
            title: 'Avvikelselista',
            property: 'Egenskap',
            field: 'Fält',
            expected: 'Förväntad',
            actual: 'Faktisk',
            severity: 'Allvarlighetsgrad',
            no_inconsistencies: 'Inga inkonsekvenser hittades.',
            trend: 'Inkonsekvenstrend',
            trend_chart_label: 'Inkonsekvenstrenddiagram som visar antal över tid',
            acknowledge: 'Bekräfta',
            resolve: 'Lös',
            suppress: 'Undertryck',
            cr_id_placeholder: 'CR-ID',
            view_all: 'Alla',
            view_my_properties: 'Mina Egenskaper',
            view_dpo_review: '[[TOK_0]] Granskningskö',
            change_request_id_required: 'Ändra begäran-ID krävs för att lösa denna inkonsekvens.',
        },
        snapshot_schedules: {
            title: 'Ögonblicksscheman',
            new: 'Ny Schema',
            schedule_name: 'Schema Namn',
            frequency: 'Frekvens',
            next_run: 'Nästa Körning',
            last_run: 'Senaste Körning',
            no_schedules: 'Inga ögonblicksbild scheman hittades.',
            target_type: 'Måltyp',
            target_id: 'Mål-ID',
            custom_frequency_days: 'Anpassad frekvens (dagar)',
            time_of_day: 'Tid på dagen',
            time: 'Tid',
            retention_days: 'Retention (dagar)',
            execute_now: 'Kör nu',
            placeholder_days: 't.ex. 10',
            target_name: 'Målnamn',
        },
        golden_templates: {
            title: 'Gyllene mallar',
            new: 'Ny Mall',
            template_name: 'Mall Namn',
            property_type: 'Egenskap Typ',
            no_templates: 'Inga gyllene mallar hittades.',
            applicable_group_ids: 'Tillämpliga grupp-ID:n (kommaseparerade)',
            applicable_groups: 'Tillämpliga grupper',
            purposes: 'Ändamål',
            legal_bases: 'Rättsliga grunder',
            banner_config: 'Bannerkonfiguration',
            consent_settings: 'Samtycksinställningar',
            group_ids_placeholder: 'grupp-id-1, grupp-id-2',
            apply_to_property: 'Tillämpa på Egenskap',
            apply_to_group: 'Tillämpa på Grupp',
            apply_success: 'Mall tillämpades framgångsrikt.',
            applications: 'Tillämpningshistorik',
            no_applications: 'Inga malltillämpningar ännu.',
            no_configuration_details: 'Mallen har inga konfigurationsdetaljer. Redigera mallen för att lägga till ändamål, rättsliga grunder, bannerinställningar eller samtyckesinställningar.',
        },
        rollouts: {
            title: 'Mallutrullningar',
            rollout_status: 'Utrullningsstatus',
            confirmed: 'Bekräftad',
            pending: 'Väntande',
            failed: 'Misslyckad',
            confirm: 'Bekräfta Egenskap',
            confirm_success: 'Egenskap bekräftad i utrullning.',
            can_close: 'Alla egenskaper bekräftade — utrullning slutförd',
            cannot_close: 'Väntar på egenskapsbekräftelser',
            no_rollouts: 'Inga utrullningar hittades.',
            in_progress: 'Pågående',
            completed: 'Slutförd',
            cancelled: 'Avbruten',
            reject: 'Avvisa Egenskap',
            reject_success: 'Egenskap avvisad från utrullning.',
            confirm_all: 'Bekräfta Alla',
            reject_all: 'Avvisa Alla',
            confirm_label: 'Bekräfta utrullning för',
            reject_label: 'Avvisa utrullning för',
            confirm_all_label: 'Bekräfta Alla Väntande Utrullningar',
            reject_all_label: 'Avvisa Alla Väntande Utrullningar',
            no_properties_in_rollout: 'Denna utrullning har inga egenskaper.',
        },
        analytics: {
            title: 'Egenskapsanalys',
            opt_in_rate: 'Opt-in-frekvens',
            opt_out_rate: 'Opt-out-frekvens',
            withdrawal_rate: 'Återkallelsefrekvens',
            total_consents: 'Totala samtycken',
            total_withdrawals: 'Totala återkallelser',
            compliance_score: 'Efterlevnadspoäng',
            non_compliant: 'Icke-efterlevande egenskaper',
            no_non_compliant: 'Alla egenskaper är efterlevande.',
            threshold: 'Efterlevnadströskel',
            property_id: 'Fastighets-ID',
            compliant: 'Överensstämmer',
            non_compliant_status: 'Icke-kompatibel',
            compliance_help_summary: 'Hur beräknas efterlevnadspoängen och hur fixar jag det?',
            compliance_help_intro: 'En egendom flaggas som icke-kompatibel när dess poäng är under 80 %. Poängen beräknas som:',
            compliance_help_with_template_label: 'Om en gyllene mall används:',
            compliance_help_with_template_text: '% av konfigurationsnycklarna (ändamål, legal_bases, banner_config, consent_settings) som matchar mallen exakt.',
            compliance_help_no_template_label: 'Om ingen gyllene mall används:',
            compliance_help_no_template_text: '% av bindningarna (samtyckestyper som tilldelats egenskapen) med deployment_status = distribuerad. En egenskap utan bindningar är som standard 100 %.',
            compliance_help_fix_intro: 'För att ta bort en egenskap från den här listan, gör något av följande:',
            compliance_help_fix_deploy_label: 'Distribuera dess bindningar',
            compliance_help_fix_deploy_text: 'öppna sidan Bindningsmatris och ställ in varje bindnings distributionsstatus till distribuerad.',
            compliance_help_fix_template_label: 'Applicera en gyllene mall',
            compliance_help_fix_template_text: 'använd Tillämpa på grupp på mallen och bekräfta sedan lanseringen för den här egenskapen. Se till att egenskapens konfiguration matchar mallen.',
            compliance_help_fix_decommission_label: 'Avveckla fastigheten',
            compliance_help_fix_decommission_text: 'använd knappen Avveckling i egenskapsdetaljmodalen om den inte längre används.',
            compliance_help_fix_no_bindings_label: 'Ta bort alla bindningar',
            compliance_help_fix_no_bindings_text: 'om en egenskap inte har någon mall och inga bindningar får den 100 % som standard.',
        },
        evidence_packs: {
            title: 'Bevispaket',
            new: 'Ny Paket',
            pack_name: 'Paket Namn',
            properties: 'Egenskaper',
            generated_at: 'Genererad Vid',
            no_packs: 'Inga bevis paket hittades.',
            generate: 'Generera',
            content_type_consent_records: 'Samtyckesposter',
            content_type_policy_versions: 'Policy Versioner',
            content_type_binding_history: 'Bindning Historik',
            content_type_change_requests: 'Ändrings Begäranden',
            content_type_inconsistency_reports: 'Inkonsekvens Rapporter',
            content_type_snapshot_data: 'Ögonblicksbild Data',
            content_type_audit_trail: 'Revision Spår',
        },
        audit: {
            title: 'Samtyckeegenskapsgranskning',
            event_type: 'Händelse Typ',
            entity_type: 'Entitet Typ',
            entity_id: 'Entitet ID',
            actor: 'Aktör',
            timestamp: 'Tidsstämpel',
            no_events: 'Inga revision händelser hittades.',
            entity_type_property: 'Egenskap',
            entity_type_group: 'Grupp',
            entity_type_binding: 'Bindning',
            entity_type_change_request: 'Ändringsbegäran',
            entity_type_golden_template: 'Gyllene mall',
            entity_type_snapshot_schedule: 'Ögonblicksschema',
            entity_type_inconsistency: 'Inkonsekvens',
            entity_type_evidence_pack: 'Bevispaket',
            action_created: 'Skapad',
            action_updated: 'Uppdaterad',
            action_deleted: 'Borttagen',
            action_decommissioned: 'Avvecklad',
            action_status_changed: 'Status ändrad',
            action_submitted: 'Inskickad',
            action_approved: 'Godkänd',
            action_rejected: 'Avvisad',
            action_deployed: 'Distribuerad',
            action_rolled_back: 'Återställd',
            action_paused: 'Pausad',
            action_resumed: 'Återupptagen',
            action_cancelled: 'Avbruten',
            action_acknowledged: 'Bekräftad',
            action_resolved: 'Löst',
            action_suppressed: 'Undertryckt',
            action_executed: 'Utförd',
        },
        property_types: {
            website: 'Webbplats',
            mobile_app: 'Mobilapp',
            ott: 'OTT',
            iot_device: 'IoT-enhet',
            kiosk: 'Kiosk',
            api_service: 'API-tjänst',
            sdk: 'SDK',
        },
        environments: {
            production: 'Produktion',
            staging: 'Iscensättning',
            development: 'Utveckling',
            testing: 'Testning',
        },
        group_types: {
            brand: 'Varumärke',
            region: 'Region',
            product_line: 'Produktlinje',
            business_unit: 'Affärsenhet',
            custom: 'Anpassad',
        },
        target_types: {
            property: 'Egenskap',
            group: 'Grupp',
            all: 'Alla',
        },
        frequencies: {
            hourly: 'Varje timme',
            daily: 'Dagligen',
            weekly: 'Veckovis',
            monthly: 'Månadsvis',
            custom: 'Anpassad',
        },
        binding_statuses: {
            current: 'Aktuell',
            outdated: 'Föråldrad',
            pending: 'Väntande',
            deploying: 'Distribuerar',
            rolled_back: 'Återställd',
        },
        sensitive_categories: {
            health: 'Hälsodata',
            biometric: 'Biometriska data',
            genetic: 'Genetiska data',
            racial_ethnic: 'Ras/etniskt ursprung',
            political_opinions: 'Politiska åsikter',
            religious_beliefs: 'Religiösa övertygelser',
            trade_union: 'Fackligt medlemskap',
            sexual_orientation: 'Sexuell läggning',
            criminal_records: 'Brottsregister',
            financial: 'Finansiella data',
            children: 'Barns data',
            geolocation: 'Exakt geolokalisering',
        },
        export_csv: 'Exportera CSV',
        exporting: 'Exporterar...',
        page_x_of_y: 'Sida {page} av {total}',
        regulatory: {
            capture_method_guidance: '[[TOK_0]] kräver samtyckesbevis för att matcha insamlingskanalen. Egendomstyper mappar till samtyckesfångstmetoder: webbplats/OTT = bannerbaserat samtycke, mobilapp/SDK = samtyckesflöde i appen, kiosk = fysisk/samtyckesfångst på skärmen, [[TOK_1]] tjänst = programmatiskt samtycke, IoT-enhet = samtyckesmekanism på enhetsnivå.',
            dashboard_metrics_info: 'Den här instrumentpanelen ger [[TOK_0]] en enda vy av samtyckeshållning över alla digitala egenskaper. Nyckelmått inkluderar: bindningstäckningsprocent (distribuerad kontra total bindning), mallefterlevnad via inkonsekvenswidgeten, väntande ändringsförfrågningar som kräver granskning och fastighetsstatusuppdelning som visar egenskaper med aktiva, inaktiva eller avvecklade tillstånd. Fastigheter med känsliga datakategorier spåras via fastighetsregistret.',
            change_request_impact_info: 'Ändringsbegäranden som påverkar samtyckesegenskaper måste dokumentera regulatorisk påverkan: vilka [TOK_0]] krav som påverkas, om ändringen påverkar känslig databehandling (art. 2.4) och om ändringen kräver ett nytt samtycke från registrerade. Konsekvenssammanfattningen i varje ändringsbegäran beskriver [[TOK_1]] regulatoriska referenser för revisionsbevis.',
            outdated_binding_warning: 'Bindningar med "föråldrad" status indikerar att en egenskap kör en policyversion som inte är aktuell. Dessa egenskaper kanske inte återspeglar de senaste [[TOK_0]] kraven eller organisationspolicyuppdateringarna. Granska och uppdatera föråldrade bindningar omedelbart för att bibehålla [[TOK_1]] efterlevnad för alla samtyckesegenskaper.',
            template_pdpl_alignment: 'Per [[TOK_0]] art. 11 måste gyllene mallar länka syften till rättsliga grunder. Bannerkonfigurationer måste genomdriva opt-in (inte opt-out) enligt art. 11.3 uttryckligt samtycke. Mallar måste ange en uttagsmekanism enligt art. 12. För känsliga uppgifter (Art. 2.4) måste mallar framtvinga uttryckligt skriftligt eller likvärdigt samtycke -- genomklicksacceptans är otillräckligt.',
        },
    },
    localization: {
        nav: {
            dashboard: 'Översikt',
            market_packs: 'Marknadspaket',
            language_packs: 'Språkpaket',
            frameworks: 'Regelverk',
            mappings: 'Modulkopplingar',
            submissions: 'Paketinlämningar',
            translations: 'Översättningsförhandsgranskning',
            audit: 'Granskningsspår',
        },
        dashboard: {
            title: 'Lokaliseringsöversikt',
            loading: 'Laddar instrumentpanelsdata...',
            active_market_packs: 'Aktiva Marknad Paket',
            published_packs_available: 'Publicerade marknadspaket tillgängliga',
            language_packs: 'Språk Paket',
            total_language_packs: 'Totalt antal registrerade språkpaket',
            active_regulatory_frameworks: 'Aktiva Regulatoriska Ramverk',
            frameworks_active: 'Ramverk med aktiva status',
            pending_pack_submissions: 'Väntande Paket Inskickningar',
            submissions_awaiting_review: 'Inskickningar inväntar granskning',
            recent_audit_events: 'Senaste Revision Händelser',
            no_recent_audit: 'Inga senaste revision händelser.',
            event_type: 'Händelse Typ',
            entity_type: 'Entitet Typ',
            entity_id: 'Entitet ID',
            actor: 'Aktör',
            timestamp: 'Tidsstämpel',
        },
        market_packs: {
            title: 'Marknadspaketkatalog',
            new: 'Ny Marknad Paket',
            pack_name: 'Paket Namn',
            market: 'Marknad',
            locale: 'Språkinställning',
            no_packs: 'Inga marknad paket hittades.',
        },
        language_packs: {
            title: 'Språkpaket',
            new: 'Ny Språk Paket',
            language: 'Språk',
            locale_code: 'Språkinställning Kod',
            completeness: 'Fullständighet',
            completeness_detail: 'Fullständighetsdetalj',
            overall_completeness: 'Övergripande fullständighet',
            total_keys: 'Totalt nycklar',
            translated_keys: 'Översatta nycklar',
            missing_keys: 'Saknade nycklar',
            namespace_breakdown: 'Namnutrymmesfördelning',
            namespace: 'Namnrymd',
            translated: 'Översatt',
            no_packs: 'Inga språk paket hittades.',
            install_language_pack: 'Installera språkpaket',
            available_packs: 'Tillgängliga språkpaket',
            install: 'Installera',
            all_installed: 'Alla språkpaket är redan installerade.',
            install_success: 'Språkpaket installerat.',
            market: 'Marknad',
            featured: 'Utvald',
        },
        frameworks: {
            title: 'Regelverk',
            new: 'Ny Ramverk',
            framework_name: 'Ramverk Namn',
            jurisdiction: 'Jurisdiktion',
            effective_date: 'Gällande Datum',
            no_frameworks: 'Inga regulatoriska ramverk hittades.',
            view_requirements: 'Visa krav',
            hide_requirements: 'Dölj krav',
            show_legacy: 'Visa äldre ramverk',
            effective_until: 'Giltig till',
            effective_on: 'Giltig från',
            replaced_by: 'Ersatt av',
            replaces_label: 'Ersätter',
            status_legacy: 'Äldre',
            status_upcoming: 'Kommande',
            watchlist: 'Bevakningslista',
            watchlist_empty: 'Inga utkast eller kommande ramverk',
            watchlist_empty_desc: 'Ramar med status "utkast" eller "kommande" kommer att visas här för övervakning.',
            expected_effective: 'Förväntas effektiv',
            effective_date_tbd: 'Ikraftträdandedatum: TBD',
            activate: 'Aktivera',
            ai_law_title: 'Vietnam [[TOK_0]] lag',
            ai_risk_classification: '[[TOK_0]] Riskklassificering',
            ai_system_dossier: '[[TOK_0]] Systemdokumentation',
            ai_labeling_checklist: '[[TOK_0]] Märkning och avslöjande',
            ai_incident_report: '[[TOK_0]] Incidentrapport',
            ai_impact_assessment: '[[TOK_0]] Konsekvensbedömning',
            ai_sandbox_application: 'Sandbox-applikation',
            ai_sandbox_monitoring: 'Sandlådeövervakning',
            ai_sandbox_completion: 'Slutförande av sandlåda',
            ai_submission_tracker: 'Inlämningsspårare',
            ai_evidence_capture: 'Bevisfångst',
            risk_level_minimal: 'Minimal risk',
            risk_level_limited: 'Begränsad risk',
            risk_level_high: 'Hög risk',
            risk_level_unacceptable: 'Oacceptabel risk',
            submission_status_draft: 'Utkast',
            submission_status_submitted: 'Inlämnad',
            submission_status_returned: 'Återkom för ändring',
            submission_status_accepted: 'Godkänd',
            submission_status_rejected: 'Avvisad',
            submission_status_closed: 'Stängt',
            ecommerce_law_title: 'Vietnam e-handelslag',
            ecommerce_platform_classification: 'Plattformsklassificering',
            ecommerce_seller_register: 'Säljarregister',
            ecommerce_complaint_register: 'Klagomålsregister',
            ecommerce_takedown_register: 'Nedtagningsregister',
            ecommerce_submission_tracking: 'Inlämningsspårning',
            ecommerce_dossier_checklist: 'Dokumentationschecklista',
            ecommerce_cross_border: 'Överensstämmelse över gränserna',
            ecommerce_trustmark: 'Trustmark Program',
            ecommerce_notification: 'Avisering',
            ecommerce_registration: 'Registrering',
            ecommerce_termination: 'Uppsägning',
            ecommerce_reporting_readiness: 'Rapporteringsberedskap',
            ecommerce_evidence_capture: 'Bevisfångst',
            submission_status_approved: 'Godkänd',
            cybersec_law_2025_title: 'Vietnam cybersäkerhetslag (2025)',
            cybersec_system_classification: 'Systemklassificering',
            cybersec_risk_assessment: 'Riskbedömning',
            cybersec_incident_report: 'Incidentrapport',
            cybersec_authority_cooperation: 'Myndighetssamarbete',
            cybersec_data_localization: 'Datalokalisering',
            cybersec_vendor_security: 'Leverantörssäkerhet',
            cybersec_submission_tracker: 'Inlämningsspårare',
            cybersec_evidence_capture: 'Bevisfångst',
            cybersec_dossier_checklist: 'Dokumentationschecklista',
            cybersec_classification_general: 'Allmänt',
            cybersec_classification_important: 'Viktigt',
            cybersec_classification_critical: 'Kritisk',
            data_law_title: 'Vietnams datalag',
            data_inventory: 'Datainventering',
            data_classification: 'Dataklassificering',
            data_sharing: 'Datadelning',
            data_governance: 'Datastyrning',
            data_submission_tracker: 'Inlämningsspårare',
            data_evidence_capture: 'Bevisfångst',
            data_dossier_checklist: 'Dokumentationschecklista',
            telecom_law_title: 'Vietnam telekomlag',
            telecom_authority_request: 'Myndighetsbegäran',
            telecom_disclosure: 'Avslöjande',
            telecom_confidentiality: 'Sekretess',
            telecom_submission_tracker: 'Inlämningsspårare',
            telecom_evidence_capture: 'Bevisfångst',
            telecom_dossier_checklist: 'Dokumentationschecklista',
            pdpl_law_title: 'Vietnams personuppgiftslagstiftning',
            pdpl_breach_notification: 'Avisering om intrång',
            pdpl_dpo_notification: '[[TOK_0]] Avisering om möte',
            pdpl_data_subject_notification: 'Registreringsanmälan',
            pdpl_submission_tracker: 'Inlämningsspårare',
            pdpl_evidence_capture: 'Bevisfångst',
            pdpl_dossier_checklist: 'Dokumentationschecklista',
            pdpl_authority_filing: 'Myndighetsarkivering',
            pdpl_mops_filing: 'MoPS-arkivering',
        },
        mappings: {
            title: 'Modulkopplingar',
            new: 'Ny Mappning',
            module: 'Modul',
            market_pack: 'Marknad Paket',
            mapping_status: 'Mappning Status',
            no_mappings: 'Inga modul mappningar hittades.',
            incomplete_entries_warning: '{count} mappning(ar) dolda på grund av saknat ramverks-ID, krav-ID eller modul.',
        },
        submissions: {
            title: 'Paketinlämningar',
            new: 'Ny Inskickning',
            submitter: 'Inskickare',
            pack: 'Paket',
            submitted_at: 'Inskickad At',
            no_submissions: 'Inga paket inskickningar hittades.',
            installed_sector_overlays_title: 'Sektoröverlägg ({count})',
            installed_sector_overlays_aria: 'Installerade sektoröverlägg',
            installed_col_name: 'Namn',
            installed_col_code: 'Kod',
            installed_col_sector: 'Sektor',
            installed_col_mode: 'Läge',
            installed_col_status: 'Status',
            installed_refresh: 'Uppdatera',
        },
        translations: {
            title: 'Översättningsförhandsgranskning',
            select_locale: 'Välj språk',
            select_module: 'Välj Modul',
            key: 'Key',
            value: 'Värde',
            no_translations: 'Inga översättningar hittades.',
        },
        audit: {
            title: 'Lokalisering Revision Spår',
            event_type: 'Händelse Typ',
            entity_type: 'Entitet Typ',
            entity_id: 'Entitet ID',
            entity_name: 'Enhetsnamn',
            actor: 'Aktör',
            timestamp: 'Tidsstämpel',
            payload: 'Nyttolast',
            collapse_payload: 'Fäll ihop nyttolastdetaljer',
            expand_payload: 'Expandera nyttolastdetaljer',
            collapse: 'Fäll ihop',
            expand: 'Expandera',
            all_entity_types: 'Alla enhetstyper',
            no_events: 'Inga revision händelser hittades.',
        },
        market_packs_detail: {
            installed_at: 'Installerad den',
            pack_details_label: 'Paketdetaljer',
            market_code: 'Marknadskod',
            supported_locales: 'Stödda lokaler',
            min_platform_version: 'Min. plattformsversion',
            pack_information: 'Paketinformation',
            pack_contents: 'Förpackningens innehåll',
            included_frameworks: 'Inkluderade ramverk',
            pack_artifacts: 'Paketartefakter',
            no_artifacts: 'Inga artefakter hittades för detta paket',
            pack_not_found: 'Paket hittades inte',
        },
        mappings_form: {
            framework_id: 'Ramverks-ID',
            requirement_id: 'Krav-ID',
            module_label: 'Modul',
            mapping_type: 'Mappningstyp',
            configuration_json: 'Konfiguration (JSON)',
            conflict_resolution: 'Konfliktlösning',
            is_override: 'Är åsidosättning',
            all_modules: 'Alla moduler',
            all_mapping_types: 'Alla mappningstyper',
        },
        submissions_detail: {
            submission_id: 'Inlämnings-ID',
            validation: 'Validering',
            reviewers: 'Granskare',
            start_review: 'Starta granskning',
            hide_comments: 'Dölj kommentarer',
            review_comments: 'Granskningskommentarer',
            loading_comments: 'Läser in kommentarer...',
            no_comments: 'Inga kommentarer ännu.',
            add_comment: 'Lägg till kommentar',
            reject_submission: 'Avvisa inlämning',
            reason_for_rejection: 'Anledning till avvisning',
            reviewer_ids: 'Granskares IDn (kommaseparerade)',
            submit_new_pack: 'Skicka in nytt paket',
            pack_type: 'Pakettyp',
            market_code: 'Marknadskod',
            target_locales: 'Mållokaler',
            pack_file: 'Paketfil',
            pack_format_info: 'Paketformat: Marknadspaket bör innehålla lokalspecifika [[TOK_0]]-filer med namnområde/nyckelöversättningar. Språkpaket bör tillhandahålla översättningar för de angivna måladresserna. Se dokumentationen för detaljerat schema.',
            accepted_formats: 'Godkända format: .json eller .zip. [[TOK_0]]-filer bör innehålla ett platt eller namnavgränsat objekt med översättningsnyckel-värdepar. ZIP-filer bör innehålla en eller flera [[TOK_1]] språkfiler.',
            comma_separated_locales: 'Kommaseparerade lokalkoder för detta språkpaket',
            confirm_approval: 'Bekräfta godkännande',
            approve_message: 'Godkänn denna paketinlämning?',
            submission_label: 'Inlämning',
            all_pack_types: 'Alla pakettyper',
            passed: 'godkänd',
            failed_label: 'misslyckades',
            market_code_required: 'Marknadskod krävs',
            version_required: 'Version krävs',
            pack_type_regulatory: 'Regulatorisk',
            framework_code: 'Ramverkskod',
            jurisdiction_code: 'Jurisdiktionskod',
            pack_source: 'Källa',
            pack_source_manual: 'Manuell',
            pack_version: 'Paketversion',
            install_regulatory_pack: 'Installera regulatoriskt paket',
            regulatory_pack_desc: 'Ladda upp ett regulatoriskt ramverkspaket (.zip)',
            framework_required: 'Regelverkskod krävs',
            jurisdiction_required: 'Jurisdiktionskod krävs',
        },
        catalog_detail: {
            packs_installed_of: 'av {total} paket installerade',
            install_all: 'Installera alla',
            installing: 'Installerar...',
            removing: 'Tar bort...',
            requires: 'Kräver',
            tab_catalog: 'Katalog',
            tab_installed: 'Installerad',
            details: 'Detaljer',
        },
        translations_detail: {
            source_locale: 'Källlokal',
            target_locale: 'Mållokal',
            locales_must_differ: 'Käll- och mållokal måste vara olika.',
            all_keys_translated: 'Alla nycklar översatta',
            keys_missing: '[[TOK_1]] nyckel(ar) saknas',
            show_missing_only: 'Visa endast saknade',
            namespace: 'Namnrymd',
            source: 'Källa',
            target: 'Mål',
        },
        frameworks_detail: {
            tab_frameworks: 'Ramverk',
            tab_watchlist: 'Bevakningslista',
            authority: 'Myndighet',
            requirements_count: 'Krav',
            all_types: 'Alla typer',
            collapse_all: 'Fäll ihop alla',
            expand_all: 'Expandera alla',
            filtered_to: 'Filtrerat till',
            clear_filter: 'Rensa filter',
            no_requirements: 'Inga krav hittades för detta ramverk.',
            requirements_label: 'Krav',
            status_updated: 'Status uppdaterad',
            overview_tab: 'Översikt',
            forms_tab: 'Formulär',
            procedures_tab: 'Förfaranden',
            fines_risks_tab: 'Böter och risker',
            deadlines_tab: 'Tidsfrister',
            guidance_tab: 'Vägledning',
            guidance_empty: 'Inget vägledningsinnehåll för detta ramverk.',
            guidance_loading: 'Läser in vägledning...',
            guidance_section: 'Vägledningssektion',
            guidance_view: 'Visa vägledning',
            guidance_map_to_workflow: 'Karta till arbetsflöde',
            guidance_link_evidence: 'Länkbevis',
            guidance_filter_type: 'Typ',
            guidance_filter_category: 'Kategori',
            guidance_filter_module: 'Modul',
            guidance_filter_status: 'Status',
            guidance_filter_search: 'Sökvägledning',
            guidance_filter_all: 'Alla',
            guidance_table_reference: 'Referens',
            guidance_table_name: 'Vägledningsnamn',
            guidance_table_type: 'Typ',
            guidance_table_category: 'Kategori',
            guidance_table_effective_date: 'Ikraftträdande datum',
            guidance_table_modules: 'Relaterade moduler',
            guidance_table_actions: 'Åtgärder',
            guidance_reference_only_banner: 'Endast referens – gäller för sektorn {[[TOK_1]]} men inte din organisation.',
            guidance_related_link: 'Relaterad vägledning',
            deadlines_empty: 'Inga regulatoriska tidsfrister hittades för detta ramverk.',
            deadlines_sla_type: 'SLA-typ',
            deadlines_value: 'Tidsfrist',
            deadlines_unit: 'Enhet',
            deadlines_extension: 'Förlängning',
            deadlines_reference: 'Juridisk referens',
            framework_stack: 'Ramverksstruktur',
            layer_parent_law: 'Huvudlag',
            layer_implementing_decree: 'Genomförandeförordning',
            layer_enforcement_decree: 'Verkställighetsförordning',
            layer_admin_procedures: 'Administrativa förfaranden',
            status_active: 'Aktiv',
            status_draft: 'Utkast',
            draft_enforcement_badge: 'Utkast — ännu inte antaget',
            effective_date: 'Ikraftträdandedatum',
            forms_table_id: 'Formulär-ID',
            forms_table_name: 'Formulärnamn',
            forms_table_source: 'Källa',
            forms_table_category: 'Kategori',
            forms_table_type: 'Typ',
            fill_form: 'Fyll i formulär',
            view_reference: 'Visa referens',
            forms_official: 'Officiell',
            forms_internal: 'Intern',
            forms_empty: 'Inga formulär hittades för detta ramverk.',
            forms_loading: 'Laddar formulär...',
            filter_by_source_layer: 'Filtrera efter källlager',
            all_layers: 'Alla lager',
            procedures_id: 'Förfarande-ID',
            procedures_name: 'Förfarande',
            procedures_trigger: 'Utlösare',
            procedures_steps: 'Steg',
            procedures_outputs: 'Resultat',
            procedures_related_forms: 'Relaterade formulär',
            procedures_submission_channels: 'Inlämningskanaler',
            procedures_empty: 'Inga förfaranden hittades för detta ramverk.',
            fines_area: 'Överträdelseområde',
            fines_articles: 'Utkastartiklar',
            fines_individual: 'Böter (enskild)',
            fines_organization: 'Böter (organisation)',
            fines_revenue: 'Intäktseskalering',
            fines_deadlines: 'Tidsfrister',
            fines_remediation: 'Åtgärder',
            fines_related: 'Relaterade förfaranden',
            fines_empty: 'Inga verkställighetsuppgifter tillgängliga för detta ramverk.',
            fines_enforcement_pending: 'Verkställighetsramverk ännu inte publicerat. Sanktionsuppgifter läggs till när genomförandeinstrumentet har utfärdats.',
            view_details: 'Visa detaljer',
            back_to_list: 'Tillbaka till listan',
            description: 'Beskrivning',
            jurisdiction: 'Jurisdiktion',
            lineage: 'Härkomst',
            replaces: 'Ersätter',
            replaced_by: 'Ersatt av',
            requirements: 'Krav',
            tab_navigation: 'Ramverksdetalj-flikar',
            forms_table_actions: 'Åtgärder',
            create_form: 'Skapa formulär',
            mark_promulgated: 'Markera som utfärdad',
            status_promulgated: 'Utfärdad',
            promulgated_success: 'Lagerstatus uppdaterad till utfärdad',
            transition_review: 'Övergångsgranskning',
            transition_review_desc: 'Detta ramverk har en väntande övergångsgranskning för antagande av efterföljarlag.',
            transition_review_by: 'Granskningsfrist',
            transition_review_status: 'Granskningsstatus',
            transition_review_notes: 'Anteckningar',
            transition_review_pending: 'Väntande',
            transition_review_in_progress: 'Pågående',
            transition_review_completed: 'Slutförd',
            transition_review_successor: 'Efterföljande ramverk',
            transition_review_lead_time: 'Förberedelsetid',
            transition_review_lead_time_days: '{days} dagar före ikraftträdandedatum',
            transition_review_forms_heading: 'Formulärövergångsgranskningar',
            transition_review_forms_desc: 'Granska varje operativ mall för relevans under efterföljande ramverk.',
            transition_review_outcome: 'Resultat',
            transition_review_outcome_carry_forward: 'Behålls',
            transition_review_outcome_carry_forward_revised: 'Behålls (reviderad)',
            transition_review_outcome_retire: 'Avvecklas',
            transition_review_outcome_split: 'Delas',
            transition_review_outcome_awaiting_decree: 'Inväntar förordning',
            transition_review_no_forms: 'Inga formulärövergångsgranskningar konfigurerade.',
            transition_review_update_success: 'Övergångsgranskning uppdaterad',
            transition_review_operational_note: 'Dessa är processstödjande operativa mallar, inte lagstadgade formulärantal. Juridisk tillhörighet kvarstår under det gamla ramverket tills efterföljarlagen träder i kraft.',
            rights_tab: 'Rättigheter',
            rights_empty: 'Inga registrerades rättigheter definierade för detta regelverk.',
            rights_code: 'Kod',
            rights_name: 'Rättighet',
            rights_legal_basis: 'Rättslig grund',
            rights_elaborating_articles: 'Detaljartiklar',
            rights_description: 'Beskrivning',
            requirements_reference: 'Referens',
            requirements_mandatory: 'Obligatorisk',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'Källa',
            category_legal_basis: 'Rättslig grund',
            category_data_subject_rights: 'Rättigheter för den registrerade',
            category_notification: 'Avisering',
            category_assessment: 'Bedömning',
            category_governance: 'Styrning',
            category_record_keeping: 'Registerföring',
            category_cross_border: 'Gränsöverskridande',
            category_technical_measures: 'Tekniska åtgärder',
            category_incident_reporting: 'Incidentrapportering',
            category_risk_management: 'Riskhantering',
            category_supply_chain: 'Supply Chain',
            category_certification: 'Certifiering',
            child_frameworks: '[[TOK_1]] barnram',
            child_frameworks_plural: '[[TOK_1]] underordnade ramar',
            replaces_prefix: 'Ersätter:',
            replaced_by_prefix: 'Ersatt av:',
            responsible_prefix: 'Ansvarig:',
            watchlist_empty_hint: 'Ramar med status "utkast" eller "kommande" kommer att visas här för övervakning.',
            framework_count: '[[TOK_1]] ramverk',
            framework_count_plural: '[[TOK_1]] ramar',
            hiding_legacy: '(döljer [[TOK_1]] arv)',
            label_VN_PDPL: '[[TOK_0]] (dekret 13/2023)',
            label_VN_PDPD_DECREE_13: 'PDPD-dekret 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Lag 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Dekret [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: '[[TOK_0]] Verkställighetsutkast 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Datalagen',
            label_VN_DATA_LAW_DECREE_165_2025: 'Datalagsdekret 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Utkast till databörser 2026',
            label_VN_TELECOM_LAW_2023: 'Telekommunikationslag 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Telekomdekret 163/2024',
            label_VN_CYBERSEC_LAW: 'Cybersäkerhetslag (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Cybersec-dekret 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Cybersäkerhetslag 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'E-handelslag 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] lag 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Företag',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Myndighet',
            sla_type_rights_request_ack: 'Rättighetsbegäran erkännande',
            'sla_type_Access control review': 'Granskning av åtkomstkontroll',
            'sla_type_Annual governance attestation': 'Årligt styrelseintyg',
            'sla_type_Audit review cycle': 'Revision granskning cykel',
            'sla_type_Authority request response': 'Myndighetsbegäran svar',
            'sla_type_Change notification processing': 'Ändra aviseringsbearbetning',
            'sla_type_Complaint acknowledgment': 'Erkännande av klagomål',
            'sla_type_Complaint resolution': 'Klagomålslösning',
            'sla_type_Confidentiality policy review': 'Granskning av sekretesspolicyn',
            'sla_type_Cybersecurity incident full report': 'Hela rapporten om cybersäkerhetsincident',
            'sla_type_Cybersecurity incident initial report': 'Inledande rapport om cybersäkerhetsincident',
            'sla_type_Data inventory review': 'Datainventering granskning',
            'sla_type_Disclosure log review cycle': 'Granskningscykel för avslöjandelogg',
            'sla_type_Incident classification decision': 'Incidentklassificeringsbeslut',
            'sla_type_Information system classification review': 'Klassificering av informationssystem',
            'sla_type_Notification processing (sales website/app)': 'Aviseringsbearbetning (säljwebbplats/app)',
            'sla_type_Pen test cycle': 'Penna testcykel',
            'sla_type_Registration processing (service platform)': 'Registreringsbehandling (serviceplattform)',
            'sla_type_Risk assessment cycle': 'Riskbedömningscykel',
            'sla_type_Takedown decision (after review)': 'Borttagningsbeslut (efter granskning)',
            'sla_type_Termination notice (public)': 'Uppsägningsmeddelande (offentligt)',
            sla_type_ai_impact_assessment_completion: '[[TOK_0]] konsekvensbedömning slutförd',
            sla_type_ai_sandbox_application_review: '[[TOK_0]] granskning av sandlådeansökan',
            sla_type_ai_serious_incident_report: '[[TOK_0]] rapport om allvarlig incident',
            sla_type_ai_system_registration: '[[TOK_0]] systemregistrering',
            sla_type_authority_request_response: 'Myndighetsbegäran svar',
            sla_type_certificate_issuance_review: 'Granskning av certifikatutfärdande',
            sla_type_complaint_handling_approach_notice: 'Anmälningsmeddelande om klagomålshantering',
            sla_type_complaint_incomplete_info_request: 'Ofullständig informationsbegäran för klagomål',
            sla_type_data_governance_attestation: 'Intyg om datastyrning',
            sla_type_dsr_acknowledgment: 'DSR-erkännande',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Cl.2) — Dra tillbaka / begränsa / invända',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Cl.2) — Tredje part',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Cl.3) — Tillgång / korrigera / tillhandahålla',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Cl.3) — Tredje part',
            sla_type_dsr_cl4_deletion: 'DSR (Cl.4) — Borttagning',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Cl.4) — Borttagning, tredje part',
            sla_type_dsr_cl5_protective_measures: 'DSR (Cl.5) — Skyddsåtgärder',
            sla_type_telecom_authority_request_response: 'Begäransvar från telekommyndigheten',
            sla_type_rights_request_completion: 'Rättigheter begär komplettering',
            sla_type_incident_authority_notification: 'Incidentmyndighetens anmälan',
            sla_type_incident_subject_notification: 'Anmälan om händelseföremål',
            sla_type_dpia_completion: '[[TOK_0]] slutförande',
            sla_type_data_retention_review: 'Granskning av datalagring',
            sla_type_authority_filing_review: 'Granskning av myndighetens ansökan',
            sla_type_authority_supplement_response: 'Myndighetstilläggssvar',
            sla_type_authority_resubmission: 'Återinlämnande av myndigheten',
            sla_type_authority_filing_supplement_response: 'Myndigheten lämnar kompletteringssvar',
            sla_type_authority_filing_resubmission: 'Myndighetsinlämning på nytt',
            unit_working_days: 'arbetsdagar',
            unit_calendar_days: 'kalenderdagar',
            unit_hours: 'timmar',
            form_category_dpa: 'DPA',
            form_category_dsr: 'DSR',
            form_category_consent: 'Samtycke',
            form_category_privacy: 'Sekretess',
            form_category_breach: 'Brott',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: 'Registrera dig',
            form_category_monitoring: 'Övervakning',
            form_category_vendor: 'Försäljare',
            form_category_org: 'Organisatorisk',
            form_category_sector: 'Sektor',
            form_category_data_mapping: 'Datakartläggning',
            form_category_governance: 'Styrning',
            form_category_incident: 'Incident',
            form_category_authority_submission: 'Myndighetsinlämning',
            form_category_notice: 'Observera',
            form_category_assessment_report: 'Bedömningsrapport',
            form_category_request: 'Begäran',
            form_category_dossier: 'Dokumentation',
            form_category_filing: 'Arkivering',
            module_consent: 'Samtycke',
            module_rights_request: 'Rättighetsbegäran',
            module_classification: 'Klassificering',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Styrning',
            module_monitoring: 'Övervakning',
            module_register: 'Registrera dig',
            module_risk: 'Risk',
            module_data_mapping: 'Datakartläggning',
            module_incident: 'Incident',
            module_assessment: 'Bedömning',
            module_vendor: 'Försäljare',
            module_policy: 'Policy',
            module_audit: 'Granskning',
            module_training: 'Utbildning',
            module_discovery: 'Upptäckt',
            enum_guidance_type_calculation_guidance: 'Beräkningsvägledning',
            enum_guidance_type_implementation_guidance: 'Implementeringsvägledning',
            enum_guidance_type_interpretive_note: 'Tolkningsanmärkning',
            enum_guidance_type_legal_guidance: 'Juridisk vägledning',
            enum_guidance_type_procedural_guidance: 'Procedurvägledning',
            enum_guidance_type_sector_guidance: 'Branschvägledning',
            enum_guidance_type_technical_methodology: 'Teknisk metodik',
            enum_guidance_category_annual_reporting: 'Årsredovisning',
            enum_guidance_category_authority_cooperation: 'Myndighetssamarbete',
            enum_guidance_category_authority_coordination: 'Myndighetssamordning',
            enum_guidance_category_business_continuity: 'Affärskontinuitet',
            enum_guidance_category_capital_adequacy: 'Kapitaltäckning',
            enum_guidance_category_complaint_handling: 'Klagomålshantering',
            enum_guidance_category_consent: 'Samtycke',
            enum_guidance_category_consent_management: 'Samtyckeshantering',
            enum_guidance_category_consumer_protection: 'Konsumentskydd',
            enum_guidance_category_control_environment: 'Kontrollmiljö',
            enum_guidance_category_cross_border: 'Gränsöverskridande',
            enum_guidance_category_cross_border_transfers: 'Gränsöverskridande överföringar',
            enum_guidance_category_data_classification: 'Dataklassificering',
            enum_guidance_category_data_localization: 'Datalokalisering',
            enum_guidance_category_data_protection_impact_assessment: 'Dataskyddskonsekvensbedömning',
            enum_guidance_category_direct_marketing: 'Direktmarknadsföring',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Styrning',
            enum_guidance_category_ict_risk_management: 'IKT Riskhantering',
            enum_guidance_category_incident_management: 'Incidenthantering',
            enum_guidance_category_internal_audit: 'Internrevision',
            enum_guidance_category_isms_documentation: 'ISMS dokumentation',
            enum_guidance_category_lawful_basis: 'Laglig grund',
            enum_guidance_category_licensing: 'Licensiering',
            enum_guidance_category_local_presence: 'Lokal närvaro',
            enum_guidance_category_logging_and_retention: 'Loggning & retention',
            enum_guidance_category_logical_and_physical_access: 'Logisk och fysisk åtkomst',
            enum_guidance_category_operational_resilience_testing: 'Operationell resilienstestning',
            enum_guidance_category_outsourcing: 'Outsourcing',
            enum_guidance_category_platform_registration: 'Plattformsregistrering',
            enum_guidance_category_quality_of_service: 'Servicekvalitet',
            enum_guidance_category_risk_classification: 'Riskklassificering',
            enum_guidance_category_risk_management: 'Riskhantering',
            enum_guidance_category_scope_definition: 'Omfattning Definition',
            enum_guidance_category_sectoral_localisation: 'Sektoriell lokalisering',
            enum_guidance_category_subscriber_protection: 'Abonnentskydd',
            enum_guidance_category_supply_chain: 'Supply Chain',
            enum_guidance_category_system_classification: 'Systemklassificering',
            enum_guidance_category_system_operations: 'Systemdrift',
            enum_guidance_category_telecommunications_data: 'Telekommunikationsdata',
            enum_guidance_category_third_party_risk: 'Tredjepartsrisk',
            enum_guidance_category_transitional_provisions: 'Övergångsbestämmelser',
            enum_guidance_category_vulnerability_management: 'Sårbarhetshantering',
            enum_guidance_status_active: 'Aktiv',
            enum_guidance_status_draft: 'Utkast',
            enum_module_access_management: 'Åtkomsthantering',
            enum_module_ai_governance: '[[TOK_0]] Styrning',
            enum_module_asset_management: 'Asset Management',
            enum_module_audit_trail: 'Revisionsspår',
            enum_module_breach_notification: 'Avisering om intrång',
            enum_module_capital_adequacy: 'Kapitaltäckning',
            enum_module_classification: 'Klassificering',
            enum_module_consent: 'Samtycke',
            enum_module_consent_management: 'Samtyckeshantering',
            enum_module_cross_border_transfers: 'Gränsöverskridande överföringar',
            enum_module_data_localization: 'Datalokalisering',
            enum_module_data_mapping: 'Datakartläggning',
            enum_module_data_protection: 'Dataskydd',
            enum_module_data_subject_rights: 'Rättigheter för den registrerade',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Kryptering',
            enum_module_governance: 'Styrning',
            enum_module_incident: 'Incident',
            enum_module_incident_management: 'Incidenthantering',
            enum_module_internal_audit: 'Internrevision',
            enum_module_isms_documentation: 'ISMS dokumentation',
            enum_module_isms_governance: 'ISMS-styrning',
            enum_module_logging_and_monitoring: 'Loggning & övervakning',
            enum_module_monitoring: 'Övervakning',
            enum_module_policy_management: 'Policyhantering',
            enum_module_risk: 'Risk',
            enum_module_risk_management: 'Riskhantering',
            enum_module_training: 'Utbildning',
            enum_module_vendor: 'Försäljare',
            enum_module_vendor_management: 'Leverantörshantering',
            enum_module_vendor_risk: 'Leverantörsrisk',
            enum_module_vulnerability_management: 'Sårbarhetshantering',
            category_access: 'Tillgång',
            category_availability: 'Tillgänglighet',
            category_change_management: 'Change Management',
            category_classification: 'Klassificering',
            category_communication_and_information: 'Kommunikation & Information',
            category_compliance: 'Efterlevnad',
            category_confidentiality: 'Sekretess',
            category_control_activities: 'Kontrollaktiviteter',
            category_control_environment: 'Kontrollmiljö',
            category_incident: 'Incident',
            category_internal_audit: 'Internrevision',
            category_internal_control: 'Intern kontroll',
            category_logical_and_physical_access: 'Logisk och fysisk åtkomst',
            category_mis_data: 'Management Information System Data',
            category_monitoring: 'Övervakning',
            category_monitoring_activities: 'Övervakningsaktiviteter',
            category_outsourcing: 'Outsourcing',
            category_privacy: 'Sekretess',
            category_processing_integrity: 'Bearbetningsintegritet',
            category_reporting: 'Rapportering',
            category_risk_assessment: 'Riskbedömning',
            category_risk_mitigation: 'Riskreducering',
            category_sector_applicability: 'Sektorns tillämplighet',
            category_system_operations: 'Systemdrift',
            category_training: 'Utbildning',
            category_vendor: 'Försäljare',
            guidance_related_forms_advisory: 'Vissa formulär har relaterad vägledning — se i',
            guidance_related_procedures_advisory: 'Vissa procedurer har relaterad vägledning — se i',
            guidance_related_requirements_advisory: 'Vissa krav har relaterad vägledning — se i',
        },
        channels: {
            title: 'Inlämningskanaler och deadlines',
            channels: 'Inlämningskanaler',
            add_channel: 'Lägg till kanal',
            channel_type: 'Typ',
            name: 'Namn',
            instructions: 'Instruktioner',
            active: 'Aktiv',
            no_channels: 'Inga inlämningskanaler konfigurerade',
            portal: 'Portal',
            in_person: 'Personligen',
            postal: 'Post',
            email: 'E-post',
            add: 'Lägg till',
            deadlines: 'Regulatoriska deadlines',
            add_deadline: 'Lägg till deadline',
            label: 'Etikett',
            days: 'Dagar',
            day_type: 'Dagtyp',
            calendar_days: 'Kalenderdagar',
            working_days: 'Arbetsdagar',
            no_deadlines: 'Inga deadlines konfigurerade',
            description: 'Beskrivning',
            failed_load: 'Kunde inte load channel data',
            channel_added: 'Kanal tillagd',
            channel_added_announce: 'Inlämningskanal tillagd',
            failed_add_channel: 'Kunde inte add channel',
            deadline_added: 'Deadline tillagd',
            deadline_added_announce: 'Regulatorisk deadline tillagd',
            failed_add_deadline: 'Kunde inte add deadline',
        },
        module_links: {
            title: 'Ramverkslänkning',
            modules: 'Länkade moduler',
            add_module: 'Lägg till modul',
            module_code: 'Modulkod',
            required: 'Obligatorisk',
            link: 'Länka',
            no_modules: 'Inga moduler länkade',
            notes: 'Anteckningar',
            personas: 'Länkade personas',
            add_persona: 'Lägg till persona',
            persona_id: 'Persona-ID',
            role_description: 'Rollbeskrivning',
            no_personas: 'Inga personas länkade',
            failed_load: 'Kunde inte load framework links',
            module_linked: 'Modul länkad',
            module_linked_announce: 'Modul länkad',
            failed_link_module: 'Kunde inte link module',
            persona_linked: 'Persona länkad',
            persona_linked_announce: 'Persona länkad',
            failed_link_persona: 'Kunde inte link persona',
        },
        regulatory_updates: {
            statuses: {
                pending: 'Väntar',
                assessed: 'Bedömd',
                applied: 'Tillämpad',
                dismissed: 'Avfärdad',
            },
            title: 'Regulatoriska uppdateringar och ramverksinstrumentpanel',
            page_description: 'Översikt över täckningen för varje installerat regelverk samt den inbyggda ändringsloggen för regeluppdateringar: ändringar, ikraftträdandedatum och konsekvensbedömningar.',
            coverage_dashboard: 'Instrumentpanel för ramverksökning',
            no_frameworks: 'Inga ramverk hittades',
            framework: 'Ramverk',
            modules: 'Moduler',
            templates: 'Mallar',
            forms: 'Formulär',
            channels: 'Kanaler',
            deadlines: 'Deadlines',
            pending: 'Väntande uppdateringar',
            updates: 'Regulatoriska uppdateringar',
            create_update: 'Skapa uppdatering',
            framework_id: 'Ramverks-ID',
            update_title: 'Titel',
            description: 'Beskrivning',
            effective_date: 'Ikraftträdandedatum',
            amendment_ref: 'Ändringsreferens',
            create: 'Skapa',
            no_updates: 'Inga regulatoriska uppdateringar',
            status: 'Status',
            impact: 'Påverkan',
            change_summary: 'Ändringssammanfattning',
            assess: 'Bedöm',
            failed_load: 'Kunde inte load data',
            update_created: 'Uppdatering skapad',
            update_created_announce: 'Regulatorisk uppdatering skapad',
            failed_create: 'Kunde inte create update',
            update_assessed: 'Uppdatering bedömd',
            failed_assess: 'Kunde inte assess update',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Bank',
                insurance: 'Försäkring',
                healthcare: 'Hälso- och sjukvård',
                ict_critical: 'Kritisk IKT',
                telecom: 'Telekommunikation',
                energy: 'Energi',
                transport: 'Transport',
                digital_services: 'Digitala tjänster',
                digital_technology_industry: 'Digital teknikindustri',
                public_administration: 'Offentlig förvaltning',
                payments: 'Betalningar',
                other: 'Övrigt',
            },
            sector_label: 'Sektor',
            direct_scope_label: 'Direkt rättslig tillämpning',
            chip_direct: 'Direkt tillämplig',
            chip_reference: 'Endast referens',
            banner_direct_copy: 'Direkt tillämplig på din organisation. Sektorrapporter och tidsfrister är aktiva.',
            banner_reference_copy: 'Endast referens — din organisation är inte klassificerad inom denna sektor.',
            edit_mode_button: 'Redigeringsläge',
            edit_form_title: 'Ändra installationsläge',
            mode_direct_label: 'Direkt — rättsligt tillämplig',
            mode_direct_help: 'Schemalägger sektorspecifika deadlines och widgetar i översikten.',
            mode_reference_label: 'Endast referens',
            mode_reference_help: 'Kan bläddras i, men utan deadlines eller widgetar.',
            reason_note_label: 'Orsak (valfritt)',
            reason_note_placeholder: 't.ex. bankdotterbolag förvärvat',
            cancel: 'Avbryt',
            confirm: 'Bekräfta',
            confirming: 'Sparar…',
            save: 'Spara',
            saving: 'Sparar…',
            toast_mode_changed: 'Läge för sektoröverlägg uppdaterat.',
            toast_installed: 'Sektoröverlägg installerat.',
            toast_sectors_saved: 'Organisationens sektorval har sparats.',
            install_modal_title: 'Installera sektoröverlägg',
            install_modal_intro: 'Sektoröverlägg är frivilliga regulatoriska paket som avgränsas till en enskild bransch.',
            install_modal_footer: 'Du kan ändra installationsläge senare från detaljsidan för regelverket.',
            install_button: 'Installera',
            installed_label: 'Installerad',
            uninstall_button: 'Avinstallera',
            uninstall_confirm: 'Bekräfta avinstallationen',
            uninstall_cancel: 'Avbryt',
            suggested_label: 'Föreslagen',
            catalog_page_title: 'Sektoröverlägg',
            catalog_page_intro: 'Valfria regulatoriska paket avgränsade till en enskild branschsektor.',
            catalog_empty_title: 'Inga sektoröverlägg tillgängliga',
            catalog_empty_description: 'Sektoröverlägg som publiceras för din plattform visas här.',
            authority_label: 'Myndighet',
            org_sectors_title: 'Branschsektorer',
            org_sectors_intro: 'Välj de branschsektorer som din organisation verkar inom.',
            widget_title: 'Sektorrapporter med förfallodatum',
            widget_aria_label: 'Sektorrapporter med förfallodatum',
            widget_empty: 'Inga kommande deadlines för sektoröverlägg.',
            audit_event_mode_changed: 'Installationsläge för sektoröverlägg ändrat',
            audit_event_installed: 'Sektoröverlägg installerat',
            view_details_button: 'Visa detaljer →',
            banner_aria_label: 'Status för sektoröverlägg',
            toast_load_failed: 'Det gick inte att läsa in sektoröverlägg',
            toast_install_failed: 'Det gick inte att installera sektoröverlägg',
            toast_uninstall_confirm_required: 'Skriv "{packCode}" för att bekräfta avinstallationen.',
            toast_uninstalled: '{packCode} har avinstallerats.',
            toast_uninstall_failed: 'Det gick inte att avinstallera sektoröverlägg',
            uninstall_warning_destructive_label: 'Destruktiv åtgärd.',
            uninstall_warning_body: 'Avinstallation raderar regelverksposten och alla sparade regulatoriska deadlines som är kopplade till {frameworkCode} från denna organisation.',
            uninstall_warning_type_to_confirm: 'Skriv {packCode} för att bekräfta.',
            uninstall_in_progress: 'Avinstallerar…',
            widget_view_all: 'Visa alla sektoröverlägg →',
            widget_due_in_days: 'Förfaller om {days} d',
            widget_overdue_days: 'Försenad med {days} d',
            widget_due_today: 'Förfaller idag',
            widget_due_unknown: '—',
        },
        phased_obligations: {
            panel_title: 'Fasindelade skyldigheter',
            panel_aria_label: 'Fasindelade skyldigheter',
            panel_intro: 'Vissa klausuler i detta regelverk aktiveras senare än själva regelverket.',
            phased_effective_date_label: 'Träder i kraft i fas:',
            status_pending: 'Väntar',
            status_active: 'Aktiv',
            status_early: 'Aktiv (införd i förtid)',
            notice_window_label: 'Tidsfönster för myndighetsanmälan:',
            days_label: 'dagar',
            recipient_label: 'Mottagare:',
            early_implement_button: 'Markera som införd i förtid',
            early_implement_modal_title: 'Markera fasindelad skyldighet som införd i förtid',
            early_implement_modal_intro: 'När en förtida implementering registreras aktiveras skyldigheten nu och timern för myndighetsanmälan schemaläggs.',
            effective_at_label: 'Gäller från',
            reason_label: 'Orsak (valfritt)',
            reason_placeholder: 't.ex. styrelsen godkände tidig tillämpning 2026-09-01',
            confirm: 'Bekräfta',
            toast_early_implemented: 'Förtida implementering registrerad.',
            audit_event_early_implemented: 'Fasindelad skyldighet markerad som införd i förtid',
            widget_rolling_window_label: 'Phased activations within 90 dagar',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Översikt',
            partner_orgs: 'Partnerorganisationer',
            service_tiers: 'Tjänstenivåer',
            deliverable_templates: 'Leveransmallar',
            deliverables: 'Leveranser',
            brand_profiles: 'Varumärkesprofiler',
            support_tickets: 'Supportärenden',
            workflow_templates: 'Arbetsflödesmallar',
            workflows: 'Arbetsflöden',
            escalation: 'Eskalering',
            reports: 'Rapporter',
            audit: 'Granskningsspår',
        },
        dashboard: {
            title: 'Partneröversikt',
            loading: 'Laddar instrumentpanelsdata...',
            total_managed_tenants: 'Totalt Hanterade Hyresgäster',
            avg_health_score: 'Gns. Hälsa Poäng',
            open_tickets: 'Öppna Ärenden',
            upcoming_deliverables: 'Kommande Leveranser',
            escalated_tickets: 'Eskalerade Ärenden',
            managed_tenants: 'Hanterade Hyresgäster',
            partner_tier: 'Partner Nivå',
            managed_tenants_count: 'Hanterade Hyresgäster Antal',
            onboarding_date: 'Onboarding Datum',
            view_details: 'Visa Detaljer',
            no_partner_orgs: 'Inga partnerorganisationer hittades.',
        },
        partner_orgs: {
            title: 'Partnerorganisationer',
            new: 'Ny Partner Org',
            contact_name: 'Kontakt Namn',
            contact_email: 'Kontakt E-post',
            partner_tier: 'Partner Nivå',
            managed_orgs: 'Hanterade Org',
            onboarding_date: 'Onboarding Datum',
            no_orgs: 'Inga partnerorganisationer hittades.',
            contact_phone: 'Kontakt Telefon',
            metadata_json: 'Metadata (JSON-format)',
            change_status: 'Ändrings Status',
            new_status: 'Ny Status',
            invalid_json_metadata: 'Ogiltig JSON i metadatafält',
            suspended: 'Avstängd',
            offboarded: 'Avregistrerad',
            all_tiers: 'Alla Nivåer',
            silver: 'Silvern',
            gold: 'Guld',
            platinum: 'Platina',
            status_offboarded: 'Avregistrerad',
            status_suspended: 'Avstängd',
            tier_gold: 'Guld',
            tier_platinum: 'Platina',
            tier_silver: 'Silvern',
        },
        service_tiers: {
            title: 'Tjänstenivåer',
            new: 'Ny Nivå',
            tier_name: 'Nivå Namn',
            monthly_fee: 'Månadsvis Fee',
            features: 'Funktioner',
            no_tiers: 'Inga service tiers hittades.',
            tier_code: 'Nivå Kod',
            user_seats: 'Användare Platser',
            user_seat_limit: 'Användare Plats Gräns',
            storage_gb: 'Lagring (GB)',
            storage_limit_gb: 'Lagring Gräns (GB)',
            response_time_hrs: 'Svarstid (tim)',
            resolution_time_hrs: 'Lösningstid (tim)',
            review_frequency: 'Granskning Frekvens',
            sla_response_time: 'SLA-svarstid (timmar)',
            sla_resolution_time: 'SLA-lösningstid (timmar)',
            module_profile_json: 'Modul Profil (JSON)',
            comparing: 'Jämför...',
            compare: 'Jämför',
            comparison: 'Tjänstenivåjämförelse',
            attribute: 'Attribut',
            deprecate: 'Fasa ut',
            deprecated: 'Utfasad',
            invalid_json_module: 'Ogiltig JSON i modulprofilfält',
            select_compare: 'Välj minst 2 nivåer att jämföra',
            comparison_title: 'Tjänstenivåjämförelse',
            status_deprecated: 'Utfasad',
            activate: 'Aktivera',
            invalid_json_module_profile: 'Ogiltig JSON in modul profil',
            resolution_time: 'Lösning Tid',
            response_time: 'Svar Tid',
            select_at_least_two: 'Välj minst 2 nivåer',
        },
        deliverable_templates: {
            title: 'Leveransmallar',
            new: 'Ny Mall',
            template_name: 'Mall Namn',
            deliverable_type: 'Leverans Typ',
            no_templates: 'Inga leverans mallar hittades.',
            frequency: 'Frekvens',
            est_effort_hrs: 'Ber. ansträngning (tim)',
            estimated_effort: 'Beräknad ansträngning (timmar)',
            associated_module: 'Associerad Modul',
            linked_tiers_count: 'Länkade Nivåer Antal',
            evidence_requirements: 'Beviskrav (kommaseparerade)',
            tier_ids: 'Nivå-ID:n (kommaseparerade)',
            frequency_one_time: 'En Tid',
            frequency_monthly: 'Månadsvis',
            frequency_quarterly: 'Kvartalsvis',
            frequency_annually: 'Årligen',
            type_report: 'Rapport',
            type_review: 'Granskning',
            type_assessment: 'Bedömning',
            type_meeting: 'Möte',
            type_configuration: 'Konfiguration',
            freq_one_time: 'En Tid',
            freq_monthly: 'Månadsvis',
            freq_quarterly: 'Kvartalsvis',
            freq_annually: 'Årligen',
            status_deprecated: 'Utfasad',
        },
        deliverables: {
            title: 'Leveranser',
            new: 'Ny Leverans',
            partner: 'Samarbetspartner',
            deliverable_type: 'Leverans Typ',
            due_date: 'Due Datum',
            no_deliverables: 'Inga leveranser hittades.',
            assigned_to: 'Tilldelad Till',
            completion_date: 'Slutförande Datum',
            update_status: 'Uppdatering Status',
            hide_details: 'Dölj Detaljer',
            view_details: 'Visa Detaljer',
            evidence_ids: 'Bevis ID:n',
            client_approval: 'Klient Godkännande',
            bulk_update: 'Masse Uppdatera',
            bulk_update_status: 'Masse Uppdatera Status',
            generate_schedule: 'Generera Schemalägg',
            generate_deliverable_schedule: 'Generera Leverans Schemalägg',
            organization_id: 'Organisation ID',
            service_tier_id: 'Tjänst Nivå ID',
            filter_assigned_to: 'Filter per Tilldelad Till',
            select_status: 'Välj status...',
            new_status: 'Ny Status',
            upcoming: 'Kommande',
            overdue: 'Försenad',
            status_deferred: 'Uppskjuten',
            status_overdue: 'Försenad',
            status_upcoming: 'Kommande',
        },
        brand_profiles: {
            title: 'Varumärkesprofiler',
            new: 'Ny Varumärke Profil',
            partner: 'Samarbetspartner',
            brand_name: 'Varumärke Namn',
            primary_color: 'Primär Färg',
            logo_url: 'Logotyp URL',
            no_profiles: 'Inga brand profiles hittades.',
            secondary_color: 'Sekundär Färg',
            header_text: 'Sidhuvud Text',
            footer_text: 'Sidfot Text',
            contact_email: 'Kontakt E-post',
            contact_phone: 'Kontakt Telefon',
            contact_website: 'Kontakt Webbplats',
            contact_address: 'Kontaktadress',
            is_default: 'Är Standard',
            set_default: 'Set Standard',
            preview: 'Förhandsgranskning',
            report_header_preview: 'Rapport Sidhuvud Förhandsgranskning',
            report_footer_preview: 'Rapport Sidfot Förhandsgranskning',
            preview_description: 'Detta är en förhandsgranskning av rapporthuvudet med de valda varumärkesfärgerna.',
            contact_website_short: 'Webbplats',
            logo_preview: 'Logotyp förhandsgranskning',
        },
        support_tickets: {
            title: 'Supportärenden',
            new: 'Ny Ärende',
            partner: 'Samarbetspartner',
            subject: 'Ämne',
            assigned_to: 'Tilldelad Till',
            no_tickets: 'Inga support ärenden hittades.',
            category: 'Kategori',
            priority: 'Prioritet',
            escalation_tier: 'Eskalering Nivå',
            sla_status: 'SLA-status',
            update_status: 'Uppdatering Status',
            escalate: 'Eskalera',
            add_note: 'Add Anteckning',
            escalate_ticket: 'Eskalera Ärende',
            escalate_to_tier: 'Eskalera To Nivå',
            notes_timeline: 'Anteckningar Tidslinje',
            no_notes: 'Inga anteckningar ännu.',
            attachments: 'Bilagor',
            no_attachments: 'Inga attachments.',
            client_org_id: 'Klient Org ID',
            content: 'Innehåll',
            note_type: 'Typ',
            view_detail: 'Visa Detalj',
            hide: 'Dölj',
            new_status: 'Ny Status',
            all_categories: 'Alla Kategorier',
            all_priorities: 'Alla prioriteringar',
            all_tiers: 'Alla Nivåer',
            ticket_not_found: 'Ärende hittades inte',
            ticket_id: 'Ärende ID',
            client_org: 'Klient Org',
            deescalate: 'Deeskalera',
            deescalate_ticket: 'Deeskalera Ärende',
            deescalate_to_tier: 'Deeskalera To Nivå',
            add_attachment: 'Add Bilaga',
            file: 'Fil',
            linked_entity: 'Länkade Entitet',
            sla_target: 'Mål',
            breached: 'Överträdd',
            remaining_hours: 'återstående',
            na: 'N/A',
            tickets_found: 'ärenden hittade',
            reason: 'Anledning',
            target: 'Mål',
            upload: 'Ladda upp',
        },
        workflow_templates: {
            title: 'Arbetsflödesmallar',
            new: 'Ny Mall',
            template_name: 'Mall Namn',
            steps: 'Steg',
            no_templates: 'Inga arbetsflöde mallar hittades.',
            category: 'Kategori',
            view_steps: 'Visa Steg',
            hide_steps: 'Dölj steg',
            step: 'Steg',
            step_title: 'Titel',
            step_description: 'Beskrivning',
            assignee_role: 'Tilldelad roll',
            sla_hours: 'SLA Timmar',
            evidence_required: 'Bevis Obligatorisk',
            guidance_notes: 'Vägledning Anteckningar',
            add_step: 'Add Steg',
            no_steps: 'Inga steg definierade.',
            no_steps_defined: 'Inga steg definierade.',
            templates_found: 'mallar hittade',
            all_categories: 'Alla Kategorier',
        },
        workflows: {
            title: 'Arbetsflöde Instanser',
            new: 'Ny Arbetsflöde',
            template: 'Mall',
            partner: 'Samarbetspartner',
            current_step: 'Aktuell Steg',
            progress: 'Framsteg',
            no_workflows: 'Inga arbetsflöde instanser hittades.',
            instances_found: 'instanser hittade',
        },
        escalation: {
            title: 'Eskalering Instrumentpanel',
            ticket: 'Ärende',
            partner: 'Samarbetspartner',
            escalated_at: 'Eskalerade Vid',
            reason: 'Anledning',
            no_escalations: 'Inga eskaleringar hittades.',
            time_in_tier: 'Tid i Nivå',
            auto_evaluate: 'Auto Utvärdera',
            priority_critical: 'Kritisk',
            priority_high: 'Hög',
            priority_medium: 'Medel',
            priority_low: 'Low',
            deescalated_from_dashboard: 'Deeskalerad från instrumentpanel',
            sla_breached: 'SLA överskriden',
            sla_remaining: 'SLA Återstående',
        },
        reports: {
            title: 'Rapporter',
            partner: 'Samarbetspartner',
            report_type: 'Rapport Typ',
            generated_at: 'Genererad Vid',
            no_reports: 'Inga rapporter hittades.',
            generate: 'Generera Rapport',
        },
        audit: {
            title: 'Partner Revision Spår',
            event_type: 'Händelse Typ',
            entity_type: 'Entitet Typ',
            entity_id: 'Entitet ID',
            actor: 'Aktör',
            timestamp: 'Tidsstämpel',
            no_events: 'Inga revision händelser hittades.',
            events_found: 'händelser hittade',
            event_type_created: 'Skapad',
            event_type_updated: 'Uppdaterad',
            event_type_deleted: 'Raderad',
            event_type_status_change: 'Statusändring',
            event_type_escalation: 'Upptrappning',
            event_type_assignment: 'Uppdrag',
            entity_type_partner_org: 'Partner Org',
            entity_type_service_tier: 'Servicenivå',
            entity_type_deliverable_template: 'Levererbar mall',
            entity_type_deliverable_instance: 'Levererbar instans',
            entity_type_brand_profile: 'Varumärkesprofil',
            entity_type_support_ticket: 'Supportbiljett',
            entity_type_workflow_template: 'Arbetsflödesmall',
            entity_type_workflow_instance: 'Arbetsflödesinstans',
            entity_type_generated_report: 'Genererad rapport',
            entity_type_escalation_rule: 'Eskaleringsregel',
        },
        no_permission_title: 'Otillräckliga behörigheter',
        no_permission_message: 'Du har inte behörighet att komma åt partnerarbetsytan.',
        status_active: 'Aktiv',
        status_suspended: 'Avstängd',
        status_offboarded: 'Utombordad',
        status_completed: 'Avslutad',
        status_cancelled: 'Avbruten',
        status_deprecated: 'Utfasad',
        status_new: 'Nytt',
        status_triaged: 'Triagerad',
        status_in_progress: 'Pågår',
        status_waiting_on_client: 'Väntar på klient',
        status_waiting_on_vendor: 'Väntar på säljaren',
        status_escalated: 'Eskalerad',
        status_resolved: 'Löst',
        status_closed: 'Stängt',
        status_pending: 'Väntar',
        status_skipped: 'Hoppade över',
        category_onboarding: 'Onboarding',
        category_incident_escalation: 'Incident Eskalering',
        category_config_change: 'Konfigurationsändring',
        category_periodic_review: 'Periodisk granskning',
        category_offboarding: 'Offboarding',
        category_custom: 'Anpassad',
        category_configuration: 'Konfiguration',
        category_incident: 'Incident',
        category_compliance_question: 'Efterlevnadsfråga',
        category_feature_request: 'Funktionsbegäran',
        category_bug_report: 'Buggrapport',
        priority_critical: 'Kritisk',
        priority_high: 'Hög',
        priority_medium: 'Medium',
        priority_low: 'Låg',
        tier_silver: 'Silver',
        tier_gold: 'Guld',
        tier_platinum: 'Platina',
        report_type_compliance_summary: 'Överensstämmelsesammanfattning',
        report_type_risk_overview: 'Risköversikt',
        report_type_incident_report: 'Incidentrapport',
        report_type_consent_status: 'Status för samtycke',
        report_type_program_maturity: 'Program Mognad',
        report_type_executive_pack: 'Executive Pack',
        note_type_internal: 'Internt',
        note_type_client_visible: 'Klient synlig',
        status_updated: 'Status uppdaterad framgångsrikt',
        deliverable_status_updated: 'Leveransstatus har uppdaterats',
        ticket_status_updated: 'Biljettstatus har uppdaterats',
        ticket_escalated: 'Biljetten eskalerade framgångsrikt',
        note_added: 'Anteckningen har lagts till',
        attachment_uploaded: 'Bilagan har laddats upp',
        ticket_deescalated: 'Biljetten deeskalerades framgångsrikt',
        auto_evaluation_completed: 'Automatisk utvärdering slutförd',
        template_created: 'Arbetsflödesmall skapad framgångsrikt',
        template_updated: 'Arbetsflödesmall har uppdaterats',
        brand_set_default: 'Varumärkesprofilen har angetts som standard',
        brand_created: 'Varumärkesprofil skapad framgångsrikt',
        brand_updated: 'Varumärkesprofilen har uppdaterats',
        tier_created: 'Servicenivån har skapats',
        tier_updated: 'Servicenivån har uppdaterats',
        tier_deprecated: 'Servicenivån har fasats ut',
        tier_activated: 'Servicenivån har aktiverats',
        period: 'Period',
        format: 'Format',
        period_start: 'Periodstart',
        period_end: 'Period slut',
        reports_count: '[[TOK_1]] rapporterar',
        reports_count_one: '[[TOK_1]] rapport',
        metric: 'Metrisk',
        value: 'Värde',
        showing_chart_view: 'Visar diagramvy',
        showing_table_view: 'Visar datatabellvy',
        evidence_ids_placeholder: 't.ex. ev-001, ev-002',
        confirm_cancel_workflow: 'Är du säker på att du vill avbryta detta arbetsflöde? Denna åtgärd kan inte ångras.',
        export_csv: 'Exportera [[TOK_0]]',
        compliance_qualifications_title: 'Compliance Service Kvalifikationer',
        compliance_qualifications_desc: 'Partnernivån (Silver/Guld/Platinum) avgör omfattningen av efterlevnadstjänsten. Guld- och platinapartners är kvalificerade för engagemang inom reglerad industri. Använd fältet Metadata för att registrera certifieringar (ISO 27001, SOC 2), specialiseringar och jurisdiktionskvalifikationer för varje partner.',
        regulatory_output_title: 'Regulatory Output Alignment',
        regulatory_output_desc: 'Varje malltyp mappas till en regulatorisk utdatakategori: Rapporter producerar efterlevnadsdokumentation, granskningar validerar kontrolleffektivitet, bedömningar omfattar riskutvärderingar ([[TOK_0]], gapanalys), mötesdokumentstyrningssessioner. Beviskrav definierar artefakterna som varje produkt måste referera till för revisionsberedskap.',
        sla_compliance_title: '[[TOK_0]] Spårning för efterlevnadsleverans',
        sla_compliance_desc: 'SLA:er för svar och upplösningstid är kontraktuellt bindande för leverans av efterlevnadstjänster. Granskningsfrekvensen avgör hur ofta leveranser av partnerefterlevnad utvärderas. [[TOK_0]] överträdelser på efterlevnadskritiska biljetter utlöser automatisk eskalering och loggas i Partner Audit Trail för regulatoriska bevis.',
        regulatory_engagement_title: 'Regulatoriska engagemangsmönster',
        regulatory_engagement_desc: 'Arbetsflödeskategorier mappas till typer av regulatoriska engagemang: Onboarding täcker initial efterlevnadsinställning och gapanalys, periodisk granskning hanterar återkommande efterlevnadsbedömningar, Incident Escalation hanterar regelöverträdelsesvar, Offboarding säkerställer att datalagringskraven uppfylls. Varje steg kan kräva bevisinsamling för att revisionsspåret ska vara fullständigt.',
        compliance_escalation_title: 'Efterlevnadskritiska eskaleringsprocedurer',
        compliance_escalation_desc: 'L1 hanterar vanliga driftsfrågor. L2 täcker efterlevnadspåverkande misslyckanden (missade regulatoriska deadlines, kontrollluckor). L3 är reserverat för scenarier för regelöverträdelser som kräver omedelbar övervakning av ledningen. [[TOK_0]] överträdelse på L2/L3-biljetter genererar granskningsspår automatiskt. Alla eskalerings- och deeskaleringsåtgärder loggas permanent.',
        audit_regulatory_title: 'Regulatoriskt bevisspår',
        audit_regulatory_desc: 'Detta revisionsspår tillhandahåller manipulationssäkra register för regelefterlevnad. Varje partneråtgärd (skapa, uppdatera, ta bort, eskalering, statusändring) loggas med aktörsidentitet, tidsstämpel och full nyttolastdiff. Använd filtret Entity Type för att isolera bevis per efterlevnadsdomän. Exportera filtrerade resultat för att skapa revisionsklar dokumentation för myndighetsinspektioner.',
        evidence_trail_title: 'Bevisspår över flera moduler',
        evidence_trail_desc: 'Varje arbetsflödessteg kan samla in bevis-ID:n som länkar till leveranser, granskningshändelser och efterlevnadsartefakter över moduler. Att avancera ett steg med bevis-ID:n skapar en verifierbar kedja som kopplar partners arbetsflöden till regulatorisk dokumentation. Genomförda arbetsflöden med fullständiga beviskedjor fungerar som bevis på leverans av efterlevnad.',
        evidence_ids_label: 'Bevis-ID',
    },
    org_groups: {
        title: 'Organisationsgrupper',
        new: 'Skapa Grupp',
        group_name: 'Grupp Namn',
        member_count: 'Medlem Antal',
        root_org: 'Rot Org',
        no_groups: 'Inga org grupper hittades.',
        add_organization: 'Lägg till Organisation',
        select_organization: 'Välj en organisation...',
        no_available_orgs: 'Inga tillgängliga organisationer att lägga till.',
        no_members: 'Inga medlemsorganisationer i denna grupp.',
        member_added: 'Organisation tillagd i gruppen.',
        member_removed: 'Organisation borttagen från gruppen.',
        already_in_group: 'Denna organisation tillhör redan en grupp.',
        org_not_found: 'Organisation hittades inte.',
        add_member_error: 'Kunde inte lägga till organisation i gruppen.',
        remove_member_error: 'Kunde inte ta bort organisation från gruppen.',
        confirm_remove_member: 'Är du säker på att du vill ta bort "{name}" från denna grupp?',
        load_error: 'Kunde inte ladda org. gruppdetaljer.',
        page_title_list: 'Organisationsgrupper',
        page_title_detail: 'Information om organisationsgrupp',
        page_title_create: 'Skapa organisationsgrupp',
        page_title_settings: 'Inställningar för organisationsgrupp',
        page_title_users: 'Gruppanvändare',
        page_title_reports: 'Grupprapporter',
        page_title_dashboard: 'Gruppinstrumentpanel',
        page_title_audit: 'Koncernrevision',
        page_title_org_audit: 'Organisationsgruppsrevision',
        page_title_shared_vendors: 'Delade leverantörer',
        page_title_shared_frameworks: 'Delade ramar',
        page_title_shared_forms: 'Mallar för delade formulär',
        page_title_merged_vendors: 'Sammanslagna leverantörer',
        page_title_settings_inheritance: 'Inställningar Arv',
        announce_loaded_groups: 'Laddade [[TOK_1]] organisationsgrupper',
        announce_loaded_group: 'Laddad grupp [[TOK_1]]',
        announce_loaded_users: 'Laddade [[TOK_1]] gruppanvändare',
        announce_loaded_reports: 'Laddade [[TOK_1]] rapporter',
        announce_loaded_vendors: 'Laddade [[TOK_1]] delade leverantörer',
        announce_loaded_frameworks: 'Laddade [[TOK_1]] delade ramverk',
        announce_loaded_templates: 'Laddade [[TOK_1]] delade formulärmallar',
        announce_loaded_audit: 'Laddade [[TOK_1]] granskningshändelser',
        announce_loaded_merged: 'Laddade [[TOK_2]] delade och [[TOK_3]] lokala leverantörer',
        announce_dashboard_loaded: 'Instrumentpanelen laddad.',
        announce_dashboard_refreshed: 'Instrumentpanelen har uppdaterats.',
        announce_dashboard_refresh_failed: 'Det gick inte att uppdatera instrumentpanelen.',
        announce_refreshing: 'Uppdaterar instrumentpanelen...',
        announce_settings_loaded: 'Inställningsarv har laddats.',
        announce_settings_saved: 'Inställningarna har sparats.',
        announce_saving_settings: 'Sparar inställningar...',
        announce_error_saving: 'Det gick inte att spara inställningar.',
        announce_group_dissolved: 'Gruppen upplöstes.',
        announce_creating_group: 'Skapar organisationsgrupp...',
        announce_group_created: 'Organisationsgruppen har skapats.',
        announce_error_creating: 'Det gick inte att skapa organisationsgrupp.',
        announce_vendor_published: 'Leverantören har publicerats framgångsrikt.',
        announce_vendor_retired: 'Säljaren gick i pension.',
        announce_framework_published: 'Ramverket har publicerats framgångsrikt.',
        announce_framework_retired: 'Framework gick i pension.',
        announce_template_published: 'Formulärmall har publicerats framgångsrikt.',
        announce_template_retired: 'Formulärmall har tagits bort.',
        announce_role_assigned: 'Roll tilldelad framgångsrikt.',
        announce_error_assign_role: 'Fel vid tilldelning av roll.',
        announce_role_revoked: 'Roll återkallad framgångsrikt.',
        announce_report_generating: 'Genererar rapport...',
        announce_report_requested: 'Rapportgenerering begärd.',
        announce_error_report: 'Det gick inte att begära rapport.',
        announce_report_deleted: 'Rapporten raderad.',
        announce_search_applied: 'Sökning tillämpad.',
        announce_search_cleared: 'Sökningen rensades.',
        announce_tab_selected: 'Fliken [[TOK_1]] har valts',
        announce_error_add_member: 'Det gick inte att lägga till medlem i gruppen.',
        announce_category_reverted: '[[TOK_1]] har återgått till ärvt från förälder.',
        announce_category_overridden: '[[TOK_1]] inställd på lokal åsidosättande.',
        announce_override_saved: '[[TOK_1]] åsidosättning sparad.',
        announce_export_started: 'Exporterar granskning som [[TOK_1]]...',
        announce_export_completed: 'Exporten som [[TOK_1]] slutförd.',
        announce_export_failed: 'Exporten misslyckades.',
        announce_filter_org: 'Filtrerat efter organisation [[TOK_1]]',
        announce_filter_org_cleared: 'Organisationsfiltret har rensats',
        announce_filter_event: 'Filtrerat efter händelsetyp [[TOK_1]]',
        announce_filter_cleared: 'Filtret har rensats',
        announce_download: 'Laddar ned [[TOK_2]] som [[TOK_3]]',
        error_load_groups: 'Det gick inte att läsa in organisationsgrupper. Försök igen.',
        error_load_users: 'Det gick inte att läsa in gruppanvändare.',
        error_load_reports: 'Det gick inte att läsa in grupprapporter.',
        error_load_dashboard: 'Det gick inte att läsa in gruppöversikten.',
        error_load_settings: 'Det gick inte att läsa in gruppinställningar.',
        error_load_vendors: 'Det gick inte att läsa in sammanslagna leverantörer.',
        error_save_settings: 'Det gick inte att spara inställningarna.',
        error_dissolve_group: 'Det gick inte att lösa upp gruppen.',
        error_assign_role: 'Det gick inte att tilldela roll.',
        error_create_group: 'Det gick inte att skapa organisationsgrupp. Försök igen.',
        error_request_report: 'Det gick inte att begära rapport.',
        error_group_name_required: 'Gruppnamn krävs.',
        success_settings_saved: 'Inställningarna har sparats.',
        confirm_retire_vendor: 'Är du säker på att du vill pensionera leverantören "[[TOK_1]]"?',
        confirm_retire_framework: 'Är du säker på att du vill avveckla ramverket "[[TOK_1]]"?',
        confirm_retire_template: 'Är du säker på att du vill ta bort formulärmallen "[[TOK_1]]"?',
        confirm_dissolve_group: 'Är du säker på att du vill lösa upp "[[TOK_1]]"? Denna åtgärd kan inte ångras.',
        confirm_revoke_role: 'Är du säker på att du vill återkalla rollen "[[TOK_2]]" från "[[TOK_3]]"?',
        confirm_delete_report: 'Är du säker på att du vill ta bort rapporten "[[TOK_1]]"?',
        dissolve_group: 'Upplös grupp',
        dissolve_warning: 'Detta kommer att permanent upplösa organisationsgruppen. Alla medlemsorganisationer kommer att tas bort.',
        count_groups: '[[TOK_1]] grupp',
        count_groups_plural: '[[TOK_1]] grupper',
        count_users: '[[TOK_1]] användare',
        count_users_plural: '[[TOK_1]] användare med grupproller',
        count_events: '[[TOK_1]] händelse',
        count_events_plural: '[[TOK_1]] händelser',
        count_reports: '[[TOK_1]] rapport',
        count_reports_plural: '[[TOK_1]] rapporterar',
        count_vendors: '[[TOK_1]] leverantör delad över hela gruppen',
        count_vendors_plural: '[[TOK_1]] leverantörer delade över gruppen',
        count_frameworks: '[[TOK_1]] ramverk delas över hela gruppen',
        count_frameworks_plural: '[[TOK_1]] ramverk delas över hela gruppen',
        count_templates: '[[TOK_1]] mall delad i gruppen',
        count_templates_plural: '[[TOK_1]] mallar som delas över hela gruppen',
        count_shared_vendors: '[[TOK_1]] delade leverantörer',
        count_local_vendors: '[[TOK_1]] lokala leverantörer',
        merged_combined_view: 'Kombinerad vy av [[TOK_2]] delade och [[TOK_3]] lokala leverantörer',
        dashboard: {
            title: 'Gruppöversikt',
            loading: 'Laddar instrumentpanelsdata...',
            total_groups: 'Totalt Grupper',
            total_members: 'Totalt Medlemmar',
            active_groups: 'Aktiva Grupper',
            overall_compliance_score: 'Övergripande efterlevnadspoäng',
            group_risk_level: 'Grupprisknivå',
            sla_compliance: '[[TOK_0]] Efterlevnad',
            compliance_posture: 'Efterlevnadshållning',
            risk_heatmap: 'Risk Värmekarta',
            sla_performance: '[[TOK_0]] Prestanda',
            recent_incidents: 'Senaste incidenter',
            recent_activity: 'Senaste aktivitet',
            refresh_label: 'Uppdatera instrumentpanelsdata',
            score_good: 'Bra',
            score_needs_attention: 'Behöver uppmärksamhet',
            score_critical: 'Kritisk',
            trend_up: 'Trender uppåt',
            trend_down: 'Trender nedåt',
            trend_stable: 'Stabil',
            risk_low: 'Low',
            risk_medium: 'Medium',
            risk_high: 'Hög',
            risk_critical: 'Kritisk',
            risk_unknown: 'Okänd',
            col_organization: 'Organisation',
            col_score: 'Betyg',
            col_trend: 'Trend',
            col_open_issues: 'Öppna frågor',
            col_critical_issues: 'Kritiska frågor',
            col_health: 'Hälsa',
            col_vendor_risk: 'Leverantörsrisk',
            col_data_risk: 'Datarisk',
            col_compliance_risk: 'Efterlevnadsrisk',
            col_total_cases: 'Totalt ärenden',
            col_on_time: 'I tid',
            col_breached: 'Brutna',
            col_sla_percent: '[[TOK_0]] %',
            col_avg_days: 'Genomsnittliga dagar',
            sr_vendor_risk: 'Leverantörsriskpoäng: [[TOK_1]]',
            sr_data_risk: 'Datariskpoäng: [[TOK_1]]',
            sr_compliance_risk: 'Efterlevnadsriskpoäng: [[TOK_1]]',
            sr_sla_breaches: 'Varning: [[TOK_1]] [[TOK_2]] överträdelser',
            sr_severity: 'Allvarlighetsgrad: [[TOK_1]]',
        },
        detail: {
            title: 'Gruppdetaljer',
            members: 'Medlemmar',
            settings: 'Inställningar',
            audit: 'Revision',
            sr_loading: 'Laddar information om organisationsgrupp',
            sr_loading_hierarchy: 'Laddar hierarki',
            member_org: 'medlemsorganisation',
            root_org_label: 'rotorganisation',
        },
        users: {
            title: 'Gruppanvändare',
            add_user: 'Add Användare',
            no_users: 'Inga användare i detta grupp.',
            role_group_admin: 'Gruppadministratör',
            role_group_reader: 'Gruppläsare',
            sr_loading: 'Laddar gruppanvändare',
        },
        reports: {
            title: 'Grupprapporter',
            no_reports: 'Inga rapporter hittades.',
            generate_report: 'Skapa ny rapport',
            report_type_compliance: 'Överensstämmelsesammanfattning',
            report_type_risk: 'Risköversikt',
            report_type_sla: '[[TOK_0]] Prestanda',
            report_type_incident: 'Incidentrapport',
            report_type_executive: 'Executive Brief',
            report_type_board: 'Styrelsens rapport',
            status_queued: 'I kö',
            status_generating: 'Genererar',
            status_completed: 'Avslutad',
            status_failed: 'Misslyckades',
            period_start: 'Periodstart',
            period_end: 'Period slut',
            sr_loading: 'Laddar grupprapporter',
        },
        shared_vendors: {
            title: 'Delade leverantörer',
            no_vendors: 'Inga delade leverantörer hittades.',
            merged_vendors: 'Sammanfogade Leverantörer',
            publish_form_label: 'Publicera delad leverantör',
            sr_loading: 'Laddar delade leverantörer',
            sr_loading_merged: 'Laddar sammanslagna leverantörer',
            local_vendors: 'Lokala leverantörer',
            source_shared: 'Delas från gruppen',
            source_local: 'Lokal försäljare',
            category_technology: 'Teknik',
            category_consulting: 'Konsultverksamhet',
            category_outsourcing: 'Outsourcing',
            category_cloud: 'Moln',
            category_data_processing: 'Databehandling',
            category_other: 'Annat',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Medium',
            risk_tier_high: 'Hög',
            risk_tier_critical: 'Kritisk',
            compliance_compliant: 'Överensstämmer',
            compliance_non_compliant: 'Icke-kompatibel',
            compliance_pending: 'Väntar',
            compliance_under_review: 'Under granskning',
            status_active: 'Aktiv',
            status_retired: 'Pensionerad',
        },
        shared_frameworks: {
            title: 'Delade regelverk',
            no_frameworks: 'Inga delade ramverk hittades.',
            publish_form_label: 'Publicera delat ramverk',
            sr_loading: 'Laddar delade ramar',
            status_active: 'Aktiv',
            status_retired: 'Pensionerad',
        },
        shared_forms: {
            title: 'Delade formulärmallar',
            no_forms: 'Inga delade formulär mallar hittades.',
            publish_form_label: 'Publicera mall för delad formulär',
            sr_loading: 'Laddar delade formulärmallar',
            status_active: 'Aktiv',
            status_retired: 'Pensionerad',
        },
        audit: {
            title: 'Gruppgranskning',
            consolidated_title: 'Konsoliderad Revision Spår',
            consolidated_subtitle: 'Tvärorganisatoriska revisionshändelser för denna grupp',
            audit_log_title: 'Grupp Revision Logg',
            event_type: 'Händelse Typ',
            actor: 'Aktör',
            timestamp: 'Tidsstämpel',
            source_org: 'Källa Org',
            org: 'Org',
            summary: 'Sammanfattning',
            details: 'Detaljer',
            no_events: 'Inga revision händelser hittades.',
            all_events: 'Alla Händelser',
            all_orgs: 'Alla Org',
            organization: 'Organisation',
            from: 'Från',
            to: 'To',
            search_events: 'Sök händelser...',
            clear: 'Rensa',
            events_24h: 'Händelser (24h)',
            events_7d: 'Händelser (7d)',
            active_orgs: 'Aktiva Org',
            exporting: 'Exporterar...',
            export_csv: 'Exportera CSV',
            export_json: 'Exportera JSON',
            back_to_group: 'Tillbaka to Grupp',
            back_to_detail: 'Tillbaka till detalj',
            sr_loading: 'Laddar revisionshändelser',
            sr_loading_summary: 'Laddar revisionssammanfattning',
        },
        settings: {
            title: 'Grupp Inställningar',
            inheritance: 'Inställningar Arv',
            inheritance_subtitle: 'Konfigurera vilka inställningskategorier som ärver från gruppen kontra lokala åsidosättningar',
            sla_settings: 'SLA Inställningar',
            calendar_settings: 'Kalender Inställningar',
            notification_settings: 'Avisering Inställningar',
            intake_settings: 'Intag Inställningar',
            cmp_integration: 'CMP-integration',
            overridden: 'Åsidosatt',
            inheriting: 'Ärvande',
            hide_defaults: 'Dölj standardvärden',
            show_group_defaults: 'Visa gruppstandardvärden',
            group_defaults: 'Grupp Standardvärden',
            inherit_from_group: 'Ärv från grupp',
            use_local_override: 'Use Lokal Åsidosätt',
            local_override_json: 'Lokal Åsidosätt (JSON)',
            save_override: 'Spara Åsidosätt',
            saving: 'Sparar...',
            sr_loading: 'Laddar arv av inställningar',
            sr_loading_settings: 'Laddar gruppinställningar',
            sr_enabled: 'Aktiverad',
            sr_disabled: 'Inaktiverad',
            sr_override_active: 'Lokal överstyrning aktiv',
            sr_inherited: 'Ärvt från förälder',
            danger_zone: 'Farozon',
            sharing_options: 'Delningsalternativ',
            advanced_options: 'Avancerade alternativ',
        },
        status_active: 'Aktiv',
        status_dissolved: 'Upplöst',
        status_pending: 'Väntar',
        status_suspended: 'Avstängd',
    },
    integrations: {
        nav: {
            webhooks: 'Webhookar',
            domains: 'Domäner',
            export_schedules: 'Exportscheman',
            email_log: 'E-postlogg',
        },
    },
    platform: {
        nav: {
            users: 'Användare',
            roles: 'Roller',
            profile: 'Min Profil',
        },
        security: {
            mfa: 'MFA-inställningar',
            sso: 'SSO-konfiguration',
            api_keys: 'API-nycklar',
            service_accounts: 'Tjänstekonton',
            ip_allowlist: 'IP-vitlista',
            delegations: 'Delegeringar',
            break_glass: 'Nödåtkomst',
            session_settings: 'Sessionsinställningar',
            active_sessions: 'Aktiva Sessioner',
            access_reviews: 'Åtkomstgranskningar',
            my_reviews: 'Mina Granskningar',
            role_analytics: 'Rollanalys',
            attestation_schedules: 'Attesteringsscheman',
            sod_rules: 'SoD-regler',
            sod_violations: 'SoD-överträdelser',
        },
        module_config: {
            title: 'Modulkonfiguration',
            subtitle: 'Aktivera eller inaktivera funktionsmoduler för din organisation. Inaktiverade moduler döljs från navigeringen.',
            enabled: 'Aktiverad',
            disabled: 'Inaktiverad',
            save: 'Spara Konfiguration',
            saving: 'Sparar...',
            saved: 'Konfigurationen sparades',
            nav_label: 'Modulkonfiguration',
            settings: 'Inställningar',
            webhooks: 'Webhookar',
            domains: 'Domäner',
            export_schedules: 'Exportscheman',
            email_log: 'E-postlogg',
        },
        files_nav: {
            section: 'Filer',
            configuration: 'Konfiguration',
            browser: 'Filläsare',
            dashboard: 'Instrumentpanel för filer',
        },
        immutable_audit_trails: {
            nav_group_label: 'Revision & Bevis',
            nav_settings: 'Inställningar',
            nav_status: 'Bevisstatus',
            nav_integrity_center: 'Integritetscenter',
            nav_usage: 'Användning & krediter',
            settings_title: 'Oföränderliga revisionsspår — Inställningar',
            settings_subtitle: 'Inställningar per organisation för tillägget Immutable Audit Trails.',
            settings_banner: 'Tillägget Immutable Audit Trails är inte aktiverat för din organisation. Aktivera det här för att börja förankra bevis för Tier-A- och Tier-B-revisionshändelser.',
            status_title: 'Oföränderliga revisionsspår — Bevisstatus',
            status_subtitle: 'Per-event bevis relationer över moduler.',
            status_banner: 'Tillägget Immutable Audit Trails är inte aktiverat för din organisation. Besök Inställningar för att aktivera det.',
            integrity_center_title: 'Oföränderliga revisionsspår — Integritetscenter',
            integrity_center_subtitle: 'Verifiera bevis och exportera integritetspaket.',
            integrity_center_banner: 'Tillägget Immutable Audit Trails är inte aktiverat för din organisation. Besök Inställningar för att aktivera det innan du kör verifiering eller exporterar integritetspaket.',
            usage_title: 'Oföränderliga revisionsspår — Användning och krediter',
            usage_subtitle: 'Kreditsaldo, paketköp och användningshistorik.',
            usage_banner: 'Aktivera Immutable Audit Trails i Inställningar för att börja konsumera beviskrediter.',
            module_tips_placeholder: 'Tips och vägledning för denna yta finns i hjälpcentret.',
            column_label: 'Bevis',
            no_proof_aria: 'Inget bevis registrerat',
            proof_status_receipt_label: 'kvitto {id}',
            in_progress_hint: 'Pågår — uppdateras automatiskt',
            status_pills: {
                pending: 'Väntar',
                submitted: 'Inlämnad',
                anchored: 'Förankrad',
                confirmed: 'Bekräftad',
                retrying: 'Försöker igen',
                paused_cap: 'Pausad (tak)',
                failed: 'Misslyckades',
                failed_auth: 'Autentisering misslyckades',
            },
            status_tooltips: {
                pending: 'Väntar — i kö till korrekturtjänsten. Kommer att flytta till Inlämnad inom kort; ingen åtgärd behövs.',
                submitted: 'Skickat – ditt evenemang skickades till korrekturtjänsten. För batchläge väntar den på att bli förseglad och förankrad på kedjan. Uppdaterar automatiskt; ingen åtgärd behövs.',
                anchored: 'Förankrad — partiet har skrivits på kedjan och väntar på slutlig bekräftelse. Uppdaterar automatiskt; ingen åtgärd behövs.',
                confirmed: 'Bekräftad – beviset är förankrat i kedjan och kan verifieras.',
                retrying: 'Försöker igen — ett övergående fel inträffade. Avstämningsenheten försöker automatiskt igen; ingen åtgärd behövs.',
                paused_cap: 'Pausad – ditt månatliga provkredittak har uppnåtts. Lös in fler krediter eller vänta till nästa faktureringsmånad.',
                failed: 'Misslyckades — förankringen lyckades inte. Avstämningsenheten kommer att försöka igen automatiskt; kontakta support om det kvarstår.',
                failed_auth: 'Autentisering misslyckades – provtjänsten avvisade våra referenser. Kontrollera sidan Inställningar för Immutable Audit Trails.',
            },
            mode_pills: {
                direct: 'Direkt',
                batch: 'Batch',
            },
            drawer: {
                title: 'Bevisdetaljer',
                close: 'Stäng',
                section_proof: 'Bevis',
                section_batch: 'Batchmedlemskap',
                status: 'Status',
                proof_reference: 'Bevisreferens',
                receipt_id: 'Kvitto-ID',
                taxonomy_class: 'Taxonomi klass',
                units_consumed: 'Förbrukade enheter',
                created_at: 'Skapad',
                verification_ref: 'Kedjeverifieringsreferens',
                chain: 'Kedja',
                tx_hash: 'Tx hash',
                block_ref: 'Block ref',
                batch_reference: 'Batchreferens',
                leaf_index: 'Bladindex',
                local_event_hash: 'Lokal händelsehash',
                show_inclusion: 'Visa inkluderingsväg',
                hide_inclusion: 'Dölj inkluderingsväg',
                privacy_note: 'Nyttolasten hashas; inga personuppgifter lämnade ComplianceOne för detta evenemang.',
                verify_now: 'Verifiera nu',
                verify_pending: 'Verifiering pågår...',
                verify_verified: 'Verifierad – lokala + kontroller på kedjan har godkänts.',
                verify_issue_prefix: 'Verifieringsproblem: ',
                verify_failed: 'Verifieringssamtal misslyckades.',
                verify_result_prefix: 'Verifieringsdom:',
                verify_pending_note: 'Verifiering väntar: detta bevis väntar fortfarande på förankring på kedjan. Försök igen efter att satsen är förseglad.',
                awaiting_anchor_note: 'Detta bevis är en del av en öppen batch. Verifiering blir tillgänglig när batchen är förseglad och förankrad i kedjan - vanligtvis inom organisationens konfigurerade batchfönster. Statusmärket uppdateras automatiskt.',
                terminal_error_note: 'Detta bevis misslyckades att förankra. Bevisstatusavstämningsenheten kommer att försöka igen automatiskt; manuell verifiering har inget att kontrollera ännu.',
            },
            integrity_center: {
                section_run: 'Kör verifiering',
                section_progress: 'Kör framsteg',
                section_issues: 'frågor',
                period_start: 'Periodstart',
                period_end: 'Periodens slut',
                module_filter: 'Moduler (kommaseparerade, valfria)',
                modules_placeholder: 'rights_requests, incidenter',
                run_button: 'Kör verifiering',
                export_button: 'Exportera integritetspaket',
                export_success: 'Integrity Pack exporterat.',
                export_failed: 'Exporten misslyckades.',
                empty_disabled: 'Aktivera Immutable Audit Trails i Inställningar för att köra verifieringspass.',
                error_period_required: 'Välj ett start- och slutdatum.',
                error_start_run: 'Det gick inte att starta körningen.',
                processed: 'Bearbetat: [[TOK_2]] av [[TOK_3]]',
                col_verdict: 'Dom',
                col_count: 'Räkna',
                col_proof_link: 'Bevislänk',
                col_module: 'Modul',
                col_event_type: 'Händelsetyp',
                col_expected: 'Förväntad hash',
                col_recomputed: 'Omberäknad hash',
                col_raised_at: 'Uppvuxen kl',
                any_verdict: 'Vilken dom som helst',
                no_issues: 'Inga problem hittades.',
            },
            settings_page: {
                load_error: 'Det gick inte att läsa in inställningarna.',
                save: 'Spara',
                save_success: 'Inställningar sparade.',
                save_error: 'Det gick inte att spara.',
                discard: 'Släng ändringar',
                read_only_banner: 'Du har skrivskyddad åtkomst. Kontakta en plattformsadministratör för att göra ändringar.',
                section_status: 'Status och aktivering',
                enabled_label: 'Tillägg aktiverat',
                enabled_help: 'När den är aktiverad hashas och förankras varje revisionshändelse på nivå A och nivå B.',
                section_scope: 'Omfattning',
                scope_self: 'Endast själv',
                scope_self_and_children: 'Själv- och barnorganisationer',
                scope_children_only: 'Endast barn (förälder bevisar inte sina egna händelser)',
                section_mode: 'Standard korrekturläge',
                mode_direct: 'Direkt (ett ankare per händelse)',
                mode_batch: 'Batch (Merkle-root ankare per grupp)',
                mode_hybrid: 'Hybrid (per klass registerstandard)',
                batch_window_label: 'Batchfönster (minuter, 1–60)',
                section_taxonomy: 'Taxonomi för skyddad händelse',
                taxonomy_help: 'Åsidosättande av klass per händelse. Nivå A → direktläge, Nivå B → batchläge, Av → inte korrektur.',
                taxonomy_search: 'Sök åsidosätter',
                taxonomy_reset: 'Återställ till standardinställningar',
                taxonomy_event_class: 'Evenemangsklass',
                taxonomy_override: 'Åsidosätt',
                taxonomy_actions: 'Åtgärder',
                taxonomy_clear: 'Rensa',
                taxonomy_no_overrides: 'Inga åsidosättningar – använder registerstandarder.',
                taxonomy_add_class: 'event_class.kod',
                taxonomy_add: 'Lägg till åsidosättande',
                section_privacy: 'Sekretesskontroller',
                privacy_log_actor_ip: 'Logga skådespelarens IP',
                privacy_log_user_agent: 'Logga användaragent',
                privacy_privileged_access_proofing: 'Korrekturläser med privilegierad åtkomst (nivå A)',
                privacy_note: 'Ändringar gäller endast prospektivt.',
                section_caps: 'Caps & limits',
                cap_label: 'Månadstak (enheter; blank = obegränsad)',
                warn_label: 'Varningströskel (enheter; måste vara mindre än taket)',
                auto_pause_label: 'Pausa automatiskt nya korrektur när taket är nått',
                section_export: 'Exportåtkomst',
                export_help: 'Roll-ID får exportera integritetspaket. Kommaseparerad; blank = använd IMMUTABLE_AUDIT_TRAILS_EXPORT behörighetsstandard.',
                section_group: 'Gruppdeltagande',
                group_view_intro: 'Du är konfigurerad som en gruppförälder. Varje underordnad organisation kontrollerar sin egen aktivera/inaktivera; deras beslut rullar upp till din fakturering enligt gruppfaktureringsreglerna.',
                group_view_rule_enabled: 'Ett barn med enabled=false visas som "Inte deltar". Du ser frånvaron; barnet styr växeln.',
                group_view_rule_billing: 'Barnkonsumtionen rullar upp till ditt månadstak. Titta på sidan Användning för att övervaka kombinerad brännhastighet.',
                group_view_rule_edit: 'Du kan inte redigera ett barns inställningar från den här sidan. Öppna den underordnade organisationen direkt för att redigera.',
                group_view_open_groups: 'Öppna organisationsgrupper',
                section_credentials: 'Inloggningsuppgifter',
                credential_id: 'Autentiserings-ID',
                credential_rotated_at: 'Senast roterade',
                rotate_button: 'Rotera autentiseringsuppgifter',
                rotate_success: 'Autentiseringsuppgifter roterade. Gamla autentiseringsuppgifter giltiga i [[TOK_1]] minuter till.',
                rotate_failed: 'Autentiseringsrotation misslyckades.',
                rotate_modal_title: 'Rotera [[TOK_0]] autentiseringsuppgifter?',
                rotate_modal_body: 'Rotation utfärdar en ny legitimation. Den gamla legitimationen förblir accepterad av [[TOK_0]] under en 60-minuters respitperiod så att flygarbetare kan avsluta sina nuvarande jobb. Efter 60 minuter återkallas den gamla legitimationen.',
                rotate_modal_confirm: 'Rotera nu',
                tier_a_off_modal_title: 'Inaktivera korrektur för en evenemangsklass?',
                tier_a_off_modal_body: 'Om du ställer in en händelseklass på "Av" stoppas provtrycket från att förankra dessa händelser. Arkitektur §6 förklarar den regulatoriska implikationen: Tier-A-händelser är regulatorrelevanta; Om du stänger av dem kan det bryta ditt revisionsspår försvarbart.',
                tier_a_off_modal_confirm: 'Jag förstår – tillämpa åsidosättande',
                error_warn_lt_cap: 'Varningströskeln måste vara lägre än månadsgränsen.',
                error_window_range: 'Batch-fönstret måste vara mellan 1 och 60 minuter.',
                error_run_in_progress: 'En verifieringskörning pågår; kan inte inaktivera tillägget just nu.',
            },
            status_page: {
                filter_status: 'Status',
                filter_mode: 'Bevisläge',
                filter_module: 'Modul',
                filter_source_collection: 'Källsamling',
                filter_from_date: 'Från',
                filter_to_date: 'Till',
                filter_search: 'Sök',
                any_status: 'Vilken status som helst',
                any_mode: 'Vilket läge som helst',
                col_module: 'Modul',
                col_event_type: 'Händelsetyp',
                col_proof_status: 'Status',
                col_proof_mode: 'Läge',
                col_created_at: 'Skapad',
                col_units: 'Enheter',
                empty_disabled: 'Tillägget Immutable Audit Trails är inte aktiverat för din organisation. Besök Inställningar för att aktivera det.',
                empty_enabled_no_rows: 'Inga bevislänkar matchar de aktuella filtren.',
                export_csv: 'Exportera [[TOK_0]]',
                export_xlsx: 'Exportera [[TOK_0]]',
                export_success: 'Exporten klar',
                export_failed: 'Exporten misslyckades',
            },
            usage_page: {
                section_alerts: 'Varningar',
                alert_dismiss: 'Avvisa',
                alert_dismiss_aria: 'Avvisa varning [[TOK_1]]',
                alert_dismissed: 'Varningen avvisades',
                alert_dismiss_failed: 'Det gick inte att avvisa varningen',
                section_balance: 'Kreditsaldo',
                balance_label: 'Tillgängliga poäng',
                balance_hint: 'Återstående enheter (1 enhet = 1 skyddad händelsesäker).',
                section_current_month: 'Aktuell månad',
                consumed_label: 'Förbrukad',
                granted_label: 'Beviljas',
                refunded_label: 'Återbetalas',
                net_label: 'Netto',
                section_history: 'Användningshistorik',
                history_kind: 'Snäll',
                history_units: 'Enheter',
                history_balance_after: 'Balansera efter',
                history_notes: 'Anteckningar',
                history_at: 'När',
                cap_warning_banner: 'Du har passerat varningsgränsen för den här faktureringsmånaden. Överväg att lösa in ytterligare krediter.',
                cap_paused_banner: 'Månadstak uppnått. Bevisinlämningar pausas till nästa månad eller tills taket höjs.',
                section_redeem: 'Lös in kreditpaket',
                redeem_purchase_id: 'Fakturanummer',
                redeem_package: 'Paket',
                redeem_button: 'Lös in',
                redeem_pending: 'Löser in...',
                redeem_success: 'Krediter inlösta',
                redeem_failed: 'Lösningen misslyckades',
                redeem_option_template: '[[TOK_4]] — [[TOK_5]] [[TOK_6]] — [[TOK_7]]',
                redeem_option_units: 'enheter',
                alert_dismissing: 'Avvisar...',
                alert_kind: {
                    cap_reached: 'Månadstak uppnått',
                    low_balance: 'Låg balans',
                    auth_failure: 'Autentiseringsfel',
                    merkle_mismatch: 'Merkle missmatchar',
                    batch_terminal_failure: 'Batchterminalfel',
                    direct_terminal_failure: 'Direkt inlämningsterminalfel',
                },
                usage_kind: {
                    consume: 'Konsumera',
                    refund: 'Återbetalning',
                    grant: 'Grant',
                    adjustment: 'Justering',
                    reservation: 'Reservation',
                },
                package_starter: 'Förrätt',
                package_growth: 'Tillväxt',
                package_enterprise: 'Företag',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Köp fler krediter',
                    purchase_title: 'Köp fler krediter',
                    purchase_subtitle: 'Välj ett paket. Du skickas till Stripes säkra kassa och din faktura kommer via e-post.',
                    checkout_button: 'Fortsätt till kassan',
                    checkout_pending: 'Öppnar kassan…',
                    cancel_button: 'Avbryt',
                    purchase_error: 'Det gick inte att starta kassan. Försök igen om en stund.',
                    redeem_subtitle: 'Har du redan betalat? Välj paketet du köpte och ange faktura-ID:t från din e-post för att lägga till krediterna.',
                    error_not_found: 'Ingen faktura hittades med det numret. Kontrollera fakturanumret och försök igen.',
                    error_not_paid: 'Den här fakturan är inte markerad som betald ännu.',
                    error_org_mismatch: 'Den här fakturan utfärdades inte till din organisation.',
                    error_package_mismatch: 'Den här fakturan matchar inte det valda paketet.',
                    error_billing_unavailable: 'Det gick inte att nå faktureringstjänsten. Försök igen om en stund.',
                },
            },
        },
        files_config: {
            title: 'Filkonfiguration',
            subtitle: 'Konfigurera filuppladdningsgränser, lagringspolicyer och åsidosättningar av typen per ägare för plattformens bifogade yta.',
            section_global: 'Globala standardinställningar',
            section_global_help: 'Dessa gränser gäller för alla filer som laddas upp av användare i din organisation såvida inte en åsidosättning per ägaretyp nedan ändrar dem.',
            section_overrides: 'Åsidosätter per ägaretyp',
            section_overrides_help: 'Åsidosätt de globala gränserna för en specifik ägartyp. Värden per ägare vinner alltid över den globala miljön.',
            max_file_size_label: 'Max filstorlek',
            max_file_size_hint: 'Per individuell uppladdning (MiB)',
            max_total_attachments_label: 'Max totala bilagor',
            max_total_attachments_hint: 'I hela organisationen',
            max_total_size_label: 'Max totalt lagringsutrymme',
            max_total_size_hint: 'I hela organisationen (MiB)',
            allowed_mime_types_label: 'Tillåtna filtyper',
            allowed_mime_types_placeholder: 'Välj MIME-typer',
            retention_days_label: 'Lagringsperiod (dagar)',
            retention_days_hint: 'Hur länge filer måste sparas innan de kan raderas. Lämna tomt för ingen lagringspolicy.',
            legal_hold_label: 'Lagligt håll',
            legal_hold_hint: 'När det är aktiverat kräver hårdradering av en fil av den här ägartypen tillåtelse för åsidosättande av laglig spärr och explicit operatörsval.',
            save: 'Spara ändringar',
            saving: 'Sparar...',
            reset: 'Återställ',
            save_success: 'Inställningar sparade',
            save_version_conflict: 'En annan operatör uppdaterade dessa inställningar medan du redigerade. Ladda om för att se de senaste värdena.',
            empty_state_title: 'Använder plattformens standardinställningar',
            empty_state_body: 'Din organisation körs för närvarande på plattformens standardfilpolicy. Redigera valfritt värde nedan för att skapa en åsidosättning på organisationsnivå.',
            read_only_banner: 'Du har skrivskyddad åtkomst till filkonfiguration. Kontakta en plattformsadministratör för att göra ändringar.',
            owner_type_default_badge: 'Standard',
            owner_type_overridden_badge: 'Åsidosatt',
            owner_type_label: 'Ägartyp',
            owner_type_collapse: 'Kollapsa',
            owner_type_expand: 'Expandera',
            override_save: 'Spara åsidosätt',
            override_remove: 'Ta bort åsidosättningen',
            mime_labels: {
                'application/pdf': '[[TOK_0]] dokument',
                'image/png': 'PNG-bild',
                'image/jpeg': 'JPEG-bild',
                'image/jpg': 'JPG-bild',
                'application/msword': 'Word-dokument (legacy)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word-dokument',
                'application/vnd.ms-excel': 'Excel-kalkylblad (legacy)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel kalkylblad',
                'text/csv': '[[TOK_0]] fil',
                'text/plain': 'Vanlig text',
                'message/rfc822': 'E-postmeddelande',
            },
        },
        files_browser: {
            title: 'Filläsare',
            subtitle: 'Sök, filtrera och hantera alla bilagor som laddas upp i hela organisationen.',
            filter_owner_type: 'Ägartyp',
            filter_uploader: 'Uppladdad av',
            filter_from: 'Laddas upp efter',
            filter_to: 'Laddat upp tidigare',
            filter_size_min: 'Min storlek (MiB)',
            filter_size_max: 'Max storlek (MiB)',
            filter_mime: 'Filtyp',
            filter_deleted_state: 'Raderingstillstånd',
            filter_deleted_any: 'Alla filer',
            filter_deleted_only: 'Endast raderad',
            filter_deleted_exclude: 'Uteslut borttagen',
            filter_orphaned: 'Endast föräldralös',
            filter_search_placeholder: 'Sök filnamn...',
            filter_apply: 'Använd filter',
            filter_clear: 'Rensa filter',
            col_filename: 'Filnamn',
            col_owner_type: 'Ägartyp',
            col_owner_entity: 'Ägare',
            col_uploader: 'Uppladdad av',
            col_uploaded_at: 'Uppladdad',
            col_size: 'Storlek',
            col_mime: 'Typ',
            col_state: 'staten',
            col_actions: 'Åtgärder',
            state_active: 'Aktiv',
            state_deleted: 'Raderad',
            state_orphaned: 'Föräldralös',
            action_view_detail: 'Visa detaljer',
            action_download: 'Ladda ner',
            action_ai_edits: '[[TOK_0]] Redigeringar',
            action_soft_delete: 'Mjuk borttagning',
            action_restore: 'Återställ',
            action_hard_delete: 'Hård radering',
            bulk_soft_delete: 'Soft-delete vald',
            bulk_export_csv: 'Exportera [[TOK_0]]',
            bulk_select_all: 'Välj alla',
            reason_label: 'Anledning',
            reason_min_10_chars: 'Orsak krävs (minst 10 tecken)',
            reason_min_20_chars: 'Orsak krävs (minst 20 tecken)',
            legal_hold_override_label: 'Åsidosätt juridisk spärr',
            legal_hold_override_warning: 'Den här filen är under laglig förvaring. Hård radering kommer att registreras i revisionsspåret med din anledning och åsidosättningsflagga.',
            empty_state_title: 'Inga filer matchar dina filter',
            empty_state_body: 'Justera dina filter för att se resultat, eller rensa dem för att visa alla filer.',
            pagination_prev: 'Föregående',
            pagination_next: 'Nästa',
            pagination_page: 'Sida [[TOK_2]] av [[TOK_3]]',
            pagination_size_label: 'Per sida',
            pagination_total: 'Totalt: [[TOK_1]]',
            toast_soft_deleted: 'Filen raderades mjukt',
            toast_restored: 'Filen återställd',
            toast_hard_deleted: 'Filen raderad permanent',
            toast_bulk_deleted: '[[TOK_1]] fil(er) raderade',
            toast_error: 'Åtgärden misslyckades',
            confirm_soft_delete_title: 'Mjuk radera fil',
            confirm_restore_title: 'Återställ fil',
            confirm_hard_delete_title: 'Ta bort filen permanent',
            confirm_bulk_soft_delete_title: 'Mjuk radera valda filer',
            confirm_submit: 'Bekräfta',
            confirm_cancel: 'Avbryt',
        },
        files_detail: {
            modal_title: 'Fildetaljer',
            close: 'Stäng',
            meta_filename: 'Filnamn',
            meta_size: 'Storlek',
            meta_mime: 'Typ',
            meta_owner_type: 'Ägartyp',
            meta_owner_entity: 'Ägarenhet',
            meta_uploader: 'Uppladdad av',
            meta_uploaded_at: 'Uppladdad',
            meta_storage_path: 'Förvaringsväg',
            meta_deleted_state: 'Raderingstillstånd',
            audit_section_title: 'Revisionsspår',
            audit_load_more: 'Ladda fler händelser',
            audit_empty: 'Inga granskningshändelser registrerade för den här filen.',
            audit_config_changed: 'Konfigurationen ändrad',
            audit_soft_deleted: 'Soft-raderad',
            audit_restored: 'Återställd',
            audit_hard_deleted: 'Raderas permanent',
            audit_downloaded: 'Nedladdat',
            audit_quota_breached: 'Kvotbrott försökt',
            action_download: 'Ladda ner',
            action_soft_delete: 'Mjuk borttagning',
            action_restore: 'Återställ',
            action_hard_delete: 'Hård radering',
            effective_settings_title: 'Effektiv politik',
            effective_max_file_size: 'Max filstorlek',
            effective_retention_days: 'Retention',
            effective_legal_hold: 'Lagligt håll',
            effective_legal_hold_yes: 'Aktiv',
            effective_legal_hold_no: 'Inga',
        },
        files_dashboard: {
            title: 'Instrumentpanel för filer',
            subtitle: 'Lagringsanvändning, tillväxt och föräldralösa filer i hela organisationen.',
            kpi_total_files: 'Totalt antal filer',
            kpi_total_size: 'Total lagring',
            kpi_near_quota: 'Kvotanvändning',
            kpi_orphaned: 'Föräldralösa filer',
            chart_by_owner_type: 'Filer efter ägaretyp',
            chart_growth_30d: '30 dagars tillväxt',
            toggle_count: 'Efter räkning',
            toggle_size: 'Efter storlek',
            orphaned_panel_title: 'Föräldralösa filer (topp 20)',
            orphaned_view_all: 'Visa alla föräldralösa filer',
            orphaned_empty: 'Inga föräldralösa filer hittades.',
            growth_empty: 'Ingen uppladdningsaktivitet under de senaste 30 dagarna.',
            retention_n_days: '[[TOK_1]] dag(ar)',
            retention_none: 'Ingen policy',
        },
    },
    category_labels: {
        'user-guide': 'Användarhandbok',
        'admin-guide': 'Adminguide',
        'getting-started': 'Komma igång',
        faq: 'FAQ',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Nycklar',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        admin: 'Admin',
        aesirx: 'AesirX',
        purposes: 'Ändamål',
        preferences: 'Inställningar',
        onboarding: 'Onboarding',
        'first-steps': 'Första stegen',
        login: 'Logga in',
        navigation: 'Navigering',
        users: 'Användare',
        user: 'Användare',
        roles: 'Roller',
        role: 'Roll',
        'access-control': 'Åtkomstkontroll',
        'access-management': 'Åtkomsthantering',
        permissions: 'Behörigheter',
        permission: 'Tillstånd',
        consent: 'Samtycke',
        'consent-management': 'Samtyckeshantering',
        privacy: 'Sekretess',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Revision',
        auditing: 'Revision',
        breach: 'Brott',
        incident: 'Incident',
        incidents: 'Incidenter',
        notification: 'Avisering',
        notifications: 'Aviseringar',
        reporting: 'Rapportering',
        risk: 'Risk',
        vendor: 'Försäljare',
        vendors: 'Försäljare',
        'vendor-risk': 'Leverantörsrisk',
        assessment: 'Bedömning',
        assessments: 'Bedömningar',
        dpia: 'DPIA',
        'cross-border': 'Gränsöverskridande',
        transfer: 'Överföring',
        transfers: 'Överföringar',
        deletion: 'Radering',
        retention: 'Retention',
        'data-mapping': 'Datakartläggning',
        discovery: 'Upptäckt',
        classification: 'Klassificering',
        workflow: 'Arbetsflöde',
        workflows: 'Arbetsflöden',
        template: 'Mall',
        templates: 'Mallar',
        catalog: 'Katalog',
        monitoring: 'Övervakning',
        tasks: 'Uppgifter',
        task: 'Uppgift',
        'task-management': 'Task Management',
        organizations: 'Organisationer',
        org: 'Organisation',
        governance: 'Styrning',
        compliance: 'Efterlevnad',
        forms: 'Blanketter',
        form: 'Form',
        connectors: 'Kontakter',
        connector: 'Anslutning',
        integration: 'Integration',
        integrations: 'Integrationer',
        security: 'Säkerhet',
        encryption: 'Kryptering',
        backup: 'Säkerhetskopiering',
        recovery: 'Återhämtning',
        maintenance: 'Underhåll',
        settings: 'Inställningar',
        configuration: 'Konfiguration',
        sla: 'SLA',
        escalation: 'Upptrappning',
        remediation: 'Sanering',
        evidence: 'Bevis',
        'case-management': 'Ärendehantering',
        profile: 'Profil',
        delegation: 'Delegation',
        'service-accounts': 'Servicekonton',
        license: 'Licens',
        'license-management': 'Licenshantering',
        plan: 'Planera',
        plans: 'Planer',
        dashboard: 'Instrumentbräda',
        'web-consent': 'Webbsamtycke',
        'partner-marketplace': 'Partner Marketplace',
        partner: 'Partner',
        partners: 'Partners',
        deliverables: 'Leveranser',
        'service-tiers': 'Servicenivåer',
        'support-tickets': 'Supportbiljetter',
        'audit-trail': 'Revisionsspår',
        'first-time-setup': 'Förstagångsinstallation',
        setup: 'Inställning',
        quickstart: 'Snabbstart',
        tour: 'Rundtur',
        tours: 'Turer',
        'sample-data': 'Exempeldata',
        'data-subject': 'Registrerad',
        'data-subjects': 'registrerade',
        pseudonymous: 'Pseudonym',
        identified: 'Identifierad',
        'help-center': 'Hjälpcenter',
        article: 'Artikel',
        articles: 'Artiklar',
        search: 'Sök',
        'platform-settings': 'Plattformsinställningar',
        'platform-config': 'Plattformskonfiguration',
        'module-config': 'Modulkonfiguration',
        'module-configuration': 'Modulkonfiguration',
        'rights-requests': 'Rättighetsbegäranden',
        'access-accountability': 'Få tillgång till ansvarighet',
        'data-discovery': 'Upptäckt av data',
        'incident-ops': 'Incidentverksamhet',
        'deletion-orchestration': 'Radering Orkesterering',
        'compliance-forms': 'Efterlevnadsformulär',
        'program-governance': 'Programstyrning',
        localization: 'Lokalisering',
        'privacy-scanner': 'Sekretessskanner',
        'consent-properties': 'Samtyckesegenskaper',
        acceptances: 'Acceptanser',
        access: 'Tillgång',
        'access-review': 'Åtkomstgranskning',
        'access-reviews': 'Åtkomstgranskningar',
        accountability: 'Ansvarsskyldighet',
        acknowledgment: 'Bekräftelse',
        'action-plans': 'Handlingsplaner',
        activation: 'Aktivering',
        activations: 'Aktiveringar',
        'active-response': 'Aktivt svar',
        activity: 'Aktivitet',
        adequacy: 'Lämplighet',
        'admin-guide': 'Adminguide',
        aggregation: 'Aggregation',
        agreements: 'Avtal',
        ai: 'AI',
        alerts: 'Varningar',
        analytics: 'Analytics',
        anchoring: 'Förankring',
        approval: 'Godkännande',
        approvals: 'Godkännanden',
        apps: 'Appar',
        assets: 'Tillgångar',
        assignments: 'Uppdrag',
        attestation: 'Intyg',
        'audit-log': 'Revisionslogg',
        'audit-pack': 'Revisionspaket',
        authentication: 'Autentisering',
        authority: 'Myndighet',
        'auto-play': 'Spela automatiskt',
        automated: 'Automatiserad',
        automation: 'Automation',
        baseline: 'Baslinje',
        batches: 'Partier',
        bidirectional: 'Dubbelriktad',
        bilingual: 'Tvåspråkig',
        bindings: 'Bindningar',
        blockchain: 'Blockchain',
        board: 'Styrelse',
        brand: 'Varumärke',
        brds: 'BRD:er',
        'break-glass': 'Break-Glass',
        builder: 'Byggare',
        bulk: 'Bulk',
        'bulk-sync': 'Bulk Sync',
        bundles: 'Buntar',
        calendar: 'Kalender',
        campaigns: 'Kampanjer',
        cases: 'Fall',
        categories: 'Kategorier',
        category: 'Kategori',
        certification: 'Certifiering',
        chain: 'Kedja',
        change: 'Ändra',
        'change-awareness': 'Ändra medvetenhet',
        'change-log': 'Ändringslogg',
        'change-management': 'Change Management',
        'change-requests': 'Ändringsförfrågningar',
        'cmp-validation': '[[TOK_0]] Validering',
        collection: 'Samling',
        comparison: 'Jämförelse',
        completeness: 'Fullständighet',
        completion: 'Slutförande',
        'compliance-posture': 'Efterlevnadshållning',
        'compliance-proof': 'Överensstämmelsebevis',
        'compliance-reviews': 'Överensstämmelserecensioner',
        config: 'Konfig',
        confirmation: 'Bekräftelse',
        conflicts: 'Konflikter',
        consolidation: 'Konsolidering',
        continuous: 'Kontinuerlig',
        contracts: 'Kontrakt',
        controls: 'Kontroller',
        cookies: 'Cookies',
        cooperation: 'Samarbete',
        coordination: 'Samordning',
        'corporate-governance': 'Bolagsstyrning',
        'corrective-actions': 'Korrigerande åtgärder',
        coverage: 'Täckning',
        'credential-vault': 'Credential Vault',
        credentials: 'Inloggningsuppgifter',
        cycles: 'Cyklar',
        dashboards: 'Instrumentbrädor',
        'data-assets': 'Datatillgångar',
        'data-flows': 'Dataflöden',
        'data-sensitivity': 'Datakänslighet',
        'data-steward': 'Data Steward',
        deadlines: 'Deadlines',
        'decree-356': 'Dekret 356',
        dedup: 'Dedup',
        definitions: 'Definitioner',
        deliverable: 'Levereras',
        departments: 'Avdelningar',
        'dependency-order': 'Beroendeordning',
        deployment: 'Utplacering',
        detection: 'Detektion',
        diff: 'Diff',
        'digital-properties': 'Digitala egenskaper',
        dimensions: 'Mått',
        disable: 'Inaktivera',
        'disaster-recovery': 'Katastrofåterställning',
        disclosure: 'Avslöjande',
        documentation: 'Dokumentation',
        documents: 'Dokument',
        domains: 'Domäner',
        dossier: 'Dokumentation',
        dpa: 'DPA',
        drift: 'Drift',
        'drift-detection': 'Driftdetektering',
        'due-diligence': 'Due Diligence',
        email: 'Email',
        emergency: 'Nödsituation',
        enable: 'Aktivera',
        'enterprise-map': 'Företagskarta',
        erasure: 'Radering',
        evaluation: 'Utvärdering',
        'event-bus': 'Event Buss',
        exceptions: 'Undantag',
        execution: 'Utförande',
        executive: 'Executive',
        exercises: 'Övningar',
        export: 'Exportera',
        exports: 'Exporter',
        filing: 'Arkivering',
        filter: 'Filtrera',
        filtering: 'Filtrering',
        findings: 'Fynd',
        flows: 'Flöden',
        'follow-up': 'Uppföljning',
        forensic: 'Rättsmedicinsk',
        forensics: 'Forensics',
        'form-filler': 'Blankettfyllare',
        framework: 'Ramverk',
        frameworks: 'Ramar',
        'gap-analysis': 'Gapanalys',
        'gap-report': 'Gaprapport',
        gaps: 'Luckor',
        gates: 'Portar',
        'getting-started': 'Komma igång',
        'golden-templates': 'Gyllene mallar',
        grc: 'GRC',
        'group-management': 'Koncernledning',
        groups: 'Grupper',
        'guided-tours': 'Guidade turer',
        guides: 'Guider',
        handling: 'Hantering',
        'hands-on': 'Hands-On',
        health: 'Hälsa',
        help: 'Hjälp',
        hierarchy: 'Hierarki',
        history: 'Historia',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Identitetsleverantör',
        implementation: 'Genomförande',
        import: 'Importera',
        improvement: 'Förbättring',
        'incident-response': 'Incident Response',
        inconsistencies: 'Inkonsekvenser',
        instances: 'Förekomster',
        intake: 'Intag',
        'intake-key': 'Intagsnyckel',
        interactive: 'Interaktiv',
        international: 'Internationell',
        inventory: 'Inventering',
        investigation: 'Utredning',
        investigations: 'Utredningar',
        'ip-allowlist': 'IP-tillståndslista',
        issues: 'frågor',
        justification: 'Motivering',
        justifications: 'Motiveringar',
        kanban: 'Kanban',
        keyboard: 'Tangentbord',
        keys: 'Nycklar',
        'knowledge-base': 'Kunskapsbas',
        koncernstyring: 'Bolagsstyrning',
        kpi: 'KPI',
        labeling: 'Märkning',
        language: 'Språk',
        'language-packs': 'Språkpaket',
        languages: 'Språk',
        lawfulness: 'Laglighet',
        layout: 'Layout',
        'legal-basis': 'Rättslig grund',
        'lessons-learned': 'Lärdomar',
        levels: 'Nivåer',
        library: 'Bibliotek',
        lifecycle: 'Livscykel',
        lineage: 'Härstamning',
        links: 'Länkar',
        listings: 'Listor',
        live: 'Live',
        locale: 'Plats',
        log: 'Log',
        logging: 'Loggning',
        'managed-service': 'Hanterad tjänst',
        mapping: 'Kartläggning',
        mappings: 'Kartläggningar',
        'market-packs': 'Marknadspaket',
        marketplace: 'Marknadsplats',
        maturity: 'Mognad',
        metrics: 'Mätvärden',
        models: 'Modeller',
        module: 'Modul',
        modules: 'Moduler',
        mps: 'MPS',
        'multi-factor': 'Multifaktor',
        'multi-market': 'Multimarknad',
        'multi-org': 'Multi-Org',
        'multi-property': 'Multi-Property',
        'my-tasks': 'Mina uppgifter',
        obligations: 'Skyldigheter',
        offboarding: 'Offboarding',
        oidc: 'OIDC',
        orchestration: 'Orkestrering',
        'org-groups': 'Organisationsgrupper',
        organization: 'Organisation',
        overdue: 'Försenad',
        overview: 'Översikt',
        'owner-review': 'Ägare recension',
        package: 'Paket',
        packages: 'Paket',
        packs: 'Förpackningar',
        pagination: 'Paginering',
        'parent-child': 'Förälder-Barn',
        patterns: 'Mönster',
        performance: 'Prestanda',
        periodic: 'Periodisk',
        periods: 'Perioder',
        personal: 'Personligt',
        'personal-data': 'Personuppgifter',
        personas: 'Personas',
        planning: 'Planering',
        platform: 'Plattform',
        playbooks: 'Handlingsplaner',
        poc: 'PoC',
        'point-in-time': 'Point-in-Time',
        policies: 'Policyer',
        portfolio: 'Portfölj',
        'post-incident': 'Efter incidenten',
        'power-user': 'Power User',
        practice: 'Öva',
        pricing: 'Prissättning',
        'privacy-impact': 'Integritetspåverkan',
        procedures: 'Förfaranden',
        processes: 'Processer',
        processing: 'Bearbetning',
        'processing-activities': 'Bearbetningsaktiviteter',
        procurement: 'Upphandling',
        productivity: 'Produktivitet',
        profiles: 'Profiler',
        programs: 'Program',
        progress: 'Framsteg',
        proof: 'Bevis',
        propagation: 'Förökning',
        properties: 'Egenskaper',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Offentlig form',
        quality: 'Kvalitet',
        questionnaires: 'Frågeformulär',
        'quick-links': 'Snabblänkar',
        'quick-start': 'Snabbstart',
        'quick-starts': 'Snabbstarter',
        raci: 'RACI',
        readiness: 'Beredskap',
        'real-time': 'Realtid',
        reassessments: 'Omvärderingar',
        reconciliation: 'Försoning',
        record: 'Spela in',
        records: 'Rekord',
        recurring: 'Återkommande',
        register: 'Registrera dig',
        registry: 'Registret',
        regulations: 'förordningar',
        regulator: 'Regulator',
        regulatory: 'Reglerande',
        'regulatory-frameworks': 'Regelverk',
        remap: 'Mappa om',
        reminders: 'Påminnelser',
        reports: 'Rapporter',
        requests: 'Förfrågningar',
        requirements: 'Krav',
        response: 'Svar',
        'response-plans': 'Responsplaner',
        'response-team': 'Responsteam',
        'response-templates': 'Svarsmallar',
        'response-time': 'Svarstid',
        responses: 'Svar',
        responsibility: 'Ansvar',
        results: 'Resultat',
        review: 'Granska',
        reviews: 'Recensioner',
        'right-to-delete': 'Rätt att radera',
        rights: 'Rättigheter',
        'risk-tiers': 'Risknivåer',
        rollouts: 'Utrullningar',
        rollup: 'Rollup',
        ropa: 'ROPA',
        routing: 'Routing',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Regler',
        runs: 'Springer',
        saml: 'SAML',
        scan: 'Skanna',
        scanning: 'Skanning',
        scc: 'SCC',
        schedule: 'Schema',
        scheduled: 'Schemalagt',
        schedules: 'Schema',
        scheduling: 'Schemaläggning',
        scores: 'Poäng',
        scoring: 'Poängsättning',
        scripts: 'Manus',
        'security-reviews': 'Säkerhetsrecensioner',
        'sensitive-data': 'Känsliga data',
        sensitivity: 'Känslighet',
        'separation-of-duties': 'Uppdelning av arbetsuppgifter',
        service: 'Service',
        sessions: 'Sessioner',
        'setup-wizard': 'Installationsguiden',
        severity: 'Allvarlighet',
        'shared-governance': 'Delad styrning',
        'shared-settings': 'Delade inställningar',
        shortcuts: 'Genvägar',
        sidebar: 'Sidofält',
        signals: 'Signaler',
        'single-sign-on': 'Enkel inloggning',
        snapshots: 'Ögonblicksbilder',
        sod: 'SoD',
        sorting: 'Sortering',
        sources: 'Källor',
        staging: 'Iscensättning',
        standards: 'Standarder',
        status: 'Status',
        structure: 'Struktur',
        'sub-processor': 'Underprocessor',
        'sub-processors': 'Underprocessorer',
        submissions: 'Inlämningar',
        subprocessors: 'Underprocessorer',
        subscription: 'Prenumeration',
        suggestions: 'Förslag',
        summaries: 'Sammanfattningar',
        supplements: 'Kosttillskott',
        support: 'Support',
        sync: 'Synkronisera',
        system: 'System',
        systems: 'System',
        tables: 'Tabeller',
        tagging: 'Taggning',
        'tamper-proof': 'Säkert mot manipulation',
        taxonomies: 'Taxonomier',
        taxonomy: 'Taxonomi',
        tenants: 'Hyresgäster',
        termination: 'Uppsägning',
        'third-party': 'Tredje part',
        'ticket-sync': 'Biljettsynkronisering',
        tickets: 'Biljetter',
        tiers: 'Nivåer',
        tokens: 'Polletter',
        totp: 'TOTP',
        traceability: 'Spårbarhet',
        tracking: 'Spårning',
        trail: 'Spår',
        training: 'Utbildning',
        translation: 'Översättning',
        translations: 'Översättningar',
        transparency: 'Transparens',
        trends: 'Trender',
        unified: 'Enhetlig',
        updates: 'Uppdateringar',
        validation: 'Validering',
        vault: 'Valv',
        'vendor-requests': 'Säljarförfrågningar',
        verification: 'Verifiering',
        versioning: 'Versionering',
        versions: 'Versioner',
        vietnam: 'Vietnam',
        violations: 'Kränkningar',
        visualization: 'Visualisering',
        waivers: 'Dispens',
        'web-records': 'Web Records',
        website: 'Webbplats',
        websites: 'Webbplatser',
        weights: 'Vikter',
        'white-label': 'White-Label',
        withdrawal: 'Uttag',
    },
    module_labels: {
        rights_requests: 'Begäran om Rättigheter',
        data_mapping: 'Datakartläggning',
        governance: 'Leverantörsstyrning',
        consent: 'Samtyckeshantering',
        consent_properties: 'Samtyckesegenskaper',
        assessments: 'Konsekvensbedömningar & Bedömningar',
        classification: 'Dataklassificering',
        monitoring: 'Övervakningsprogram',
        program: 'Övervakningsprogram',
        incidents: 'Incidenthantering',
        connectors: 'Anslutningar',
        vendor_risk: 'Leverantörsrisk',
        deletion_orchestration: 'Raderingsorkestrering',
        discovery: 'Dataupptäckt',
        incident_ops: 'Incidentdrift',
        program_governance: 'Programstyrning',
        access_accountability: 'Åtkomstansvar',
        localization: 'Lokalisering',
        partner_workspace: 'Partnerarbetsyta',
        privacy_scanner: 'Integritetsskanner',
        onboarding: 'Onboarding',
        compliance_forms: 'Efterlevnadsformulär',
        audit_trail: 'Granskningslogg',
        data_subjects: 'Registrerade',
        organizations: 'Organisationer',
        task_management: 'Task Management',
        deletion_orch: 'Raderingsorkestrering',
        forms: 'Efterlevnadsformulär',
        partner_marketplace: 'Partnermarknadsplats',
        dashboard: 'Översikt',
        platform_settings: 'Plattformsinställningar',
        help_center: 'Hjälpcenter',
    },
    module_descriptions: {
        rights_requests: 'Hantera registrerades rättighetsbegäranden inklusive åtkomst, radering och portabilitet. Spåra begärandens livscykel, tilldela handläggare och uppfyll lagstadgade tidsfrister.',
        data_mapping: 'Kartlägg dataflöden i din organisation. Spåra behandlingsaktiviteter, datakategorier, ändamål, lagringspolicyer och systemintegrationer.',
        governance: 'Hantera leverantörsefterlevnad och styrning. Spåra leverantörsbedömningar, avtal, SLA-prestanda och regulatoriska skyldigheter.',
        consent: 'Hantera insamling, lagring och återkallande av samtycke. Spåra samtyckesposter, ändamål och integration med samtyckeshanteringsplattformar.',
        consent_properties: 'Konfigurera samtyckesegenskaper, grupper och gyllene mallar. Definiera återanvändbara samtyckeskonfigurationer för enhetlig distribution.',
        assessments: 'Genomför konsekvensbedömningar avseende dataskydd (DPIA) och integritetsriskbedömningar. Utvärdera behandlingsaktiviteter för efterlevnadsrisker.',
        classification: 'Klassificera datatillgångar efter känslighetsnivå. Tillämpa taxonomietiketter, spåra livscykelposter och identifiera klassificeringsluckor.',
        monitoring: 'Konfigurera övervakningsprogram för att spåra efterlevnadsmått, centrala riskindikatorer och kontrolleffektivitet över tid.',
        incidents: 'Rapportera och hantera integritetsincidenter och dataintrång. Spåra utrednings-, aviserings- och åtgärdsarbetsflöden.',
        connectors: 'Konfigurera datakälleanslutningar och integrationer. Anslut externa system för automatiserad dataupptäckt och övervakning.',
        vendor_risk: 'Bedöm och övervaka tredjepartsleverantörsrisker. Poängsätt leverantörer, spåra riskreducering och hantera leverantörsriskkonfigurationer.',
        deletion_orchestration: 'Orkestrera dataradering över system. Spåra raderingsbegäranden, verifiera beviskedjor och säkerställ fullständig databorttagning.',
        discovery: 'Upptäck personuppgifter i anslutna system. Skanna datakällor för att bygga en heltäckande datainventering.',
        incident_ops: 'Operativ incidenthantering med handböcker, eskaleringsarbetsflöden och SLA-spårning för incidentlösning.',
        program_governance: 'Spåra det övergripande integritetsprogrammets mognad, efterlevnadspoäng, bevisbrister och ledningsrapportering i hela din organisation.',
        access_accountability: 'Undersök och granska användaråtkomstmönster. Spåra åtkomstkonfigurationer, övervaka misstänkt aktivitet och upprätthåll ansvarsskyldighet.',
        localization: 'Installera och hantera marknadslokaliserings­paket. Lägg till regulatoriska ramverk, språkpaket och regionsspecifikt efterlevnadsinnehåll.',
        partner_workspace: 'Samarbeta med externa partners. Dela efterlevnadsdata, spåra partnerskyldigheter och hantera partnerrelationer.',
        privacy_scanner: 'Skanna webbplatser efter integritetsefterlevnadsproblem. Övervaka kakanvändning, spårningsskript och förekomst av integritetspolicyer i realtid.',
        onboarding: 'Guida nya organisationer genom plattformskonfiguration. Steg-för-steg-introduktionsguide för initial konfiguration och dataimport.',
        compliance_forms: 'Skapa och hantera efterlevnadsformulär från en mallkatalog. Fyll i regulatoriska formulär, spåra inlämningar och generera rapporter.',
        audit_trail: 'Visa en komplett granskningslogg över alla systemåtgärder. Spåra vem som gjorde vad, när och var i alla moduler.',
        organizations: 'Hantera organisationer och flerhyresgästinställningar. Konfigurera organisationsprofiler, hierarkier och relationer mellan organisationer.',
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Förklara anomalier',
            explaining: 'Förklarar...',
            results_heading: 'Anomaliförklaringar ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            items_label: '[[TOK_1]] objekt',
            remediation_label: 'Saneringssteg',
            items_detail_label: 'Berörda föremål',
            accept_label: 'Acceptera förklaring',
            reject_label: 'Avvisa förklaringen',
            error_generic: 'Kunde inte förklara anomalierna. Försök igen eller kontrollera att skanningen är klar.',
        },
        cookie_insight: {
            insight_label: 'Cookie & tracker [[TOK_0]] insikt',
            producing: 'Producerar insikt...',
            results_heading: 'Cookie- och spårningsinsikt ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            items_label: '[[TOK_1]] objekt',
            classification_label: 'Klassificering',
            severity_label: 'Allvarlighet',
            banner_copy_label: 'Föreslagen bannerkopia',
            retention_label: 'Retentionsråd',
            citations_label: 'Citat',
            kind_cookie: 'Cookie',
            kind_tracker: 'Spårare',
            class_necessary: 'Nödvändigt',
            class_analytics: 'Analytics',
            class_marketing: 'Marknadsföring',
            class_social: 'Social',
            accept_label: 'Acceptera insikt',
            reject_label: 'Avvisa insikt',
            no_items: 'Inga cookies eller spårare upptäcktes i denna genomsökning.',
            error_generic: 'Det gick inte att producera cookie-insikten. Försök igen eller kontrollera att skanningen är klar.',
        },
        monitoring: {
            title: 'Integritetsövervakning',
            new_scan: 'Ny Skanning',
            scan_url: 'URL att Skanna',
            scan_frequency: 'Skanningsfrekvens',
            last_scan: 'Senaste Skanning',
            score: 'Integritetspoäng',
            issues: 'Hittade Problem',
            history: 'Skanningshistorik',
            settings: 'Övervakningsinställningar',
        },
        real_time: {
            title: 'Realtidsskanner',
            scan_now: 'Skanna Nu',
            scanning: 'Skannar...',
            results: 'Skanningsresultat',
            no_results: 'Inga skanningsresultat ännu.',
            cookies: 'Kakor',
            trackers: 'Spårare',
            consent_banners: 'Samtyckesbannrar',
            third_party: 'Tredjepartsskript',
            archive: 'Resultatarkiv',
            settings: 'Skannerinställningar',
        },
        dashboard: {
            page_title: 'Översikt för integritetsövervakning',
            privacy_monitoring: 'Sekretessövervakning',
            plan_label: '[[TOK_1]] plan',
            expires_label: 'löper ut [[TOK_1]]',
            settings: 'Inställningar',
            refresh: 'Uppdatera',
            refreshing_dashboard: 'Uppfriskande övervakningsinstrumentpanel',
            refresh_aria: 'Uppdatera övervakningsinstrumentpanelen',
            not_configured_title: 'Sekretessövervakning inte konfigurerad',
            not_configured_desc: 'Anslut din [[TOK_0]] tjänst för sekretessövervakning för att börja spåra webbplatsens efterlevnad.',
            configure_monitoring: 'Konfigurera övervakning',
            license_expired_title: 'Licensen har löpt ut',
            license_expired_desc: 'Din licens för [[TOK_0]] integritetsövervakning har löpt ut. Vänligen förnya den för att undvika avbrott i tjänsten.',
            compliance_score: 'Efterlevnadspoäng',
            cookies_detected: 'Cookies upptäckts',
            trackers_label: 'Spårare',
            open_issues: 'Öppna frågor',
            score_good: 'Bra',
            score_needs_improvement: 'Behöver förbättring',
            score_critical: 'Kritisk',
            action_required: 'Åtgärd krävs',
            cookies_sr: 'cookies upptäckts',
            trackers_sr: 'spårare hittade',
            open_issues_sr: 'öppna frågor',
            action_required_sr: 'åtgärd krävs',
            metric_label: 'Metrisk',
            value_label: 'Värde',
            status_label: 'Status',
            aria_metrics: 'Sekretessövervakningsstatistik',
            plan_limit_warning: 'Skannar [[TOK_4]]: [[TOK_2]]/[[TOK_3]] – du har nått din plangräns.',
            manage_domains: 'Hantera domäner eller uppgradera din plan.',
            monitored_domains: 'Övervakade domäner',
            domain_added: 'Domän [[TOK_1]] har lagts till',
            domain_removed: 'Domänen [[TOK_1]] har tagits bort',
            failed_add_domain: 'Det gick inte att lägga till domän',
            failed_remove_domain: 'Det gick inte att ta bort domänen',
            failed_load: 'Det gick inte att läsa in övervakningsinstrumentpanelen',
            new_domain_aria: 'Ny domän [[TOK_0]]',
            add_domain: 'Lägg till domän',
            adding_domain: 'Lägger till...',
            no_domains: 'Inga övervakade domäner har konfigurerats ännu.',
            aria_domains_table: 'Övervakade domäner',
            col_domain: 'Domän',
            col_compliance_score: 'Efterlevnadspoäng',
            col_status: 'Status',
            col_cookies: 'Cookies',
            col_trackers: 'Spårare',
            col_issues: 'frågor',
            col_last_scan: 'Senaste skanningen',
            col_action: 'Åtgärd',
            compliance_status_sr: 'efterlevnadsstatus',
            showing_chart: 'Visar diagramvy',
            showing_table: 'Visar datatabellvy',
            loading_sr: 'Laddar övervakningsinstrumentpanelen',
            col_framework_tags: 'Ramtaggar',
            col_last_monitored: 'Senast övervakad',
            framework_tags_sr: 'tillämpliga regelverk',
            last_monitored_sr: 'kontinuerlig övervakning tidsstämpel',
            audit_trail_heading: 'Revisionsspår',
            audit_trail_info: 'Varje övervakningsskanning tidsstämplas och loggas. Ändringar av efterlevnad på domännivå ger en oföränderlig revisionspost som kan exporteras för regulatorisk granskning.',
            cybersecurity_law_info_heading: 'Upptäckt av cybersäkerhetslagar',
            cybersecurity_law_info: 'Övervakade domäner kontrolleras automatiskt mot cybersäkerhetslagstiftningen (t.ex. Vietnam Cybersecurity Law, [[TOK_0]] direktiv). Ramtaggar anger vilka regler som gäller. Frågor kategoriseras efter regelverk för riktad sanering.',
        },
        scan: {
            page_title: 'Realtidsskanning',
            title: 'Sekretessskanner i realtid',
            settings: 'Inställningar',
            results_archive: 'Resultatarkiv',
            launch_scan: 'Starta Scan',
            target_url: 'Mål [[TOK_0]]',
            protocol_aria: 'Protokoll',
            url_required: '[[TOK_0]] krävs',
            url_whitespace: 'Ta bort blanksteg från [[TOK_0]]',
            url_invalid: 'Ange en giltig domän (t.ex. example.com)',
            add_subpages: 'Lägg till undersidor',
            add_subpages_aria: 'Lägg till undersidor, [[TOK_1]] har lagts till',
            start_scan: 'Starta skanning',
            launching: 'Startar...',
            scan_launched: 'Skanningen har startats',
            scan_failed: 'Det gick inte att starta skanningen',
            scan_progress: 'Skanna framsteg',
            scanning_in_progress: 'Skanning pågår...',
            scan_id: 'Skanna ID',
            status_label: 'Status',
            status_unknown: 'unknown',
            progress_label: 'Framsteg',
            pages_label: 'Sidor',
            refresh_status: 'Uppdatera status',
            new_scan: 'Ny skanning',
            scan_completed: 'Skanningen slutförd, resultat tillgängliga',
            failed_check_status: 'Det gick inte att kontrollera skanningsstatus',
            scan_results: 'Skanningsresultat',
            main_page: 'Huvudsida',
            page_n: 'Sida [[TOK_1]]',
            result_pages_nav: 'Resultatsidor',
            page_url: 'Sida [[TOK_0]]',
            risk_score: 'Riskpoäng',
            risk_score_sr: 'riskpoäng',
            cookies_label: 'Cookies',
            cookies_sr: 'cookies upptäckts',
            scripts_label: 'Manus',
            scripts_sr: 'skript har upptäckts',
            issues_label: 'frågor',
            issues_sr: 'problem hittades',
            issues_found: 'Hittade problem',
            aria_issues_table: 'Problem upptäckta under skanningen',
            col_severity: 'Allvarlighet',
            col_category: 'Kategori',
            col_title: 'Titel',
            col_remediation: 'Sanering',
            severity_sr: 'severity',
            scan_result_metrics: 'Skanna resultatstatistik',
            view_full_detail: 'Visa hela detaljer',
            col_consent_category: 'Samtyckeskategori',
            consent_category_sr: 'samtyckeskategorisering',
            compliance_evidence_heading: 'Efterlevnadsbevis',
            compliance_evidence_info: 'Skanningsfynd kopplas automatiskt till efterlevnadsfall. Varje fråga kan spåras till en samtyckeskategori (väsentligt, funktionellt, analytiskt, marknadsföring) och producerar revisionsfärdiga bevis för regulatorisk granskning.',
            rule_config_heading: 'Regelkonfiguration',
            rule_config_info: 'Genomsökningsregler kan konfigureras enligt regelverk. Cookiekontroller, skriptdetektering och leverantörsanalys kan aktiveras eller inaktiveras via Inställningar. Anpassade regler kan definieras för att matcha din organisations efterlevnadskrav.',
            case_linkage_heading: 'Efterlevnadsfallskoppling',
            case_linkage_info: 'Problem som upptäcks under realtidsskanningar kan kopplas till efterlevnadsfall för spårning och åtgärdande. Navigera till sidan med detaljer om skanningsresultat för att se fallassociationer.',
            subpages_modal_title: 'Lägg till undersidor',
            subpages_modal_desc: 'Lägg till upp till 5 webbadresser för undersidor för att skanna tillsammans med huvuddomänen.',
            subpage_n: 'Undersida [[TOK_1]]',
        },
        result_detail: {
            page_title: 'Scan resultat detalj',
            title: 'Skanningsresultat',
            back_to_archive: 'Tillbaka till Arkiv',
            failed_load: 'Det gick inte att ladda skanningsresultatet',
            loading_sr: 'Laddar skanningsresultat...',
            scan_id: 'Skanna ID',
            target_url: 'Mål [[TOK_0]]',
            status_label: 'Status',
            status_sr: 'status',
            started: 'Startade',
            completed: 'Avslutad',
            pages_scanned: 'Skannade sidor',
            https_label: 'HTTPS',
            highest_risk_score: 'Högsta riskpoäng',
            most_cookies: 'De flesta kakor',
            most_vendors: 'De flesta tredjepartsleverantörer',
            most_issues: 'De flesta frågor',
            across_pages: 'över sidorna',
            highest_values_aria: 'Högsta värden på alla sidor',
            scanned_pages_nav: 'Skannade sidor',
            main_page: 'Huvudsida',
            page_n: 'Sida [[TOK_1]]',
            page_url: 'Sida [[TOK_0]]',
            risk_score: 'Riskpoäng',
            overall_risk_sr: 'övergripande riskpoäng',
            cookies_label: 'Cookies',
            cookies_sr: 'cookies upptäckts',
            vendors_label: 'Tredjepartsleverantörer',
            vendors_sr: 'tredjepartsleverantörer upptäckts',
            issues_label: 'frågor',
            issues_sr: 'problem hittades',
            risk_breakdown_aria: 'Fördelning av riskpoäng',
            issues_found: 'Hittade problem',
            aria_issues_table: 'Problem upptäckta under skanningen',
            col_severity: 'Allvarlighet',
            col_category: 'Kategori',
            col_title: 'Titel',
            col_remediation: 'Sanering',
            severity_sr: 'severity',
            cookies_heading: 'Cookies ([[TOK_1]])',
            aria_cookies_table: 'Cookies upptäcktes',
            col_name: 'Namn',
            col_domain: 'Domän',
            col_path: 'Väg',
            col_secure: 'Säker',
            col_httponly: 'Endast Http',
            col_samesite: 'SameSite',
            vendors_heading: 'Tredjepartsleverantörer ([[TOK_1]])',
            aria_vendors_table: 'Tredjepartsleverantörer har upptäckts',
            col_hostname: 'Värdnamn',
            scripts_heading: 'Skript/Beacons ([[TOK_1]])',
            aria_scripts_table: 'Skript och beacons har upptäckts',
            col_url: 'URL',
            col_type: 'Typ',
            links_heading: 'Länkar',
            first_party: 'Första part',
            third_party: 'Tredje part',
            col_risk_category: 'Riskkategori',
            col_regulatory_framework: 'Regelverk',
            col_actionable_detail: 'Handlingsbar detalj',
            risk_category_sr: 'regulatorisk riskkategori',
            risk_category_mapping_heading: 'Riskkategorikartläggning',
            risk_category_mapping_info: 'Varje skanningsfynd mappas till en regulatorisk riskkategori (datainsamling, gränsöverskridande överföring, samtyckeshantering, datalagring, säkerhetskontroller). Denna kartläggning möjliggör riktad sanering prioriterad av regulatorisk påverkan.',
            compliance_case_heading: 'Compliance Case Association',
            compliance_case_info: 'Skanningsresultat är kopplade till efterlevnadsfall för spårning från början till slut. Problem kan eskaleras direkt från skanningsresultat till arbetsflödet för efterlevnadsärende.',
        },
        results_archive: {
            page_title: 'Skanna resultatarkiv',
            title: 'Skanna resultatarkiv',
            back_to_scanner: 'Tillbaka till Scanner',
            failed_load: 'Det gick inte att läsa in skanningsresultat',
            results_loaded: 'Skanningsresultat laddade, [[TOK_1]] poster',
            total_label: 'Totalt: [[TOK_1]]',
            aria_table: 'Skanna resultatarkiv',
            col_scan_date: 'Skanningsdatum',
            col_target_url: 'Mål [[TOK_0]]',
            col_duration: 'Varaktighet',
            col_issues_found: 'Hittade problem',
            col_risk_score: 'Riskpoäng',
            col_status: 'Status',
            col_actions: 'Åtgärder',
            scan_status_sr: 'skanningsstatus',
            view_result: 'Visa',
            no_results: 'Inga skanningsresultat hittades.',
            loading_sr: 'Laddar skanningsresultat',
            pagination_aria: 'Paginering av skannaresultat',
            col_risk_category: 'Riskkategori',
            risk_category_sr: 'regulatorisk riskkategori',
            archive_retention_heading: 'Arkivbevarande',
            archive_retention_info: 'Skanningsresultaten bevaras under den tid som anges i din organisations policy för datalagring. Arkiverade resultat inkluderar fullständig genomsökningskontext (ramtaggar, riskkategorier, åtgärdsvägledning) och kan exporteras som [[TOK_0]] för regulatoriska bevis.',
            export_context_info: 'Exporterade [[TOK_0]] filer inkluderar regulatorisk kontext: riskkategori, tillämpliga ramverk och åtgärdsdetaljer för varje fynd.',
        },
        scanner_settings: {
            page_title: 'Skannerinställningar',
            title: 'Skannerinställningar',
            back_to_scanner: 'Tillbaka till Scanner',
            failed_load: 'Det gick inte att läsa in skannerkonfigurationen',
            endpoint_url: 'Slutpunkt [[TOK_0]]',
            save_success: 'Skannerkonfigurationen har sparats.',
            save_failed: 'Det gick inte att spara skannerkonfigurationen',
            test_connection: 'Testa anslutningen',
            testing: 'Testar...',
            save_configuration: 'Spara konfiguration',
            saving: 'Sparar...',
            loading_sr: 'Laddar skannerinställningar',
        },
        monitoring_settings: {
            page_title: 'Inställningar för sekretessövervakning',
            title: 'Övervakningsinställningar',
            back_to_dashboard: 'Tillbaka till Dashboard',
            failed_load: 'Det gick inte att ladda övervakningskonfigurationen',
            credentials_heading: '[[TOK_0]] Inloggningsuppgifter',
            connected_as: 'Ansluten som [[TOK_1]]',
            credentials_desc: 'Ange dina [[TOK_0]] kontouppgifter för att ansluta sekretessövervakning. Hitta ditt medlems-ID på din [[TOK_1]] kontoprofilsida.',
            client_id: 'Klient-ID',
            client_secret: 'Klienthemlighet',
            username: '[[TOK_0]] Användarnamn (e-post)',
            password: '[[TOK_0]] Lösenord',
            placeholder_keep: '(lämna tomt för att behålla befintligt)',
            credential_form_aria: '[[TOK_0]] legitimationsformulär',
            test_connection: 'Testa anslutningen',
            testing: 'Testar...',
            test_aria: 'Testa [[TOK_0]]-anslutningen',
            testing_aria: 'Testar anslutning',
            save_configuration: 'Spara konfiguration',
            saving: 'Sparar...',
            save_aria: 'Spara autentiseringsuppgifter',
            saving_aria: 'Sparar autentiseringsuppgifter',
            credentials_saved: '[[TOK_0]] användaruppgifter har sparats.',
            credentials_saving: '[[TOK_0]] användaruppgifter sparade. Laddar om konfigurationen...',
            credentials_save_failed: 'Det gick inte att spara användaruppgifter',
            client_id_required: 'Klient-ID och användarnamn krävs.',
            all_fields_required: 'Alla autentiseringsfält är obligatoriska.',
            email_heading: 'E-postmeddelanden',
            receive_emails: 'Ta emot e-postmeddelanden med skanningsrapporter',
            email_toggle_aria: 'Växla skanningsrapport e-postmeddelanden',
            only_on_change: 'Maila bara när riskstatus ändras',
            only_on_change_aria: 'Växla endast e-post vid förändring av riskstatus',
            emails_enabled: 'Genomsökning av e-postrapporter har aktiverats',
            emails_disabled: 'Skanna rapport e-postmeddelanden inaktiverad',
            only_change_on: 'Mailar endast om riskförändringar',
            only_change_off: 'Skickar e-post vid varje skanning',
            email_failed: 'Det gick inte att uppdatera e-postinställningen',
            email_settings_aria: 'Inställningar för e-postmeddelanden',
            loading_sr: 'Laddar övervakningsinställningar',
        },
        entity_types: {
            user: 'Användare',
            case: 'Fall',
            incident: 'Incident',
            assessment: 'Bedömning',
            vendor: 'Försäljare',
            consent: 'Samtycke',
            policy: 'Policy',
            data_map: 'Datakarta',
        },
        actions: {
            create: 'Skapa',
            update: 'Uppdatering',
            delete: 'Ta bort',
            view: 'Visa',
            export: 'Exportera',
            status_change: 'Statusändring',
        },
    },
    forms: {
        dashboard: {
            title: 'Formuläröversikt',
            total_templates: 'Totalt Antal Mallar',
            installed: 'Installerade',
            available: 'Tillgängliga',
            by_market: 'Per Marknad',
            back_dashboard: 'Tillbaka till instrumentpanel',
            browse_templates: 'Bläddra i mallar',
            catalog_coverage: 'Katalog Täckning',
            quick_start: 'Snabb Start',
            recent_instances: 'Senaste Instanser',
            total_instances: 'Totalt Instanser',
            fetch_failed: 'Kunde inte hämta instrumentpanelsdata.',
            no_instances: 'Inga instanser hittades.',
            form_metrics: 'Översikt av formulärmätvärden',
            templates_total: 'mallar totalt',
            instances_total: 'instanser totalt',
            installed_of_available: '[[TOK_2]] av [[TOK_3]] installerade',
            templates_in_category: 'mallar i {category}',
        },
        templates: {
            title: 'Formulärmallar',
            new: 'Ny Mall',
            edit: 'Redigera Mall',
            name: 'Mallnamn',
            form_type: 'Formulärtyp',
            market: 'Marknad',
            language: 'Språk',
            schema: 'Formulärschema',
            preview: 'Förhandsgranska',
            duplicate: 'Duplicera Mall',
            grid_view: 'Rutnät Visa',
            list_view: 'Lista Visa',
            fetch_failed: 'Kunde inte hämta mallar.',
            filter_templates: 'Filtrera mallar',
            version_history: 'Versionshistorik',
            no_version_history: 'Ingen versionshistorik — detta är den ursprungliga versionen.',
            form_id: 'Formulär-ID',
            source_instrument: 'Källinstrument',
            issuer: 'Utfärdare',
            all_frameworks: 'Alla ramverk',
            view_mode: 'Visningsläge',
        },
        catalog: {
            title: 'Formulärkatalog',
            install: 'Installera',
            uninstall: 'Avinstallera',
            install_all: 'Installera Alla',
            installed_tab: 'Installerade',
            catalog_tab: 'Katalog',
            search_placeholder: 'Sök mallar...',
            no_templates: 'Inga mallar hittades.',
            template_count: '{count} mallar',
            all_markets: 'Alla Marknader',
            sections: 'Avsnitt',
            all_categories: 'Alla Kategorier',
            category: 'Kategori',
            category_install_failed: 'Kunde inte installera kategorimallar.',
            category_install_success: 'Kategori mallar installerade.',
            fetch_failed: 'Kunde inte hämta mallar.',
            fetch_installed_failed: 'Kunde inte hämta installerade mallar.',
            fields: 'Fält',
            install_failed: 'Kunde inte installera mall.',
            install_success: 'Mall installerad.',
            installing: 'Installerar...',
            removing: 'Tar bort...',
            uninstall_confirm: 'Är du säker på att du vill avinstallera denna mall?',
            uninstall_failed: 'Kunde inte avinstallera mall.',
            uninstall_success: 'Mall avinstallerad.',
            installation_summary: 'Installationsöversikt',
            filter_catalog: 'Filtrera katalog',
            all_frameworks: 'Alla ramverk',
            templates_installed_count: '[[TOK_1]] mallar har installerats',
            all_already_installed: 'Alla mallar i denna kategori är redan installerade',
            form_id: 'Formulär-ID',
            issuer: 'Utfärdare',
            catalog_tabs: 'Formulärkatalogens flikar',
        },
        filler: {
            back_templates: 'Tillbaka till mallar',
            no_sections: 'Inga avsnitt hittades.',
            draft_created: 'Utkast skapad.',
            draft_saved: 'Utkast sparat.',
            fetch_template_failed: 'Kunde inte hämta mall.',
            save_draft: 'Spara Utkast',
            save_draft_failed: 'Kunde inte spara utkast.',
            saving: 'Sparar...',
            select_option: 'Välj an alternativ',
            submit: 'Skicka in',
            submit_failed: 'Kunde inte skicka in.',
            submitting: 'Skickar in...',
            title: 'Formulärguide',
            form_id_label: 'Formulär-ID',
            schema_label: 'Schema',
            framework_label: 'Ramverk',
            issuer_label: 'Utfärdare',
            source_label: 'Källa',
            market_label: 'Marknad',
            section_of: 'Avsnitt {current} av {total}',
            form_navigation: 'Formulärnavigering',
            form_progress: 'Formulärframsteg: Avsnitt {current} av {total}',
            removed_item: 'Objekt {index} borttaget från {field}',
            added_item: 'Nytt objekt tillagt i {field}',
            go_to_previous: 'Gå till föregående avsnitt, avsnitt {current} av {total}',
            go_to_next: 'Gå till nästa avsnitt, avsnitt {current} av {total}',
            risk_matrix_placeholder: '1–5',
        },
        filing: {
            title: 'Inlämningsstatus',
            advance: 'Uppdatera inlämningsstatus...',
            not_started: 'Ej påbörjad',
            drafting: 'Utkast',
            internal_review: 'Intern granskning',
            approved_for_submission: 'Godkänd för inlämning',
            submitted_to_authority: 'Insänd till myndighet',
            supplement_requested: 'Komplettering begärd',
            supplement_in_progress: 'Komplettering pågår',
            resubmitted: 'Återinsänd',
            accepted: 'Godkänd',
            rejected: 'Avvisad',
            closed: 'Stängd',
        },
        instances: {
            approved_by: 'Godkänd av',
            form_answers: 'Formulär Svar',
            no_answers: 'Inga svar hittades.',
            view_outputs: 'Visa Utdata',
            approve: 'Godkänn',
            approve_failed: 'Kunde inte godkänna.',
            approving: 'Godkänner...',
            detail_title: 'Instans Detalj',
            fetch_failed: 'Kunde inte hämta instanser.',
            generate_failed: 'Kunde inte generera utdata.',
            generate_output: 'Generera Utdata',
            generating: 'Genererar...',
            submitted_at: 'Inskickad At',
            instance_metadata: 'Formulärinstansens metadata',
            filing_status_steps: 'Arkiveringsstatus-steg',
            current_status: 'aktuell status',
            filing_status_update_failed: 'Kunde inte uppdatera inlämningsstatus',
        },
        outputs: {
            back_instance: 'Tillbaka to Instans',
            no_outputs_msg: 'Inga utdata har genererats ännu.',
            no_outputs_title: 'Inga utdata',
            output_name: 'Utdata Namn',
            download: 'Ladda ner',
            download_failed: 'Kunde inte ladda ner.',
            fetch_failed: 'Kunde inte hämta utdata.',
            format: 'Filformat',
            generated_at: 'Genererad Vid',
            generated_by: 'Genererad Per',
            size: 'Storlek',
            title: 'Formulär Utdata',
            print: 'Skriv ut',
            print_outputs: 'Skriv ut formulärutdata',
            printing: 'Skriver ut formulärutdata',
            pdf_preview: 'PDF-förhandsgranskning',
            downloading: 'Laddar ner {name}',
            preview_in_new_window: 'Förhandsgranska {name} ({format}) i nytt fönster',
        },
        cybersec_domains: {
            scope: 'Omfattning och tillämplighet',
            risk: 'Riskbedömning och kontrollkartläggning',
            policy: 'Organisatoriska säkerhetspolicyer',
            localization: 'Datalokalisering och lokal närvaro',
            vendor: 'Tredjeparter och leveranskedja',
            authority: 'Hantering av myndighetsförfrågningar',
            incident: 'Incidenthantering och bevisning',
            training: 'Utbildning och beredskap',
        },
        market_finalization_domains: {
            data_law: 'Datalag — Styrning och Operativa Kontroller',
            pdpl_2025: 'PDPL 2025 — Integritetsstyrning och Registrerades Rättigheter',
            decree_356: 'Förordning 356/2025 — Leverantörs- och Gränsöverskridande Kontroller',
            telecom: 'Telekomlag — Sekretess och Myndighetsförfrågningar',
        },
        nav: {
            filing_case_links: 'Ärendelänkar',
            section_routing: 'Sektionsdirigering',
            submission_packages: 'Inlämningspaket',
        },
        filing_case_links: {
            title: 'Ärendelänkar',
            link_form: 'Länka formulär till ärende',
            filing_case_type: 'Ärendetyp',
            form_instance: 'Formulärinstans',
            select_form_instance: 'Välj en formulärinstans...',
            select_filing_case: 'Välj ett ärende...',
            no_links_found: 'Inga ärendelänkar hittades.',
            linked: 'Länkad',
            filing_case_id: 'Arkiveringsärende-ID',
            link_created: 'Arkiveringsärende-länk skapad',
            link_deleted: 'Ärendelänk borttagen',
            aria_delete_link: 'Ta bort länk {name}',
            case_type_dpia_dossier: 'DPIA-dossier',
            case_type_cross_border_filing: 'Gränsöverskridande arkivering',
            case_type_breach_notification: 'Incidentanmälan',
            no_instances_guidance: 'Inga formulärinstanser ännu. Skapa en från Formulärmallar.',
            no_filings_guidance: 'Inga arkiveringsärenden ännu. Skapa ett från Bedömningar.',
        },
        section_routing: {
            title: 'Sektionsdirigering',
            assign_section: 'Tilldela sektion',
            department: 'Avdelning',
            select_department: 'Välj en avdelning...',
            assignee: 'Tilldelad',
            select_assignee: 'Välj en tilldelad...',
            section: 'Sektion',
            select_section: 'Välj en sektion...',
            select_form_instance: 'Välj en formulärinstans...',
            no_assignments_found: 'Inga sektionstilldelningar hittades.',
            select_instance_prompt: 'Välj en formulärinstans för att visa sektionstilldelningar.',
            complete_section: 'Slutför sektion',
            status_pending: 'Väntande',
            status_in_progress: 'Pågående',
            status_completed: 'Slutförd',
            status_reviewed: 'Granskad',
            form_instance_id: 'Formulärinstans-ID',
            assignment_created: 'Avsnittsstilldelning skapad',
            assignment_deleted: 'Sektionstilldelning borttagen',
            status_updated: 'Avsnittsstatus uppdaterad',
            aria_delete_assignment: 'Ta bort tilldelning {name}',
            deadline: 'Tidsfrist',
            deadline_help: 'Valfritt. Tilldelningar efter detta datum visas som försenade.',
            overdue: 'Försenad',
            days_remaining: 'dagar kvar',
            approval_requested: 'Inskickad för granskning',
            form_approved: 'Formulär godkänt',
            form_rejected: 'Formulär avvisat',
            no_departments_guidance: 'Inga avdelningar konfigurerade. Ställ in i Organisationsinställningar.',
            no_sections_guidance: 'Inga sektioner definierade i mallen. Se till att formulärmallen har sektioner.',
            select_instance_first: 'Välj en formulärinstans först för att ladda tillgängliga sektioner.',
        },
        submission_packages: {
            title: 'Inlämningspaket',
            assemble_package: 'Sammanställ inlämningspaket',
            dossier: 'Dokumentation',
            select_dossier: 'Välj en dossier...',
            package_label: 'Paketetikett',
            cover_letter: 'Följebrev',
            checklist: 'Checklista',
            evidence_index: 'Bevisindex',
            completeness: 'Fullständighet',
            incomplete_warning: 'Kan inte sammanställa: formuläret har ofullständiga sektioner.',
            no_packages_found: 'Inga inlämningspaket hittades.',
            version: 'Version',
            package_assembled: 'Inlämningspaket sammanställt',
            package_deleted: 'Inlämningspaket borttaget',
            aria_delete_package: 'Ta bort paket {name}',
            status_draft: 'Utkast',
            status_complete: 'Fullständig',
            status_submitted: 'Inskickad',
            status_accepted: 'Godkänd',
            status_rejected: 'Avvisad',
            package_updated: 'Inlämningspaket uppdaterat',
            document_generated: 'Dokument genererat',
            documents: 'Dokument',
            generate: 'Generera',
            preview: 'Förhandsgranska',
            download: 'Ladda ner',
            download_all: 'Ladda ner alla',
            no_dossiers_guidance: 'Inga dossier ännu. Skapa ett från Bedömningar.',
            package_plan_help: 'Inkludera i paketplanen (automatisk dokumentgenerering tillgänglig):',
            cover_letter_help: 'Officiellt följebrev adresserat till den mottagande myndigheten',
            checklist_help: 'Efterlevnadschecklista som verifierar att alla inlämningskrav är uppfyllda',
            evidence_index_help: 'Index över stöddokument som refereras i inlämningen',
            completeness_skipped: 'Fullständighetskontroll överhoppad — ingen formulärinstans kopplad till detta dossier.',
            completeness_unavailable: 'Fullständighetskontroll ej tillgänglig — fortsätter med paketsammansättning.',
            duplicate_package_error: 'Ett inlämningspaket finns redan för detta dossier.',
            doc_cover_letter: 'Följebrev',
            doc_checklist: 'Checklista',
            doc_evidence_index: 'Bevisindex',
            export_csv: 'Exportera CSV',
            export_success: 'Länkar till arkiveringsärenden exporterade framgångsrikt',
            no_assignments_guidance: 'Inga avsnittsstilldelningar ännu. Tilldela avsnitt till avdelningar och teammedlemmar för att påbörja dirigering.',
        },
        template_picker: {
            title: 'Välj en mall',
            hint: 'Välj en regulatorisk formulärmall eller börja med ett tomt formulär.',
            market_filter: 'Filtrera efter marknad',
            framework_filter: 'Filtrera efter ramverk',
            all_markets: 'Alla marknader',
            all_frameworks: 'Alla ramverk',
            search_placeholder: 'Sök mallar...',
            blank_form: 'Tomt / generiskt formulär',
            blank_form_desc: 'Skapa utan mall — fyll i fält manuellt.',
            no_templates: 'Inga mallar hittades för detta filter.',
            select: 'Välj',
            link_error: 'Mallkoppling misslyckades — du kan länka en mall senare från Redigeringsvyn.',
            internal_badge: 'Intern mall',
            legacy_badge: 'Föråldrad',
            draft_badge: 'Utkast',
            upcoming_badge: 'Kommande',
            hidden_badge: 'Dold',
            show_hidden_toggle: 'Visa dolda / föråldrade mallar',
            show_hidden_toggle_hint: 'Administratörsvy: inkluderar mallar markerade som internal_only, hidden, legacy eller draft.',
        },
        cover_letter_modal: {
            title: 'Följebrev: förhandsgranskning och redigering',
            iframe_title: 'Förhandsgranskning av följebrev',
            stage_label: 'Steg',
            stage_initial: 'Första inlämning',
            stage_supplement: 'Kompletterande svar',
            stage_resubmission: 'Återinlämning',
            subject_label: 'Ämne',
            body_label: 'Huvudstycke',
            notes_label: 'Ytterligare anteckningar',
            refresh_preview: 'Uppdatera förhandsgranskning',
            confirm: 'Bekräfta och spara',
            regenerate: 'Generera igen',
            snapshot_saved: 'Följebrev sparat',
        },
        related_panel: {
            title: 'Relaterade regelformulär',
            open_form: 'Fyll i formulär',
            no_forms: 'Inga relaterade formulär hittades.',
            hint_vn: 'VN-specifika regelformulär tillgängliga — välj ett formulär för att öppna efterlevnadsguiden.',
            internal_badge: 'Intern',
            official_badge: 'Officiell',
            loading: 'Laddar relaterade formulär...',
            error: 'Kunde inte ladda relaterade formulär.',
            form_id: 'Formulär-ID',
            form_name: 'Formulärnamn',
            framework: 'Regelverk',
        },
        view_form: 'Visa formulär',
        edit_form: 'Redigera formulär',
        save_draft: 'Spara utkast',
        module_settings: 'Modulinställningar',
        validation_errors: 'Åtgärda valideringsfelen',
        custom_name_help: 'Valfritt — standard är mallens namn om tomt',
        select_placeholder: 'Välj...',
        previous_section: 'Föregående',
        next_section: 'Nästa',
        loading: 'Laddar...',
        array_add: 'Lägg till',
        array_remove: 'Ta bort',
        array_item_label: '{label} post {index}',
        array_add_item: 'Lägg till post i {label}',
        array_remove_item: 'Ta bort post {index} från {label}',
        legacy_banner: 'Den här posten skapades innan enhetliga formulär. Vissa data kan skilja sig mellan entiteten och formulärinstansen.',
        field_required: '{label} är obligatoriskt',
        section_announcement: 'Avsnitt [[TOK_3]] av [[TOK_4]]: [[TOK_5]]',
        sections_nav_label: 'Formulärsektioner',
        no_sections: 'Inga mallsektioner tillgängliga.',
        section_label_tpl: 'Avsnitt [[TOK_2]]: [[TOK_3]]',
        module_settings_auto_applied: 'Modulspecifika inställningar tillämpas automatiskt.',
        operation_failed: 'Åtgärden misslyckades',
        failed_to_load_form: 'Det gick inte att läsa in formuläret',
        failed_to_save_form: 'Det gick inte att spara formuläret',
        failed_to_submit_form: 'Det gick inte att skicka in formuläret',
        failed_to_load_template: 'Det gick inte att läsa in mallen',
        failed_to_save_draft: 'Det gick inte att spara utkastet',
        failed_to_create: 'Det gick inte att skapa',
    },
    pack_catalog: {
        title: 'Paketkatalog',
        install: 'Installera Paket',
        uninstall: 'Avinstallera Paket',
        install_batch: 'Installera Kluster',
        installed_tab: 'Installerade',
        catalog_tab: 'Katalog',
        pack_details: 'Paketdetaljer',
        frameworks: 'Ramverk',
        requirements: 'Krav',
        artifacts: 'Artefakter',
        language_pack: 'Språkpaket',
        dependencies: 'Beroenden',
        no_packs: 'Inga paket hittades.',
    },
    platform_pages: {
        users: {
            title: 'Användare',
            new: 'Ny Användare',
            invite: 'Bjud in Användare',
            edit: 'Redigera Användare',
            name: 'Namn',
            email: 'E-post',
            role: 'Roll',
            status: 'Tillstånd',
            identity_type: 'Identitetstyp',
            last_login: 'Senaste Inloggning',
            deactivate: 'Inaktivera',
            reactivate: 'Återaktivera',
            unlock: 'Lås upp',
            reset_password: 'Återställ Lösenord',
            remove: 'Ta bort',
            remove_confirm: 'Ta bort "{name}"? Denna åtgärd är permanent och användaren förlorar all åtkomst. Posten behålls för revisionsändamål.',
        },
        roles: {
            title: 'Roller',
            new: 'Ny Roll',
            edit: 'Redigera Roll',
            name: 'Rollnamn',
            description: 'Beskrivning',
            permissions: 'Behörigheter',
            users_count: 'Användare',
            detail: 'Rolldetaljer',
            all_tiers: 'Alla nivåer',
            role_name_placeholder: 't.ex. regional efterlevnadschef',
        },
        profile: {
            title: 'Min Profil',
            name: 'Namn',
            display_name: 'Visningsnamn',
            email: 'E-post',
            phone: 'Telefon',
            department: 'Avdelning',
            job_title: 'Befattning',
            language: 'Språk',
            role: 'Roll',
            persona: 'Identifierad persona',
            last_login: 'Senaste Inloggning',
            save: 'Spara ändringar',
            save_success: 'Profilen har uppdaterats',
            module_tips_section: 'Modultips',
            tips_toggle: 'Visa regulatoriska tips i moduler',
            dismissed_tips: 'Avvisade tips',
            reset_dismissed: 'Återställ alla avvisade tips',
            notification_prefs: 'Aviseringsinställningar',
            notification_prefs_link: 'Hantera aviseringsinställningar →',
            change_password: 'Ändra Lösenord',
            current_password: 'Nuvarande Lösenord',
            new_password: 'Nytt Lösenord',
            confirm_password: 'Bekräfta Lösenord',
            accessibility: 'Tillganglighet',
            high_contrast: 'Hogkontrastlage',
            high_contrast_desc: 'Oka kontrasten for battre lasbarhet. Uppfyller WCAG 2.1 AAA.',
            passwords_no_match: 'Lösenorden matchar inte',
            password_changed_logout: 'Lösenord ändrat. Du loggas ut.',
            failed_update: 'Kunde inte uppdatera profilen',
            failed_change_password: 'Kunde inte ändra lösenord',
            none: 'Ingen',
            never: 'Aldrig',
            password_requirements: 'Min. 12 tecken, versal, gemen, siffra, specialtecken',
        },
        security: {
            mfa_title: 'MFA-inställningar',
            mfa_enable: 'Aktivera MFA',
            mfa_disable: 'Inaktivera MFA',
            mfa_setup: 'Skanna denna QR-kod med din autentiseringsapp',
            sso_title: 'SSO-konfiguration',
            sso_provider: 'Leverantör',
            sso_client_id: 'Klient-ID',
            sso_redirect: 'Omdirigerings-URI',
            api_keys_title: 'API-nycklar',
            api_keys_new: 'Ny API-nyckel',
            api_keys_name: 'Nyckelnamn',
            api_keys_last_used: 'Senast Använd',
            api_keys_expires: 'Utgår',
            api_keys_revoke: 'Återkalla',
            service_accounts_title: 'Tjänstekonton',
            ip_allowlist_title: 'IP-vitlista',
            ip_add: 'Lägg till IP-adress',
            ip_address: 'IP-adress',
            ip_description: 'Beskrivning',
            delegations_title: 'Delegeringar',
            delegations_new: 'Ny Delegering',
            delegations_from: 'Från Användare',
            delegations_to: 'Till Användare',
            delegations_expires: 'Utgår',
            break_glass_title: 'Nödåtkomst',
            break_glass_request: 'Begär Åtkomst',
            break_glass_reason: 'Anledning till Åtkomst',
            break_glass_duration: 'Varaktighet',
            session_settings_title: 'Sessionsinställningar',
            session_timeout: 'Sessionstimeout (minuter)',
            session_max_concurrent: 'Max Samtida Sessioner',
            active_sessions_title: 'Aktiva Sessioner',
            active_sessions_device: 'Enhet',
            active_sessions_ip: 'IP-adress',
            active_sessions_started: 'Startad',
            active_sessions_revoke: 'Återkalla Session',
            active_sessions_confirm_terminate: 'Är du säker på att du vill avsluta den här sessionen?',
            active_sessions_confirm_terminate_current: 'Det här är din nuvarande session. Om du avslutar det loggas du ut omedelbart. Fortsätta?',
            active_sessions_confirm_terminate_all: 'Är du säker på att du vill avsluta alla andra sessioner? Endast din nuvarande session kommer att förbli aktiv.',
            active_sessions_terminated: 'Sessionen avslutades.',
            active_sessions_all_terminated: 'Alla andra sessioner har avslutats.',
            active_sessions_terminate_all: 'Avsluta alla andra sessioner',
            active_sessions_last_activity: 'Senaste aktivitet',
            active_sessions_current: 'Aktuell session',
            active_sessions_revoke_selected: 'Återkalla valda',
            active_sessions_confirm_terminate_selected: 'Är du säker på att du vill avsluta de valda sessionerna?',
            active_sessions_selected_terminated: 'Valda sessioner avslutade.',
            ip_allowlist_desc: 'Hantera tillåtna IP-adresser för [[TOK_0]] åtkomst.',
            ip_no_entries: 'Inga IP-adresser har konfigurerats.',
            session_settings_desc: 'Konfigurera sessionstimeout och gränser för samtidiga sessioner.',
            session_settings_save_policy: 'Spara sessionspolicy',
            session_settings_saved: 'Sessionsinställningarna har uppdaterats.',
            session_settings_idle_timeout: 'Timeout för inaktivitet (minuter)',
            session_settings_absolute_timeout: 'Absolut timeout (minuter)',
            session_settings_help_idle: 'Sessionen kommer att upphöra efter denna period av inaktivitet.',
            session_settings_help_absolute: 'Sessionen kommer att upphöra efter denna totala varaktighet oavsett aktivitet.',
            session_settings_help_max: 'Maximalt antal samtidiga sessioner per användare.',
            sso_note: 'Ändringar av SSO-konfigurationen kan kräva att användarna autentiseras på nytt.',
            service_accounts_warning: 'Denna [[TOK_0]]-nyckel kommer bara att visas en gång. Kopiera det nu och förvara det säkert.',
            service_accounts_new: 'Nytt servicekonto',
            service_accounts_name: 'Kontonamn',
            service_accounts_role: 'Roll',
            service_accounts_created: 'Skapad',
            service_accounts_desc: 'Hantera maskin-till-maskin-tjänstkonton för [[TOK_0]] integrationer.',
            break_glass_warning: 'Kross-glasåtkomst granskas och loggas. Använd endast för äkta nödsituationer.',
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] minsta tecken',
            break_glass_permission_count: '[[TOK_1]] behörighet(er) har valts',
            break_glass_submitted: 'Begäran om krossat glas har lämnats in. Väntar på godkännande.',
            break_glass_approved: 'Begäran om krossat glas godkänd.',
            break_glass_denied: 'Begäran om krossning avslogs.',
            break_glass_confirm_activate: 'Godkänna denna begäran om krossat glas? Detta kommer att ge nödåtkomst omedelbart.',
            break_glass_confirm_title: 'Bekräfta aktivering',
            break_glass_pending: 'Väntande förfrågningar',
            break_glass_active_sessions: 'Aktiva Break-Glass-sessioner',
            break_glass_time_remaining: 'Återstående tid',
            break_glass_expired: 'Utgått',
            break_glass_approved_denied_by: 'Godkänd/Nejad av',
            delegations_desc: 'Hantera tillfälliga behörighetsdelegationer mellan användare.',
            delegations_my: 'Mina delegationer',
            delegations_to_me: 'Delegerad till mig',
            delegations_scope_all: 'Alla behörigheter',
            delegations_scope_specific: 'Specifika behörigheter',
            delegations_created: 'Delegationen har skapats.',
            delegations_revoked: 'Delegationen återkallad.',
            delegations_confirm_revoke: 'Är du säker på att du vill återkalla denna delegering?',
            delegations_confirm_revoke_title: 'Bekräfta återkalla',
            delegations_permission_count: '[[TOK_1]] behörighet(er)',
            api_keys_status: 'Status',
            api_keys_prefix: 'Nyckelprefix',
            api_keys_permissions_count: 'Behörigheter',
            api_keys_ip_count: 'IP-begränsningar',
            api_keys_created: 'Skapad',
            api_keys_confirm_revoke_title: 'Bekräfta återkalla',
            api_keys_confirm_revoke_message: 'Är du säker på att du vill återkalla [[TOK_2]]-tangenten "[[TOK_1]]"? Denna åtgärd kan inte ångras.',
            api_keys_confirm_rotate_title: 'Bekräfta rotation',
            api_keys_confirm_rotate_message: 'Är du säker på att du vill rotera [[TOK_2]]-tangenten "[[TOK_1]]"? Den aktuella nyckeln slutar fungera omedelbart.',
            api_keys_created_success: 'Nyckeln [[TOK_0]] skapades framgångsrikt.',
            api_keys_revoked_success: '[[TOK_2]]-tangenten "[[TOK_1]]" har återkallats.',
            api_keys_rotated_success: '[[TOK_2]]-tangenten "[[TOK_1]]" har roterats. Kopiera den nya nyckeln nedan.',
            api_keys_load_error: 'Det gick inte att ladda [[TOK_0]] nycklar.',
            api_keys_create_error: 'Det gick inte att skapa nyckeln [[TOK_0]].',
            api_keys_revoke_error: 'Det gick inte att återkalla [[TOK_0]]-nyckeln.',
            api_keys_rotate_error: 'Det gick inte att rotera [[TOK_0]]-tangenten.',
            break_glass_duration_15: '15 minuter',
            break_glass_duration_30: '30 minuter',
            break_glass_duration_60: '60 minuter (1h)',
            break_glass_duration_120: '120 minuter (2h)',
            break_glass_duration_240: '240 minuter (4h)',
            sod_rules_title: 'Regler för arbetsuppdelning',
            sod_violations_report: 'Rapport om överträdelser',
            sod_create_rule: 'Skapa regel',
            sod_col_name: 'Namn',
            sod_col_description: 'Beskrivning',
            sod_col_conflict_count: 'Antal konflikter',
            sod_col_severity: 'Allvarlighet',
            sod_col_status: 'Status',
            sod_col_actions: 'Åtgärder',
            sod_no_rules: 'Inga SoD-regler hittades',
            sod_severity_warning: 'Varning',
            sod_severity_blocking: 'Blockering',
            sod_active: 'Aktiv',
            sod_inactive: 'Inaktiv',
            sod_edit: 'Redigera',
            sod_exceptions: 'Undantag',
            sod_deactivate: 'Inaktivera',
            sod_confirm_deactivate_title: 'Bekräfta avaktivering',
            sod_confirm_deactivate_message: 'Inaktivera regeln "[[TOK_1]]"? Det kommer inte längre att flagga överträdelser.',
            sod_deactivate_error: 'Det gick inte att inaktivera regeln',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: 'Åtkomstgranskningar',
            campaigns: 'Granskningskampanjer',
            new_campaign: 'Ny Kampanj',
            campaign_name: 'Kampanjnamn',
            scope: 'Omfattning',
            reviewers: 'Granskare',
            due_date: 'Förfallodatum',
            progress: 'Framsteg',
            my_reviews: 'Mina Granskningar',
            approve: 'Godkänn',
            revoke: 'Återkalla',
            analytics: 'Rollanalys',
            analytics_title: 'Rollanalys',
            permission_usage: 'Behörighetsanvändning',
            role_coverage: 'Rolltäckning',
            campaign_detail: 'Kampanjdetaljer',
            campaign_description: 'Beskrivning',
            campaign_status: 'Status',
            campaign_deadline: 'Deadline',
            campaign_scope_type: 'Omfattning Typ',
            campaign_completion: 'Slutförande',
            campaign_total_items: 'Totalt antal artiklar',
            campaign_pending_items: 'Väntar',
            campaign_confirmed_items: 'Bekräftad',
            campaign_revoked_items: 'Återkallad',
            campaign_escalated_items: 'Eskalerad',
            campaign_launch: 'Starta kampanj',
            campaign_cancel: 'Avbryt kampanj',
            campaign_confirm_launch: 'Är du säker på att du vill lansera den här kampanjen?',
            campaign_confirm_cancel: 'Är du säker på att du vill avbryta den här kampanjen?',
            campaign_launched: 'Kampanjen lanserades framgångsrikt.',
            campaign_cancelled: 'Kampanjen avbruten.',
            review_items: 'Granska objekt',
            review_item_user: 'Användare',
            review_item_role: 'Roll',
            review_item_reviewer: 'Recensent',
            review_item_decision: 'Beslut',
            review_item_justify: 'Motivering',
            review_item_confirm: 'Bekräfta',
            review_item_revoke: 'Återkalla',
            review_item_escalate: 'Eskalera',
            all_decisions: 'Alla beslut',
            bulk_action: 'Bulk Action',
            bulk_confirm: 'Massbekräfta',
            bulk_revoke: 'Bulk Revoke',
            selected_count: '[[TOK_1]] har valts',
            justify_required: 'Motivering krävs',
            scope_all_users: 'Alla användare',
            scope_role_owner: 'Rollägare',
            scope_department: 'Avdelning',
            back_to_campaigns: 'Tillbaka till Kampanjer',
            recommendations: 'Rekommendationer',
            refreshing: 'Uppfriskande...',
            decide: 'Bestäm dig',
            decision_by: 'Beslut av',
            loading_items: 'Laddar objekt...',
            loading_review_items: 'Laddar recensionsobjekt...',
            campaign_not_found: 'Kampanjen hittades inte',
            loading_campaign: 'Läser in kampanjinformation...',
            campaign_completed: 'Kampanjen slutfördes framgångsrikt.',
            confirm_cancel_title: 'Bekräfta Avbryt',
            justify_bulk_confirm: 'Motivering för bulkbekräftelse:',
            justify_bulk_revoke: 'Motivering för massåterkallelse:',
            items_selected: '[[TOK_1]] objekt(er) har valts',
            justify_bulk_required: 'Motivering krävs för bulkåtgärder',
            create_campaign_title: 'Skapa åtkomstgranskningskampanj',
            name_required: 'Namn krävs',
            scope_type_required: 'Omfattningstyp krävs',
            reviewer_strategy_required: 'Granskarestrategi krävs',
            deadline_required: 'Deadline krävs',
            reviewer_id_required: 'Granskare-ID krävs för specifik användarstrategi',
            invalid_json: 'Ogiltig [[TOK_0]]',
            scope_filter_label: 'Omfattningsfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Granskarestrategi',
            reviewer_id_label: 'Granskare-ID',
            deadline_label: 'Deadline',
            create_campaign_btn: 'Skapa kampanj',
            scope_type_label: 'Omfattning Typ',
            scope_by_role: 'Efter roll',
            scope_by_department: 'Efter avdelning',
            scope_custom: 'Anpassad',
            reviewer_manager: 'Chef',
            reviewer_specific_user: 'Specifik användare',
            enter_json_filter: 'Ange [[TOK_0]] filter',
            hint_label: 'Tips:',
            role_usage: 'Rollanvändning',
            over_privileged_users: 'Överprivilegierade användare',
            role_name_col: 'Rollnamn',
            assigned_users: 'Tilldelade användare',
            active_users_30d: 'Aktiva användare (30d)',
            total_perms: 'Total Perms',
            used_perms: 'Använd Perms',
            unused_perms: 'Oanvända Perms',
            no_data_available: 'Inga data tillgängliga',
            roles_col: 'Roller',
            total_col: 'Totalt',
            used_col: 'Används',
            unused_pct: 'Oanvänd %',
            current_count: 'Nuvarande räkning',
            recommended_count: 'Rekommenderad räkning',
            rationale: 'Motivering',
            loading_analytics: 'Läser in analys...',
            loading_role_analytics: 'Läser in rollanalysdata...',
            computed_at: 'Beräknat vid:',
            form_errors: 'Formuläret har [[TOK_1]] fel. Vänligen korrigera dem.',
            scope_filter_invalid_json: 'Omfattningsfiltret innehåller ogiltigt [[TOK_0]]',
            scope_hint_all_users: 'Inget filter behövs - alla användare kommer att inkluderas.',
            review_type_label: 'Granskningstyp',
            review_type_required: 'Granskningstyp krävs',
            reviewer_ids_label: 'Granskare-ID:n',
            reviewer_ids_hint: 'Ange användar-ID:n åtskilda med kommatecken',
            reviewer_ids_required: 'Minst ett granskare-ID krävs',
            start_date_label: 'Startdatum',
            start_date_required: 'Startdatum krävs',
            end_date_label: 'Slutdatum',
            end_date_required: 'Slutdatum krävs',
            review_type_user_access: 'Användaråtkomst',
            review_type_role_permissions: 'Rollbehörigheter',
            review_type_service_accounts: 'Tjänstekonton',
            review_type_privileged_access: 'Privilegierad åtkomst',
            review_type_application_access: 'Programåtkomst',
            auto_revoke_label: 'Återkalla automatiskt vid avslag',
            campaigns_title: 'Få åtkomst till granskningskampanjer',
            create_campaign_label: '+ Skapa kampanj',
            no_campaigns_found: 'Inga kampanjer hittades',
            loading_campaigns: 'Läser in kampanjer...',
            no_reviews_assigned: 'Inga recensioner har tilldelats dig',
            loading_reviews: 'Laddar recensioner...',
            review_decision_title: 'Granska beslut',
            justification_label: 'Motivering',
            announce_loaded_review_items: 'Laddade [[TOK_1]] recensionsobjekt',
            announce_loaded_campaigns: 'Laddade [[TOK_1]] kampanjer',
            announce_decision_submitted: 'Beslutet "[[TOK_1]]" har lämnats in för granskning',
            announce_decision_submitted_for: 'Beslutet "[TOK_2]] har lämnats för [[TOK_3]]',
            announce_bulk_decision: 'Bulk [[TOK_2]] tillämpas på [[TOK_3]] objekt',
        },
        attestation: {
            title: 'Attesteringsscheman',
            new: 'Nytt Schema',
            edit: 'Redigera Schema',
            create_title: 'Skapa attesteringsschema',
            edit_title: 'Redigera attesteringsschema',
            schedule_history: 'Schemahistorik',
            next_run_date: 'Nästa körningsdatum',
            schedule_name: 'Schemanamn',
            frequency: 'Frekvens',
            next_run: 'Nästa Körning',
            last_run: 'Senaste Körning',
            history: 'Attesteringshistorik',
            description: 'Beskrivning',
            scope: 'Omfattning',
            status: 'Status',
            created_at: 'Skapad',
            updated_at: 'Uppdaterad',
            trigger_now: 'Utlösa nu',
            back_to_schedules: 'Tillbaka till scheman',
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Schema utlöstes.',
            deleted: 'Schema raderat.',
            saved: 'Schema har sparats.',
            campaigns_generated: 'Genererade kampanjer',
            run_date: 'Kördatum',
            run_status: 'Körstatus',
            create_schedule: 'Skapa schema',
            view_history: 'Visa historik',
            deactivate: 'Inaktivera',
            overdue: 'OVERDUE',
            overdue_sr: 'Schemat är försenat',
            confirm_trigger_title: 'Bekräfta åtgärd',
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Bekräfta avaktivering',
            confirm_deactivate_message: 'Är du säker på att du vill inaktivera det här schemat?',
            triggered_success: 'Schema utlöstes.',
            deactivated_success: 'Schema avaktiverat.',
            name_label: 'Namn *',
            frequency_label: 'Frekvens *',
            scope_type_label: 'Omfattningstyp *',
            scope_filter_label: 'Omfattningsfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Granskarestrategi *',
            reviewer_id_label: 'Granskare-ID *',
            frequency_quarterly: 'Kvartalsvis',
            frequency_semi_annual: 'Halvårsvis',
            frequency_annual: 'Årlig',
            scope_all_users: 'Alla användare',
            scope_by_role: 'Efter roll',
            scope_by_department: 'Efter avdelning',
            scope_framework: 'Ramverk',
            scope_custom: 'Anpassad',
            reviewer_manager: 'Chef',
            reviewer_role_owner: 'Rollägare',
            reviewer_specific_user: 'Specifik användare',
            computed_next_run_date: 'Beräknat nästa körningsdatum',
            current_scheduled_date: 'Aktuellt planerat datum',
            recomputed_frequency_changed: '(omräknat -- frekvens ändrad)',
            estimated_days_hint: 'Beräknad baserat på [[TOK_1]] dagar från och med idag',
            validation_name_required: 'Namn krävs',
            validation_frequency_required: 'Frekvens krävs',
            validation_scope_type_required: 'Omfattningstyp krävs',
            validation_reviewer_strategy_required: 'Granskarestrategi krävs',
            validation_reviewer_id_required: 'Granskare-ID krävs för specifik användarstrategi',
            validation_invalid_json: 'Ogiltig [[TOK_0]]',
            validation_scope_filter_invalid_json: 'Omfattningsfiltret innehåller ogiltigt [[TOK_0]]',
            form_errors: 'Formuläret har [[TOK_1]] fel. Vänligen korrigera dem.',
            create_schedule_btn: 'Skapa schema',
            schedule_history_title: 'Schemalägg historik',
            campaign_name_col: 'Kampanjens namn',
            items_col: 'Föremål',
            no_campaigns_yet: 'Inga kampanjer har genererats ännu',
            loading_history: 'Laddar historik...',
            loading_schedule: 'Laddar schema...',
            total_campaigns: 'Totalt antal kampanjer: [[TOK_1]]',
            results_per_page: 'Resultat per sida',
            page_size_option: '[[TOK_1]] / sida',
        },
        sod: {
            title: 'Regler för Funktionsseparering',
            new: 'Ny Regel',
            edit: 'Redigera Regel',
            create_title: 'Skapa SoD-regel',
            edit_title: 'Redigera SoD-regel',
            rule_name: 'Regelnamn',
            conflicting_permissions: 'Motstridiga Behörigheter',
            permission_a: 'Behörighet A',
            permission_b: 'Behörighet B',
            violations: 'SoD-överträdelser',
            violation_user: 'Användare',
            violation_rule: 'Överträdd Regel',
            violation_date: 'Upptäckt Vid',
            exceptions: 'SoD-undantag',
            exception_reason: 'Undantagsanledning',
            exception_approver: 'Godkänd Av',
            exception_status: 'Undantagsstatus',
            has_exception: 'Har undantag',
            no_exception: 'Inget undantag',
            grant_exception: 'Bevilja undantag',
            granting: 'Beviljar...',
            grant_new_exception: 'Bevilja nytt undantag',
            exceptions_for: 'Undantag för: [[TOK_1]]',
            back_to_rules: 'Tillbaka till Regler',
            no_violations: 'Inga överträdelser hittades',
            no_exceptions_found: 'Inga undantag hittades för denna regel',
            all_exception_statuses: 'Alla undantagsstatusar',
            user_id_label: 'Användar-ID',
            justification_label: 'Motivering',
            compensating_controls_label: 'Kompenserande kontroller',
            expires_at_label: 'Går ut kl',
            granting_exception_for: 'Bevilja ett undantag för regel: [[TOK_1]]',
            severity: 'Allvarlighet',
            severity_warning: 'Varning',
            severity_blocking: 'Blockering',
            violation_count: '[[TOK_1]] överträdelser',
            exception_count: '[[TOK_1]] undantag(er)',
            rule_description: 'Beskrivning',
            confirm_delete: 'Är du säker på att du vill ta bort den här regeln?',
            deleted: 'Regel raderad.',
            framework_code: 'Regelverk',
            name_label: 'Namn *',
            severity_label: 'Allvarlighet *',
            conflict_pairs_legend: 'Konflikttillståndspar',
            conflict_pairs_hint: 'Varje par definierar två behörigheter som inte ska innehas av samma användare.',
            placeholder_permission_a: '-- Tillstånd A --',
            placeholder_permission_b: '-- Tillstånd B --',
            permission_a_for_pair: 'Behörighet A för paret [[TOK_1]]',
            permission_b_for_pair: 'Behörighet B för paret [[TOK_1]]',
            conflict_pair_label: 'Konfliktpar [[TOK_1]]',
            remove_conflict_pair: 'Ta bort konfliktpar [[TOK_1]]',
            add_pair: '+ Lägg till par',
            placeholder_name: 't.ex. Betalningsgodkännande Separation',
            create_rule: 'Skapa regel',
            loading_rule: 'Laddar SoD-regel...',
            failed_load_rule: 'Det gick inte att läsa in regeln.',
            failed_create_rule: 'Det gick inte att skapa SoD-regeln.',
            failed_update_rule: 'Det gick inte att uppdatera SoD-regeln.',
            validation_name_required: 'Namn krävs.',
            validation_pair_required: 'Minst ett konfliktbehörighetspar krävs.',
            validation_pair_both_required: 'Par [[TOK_1]]: Båda behörigheterna måste väljas.',
            validation_pair_must_differ: 'Par [[TOK_1]]: Behörighet A och Behörighet B måste vara olika.',
            added_conflict_pair: 'Lade till konfliktpar [[TOK_1]]',
            removed_conflict_pair: 'Tog bort konfliktpar [[TOK_1]]',
            announce_loaded_violations: 'Laddade [[TOK_1]] överträdelser',
            announce_loaded_exceptions: 'Laddade [[TOK_1]] undantag',
            announce_loaded_rules: 'Laddade [[TOK_1]] SoD-regler',
            announce_loading_exceptions: 'Läser in undantag...',
            regulatory_info: {
                sod_context: 'SoD-regler tillaempar den regelverksmaessiga rollseparation som kraevs av PDPL. Oevertradelser kopplade till en framework_code kan inkluderas i ramverksspecifika bevispaketer (UC-VN-09).',
                violation_export_context: 'SoD-oevertradelsexporter inkluderar framework_code, motstridiga roller, allvarlighetsgrad, skapare och detektionstidpunkt foer bevispaketer (P-VN-10).',
                exception_context: 'SoD-undantag producerar revisionsdokumentation: godkaennare, motivering, kompenserande kontroller och foerfallodatum. Foerfallna undantag foerblir synliga (UC-VN-09 Steg 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'CMP-integration',
            status: 'Anslutningsstatus',
            endpoint: 'CMP-slutpunkt',
            last_sync: 'Senaste Synkronisering',
            configure: 'Konfigurera',
        },
        purpose_mapping: {
            title: 'Ändamålskoppling',
            cmp_purpose: 'CMP-ändamål',
            grc_purpose: 'GRC-ändamål',
            mapping_status: 'Kopplingsstatus',
            auto_map: 'Automatisk Koppling',
            new_mapping: 'Ny Koppling',
        },
        webhook: {
            title: 'Webhook-konfiguration',
            webhook_url: 'Webhook-URL',
            secret: 'Webhook-hemlighet',
            events: 'Händelsetyper',
            test_webhook: 'Testa Webhook',
        },
        bulk_sync: {
            title: 'Masssynkronisering',
            sync_now: 'Synkronisera Nu',
            last_run: 'Senaste Körning',
            records_synced: 'Synkroniserade Poster',
            sync_history: 'Synkroniseringshistorik',
            syncing: 'Synkroniserar...',
        },
        sync_settings: {
            sync_failures: 'Synkronisering Fel',
            sync_secret_warning: 'Synkroniseringshemlighet (spara detta nu — det visas inte igen):',
            push_description: 'Konfigurera GRC Suite för att skicka ärendestatusuppdateringar till AesirX CMP.',
            technical_description: 'Den här konfigurationen styr hur GRC Suite skickar ärendestatusuppdateringar till [[TOK_1]] [[TOK_0]].',
            direction_label: 'Riktning',
            direction_value: 'GRC Suite → AesirX CMP (utgående)',
            auth_label: 'Autentisering',
            auth_value: 'HMAC-SHA256-signatur i X-GRC-Signature-huvud',
            retry_label: 'Omförsök Policy',
            retry_value: '3 omförsök med exponentiell fördröjning (30s, 2min, 10min)',
            inbound_label: 'Inkommande Konfiguration',
            inbound_value: 'Inkommande webhook (CMP → GRC) är konfigurerad i',
            cmp_webhook_settings: 'CMP Webhook Inställningar',
            page_title: 'CMP Synkroniseringsinställningar',
            outbound_sync_configured: 'Utgående synkronisering konfigurerad.',
            configure_sync_failed: 'Kunde inte konfigurera synkronisering',
            configuration_updated: 'Konfiguration uppdaterad.',
            update_configuration_failed: 'Kunde inte uppdatera konfiguration',
            connection_test_failed: 'Anslutningstest misslyckades',
            test_result_message: 'Test skickat till {endpoint}. Status: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Ny → Under granskning (tilldelad)',
                under_review_to_identity_verification: 'Under granskning → Identitetsverifiering',
                under_review_to_in_progress: 'Under granskning → Pågående',
                in_progress_to_completed: 'Pågående → Slutförd',
                in_progress_to_denied: 'Pågående → Avslagen',
                any_to_closed: 'Alla → Stängd',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhookar',
            new: 'Ny Webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Händelser',
            secret: 'Hemlighet',
            active: 'Aktiv',
            test: 'Testa',
            create_failed: 'Kunde inte skapa webhook.',
            create_success: 'Webhook skapad.',
            deactivate_failed: 'Kunde inte inaktivera webhook.',
            deactivate_success: 'Webhook avaktiverad.',
            fetch_failed: 'Kunde inte hämta webhooks.',
            send_test_failed: 'Kunde inte skicka test.',
            test_failed: 'Webhook test misslyckade.',
            test_success: 'Webhook-test lyckades.',
            edit_title: 'Redigera webhook',
            announce_loaded: 'Webhookar laddade',
            update_success: 'Webhook uppdaterad.',
            update_failed: 'Kunde inte uppdatera webhook.',
            activate_success: 'Webhook aktiverad.',
            activate_failed: 'Kunde inte aktivera webhook.',
        },
        domains: {
            title: 'Domäner',
            new: 'Ny Domän',
            domain_name: 'Domännamn',
            verified: 'Verifierad',
            verify: 'Verifiera',
            add_failed: 'Kunde inte lägga till domän.',
            add_success: 'Domän tillagd.',
            domain_placeholder: 't.ex. grc.example.com',
            fetch_failed: 'Kunde inte hämta domäner.',
            remove_failed: 'Kunde inte ta bort domän.',
            remove_success: 'Domän borttagen.',
            txt_record: 'TXT Post',
            verify_dns_failed: 'DNS verifiering misslyckade.',
            verify_failed: 'Kunde inte verifiera domän.',
            verify_success: 'Domän verifierad.',
        },
        export_schedules: {
            title: 'Exportscheman',
            new: 'Nytt Schema',
            schedule_name: 'Namn',
            frequency: 'Frekvens',
            format: 'Filformat',
            last_run: 'Senaste Körning',
            next_run: 'Nästa Körning',
            create_failed: 'Kunde inte skapa schema.',
            create_success: 'Schema skapat.',
            day_of_month: 'Dag i månaden',
            day_of_week: 'Dag av Vecka',
            deactivate_failed: 'Kunde inte inaktivera schema.',
            deactivate_success: 'Schema inaktiverat.',
            fetch_failed: 'Kunde inte hämta scheman.',
            freq_daily: 'Dagligen',
            freq_monthly: 'Månadsvis',
            freq_weekly: 'Veckovis',
            recipients: 'Mottagare',
            time_utc: 'Tid (UTC)',
            trigger_failed: 'Kunde inte utlösa export.',
            trigger_success: 'Export utlöst.',
            type_audit_trail: 'Revision Spår',
            type_compliance_report: 'Efterlevnad Rapport',
            type_custom: 'Anpassad',
            type_incident_report: 'Incident Rapport',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: 'E-postlogg',
            recipient: 'Mottagare',
            subject: 'Ämne',
            sent_at: 'Skickad Vid',
            status: 'Tillstånd',
            resend: 'Skicka Igen',
            fetch_failed: 'Kunde inte hämta e-postloggar.',
        },
    },
    organizations: {
        title: 'Organisationer',
        create: 'Skapa Organisation',
        edit: 'Redigera Organisation',
        name: 'Namn',
        slug: 'Identifierare',
        timezone: 'Tidszon',
        locale: 'Standard Språkinställning',
        parent: 'Överordnad Organisation',
        group: 'Grupp',
        org_group: 'Organisationsgrupp',
        no_group: '(Ingen - inte i en grupp)',
        created: 'Skapad',
        no_parent: '(Ingen - fristående)',
        no_orgs: 'Inga organisationer hittades',
        load_error: 'Kunde inte ladda organisationer',
        save_error: 'Kunde inte spara organisation',
        created_msg: 'Organisation skapad',
        updated: 'Organisation uppdaterad',
        deactivate: 'Inaktivera',
        deactivated: 'Organisation inaktiverad',
        confirm_deactivate: 'Är du säker på att du vill inaktivera denna organisation?',
        loaded_results: 'Organizations laddade, {count} resultat',
        form_loaded: 'Organization-formulär laddat',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        locale_en_us: 'engelska (en-US)',
    },
    intake_configs: {
        title: 'Offentlig Intag Konfigurationer',
        create: 'Skapa Konfiguration',
        edit: 'Redigera Intags Konfiguration',
        label_col: 'Etikett',
        key: 'Intag Nyckel',
        key_hint: 'Offentlig URL vil være: /rights-request?key=',
        mapped_org: 'Mål Organisation',
        status: 'Tillstånd',
        enabled: 'Aktiverad',
        disabled: 'Inaktiverad',
        request_types: 'Aktiverad Begäran Typer',
        language: 'Standard Språk',
        public_url: 'Offentlig URL',
        no_configs: 'Inga intagskonfigurationer hittades. Skapa en för att aktivera offentliga rättighetsbegäranformulär.',
        load_error: 'Kunde inte ladda intagskonfigurationer',
        save_error: 'Kunde inte spara',
        delete_error: 'Kunde inte radera',
        created_msg: 'Konfiguration skapad',
        updated: 'Konfiguration uppdaterad',
        deleted: 'Intagskonfiguration raderad',
        confirm_delete: 'Radera denna intagskonfiguration?',
        select_types: 'Välj minst en begärantyp',
        select_org: 'Välj a mål organisation',
        routing_mode: 'Routingläge',
        single_org: 'Enskild Organisation',
        org_group_mode: 'Organisationsgrupp',
        org_group: 'Organisationsgrupp',
        select_group: 'Välj en organisationsgrupp...',
        group_root_hint: 'Ställs automatiskt in på gruppens rotorganisation när gruppen väljs.',
        loaded_results: 'Intake configurations laddade, {count} resultat',
        form_loaded: 'Intake configuration-formulär laddat',
    },
    frequency: {
        weekly: 'Veckovis',
        monthly: 'Månadsvis',
        quarterly: 'Kvartalsvis',
        semi_annually: 'Halvårsvis',
        annually: 'Årsvis',
        custom: 'Anpassad',
    },
    task_management: {
        nav: {
            calendar: 'Kalender',
            all_tasks: 'Alla uppgifter',
            my_tasks: 'Mina uppgifter',
            overdue: 'Försenade',
            board: 'Tavla',
            workflows: 'Arbetsflöden',
        },
        list: {
            title: 'Alla uppgifter',
            my_title: 'Mina uppgifter',
            overdue_title: 'Försenade uppgifter',
            new_task: 'Skapa uppgift',
            no_tasks: 'Inga uppgifter hittades.',
            empty_state: 'Inga uppgifter hittades. Uppgifter genereras från modularbetsflöden som bedömningar, incidenter och granskningskampanjer.',
            total: 'Totalt uppgifter',
            search_placeholder: 'Sök uppgifter...',
            bulk_actions: 'Massåtgärder',
            change_status: 'Ändra status',
            change_priority: 'Ändra prioritet',
            assign: 'Tilldela',
            sr_my_tasks_count: '{count} uppgifter tilldelade dig',
            sr_days_overdue: '{count} dagar försenad',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Uppgiftsdetalj',
            description: 'Beskrivning',
            workflow_progress: 'Arbetsflödesframsteg',
            checklist: 'Checklista',
            dependencies: 'Beroenden',
            comments: 'Kommentarer',
            activity_timeline: 'Aktivitetstidslinje',
            assignees: 'Tilldelade',
            add_assignee: 'Lägg till tilldelad',
            remove_assignee: 'Ta bort tilldelad',
            due_date: 'Förfallodatum',
            start_date: 'Startdatum',
            sla_status: 'SLA-status',
            sla_on_track: 'I fas',
            sla_at_risk: 'I riskzonen',
            sla_breached: 'Bruten',
            tags: 'Taggar',
            source_entity: 'Källentitet',
            view_source: 'Visa källa',
            add_dependency: 'Lägg till beroende',
            remove_dependency: 'Ta bort beroende',
            write_comment: 'Skriv en kommentar...',
            post_comment: 'Skicka',
            edit_comment: 'Redigera',
            delete_comment: 'Radera',
            add_checklist_item: 'Lägg till objekt',
            no_dependencies: 'Inga beroenden',
            no_comments: 'Inga kommentarer ännu',
            blocks: 'Blockerar',
            blocked_by: 'Blockerad av',
            related: 'Relaterad',
            working_days_remain: 'arbetsdagar kvar',
            created_by: 'Skapad av',
            completed_at: 'Slutförd den',
            no_assignees: 'Inga tilldelade',
            add_assignee_placeholder: 'Ange användar-ID...',
            edited: 'redigerad',
            timeline: 'Aktivitetstidslinje',
            no_timeline: 'Ingen aktivitet ännu',
            no_workflow: 'Inget arbetsflöde tilldelat',
            add_dependency_placeholder: 'Ange uppgifts-ID...',
            sr_status_updated: 'Status uppdaterad till [[TOK_1]]',
            sr_priority_updated: 'Prioritet uppdaterad till [[TOK_1]]',
            convert_to_workflow: 'Kör som arbetsflöde',
            convert_modal_title: 'Konvertera uppgift till arbetsflödeskörning',
            convert_workflow_label: 'Arbetsflöde',
            convert_workflow_placeholder: 'Välj ett arbetsflöde...',
            convert_attachments_label: 'Bilagor',
            convert_attachments_empty: 'Inga bilagor för denna uppgift.',
            convert_persona_label: 'Persona åsidosätta (valfritt)',
            convert_submit: 'Starta arbetsflödeskörning',
            convert_starting: 'Startar körning av arbetsflöde...',
            convert_started: 'Arbetsflödeskörning startade — öppningskörning...',
            convert_disabled_in_flight: 'Ett arbetsflöde som körs från den här uppgiften pågår redan.',
            linked_workflow_chip: 'Från [[TOK_1]]',
            linked_chat_chip: 'Från [[TOK_0]] Chat',
            linked_more: '+[[TOK_1]] till',
        },
        calendar: {
            title: 'Uppgiftskalender',
            page_title: 'Kalender',
            create_task: 'Skapa uppgift',
            month: 'Månad',
            week: 'Vecka',
            day: 'Dag',
            today: 'Idag',
            more_tasks: '+[[TOK_1]] till',
            no_tasks_day: 'Inga uppgifter denna dag',
            all_day: 'Hela dagen',
            quick_create_tooltip: 'Skapa uppgift för denna dag',
            view_changed: 'Kalendervy ändrad till {view}',
            tasks_in_view: '{count} uppgifter i vy',
            task_in_view: '[[TOK_1]] uppgift i sikte',
        },
        filters: {
            assignee: 'Tilldelad',
            me: 'Jag',
            role: 'Roll',
            status: 'Status',
            priority: 'Prioritet',
            task_type: 'Uppgiftstyp',
            source_module: 'Källmodul',
            organization: 'Organisation',
            sla_breached_only: 'Visa bara SLA-brutna',
            clear_filters: 'Rensa filter',
            apply_filters: 'Tillämpa',
            source_label: 'Källa',
            source_manual: 'Manuell',
            source_module_kind: 'Modulgenererad',
            source_chat: 'Från [[TOK_0]] Chat',
            source_workflow_run: 'Från [[TOK_0]] arbetsflödeskörning',
        },
        status: {
            pending: 'Väntande',
            in_progress: 'Pågår',
            blocked: 'Blockerad',
            completed: 'Slutförd',
            overdue: 'Försenade',
            escalated: 'Eskalerad',
            cancelled: 'Avbruten',
        },
        priority: {
            critical: 'Kritisk',
            high: 'Hög',
            medium: 'Medel',
            low: 'Låg',
        },
        task_types: {
            manual_task: 'Manuell uppgift',
            dsr_case: 'DSR-ärende',
            dsr_review: 'DSR-granskning',
            dsr_escalation: 'DSR-eskalering',
            dpia_review: 'DPIA-granskning',
            dpia_approval: 'DPIA-godkännande',
            transfer_review: 'Överföringsgranskning',
            incident_task: 'Incidentuppgift',
            incident_notification: 'Incidentavisering',
            playbook_step: 'Playbook-steg',
            regulator_deadline: 'Myndighetsfrist',
            monitoring_task: 'Övervakningsuppgift',
            kpi_alert: 'KPI-varning',
            vendor_review: 'Leverantörsgranskning',
            vendor_questionnaire: 'Leverantörsenkät',
            governance_review: 'Styrningsgranskning',
            drift_alert: 'Avvikelsevarning',
            governance_approval: 'Styrningsgodkännande',
            deletion_task: 'Raderingsuppgift',
            deletion_verification: 'Raderingsverifiering',
            access_review: 'Åtkomstgranskning',
            sod_alert: 'SoD-varning',
            consent_workflow: 'Samtyckesarbetsflöde',
            consent_alert: 'Samtyckesvarning',
            property_review: 'Egenskapsgranskning',
            inconsistency_alert: 'Inkonsekvensvarning',
            form_review: 'Formulärgranskning',
            dossier_deadline: 'Dossiertidsfrist',
            submission_task: 'Inlämningsuppgift',
            translation_review: 'Översättningsgranskning',
            governance_task: 'Styrningsuppgift',
            reporting_deadline: 'Rapporteringsfrist',
            scanner_alert: 'Skannervarning',
            classification_review: 'Klassificeringsgranskning',
            lifecycle_task: 'Livscykeluppgift',
            discovery_review: 'Upptäcktsgranskning',
        },
        task_type_groups: {
            manual: 'Manuell',
            dsr: 'DSR / Rättighetsbegäranden',
            assessments: 'Bedömningar',
            incidents: 'Incidenter',
            incident_ops: 'Incidentdrift',
            monitoring: 'Övervakning',
            vendor_risk: 'Leverantörsrisk',
            governance: 'Styrning',
            deletion: 'Radering',
            access_review: 'Åtkomstgranskning',
            consent: 'Samtycke',
            consent_properties: 'Samtyckesegenskaper',
            forms: 'Formulär',
            localization: 'Lokalisering',
            program_governance: 'Programstyrning',
            privacy_scanner: 'Integritetsskanner',
            classification: 'Klassificering',
            discovery: 'Upptäckt',
        },
        create: {
            title: 'Skapa uppgift',
            task_title: 'Titel',
            task_description: 'Beskrivning',
            task_type: 'Uppgiftstyp',
            task_type_label: 'Uppgiftstyp',
            task_type_placeholder: 'Välj en uppgiftstyp',
            priority: 'Prioritet',
            assignees: 'Tilldelade',
            assignee_search_placeholder: 'Sök användare...',
            due_date: 'Förfallodatum',
            start_date: 'Startdatum',
            checklist: 'Checklista',
            tags: 'Taggar',
            add_checklist_item: 'Lägg till checklistobjekt',
            validation: {
                title_required: 'Titel krävs',
                title_max_length: 'Titel måste vara 500 tecken eller färre',
                description_max_length: 'Beskrivning måste vara 5000 tecken eller färre',
                due_date_before_start: 'Förfallodatum måste vara efter startdatum',
                max_reminders: 'Maximalt 5 påminnelser per uppgift',
            },
            reminders: {
                title: 'Påminnelser',
                add: 'Lägg till påminnelse',
                at_due_date: 'På förfallodatum',
                minutes_before: '[[TOK_1]] minuter innan',
                hours_before: '[[TOK_1]] timmar innan',
                days_before: '[[TOK_1]] dagar innan',
                weeks_before: '[[TOK_1]] veckor innan',
                custom: 'Anpassad',
                channel_platform: 'Plattform',
                channel_email: 'E-post',
                channel_both: 'Båda',
            },
            workflow: {
                label: 'Arbetsflöde',
                none: 'Ingen (manuell statushantering)',
                steps_count: '[[TOK_1]] steg',
                preview_label: 'Arbetsflödessteg',
            },
        },
        errors: {
            fetch_failed: 'Kunde inte ladda uppgifter.',
            save_failed: 'Kunde inte spara uppgift.',
            delete_failed: 'Kunde inte radera uppgift.',
            status_change_failed: 'Kunde inte ändra uppgiftsstatus.',
            assign_failed: 'Kunde inte tilldela uppgift.',
            comment_failed: 'Kunde inte spara kommentar.',
            checklist_failed: 'Kunde inte uppdatera checklista.',
            dependency_failed: 'Kunde inte uppdatera beroende.',
            workflow_failed: 'Kunde inte spara arbetsflöde.',
            workflow_activate_failed: 'Kunde inte aktivera arbetsflöde.',
            workflow_delete_failed: 'Kunde inte radera arbetsflöde.',
            template_install_failed: 'Kunde inte installera mall.',
            search_failed: 'Kunde inte söka uppgifter.',
            convert_failed: 'Det gick inte att starta arbetsflödeskörningen.',
            convert_quota_exhausted: 'Token hink låg. Fyll på innan du kör igen.',
        },
        dependency_types: {
            blocks: 'Blockerar',
            blocked_by: 'Blockerad av',
            related: 'Relaterad',
        },
        workflow: {
            current_step: 'Nuvarande steg',
            transition: 'Övergång',
            history: 'Steghistorik',
            no_workflow: 'Inget arbetsflöde tilldelat',
            detail_title: 'Arbetsflödesdetaljer',
            list_title: 'Arbetsflödesdefinitioner',
            create_workflow: 'Skapa arbetsflöde',
            browse_templates: 'Bläddra bland mallar',
            template_catalog_title: 'Arbetsflödesmallkatalog',
            name: 'Namn',
            description: 'Beskrivning',
            task_types: 'Uppgiftstyper',
            steps: 'Steg',
            version: 'Version',
            created: 'Skapad',
            actions: 'Åtgärder',
            status_draft: 'Utkast',
            status_active: 'Aktiv',
            status_archived: 'Arkiverad',
            activate: 'Aktivera',
            archive: 'Arkivera',
            save: 'Spara',
            edit: 'Redigera',
            delete: 'Radera',
            clone: 'Klona',
            install: 'Installera',
            installed: 'Installerad',
            system: 'System',
            general_settings: 'Allmänna inställningar',
            default_assignment: 'Standardtilldelning',
            default_sla: 'Standard-SLA',
            workflow_steps: 'Arbetsflödessteg',
            add_step: 'Lägg till steg',
            step_name: 'Stegnamn',
            step_status: 'Statusvärde',
            assignment_strategy: 'Tilldelningsstrategi',
            assignment_role: 'Tilldelningsroll',
            sla_hours: 'SLA-timmar',
            sla_calendar_type: 'Kalendertyp',
            working_days: 'Arbetsdagar',
            calendar_days: 'Kalenderdagar',
            is_terminal: 'Terminalsteg',
            required_fields: 'Obligatoriska fält',
            checklist_template: 'Checklistmall',
            transitions: 'Övergångar',
            add_transition: 'Lägg till övergång',
            from_step: 'Från',
            to_step: 'Till',
            permission: 'Behörighet',
            sla_action: 'SLA-åtgärd',
            notify: 'Meddela',
            escalation_rules: 'Eskaleringsregler',
            add_rule: 'Lägg till regel',
            trigger: 'Utlösare',
            threshold: 'Tröskel',
            action: 'Åtgärd',
            target_role: 'Målroll',
            trigger_sla_threshold: 'SLA-tröskel',
            trigger_sla_breach: 'SLA-brott',
            trigger_blocked_duration: 'Blockerad varaktighet',
            trigger_manual: 'Manuell',
            action_notify: 'Meddela',
            action_escalate: 'Eskalera nivå',
            action_reassign: 'Omtilldela',
            sla_start: 'Starta',
            sla_pause: 'Pausa',
            sla_resume: 'Återuppta',
            sla_stop: 'Stoppa',
            strategy_manual: 'Manuell',
            strategy_role_based: 'Rollbaserad',
            strategy_round_robin: 'Round Robin',
            strategy_least_loaded: 'Minst belastad',
            strategy_creator: 'Skapare',
            confirm_delete: 'Är du säker på att du vill radera detta arbetsflöde?',
            confirm_archive: 'Är du säker på att du vill arkivera detta arbetsflöde?',
            cannot_delete_active: 'Aktiva arbetsflöden kan inte raderas. Arkivera först.',
            validation_errors: 'Valideringsfel i arbetsflöde',
            step_count: '[[TOK_1]] steg',
            no_workflows: 'Inga arbetsflöden hittades.',
            no_templates: 'Inga mallar tillgängliga.',
            sr_templates_count: '[[TOK_1]] mallar tillgängliga',
            template_installed: 'Mall installerad.',
            activate_success: 'Arbetsflöde aktiverat.',
            archive_success: 'Arbetsflöde arkiverat.',
            save_success: 'Arbetsflöde sparat.',
            delete_success: 'Arbetsflöde raderat.',
        },
        columns: {
            priority: 'Prioritet',
            title: 'Titel',
            status: 'Status',
            type: 'Typ',
            assignees: 'Tilldelad(e)',
            due_date: 'Förfallodatum',
            source: 'Källa',
            actions: 'Åtgärder',
        },
        groups: {
            overdue: 'Försenade',
            due_today: 'Förfaller idag',
            due_this_week: 'Förfaller denna vecka',
            due_later: 'Förfaller senare',
            no_due_date: 'Inget förfallodatum',
        },
        board: {
            title: 'Uppgiftstavla',
            drag_hint: 'Dra uppgifter mellan kolumner för att ändra status',
            empty_column: 'Inga uppgifter',
            keyboard_hint: 'Tangentbord: piltangenter för att navigera, mellanslag för att plocka upp en uppgift, vänster/höger för att välja kolumn, Enter för att släppa, Escape för att avbryta.',
            sr_moving: 'Flyttar {title}. Över {column}. Tryck Enter för att släppa, Escape för att avbryta.',
            sr_tasks_shown: '{count} uppgifter visade',
            sr_picked_up: '{title} lyft',
            sr_returned: '[[TOK_2]] återvände till [[TOK_3]]',
            sr_dropped: '{title} släppt i {column}, position {position} av {total}',
            sr_move_cancelled: 'Flytt avbruten',
            sr_over_column: 'Över {column}',
            sr_moved_to: '{title} flyttad till {column}',
            invalid_transition: 'Kan inte flytta uppgift fran {from} till {to}.',
            terminal_status: 'Denna uppgift har en slutstatus och kan inte flyttas.',
            invalid_drop_target: 'Ogiltigt slapmal',
        },
        team: {
            title: 'Teamarbetsbelastning',
            assignee: 'Tilldelad',
            active: 'Aktiv',
            overdue: 'Försenade',
            blocked: 'Blockerad',
            completed_7d: 'Avslutad (7d)',
            load: 'Belastning',
            load_high: 'Hög',
            load_medium: 'Medel',
            load_normal: 'Normal',
        },
        graph: {
            title: 'Beroendediagram',
            list_view: 'Listvy',
            graph_view: 'Grafvy',
            zoom_in: 'Zooma in',
            zoom_out: 'Zooma ut',
            reset_zoom: 'Återställ',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Inga beroenden att visualisera.',
        },
        add_dependency_modal: {
            title: 'Lägg till beroende',
            search_placeholder: 'Sök uppgifter efter titel eller ID...',
            no_results: 'Inga uppgifter hittades.',
            this_blocks: 'Denna uppgift blockerar markerade',
            this_blocked_by: 'Denna uppgift är blockerad av valda',
            related: 'Relaterad',
            max_dependencies: 'Max 10 beroenden per uppgift.',
            circular_error: 'Kan inte lägga till: skulle skapa ett cirkulärt beroende.',
        },
        conflict_detection: {
            title: 'Konfliktdetektering',
            unresolved: 'olöst',
            no_conflicts: 'Inga konflikter upptäckta',
            section: 'Avsnitt',
            field: 'Fält',
            dept_a: 'Avdelning A',
            value_a: 'Värde A',
            dept_b: 'Avdelning B',
            value_b: 'Värde B',
            severity: 'Allvarlighetsgrad',
            status: 'Status',
            resolved: 'Löst',
            open: 'Öppen',
            resolve: 'Lös',
            load_failed: 'Kunde inte load conflicts',
            resolve_success: 'Konflikt löst',
            resolve_failed: 'Kunde inte resolve conflict',
            severity_critical: 'Kritisk',
            severity_warning: 'Varning',
            severity_info: 'Info',
        },
        consolidation: {
            title: 'Konsolideringsframsteg',
            add_child: 'Lägg till underuppgift',
            child_task_id: 'Underuppgifts-ID',
            department_id: 'Avdelnings-ID',
            link: 'Länka',
            overall_completion: 'Totalt slutförande',
            departments_complete: 'Avdelningar slutförda',
            overdue: 'Försenad',
            ready: 'Redo',
            not_ready: 'Inte redo',
            master_status: 'Huvudstatus',
            department_breakdown: 'Avdelningsfördelning',
            department: 'Avdelning',
            status: 'Status',
            completion: 'Slutförande',
            due_date: 'Förfallodatum',
            overdue_flag: 'Försenad',
            child_tasks: 'Underuppgifter',
            task: 'Uppgift',
            load_failed: 'Kunde inte load consolidation data',
            child_linked: 'Underuppgift länkad',
            link_failed: 'Kunde inte link child task',
            confirm_unlink: 'Är du säker på att du vill ta bort länken till denna underordnade uppgift?',
            child_unlinked: 'Underordnad uppgift har tagits bort',
            unlink_failed: 'Det gick inte att ta bort länken till den underordnade uppgiften',
            unlink: 'Ta bort länken',
            status_completed: 'Slutförd',
            status_in_progress: 'Pågående',
            status_pending: 'Väntande',
            select_child_task: 'Välj underuppgift',
            select_department: 'Välj avdelning',
        },
        section_assignments: {
            title: 'Avsnitttstilldelningar',
            assign_section: 'Tilldela avsnitt',
            section_ref: 'Avsnittsref.',
            section_label: 'Avsnittsetikett',
            department_id: 'Avdelnings-ID',
            department: 'Avdelning',
            assignee_id: 'Tilldelad-ID',
            assignee: 'Tilldelad',
            mandatory: 'Obligatorisk',
            assign: 'Tilldela',
            no_assignments: 'Inga avsnitttstilldelningar',
            status: 'Status',
            completion: 'Slutförande',
            mark_complete: 'Slutför',
            load_failed: 'Kunde inte load section assignments',
            assign_success: 'Avsnitt tilldelat',
            assign_failed: 'Kunde inte assign section',
            status_updated: 'Status uppdaterad',
            status_update_failed: 'Kunde inte uppdatera status',
            section_ref_placeholder: 't.ex. 3.2',
            status_completed: 'Slutförd',
            status_in_progress: 'Pågående',
            status_pending: 'Väntande',
            select_department: 'Välj avdelning',
            select_assignee: 'Välj tilldelad',
        },
        overdue_columns: {
            days_overdue: 'Dagar forsenade',
        },
        regulatory_info: {
            deadline_context: 'Vid skapande av DPIA-uppgifter bor forfallodatum overensstamma med PDPL-inlamningsfrister: avdelningsinmatning = 10 arbetsdagar. Cybersakers- och telekomfrister galler ocksa.',
            overdue_deadline_context: 'Regelfrister fran paketdata: PDPL avdelningsinmatning = 10 arbetsdagar, tillaggssvar = 15 arbetsdagar, aterinlamning = 10 arbetsdagar. SLA-brott markeras visuellt.',
            section_assignment_context: 'DPIA fleravdelningsprocess (PDPL-P1): DPO tilldelar dossiersektioner till avdelningar. Avdelningsinmatningsfrist: 10 arbetsdagar.',
            template_catalog_context: 'Systemmallar tackar ramverksspecifika processer: PDPL DPIA, Data Law attestering, Cybersakers incidentrespons, Telekom myndighetsforfragan och AI-registrering. Systemmallar ar inte redigerbara.',
            workflow_instantiation_context: 'Installerade mallar kan instantieras till live arbetsfloden. Uppgifter skapas automatiskt med beraknade forfallodatum.',
        },
    },
    notifications: {
        bell: {
            title: 'Aviseringar',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Aviseringar',
            mark_all_read: 'Markera alla som lästa',
            no_notifications: 'Inga aviseringar',
            filter: {
                all: 'All',
                unread: 'Oläst',
                tasks: 'Uppgifter',
                approvals: 'Godkännanden',
                alerts: 'Varningar',
            },
        },
        preferences: {
            title: 'Aviseringsinställningar',
            description: 'Konfigurera hur du tar emot aviseringar',
            category: {
                label: 'Kategori',
                task_assigned: 'Uppgift tilldelad',
                task_sla_approaching: '[[TOK_0]] Närmar sig',
                task_overdue: 'Uppgift försenad',
                task_completed: 'Uppgift slutförd',
                task_escalated: 'Uppgift eskalerad',
                workflow_transition: 'Arbetsflödesövergång',
                approval_requested: 'Godkännande begärs',
                comment_added: 'Kommentar tillagd',
                weekly_digest: 'Weekly Digest',
                sla_breach_report: '[[TOK_0]] Rapport om brott',
                system_alert: 'Systemvarning',
            },
            channel: {
                platform: 'Plattform',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Tysta timmar',
                start: 'Starta',
                end: 'End',
                timezone: 'Tidszon',
            },
            digest: {
                title: 'Digest Frequency',
                daily: 'Dagligen',
                weekly: 'Varje vecka',
                none: 'Inga',
            },
            watched: {
                title: 'Bevakade Entities',
                empty: 'Inga bevakade enheter',
            },
            save: 'Spara inställningar',
            saving: 'Sparar...',
            saved_success: 'Inställningarna har sparats',
            load_error: 'Det gick inte att läsa in sparade inställningar. Visar standardvärden — ändringarna sparas när du klickar på Spara.',
            enabled: 'Aktiverad',
            disabled: 'Inaktiverad',
            unwatch: 'Avvakta',
        },
        admin_queue: {
            title: 'Administrationskö för aviseringar',
            description: 'Övervaka e-postleveransstatus och försök skicka misslyckade meddelanden igen',
            load_error: 'Kunde inte ladda e-postködata',
            retry_error: 'Kunde inte skicka e-post igen',
            filter_status: 'Filtrera efter status',
            all_statuses: 'Alla',
            refresh: 'Uppdatera',
            status_queued: 'I kö',
            status_sent: 'Skickat',
            status_failed: 'Misslyckat',
            status_bounced: 'Studsat',
            col_recipient: 'Mottagare',
            col_category: 'Kategori',
            col_template: 'Mall',
            col_status: 'Status',
            col_retries: 'Återförsök',
            col_created: 'Skapad',
            col_sent: 'Skickat den',
            col_actions: 'Åtgärder',
            no_items: 'Inga e-postköelement hittades',
            retry: 'Försök igen',
            retrying: 'Försöker igen...',
            prev: 'Föregående',
            next: 'Nästa',
            access_denied_title: 'Administratörsåtkomst krävs',
            access_denied: 'Denna sida är endast tillgänglig för administratörer. Kontakta din administratör om du behöver åtkomst.',
            announce_queue_loaded: 'E-postkö laddad, [[TOK_1]] objekt',
            announce_processed: 'Behandlade [[TOK_1]] e-post(ar)',
            process_now: 'Bearbeta nu',
            processing_ellipsis: 'Bearbetar...',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'UI Assist',
            activate: 'Aktivera',
            deactivate: 'Inaktivera',
            connected: 'Ansluten',
            disconnected: 'Frånkopplad',
            disconnected_hint: 'Frånkopplad — kör `npm run relay` för att ansluta till Claude CLI',
            open_panel: 'Öppna UI Assist-panelen',
            history: 'Historia',
            settings: 'Inställningar',
        },
        prompt: {
            placeholder: 'Beskriv förändringen du vill göra...',
            send: 'Skicka',
            cancel: 'Avbryt',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Bearbetar...',
            complete: 'Komplett',
            error: 'Fel',
            abort: 'Avbryt',
            abort_confirm: 'Är du säker på att du vill avbryta?',
            aborted_hint: 'Sessionen avbröts — du kan fortsätta härifrån.',
            undo: 'Ångra',
            redo: 'Gör om',
            retry: 'Försök igen',
            dismiss: 'Avvisa',
        },
        label: {
            component: 'Komponent',
            element: 'Element',
            file: 'Arkiv',
        },
        response: {
            you: 'You',
            claude: 'Claude',
            empty: 'Inga meddelanden än. Välj element och skicka en uppmaning för att komma igång.',
        },
        panel: {
            tab_conversation: 'Chatta',
            tab_tasks: 'Uppgifter',
            tab_sprint: 'Sprint',
            tab_sessions: 'Sessioner',
            tab_lobby: 'Lobbyn',
            follow_up: 'Följ upp',
            followup_placeholder: 'Ställ en följdfråga...',
            interrupt_placeholder: 'Skriv för att avbryta och omdirigera…',
            send_interrupt: 'Skicka & Avbryt',
            will_interrupt: 'Avbryter det aktuella svaret och skickar detta istället',
            expand: 'Expandera till helskärm',
            collapse: 'Fäll ihop till sidopanel',
            no_sessions: 'Inga tidigare sessioner. Välj element och skicka ett meddelande för att börja.',
            session_active: 'Aktiv',
            session_ended: 'Avslutad',
            session_messages: '{count} meddelanden',
            switch_session: 'Byt till denna session',
            load_session: 'Ladda sessionshistorik',
            session_restored: 'Session återställd från historien',
            archive_session: 'Arkivsession',
            archive_confirm: 'Arkivera den här sessionen? Sessionsfilen kommer att raderas.',
            new_session: 'Ny session',
            new_session_desc: 'Använd Aktivera för att välja ett UI-element och starta en ny session',
            start_new_session: 'Starta ny session',
            no_active_session_chat: 'Starta en ny session eller använd Aktivera för att välja ett UI-element på sidan för att börja.',
            no_active_session_tasks: 'Starta en ny session eller välj en befintlig session för att skapa uppgifter.',
            no_active_session_sprint: 'Starta en ny session eller välj en befintlig session för att planera en sprint.',
            previous_sessions: 'Tidigare sessioner',
        },
        tasks: {
            none_found: 'Inga uppgifter hittades i svaret. Be Claude att föreslå uppgifter.',
            selected: 'selected',
            create_selected: 'Skapa uppgifter',
            execute_tasks: 'Utför uppgifter',
            creating: 'Skapar...',
            created: 'skapade uppgifter',
            create_error: 'Det gick inte att skapa uppgiften',
            plan_sprint: 'Planera sprint',
            priority_critical_desc: 'Blockerande — åtgärda omedelbart',
            priority_high_desc: 'Viktig — lös i denna sprint',
            priority_medium_desc: 'Normal — planera för kommande sprint',
            priority_low_desc: 'Trevligt att ha — backlog-kandidat',
            add_custom: 'Lägg till uppgift',
            add_title_placeholder: 'Uppgiftstitel…',
            add_desc_placeholder: 'Beskrivning (valfritt)',
            add_save: 'Lägg till',
            add_cancel: 'Avbryt',
        },
        sprint: {
            title: 'Sprintplanerare',
            assigned: 'assigned',
            new_placeholder: 'Sprintnamn (t.ex. Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Eftersläpning',
            move_to: 'Flytta till...',
            empty: 'Skapa en sprintgrupp och tilldela uppgifter till den.',
            create_all: 'Skapa alla uppgifter',
            remove: 'Ta bort',
            drop_here: 'Tilldela uppgifter från backloggen nedan',
            add_task: 'Lägg till uppgift från eftersläpning...',
        },
        feature_disabled: 'UI Assist är inte aktiverat',
        permission_denied: 'Du har inte behörighet att använda UI Assist',
    },
    license: {
        title: 'Licens & Paket',
        current_license: 'Aktuell licens',
        license_key: 'Licensnyckel',
        activate: 'Aktivera licens',
        deactivate: 'Inaktivera licens',
        validate_now: 'Validera nu',
        status: 'Licensstatus',
        active: 'Aktiv',
        expired: 'Utgått',
        suspended: 'Avstängd',
        invalid: 'Ogiltig',
        pending: 'Väntar',
        no_license: 'Ingen licens',
        expires_at: 'Upphör att gälla',
        last_validated: 'Senast validerad',
        domain: 'Licensierad domän',
        activation_success: 'Licensen har aktiverats.',
        activation_failed: 'Licensaktivering misslyckades.',
        domain_mismatch: 'Licensdomänen matchar inte den aktuella domänen.',
        deactivation_success: 'Licens avaktiverad.',
        validation_success: 'Licensen har validerats.',
        validation_failed: 'Licensvalideringen misslyckades.',
        enter_key: 'Ange din licensnyckel',
        confirm_deactivate: 'Är du säker på att du vill inaktivera den här licensen? Modulrestriktioner kommer att gälla baserat på standardnivån.',
    },
    package_mgmt: {
        title: 'Paket',
        module_column: 'Modul',
        current_tier: 'Aktuellt paket',
        light: 'Ljus',
        standard: 'Standard',
        enterprise_unlimited: 'Enterprise Unlimited',
        change_package: 'Byt paket',
        upgrade: 'Uppgradera',
        downgrade: 'Nedgradera',
        target_tier: 'Målpaket',
        new_license_key: 'Licensnyckel för målpaket',
        confirm_change: 'Bekräfta paketändring',
        change_success: 'Paketet har ändrats.',
        change_failed: 'Paketbytet misslyckades.',
        modules_included: 'Moduler ingår',
        modules_restricted: 'Ej tillgängligt i nuvarande paket',
        upgrade_to_enable: 'Uppgradera för att aktivera denna modul.',
        module_availability: 'Modultillgänglighet',
        comparison: 'Paketjämförelse',
        power_users: 'Power Users',
        unlimited: 'Obegränsad',
        impact_warning: 'Nedgradering kommer att inaktivera följande moduler:',
        invalid_license: 'Den angivna licensnyckeln är inte giltig för detta paket.',
        tier_mismatch: 'Licensnyckeln är för en annan paketnivå.',
    },
    board_report: {
        title: 'Styrelseöversikt över Efterlevnad',
        subtitle: 'Sammanfattning av efterlevnad över alla moduler',
        date_from: 'Från datum',
        date_to: 'Till datum',
        language: 'Rapportspråk',
        generate: 'Generera rapport',
        generating: 'Genererar rapport...',
        download_pdf: 'Ladda ner PDF',
        close: 'Stäng rapport',
        open_board_report: 'Generera styrelserapport',
        close_board_report: 'Stäng styrelserapport',
        report_period: 'Rapportperiod',
        generated_at: 'Genererad den',
        generated_by: 'Genererad av',
        organization: 'Organisation',
        section_rights_requests: 'Rättighetsbegäranden',
        section_vendors: 'Leverantörer',
        section_dpias: 'DPIA:er',
        section_consent: 'Samtyckespolicyer',
        section_data_mapping: 'Datakartläggning',
        section_incidents: 'Incidenter',
        section_classification: 'Dataklassificering',
        section_governance: 'Styrning',
        open: 'Öppen',
        closed: 'Stängd',
        sla_compliance: 'SLA-efterlevnad',
        total: 'Totalt',
        expired_dpa: 'Utgånget DPA',
        high_risk: 'Hög risk',
        completed: 'Slutförd',
        overdue: 'Försenad',
        policies_active: 'Aktiva policyer',
        coverage: 'Täckning',
        systems: 'System',
        completeness: 'Fullständighet',
        avg_resolution_days: 'Gns. lösningstid (dagar)',
        labeled: 'Märkt',
        unlabeled_systems: 'Omärkta system',
        compliance_score: 'Efterlevnadspoäng',
        drift_events_open: 'Öppna avvikelser',
        no_data: 'Inga data tillgängliga för den valda perioden.',
        error_date_range: 'Välj både start- och slutdatum.',
        table_category: 'Kategori',
        table_metric: 'Mätetal',
        table_value: 'Värde',
        showing_chart_view: 'Visar diagramvy',
        showing_table_view: 'Visar datatabellvy',
        error_generate: 'Styrelserapport kunde inte genereras.',
        playbook_evidence_title: 'Bevis för playbook-körningar',
        playbook_evidence_description: 'Körningsaktivitet per playbook och bifogade bevisfiler för rapportperioden.',
        playbook_name: 'Playbook',
        playbook_execution_count: 'Körningar',
        playbook_steps_total: 'Steg',
        playbook_steps_required: 'Bevis krävs',
        playbook_steps_attached: 'Bevis bifogat',
        playbook_coverage_pct: 'Täckning',
        playbook_evidence_files: 'Bevisfiler',
        playbook_no_evidence: 'Inga playbook-körningar under denna period.',
        playbook_download_file: 'Ladda ner fil',
    },
    framework_module_links: {
        title: 'Ramverkslänkning',
        modules: 'Länkade moduler',
        add_module: 'Lägg till modul',
        module_code: 'Modulkod',
        required: 'Obligatorisk',
        notes: 'Anteckningar',
        link: 'Länk',
        no_modules: 'Inga moduler länkade',
        personas: 'Länkade personas',
        add_persona: 'Lägg till persona',
        persona_id: 'Persona-id',
        role_description: 'Rollbeskrivning',
        no_personas: 'Inga personas länkade',
    },
    framework_channels: {
        title: 'Inlämningskanaler & Deadlines',
        channels: 'Inlämningskanaler',
        add_channel: 'Lägg till kanal',
        channel_type: 'Typ',
        name: 'Namn',
        instructions: 'Instruktioner',
        active: 'Aktiv',
        no_channels: 'Inga inlämningskanaler konfigurerade',
        portal: 'Portal',
        in_person: 'Personligen',
        postal: 'Post',
        email: 'E-post',
        add: 'Lägg till',
        deadlines: 'Regelverksdeadlines',
        add_deadline: 'Lägg till deadline',
        label: 'Etikett',
        days: 'Dagar',
        day_type: 'Dagstyp',
        calendar_days: 'Kalenderdagar',
        working_days: 'Arbetsdagar',
        description: 'Beskrivning',
        no_deadlines: 'Inga deadlines konfigurerade',
    },
    regulatory_updates: {
        title: 'Regelverksuppdateringar & Ramverksdashboard',
        coverage_dashboard: 'Ramverkstäckningsdashboard',
        no_frameworks: 'Inga ramverk hittades',
        framework: 'Ramverk',
        status: 'Status',
        modules: 'Moduler',
        templates: 'Mallar',
        forms: 'Formulär',
        channels: 'Kanaler',
        deadlines: 'Deadlines',
        pending: 'Väntande uppdateringar',
        updates: 'Regelverksuppdateringar',
        create_update: 'Skapa uppdatering',
        framework_id: 'Ramverk-id',
        update_title: 'Titel',
        description: 'Beskrivning',
        effective_date: 'Ikraftträdandedatum',
        create: 'Skapa',
        no_updates: 'Inga regelverksuppdateringar',
        impact: 'Påverkan',
        assess: 'Bedöm',
    },
    module_tips: {
        show_guide: 'Visa guide',
        hide_guide: 'Dölj guide',
        title: 'Modulguide',
        title_prefix: 'Modultips:',
        loading_aria: 'Laddar modultips',
        related_frameworks: 'Relaterade ramverk',
        quick_start_label: 'Snabbstart',
        related_forms_note: 'Relaterade efterlevnadsformulär finns nedan — leta efter Mẫu số-märket för att identifiera officiella vietnamesiska lagstiftningsformulär.',
        read_full_guide: 'Läs hela guiden',
        view_full_requirements: 'Visa fullständiga krav',
        relevant_for: 'Relevant för',
        key_procedure: 'Nyckelprocedur',
        deletion_orchestration: 'Samordning av dataradering över system och leverantörer med verifieringsarbetsflöden och revisionsspår.',
        rights_requests: 'Hantera begäranden om registrerades rättigheter inklusive åtkomst, radering, rättelse och portabilitet. Krävs enligt PDPL lag 91/2025 och GDPR.',
        consent: 'Hantera samtyckespolicyer och arbetsflöden. Krävs för PDPL, e-handelslagen och GDPR-efterlevnad.',
        consent_properties: 'Konfigurera samtyckeinsamlingspunkter och CMP-integrationsegenskaper för webb- och appsamtycke.',
        data_mapping: 'Kartlägg dataflöden i din organisation — behandlingsaktiviteter, system och gränsöverskridande överföringar.',
        data_mapping_registry: 'Upprätthåll en inventering per fält av varje persondataelement som din organisation har. Bifoga varje element till en datakategori, åsidosätt känslighet eller lagring vid behov, och importera inskickningar från regulatoriska register ([[TOK_0]] persondatainventering) utan att förlora operatörsredigeringar.',
        data_mapping_ropa_completeness: 'Hygiengranskning per fält av varje bearbetningsaktivitet mot ramverkets obligatoriska ROPA-fält ([[TOK_1]], [[TOK_0]], dekret 165). Identifiera kritiska/höga/villkorliga missar innan regulatorisk inlämning och hoppa direkt in i aktivitetsredigeraren för att fixa var och en.',
        assessments: 'Skapa och hantera dataskyddskonsekvensbedömningar (DPIA) och AI-systemriskbedömningar. Krävs enligt PDPL lag 91/2025 artikel 24.',
        classification: 'Klassificera och märk datatillgångar efter känslighet, kategori och regulatoriska krav.',
        incidents: 'Registrera och hantera säkerhetsincidenter och dataintrång. Krävs för intrångsanmälan enligt PDPL och cybersäkerhetslagen.',
        incident_ops: 'Koordinera incidenthanteringsoperationer med playbook-aktiveringar, eskaleringvägar och realtids-koordineringsdashboards.',
        monitoring: 'Övervaka efterlevnads-KPI:er, programhälsa och uppgiftsslutförandegrad i hela organisationen.',
        vendor_risk: 'Bedöm och hantera leverantörsrisk genom frågeformulär, riskportföljer och efterlevnadspoäng.',
        governance: 'Hantera leverantörsstyrning, playbooks och tredjepartskrav för efterlevnad.',
        program_governance: 'Konfigurera programstyrningens mognadsbedömningar, dashboardmått och ramverk för efterlevnadspoäng.',
        discovery: 'Upptäck och inventera datatillgångar i din organisation med automatiserad skanning och klassificeringsarbetsflöden.',
        discovery_cycles: 'Schemalägg och kör återkommande upptäcktscykler som skannar om system, visar delta-ändringar och dirigerar fynd genom granskning, godkännande och publicering.',
        connectors: 'Konfigurera integrationer och datakonnektorer för automatiserad efterlevnadsdatainsamling.',
        task_management: 'Hantera efterlevnadsuppgifter, tilldelningar och deadlines över team och moduler.',
        audit_trail: 'Visa och sök i det enhetliga revisionsspåret för alla efterlevnadsaktiviteter och bevisinsamling.',
        evidence_packs: 'Sätt ihop, verifiera och skicka in revisionsbevispaket för efterlevnad av regelverk. Bevispaket samlar in granskningshändelser efter ramverk, enhetstyp och tidsperiod till exporterbara paket för intern granskning eller myndighetsinlämning.',
        audit_periods: 'Definiera och hantera revisionsrapporteringsperioder per regelverk. Revisionsperioder anger tidsgränser och lagringspolicyer för bevisinsamling och efterlevnadsrapporteringscykler.',
        qs_evidence_pack: 'Sätt ihop ditt första bevispaket',
        qs_audit_period: 'Skapa en revisionsrapporteringsperiod',
        compliance_forms: 'Bläddra i efterlevnadsformulärskatalogen och skapa formulärinstanser för regulatoriska inlämningar.',
        partner_workspace: 'Hantering av partner- och återförsäljararbetsytor med avgränsad åtkomst, efterlevnadsgranskningsarbetsflöden och samarbetsverktyg.',
        localization: 'Hantera regulatoriska ramverk, språkpaket och lokaliseringsinställningar.',
        onboarding: 'Följ onboardingframsteg, slutför snabbstarter och följ personabaserade efterlevnadsvägar.',
        organizations: 'Hantera organisationsstruktur, avdelningar och multi-org-konfigurationer.',
        privacy_scanner: 'Övervaka webbplatsens integritetsefterlevnad med automatiserad skanning och problemdetektering.',
        access_accountability: 'Konfigurera åtkomstgranskningskampanjer och ansvarspolicyer för datastyrning.',
        dashboard: 'Se översikten över efterlevnadsöversikten med statussammanfattningar i realtid, ramverkstäckning och viktiga efterlevnadsmått.',
        platform: 'Hantera plattformssäkerhetsinställningar inklusive [[TOK_0]]-nycklar, nödåtkomst med krossat glas och SSO-konfiguration.',
        framework_vn_pdpl: 'VN Lag om skydd av personuppgifter (PDPL)',
        framework_vn_cybersecurity: 'VN Cybersäkerhetslag',
        framework_vn_ecommerce: 'VN E-handelslag',
        framework_vn_ai_law: 'VN AI-lag',
        framework_vn_telecom: 'VN Telekommunikationslag',
        framework_vn_banking_circular_83: 'VN Banking Circular [[TOK_0]] – Internt kontrollsystem',
        framework_gdpr: 'EU GDPR',
        cross_framework: 'Tvärs över ramverk — stöder alla regulatoriska efterlevnadsaktiviteter',
        qs_dpia_filing: 'Slutför din första DPIA-inlämning',
        qs_dept_compliance: 'Skicka in din första avdelningsefterlevnadssektion',
        qs_ecommerce_consent: 'Konfigurera samtyckeinsamling för e-handel',
        qs_telecom_data: 'Ställ in hantering av telekomprenumerantdata',
        qs_data_flow: 'Kartlägg ditt första dataflöde',
        qs_incident_response: 'Konfigurera arbetsflöde för incidenthantering',
        qs_ai_risk: 'Kör en AI-systemriskbedömning',
        qs_cross_border: 'Bedöm en gränsöverskridande dataöverföring',
        qs_breach_notification: 'Simulera ett arbetsflöde för intrångsanmälan',
        qs_audit_trail: 'Granska ett efterlevnadsrevisionsspår',
        procedure_data_deletion_fulfillment: 'Genomförande av dataradering',
        procedure_cross_system_deletion: 'Systemövergripande radering',
        procedure_dsar_intake: 'Mottagande av registrerades rättighetsförfrågningar',
        procedure_cmp_property_config: 'CMP-egenskapskonfiguration',
        procedure_consent_collection: 'Policy för insamling av samtycke',
        procedure_ropa_filing: 'Inlämning av behandlingsregister',
        procedure_cross_border_assessment: 'Bedömning av gränsöverskridande dataöverföring',
        procedure_data_classification: 'Dataklassificering',
        procedure_breach_notification: 'Anmälan om dataintrång',
        procedure_incident_timeline: 'Spårning av incidentförlopp',
        procedure_playbook_escalation: 'Eskalering via handlingsplan',
        procedure_compliance_kpi_monitoring: 'Övervakning av efterlevnads-KPI',
        procedure_vendor_risk_assessment: 'Leverantörsriskbedömning',
        procedure_transfer_mechanism_review: 'Granskning av överföringsmekanism',
        procedure_program_maturity: 'Bedömning av programmognad',
        procedure_data_discovery: 'Upptäckt av datatillgångar',
        procedure_connector_setup: 'Installation och konfiguration av anslutningar',
        procedure_task_assignment: 'Uppgiftstilldelning och delegering',
        procedure_audit_evidence: 'Insamling av revisionsbevis',
        procedure_form_submission: 'Inlämning av efterlevnadsformulär',
        procedure_partner_onboarding: 'Arbetsflöde för partneronboarding',
        procedure_partner_access: 'Partnertillgång och behörigheter',
        procedure_framework_pack_install: 'Installation av ramverkspaket',
        procedure_language_pack_deploy: 'Utrullning av språkpaket',
        procedure_org_onboarding: 'Konfiguration av organisationsonboarding',
        procedure_multi_org_config: 'Multiorganisationskonfiguration',
        procedure_privacy_scan: 'Integritetsskanning av efterlevnad',
        procedure_access_review: 'Kampanj för åtkomstgranskning',
        procedure_dpia_filing: 'DPIA-inlämningsprocess',
        security: 'Plattformssäkerhetskonfiguration: [[TOK_0]] nyckelhantering, sessionspolicyer, MFA-tillämpning, SSO-integration, IP-godkännandelistor och nödåtkomstkontroller av glasögontyp.',
        settings: 'Plattformsomfattande konfiguration: aviseringsinställningar, domänhantering, exportscheman och modulkonfiguration för din organisation.',
        users: 'Användarkontohantering: skapa och hantera användarkonton, tilldela roller, konfigurera avdelningsmedlemskap och spåra inloggningsaktivitet.',
        roles: 'Hantering av roller och behörigheter: definiera anpassade roller, konfigurera granulära behörigheter per modul och framtvinga separering av arbetsuppgifter.',
        profile: 'Dina personliga profilinställningar: visningsnamn, kontaktuppgifter, språkinställningar, modulguideinställningar, tillgänglighetsalternativ och lösenordshantering.',
        consent_properties_bindings: 'Hantera samtyckespolicybindningar över digitala fastigheter. Spåra vilken policyversion som distribueras till varje egendom, identifiera föråldrade bindningar och samordna policyimplementering.',
        consent_properties_templates: 'Hantering av gyllene mallar: definiera standardkonfigurationer för samtycke, jämför egenskaper med mallar och implementera malländringar över egendomsgrupper.',
        consent_properties_compliance: 'Övervakning av samtyckesefterlevnad: upptäck konfigurationsinkonsekvenser mellan egenskaper och gyllene mallar, hantera ändringsförfrågningar genom godkännandearbetsflöden och generera bevispaket för revisionsberedskap.',
        consent_properties_operations: 'Operationell hantering för samtyckesegenskaper: konfigurera automatiserade ögonblicksbildscheman, organisera egenskaperna i grupper och granska granskningsspåret för samtyckesegenskapen.',
        consent_properties_audit: 'Revision och analys av samtyckesegendomar: granska konfigurationsändringshistoriken, analysera trender för efterlevnad av fastigheter och generera efterlevnadsrapporter för regulatorisk granskning.',
        classification_taxonomies: 'Definiera och hantera dataklassificeringstaksonomier med känslighets- och betydelsedimensioner. Konfigurera klassificeringsnivåer, hanteringskrav och [[TOK_0]] risknivåer.',
        classification_labeling: 'Tillämpa klassificeringsetiketter på datatillgångar. Skicka in etiketter för granskning, hantera massklassificering och spåra etikettstatus i ditt datalager.',
        classification_lifecycle: 'Spåra livscykeln för klassificerade datatillgångar genom steg: utkast, aktiv användning, under granskning, arkivering och pågående radering. Övervaka kvarhållningsperioder och aktivera raderingsarbetsflöden.',
        classification_gaps: 'Upptäck och hantera klassificeringsluckor i ditt datalager. Kör gapdetektering för att identifiera omärkta tillgångar och saknade livscykeltilldelningar och spåra sedan åtgärdande.',
        classification_reviews: 'Hantera klassificeringsgranskningsuppgifter med eskaleringstimer. Granska föreslagna etiketter, hantera undantag och se till att klassificeringsbeslut fattas i rätt tid.',
        incidents_breach: 'Hantera meddelanden om dataintrång och myndighetsrapportering. Skapa meddelandepaket, spåra regulatoriska deadlines och dokumentera den fullständiga tidslinjen för överträdelsesvar.',
        incidents_authority: 'Hantera formella myndighetsförfrågningar från tillsynsorgan. Spåra inkommande förfrågningar, sätt ihop bevispaket, hantera verifieringschecklistor och håll svarstiderna.',
        incidents_disclosure: 'Upprätthålla det centraliserade avslöjningsregistret för all kommunikation med tillsynsmyndigheter. Registrera avslöjandedatum, kanaler, mottagare och innehållssammanfattningar för efterlevnad av granskningsspår.',
        incidents_reports: 'Generera och hantera incidentrapporter för intern granskning och regulatorisk inlämning. Skapa detaljerade incidentsammanfattningar, spåra rapportstatus och exportdokumentation för myndighetshandlingar.',
        incidents_tasks: 'Koordinera incidenthanteringsuppgifter över team. Skapa uppgiftschecklistor, tilldela ägare, spåra prioriteringar och beroenden, eskalera blockerade objekt och övervaka slutförandets framsteg.',
        incidents_supplements: 'Hantera kompletterande dokumentation som begärs av tillsynsmyndigheter efter första anmälan om överträdelse. Spåra kompletteringsförfrågningar, förbered svarspaket och övervaka inlämningsdeadlines.',
        incidents_remediation: 'Spåra korrigerande åtgärder som tilldelats avdelningar och användare för att åtgärda grundorsaken och konsekvenserna av incidenter. Övervaka implementeringsdeadlines, verifiera slutförandet och dokumentera korrigeringsbevis.',
        incident_ops_playbooks: 'Skapa och hantera spelböcker för incidentrespons. Definiera eskaleringsvägar, tilldela svarsteam och aktivera spelböcker under liveincidenter.',
        incident_ops_sla: 'Spåra SLA:er för incidentrespons och regulatoriska deadlines. Övervaka efterlevnaden av lagstadgade tidslinjer för meddelanden och mät mätvärden för svarsprestanda.',
        incident_ops_evidence: 'Underhåll beviskedjor för incidenter och genomför granskningar efter incidenten. Generera regulator-färdiga exportpaket med komplett incidentdokumentation.',
        data_mapping_systems: 'Registrera och hantera system som behandlar personuppgifter. Dokumentera systemägande, datakategorier, bearbetningsändamål och efterlevnadspoäng.',
        data_mapping_flows: 'Kartlägga dataflöden mellan system, inklusive gränsöverskridande överföringar. Dokumentera datarörelsevägar, överföringsmekanismer och mottagarjurisdiktioner.',
        data_mapping_activities: 'Dokumentera bearbetningsaktiviteter och generera Records of Processing Activities (RoPA). Länka aktiviteter till rättsliga grunder, syften och datakategorier.',
        data_mapping_governance: 'Hantera datastyrningsuppdrag, attestationscykler och riskbedömningar. Spåra styrande ägande och granska scheman över din datainventering.',
        data_mapping_reference: 'Hantera referensdata för datamappning: datakategorier, bearbetningsändamål, lagringspolicyer och exportkonfigurationer.',
        data_mapping_categories: 'Hantera datakategorikatalogen: namn, känslighetsnivåer, exempel och taggar. Grund för varje klassificering och kartläggning.',
        data_mapping_purposes: 'Katalogbehandlingsändamål med deras rättsliga grund. Används av ROPA, [[TOK_0]] och laglighetsrevisioner.',
        data_mapping_retention: 'Konfigurera lagringspolicyer, kasseringsmetoder och granska kadens. Överensstämmer med kraven i dekret 13/2023 och dekret 356/2025.',
        data_mapping_exports: 'Exportera ROPA, system, syften och kategorier till [[TOK_0]], [[TOK_3]], [[TOK_2]] eller [[TOK_1]]. All export landar i plattformen File Browser.',
        data_mapping_attestation: 'Schemalägg och övervaka databeviscykler. Spåra slutförandet av attesteringar över hela ditt datalager.',
        data_mapping_review: 'Granskningskö för klassificering: granskningsuppgifter, kvalitetssignaler och godkännandestatus.',
        data_mapping_risk: 'Riskbedömning för bearbetningsaktiviteter: poängramverk, begränsningsplaner och effektivitetsspårning.',
        data_mapping_evidence: 'Bevis kopplat till bearbetningsaktiviteter: säkerhetscertifikat, DPA-kontrakt, [[TOK_0]] rapporter.',
        data_mapping_inventory: 'Översikt över klassificeringsinventering: taggar, känslighetsnivåer och organisationsövergripande distribution.',
        data_mapping_exceptions: 'Undantagsregister för klassificeringar: motivering, godkännare, giltighetsfönster och åtgärdsväg.',
        data_mapping_history: 'Ändringshistorik för klassificering: vem ändrade vad, när och varför.',
        access_accountability_logs: 'Realtidsström av händelser med privilegierad åtkomst. Koppla ihop med policysidan för att definiera vem som kan nå varje datazon; par med utredningar för att följa upp avvikelser.',
        access_accountability_policies: 'Utformning av åtkomstzonspolicy: deklarera vilka roller och användare som kan nå varje datazon, med tidsbegränsade undantag. Driver tillsynen kontrollerar den ytan i stockarna.',
        access_accountability_anchoring: 'Förankringssäker förankring av åtkomstloggen till en hashkedja. Krävs för VN Cybersecurity Law revisionsspår integritet.',
        access_accountability_investigations: 'Case-arbetsyta för att undersöka misstänkta åtkomsthändelser. Tidslinje, länkade loggar, bevispaket och arbetsflöde för stängning av ärenden i en vy.',
        assessment_triggers: 'Regler som automatiskt öppnar en [[TOK_0]] eller dossierfil när uppströmsändringar (ny bearbetningsaktivitet, ny leverantör, nytt gränsöverskridande flöde) uppfyller utlösningsvillkoret.',
        connectors_gap_register: 'Katalog över oimplementerade eller partiella kontakter. Triage objekt, tilldela ägare, spåra luckor över färdplanen.',
        connectors_system_inventory: 'Inventering av varje system nås via en anslutning. En enda källa till sanning för datakartan.',
        connectors_traceability: 'End-to-end-linje för ett dataelement över system länkade via kopplingar. Viktigt för ROPA-noggrannhet och uppfyllande av ämnesförfrågan.',
        consent_properties_change_requests: 'Pipeline av föreslagna ändringar av en samtyckesegendom (tillagt syfte, nytt språk, uppdaterad policylänk). Styrningsgranskning innan produktionsutrullning.',
        consent_properties_comparison: 'Jämförelse sida vid sida av formen för samtyckesegendomen över domäner eller implementeringar. Flaggor driver som skulle försvaga verkställbarheten.',
        governance_playbooks: 'Playbook-mallar som driver upprepningsbara styrningsarbetsflöden (introduktion av leverantörer, DPA-granskning, överföringsbedömning).',
        incident_ops_coordination: 'Samordningspanel för en aktiv incident. En plats för att se vem som är på den, vad de gör och vad som är blockerad.',
        incident_ops_escalation: 'Eskaleringslogg för aktiva incidenter. Allvarlighetsövergångar, intressentmeddelanden och ledningsmanualer registreras här.',
        incident_ops_post_review: 'Granskning efter incidenten: analys av grundorsaker, tidslinje, åtgärdande åtgärder och lärdomar. Matar in i träning och uppdateringar av spelböcker.',
        incident_ops_regulator_exports: 'Generera tillsynspaket för anmälningspliktiga incidenter. Mẫu số 08 (överträdelse) + paket med stödjande bevis.',
        incident_ops_vendor_coordination: 'Koordinera svar med leverantören vars system har brutits. Kontraktsåtaganden, SLA:er för svar och delad beviskedja.',
        monitoring_authority_readiness: 'Checklista för beredskap och bevispaket för kommande tillsynsbesök. Konsoliderad bild av utestående luckor och genomförda kontroller.',
        monitoring_change_review: 'Regelbunden granskning av kontrollförändringar över hela övervakningsprogrammet. Upptäcker drift innan det blir en efterlevnadslucka.',
        monitoring_framework_link: 'Länka övervakningskontroller till specifika ramverksartiklar. Genererar beviskartan som regulatorer förväntar sig.',
        monitoring_ric: 'Tillsynsutredning och korrespondensärenden. Spåra frågor och svar från tillsynsmyndigheten över tid.',
        forms: 'Föreskriftsformulärkatalog, formulärutfyllare, formulärinstanser och länkar för arkivärenden. Ryggraden för Mẫu số 02a/02b och relaterade inlämningar.',
        monitoring_tasks: 'Övervakningsuppgiftskö: schemalagda kontrollverifieringar, intyg och bevisuppdateringar.',
        partner_workspace_reports: 'Rapporter som delas över partnernätverket: efterlevnadshälsa, månatliga sammanfattningar, statistik över organisation.',
        partner_workspace_tickets: 'Stödbiljetter som samlats in mellan partners om delade arbetsflöden och upptrappningar.',
        program_governance_audit_readiness: 'Granskningsberedskapsbedömning med borrning av saknade bevis, luckaregister och ägare av sanering.',
        program_governance_drafting: 'Arbetsyta för dokumentritning med versionshantering, granskningsrutt och arbetsflöde för godkännande.',
        program_governance_evidence_gaps: 'Evidence-gap register: vilka kontroller som saknar aktuella bevis och när uppdateringen ska ske.',
        program_governance_executive_summaries: 'Sammanfattningsmallar med automatiskt ifyllda KPI:er för styrelse- och ledningsmöten.',
        program_governance_health: 'Övergripande programhälsoinstrumentpanel: mognad, täckning och trendindikatorer.',
        program_governance_issuance: 'Arbetsflöde för utfärdande av dokument: godkännande, publicering, intressentmeddelande.',
        program_governance_model: 'Verksamhetsmodell för styrning: roller, ansvar, kommittéer och beslutsrätt.',
        program_governance_remediation: 'Saneringsplaner kopplade till identifierade luckor. Ägare, deadline, status och verifieringsbevis.',
        program_governance_review_cadence: 'Schemalagd granskningstakt för styrningsartefakter: policyer, procedurer, kontroller, bevis.',
        program_governance_trends: 'Trendinstrumentbräda: mognad över tid, bevisnyhet, spaltstängningshastighet.',
        task_management_conflicts: 'Upptäck motstridiga uppgiftstilldelningar (dubbelbokade ägare, överlappande deadlines) och lös via omtilldelning.',
        task_management_consolidation: 'Konsolidera uppgifter som genereras automatiskt av flera moduler till ett enda arbetsflöde för mottagaren.',
        localization_dashboard: 'Lokaliseringsmodulöversikt: ramkatalogens hälsa, paketstatus, översättningstäckning och väntande regulatoriska uppdateringar i en instrumentpanel.',
        localization_frameworks: 'Regelverkskatalog: [[TOK_1]], dekret 13/2023, dekret 356/2025, cybersäkerhetslag och [[TOK_0]]. Varje ramverk länkar artiklar till plattformskontroller.',
        localization_framework_channels: 'Inlämningskanaler för regulatorer som är länkade till varje ramverk ([[TOK_1]]-portal, [[TOK_0]] slutpunkt, e-post till auktoritet). Driver routing av Mẫu số-filer.',
        localization_framework_detail: 'En-framework detaljvy: artiklar, procedurer, personas, länkade formulär och implementeringsdjup över hela plattformen.',
        localization_framework_module_links: 'Ramverk → modultäckningskarta. Vilka regleringsartiklar upprätthålls av vilken plattformsmodul.',
        localization_language_packs: 'Språkpaketkatalog över 16 språk: installationsstatus, översättningsfullständighet och paketinlämningshistorik.',
        localization_audit: 'Granskningsspår för lokaliseringsändringar: ramverksredigeringar, paketuppdateringar, inlämningshändelser.',
        localization_market_packs: 'Marknadspaketkatalogpaketeringsram + språk + formulär per marknad (VN, EU-medlemsstater, etc.).',
        localization_module_mappings: 'Modulmappningsregister: vilken ramartikel som gäller för vilken modul på funktionsnivå.',
        localization_pack_detail: 'Enkelt paket detaljvy: version, ramverk ingår, översättningstillstånd, installationshistorik.',
        localization_pack_submissions: 'Packinlämningspipeline: partnerinlämningar, granskningsstatus, publiceringsgodkännanden.',
        localization_regulatory_updates: 'Föreskriftsuppdateringsflöde: nya dekret, ändringar och vägledning som påverkar ramkatalogen.',
        localization_sector_overlays: 'Sektoröverlagringskatalog: valfria branschspecifika regleringspaket (t.ex. bank, sjukvård). Installera i direktläge för organisationer inom omfattningen eller referensläge för tvärsektoriell synlighet.',
        localization_help_content_packs: 'Help-Content Pack-hanteraren: installera, versionera och översätt hjälpartiklarna i appen, modulguiderna och snabbstarterna som dyker upp i administratörsgränssnittet.',
        localization_translation_preview: 'Live förhandsvisning av gränssnittssträngar över olika språk. Jämförelse sida vid sida för QA översättning.',
        organizations_groups_create: 'Skapa en ny organisationsgrupp (koncern): välj rotorganisation, välj medlemmar, definiera arvsläge per kategori.',
        organizations_groups_detail: 'Enskild organisationsgruppsinformation: medlemmar, arvsmatris, delade resurser och granskningssammanfattning.',
        organizations_groups_settings: 'Organisationsgruppsinställningar: [[TOK_0]], kalender, aviseringar, intag, [[TOK_1]] integration. Växla för ärvning/åsidosättning per kategori.',
        organizations_groups_audit: 'Granskningslogg per grupp: medlemskapsändringar, växling av arv, lägg till/ta bort med delad resurs.',
        organizations_groups_consolidated_audit: 'Konsoliderad revisionsvy över alla medlemsorganisationer i en grupp. Filtrera efter enhet, skådespelare, tidsfönster.',
        organizations_groups_dashboard: 'Översikt över medlemmar: efterlevnadshälsa, öppna objekt, [[TOK_0]] överträdelser rullade upp för hela gruppen.',
        organizations_groups_reports: 'Rapporter på gruppnivå: sammanfattning, sammanställning av regulatorer, jämförelse mellan [[TOK_0]] mellan medlemmar.',
        organizations_groups_users: 'Användare som är synliga i hela gruppen: rolltilldelningar över organisationer, delade administratörer, identitetskedja.',
        organizations_groups_merged_vendors: 'Avduplicerad leverantörsvy över medlemsorganisationer – en enskild leverantör visas en gång även om den är inbyggd separat.',
        organizations_groups_shared_templates: 'Formulärmallar publicerade på gruppnivå. Medlemmar väljer att ärva en mall; opt-out är per organisation.',
        organizations_groups_shared_frameworks: 'Regelverk som delas över hela gruppen. Central uppdatering flödar till varje medlem med mode=inherit.',
        organizations_groups_shared_vendors: 'Leverantörsregister på gruppnivå. Kontrakt, DPA-status och riskpoäng som är synliga för varje medlem.',
        onboarding_help_center: 'Hjälpcenter: bläddra bland alla 309+ artiklar efter modul, kategori och person. Fulltextsökning i EN + VI-innehåll.',
        onboarding_progress: 'Onboarding progress tracker: vilka startsteg som är klara, vilka som väntar, vem som äger blockerarna.',
        onboarding_personas: 'Persona-drivna onboard-resor för de 10 VN-rollerna (P-VN-01 till P-VN-10). Varje resa är en sammanställd lista med första åtgärder.',
        onboarding_quick_starts: 'Snabbstartscenarier: kör ett komplett efterlevnadsarbetsflöde från början till slut i sandlådan. Idealisk för träning.',
        onboarding_sample_data: 'Exempel på datagenerator: ladda realistiska demo-rader i valfri modul. Användbar för försäljningsdemonstrationer och utbildning.',
        onboarding_tours: 'Interaktiva guidade turer. Starta en modulspecifik genomgång som berättar varje sida när du navigerar.',
        security_sessions: 'Livevisning av autentiserade sessioner: enhet, IP, senaste aktivitet, MFA-faktor som används. Avsluta med ett klick.',
        security_api_keys: 'Nycklar för tjänstkonto [[TOK_0]]: omfattning, rotation, senast använda och granskningsspår per nyckel.',
        security_break_glass: 'Nödåtkomst av glasögon: tidsbegränsat superadminbidrag med obligatorisk revisionsspår och granskning efter händelse.',
        security_delegations: 'Tillfälliga rolldelegationer: täckning utanför kontoret, godkännandekedjor, automatiskt upphörande.',
        security_ip_allowlist: 'Konfiguration av IP-godkännandelista: begränsa administratörsinloggning till specifika företagsnätverk eller VPN-intervall.',
        security_mfa: 'Flerfaktorsautentiseringspolicy: verkställighet per roll, faktorgodkännandelista (TOTP/SMS/WebAuthn), återställningsflöde.',
        security_service_accounts: 'Tjänsten står för system-till-system-integration. Omfattning, granskad och roterad separat från mänskliga användare.',
        security_session_settings: 'Sessionspolicy: inaktiv timeout, högsta sessionsålder, gräns för samtidiga sessioner, utlösare för omautentisering.',
        security_sso: 'Konfiguration för enkel inloggning: SAML/OIDC-leverantörer, attributmappning, regler för automatisk administration.',
        rights_requests_create: 'Skapa ett nytt ärende för begäran om rättigheter för registrerade. Fångar begärandens identitet, begäranstyp, kanal och [[TOK_0]] klockstart.',
        rights_requests_list: 'Alla rättighetsbegäranden med [[TOK_0]] nedräkning, mottagare, status och filterchips för kanal + begäran typ.',
        rights_requests_detail: 'Arbetsyta för enstaka fall: korrespondens, fullgörandeåtgärder, bevis, utarbetande av svar, [[TOK_0]] övergångar.',
        rights_requests_cmp_sync: '[[TOK_0]] integrationssynkroniseringsinställningar: webhook-slutpunkt, regler för att skapa ärenden automatiskt, policy för försök igen.',
        rights_requests_extensions: '[[TOK_0]] förlängningsförfrågningar: motivering, routing för godkännare och införande av revisionsspår vid beviljande/avslag.',
        rights_requests_fulfillment: 'Arbetsyta för beställningsuppfyllelse: samla in datapaket, tillämpa redigeringar, paketera för leverans.',
        rights_requests_responses: 'Svarsutkast med mallinfogning, sammanfogningsfält och sida vid sida EN/VI-förhandsgranskning.',
        rights_requests_response_templates: 'Svarsmallkatalog: godkända mallar per förfrågningstyp + jurisdiktion, med versionshistorik.',
        compliance_forms_consolidation_create: 'Skapa ett nytt konsolideringsärende: gruppera relaterade formulärinlämningar under ett enda arkiveringspaket avsett för en regulator.',
        compliance_forms_consolidation_detail: 'Arbetsyta för enstaka konsolideringsärenden: sektionsindata, granskaregodkännanden, export av hela underlaget till tillsynsmyndigheten.',
        compliance_forms_consolidation_cases: 'Alla konsolideringsärenden med arkiveringsstatus, granskaruppdrag och deadline-spårning.',
        compliance_forms_consolidation_review: 'Granska arbetsytan för konsolideringsärenden: godkänn sektionsinmatningar, begär revisioner, logga av före export.',
        compliance_forms_dossier_export: 'Exportera det konsoliderade underlaget som ett regulatorfärdigt [[TOK_0]]-paket med följebrev, bilagor och signaturer.',
        compliance_forms_section_input: 'Avdelningsägares arbetsyta för att slutföra ett enda avsnitt av ett konsolideringsärende.',
        compliance_forms_filing_case_links: 'Länkar mellan formulärinstanser och arkivärenden. Säkerställer att varje arkivering backas upp av rätt formulärdata.',
        compliance_forms_section_routing: 'Regler för sektionsdirigering: vilken avdelning äger vilken sektion av varje formulärmall.',
        assessments_dashboard: 'Instrumentpanelen för bedömningar: [[TOK_0]] antal, överföringsbedömningar, sammanfattning av luckor, kommande granskningsdeadlines.',
        assessments_dossier_filing_detail: 'Enskild arkivering: formulärtyp (Mẫu số 02a/02b), sektionsuppgifter, sektionsstatus, inlämningsdetaljer, [[TOK_0]] timers.',
        assessments_dossier_filing_list: 'Alla underlagsansökningar med formulärtyp, status och sektionstilldelningsförlopp. Filtrera efter status och ramverk.',
        assessments_dpia_list: '[[TOK_0]] register: alla pågående, godkända och arkiverade dataskyddskonsekvensbedömningar.',
        assessments_gap_report: 'Gap Report: [[TOK_0]] täckning, oklassificerade [[TOK_1]] krav, oförminskade risker, saknade anmälningar. Primär revisionsberedskapsyta.',
        assessments_transfer_list: 'Överföringsbedömningar för gränsöverskridande dataflöden. Varje bedömning dokumenterar mekanism, skyddsåtgärder och riskklassificering.',
        deletion_orchestration_templates: 'Checklistamallar för raderingskörningar. Varje mall är en skriptad sekvens av uppgifter kopplade till specifika system och lagringsregler.',
        deletion_orchestration_dsr_integration: 'DSR-till-radering-integration: utlöser automatiskt en raderingskörning från en godkänd raderingsbegäran.',
        deletion_orchestration_tasks: 'Exekveringsuppgifter för aktiva borttagningskörningar. Varje uppgift spårar system, åtgärd, ägare och verifieringsbevis.',
        deletion_orchestration_dashboard: 'Instrumentpanel för raderingsorkestrering: aktiva körningar, slutförandefrekvens, väntande verifieringar, korrekturkedjans färskhet.',
        deletion_orchestration_proof_chain: 'Säkerhetssäker kedja för varje raderingsåtgärd. Krävs för [[TOK_0]] efterlevnad vid radering.',
        organizations_compliance_rollup: 'Samordning av efterlevnad mellan enheter: [[TOK_0]] per enhet, täckning på ramnivå, utestående åtaganden.',
        organizations_departments_admin: 'Administratörsarbetsyta för avdelningar: skapa, tilldela om ägare, hantera gruppmedlemskap, ange routingregler.',
        organizations_departments: 'Avdelningar listar över enheter. Driver sektionsdirigering, godkännandeflöden och bevistillskrivning.',
        organizations_entity_frameworks: 'Tilldela regelverk till varje enhet. Driver vilka Mẫu số blanketter gäller och vilka revisioner är obligatoriska.',
        organizations_entity_form: 'Skapa eller redigera en enskild organisationsenhet: juridiskt namn, företagsregistrering, adress, representant.',
        organizations_list: 'Alla organisationsenheter över hyresgästen. Primär listvy med statusfilter och snabbåtkomståtgärder.',
        organizations_retention_policies_admin: 'Administration av lagringspolicy som omfattas av organisationen: standardregler, åsidosättningar per enhet.',
        task_management_calendar: 'Kalendervy över uppgifter och deadlines. Färgkodad efter modul och [[TOK_0]] tillstånd.',
        task_management_my_tasks: 'Personlig uppgiftskö: tilldelad till mig, förfaller snart, försenad. Primär daglig arbetsplats.',
        task_management_overdue: 'Förfallna uppgifter i hela organisationen. Filtrerar efter ägare, modul och förfallna dagar.',
        task_management_section_assignments: 'Sektionsuppdragsöversikt: vilken avdelning äger vilken sektion av varje aktiv formulärinlämning.',
        task_management_board: 'Kanban styrelse syn på uppgifter. Dra mellan kolumner (Att göra / Pågående / Granska / Klar) för att uppdatera status.',
        task_management_detail: 'Arbetsyta för en enda uppgift: beskrivning, kommentarer, bilagor, deluppgifter, granskningsspår, statusövergångar.',
        task_management_list: 'Platt lista över alla uppgifter med filter: ägare, modul, status, prioritet, förfallodatum.',
        consent_cmp_sync: '[[TOK_0]] synkroniseringsarbetsyta: utlösa synkroniseringar, granska synkroniseringshistorik, inspektera fel. Håller [[TOK_1]] tillstånd i linje med plattformen.',
        consent_cmp_bulk_sync: 'Bulk [[TOK_0]] synkronisering: synkronisera om alla samtyckesposter för alla egenskaper. Används för hyresgästmigreringar och stora [[TOK_1]] ändringar.',
        consent_cmp_integration: '[[TOK_0]] integrationsinställningar: slutpunkt, autentisering, synkroniseringspolicy och anslutningshälsa.',
        consent_cmp_purpose_mapping: 'Kartlägg [[TOK_0]] ändamål till plattformsändamål. Säkerställer att samtyckessignaler flödar korrekt mellan de två systemen.',
        consent_cmp_webhook: '[[TOK_0]] webhook config: inkommande händelse routing, signering hemligheter, försök igen.',
        partner_workspace_brand_profiles: 'Partners varumärkesprofiler: logotyp, tagline, kontakt, tjänsteerbjudanden. Driver lista över partnermarknadsplatsen.',
        partner_workspace_deliverable_templates: 'Levererbar mallkatalog: standardiserade servicepaket som partner kan erbjuda ([[TOK_0]] granskning, leverantörsrevision, utbildning).',
        partner_workspace_deliverables: 'Aktiva leveranser över partnerengagemang. Spåra omfattning, förfallodatum, acceptanskriterier.',
        partner_workspace_service_tiers: 'Servicenivådefinitioner: Brons / Silver / Guld med omfattning, [[TOK_0]] och prisklasser.',
        partner_workspace_workflow_instances: 'Aktiva arbetsflödesinstanser mellan partners: onboarding, granskning, eskalering, offboardingkörningar.',
        partner_workspace_workflow_templates: 'Arbetsflödesmallkatalog för partnerengagemang. Varje mall definierar steg, ägare, SLA:er och utgångar.',
        access_accountability_justification_reviews: 'Granska åtkomstmotiveringar som skickats av användare. Godkänn, utmana eller eskalera per zonpolicy.',
        access_accountability_review_campaigns: 'Schemalagda kampanjer för åtkomstgranskning: återkommande, omfattning, granskaruppdrag, slutförandespårning.',
        access_reviews_list: 'Alla åtkomst-recensionskampanjer med filter: cykel, status, granskare, målsystem.',
        access_reviews_campaign_detail: 'Arbetsyta för en enda kampanj: omfattning, granskare, artikelkö, certifieringsstatus, revisionsspår.',
        access_reviews_my_reviews: 'Recensioner tilldelade mig: väntande beslut med sammanhang, intyga eller återkalla per artikel.',
        attestation_schedules_list: 'Attestschemaregister: upprepning, omfattning, nästa förfallodatum, slutförandegrad per schema.',
        attestation_schedules_create: 'Skapa ett nytt verifieringsschema: plockfrekvens, omfattning, verifierare och beviskrav.',
        attestation_schedules_edit: 'Redigera ett befintligt attestschema. Ändringar gäller för nästa cykel; tidigare cykler förblir oförändrade.',
        attestation_schedules_history: 'Historisk tidslinje för slutförande av ett attestschema. Bevisartefakter kopplade per cykel.',
        governance_board_report: 'Styrelseklar efterlevnadsrapport: sammanfattning, resultattrender, utestående risker, åtgärdsstatus.',
        governance_compliance_score: 'Beräkning av efterlevnadspoäng över ramar. Drill-down i bidrag per kontroll.',
        governance_drift_monitor: 'Upptäck kontrolldrift: ändringar i inställningar, beviljande av tillstånd, policyundantag som försvagar hållningen.',
        governance_audit: 'Styrningsspecifik revisionslogg: arbetsflödeshändelser, godkännandebeslut, driftsignaler.',
        governance_evidence: 'Beviskatalog för styrningskontroller. Stöddokument, skärmdumpar, intygskvitton.',
        partner_workspace_escalation: 'Översiktspanel för eskalering mellan partner: öppna eskalationer, allvarlighetsgrad, [[TOK_0]] klockor och nästa åtgärdsägare.',
        partner_workspace_audit: 'Granskningslogg för partnerarbetsytan: engagemangsändringar, leveransbara uppdateringar, eskaleringsövergångar.',
        partner_workspace_partner_detail: 'Enskild partnerorganisationsprofil: engagemangshistorik, aktiva resultat, kontakter, resultatpoäng.',
        partner_workspace_partner_list: 'Partnerorganisationsregister: aktiva, onboarding- och offboard-partners med servicenivå + prestandamärken.',
        platform_license: 'Licensinställningar: nivå, antal platser, förnyelsestatus, funktionsknappar som drivs av den installerade licensen.',
        platform_notifications_admin_queue: 'Administratörsaviseringskö: varningar under flygning, leveransfel, försök igen över e-post/SMS/in-app-kanaler.',
        platform_notifications_prefs: 'Aviseringsinställningar per användare: kanalval, sammanfattningsschema, dämpade ämnen.',
        settings_overview: 'Översikt över hyresgästinställningar: snabblänkar till domäner, e-post, export, webhooks och andra plattformsomfattande konfigurationer.',
        settings_domains: 'Tillåtna domäner för registrering och SSO. Begränsar kontoskapandet till verifierade företagsdomäner.',
        settings_email: 'Utgående e-postkonfiguration: SMTP-leverantör, avsändaridentitet, DKIM/SPF-status, test-e-postverktyg.',
        settings_export_schedules: 'Schemalagda exporter: återkommande [[TOK_0]]/[[TOK_2]]/[[TOK_1]]-generering levererad till filläsaren enligt ett cron-schema.',
        settings_webhooks: 'Outbound webhook endpoints: prenumerera externa system på plattformshändelser. Signering, försök igen, revision av varje leverans.',
        sod_rules_create: 'Skapa en regel för uppdelning av arbetsuppgifter: välj motstridiga rollpar, omfattning och tillämpningsläge (blockera/varna).',
        sod_rules_edit: 'Redigera en befintlig SoD-regel. Ändringar träder i kraft omedelbart; befintliga överträdelser omvärderas vid nästa åtkomst.',
        sod_rules_list: 'Alla SoD-regler över hyresgästen: verkställighetsläge, rollpar, antal undantag, antal överträdelser.',
        connectors_definitions: 'Anslutningstypsregister: definition av varje integration (slutpunktsform, autentisering, operationer som stöds).',
        connectors_list: 'Alla anslutningsinstanser kopplade till hyresgästen. Status, senaste synkronisering, fellogg, sync-on-demand-åtgärd.',
        connectors_credentials: 'Anslutningsreferensvalv: [[TOK_1]] tokens, [[TOK_0]] nycklar, tjänstkontolösenord. Rotationsschema + revision.',
        connectors_event_bus: 'Connector-händelsebuss: inkommande händelser från integrationer, routingregler, återuppspelning av dödbokstavskö.',
        consent_change_awareness: 'Upptäck meningsfulla samtyckesändringar: syfte tillagt, policy uppdaterad, omfattning utökad. Driver kampanjer för nytt samtycke.',
        consent_audit: 'Granskningsspår för samtycke: varje anslag, uppdatering, tillbakadragande över arbetsflöden. Primär yta för regulatorgenomgångar.',
        consent_reconciliation: 'Jämför samtyckestillstånd över [[TOK_0]], plattform och nedströmssystem. Flaggar avvikelser.',
        consent_withdrawal_propagation: 'Utbredningspipeline för återkallelse: när en subjekt drar tillbaka samtycke, se till att det flödar till alla länkade system.',
        consent_policies: 'Samtyckspolicykatalog: versioner av sekretesspolicy, språkvarianter, aktiveringsfönster.',
        consent_purpose_catalog: 'Ändamålskatalog som används av samtyckesarbetsflöden. Varje syfte länkar till en rättslig grund och en bevaranderegel.',
        consent_snapshots: 'Ögonblicksbilder av samtycke: fånga alla aktiva samtycken vid tidpunkten. Krävs för revisioner och juridiska innehav.',
        consent_workflows: 'Arbetsflödeskatalog för samtycke. Varje arbetsflöde definierar utlösare, insamlingsflöden och nedströmsåtgärder.',
        discovery_classification_lineage: 'Klassificeringslinje: spåra hur ett dataelement klassificerades över skanningar och manuell granskning.',
        discovery_classification_rules: 'Klassificeringsreglerregister: regex, vokabulär, ML-mönster som används för att autoklassificera upptäckta fält.',
        discovery_dedup_rules: 'Dedupliceringsregler för upptäckta poster. Förhindrar att samma fält visas flera gånger.',
        discovery_import_templates: 'Importera mallar för att ta med befintliga datakataloger till Discovery-modulen via [[TOK_0]] eller externa verktyg.',
        discovery_owner_review: 'Ägargranskningskö: föreslagna klassificeringar som väntar på dataägarens godkännande eller avslag.',
        discovery_staging: 'Uppställningsområde för nyupptäckta fält. Triage före befordran till Data Mapping-katalogen.',
        discovery_suggestion_analytics: 'Analys för förslagsmotorn: noggrannhet, täckning, de flesta åsidosatta klassificeringarna.',
        discovery_suggestion_queue: 'Granska kön med föreslagna klassificeringar innan de tillämpas. Acceptera, ändra eller avvisa per artikel.',
        compliance_forms_filler: 'Interaktivt formulärutfyllare: stega igenom ett regleringsformulär med validering, autospara och stöd för medförfattare.',
        compliance_forms_instance_detail: 'Enformsinstans: aktuellt tillstånd, historik, länkat arkivärende, exporter.',
        compliance_forms_outputs: 'Genererade utdata per formulärinstans: [[TOK_2]], [[TOK_1]], [[TOK_0]] paket med följebrev och signaturer.',
        compliance_forms_submission_packages: 'Inlämningspaketkatalog: regulatorfärdiga paket med manifest, signaturer och leveranskvitto.',
        incident_ops_regulatory_sla: 'Regulatorisk [TOK_2]]-konfiguration för incidentmeddelanden (VN Cybersecurity Law 72-timmarsfönster, [[TOK_1]] 72-timmar, [[TOK_0]] 72-timmar).',
        incident_ops_response_metrics: 'Incidentsvarsstatistik: MTTD, MTTR, [[TOK_0]] efterlevnadsgrad, eskaleringsantal.',
        incident_ops_sla_dashboard: '[[TOK_0]] instrumentpanel: aktiva incidenter mot deras [[TOK_1]] klocka, riskvarningar, intrångshistorik.',
        incident_ops_sla_definitions: '[[TOK_0]] definitioner: allvarlighetsnivåer, per-tier-svar och upplösningsfönster, ramverkshänvisningar.',
        monitoring_governance_raci: 'RACI-matris för styrningskontroller: ansvarig, ansvarig, konsulterad, informerad per kontroll över hela programmet.',
        monitoring_periods: 'Övervakningsperioder: årliga/kvartalsvisa/månatliga granskningscykler anpassade till lagstadgade ansökningsperioder.',
        monitoring_programs_list: 'Övervakningsprogramkatalog: ramanpassade program med omfattning, ägare, kadens.',
        monitoring_task_templates: 'Uppgiftsmallar för övervakning av cykler. Varje mall definierar omfattning, tilldelad roll, beviskrav.',
        access_accountability_evidence_detail: 'Enskilda bevispaketdetaljer: spårbarhetskedjan, signaturer, exportalternativ för inlämnande av tillsynsmyndigheter.',
        access_accountability_evidence_packages: 'Bevispaketkatalog för åtkomstansvar: signerade, manipuleringssäkra paket redo för granskning.',
        access_reviews_role_analytics: 'Rollanalys: rollanvändningstäthet, berättigandekrypning, certifierings-beslutstrender.',
        access_accountability_pattern_analysis: 'Mönsteranalys över åtkomstloggar: ovanliga åtkomsttider, geografiska extremvärden, privilegieskaleringssignaler.',
        access_accountability_session_dashboard: 'Sessionsinstrumentpanel: live-autentiserade sessioner, sessionsvärmekarta per timme/dag, varningar om inaktiva sessioner.',
        classification_exports: 'Klassificeringsexport: exportera klassificeringsinventeringen som [[TOK_0]]/[[TOK_1]] för externa revisionsverktyg.',
        classification_discovery_cycles: 'Upptäcktscykler för klassificering: schemalagda skanningar som visar nytillagda eller ändrade dataelement.',
        classification_enterprise_data_map: 'Företagsdatakarta: aggregerad klassificeringsvy över system, avdelningar och känslighetsnivåer.',
        connectors_automation_planning: 'Automationsplanering: definiera trigger → koppling → åtgärdskedjor för händelsedrivna dataoperationer.',
        connectors_brd_capture: 'Affärskrav Dokumentfångst för nya anslutningsutbyggnader.',
        connectors_poc_scorecards: 'Proof-of-concept styrkort för att utvärdera nya kopplingsintegrationer mot acceptanskriterier.',
        discovery_connector_management: 'Hantering av upptäcktsanslutningar: vilka skannrar som är installerade, deras hälsa och vilka system de riktar sig till.',
        discovery_scans_list: 'Alla upptäcktsskanningar med status, täckning och upptäckter. Gå igenom resultaten per skanning.',
        governance_approvals: 'Kön för ledningsgodkännanden: väntande beslut över leverantörsintroduktion, DPA-granskningar, överföringsbedömningar.',
        governance_offboarding: 'Leverantörens arbetsflöde: uppsägning av kontrakt, dataretur/radering, återkallande av åtkomst, slutrevision.',
        governance_periodic_review: 'Periodisk leverantörsgranskning: planerad omvärdering av risk, DPA-valuta, underprocessorlista.',
        incident_ops_playbook_activations: 'Active playbook-instanser: vilken playbook körs på vilken incident, framsteg, utestående uppgifter.',
        incident_ops_playbook_links: 'Playbook → incidentkopplingsregister. Även länkar till mallar för regulatormeddelanden per spelbok.',
        incident_ops_playbook_templates: 'Playbook-mallkatalog: återanvändbara incident-respons-skript per incidenttyp och svårighetsgrad.',
        organizations_groups_settings_inheritance: 'Inställning av arvsmatris för gruppmedlemmar. Växla mellan ärv/åsidosättning per kategori med revisionsspår.',
        organizations_intake_config_form: 'Skapa eller redigera en intagskonfiguration: offentlig-form [[TOK_0]] sökväg, hastighetsgränser, captcha, aviseringsdirigering.',
        organizations_intake_configs_list: 'Intagskonfigurationskatalog: ingångspunkter för offentliga rättigheter-begäran per marknad/varumärke.',
        privacy_scanner_monitoring_dashboard: 'Övervakningsinstrumentpanel för sekretessskanner: egendomstäckning, skanningskadens, flaggade signaler per egendom.',
        privacy_scanner_monitoring_settings: 'Övervakningsinställningar: skanningsfrekvens, tröskelregler, varningsdirigering, bibehållande av skanningsresultat.',
        privacy_scanner_settings: 'Skannerinställningar: aktiverade skanningskategorier, signaturuppdateringar, [[TOK_0]] autentiseringsuppgifter för skannerns slutpunkt.',
        privacy_scanner_real_time_scan: 'Realtidsskanning: utlös en ad-hoc-skanning och titta på resultat strömmar in. Perfekt för snabb verifiering.',
        privacy_scanner_scan_result_detail: 'Detaljvy av ett enda skanningsresultat: cookies, beacons, spårare som hittats, klassificering, åtgärdsåtgärder.',
        privacy_scanner_results_archive: 'Arkiv med historiska skanningsresultat. Filtrera efter egenskap, datumintervall, signaltyp.',
        task_management_workflow_detail: 'Enstaka arbetsflödesinstans: alla steg, ägare, SLA:er, förgreningslogik, slutförandebevis.',
        task_management_workflow_list: 'Alla arbetsflödesinstanser över moduler: status, ägare, deadline, ursprungsmodul.',
        task_management_workflow_templates: 'Arbetsflödesmallkatalog: återanvändbara arbetsflöden i flera steg som kan instansieras från vilken källmodul som helst.',
        audit_trail_classic: 'Klassisk revisionsspårvy (legacy). Utfasas till förmån för den enhetliga revisionsmodulen.',
        audit_trail_unified: 'Enhetlig revisionsspår över varje modul. Primär revisionsyta.',
        iat_settings: 'Konfigurera tillägget Immutable Audit Trails: aktivering, omfattning, standardprovläge, taxonomiförbidrag, caps och [[TOK_0]] autentiseringsrotation. Läs den kanoniska modulguiden först; den djupa följeslagaren är "Aktivera och konfigurera".',
        iat_status: 'Bläddra i varje proof_link med status-, läges-, modul- och datumfilter. Klicka på valfri märke för att öppna korrekturlådan. Djup följeslagare: "Understanding Proof Status".',
        iat_integrity_center: 'Kör driftdetekteringsverifiering passerar över ett datumintervall; exportera integritetspaketet för alla granskningar. Djup följeslagare: "Använder integritetscentret".',
        iat_usage: 'Spåra aktuellt saldo, månatlig förbrukning, takstatus och lös in kreditpaket. Djup följeslagare: "Credits and Caps".',
        classification_exceptions: 'Klassificeringsundantagskö: poster flaggade som kantfall, väntar på manuell granskning.',
        classification_review_tasks: 'Uppgiftskö för klassificeringsgranskning: automatiskt föreslagna klassificeringar som väntar på ägarens bekräftelse.',
        consent_properties_audit_log: 'Granskningsspår för ändringar av samtyckesegenskap: vem uppdaterade vad, när, gamla/nya värden.',
        consent_properties_analytics: 'Samtycksegenskapsanalys: samtyckesfångsthastighet, uttagsfrekvens, trender för ändamålsblandning.',
        consent_properties_evidence_packs: 'Bevispaket för samtyckesegenskaper: regulatorfärdiga paket som bevisar överensstämmelse med samtyckesfångst.',
        consent_properties_inconsistencies: 'Inkonsekvenser av samtyckesegendom: egenskaper där plattformen och [[TOK_0]] inte är överens om tillstånd.',
        consent_properties_golden_templates: 'Gyllene mallar för samtyckesbanner: godkända, granskade, styrningsklara bannerformer distribuerade över fastigheter.',
        consent_properties_template_rollouts: 'Mallutrullningspipeline: steg, pilot, produktionsvågor för att skjuta gyllene mallar till fastigheter.',
        consent_properties_property_groups: 'Fastighetsgrupper: klusterrelaterade fastigheter för styrning och rapportering.',
        consent_properties_snapshot_schedules: 'Schema för ögonblicksbilder: automatisera periodiska insamlingar av samtyckestillstånd för granskning och lagliga förvaringsändamål.',
        deletion_orchestration_completeness: 'Fullständighetsspårare: verifierar alla system i retentionsomfånget bekräftad radering.',
        deletion_orchestration_runs_list: 'Alla raderingskörningar: status, varaktighet, täckta system, slutförandegrad.',
        deletion_orchestration_vendor_requests: 'Utgående raderingsförfrågningar till leverantörer: spårning, [[TOK_0]], verifieringsartefakter.',
        deletion_orchestration_vendor_verification: 'Arbetsflöde för leverantörsverifiering: bekräfta att leverantörssystem har slutfört raderingen enligt vår begäran.',
        compliance_forms_catalog: 'Överensstämmelseblankettkatalog: alla regleringsformulär (Mẫu số, [[TOK_0]] Art 30, ISO 27701) tillgängliga för arkivering.',
        compliance_forms_template_browser: 'Mallwebbläsare: upptäck godkända formulärmallar över ramar.',
        governance_cross_border: 'Register för gränsöverskridande överföringar på förvaltningsnivå: mekanismer, skyddsåtgärder, landriskbedömning.',
        governance_subprocessors: 'Underprocessorregister: vilka våra leverantörer använder, DPA-kaskad, meddelande om ändringar.',
        incidents_detail: 'Arbetsyta för enstaka incidenter: tidslinje, ägare, allvarlighetsgrad, åtgärdande, status för regulatormeddelanden.',
        incidents_list: 'Incidentregister: alla aktiva + historiska incidenter med filter för svårighetsgrad, kanal, ramverk.',
        partner_workspace_partner_dashboard: 'Partnerinstrumentpanel: KPI:er på toppnivå för alla partnerengagemang, eskaleringsräkningar, hälsotrend.',
        partner_workspace_support_tickets: 'Katalog för partnersupportbiljetter. Delas mellan partner- och hyresgästteam med [[TOK_0]] spårning.',
        program_governance_acknowledgment_tracking: 'Spårning av dokumentbekräftelse: vem som har läst och bekräftat varje policy eller procedur.',
        program_governance_change_log: 'Dokumentändringslogg: varje redigering av ett styrdokument med diff och godkännandekedja.',
        roles_detail: 'Enskild rolldetalj: behörigheter bundna till denna roll, tilldelade användare, granskning av medlemskapsändringar.',
        roles_list: 'Rollkatalog: varje inbyggd och anpassad roll med medlemsantal och behörighetsomfång.',
        consent_properties_cross_property_dashboard: 'Översikt över fastigheter: samtyckeshälsa över alla fastigheter. Aggregerar fångsthastighet, uttagshastighet, driftindikatorer.',
        consent_properties_property_registry: 'Fastighetsregister: varje fastighet som hyresgästen hanterar med sitt samtycke bannerstatus, länkad [[TOK_0]], policyversion.',
        forseti_projects_overview: 'Forseti-arbetsytor: ett projekt grupperar dokument, konversationer, arbetsflödeskörningar och tabellöversikter i en behållare så att [[TOK_0]]-rådgivaren behåller sammanhanget över hela engagemanget.',
        forseti_workflows_list: 'Sparade [[TOK_0]] promptmallar som producerar uppgifter och utkast till bevis på begäran. Använd inbyggda paketarbetsflöden eller skapa dina egna; körningar debiteras mot din månatliga token-bucket.',
        forseti_tabular_reviews_list: 'Upprepad, kolumn-för-kolumn granskning av en dokumentkorpus. Definiera frågorna en gång, kör samma granskning över många bilagor och få ett svarsrutnät sida vid sida med citat.',
        forseti_document_review_index: 'Triage-inkorg för dokument med [[TOK_0]]-föreslagna redigeringar eller versioner från Forseti. Dokument kommer in i kön från chattar, arbetsflödeskörningar eller CTA:n "Skicka ett dokument för granskning" på den här sidan.',
        forseti_audit_lineage: 'Spåra varje [[TOK_0]]-genererad artefakt som är kopplad till en post: chattar, verktygsanrop, uppgifter, bevisutkast och dokumentversioner. Krävs för bevisförsvar och revisioner efter åtgärd.',
        forseti_draft_evidence: '[[TOK_0]]-utkastade bevis i väntan på mänsklig granskning. Varje utkast måste godkännas av en auktoriserad granskare innan det blir formellt bevis – Forseti arkiverar aldrig automatiskt.',
        forseti_usage: 'Tokenförbrukning och hinkstatus för denna organisation. Spårar månatliga fakturerbara enheter, återstående hink och senaste aktivitet efter användare/funktion/verktyg.',
        forseti_overview: 'Ingångspunkt till Forseti [[TOK_0]] Juridisk rådgivare: välj en persona, bläddra bland de senaste chattarna och starta en ny konversation. Personval här ställer in standardrösten för nya chattar.',
        forseti_chat_detail: 'Enkel Forseti-konversation: se meddelandehistoriken, byt personas mitt i chatten, skicka nya meddelanden och exportera utskriften som [[TOK_0]] i bevissyfte.',
        forseti_cross_framework_conflicts: 'Kurerad katalog över konflikter mellan de regleringspaket som din organisation har installerat. Filtrera efter ramverk / ämne / allvarlighetsgrad / bekräftelsestatus, klicka på en rad för att se ramverkspositioner sida vid sida och bekräfta / tilldela / lösa. Forseti yttrar konflikterna; människor bestämmer.',
        users_detail: 'Enanvändarprofil: identitet, roll, MFA, sessionshistorik, revisionsspår.',
        users_list: 'Användarkatalog: alla aktiva, inbjudna och inaktiverade användare med snabbfilter och massåtgärder.',
        governance_vendors: 'Hantera leverantörsstyrningslivscykeln: onboardingpipeline, periodiska granskningar, godkännanden och offboarding. Spåra leverantörs efterlevnadsstatus och efterlevnad av playbook.',
        governance_compliance: 'Övervaka organisationens efterlevnadshållning med poängsättning, avdriftsdetektering och styrelserapportering. Spåra efterlevnadstrender och generera rapporter som är redo för chefer.',
        governance_transfers: 'Hantera gränsöverskridande dataöverföringar, DPA-granskningar och styrning av underprocessorer. Dokumentera överföringsmekanismer och säkerställa regelefterlevnad för internationella dataflöden.',
        vendor_risk_assessment: 'Bedöm och värdera leverantörsrisk i din portfölj. Övervaka risksignaler, spåra omvärderingar och upprätthåll en heltäckande riskportföljvy.',
        vendor_risk_contracts: 'Hantera leverantörskontrakt, due diligence-frågeformulär och gate-utvärderingar. Spåra avtalsvillkor, förnyelsedatum och efterlevnadskrav.',
        vendor_risk_onboarding: 'Hantera leverantörens introduktionslivscykel: intagsbedömning, granskningsrutt, arbetsflöden för godkännande och beslut om riskacceptans.',
        vendor_risk_dashboard: 'Central översikt över din leverantörsriskställning: portföljfördelning efter nivå, senaste nivåändringar, kontrakt som löper ut inom 90 dagar, granska nyckeltal och hälsa för riskacceptans. Börja här för en snabb läsning innan du borrar i poäng, signaler eller grindar.',
        vendor_risk_scoring: 'Konfigurera poängdimensioner och utvärdera leverantörer mot viktade riskkriterier. Spåra sammansatta poäng, tilldelade nivåer och poänghistorik över tid.',
        vendor_risk_signals: 'Spåra ogynnsamma händelser som kan motivera omvärdering av leverantören: certifieringsupphörande, meddelanden om överträdelser, finansiell instabilitet och ändringar i efterlevnad. Signaler driver nedströms omvärderingsuppgifter.',
        vendor_risk_reviews: 'Genomför regelbundna leverantörsgranskningar med ögonblicksbilder av kontraktsstatus, resultat och rekommendationer. Spåra granskningsresultat (tillfredsställande, problem identifierade, åtgärdande krävs, eskalerad) över program och perioder.',
        vendor_risk_reassessments: 'Utlösa och hantera omvärderingsuppgifter när signaler eller periodiska scheman indikerar förändrad riskställning. Registrera resultat och uppdaterade risknivåer; genomförda omvärderingar går tillbaka till poängsättning.',
        vendor_risk_acceptance: 'Acceptera formellt kvarvarande leverantörsrisk med uttryckliga villkor, utgångsdatum och motivering. Upprätthåll riskacceptansregistret – det revisionsbara registeret över aktiva, utgångna och återkallade godkännandebeslut.',
        vendor_risk_onboarding_cases: 'Hantera livscykeln för leverantörens introduktionsfall: ny introduktion, granskning av materialförändringar och periodiska granskningar. Arbeta igenom stegvisa flikar med slutförandeindikatorer och utlösa godkännandeportar när du är klar.',
        vendor_risk_review_routing: 'Dirigera leverantörsgranskningsuppgifter till specifika granskare efter användare och roll. Tilldela frågeformulär, spåra granskarens uppdrag och fånga routingresultat med fullständig revisionsspår.',
        vendor_risk_gates: 'Utvärdera inköpsgodkännandeportar innan leverantörer går live. Konfigurera grindkriterier (certifieringar, DPA undertecknad, frågeformulär komplett, risk inom tröskeln), registrera åsidosättande motiveringar och länkbevis.',
        vendor_risk_questionnaires: 'Skapa mallar för due diligence frågeformulär och tilldela dem till leverantörer. Spåra slutförande av svar, granska kommentarer och fynd som matas in i riskpoäng och godkännandeportar.',
        monitoring_programs: 'Skapa och hantera efterlevnadsövervakningsprogram kopplade till regelverk. Tilldela uppgifter via RACI-styrning och spåra programexekvering.',
        monitoring_kpi: 'Spåra efterlevnads-KPI:er, auktoritetsberedskapspoäng och ändra granskningsstatus. Dashboardvy över övervakning av programprestanda över alla aktiva ramverk.',
        discovery_scans: 'Kör dataupptäcktsskanningar över anslutna system. Hantera upptäcktscykler med deltadetektering, konfigurera kontakter och spåra skanningsresultat.',
        discovery_classification: 'Granska upptäcktsförslag, hantera uppställningsområdet för nyupptäckt data och genomför ägargranskning med klassificeringsrekommendationer.',
        discovery_management: 'Konfigurera dedupliceringsregler, hantera importmallar och spåra klassificeringslinjer från upptäckt till godkända klassificeringsetiketter.',
        connectors_integration: 'Konfigurera systemanslutningar, hantera autentiseringsuppgifter och övervaka händelsebussen för datasynkronisering i realtid över integrerade system.',
        connectors_automation: 'Planera automationsstrategier, fånga affärskrav och utvärdera proof-of-concept styrkort för systemintegrationsprojekt.',
        connectors_governance: 'Hantera systeminventeringen, genomför säkerhetsgranskningar, underhålla spårbarhetsmatriser och spåra register över integrationsluckor.',
        task_management_tasks: 'Visa och hantera efterlevnadsuppgifter: uppgiftslista, personlig uppgiftskö, försenade uppgifter, aktivitetstavla och kalendervyer för att spåra arbete över alla moduler.',
        task_management_workflows: 'Designa och hantera efterlevnadsarbetsflöden: skapa arbetsflödesmallar, konfigurera sektionstilldelningar och övervaka arbetsflödets exekvering.',
        compliance_forms_templates: 'Bläddra och hantera mallar för efterlevnadsformulär. Gå till mallkatalogen, skapa anpassade mallar och konfigurera formulärlayouter för lagstadgade inskickningar.',
        compliance_forms_submissions: 'Fyll i och skicka in efterlevnadsformulär. Spåra formulärinstanser, granska utdata och hantera inlämningspaket för lagstadgade arkivering.',
        compliance_forms_filing: 'Hantera länkar för arkivering, sektionsdirigering och konsolidering av flera avdelningar för förberedelse och inlämning av lagstadgade underlag.',
        organizations_entities: 'Hantera organisationsenheter, tilldela regelverk per enhet och konfigurera avdelningshierarkier för efterlevnad av flera enheter.',
        organizations_groups: 'Hantera organisationsgrupper för multi-entity-företag. Dela leverantörer, ramverk och formulärmallar mellan gruppmedlemmar med konsoliderad rapportering.',
        organizations_intake: 'Konfigurera intagsinställningar och hantera inställningsarv över organisationshierarkierna.',
        access_accountability_sessions: 'Övervaka användarsessioner, granska åtkomstloggar och analysera åtkomstmönster. Spåra sessionsaktivitet med förankringsstatus för ansvarsbevis.',
        access_accountability_reviews: 'Kör åtkomstgranskningskampanjer, hantera motiveringsgranskningar och spåra granskarens framsteg. Samordna periodisk åtkomstcertifiering över hela organisationen.',
        access_accountability_sod: 'Definiera arbetsuppdelningsregler, upptäck överträdelser och hantera undantag. Genomför kontroller av intressekonflikter över roller och behörigheter.',
        access_accountability_evidence: 'Generera bevispaket för åtkomstgranskningar, genomför utredningar och analysera rollanvändningsmönster för åtkomstrapportering.',
        program_governance_maturity: 'Bedöm och spåra efterlevnadsprograms mognad över ramar. Definiera mognadsmodeller, kör bedömningar och övervaka förbättringstrender över tid.',
        program_governance_obligations: 'Kartlägg regulatoriska skyldigheter till organisatoriska enheter med RACI-styrning. Definiera styrmodellen och spåra saneringsplaner för identifierade luckor.',
        program_governance_documents: 'Hantera styrdokumentregistret: utkast, granska, utfärda och spåra erkännande av efterlevnadspolicyer och driftsdokument.',
        program_governance_reporting: 'Generera sammanfattningar, rapporter om revisionsberedskap och analyser av bevisluckor. Spåra rapporteringsperioder och övervaka programhälsostatistik.',
        deletion_orchestration_runs: 'Kör och övervaka borttagningsförlopp. Spåra exekveringsuppgifter, verifiera fullständighet och hantera raderingsinstrumentpanelen.',
        deletion_orchestration_vendors: 'Koordinera förfrågningar om borttagning av leverantörer, verifiera leverantörens efterlevnad av raderingsskyldigheter och underhåll beviskedjedokumentation.',
        consent_management: 'Hantera samtyckespolicyer, syfteskataloger och samtyckesarbetsflöden. Konfigurera regler för insamling av samtycke och spåra ögonblicksbilder av samtycke över tid.',
        consent_cmp: 'Integrera med Consent Management Platforms (CMP:er): konfigurera webhooks, mappa [[TOK_0]]-ändamål till GRC-katalogändamål och synkronisera samtyckesposter.',
        consent_compliance: 'Övervaka samtyckesefterlevnad: upptäck konfigurationsändringar, stäv av oöverensstämmelser, spåra återkallelsespridning och granska samtyckesrevisionsspåret.',
        partner_workspace_partners: 'Hantera partnerorganisationer, genomför partnerrevisioner och hantera upptrappningar. Spåra partnerns introduktionsstatus och efterlevnadskrav.',
        partner_workspace_operations: 'Hantera partnerleveranser, arbetsflödesmallar, servicenivåer och varumärkesprofiler. Konfigurera operativa arbetsflöden för partnersamarbete.',
        privacy_scanner_scanning: 'Kör sekretessskanningar i realtid på webbplatser och applikationer. Granska skanningsresultat, spåra spårningsbevis före samtycke och hantera skanningsarkivet.',
        privacy_scanner_monitoring: 'Konfigurera instrumentpaneler och inställningar för sekretessskannerövervakning. Ställ in automatiska skanningsscheman och hantera skannerkonfigurationen.',
        consent_import: 'Massimport av samtyckesposter från [[TOK_0]] filer. Idealisk för att registrera pappersbaserat samtycke (anställningsavtal, förälder/skola samtyckesformulär) i stor skala. Stöder arbetsflödestyper för beviljande, återkallande, begränsningar och invändningar.',
        cases_import: 'Massimport av registrerade rättigheter för begäranden från [[TOK_0]] filer. Stöder flerkanals intagskällor inklusive telefon, post, e-post och personliga inlämningar för organisationer som tar emot stora volymer DSAR.',
        data_subjects: 'Visa enhetliga profiler för registrerade som sammanställer alla fall för begäran om rättigheter och samtyckesposter för varje individ. Spåra hela sekretesslivscykeln per person – samtyckeshistorik, DSR-fall och interaktionstidslinje.',
        files_config: 'Ställ in den plattformsomfattande filuppladdningspolicyn – storleksgränser, typgodkännandelista, lagringsstandarder och regler för laglig spärr. Med åsidosättningar per ägare kan du skärpa policyn för känsliga moduler (t.ex. bevis för begäran om rättigheter) samtidigt som resten av organisationen är standard. Lagringsstandarder stöder förväntningarna på dataminimering enligt [[TOK_0]] lag 91/2025 artikel 3; juridisk spärr avbryter radering under öppna utredningar eller tvister.',
        files_browser: 'Bläddra, sök och hantera alla bilagor som laddas upp i hela organisationen. Filtrera efter ägarmodul, uppladdare, datum och MIME-typ; öppna lådan med bilagor för att se granskningshistorik, länkad enhet och lagringsstatus. En operativ vy – inte ramspecifik – som används av administratörer och revisorer för att hitta och triage filer.',
        files_dashboard: 'Operationell översikt av filytan: total lagring, tillväxt över tid, föräldralösa bilagor (ingen överordnad enhet) och efterlevnad av lagringspolicy per ägaretyp. Använd den för att upptäcka policyavvikelser (t.ex. en modul som lagrar filer efter det globala lagringsfönstret) och för att budgetera lagring. Operativt verktyg — inte knutet till ett specifikt regelverk.',
    },
    framework_rights: {
        be_informed: 'Rätt att bli informerad',
        consent: 'Rätt till samtycke',
        refuse_consent: 'Rätt att vägra samtycke',
        withdraw_consent: 'Rätt att återkalla samtycke',
        access: 'Rätt till tillgång',
        rectification: 'Rätt till rättelse',
        data_provision: 'Rätt till datatillhandahållande',
        deletion: 'Rätt till radering',
        restriction_of_processing: 'Rätt till begränsning av behandling',
        object_to_processing: 'Rätt att invända mot behandling',
        complaint: 'Rätt att lämna klagomål',
        denunciation: 'Rätt till anmälan',
        lawsuit: 'Rätt att väcka talan',
        claim_damages: 'Rätt till skadestånd',
        request_protection_measures: 'Rätt att begära skyddsåtgärder',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Direktiv 2002/58/EG (e-integritetsdirektivet)',
            description: 'Överordnat direktiv för nationella införlivande av e-integritet. Omfattar cookies, elektronisk kommunikationssekretess, direktmarknadsföring. Varje medlemsstat måste införliva i nationell lagstiftning.',
        },
        EU_GDPR: {
            display_name: 'Allmän dataskyddsförordning (EU) 2016/679',
            description: 'Den allmänna dataskyddsförordningen ([[TOK_0]]) är en EU-förordning om dataskydd och integritet. Den gäller direkt i alla EU/EES-medlemsländer.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Direktiv (EU) 2022/2555 ([[TOK_0]])',
            description: 'Överordnade direktiv för nationella [[TOK_0]] införlivande. Täcker riskhantering för cybersäkerhet, incidentrapportering, säkerhet i leveranskedjan för viktiga och viktiga enheter.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Vietnam [[TOK_0]] lag ([[TOK_1]]) – Gäller 1 mars 2026',
            description: 'Vietnam [TOK_0]] lag (Luật Trí tuệ nhân tạo [[TOK_2]]) som styr utvecklingen, driftsättningen och användningen av system för artificiell intelligens. Upprättar riskklassificering, transparens och märkningsplikter, krav på incidentrapportering, skyldigheter för konsekvensbedömningar och en kontrollerad testmekanism (sandlåda) för [[TOK_1]] aktiviteter i Vietnam.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Vietnams cybersäkerhetslag (24/2018)',
            description: 'Vietnams lag om cybersäkerhet (lag nr [[TOK_0]]) som fastställer krav för cybersäkerhet, datalokalisering och incidentrapportering. Aktiv tills den ersatts av lag [[TOK_1]] från och med 2026-07-01.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Dekret 53 – Implementering av cybersäkerhetslagar',
            description: 'Dekret [[TOK_0]] som implementerar cybersäkerhetslagen, som omfattar fastställande av omfattning, utlösare av datalokalisering, krav på lokal närvaro och arbetsflöden för myndighetssamarbete.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Lag om cybersäkerhet ([[TOK_0]])',
            description: 'Vietnams konsoliderade lag om cybersäkerhet (lag [[TOK_0]]), som ersätter lag [[TOK_1]], med verkan 1 juli 2026. Konsoliderar omfattningen av dekret [[TOK_2]]Đ-CP (se VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Vietnams datalag',
            description: 'Vietnams datalag (lag [[TOK_0]]) som fastställer omfattande datastyrningskrav inklusive datainventering, klassificering, delningsstyrning och gränsöverskridande dataöverföringsstyrning. Överlappar med VN_PDPL_LAW_2025 (personuppgiftsaspekter) och VN_CYBERSEC_LAW_2025 (datalokalisering/klassificering).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Dekret [[TOK_0]]Đ-CP (Datalagsimplementering)',
            description: 'Dekret [[TOK_0]]Đ-CP som implementerar Vietnams datalag (lag [[TOK_1]]). Tillhandahåller officiella formulär för konsekvensbedömning av gränsöverskridande dataöverföring, årlig riskbedömningsrapportering och nationell databasåtkomst. Definierar 11 officiella Mẫu số-former.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Utkast till dekret om databörser 2026',
            description: 'Utkast till dekret om driften av plattformar för datautbyte (Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu). Reglerar plattformsklassificering, deltagares behörighet, kontroller för dataprodukter och tjänster, testning av sandlåde, transaktionsarbetsflöde, elektroniska avtal, intyg om äganderätt till data och hantering av klagomål/tvister. För närvarande i offentligt samråd; ännu inte meddelats. Hänvisar till lag om data [[TOK_0]], lag om skydd av personuppgifter [[TOK_1]], lag om cybersäkerhet [[TOK_2]] och lag om elektroniska transaktioner [[TOK_3]].',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Lag om elektronisk handel ([[TOK_0]])',
            description: 'Vietnamlag om elektronisk handel (Luật Thương mại điện tử [[TOK_0]]) som upprättar ett enhetligt nationellt system för elektronisk handel, som täcker inhemska och gränsöverskridande plattformsoperationer, plattformsstyrning och ansvarsskyldighet, konsumentskydd, säljare och affiliate-bolagshantering, hantering av innehåll, kontroll och hantering av klagomål och hantering av administrativt innehåll, kontroll och hantering av klagomål statligt ledningssystem för e-handel.',
        },
        VN_PDPL: {
            display_name: 'Vietnam [[TOK_0]] (dekret 13/2023)',
            description: 'Vietnams personuppgiftsskyddsdekret (dekret [[TOK_0]]) som fastställer omfattande dataskyddskrav. Äldre ramverk – ersatt av lag [[TOK_1]] och dekret [[TOK_2]] gällande 2026-01-01.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Dekret 13 — [[TOK_0]] Operationell baslinje',
            description: 'Dekret [[TOK_1]], det operativa instrumentet för [[TOK_0]] uppgifter inklusive arkivering av underlag, förvaltningsartefakter, gränsöverskridande mekanik och administrativa förfaranden för MoPS. Ersatt av dekret [[TOK_2]] med verkan 2026-01-01.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Personuppgiftslagstiftning ([[TOK_0]])',
            description: 'Vietnams lag om skydd av personuppgifter (lag [[TOK_2]]) som upprättar ett omfattande ramverk för skydd av personuppgifter, träder i kraft den 1 januari 2026. Täcker efterlevnadsteman A–J: lagliga behandlingsbaser, samtycke till känsliga uppgifter, registrerades rättigheter (åtkomst/rättelse/radering/begränsning/invändning mot anmälan/portabilitet, datasubjektets myndighet), [[TOK_0]] för högriskbearbetning, styrning av gränsöverskridande överföringar, [[TOK_1]] beteckning, register över bearbetningsaktiviteter, processoravtalsförpliktelser. Myndighetsarkiveringsskyldighet via MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Korsreferenser: VN_PDPL_DECREE_356_2025 (genomförandedekret), VN_CYBERSEC_LAW_2025 (cybersäkerhetsöverlappningar), VN_DATA_LAW (datastyrning).',
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Dekret [[TOK_1]] ([[TOK_0]] Implementering)',
            description: 'Dekret [[TOK_0]] som implementerar lagen om skydd av personuppgifter, som ersätter dekret [[TOK_1]]. Täcker arkivering av underlag, förvaltningsartefakter, gränsöverskridande mekanik och tjänsteleverantörscertifiering. Bilaga blankett inventering: Phụ lục I–VIII (konsekvensbedömning, gränsöverskridande överföring, certifiering). MoPS administrativa förfaranden via VN_PDPL_ADMIN_PROCEDURES_778_2026 (beslut 778/QĐ-BCA-A05). Certifieringsarbetsflöde: ansökan → utfärdande → ändringsbegäran → återutfärdande → återkallelse. Korsreferenser: VN_PDPL_LAW_2025 (överordnad lag), VN_CYBERSEC_LAW_2025 (datalokalisering), VN_DATA_LAW (datastyrning överlappar).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] A05 Administrativa förfaranden (beslut 778/QĐ-BCA-A05)',
            description: 'Beslut 778/QĐ-BCA-A05 (februari 2026) — Administrativa rutiner för skydd av personuppgifter enligt A05 ([[TOK_0]]). Definierar förfaranden för inlämning, bearbetning och resultatutfärdande av underlag inklusive DLCN-HC-formulär och lagstadgade formulär.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Utkast till verkställighetsdekret 2026',
            description: 'Utkast till verkställighets- och sanktionsdekret för brott mot lagen om skydd av personuppgifter (lag [[TOK_0]]). Definierar straffintervall, försvårande/förmildrande faktorer och verkställighetsförfaranden. För närvarande i utkaststatus i väntan på offentliggörande.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Vietnams telekommunikationslag 2023',
            description: 'Vietnam Telecommunications Law 2023 (Luật Viễn thông), en sektoröverlagring för telekom/ISP/plattformsföretag med sekretess, avslöjandekontroll och myndighetsförfrågningarhanteringsskyldigheter. Korsreferenser: VN_CYBERSEC_LAW_2025 (informationssystemsäkerhet), VN_PDPL_LAW_2025 (användardatabehandling), VN_DATA_LAW (datastyrning).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Dekret [[TOK_0]]Đ-CP (Telecom Law Implementation)',
            description: 'Dekret [[TOK_0]]Đ-CP som genomför telekommunikationslagen (lag [[TOK_1]]). Tillhandahåller officiella formulär för meddelanden om telekomtjänster, licensiering, registrering och utvecklingsplaner för datacenter. Definierar 7 officiella Mẫu số-former.',
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Arkivering av utvecklingsplan för datacenter',
            description: 'Datacenterutvecklingsplaner måste lämnas in till den behöriga myndigheten enligt dekret [[TOK_0]]Đ-CP.',
        },
        d163_r3: {
            title: 'Registrering av telekomtjänst',
            description: 'Registrering av teletjänster måste lämnas in till den behöriga myndigheten med hjälp av det föreskrivna formuläret.',
        },
        d163_r2: {
            title: 'Ansökan om telekomlicens',
            description: 'Ansökningar om teletillstånd ska göras på den föreskrivna blanketten i enlighet med förordning [[TOK_0]]Đ-CP.',
        },
        d163_r1: {
            title: 'Anmälan om tillhandahållande av teletjänster',
            description: 'Leverantörer av telekomtjänster måste underrätta den behöriga myndigheten om tillhandahållande av tjänster med hjälp av det föreskrivna formuläret innan tjänsten påbörjas.',
        },
        vn_dp_draft_f: {
            title: 'Klagomål, tvister och riskhantering',
            description: 'Plattformsoperatörer måste tillhandahålla klagomålsintag, tvisthanteringsarbetsflöde med bevisbevarande, riskidentifiering och tidig varningskontroll och periodisk granskning av risker för integritet, cybersäkerhet och åtkomsthantering.',
        },
        vn_dp_draft_e: {
            title: 'Transaktionsarbetsflöde och intyg om äganderätt över data',
            description: 'Transaktioner kräver kontoregistrering, noteringsgodkännande, elektronisk kontraktering, betalningsbekräftelse, leveranspost och utfärdande av ett intyg om äganderätt till data där så är tillämpligt. Transaktionshistorik och spårbarhet ska bevaras i ett transaktionsregister.',
        },
        vn_dp_draft_d: {
            title: 'Sandlåda och testmiljökontroller',
            description: 'Testmiljöer måste isoleras, åtkomstbegränsas, säkerhetsövervakas och granskas innan någon utdata extraheras. Inga källdata får extraheras från testmiljön och stängning/städning av testsessioner måste registreras.',
        },
        vn_dp_draft_c: {
            title: 'Kontroller för dataprodukter och tjänster',
            description: 'Listor måste stödjas av bevis från laglig källa och äganderätt/användningsrätt, tekniska valideringsposter, kvalitetsupplysningar och gransknings- och godkännandeposter på plattformssidan. Förbjudna data måste filtreras innan listning.',
        },
        vn_dp_draft_b: {
            title: 'Deltagarbehörighet och onboarding',
            description: 'Plattformsoperatörer måste verifiera juridisk status, juridisk kapacitet och villkorliga affärskrav för säljare och köpare, registrera transaktions- och betalningskonton och upprätthålla ett deltagarregister.',
        },
        vn_dp_draft_a: {
            title: 'Dataplattformsklassificering och verksamhetsmodell',
            description: 'Plattformsoperatörer måste upprätta en klassificering av plattformstyp (nationell dataplattform kontra andra dataplattformar), definiera operatörens behörighet och ansvar och dokumentera prissättning, avgifter, driftregler och teknisk styrning.',
        },
        d165_r5: {
            title: 'Tillgång till nationell databasinformation',
            description: 'Begäran om att extrahera/använda information från den nationella digitala databasen använder föreskrivna formulär (Mẫu số 07a/07b).',
        },
        d165_r4: {
            title: 'Årlig riskbedömningsrapportering',
            description: 'Årliga riskbedömningsrapporter måste arkiveras med hjälp av föreskrivna blanketter (Mẫu số 05a/05b, 06).',
        },
        d165_r3: {
            title: 'Uppsägning av gränsöverskridande överföring',
            description: 'Uppsägning av gränsöverskridande överföring måste meddelas med hjälp av föreskrivna blanketter (Mẫu số 04a/04b).',
        },
        d165_r2: {
            title: 'Avisering om bedömningsresultat',
            description: 'Myndigheten utfärdar meddelanden om bedömningsresultat med hjälp av föreskrivet formulär (Mẫu số 03).',
        },
        d165_r1: {
            title: 'Anmälan om konsekvensbedömning för gränsöverskridande dataöverföring',
            description: 'Organisationer måste lämna in underlag för gränsöverskridande dataöverföring/bearbetning av konsekvensbedömningar med hjälp av föreskrivna formulär (Mẫu số 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Samtycke för cookies och liknande tekniker',
            description: 'Lagring eller åtkomst av information på en terminalutrustning är endast tillåten med förhandsmedgivande, förutom för tekniskt nödvändig lagring.',
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Kommunikationssekretess',
            description: 'Medlemsstaterna ska säkerställa konfidentialitet för kommunikation och relaterade trafikdata med hjälp av ett allmänt kommunikationsnät och allmänt tillgängliga elektroniska kommunikationstjänster.',
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Samtycke för direktmarknadsföring (opt-in)',
            description: 'Användning av elektroniska kommunikationssystem för direktmarknadsföring kräver förhandsgodkännande från abonnenten.',
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Mjuk opt-in för befintliga kunder',
            description: 'Direktmarknadsföring till befintliga kunder för liknande produkter/tjänster är tillåten utan samtycke om opt-out ges.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Överträdelsemeddelande för telekomleverantörer',
            description: 'Leverantörer av allmänt tillgängliga elektroniska kommunikationstjänster ska underrätta den behöriga nationella myndigheten om personuppgiftsintrång.',
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: 'Rätt att invända mot direktmarknadsföring',
            description: 'Prenumeranter ska när som helst och kostnadsfritt ges möjlighet att invända mot att få direktmarknadsföringsmeddelanden.',
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Lagring och radering av trafikdata',
            description: 'Trafikdata som rör abonnenter och användare måste raderas eller göras anonyma när de inte längre behövs för överföring, förutom för fakturering eller samtrafik.',
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Behandlingsvillkor för platsdata',
            description: 'Andra platsdata än trafikdata får endast behandlas när de görs anonyma eller med användarens samtycke, i den utsträckning och under den tid som behövs.',
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Lagligheten av behandlingen — samtycke',
            description: 'Behandlingen ska vara laglig endast om den registrerade har gett sitt samtycke till behandlingen av sina personuppgifter för ett eller flera specifika ändamål.',
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Lagligheten av behandlingen — kontrakt',
            description: 'Behandlingen är nödvändig för att fullgöra ett avtal som den registrerade är part i.',
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Lagligheten av behandlingen — rättslig skyldighet',
            description: 'Behandlingen är nödvändig för att uppfylla en rättslig skyldighet som den registeransvarige är föremål för.',
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Lagligheten av behandlingen — vitala intressen',
            description: 'Behandlingen är nödvändig för att skydda den registrerades eller en annan fysisk persons vitala intressen.',
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Lagligheten av behandlingen — allmänt intresse',
            description: 'Behandlingen är nödvändig för att utföra en uppgift som utförs av allmänt intresse eller i myndighetsutövning.',
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Lagligheten av behandlingen — berättigade intressen',
            description: 'Behandlingen är nödvändig för de legitima intressen som eftersträvas av den registeransvarige eller en tredje part.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Behandling av särskilda kategorier (känsliga uppgifter)',
            description: 'Behandling av särskilda kategorier av personuppgifter (rasligt ursprung, politiska åsikter, hälsa etc.) är förbjuden om inte särskilda villkor i art. 9(2) är uppfyllda.',
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Villkor för samtycke',
            description: 'Den registeransvarige måste visa att samtycke har getts. Samtycke måste ges fritt, specifikt, informerat och otvetydigt. Återkallelse måste vara lika enkelt som att ge samtycke.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: 'Barns samtycke — digitala tjänster',
            description: 'Behandling av personuppgifter om ett barn under 16 år (eller lägre ålder fastställd av medlemsstaten, inte under 13) kräver föräldrarnas samtycke för informationssamhällets tjänster.',
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Transparent information och kommunikation',
            description: 'Den registeransvarige ska tillhandahålla information om behandlingen i en kortfattad, transparent, begriplig och lättillgänglig form.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Information för direkt insamling',
            description: 'Om personuppgifter samlas in från den registrerade ska den registeransvarige tillhandahålla specificerad information vid tidpunkten för insamlingen.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Information för indirekt insamling',
            description: 'Om personuppgifter inte har inhämtats från den registrerade ska den registeransvarige lämna specificerad information inom rimlig tid.',
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: 'Rätt till tillträde',
            description: 'Den registrerade ska ha rätt att få bekräftelse på behandlingen och tillgång till personuppgifterna och kompletterande information.',
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Rätt till rättelse',
            description: 'Den registrerade ska ha rätt att få rättelse av felaktiga personuppgifter utan onödigt dröjsmål.',
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: 'Rätt till radering (rätt att bli glömd)',
            description: 'Den registrerade ska ha rätt att få radering av personuppgifter utan onödigt dröjsmål om särskilda skäl föreligger.',
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Rätt till begränsning av behandlingen',
            description: 'Den registrerade ska ha rätt att få begränsning av behandlingen där angivna förutsättningar gäller.',
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Anmälningsskyldighet — rättelse/radering/begränsning',
            description: 'Den personuppgiftsansvarige ska meddela varje rättelse, radering eller begränsning till varje mottagare till vilken uppgifterna har lämnats ut.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Rätt till dataportabilitet',
            description: 'Den registrerade ska ha rätt att få sina personuppgifter i ett strukturerat, vanligt förekommande, maskinläsbart format.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: 'Rätt att invända',
            description: 'Den registrerade ska ha rätt att invända mot behandling utifrån allmänt intresse eller legitima intressen, inklusive profilering.',
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Automatiserat individuellt beslutsfattande, inklusive profilering',
            description: 'Den registrerade ska ha rätt att inte bli föremål för ett beslut baserat enbart på automatiserad behandling som ger rättsliga eller liknande betydande effekter.',
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: 'Överträdelsemeddelande till tillsynsmyndigheten (72h)',
            description: 'I händelse av ett personuppgiftsintrång ska den personuppgiftsansvarige meddela tillsynsmyndigheten inom 72 timmar efter att han fått kännedom, såvida det inte är osannolikt att det leder till risk.',
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Överträdelsemeddelande till registrerade (hög risk)',
            description: 'När ett intrång sannolikt kommer att leda till en hög risk för rättigheter och friheter, ska den registeransvarige meddela intrånget till den registrerade utan onödigt dröjsmål.',
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Svar på förfrågningar från registrerade (30 dagar)',
            description: 'Den registeransvarige ska svara på den registrerades begäran utan onödigt dröjsmål och inom en månad efter mottagandet, med möjlighet att förlänga med ytterligare två månader för komplexa förfrågningar.',
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: 'Konsekvensbedömning av dataskydd',
            description: 'Om behandlingen sannolikt kommer att leda till en hög risk för rättigheter och friheter ska den registeransvarige utföra en [[TOK_0]] innan behandlingen.',
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: 'Förhandssamråd med tillsynsmyndighet',
            description: 'Den registeransvarige ska rådfråga tillsynsmyndigheten om en [[TOK_0]] indikerar att behandlingen skulle leda till hög risk utan begränsningsåtgärder.',
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] obligatorisk bearbetningslista',
            description: '[[TOK_0]] krävs för systematisk utvärdering/profilering, storskalig bearbetning av specialkategorier och systematisk övervakning av offentliga ytor.',
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Register över bearbetningsaktiviteter (kontrollant)',
            description: 'Varje personuppgiftsansvarig ska föra ett register över behandlingsaktiviteter under dess ansvar, inklusive syften, kategorier, mottagare, överföringar och lagring.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Register över bearbetningsaktiviteter (behandlare)',
            description: 'Varje registerförare ska föra ett register över alla kategorier av behandlingsaktiviteter som utförs på uppdrag av en registeransvarig.',
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Säkerhet för bearbetning',
            description: 'Den personuppgiftsansvarige och registerföraren ska genomföra lämpliga tekniska och organisatoriska åtgärder för att säkerställa säkerhet som är lämplig för risken.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Dataskydd genom design och som standard',
            description: 'Den registeransvarige ska vidta lämpliga åtgärder för att säkerställa att endast personuppgifter som är nödvändiga för varje specifikt ändamål behandlas (dataminimering).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Utnämning av dataskyddsombud',
            description: 'Den registeransvarige och registerföraren ska utse en [[TOK_0]] där behandlingen utförs av en myndighet, innebär regelbunden och systematisk övervakning eller storskalig behandling av särskilda kategorier.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Allmän princip för överföringar',
            description: 'All överföring av personuppgifter till ett tredjeland ska endast ske om villkoren i kapitel V är uppfyllda.',
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Överföringar baserade på adekvat beslut',
            description: 'En överföring får ske om kommissionen har beslutat att tredjelandet garanterar en adekvat skyddsnivå.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Överföringar omfattas av lämpliga skyddsåtgärder',
            description: 'I avsaknad av ett adekvat beslut kan överföringar ske där lämpliga garantier tillhandahålls, inklusive SCC eller BCR.',
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Standardavtalsklausuler',
            description: 'Standardavtalsklausuler som antagits av kommissionen eller av en tillsynsmyndighet ger lämpliga garantier för internationella överföringar.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Bindande företagsregler',
            description: 'Bindande företagsregler som godkänts av en behörig tillsynsmyndighet ger lämpliga skyddsåtgärder för internationella överföringar inom gruppen.',
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Undantag för särskilda situationer',
            description: 'I avsaknad av tillräcklighet eller garantier kan överföringar ske baserat på uttryckligt samtycke, kontraktsnödvändighet, allmänintresse, rättsliga anspråk, vitala intressen eller offentligt register.',
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Ledningsorgansansvar och utbildning',
            description: 'Ledningsorgan för väsentliga och viktiga enheter måste godkänna riskhanteringsåtgärder för cybersäkerhet och genomgå regelbunden utbildning.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Åtgärder för hantering av cybersäkerhetsrisk',
            description: 'Väsentliga och viktiga enheter ska vidta lämpliga och proportionerliga tekniska, operativa och organisatoriska åtgärder för att hantera cybersäkerhetsrisker.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Incidenthanteringspolicyer och rutiner',
            description: 'Enheter ska implementera policyer för incidenthantering inklusive upptäckt, analys, inneslutning och reaktionsprocedurer.',
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Affärskontinuitet och krishantering',
            description: 'Enheter ska implementera affärskontinuitetsåtgärder inklusive backuphantering, katastrofåterställning och krishantering.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: 'Säkerhet i försörjningskedjan',
            description: 'Enheter ska ta upp säkerhetsrelaterade aspekter av relationer med direkta leverantörer och tjänsteleverantörer, inklusive riskbedömningar av försörjningskedjan.',
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: 'Säkerhet i nätverk och informationssystem',
            description: 'Enheter ska implementera säkerhet vid anskaffning, utveckling och underhåll av nätverk och informationssystem, inklusive sårbarhetshantering.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Sårbarhetshantering och avslöjande',
            description: 'Enheter ska implementera policyer och rutiner för samordnad avslöjande och hantering av sårbarheter.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Effektivitet i bedömning av cybersäkerhetsrisk',
            description: 'Enheter ska implementera policyer och förfaranden för att bedöma effektiviteten av riskhanteringsåtgärder för cybersäkerhet.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Kryptografi och krypteringspolicyer',
            description: 'Enheter ska implementera policyer och förfaranden för användning av kryptografi och, där så är lämpligt, kryptering.',
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: 'HR-säkerhet, passerkontroll, kapitalförvaltning',
            description: 'Enheter ska implementera personalsäkerhet, åtkomstkontrollpolicyer och tillgångshantering.',
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Multi-faktor autentisering',
            description: 'Enheter ska använda multifaktorautentisering eller kontinuerliga autentiseringslösningar, säker röst-/video-/textkommunikation och säkrade nödkommunikationssystem.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Tidig varning till CSIRT (24h)',
            description: 'Enheter ska skicka en tidig varning till den behöriga CSIRT inom 24 timmar efter att de fått kännedom om en betydande incident.',
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: 'Incidentmeddelande till CSIRT (72h)',
            description: 'Enheter ska lämna en incidentanmälan till den behöriga CSIRT inom 72 timmar efter att de fått kännedom om en betydande incident.',
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Slutrapport till CSIRT (1 månad)',
            description: 'Enheter ska lämna in en slutrapport till den behöriga CSIRT senast en månad efter incidentmeddelandet.',
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: 'Bestämning av tillämplighet för [[TOK_0]] aktiviteter',
            description: 'Bestäm om organisationen bedriver [[TOK_0]] aktiviteter som omfattas av Vietnams [[TOK_1]] lag och dokumentera tillämplighetsbeslutet.',
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: '[[TOK_0]] systemriskklassificering efter risknivå',
            description: 'Klassificera varje [[TOK_0]] system efter risknivå (minimal, begränsad, hög, oacceptabel) med hjälp av den guidade klassificeringsmetoden.',
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Underhåll av registrering av systemregister',
            description: 'Håll ett register över [[TOK_0]] system med systemnamn, ägare, syfte, implementeringskontext, risknivå och leverantörsinblandning.',
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Systemdokumentation med artefaktchecklista och bevis',
            description: 'Bygg och underhåll ett systemunderlag med obligatorisk checklista för artefakter, bevisbibliotek och versionshistorik.',
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: 'Transparenskrav för [[TOK_0]] systemoperatörer',
            description: 'Genomför transparensåtgärder för [[TOK_0]] system, inklusive användarmeddelanden, avslöjande av [[TOK_1]] inblandning och systemdokumentation.',
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: '[[TOK_0]] utdatamärkning, vattenmärkning och metadatasignering',
            description: 'Implementera märkning och vattenmärkning för [[TOK_0]]-genererat innehåll inklusive metadatasignering där tillämpligt.',
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: 'Upplysningskrav för [[TOK_0]]-genererat innehåll',
            description: 'Avslöja för användare när innehåll är [[TOK_0]]-genererat och tillhandahåll mekanismer för användare att identifiera [[TOK_1]] engagemang.',
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Förklarbarhet och öppenhetsuppgifter för användaren',
            description: 'Tillhandahåll förklarliga utdata för [[TOK_0]] beslut som påverkar individer och upprätthåll användarinriktad transparensdokumentation.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Mänsklig tillsynsskyldighet för högrisksystem [[TOK_0]]',
            description: 'Se till att mänskliga tillsynsmekanismer finns på plats för högrisksystem [[TOK_0]] inklusive eskalerings- och åsidosättningsfunktioner.',
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] incidentövervakning och upptäckt',
            description: 'Implementera övervakningsfunktioner för att upptäcka [[TOK_0]] systemincidenter, funktionsfel och negativa resultat.',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: 'Allvarlig [TOK_0]] incidentrapportering till myndigheten',
            description: 'Rapportera allvarliga [TOK_0]] incidenter till den behöriga myndigheten inom den föreskrivna tidslinjen (72 timmar).',
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: '[[TOK_0]] efterlevnad av tidslinje för incidentmeddelanden',
            description: 'Följ tidsfrister för aviseringar för [[TOK_0]] incidenter inklusive initiala meddelanden, uppdateringar och stängningsrapporter.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: '[[TOK_0]] konsekvensbedömning för högrisksystem',
            description: 'Genomför konsekvensbedömningar för högrisksystem [[TOK_0]] som omfattar risker, begränsningar, mänsklig tillsyn och övervakningsplaner.',
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Kontrollerad testning / bestämning av behörighet i sandlåda',
            description: 'Bestäm behörighet för deltagande i kontrollerad testning (sandlåda) och dokumentera behörighetsbedömningen.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Inlämning av sandlådeansökningar och spårning av godkännande',
            description: 'Skicka in sandlådeansökningar till den behöriga myndigheten och spåra godkännandestatus genom inlämningslivscykeln.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Sandlåda övervakning checkpoints och färdigställande/utfart',
            description: 'Genomför periodiska övervakningskontrollpunkter under sandlådedeltagande och förbered slutförings-/avslutsrapporter.',
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Märkning av undantag/undantagsdokumentation med motivering',
            description: 'Dokumentera eventuella märkningsundantag eller undantag med motivering och stödjande bevis.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Datalokalisering för vietnamesiska användare',
            description: 'Data från vietnamesiska användare om tjänster som tillhandahålls i Vietnam måste lagras inom Vietnams territorium.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: 'Rapportering av cybersäkerhetsincidenter',
            description: 'Cybersäkerhetsincidenter måste rapporteras till behöriga myndigheter i god tid.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: 'Klassificering av informationssystem',
            description: 'Informationssystem måste klassificeras efter betydelsenivå och lämpliga säkerhetsåtgärder måste vidtas.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Cybersäkerhetsriskbedömning',
            description: 'Regelbundna cybersäkerhetsriskbedömningar måste göras för informationssystem.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: 'Bestämning inom omfattningen (beslutsträd)',
            description: 'Organisationer måste avgöra om de faller inom tillämpningsområdet för förordning 53 med hjälp av det föreskrivna beslutsträdet.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Datalokaliseringsbedömning och beredskap',
            description: 'Organisationer måste bedöma krav på datalokalisering och visa beredskap.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Checklista för beredskap för förvaring och lagring',
            description: 'En checklista för beredskap för lagring och lagring måste fyllas i för överensstämmelse med datalokalisering.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Bedömning av lokal närvarokrav',
            description: 'Organisationer måste bedöma om lokala närvarokrav gäller och planera därefter.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Myndighetsbegäran mottagande och verifiering',
            description: 'Myndighetsbegäranden måste tas emot, verifieras och behandlas enligt föreskrivna förfaranden.',
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Myndigheten begär svar inom tidsfristen',
            description: 'Svar på myndighetsförfrågningar ska lämnas inom föreskriven tidsfrist.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: 'Logg för hantering av myndighetsbegäran',
            description: 'En logg över alla myndighetsförfrågningarhanteringsaktiviteter måste föras.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Tillämplighet och bestämning inom räckvidden (konsoliderad)',
            description: 'Organisationer måste avgöra om de omfattas av den konsoliderade cybersäkerhetslagen, som täcker både den gamla lagen 24/2018 och dekret 53/2022.',
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: 'Informationssystemsklassificering efter betydelsenivå',
            description: 'Informationssystem ska klassificeras efter betydelsenivå (allmänt, viktigt, kritiskt) med motsvarande säkerhetskrav.',
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Cybersäkerhetsstyrningsstruktur och ansvarig personal',
            description: 'Organisationer måste upprätta styrningsstrukturer för cybersäkerhet och utse ansvarig personal.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Periodisk bedömning av cybersäkerhetsrisk',
            description: 'Regelbundna cybersäkerhetsriskbedömningar måste genomföras för alla sekretessbelagda informationssystem.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: 'Säkerhetsåtgärder per klassificering av informationssystem',
            description: 'Tekniska säkerhetsåtgärder måste tillämpas på lämpligt sätt för varje klassificeringsnivå för informationssystem.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: 'Tillträdeskontroll och identitetshantering',
            description: 'Åtgärder för åtkomstkontroll och identitetshantering måste implementeras för informationssystem.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: 'Loggning, övervakning och revisionsspår',
            description: 'Informationssystem måste upprätthålla kapacitet för loggning, övervakning och revisionsspår.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Sårbarhetshantering och lappning',
            description: 'Sårbarhetshantering och lappningsprocesser måste etableras och underhållas.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Datalokalisering för vietnamesisk användardata',
            description: 'Data från vietnamesiska användare om tjänster som tillhandahålls i Vietnam måste lagras inom Vietnams territorium.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Lokal närvarokrav för utländska tjänsteleverantörer',
            description: 'Utländska tjänsteleverantörer som verkar i Vietnam måste upprätthålla lokal närvaro enligt föreskrifter.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Lokal lagringsarkitektur och gränsöverskridande flödesdokumentation',
            description: 'Lokal lagringsarkitektur måste dokumenteras och gränsöverskridande dataflöden måste kartläggas och kontrolleras.',
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Upptäckt och svar på cybersäkerhetsincidenter',
            description: 'Organisationer måste ha förmåga att upptäcka och reagera på cybersäkerhetsincidenter.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: 'Obligatorisk incidentrapportering till behörig myndighet',
            description: 'Kvalificerande cybersäkerhetsincidenter måste rapporteras till [[TOK_1]]/[[TOK_0]] inom föreskrivna tidslinjer.',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Tidslinjeöverensstämmelse för incidentmeddelanden',
            description: 'Incidentmeddelanden måste följa föreskrivna tidslinjekrav (initial rapport inom 24 timmar, fullständig rapport inom 72 timmar).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Myndighetsförfrågningshantering och samarbete',
            description: 'Myndighetsförfrågningar måste hanteras skyndsamt och samarbete tillhandahållas enligt föreskrivna rutiner.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: 'Myndighetsbegäran ärenderegister och utlämnandelogg',
            description: 'Alla myndighetsförfrågningar och utlämnanden ska loggas i ett ärenderegister med fullständig revisionsspår.',
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Säkerhetsbedömning av leverantörer och tredje part',
            description: 'Tredjepartsleverantörer med tillgång till informationssystem måste genomgå säkerhetsbedömning.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Kontroller för åtkomst till leverantörsdata och incidentmeddelanden',
            description: 'Åtkomst till leverantörsdata måste dokumenteras och avtalsenliga skyldigheter för anmälan av incidenter måste fastställas.',
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Säkerhetsmedvetandeutbildning och övningar',
            description: 'Regelbunden cybersäkerhetsmedvetenhetsutbildning och bordsövningar måste genomföras.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: 'Periodiskt penntest och säkerhetsrevision',
            description: 'Periodiska penetrationstester och säkerhetsrevisioner ska utföras på sekretessbelagda informationssystem.',
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: 'Upprätthålla digital datainventering',
            description: 'Organisationer måste upprätthålla en omfattande digital datainventering som katalogiserar alla datatillgångar.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Dataklassificering efter känslighet och betydelse',
            description: 'Data ska klassificeras enligt känslighets- och betydelsenivåer som definieras av datalagen.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Definiera hanteringsregler efter klassificeringsnivå',
            description: 'Hanteringsregler måste fastställas för varje dataklassificeringsnivå.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Spåra datadelning och avslöjande med godkännanden',
            description: 'All datadelning och avslöjande aktiviteter måste spåras med lämpliga godkännanden.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Styrning av gränsöverskridande dataöverföring',
            description: 'Gränsöverskridande dataöverföringar måste följa styrningskraven enligt datalagen.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Upprätthålla styrningspolicyer och ansvar',
            description: 'Organisationer måste upprätthålla policyer för datastyrning och tilldela styrningsansvar.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: 'Årligt styrelseintyg',
            description: 'Ett årligt intyg om styrning måste fyllas i för att bekräfta pågående efterlevnad.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Datariskbedömning',
            description: 'En datariskbedömning måste utföras för att identifiera och mildra risker för datastyrning.',
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Plattformsoperatörers ansvar och styrningsskyldigheter',
            description: 'Upprätta ansvarsstrukturer för plattformsoperatörer inklusive styrningspolicyer, övervakningsansvar och verkställighetsskyldigheter.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Plattformsregler publicering och insyn i information',
            description: 'Publicera plattformsregler, handelsvillkor och operativa upplysningar på ett öppet och tillgängligt sätt.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'E-handelsförsäljningswebbplats/appavisering till MOIT',
            description: 'Skicka meddelande till MOIT för e-handelsförsäljningswebbplatser och applikationer via Online.gov.vn eller angivna kanaler.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'E-handelstjänstplattform/marknadsplatsregistrering hos MOIT',
            description: 'Registrera plattformar och marknadsplatser för e-handelstjänster med MOIT, inklusive inlämning av underlag och spårning av godkännande.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Säljarregistrets underhåll (inrikes och utländska)',
            description: 'Håll ett register över alla säljare på plattformen inklusive inhemska och utländska säljare med onboarding, verifiering och livscykelspårning.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Livestream säljarregister och efterlevnadskontroller',
            description: 'Upprätthåll ett register över livestream-säljare med identitetsverifiering, aktivitetsspårning och efterlevnadskontroller.',
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Affiliate- och marknadsföringspartnerregister',
            description: 'Upprätthålla ett register över affiliate-marknadsförare och hänvisningspartners med kontraktsstatus, innehållsriktlinjer och efterlevnadsbekräftelser.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Produktlistning och tillämpning av förbjudna/villkorade varor',
            description: 'Implementera produktlistningskontroller inklusive kontroll av förbjudna och villkorade varor, övervakning och tillsynsåtgärder.',
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: 'Konsumentklagomål registreras med intag, åtgärder och revisionsspår',
            description: 'Upprätthåll ett klagomålsregister med intagsregister, utredningsåtgärder, lösningsresultat och fullständig revisionsspår.',
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Procedur för hantering av klagomål och tidsplaner för lösning',
            description: 'Upprätta förfaranden för hantering av klagomål med definierade tidslinjer för bekräftelse, utredning och lösning.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Innehållsmoderering, övervakning och upprätthållande av borttagning',
            description: 'Implementera förfaranden för moderering, övervakning och borttagning av innehåll för olagligt, förbjudet eller kränkande innehåll.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: 'Nedtagnings- och verkställighetsåtgärder registreras med bevisbevarande',
            description: 'Upprätthålla ett register över borttagnings- och verkställighetsåtgärder med beslutsprotokoll, bevisbevarande och säljarmeddelanden.',
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Plattformspolicy och upplysningsregister (versioner, publiceringsdatum, godkännande)',
            description: 'Upprätthålla ett register över plattformspolicyer och upplysningar med versionshistorik, publiceringsdatum och godkännandebevis.',
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: 'Konsumentinformationsplikter - korrekt produktinformation och antibedrägeri',
            description: 'Säkerställ korrekt, tydlig produkt- och tjänstinformation och implementera åtgärder för att förhindra bedrägliga metoder på plattformen.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Driftsvillkor för utländska plattformar och registrering/anmälan',
            description: 'Följ driftsvillkoren för utländska plattformar som betjänar vietnamesiska användare, inklusive registrerings- eller anmälningskrav.',
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Lokal representation eller auktorisation för utländska plattformar',
            description: 'Utse en lokal representant eller auktoriserad enhet i Vietnam för utländska plattformar enligt lag.',
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Samordning av gränsöverskridande säljare och reklamationshantering',
            description: 'Koordinera gränsöverskridande säljarhantering och klagomålslösning inklusive eskalering och bevishantering.',
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Statligt e-handelsledningssystem interaktion och rapporteringsberedskap',
            description: 'Förbered dig för interaktion med det statliga ledningssystemet för e-handel inklusive kartläggning av datafält och rapporteringskapacitet.',
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Meddelande om väsentlig förändring efter godkännande',
            description: 'Skicka meddelanden om väsentliga ändringar av plattformsdetaljer, policyer eller operationer efter det första godkännandet.',
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Avisering om uppsägning och avaktivering',
            description: 'Skicka meddelanden om uppsägning eller avaktivering när du upphör med e-handel, inklusive offentliga meddelanden och konsumentskyddshantering.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Trustmark och trovärdighetsklassificeringsprogram för behörighet och underhåll',
            description: 'Bedöma berättigande till program för förtroendemärke och trovärdighetsklassificering och upprätthålla överensstämmelsebevis för pågående deltagande.',
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Samtycke för personuppgiftsbehandling',
            description: 'Behandling av personuppgifter kräver samtycke från den registrerade om inte ett undantag gäller.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Samtycke för behandling av känsliga uppgifter',
            description: 'Behandling av känsliga personuppgifter kräver uttryckligt samtycke med separat, tydlig anmälan till den registrerade.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: 'Rätt till tillträde',
            description: 'De registrerade har rätt att få tillgång till sina personuppgifter som finns hos den personuppgiftsansvarige.',
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Rätt till rättelse',
            description: 'Registrerade har rätt att begära rättelse av felaktiga personuppgifter.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: 'Rätt till radering',
            description: 'Registrerade har rätt att begära radering av sina personuppgifter.',
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Rätt att begränsa behandlingen',
            description: 'Registrerade har rätt att begära begränsning av behandlingen av sina personuppgifter.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: 'Rätt att invända',
            description: 'Registrerade har rätt att invända mot behandlingen av deras personuppgifter.',
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Rätt att återkalla samtycke',
            description: 'Registrerade har rätt att när som helst återkalla tidigare lämnat samtycke.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: 'Överträdelsemeddelande till myndigheten (72h)',
            description: 'Den personuppgiftsansvarige måste meddela ministeriet för allmän säkerhet inom 72 timmar efter att ett personuppgiftsintrång upptäcktes.',
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Överträdelsemeddelande till registrerade',
            description: 'Personuppgiftsansvarig ska utan onödigt dröjsmål underrätta berörda registrerade om ett personuppgiftsintrång.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] för högriskbehandling',
            description: 'En dataskyddskonsekvensbedömning måste göras för behandlingsaktiviteter som sannolikt kommer att leda till hög risk.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Bedömning av gränsöverskridande överföringar',
            description: 'En konsekvensanalys måste göras innan personuppgifter överförs utanför Vietnam.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Registrering av bearbetningsaktiviteter',
            description: 'Personuppgiftsansvariga måste föra ett register över behandlingsaktiviteter (RoPA) som dokumenterar alla behandlingsaktiviteter.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Databehandlande avtalsregister',
            description: 'Register över databehandlande avtal med processorer och underbehandlare ska föras.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Skyddsåtgärder för gränsöverskridande överföringar',
            description: 'Överföringar av personuppgifter utanför Vietnam kräver lämpliga skyddsåtgärder och dokumenterade bedömningar.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Bekräftelse inom 2 arbetsdagar',
            description: 'Begäran från den registrerade måste bekräftas inom 2 arbetsdagar efter mottagandet.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Färdigställande inom 15 arbetsdagar',
            description: 'Begäran om den registrerade måste slutföras inom 15 arbetsdagar, med en eventuell förlängning på 5 arbetsdagar.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'MoPS konsekvensbedömningsunderlag',
            description: 'Organisationer som bedriver högriskbehandling måste lämna in en konsekvensbedömningsunderlag till ministeriet för allmän säkerhet enligt det föreskrivna administrativa förfarandet.',
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'MoPS gränsöverskridande överföringsunderlag',
            description: 'Organisationer som överför personuppgifter utanför Vietnam måste lämna in en konsekvensbedömningsunderlag för gränsöverskridande överföring till ministeriet för allmän säkerhet.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Bearbetar tjänsteleverantörscertifiering',
            description: 'Organisationer som tillhandahåller personuppgiftsbehandling som en tjänst måste skaffa ett tjänstebearbetningscertifikat från ministeriet för allmän säkerhet.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: 'Behandling av konsekvensbedömningsunderlag när triggers uppfylls',
            description: 'En bearbetningskonsekvensbedömningsunderlag måste lämnas in när föreskrivna triggers uppfylls.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Dokumentation för gränsöverskridande överföring',
            description: 'Ett underlag för gränsöverskridande överföringseffekter måste förberedas och arkiveras för internationella dataöverföringar.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Utnämning av dataskyddsombud',
            description: 'Ett dataskyddsombud ska utses enligt dekret 13.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Styrningsartefakter (policyer, roller, procedurer)',
            description: 'Styrningsartefakter inklusive policyer, roller och procedurer måste bibehållas.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Bevispaketets fullständighet och oföränderlig revisionsspår',
            description: 'Bevispaket måste vara kompletta och ett oföränderligt granskningsspår måste upprätthållas.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Stöd för arbetsflöde för arkivering',
            description: 'Arbetsflöden för arkivering av ärenden måste stödjas för konsekvensbedömningar och gränsöverskridande ärenden.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Bearbetaravtalskrav',
            description: 'Avtalskrav på databehandlare ska fastställas och övervakas.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: 'Årlig granskning av efterlevnad',
            description: 'En årlig efterlevnadsgranskning måste genomföras för att verifiera att den fortlöpande efterlevs.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Myndighetsarkivering av inlämningsuppgifter',
            description: 'Register över alla myndighetshandlingar måste föras.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Lagliga grunder för behandling av personuppgifter',
            description: 'Behandling av personuppgifter måste baseras på laglig grund enligt definitionen av [[TOK_0]].',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Samtyckeskrav för känsliga uppgifter',
            description: 'Behandling av känsliga personuppgifter kräver uttryckligt samtycke med särskilda krav.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Den registrerades rättigheter (åtkomst, rättelse, radering, begränsning, objekt, portabilitet)',
            description: 'Registrerade personer har omfattande rättigheter inklusive åtkomst, rättelse, radering, begränsning, invändning och portabilitet.',
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: 'Överträdelsemeddelande till myndigheten',
            description: 'Personuppgiftsansvariga måste underrätta den behöriga myndigheten om personuppgiftsintrång inom den föreskrivna tidsramen.',
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Överträdelsemeddelande till registrerade',
            description: 'Personuppgiftsansvariga måste underrätta berörda registrerade om intrång i personuppgiftsrätten.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: 'Konsekvensbedömning av dataskydd',
            description: 'En konsekvensbedömning av dataskyddet måste göras för högriskbehandlingsverksamhet.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Styrning av gränsöverskridande överföringar',
            description: 'Gränsöverskridande överföringar av personuppgifter måste följa styrningskraven.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Utnämning av dataskyddsombud',
            description: 'Organisationer måste utse ett dataskyddsombud vid behov.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Register över bearbetningsaktiviteter',
            description: 'Organisationer måste föra register över alla bearbetningsaktiviteter.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Bearbetarens avtalsförpliktelser',
            description: 'Avtalsförpliktelser måste upprättas med databehandlare.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Inlämning av konsekvensbedömningsunderlag',
            description: 'Dokumentation om konsekvensbedömning måste lämnas in till den behöriga myndigheten enligt föreskrifterna.',
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Dokumentation för gränsöverskridande överföring',
            description: 'Ett underlag för gränsöverskridande överföringseffekter måste förberedas och arkiveras för internationella dataöverföringar.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] möte och meddelande',
            description: 'Ett dataskyddsombud ska utses och myndigheten underrättas.',
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Styrningspolicyer och rutiner',
            description: 'Styrningspolicyer och förfaranden måste upprättas och underhållas.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Bevispaket och oföränderligt revisionsspår',
            description: 'Bevispaket måste vara kompletta och ett oföränderligt granskningsspår måste upprätthållas.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Arkivärendes livscykel',
            description: 'Ansökningsärendes livscykler måste hanteras genom föreskrivna stadier.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Bearbetaravtalskrav',
            description: 'Avtalskrav på databehandlare ska fastställas och övervakas.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Certifiering av tjänstebearbetningsleverantör',
            description: 'Organisationer som tillhandahåller databehandlingstjänster måste erhålla certifiering.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Myndighetsarkivering av inlämningsuppgifter',
            description: 'Register över alla myndighetshandlingar måste föras.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: 'Årlig granskning av efterlevnad',
            description: 'En årlig efterlevnadsgranskning måste genomföras för att verifiera att den fortlöpande efterlevs.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Tekniska åtgärder för datasäkerhet',
            description: 'Tekniska åtgärder för datasäkerhet ska implementeras och underhållas.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Dekret 356 officiella Mẫu số formkrav',
            description: 'De 13 officiella Mẫu số-formulären för administrativa förfaranden (Mẫu số 01a–10) som föreskrivs i dekret [[TOK_0]]Đ-CP måste användas för motsvarande ansökningar till ministeriet för allmän säkerhet. Phụ lục I–VIII-objekten är interna datastrukturmappningar, inte officiella regleringsformulär.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] inlämning av underlag till A05',
            description: 'Organisationer måste lämna in [TOK_0]] ärenden till A05/[[TOK_1]] för behandlingsaktiviteter som involverar känsliga personuppgifter eller storskalig behandling.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Inlämning av underlag för gränsöverskridande överföring',
            description: 'Organisationer måste lämna in underlag för gränsöverskridande dataöverföring för A05/[[TOK_0]] granskning och godkännande.',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Bearbetar ansökan om tjänstecertifikat',
            description: 'Leverantörer av databehandlingstjänster måste ansöka om certifikat från A05/[[TOK_0]].',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Anmälan om behandling av personuppgifter',
            description: 'Personuppgiftsansvariga måste meddela A05/[[TOK_0]] om behandling av personuppgifter med hjälp av föreskrivna formulär (Mẫu số 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: 'Årlig lägesrapportering',
            description: 'Personuppgiftsansvariga måste lämna årliga situationsrapporter för behandling av personuppgifter (Mẫu số 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Användarinformation sekretess som standard',
            description: 'Användarinformation måste som standard behandlas som konfidentiell.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Minsta organisatoriska och tekniska skyddskontroller',
            description: 'Minsta organisatoriska och tekniska skyddskontroller måste implementeras.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Avslöjande endast med korrekt grund',
            description: 'Avslöjande av användarinformation är endast tillåtet med en korrekt rättslig grund.',
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Obligatorisk redovisningsloggning och granskningsbarhet',
            description: 'Alla avslöjanden måste loggas och granskas.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: 'Internt godkännande arbetsflöde för upplysningar',
            description: 'Ett internt arbetsflöde för godkännande måste upprättas för alla upplysningar.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Myndighetsbegäran svarshantering',
            description: 'Myndighetsförfrågningar ska hanteras och besvaras enligt föreskrivna rutiner.',
        },
    },
    framework_rights_descriptions: {
        be_informed: 'Den registrerade har rätt att bli informerad om personuppgiftsbehandling.',
        consent: 'Den registrerade har rätt att samtycka till behandling av sina personuppgifter.',
        refuse_consent: 'Den registrerade har rätt att inte samtycka till behandling av sina personuppgifter.',
        withdraw_consent: 'Den registrerade har rätt att begära återkallelse av tidigare lämnat samtycke.',
        access: 'Den registrerade har rätt att se och få tillgång till sina personuppgifter som den registeransvarige innehar.',
        rectification: 'Den registrerade har rätt att rätta eller begära rättelse av felaktiga personuppgifter.',
        data_provision: 'Den registrerade har rätt att begära tillhandahållande av sina personuppgifter (yêu cầu cung cấp dữ liệu cá nhân).',
        deletion: 'Den registrerade har rätt att begära radering eller förstöring av personuppgifter, med förbehåll för lagens undantag.',
        restriction_of_processing: 'Den registrerade har rätt att begära begränsning av behandlingen av sina personuppgifter.',
        object_to_processing: 'Den registrerade har rätt att skicka en begäran om invändning mot behandlingen av sina personuppgifter.',
        complaint: 'Den registrerade har rätt att lämna in ett klagomål (khiếu nại) angående behandling av personuppgifter.',
        denunciation: 'Den registrerade har rätt att göra en uppsägning (tố cáo) angående brott mot personuppgiftsskyddet.',
        lawsuit: 'Den registrerade har rätt att väcka rättsliga åtgärder (khởi kiện) för kränkningar av deras dataskyddsrättigheter.',
        claim_damages: 'Den registrerade har rätt att kräva ersättning för skada som orsakats av brott mot personuppgiftsskyddet.',
        request_protection_measures: 'Den registrerade har rätt att begära att behöriga myndigheter eller relevanta organisationer/individer vidtar åtgärder för att skydda sina personuppgifter.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Riskhantering och övervakning (utkast)',
            steps: {
                '1': 'Identifiera riskkategorier',
                '2': 'Upprätthåll tidig varningskontroll',
                '3': 'Granska insamlings-, lagrings-, bearbetnings-, delnings- och transaktionsrisker',
                '4': 'Registrera risker för integritet, cybersäkerhet och åtkomsthantering',
                '5': 'Utlösa saneringsåtgärder',
                '6': 'Bevara recensionshistorik',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Klagomål och tvister (utkast)',
            steps: {
                '1': 'Ta emot klagomål/tvistintag',
                '2': 'Kontrollera att nödvändig information är fullständig; begär tillägg inom 24 timmar om den är ofullständig',
                '3': 'Informera parterna om hanteringssätt och förväntad tidslinje inom 3 arbetsdagar efter att ha mottagit en fullständig förfrågan',
                '4': 'Begär svar och stödjande dokument',
                '5': 'Bedöm tvistfakta och plattformsansvar',
                '6': 'Rekordupplösningsresultat',
                '7': 'Bevara bevis och avsluta ärendet',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Leverans och intyg om äganderätt till data (utkast)',
            steps: {
                '1': 'Leverera produkt/tjänst enligt avtalsmetod',
                '2': 'Registrera leveranshändelse och tid',
                '3': 'Skapa intyg om äganderätt över data',
                '4': 'Registrera transaktionsslutförande',
                '5': 'Aktivera senare uppslag/verifiering vid behov',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Transaktionsinitiering och kontraktering (utkast)',
            steps: {
                '1': 'Granska listning och utvärderingsresultat',
                '2': 'Initiera arbetsflödet för köp, förhandling eller auktion',
                '3': 'Skapa elektroniska kontrakt',
                '4': 'Säkra båda parters acceptans',
                '5': 'Registrera slutförd betalning',
                '6': 'Godkänn leverans',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Tillgång till sandlåda/testmiljö (utkast)',
            steps: {
                '1': 'Skicka sandlådeförfrågan',
                '2': 'Definiera omfattning, tillåtna data, tidsperiod och bearbetningsbehörigheter',
                '3': 'Tillhandahålla isolerad teknisk miljö',
                '4': 'Övervaka säkerhet och åtkomst under testning',
                '5': 'Granska utdata före extraktion',
                '6': 'Godkänn utvinning endast där det är tillåtet',
                '7': 'Stäng testsession och städa upp miljön',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Dataprodukt-/tjänsteförteckning (utkast)',
            steps: {
                '1': 'Skapa noteringsapplikation',
                '2': 'Fånga källa och ägande / användningsrätt bevis',
                '3': 'Anteckna tekniska egenskaper, format, [[TOK_0]] detaljer och begränsningar',
                '4': 'Upplysningar om rekordkvalitet',
                '5': 'Skicka in listningsunderlag till plattformsgranskning',
                '6': 'Plattformen utför fullständighet, laglighet och tekniska kontroller',
                '7': 'Godkänn eller avvisa notering',
                '8': 'Om den godkänns, publicera listning med bifogat utvärderingsresultat',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Introduktion av deltagare (utkast)',
            steps: {
                '1': 'Bestäm deltagartyp: säljare eller köpare',
                '2': 'Verifiera juridisk status och rättskapacitet',
                '3': 'Verifiera ytterligare villkor om villkorade affärslinjer gäller',
                '4': 'Registrera transaktionskonto',
                '5': 'Länka betalningskonto',
                '6': 'Godkänn plattformsdeltagande',
                '7': 'Lagra deltagarregister och revisionsspår',
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Systemregistrering/avisering',
            steps: {
                '1': 'Tillämpningskontroll och [[TOK_0]] systemklassificering',
                '2': 'Bygg registrerings-/anmälningsunderlag',
                '3': 'Internt godkännande',
                '4': 'Skicka in via kanal',
                '5': 'Ändringsslinga – om den returneras, uppdatera och skicka in igen',
                '6': 'Stäng och lagra bekräftelse',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Arbetsflöde för riskklassificering',
            steps: {
                '1': 'Skapa [[TOK_0]] systemregisterpost',
                '2': 'Kör klassificeringsguiden',
                '3': 'Bifoga bevis',
                '4': 'Godkänn klassificering',
                '5': 'Länka utdata till systemunderlag',
            },
        },
        AI_A3: {
            name: 'Efterlevnad av märkning och avslöjande',
            steps: {
                '1': 'Identifiera märkningsskyldigheter efter system och användningsfall',
                '2': 'Implementera märkningsmeddelanden',
                '3': 'Fånga bevis — skärmdumpar, UI-kopia, teknisk metadata',
                '4': 'Hantera undantag och registrera motivering',
                '5': 'Godkänn och version',
            },
        },
        AI_A4: {
            name: 'Rapportering av allvarliga incidenter',
            steps: {
                '1': 'Skapa [[TOK_0]] Incidentpost',
                '2': 'Klassificera svårighetsgrad',
                '3': 'Utför inneslutningsåtgärder och bevisfångst',
                '4': 'Skapa mall för rapport för allvarliga incidenter',
                '5': 'Lämna in till myndigheten via kanal',
                '6': 'Spåra myndigheters svar och stängning',
            },
        },
        AI_A5: {
            name: '[[TOK_0]] Konsekvensbedömning',
            steps: {
                '1': 'Skapa bedömningspost',
                '2': 'Fyll i obligatoriska avsnitt',
                '3': 'Bifoga bevis — dataflöden, modelldokumentation, kontroller',
                '4': 'Internt godkännande',
                '5': 'Exportera rapport och lagra i dossier',
            },
        },
        AI_A6: {
            name: 'Kontrollerad testning / Sandlådedeltagande',
            steps: {
                '1': 'Komplett behörighets- och beredskapsregister',
                '2': 'Förbered ansökan och export',
                '3': 'Skicka in via kanal',
                '4': 'Spårgodkännande',
                '5': 'Utför övervakningskontrollpunkter och loggar',
                '6': 'Komplett slutrapport och avslutande paket',
            },
        },
        CYBERSEC_C1: {
            name: 'Säkerhetsbedömning av kritiskt informationssystem',
            steps: {
                '1': 'Klassificera informationssystem enligt nationella krav på cybersäkerhet',
                '2': 'Genomföra säkerhetsbedömning och riskutvärdering för sekretessbelagda system',
                '3': 'Implementera nödvändiga säkerhetsåtgärder och baslinjekontroller',
                '4': 'Dokumentera bevis på efterlevnad och schemalägg periodiska granskningar',
            },
        },
        CYBERSEC_C2: {
            name: 'Meddelande om cybersäkerhetsincident',
            steps: {
                '1': 'Upptäck, klassificera och bedöm cybersäkerhetsincidenten',
                '2': 'Utför omedelbara svarsåtgärder och bevisbevarande',
                '3': 'Rapportera till myndigheten och delta i nationell incident-respons-samordning',
                '4': 'Genomför granskning efter incidenten och dokumentera lärdomar',
            },
        },
        CYBERSEC_C3: {
            name: 'Verifiering av efterlevnad av datalokalisering',
            steps: {
                '1': 'Bedöm om utlösare för datalokalisering gäller baserat på tjänstetyp och datakategorier',
                '2': 'Kontrollera att lokal lagringsarkitektur och gränsöverskridande flödeskontroller är på plats',
                '3': 'Bedöm lokal närvarokrav (filial / representationskontor) där så är tillämpligt',
                '4': 'Dokumentera överensstämmelsebevis och underhålla för myndighetsgranskning',
            },
        },
        CYBERSEC_C4: {
            name: 'Svar från myndighetssamarbete',
            steps: {
                '1': 'Ta emot och verifiera legitimiteten och omfattningen av myndighetsbegäran',
                '2': 'Samla in och förbered begärd information eller utför nödvändiga åtgärder',
                '3': 'Skicka svar till myndigheten inom den tidsram som krävs',
                '4': 'Logga avslöjandet och stäng ärendet',
            },
        },
        CYBERSEC_C5: {
            name: 'Verifiering av kvalificering för cybersäkerhetspersonal',
            steps: {
                '1': 'Bedöm leverantörens säkerhetsställning med hjälp av ramverket för cybersäkerhetsbedömning',
                '2': 'Verifiera åtkomstomfånget för leverantörsdata och registrera i åtkomstloggen för leverantörsdata',
                '3': 'Granska klausulen om leverantörsincidentmeddelanden och avtalsenliga krav på cybersäkerhet',
                '4': 'Schemalägg periodiska säkerhetsgranskningar av leverantörer och övervaka efterlevnad',
            },
        },
        DATA_D1: {
            name: 'Datainventering och klassificeringsinställning',
            steps: {
                '1': 'Katalogisera alla datatillgångar med typer och källor i datainventeringsregistret',
                '2': 'Klassificera varje tillgång efter känslighetsnivå',
                '3': 'Definiera hanteringsregler per klassificeringsnivå',
                '4': 'Fånga bevis — skärmdumpar, arkitekturdiagram, åtkomstkontroller',
                '5': 'Schemalägg periodiska granskningar',
            },
        },
        DATA_D2: {
            name: 'Styrning av datadelning',
            steps: {
                '1': 'Utvärdera nya delningsarrangemang via riskbedömning av datadelning',
                '2': 'Komplett internt godkännande arbetsflöde',
                '3': 'Registrera delningshändelse i datadelnings-/avslöjandelogg',
                '4': 'Fånga bevis — godkännandedokument, kontraktsdokument',
                '5': 'Periodisk översyn av delningsarrangemang',
            },
        },
        DATA_D3: {
            name: 'Gränsöverskridande dataöverföringsbedömning',
            steps: {
                '1': 'Identifiera gränsöverskridande överföringar i datainventering',
                '2': 'Utför överföringsriskbedömning',
                '3': 'Tillämpa skyddsåtgärder och styrningsåtgärder',
                '4': 'Dokument i gränsöverskridande avsnitt av förvaltningsbevis',
                '5': 'Exportbedömningspaket för revision',
            },
        },
        DATA_D4: {
            name: 'Årligt styrelseintyg',
            steps: {
                '1': 'Granska styrning RACI matris',
                '2': 'Verifiera policystatus (styrning, klassificering, delning, lagring)',
                '3': 'Komplett intygspaket',
                '4': 'Skaffa internt godkännande',
                '5': 'Exportera och arkivera intyg',
            },
        },
        DATA_D5: {
            name: 'Hantering av dataincidenter',
            steps: {
                '1': 'Klassificera händelsen med hjälp av beslutsprotokoll',
                '2': 'Utför incidentsvar per spelbok',
                '3': 'Fånga bevis – loggar, skärmdumpar, kommunikation',
                '4': 'Genomför granskning efter incidenten',
                '5': 'Om myndighetsanmälan krävs: skapa inlämningsärende och skicka in till [[TOK_0]]',
                '6': 'Stäng och arkivera',
            },
        },
        ECOM_P1: {
            name: 'Avisering (försäljningswebbplats/app)',
            steps: {
                '1': 'Bestäm klassificering: försäljningssajt/app kontra marknadsplats/tjänstplattform',
                '2': 'Skapa intern underlagspost med företagsidentitet, webbplats/appinformation och obligatoriska upplysningar',
                '3': 'Generera bevispaket — skärmdumpar av avslöjanden, policy-URL:er, versionshistorik',
                '4': 'Skicka in via Online.gov.vn – ladda upp dokument, spela in tidsstämpel och bekräftelse',
                '5': 'Spåra bearbetning – om den returneras för ändring, fånga upp orsaker och skicka in igen',
                '6': 'Stäng — butiksbekräftelse, länkbevis och revisionsspår',
            },
        },
        ECOM_P2: {
            name: 'Registrering (tjänsteplattformar/marknadsplatser)',
            steps: {
                '1': 'Bestäm plattformsmodell och skyldigheter – marknadsplats vs blandad vs social handel',
                '2': 'Bygg registreringsunderlag — ansökningsformulär, tjänsteförsörjningssystem, villkor, plattformsregler',
                '3': 'Interna godkännanden — tilldela juridisk/efterlevnadsägare, godkänn för inlämning',
                '4': 'Skicka in via Online.gov.vn — ladda upp underlag, spela in tidsstämpel',
                '5': 'Bearbetningsslinga — om den returneras för ändring, uppdatera och skicka in igen',
                '6': 'Godkännande och operationalisering — butiksbekräftelse, upprätthålla löpande efterlevnadsregister',
            },
        },
        ECOM_P3: {
            name: 'Uppdatera/ändringsmeddelande',
            steps: {
                '1': 'Identifiera ändringsutlösare — materialändring av underlagsartiklar',
                '2': 'Generera ändringspaket — ändringssammanfattning, uppdaterade dokument, bevisuppdateringar',
                '3': 'Skicka uppdatering och registrera inlämningsstatus',
                '4': 'Spåra bearbetning och stäng',
            },
        },
        ECOM_P4: {
            name: 'Uppsägning / avaktivering',
            steps: {
                '1': 'Förbered uppsägningspaket — upphörandedatum, orsak, hanteringsplan för konsumentskydd, bevis på offentligt meddelande',
                '2': 'Skicka uppsägning — spela in tidsstämpel och bekräftelse',
                '3': 'Stäng — lagra slutlig status och bevis',
            },
        },
        ECOM_P5: {
            name: 'Trustmark / Credibility Rating Program',
            steps: {
                '1': 'Behörighets- och beredskapsprövning',
                '2': 'Förbered underlag med officiell blankett',
                '3': 'Skicka in och spåra',
                '4': 'Upprätthåll fortlöpande överensstämmelsebevis',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Inlämning till [[TOK_1]]',
            steps: {
                '1': 'Fyll i [[TOK_0]] med hjälp av dekret 356 formulärväg (Mẫu số 02a/02b)',
                '2': 'Samla omslagsdokument och stödbevis',
                '3': 'Skicka in ett originalunderlag till ministeriet för allmän säkerhet ([[TOK_0]])',
                '4': 'Övervaka efter förfrågningar om tillägg från [[TOK_0]] och svara inom deadline',
                '5': 'Behåll underlag och bevis för inlämning för revisionsspår',
            },
        },
        PDPL_P2: {
            name: 'Ansökan om gränsöverskridande överföring',
            steps: {
                '1': 'Komplettera gränsöverskridande överföringsunderlag med hjälp av dekret 356-formulär (Mẫu số 01a/01b, Mẫu số 09)',
                '2': 'Skicka in ett originalunderlag till [[TOK_0]] inom 60 dagar efter det att behandlingen påbörjades',
                '3': 'Meddela [[TOK_0]] efter lyckad överföring med kontaktuppgifter till den mottagande parten',
                '4': 'Svara på förfrågningar om tillägg/korrigering/inspektion från [[TOK_0]] inom deadline',
            },
        },
        PDPL_P3: {
            name: 'Ansökan om certifikat för databehandlingstjänst',
            steps: {
                '1': 'Förbered certifieringsansökan enligt dekret 356 krav',
                '2': 'Skicka in ansökan till [[TOK_0]] med nödvändiga styrkande handlingar',
                '3': 'Svara på [[TOK_0]] granskningskommentarer och förfrågningar om tillägg',
                '4': 'Upprätthålla certifikat och förnyelseschema',
            },
        },
        PDPL_P4: {
            name: 'Bearbetning av begäran om registrerade rättigheter',
            steps: {
                '1': 'Ta emot och logga begäran; verifiera den registrerades identitet inom 2 arbetsdagar',
                '2': 'Bedöm typ av begäran och bestäm tillämplig deadline (10/15/20 dagar per typ)',
                '3': 'Utför genomförandeåtgärder över relevanta system och avdelningar',
                '4': 'Förbered och skicka svar till den registrerade med resultat och motivering',
                '5': 'Stäng ärendet och behåll bevis för revision; dokumentera eventuella skäl för vägran',
            },
        },
        PDPL_P5: {
            name: 'Avisering om brott till [[TOK_0]]',
            steps: {
                '1': 'Upptäcka och bedöma överträdelsen; fastställa anmälningsskyldighet inom 2 arbetsdagar',
                '2': 'Förbered aviseringspaket enligt [[TOK_0]] krav',
                '3': 'Skicka meddelande till [[TOK_0]] inom 2 arbetsdagar efter upptäckten',
                '4': 'Svara på [[TOK_0]] uppföljningsförfrågningar; lämna in kompletteringar och samordningsbevis',
            },
        },
        TELECOM_T1: {
            name: 'Hantering av myndighetsförfrågningar',
            steps: {
                '1': 'Ta emot och logga myndighetsbegäran via intagspost',
                '2': 'Verifiera myndighetsidentitet, rättslig grund och begärans omfattning',
                '3': 'Genomför intern juridisk granskning och erhåll ledningens godkännande',
                '4': 'Förbered svarspaket med samlade bevis',
                '5': 'Utarbeta och godkänn svarsbrev',
                '6': 'Skapa inlämningsärende och skicka in svar via kanalen',
                '7': 'Loggavslöjande och spårmyndighetsbekräftelse',
                '8': 'Stäng ärendet och behåll bevis för revisionsspår',
            },
        },
        TELECOM_T2: {
            name: 'Disclosure Management',
            steps: {
                '1': 'Ta emot begäran om avslöjande (användarens samtycke, juridisk skyldighet eller myndighetsbegäran)',
                '2': 'Komplett arbetsflöde för godkännande av avslöjande',
                '3': 'Utför avslöjande och registrera i loggregister',
                '4': 'Fånga bevis — godkännanderegister, kommunikationsregister',
                '5': 'Regelbunden granskning av avslöjandelogg',
            },
        },
        TELECOM_T3: {
            name: 'Konfidentialitetspolicy och inställning av åtkomstkontroll',
            steps: {
                '1': 'Utarbeta och godkänn sekretesspolicy',
                '2': 'Utarbeta och godkänn policy för åtkomstkontroll och loggning',
                '3': 'Dokumentbehandlingsaktiviteter i användarinformationsbehandlingsregister',
                '4': 'Fånga bevis — policydokument, genomförandebevis',
                '5': 'Schemalägg periodiska granskningar',
            },
        },
        TELECOM_T4: {
            name: 'Telecom Incident Assessment',
            steps: {
                '1': 'Klassificera och bedöm händelsen',
                '2': 'Bestäm aviseringskrav',
                '3': 'Om myndighetsanmälan krävs: skapa inlämningsärende',
                '4': 'Fånga och bevara bevis',
                '5': 'Upplösning och stängning',
            },
        },
        TELECOM_T5: {
            name: 'Hantering av kvarhållning och radering',
            steps: {
                '1': 'Definiera lagrings- och raderingsschema per datakategori',
                '2': 'Implementera raderingsprocedurer',
                '3': 'Fånga bevis — radering av poster',
                '4': 'Periodisk genomgång av scheman',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Incidenthantering och rapporteringsfel',
            'CYBERSEC-FINE-B': 'Systemsäkerhetsövervakning och Baseline-kontrollfel',
            'CYBERSEC-FINE-C': 'Myndighetsbegäran Samarbete misslyckades',
            'CYBERSEC-FINE-D': 'Datalokalisering och lokal närvaroöverträdelser',
            'CYBERSEC-FINE-E': 'Förebyggande av skadlig programvara och systemskyddsfel',
            'CYBERSEC-FINE-F': 'Plattforms-/tjänsteleverantörssvarsfel',
            'CYBERSEC-FINE-G': 'Säkerhetsfel hos leverantören/tredje part',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Registrering / Anmälan / Administrativ beredskap',
            'ECOM-FINE-B': 'Klagomål och konsumentskydd',
            'ECOM-FINE-C': 'Övervakning och borttagningskontroll',
            'ECOM-FINE-D': 'Gränsöverskridande operationer',
            'ECOM-FINE-E': 'Plattformsregler och transparens',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Underlåtenhet att utföra [[TOK_0]]',
            'PDPL-FINE-B': 'Obehörig gränsöverskridande överföring',
            'PDPL-FINE-C': 'Behandling utan laglig grund',
            'PDPL-FINE-D': 'Underlåtenhet att svara på DSR',
            'PDPL-FINE-E': 'Underlåtenhet att meddela dataintrång',
            'PDPL-FINE-F': 'Icke-kompatibelt bearbetningsavtal',
            'PDPL-FINE-G': 'Överträdelser av känslig databehandling',
            'PDPL-FINE-H': 'Barns databehandlingsöverträdelser',
            'PDPL-FINE-I': 'Automatiserade beslutsfattande kränkningar',
            'PDPL-FINE-J': 'Underlåtenhet att följa myndighetsföreskrifter',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Hantering av myndighetsbegäranden',
            'TELECOM-FINE-B': 'Sekretess och obehörigt avslöjande',
            'TELECOM-FINE-C': 'Åtkomstkontroll och loggningsfel',
            'TELECOM-FINE-D': 'Överträdelser av kvarhållande och radering',
            'TELECOM-FINE-E': 'Utvärdering av telekomincidenter misslyckades',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Omedelbart efter upptäckt',
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Som anges i myndighetsbegäran',
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Upp till 80 miljoner VND',
                fine_org: 'Upp till 160 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'ECOM-FINE-D': {
                fine_individual: 'Upp till 80 miljoner VND',
                fine_org: 'Upp till 160 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'ECOM-FINE-C': {
                fine_individual: 'Upp till 80 miljoner VND',
                fine_org: 'Upp till 160 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'ECOM-FINE-B': {
                fine_individual: 'Upp till 80 miljoner VND',
                fine_org: 'Upp till 160 miljoner VND',
                deadlines: 'Som specificerats enligt skyldigheter för hantering av klagomål',
            },
            'ECOM-FINE-A': {
                fine_individual: 'Upp till 80 miljoner VND',
                fine_org: 'Upp till 160 miljoner VND',
                deadlines: 'Innan du påbörjar e-handelsverksamhet',
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'CYBERSEC-FINE-F': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Som anges i myndighetsbegäran',
            },
            'CYBERSEC-FINE-E': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Löpande skyldighet',
            },
            'CYBERSEC-FINE-D': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Som anges i myndighetsbeslut; pågående skyldighet där den utlöstes',
            },
            'CYBERSEC-FINE-C': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Som anges i myndighetsbegäran',
            },
            'CYBERSEC-FINE-B': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Pågående skyldighet; kontroller måste vara på plats innan systemet tas i drift',
            },
            'CYBERSEC-FINE-A': {
                fine_individual: 'Upp till 100 miljoner VND',
                fine_org: 'Upp till 200 miljoner VND',
                deadlines: 'Omedelbart svar krävs; rapportering inom föreskriven tidslinje',
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: '60 dagar från början av behandlingen för att skicka in underlag till [[TOK_0]]',
            },
            'PDPL-FINE-B': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                revenue: '3%–5% av föregående år Vietnams intäkter i allvarliga fall',
                deadlines: '60 dagar från början av behandlingen för att lämna in underlag till [[TOK_0]]; meddelande efter överföring krävs',
            },
            'PDPL-FINE-C': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: 'Pågående skyldighet; samtycke måste inhämtas innan behandlingen',
            },
            'PDPL-FINE-D': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: '2 arbetsdagars procedursvar; 10 dagars åtkomst/korrigering; 15 dagars återkallelse/begränsning/invändning; 20 dagars radering',
            },
            'PDPL-FINE-E': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: '2 arbetsdagar att meddela [[TOK_0]] efter att ha upptäckt en överträdelse',
            },
            'PDPL-FINE-F': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: 'Löpande skyldighet',
            },
            'PDPL-FINE-G': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: 'Pågående skyldighet; kontroller måste finnas på plats innan känsliga uppgifter behandlas',
            },
            'PDPL-FINE-H': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: 'Pågående skyldighet; föräldrarnas samtycke krävs innan behandlingen',
            },
            'PDPL-FINE-I': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                deadlines: 'Löpande skyldighet',
            },
            'PDPL-FINE-J': {
                fine_individual: 'Upp till 1,5 miljarder VND',
                fine_org: 'Upp till 3 miljarder VND',
                revenue: 'Upp till 5 % av tidigare års intäkter från Vietnam för upprepade överträdelser',
                deadlines: 'Som anges i myndighetsförordningen',
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Pågående drift av plattformen',
            responsible: {
                '1': 'Plattformsoperatör/risk',
                '2': 'Plattformsoperatör / Säkerhet',
                '3': 'Plattformsoperatör/risk',
                '4': 'Plattformsoperatör / Säkerhet',
                '5': 'Plattformsoperatör',
                '6': 'Efterlevnad',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P6: {
            trigger: 'En deltagare lämnar in ett klagomål eller en begäran om tvist',
            responsible: {
                '1': 'Plattformsoperatör',
                '2': 'Plattformsoperatör',
                '3': 'Plattformsoperatör',
                '4': 'Plattformsoperatör',
                '5': 'Plattformsoperatör / Juridisk',
                '6': 'Plattformsoperatör',
                '7': 'Efterlevnad',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P5: {
            trigger: 'Leverans slutförs efter att kontrakt och betalningsvillkor är uppfyllda',
            responsible: {
                '1': 'Säljare / Plattformsoperatör',
                '2': 'Plattformsoperatör',
                '3': 'Plattformsoperatör',
                '4': 'Plattformsoperatör',
                '5': 'Plattformsoperatör',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P4: {
            trigger: 'En köpare initierar en transaktion för data, produkt eller tjänst',
            responsible: {
                '1': 'Köpare',
                '2': 'Köpare / Plattformsoperatör',
                '3': 'Plattformsoperatör',
                '4': 'Köpare/säljare',
                '5': 'Plattformsoperatör / Betalning',
                '6': 'Plattformsoperatör',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P3: {
            trigger: 'En deltagare vill utvärdera dataprodukter/tjänster i den isolerade miljön',
            responsible: {
                '1': 'Deltagare',
                '2': 'Plattformsoperatör/deltagare',
                '3': 'Plattformsoperatör / IT',
                '4': 'Plattformsoperatör / Säkerhet',
                '5': 'Plattformsoperatör',
                '6': 'Plattformsoperatör',
                '7': 'Plattformsoperatör / IT',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P2: {
            trigger: 'En säljare försöker lista data, produkt eller datatjänst för handel',
            responsible: {
                '1': 'Säljare',
                '2': 'Säljare / Juridisk',
                '3': 'Säljare / IT',
                '4': 'Säljare',
                '5': 'Säljare',
                '6': 'Plattformsoperatör',
                '7': 'Plattformsoperatör',
                '8': 'Plattformsoperatör',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P1: {
            trigger: 'En säljare eller köpare ansluter sig till dataplattformen',
            responsible: {
                '1': 'Plattformsoperatör',
                '2': 'Plattformsoperatör / Juridisk',
                '3': 'Plattformsoperatör / Juridisk',
                '4': 'Plattformsoperatör',
                '5': 'Plattformsoperatör',
                '6': 'Plattformsoperatör',
                '7': 'Efterlevnad',
            },
            step_outputs: {},
        },
        PDPL_P1: {
            trigger: 'Inledning av personuppgiftsbehandling som kräver konsekvensanalys',
            responsible: {
                '1': '[[TOK_0]] / Sekretessteam',
                '2': 'Sekretessteam',
                '3': 'Juridisk / Efterlevnad',
                '4': '[[TOK_0]] / Sekretessteam',
                '5': 'Efterlevnadsteam',
            },
            step_outputs: {},
        },
        PDPL_P2: {
            trigger: 'Avsikt att överföra personuppgifter utanför Vietnam',
            responsible: {
                '1': '[[TOK_0]] / Sekretessteam',
                '2': 'Juridisk / Efterlevnad',
                '3': 'Juridisk / Efterlevnad',
                '4': '[[TOK_0]] / Sekretessteam',
            },
            step_outputs: {},
        },
        PDPL_P3: {
            trigger: 'Organisation som tillhandahåller databehandlingstjänster som kräver certifiering',
            responsible: {
                '1': 'Juridisk / Efterlevnad',
                '2': 'Juridisk / Efterlevnad',
                '3': '[[TOK_0]] / Sekretessteam',
                '4': 'Efterlevnadsteam',
            },
            step_outputs: {},
        },
        PDPL_P4: {
            trigger: 'Mottagande av en begäran om registrerade rättigheter',
            responsible: {
                '1': 'Integritetsteam / kundtjänst',
                '2': '[[TOK_0]] / Sekretessteam',
                '3': 'Avdelningsledare / IT',
                '4': '[[TOK_0]] / Sekretessteam',
                '5': 'Efterlevnadsteam',
            },
            step_outputs: {},
        },
        PDPL_P5: {
            trigger: 'Upptäckt av en överträdelse eller intrång i personuppgiftsskyddet',
            responsible: {
                '1': 'Incident Response Team / [[TOK_0]]',
                '2': '[[TOK_0]] / Sekretessteam',
                '3': 'Juridisk / Efterlevnad',
                '4': '[[TOK_0]] / Incident Response Team',
            },
            step_outputs: {},
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Dekret 13 art. 24',
        'MoPS Admin Procedures': 'MoPS Admin-procedurer',
        'Annual cycle': 'Årscykel',
        'Decree 13/2023/NĐ-CP Art. 24': 'Dekret [[TOK_0]]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Dekret [[TOK_0]]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 2–5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Dekret [[TOK_0]]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Utkast till dekret om dataplattformar 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Lag [[TOK_0]] Kap. III; NĐ 98/2020; NĐ 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Lag [[TOK_0]] Kap. IV (Konsumentskydd)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Lag [[TOK_0]] – Online.gov.vns operativa procedur',
        'Law 134/2025/QH15 Article 12': 'Lag [[TOK_0]] Artikel 12',
        'Law 134/2025/QH15 Article 21': 'Lag [[TOK_0]] Artikel 21',
        'Law 134/2025/QH15 Article 27': 'Lag [[TOK_0]] Artikel 27',
        'Law 134/2025/QH15 Articles 9–10': 'Lag [[TOK_0]] artiklarna 9–10',
        'Law 24/2023/QH15 — article mapping pending': 'Lag [[TOK_0]] – artikelkartläggning pågår',
        'Law 60/2024/QH15 (internal control target)': 'Lag [[TOK_0]] (internkontrollmål)',
        'Law 91/2025/QH15 Art. 21': 'Lag [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Lag [[TOK_0]] Art. 23',
        'Policy-defined': 'Policydefinierad',
        Quarterly: 'Kvartalsvis',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 administrativt förfarande',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'mål för intern kontroll (lag [[TOK_0]] art. 24(2)(b), 41(5) – exakt tidslinje i väntan på genomförandeinstrument)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'internkontrollmål (lag [[TOK_0]] artikel 41.3 – exakt tidslinje i väntan på genomförandeinstrument)',
        'source verification pending': 'källverifiering väntar',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN — Ad hoc-rapportering från internrevisionen till SBV (nivå 5)',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN — Årlig ICAAP-rapport (bilaga III) (nivå 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN — Årlig bilaga I (nivå 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN — Årlig bilaga IV (nivå 5)',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN — Årlig riskhanteringsrapport (bilaga II) (nivå 5)',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Ansvar för tillgångsförvaltning (nivå 2, tema C)',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": 'Circular 83/2025/TT-NHNN â€” Tillsyn frÃ¥n styrelse / medlemsrÃ¥d (nivÃ¥ 2, tema A)',
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Styrelsekommittéer (nivå 2, tema A)',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Styrelsebeslut och protokoll (nivå 2, tema A)',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Rutiner för filialkontroll (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Efterlevnadsbedömning av interna regler (nivå 2, tema D)',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Efterlevnadsfunktion (nivå 2, tema D)',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Uppföljning av efterlevnadsåtgärder (nivå 2, tema D)',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Koncentrationsrisk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Intressekonflikter (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN — Kontrollkultur (nivå 2, tema A/B)',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Kreditrisk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Delegerad befogenhet (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN — Anmälan om tidig implementering (nivå 5)',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Generaldirektörens ansvar (nivå 2, tema A)',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — ICAAP (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Ränterisk i bankboken (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internrevisionsstadga (nivå 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN — Internrevisionsuppdrag (tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Kommunikation av internrevisionsiakttagelser (nivå 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN — Internrevisionsiakttagelser och korrigerande åtgärder (tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN — Uppföljning av internrevision (tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN — Styrning av internrevision',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internrevisionens oberoende (nivå 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN — Internrevisionsplan (nivå 2/tema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internrevisionsrapportering till SBV (nivå 2, tema H)',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN — Styrning av internkontrollsystemet (nivå 2)',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Intern rapporteringsrutin (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Register över interna rapporter (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Bevakning av lagändringar (nivå 2, tema D)',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Juridisk risk och anseenderisk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Eskalering vid limitöverträdelse (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Likviditetsrisk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Årlig översyn av MIS (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS-backup och kontinuitet (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Eskalationsmekanismer för MIS (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS-tillförlitlighet och konfidentialitet (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Källor för riskdata i MIS (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN — Management Information System (nivå 4)',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Marknadsrisk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN — Register över väsentliga risker (nivå 3)',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Modellrisk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Granskning av nya produkter (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Operativ risk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — BCP för outsourcing (nivå 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcingavtal (nivå 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN — Kontroller för outsourcing',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Due diligence för outsourcing (nivå 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Reservleverantör vid outsourcing (nivå 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Väsentlighet för outsourcing (nivå 2, tema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Övervakning av outsourcing (nivå 2, tema G)',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN — Tekniska referenser för bilaga V/VI (nivå 5)',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Policyregister (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Yrkesetik (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN — Risktolerans (nivå 3)',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Samordning i riskkommittén (nivå 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Styrning av riskdata (nivå 3, tema E/F) — fasas in till 2028-01-01',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Översyn av risklimiter (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Ramverk för risklimiter (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Riskhanteringsfunktion (nivå 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Riskmetodik och modeller (nivå 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Riskrapportering (nivå 2, tema E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Rapporteringsfrekvens för risker (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN — Inlämning av åtgärdsplan till SBV (nivå 5)',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN — Inlämningskanaler till SBV (nivå 5)',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN — Sektortillämplighet (nivå 1)',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Separation av arbetsuppgifter (nivå 2, tema C)',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Tillsyn från högsta ledningen (nivå 2, tema A)',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Strategisk risk (nivå 3, tema E)',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Stresstester (nivå 3, tema E) — fasas in till 2028-01-01',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Tillsynsstyrelse (nivå 2, tema A)',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Register över tillsynsiakttagelser (nivå 4, tema F)',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN — Roller och eskalering i tre försvarslinjer (nivå 2, tema B)',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN — Tre försvarslinjer (nivå 2)',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Eskalering av regelöverträdelse (nivå 2, tema D)',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội (nationalförsamlingen)',
        'Ministry of Public Security / A05 Department': 'Ministeriet för allmän säkerhet / A05-avdelningen',
        'Ministry of Public Security': 'Ministeriet för allmän säkerhet',
        'Ministry of Information and Communications': 'Informations- och kommunikationsministeriet',
        'Government of Vietnam': 'Vietnams regering',
        'European Data Protection Board (EDPB)': 'Europeiska dataskyddsstyrelsen (EDPB)',
        'ENISA / National CSIRTs': 'ENISA / Nationella CSIRTs',
        'State Bank of Vietnam': 'State Bank of Vietnam',
    },
    tour_titles: {
        access_accountability: 'Få tillgång till Accountability Tour',
        assessments: 'Bedömningstur',
        audit_trail: 'Rundtur i Audit Trail',
        classification: 'Klassificeringstur',
        compliance_forms: 'Överensstämmelseformulär Tour',
        connectors: 'Connectors Tour',
        consent_properties: 'Consent Properties Tour',
        consent: 'Samtyckstur',
        dashboard: 'Dashboard rundtur',
        data_mapping: 'Datakartläggningstur',
        data_subjects: 'Datasubjektsrundtur',
        deletion_orchestration: 'Radering Orchestration Tour',
        discovery: 'Discovery Tour',
        governance: 'Governance Tour',
        help_center: 'Rundtur i hjälpcentret',
        incident_ops: 'Incident Operations Tour',
        incidents: 'Incident Tour',
        localization: 'Lokaliseringstur',
        monitoring: 'Övervakningstur',
        onboarding: 'Onboarding Tour',
        organizations: 'Organisationsturné',
        partner_workspace: 'Partner Workspace Tour',
        platform_settings: 'Plattformsinställningar rundtur',
        privacy_scanner: 'Sekretessskannertur',
        program_governance: 'Programstyrningsturné',
        rights_requests: 'Rättighetsförfrågningar Tour',
        task_management: 'Task Management Tour',
        vendor_risk: 'Leverantörsrisktur',
    },
    tour_descriptions: {
        access_accountability: 'Som internrevisionsledare (P-VN-10), granska åtkomstbevis, användning av revisionsbehörighet och undersök avvikande mönster för att visa [[TOK_0]] artikel 5(1)(f) integritet och konfidentialitet.',
        assessments: 'När företaget [[TOK_1]] (P-VN-01) utför DPIAs enligt dekret 356 Mau so 02a, identifiera efterlevnadsluckor och bedöm gränsöverskridande överföringsrisker under [[TOK_0]].',
        audit_trail: 'Som internrevisionsledare (P-VN-10), fråga efter bevis över flera moduler, sätt ihop revisionspaket och exportera manipuleringssäkra loggar för regulatoriska inlämningar.',
        classification: 'Som Data Steward (P-VN-05), definiera dataklassificeringstaxonomier, tilldela känslighetsetiketter, upprätthåll lagringspolicyer och lös täckningsluckor som krävs för att [[TOK_0]] ska uppfyllas.',
        compliance_forms: 'Som Enterprise [[TOK_0]] (P-VN-01), bläddra, fyll i och skicka in officiella vietnamesiska tillsynsformulär inklusive Phu luc I, Phu luc II och Mau so mallar för PDP-kommittéansökningar.',
        connectors: 'Som IT-systemledare (P-VN-05), fånga upp affärskrav för integrationer, mappa kopplingar till efterlevnadsdataflöden och verifiera POC-beredskap innan du går live.',
        consent_properties: 'Som Enterprise [[TOK_1]] (P-VN-01), konfigurera [[TOK_2]]-distribution: digital egendomsregistrering, gyllene mallar för konsekventa [[TOK_0]] samtyckesbanners och bindande matriser som länkar egenskaper till bearbetningsaktiviteter.',
        consent: 'Som Enterprise [[TOK_1]] (P-VN-01), hantera samtyckespolicyns livscykel: definiera insamlingsändamål, upprätthålla [[TOK_0]] uttagsrättigheter och integrera med din samtyckeshanteringsplattform.',
        dashboard: 'Som Enterprise [[TOK_1]] (P-VN-01), orientera dig runt kommandocentret för efterlevnadsställning som visar [[TOK_0]] deadlines, bryter mot SLA:er och KPI:er för revisionsberedskap.',
        data_mapping: 'Som Data Steward (P-VN-05), bygg upp din ROPA-inventering, kartlägg gränsöverskridande dataflöden och underhåll registret för behandlingsaktivitet som krävs av [[TOK_0]].',
        data_subjects: 'Som Enterprise DPO eller Education Compliance Lead, hantera enhetliga profiler för registrerade som länkar samtyckesposter, rättighetsbegäranden och tidslinjeaktivitet över hela plattformen.',
        deletion_orchestration: 'Som [[TOK_1]] (P-VN-01), verifiera radering av data från slut till ände över interna system och tredjepartsleverantörer, med kryptografiska beviskedjor för [[TOK_0]] artikel 17-rättighet att radera efterlevnad.',
        discovery: 'Som Data Steward (P-VN-05), kör automatiska skanningar för att upptäcka personuppgifter över anslutna system, granska stegvisa fynd och mata in resultat i klassificeringsmodulen för [[TOK_0]]-märkning.',
        governance: 'Som leverantörsriskhanterare (P-VN-08), upprätthåll leverantörsregistret, spåra underprocessorkedjor, bedöm gränsöverskridande överföringsrisker och upprätthåll styrningshandböcker under [[TOK_0]].',
        help_center: 'För alla personas -- DPO:er, revisorer, IT-chefer och compliance managers -- hitta svar, instruktionsguider och modulspecifik dokumentation för att stödja dina dagliga efterlevnadsarbetsflöden.',
        incident_ops: 'Som Incident Commander (P-VN-09), aktivera svarsspelböcker, spåra [[TOK_1]] efterlevnad mot 72-timmars [[TOK_0]] aviseringsfönstret, hantera eskalationer och samordna leverantörens svar.',
        incidents: 'Som incidentbefälhavare (P-VN-09), upptäck och rapportera dataintrång med 72-timmars [TOK_0]] anmälningsskyldighet till PDP-kommittén, triage efter svårighetsgrad och bygg tillbudsunderlag i revisionsgrad.',
        localization: 'Som Enterprise [[TOK_1]] (P-VN-01), hantera regelverkets livscykel: installera vietnamesiska marknadspaket, aktivera ramverken [[TOK_0]] och dekret 13, kartlägga krav till plattformsmoduler och hantera översättningar.',
        monitoring: 'Som Enterprise [[TOK_1]] (P-VN-01), upprätta pågående program för efterlevnadsövervakning, spåra regulatoriska ändringar, mät KPI:er och hantera regulatoriska interaktionsärenden under [[TOK_0]].',
        onboarding: 'Som Compliance Trainer (P-VN-02), ge utbildning via guidade turer, ladda realistiska exempeldata för praktiska övningar och kör inställningsguiden för snabbstartsscenarier.',
        organizations: 'Som [[TOK_0]] (P-VN-01), konfigurera efterlevnadsstrukturer för flera organisationer, upprätta avdelningshierarkier och dirigera förfrågningar från datasubjekt över din företagsgrupp.',
        partner_workspace: 'Som Partner Account Manager, integrera partnerorganisationer, konfigurera servicenivåer, spåra efterlevnadsleveranser och hantera partnermarknaden.',
        platform_settings: 'Som plattformsadministratör, hantera all operativ konfiguration -- identitet, säkerhet, integrationer och modulåtkomst som ligger till grund för ditt efterlevnadsprogram.',
        privacy_scanner: 'Som integritetsanalytiker (P-VN-06), kör kontinuerliga övervakningsskanningar för att upptäcka överträdelser av cookie-samtycke, obehöriga spårare och policyluckor – generera bevis för ePrivacy och [[TOK_0]] efterlevnad.',
        program_governance: 'Navigera mellan mognadsmodeller, bedömningar, bevisluckor, sammanfattningar med mera. Varje delmodul bidrar till en helhetssyn på din interna programhälsa.',
        rights_requests: 'Som Enterprise [[TOK_1]] (P-VN-01), hantera förfrågningar om registrerade rättigheter under [[TOK_0]] med 15-dagars lagstadgade deadlines, identitetsverifiering och revisionsgradsupplösningsspår.',
        task_management: 'Rikta efterlevnadsuppgifter över personas, spåra [[TOK_0]] deadlines och automatisera arbetsflöden som håller ditt team ansvarigt.',
        vendor_risk: 'Som leverantörsriskhanterare (P-VN-08), bedöm tredjepartsrisk, framtvinga gate-recensioner och utlösa omvärderingar – till skillnad från Program Governance, som spårar din interna mognad.',
    },
    consolidation: {
        title: 'Konsolideringsarenden',
        new_case: 'Skapa konsolideringsfall',
        case_count: 'case',
        created: 'Konsolideringsärende skapat',
        create: 'Skapa ärende',
        creating: 'Skapar...',
        cancel: 'Avbryt',
        no_cases: 'Inga konsolideringsärenden hittades.',
        all_statuses: 'Alla statusar',
        all_purposes: 'Alla ändamål',
        filter_status: 'Filtrera efter status',
        filter_purpose: 'Filtrera efter syfte',
        col_title: 'Titel',
        col_purpose: 'Syfte',
        col_status: 'Status',
        col_progress: 'Framsteg',
        col_deadline: 'Deadline',
        col_department: 'Avdelning',
        col_version: 'Version',
        col_evidence: 'Bevis',
        sections_accepted: 'accepted',
        prev: 'Föregående',
        next: 'Nästa',
        page: 'Sida',
        prev_page: 'Föregående sida',
        next_page: 'Nästa sida',
        field_title: 'Titel',
        field_purpose: 'Syfte',
        field_framework: 'Ramkod',
        field_deadline: 'Deadline',
        field_reviewer: 'Granskare användar-ID',
        title_placeholder: 'Ange ärendetitel',
        framework_placeholder: 't.ex. PDPD-2023',
        reviewer_placeholder: 'Ange granskarens användar-ID',
        purposes: {
            dpia_filing: '[[TOK_0]] Arkivering',
            cross_border_filing: 'Gränsöverskridande arkivering',
            annual_governance_attestation: 'Årligt styrelseintyg',
            breach_package: 'Breach Package',
            audit_inspection_pack: 'Audit Inspection Pack',
        },
        statuses: {
            draft: 'Utkast',
            collecting: 'Samlar',
            consolidating: 'Konsoliderar',
            review: 'Granska',
            corrections: 'Rättelser',
            pending_approval: 'Väntar på godkännande',
            approved: 'Godkänd',
            completed: 'Avslutad',
            closed: 'Stängt',
            rejected: 'Avvisad',
        },
        section_statuses: {
            pending: 'Väntar',
            in_progress: 'Pågår',
            submitted: 'Inlämnad',
            accepted: 'Godkänd',
            needs_correction: 'Behöver korrigering',
            corrected: 'Rättad',
        },
        flag_types: {
            missing_section: 'Saknat avsnitt',
            conflicting_entry: 'Motstridiga inträde',
            stale_entry: 'Inaktuellt inträde',
            missing_evidence: 'Saknade bevis',
            incomplete_data: 'Ofullständiga data',
            duplicate_entry: 'Dubblett inmatning',
        },
        flag_severities: {
            critical: 'Kritisk',
            warning: 'Varning',
            info: 'Info',
        },
        sections_title: 'Avsnitt',
        no_sections: 'Inga avsnitt tilldelade ännu.',
        flags_title: 'Flaggor',
        no_flags: 'Inga flaggor upptäcktes.',
        open: 'open',
        approval_chain: 'Godkännandekedja',
        pending: 'Väntar',
        audit_trail: 'Revisionsspår',
        no_audit: 'Inga revisionshändelser.',
        auto_assign: 'Auto-tilldela sektioner',
        start_collection: 'Starta insamling',
        review_case: 'Granska ärendet',
        generate_export: 'Skapa export',
        review_title: 'Konsolidering översyn',
        advance_approval: 'Gå vidare till godkännande',
        back_to_case: 'Tillbaka till Case',
        accept: 'Acceptera',
        return_section: 'Återgå',
        return_comment: 'Returnera kommentar...',
        resolve: 'Lös',
        dismiss: 'Avvisa',
        resolution_notes: 'Upplösningsanteckningar...',
        notes: 'Anteckningar',
        section_accepted: 'Avsnitt accepterat',
        section_returned: 'Avsnittet returnerades för korrigering',
        advanced_to_approval: 'Ärendet har avancerat till att vänta på godkännande',
        section_data: 'Sektionsdata',
        save_progress: 'Spara framsteg',
        submit_section: 'Skicka avsnitt',
        submitting: 'Skickar...',
        resubmit: 'Skicka in igen',
        progress_saved: 'Framsteg sparas',
        section_submitted: 'Avsnitt inlämnat',
        correction_required: 'Korrigering krävs',
        evidence_title: 'Bevis',
        no_evidence: 'Inga bevis bifogade.',
        add_evidence: 'Lägg till bevis',
        evidence_added: 'Bevis har lagts till',
        evidence_files: 'bevisfiler',
        uploaded_by: 'uppladdad av',
        comments_title: 'Kommentarer',
        no_comments: 'Inga kommentarer än.',
        comment_placeholder: 'Lägg till en kommentar...',
        add_comment: 'Lägg till kommentar',
        comment_added: 'Kommentar tillagd',
        view_data: 'Visa inlämnad data',
        export_title: 'Dokumentexport',
        export_generated: 'Exportpaket genererat',
        regenerate: 'Återskapa',
        regenerating: 'Regenererar...',
        generated_at: 'Genereras kl',
        artifacts_title: 'Exportera artefakter',
        artifact_type: 'Artefakt',
        file_name: 'Filnamn',
        file_size: 'Storlek',
        generated: 'Genererad',
        download: 'Ladda ner',
        artifacts: {
            master_report: 'Huvudrapport',
            evidence_bundle: 'Bevispaket (ZIP)',
            contributor_lineage: 'Bidragsgivares härstamning',
            conflict_resolution: 'Konfliktlösning',
            approval_history: 'Godkännandehistorik',
        },
        official_forms: 'Officiella formulär',
        forms_description: 'Följande officiella formulär kan genereras från de konsoliderade uppgifterna. Officiella formulär är separata från interna arbetsdokument.',
        announce_loaded_cases: 'Laddade [[TOK_1]] konsolideringsärenden',
        announce_case_detail_loaded: 'Falldetaljer har laddats',
        announce_case_transitioned: 'Ärendet har övergått till [[TOK_1]]',
        announce_flag_resolved: 'Flaggan löst',
        announce_flag_dismissed: 'Flaggan har avvisats',
        case_detail_loaded: 'Falldetaljer har laddats',
        sections_auto_assigned: 'Avsnitt tilldelas automatiskt från avdelningshierarkin',
        errors: {
            load_failed: 'Det gick inte att ladda data. Försök igen.',
            create_failed: 'Det gick inte att skapa ärende. Försök igen.',
            required_fields: 'Fyll i alla obligatoriska fält.',
            not_found: 'Hittade inte.',
            comment_required: 'Kommentar krävs när du returnerar en sektion.',
            notes_required: 'Anteckningar krävs när du löser eller avvisar en flagga.',
        },
    },
    rights_requests: {
        import: {
            title: 'Importera ärenden',
            nav_title: 'Massimport',
            description: 'Ladda upp en CSV-fil för att massimportera rättighetsärenden.',
            select_file: 'Välj CSV-fil',
            file_help: 'CSV med rubriker som matchar ärendefält.',
            file_too_large: 'Filen är för stor. Maximal storlek är 2MB.',
            preview: 'Förhandsgranska',
            columns_detected: 'Kolumner hittade: {count}',
            column_mapping: 'Kolumnmappning',
            import_button: 'Importera',
            import_complete: 'Import slutförd',
            import_error: 'Import misslyckades',
            result: 'Importresultat',
            total: 'Totalt',
            imported: 'Importerade',
            skipped: 'Överhoppade',
            failed: 'Misslyckade',
            errors: 'Fel',
            error_row: 'Rad',
            error_field: 'Fält',
            error_message: 'Meddelande',
            history: 'Importhistorik',
            no_history: 'Ingen importhistorik.',
            history_file: 'Filnamn',
            history_date: 'Datum',
        },
        batch: {
            nav_title: 'Batchprocess',
            page_title: 'DSR Batch Process',
            page_subtitle: 'Ladda upp en [[TOK_1]] av väntande DSR. Forseti upprättar ett bekräftelsesvar per begäran och köar en verifieringsuppgift per rad. [[TOK_0]] recensionerna + accepterar var och en före sändning.',
            upload_heading: 'Ladda upp',
            csv_hint: 'Obligatoriska kolumner: request_id, requester_email, request_type. Valfritt: deadline (ISO-8601), anteckningar.',
            rows_heading: '[[TOK_1]] rader analyserade',
            submit_label: 'Kör batch',
            submitting: 'Utarbetar...',
            col_request_id: 'Begär-id',
            col_email: 'E-post för begäran',
            col_type: 'Typ',
            col_status: 'Status',
            col_actions: 'Åtgärder',
            status_queued: 'I kö',
            status_drafted: 'Utarbetad',
            status_failed: 'Misslyckades',
            status_accepted: 'Godkänd',
            status_rejected: 'Avvisad',
            'status_parsing-error': 'Analysfel',
            accept: 'Acceptera',
            reject: 'Avvisa',
            permission_denied: 'Du har inte behörighet att köra Forseti-arbetsflöden.',
        },
    },
    assessment_triggers: {
        title: 'Bedömningsutlösare',
        subtitle: 'Konfigurera automatiskt skapande av bedömningar och [[TOK_0]] aviseringar för sekretessarbetsflöden.',
        auto_create_dpia_label: 'Skapa [[TOK_0]] automatiskt när bearbetningsaktivitet markerad som [[TOK_1]] krävs',
        auto_notify_new_purpose_label: 'Meddela automatiskt [[TOK_0]] när nya ändamål skapas med känsliga datakategorier',
        auto_notify_cross_border_label: 'Meddela automatiskt [[TOK_0]] när gränsöverskridande överföring läggs till bearbetningsaktivitet',
        default_dpo_label: 'Standard [[TOK_0]]',
        default_dpo_placeholder: 'Välj standard [[TOK_0]]...',
        notification_channels_label: 'Aviseringskanaler',
        channel_in_app: 'I appen',
        channel_email: 'Email',
        save_success: 'Inställningar för bedömningsutlösare har sparats.',
        save_error: 'Det gick inte att spara inställningar för utlösare för utvärdering.',
        fetch_error: 'Det gick inte att läsa in inställningar för utlösare för utvärdering.',
        fetch_users_error: 'Det gick inte att läsa in användare.',
        announce_loaded: 'Inställningar för bedömningsutlösare har laddats',
        dpia_status: '[[TOK_0]] Status',
        dpia_linked: '[[TOK_0]] Länkad',
        dpia_required_no_dpia: '[[TOK_0]] Obligatoriskt – inte skapat',
        create_dpia: 'Skapa [[TOK_0]]',
        create_dpia_success: '[[TOK_0]] skapat och länkat till aktivitet.',
        create_dpia_error: 'Det gick inte att skapa [[TOK_0]] för aktivitet.',
        view_dpia: 'Visa [[TOK_0]]',
    },
    data_subjects: {
        title: 'Registrerade personers profiler',
        nav_title: 'Registrerade personer',
        nav: {
            profiles: 'Profiler',
        },
        create: 'Skapa profil',
        edit: 'Redigera profil',
        delete: 'Radera profil',
        delete_confirm: 'Är du säker på att du vill ta bort den här registrerade profilen?',
        display_name: 'Visningsnamn',
        email: 'Email',
        phone: 'Telefon',
        employee_id: 'Medarbetar-ID',
        student_id: 'Student-ID',
        notes: 'Anteckningar',
        external_refs: 'Externa referenser',
        cases_count: 'Fall',
        workflows_count: 'samtyckesregister',
        last_activity: 'Senaste aktivitet',
        timeline: 'Tidslinje',
        link_case: 'Link Case',
        link_workflow: 'Länka arbetsflöde',
        no_profiles: 'Inga registrerade profiler hittades.',
        search_placeholder: 'Sök efter namn, e-post, telefon eller ID...',
        create_success: 'Den registrerade profilen har skapats.',
        create_error: 'Det gick inte att skapa den registrerade profilen.',
        update_success: 'Den registrerade profilen uppdaterad.',
        update_error: 'Det gick inte att uppdatera den registrerades profil.',
        delete_success: 'Den registrerade profilen raderad.',
        delete_error: 'Det gick inte att ta bort den registrerades profil.',
        link_case_success: 'Ärende kopplat till profil.',
        link_case_error: 'Det gick inte att länka ärendet till profilen.',
        link_workflow_success: 'Arbetsflöde kopplat till profil.',
        link_workflow_error: 'Det gick inte att länka arbetsflödet till profilen.',
        load_error: 'Det gick inte att läsa in registrerade profiler.',
        detail_load_error: 'Det gick inte att läsa in den registrerade profilen.',
        timeline_load_error: 'Det gick inte att ladda tidslinjen.',
        tab_cases: 'DSR-fall',
        tab_consent: 'samtyckesregister',
        tab_timeline: 'Tidslinje',
        tab_consent_workflows: 'Arbetsflöden för samtycke',
        tab_web_consent: '[[TOK_0]] Samtycke',
        web_consent_empty: 'Inga [[TOK_0]] samtyckesposter hittades för detta ämne.',
        web_consent_load_error: 'Det gick inte att ladda [[TOK_0]] samtyckesposter.',
        col_policy_version: 'Policyversion',
        col_versions: 'Versioner',
        col_consent_version: 'Samtycke',
        col_cookie_declaration_version: 'Cookiedeklaration',
        col_purposes: 'Ändamål',
        purpose_granted: 'Beviljas',
        purpose_denied: 'Nekad',
        granted_domains: 'Beviljas',
        denied_domains: 'Nekad',
        col_action: 'Åtgärd',
        col_timestamp: 'Tidsstämpel',
        col_domain: 'Domän',
        no_cases: 'Inga länkade fall.',
        no_workflows: 'Inga länkade samtyckesarbetsflöden.',
        no_timeline: 'Inga tidslinjehändelser.',
        case_id: 'Ärende ID',
        case_status: 'Status',
        case_type: 'Typ av begäran',
        case_created: 'Skapad',
        workflow_id: 'Arbetsflödes-ID',
        workflow_type: 'Typ',
        workflow_status: 'Status',
        workflow_created: 'Skapad',
        timeline_date: 'Datum',
        timeline_event: 'Händelse',
        timeline_details: 'Detaljer',
        timeline_time: 'Tid',
        timeline_type: 'Typ',
        timeline_summary: 'Sammanfattning',
        type_case: 'DSR-väska',
        type_consent_workflow: 'Arbetsflöde för samtycke',
        profile_info: 'Profilinformation',
        announce_loaded: 'Registrerade profiler laddade',
        announce_detail_loaded: 'Den registrerade profilen har laddats',
        select_case: '— Välj ett ärende —',
        select_workflow: '— Välj ett arbetsflöde —',
        no_cases_hint: 'Länka ärenden för att se dem här.',
        no_workflows_hint: 'Länka medgivandearbetsflöden för att se dem här.',
    },
    flows: {
        map: {
            description_prefix: '[[TOK_4]] system · [[TOK_5]] flöden · [[TOK_6]] gränsöverskridande · [[TOK_7]] hög/kritisk risk',
            switch_to_list: 'Växla till listvy',
            switch_to_list_aria: 'Växla till tabellvy',
            svg_aria: 'Dataflödeskarta: [[TOK_3]] system, [[TOK_4]] flöden, [[TOK_5]] gränsöverskridande',
            selected_system: 'Valt system',
            drill_hint: 'Öppna listfliken för att redigera länkade flöden, DPIA:er och leverantörstilldelningar för detta system.',
        },
    },
    packages: {
        light: {
            name: 'Ljus',
            description: 'Viktiga integritetscompliance-verktyg för små team',
        },
        standard: {
            name: 'Standard',
            description: 'Komplett compliance-plattform för växande organisationer',
        },
        enterprise_unlimited: {
            name: 'Enterprise Unlimited',
            description: 'Compliance på företagsnivå med stöd för flera organisationer och dedikerade tjänster',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Providerinställningar',
            subtitle: 'Konfigurera Claude-leverantören för Forseti [[TOK_0]] juridiska rådgivare.',
            healthHeading: 'Leverantörshälsa',
            statusLabel: 'Status',
            statusOk: 'OK',
            statusFailed: 'Ej tillgänglig',
            providerLabel: 'Leverantör',
            providerClaudeApi: 'Claude [[TOK_0]]',
            providerCliRelay: 'Claude CLI relä',
            providerAesirManaged: 'Aesir-hanterade tokens',
            lastCheckedLabel: 'Senast kontrollerad',
            reasonLabel: 'Anledning',
            refreshButton: 'Uppdatera',
            apiKeyHeading: 'Claude [[TOK_0]]-tangenten',
            apiKeyHint: 'Genom att ställa in en [[TOK_0]]-knapp aktiveras Claude [[TOK_1]]-läget. Lämna det oinställt för att använda det lokala CLI-reläet (utvecklare/egenvärdläge).',
            apiKeyLabel: '[[TOK_0]]-tangenten',
            apiKeyMinLength: 'Minst 32 tecken. Krypterad i vila; visas aldrig igen.',
            apiKeyTooShort: '[[TOK_0]]-tangenten måste bestå av minst 32 tecken.',
            apiKeySaved: '[[TOK_0]]-nyckeln sparad. Uppfriskande hälsa...',
            apiKeyCleared: '[[TOK_0]]-tangenten nollställd. Forseti använder nu det lokala CLI-reläet.',
            setKeyButton: 'Spara [[TOK_0]]-tangenten',
            clearKeyButton: 'Rensa [[TOK_0]]-tangenten (använd CLI-relä)',
        },
        usage: {
            title: 'Användning',
            subtitle: 'Tokenförbrukning och status för den här organisationen.',
            bucketHeading: 'Månatlig token hink',
            remainingLabel: 'Kvar',
            consumedLabel: 'Förbrukad',
            totalLabel: 'Totalt',
            unitsLabel: 'fakturerbara enheter',
            lastReconciledLabel: 'Senast avstämt',
            recentHeading: 'Senaste aktiviteten',
            historyHeading: 'Senaste 12 perioderna',
            noActivity: 'Ingen aktivitet ännu denna period.',
            featureLabel: 'Funktion',
            whenLabel: 'När',
            periodLabel: 'Period',
            topUpButton: 'Begär ett påfyllningspaket',
            topUpHint: 'Kontakta din kontoansvariga för att begära ett påfyllningspaket.',
            buyMore: {
                buyButton: 'Köp fler enheter',
                purchaseTitle: 'Köp fler faktureringsenheter',
                purchaseSubtitle: 'Välj ett paket. Du skickas till en säker Stripe-kassa och din faktura skickas via e-post.',
                packageLabel: 'Paket',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Litet',
                packageMedium: 'Medel',
                packageLarge: 'Stort',
                checkoutButton: 'Fortsätt till kassan',
                checkoutPending: 'Öppnar kassan…',
                cancelButton: 'Avbryt',
                purchaseError: 'Det gick inte att starta kassan. Försök igen om en liten stund.',
                redeemTitle: 'Lös in en faktura',
                redeemSubtitle: 'Har du redan betalat? Välj det paket du köpte och ange fakturanumret från din e-post för att lägga till enheterna.',
                invoiceLabel: 'Fakturanummer',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Lös in',
                redeemPending: 'Löser in…',
                redeemSuccess: 'Enheter tillagda i din pott.',
                redeemAlready: 'Denna faktura har redan lösts in.',
                errorNotFound: 'Ingen faktura hittades med det numret. Kontrollera fakturanumret och försök igen.',
                errorNotPaid: 'Denna faktura är inte markerad som betald ännu.',
                errorOrgMismatch: 'Denna faktura utfärdades inte till din organisation.',
                errorPackageMismatch: 'Denna faktura matchar inte det valda paketet.',
                errorInvalidInvoice: 'Ange ett giltigt fakturanummer.',
                errorGeneric: 'Inlösen misslyckades. Försök igen om en liten stund.',
            },
            byFeatureHeading: 'Denna månad per funktion',
            byFeatureEmpty: 'Ingen funktionsaktivitet ännu denna period.',
            featureColumn: 'Funktion',
            featureUnitsColumn: 'Enheter',
            featureRunsColumn: 'Springer',
            byUserHeading: 'Denna månad av användare (adminvy)',
            byUserEmpty: 'Ingen aktivitet per användare ännu denna period.',
            userColumn: 'Användare',
            reconciliationLinkLabel: 'Visa avstämningsavvikelserapport',
            reconciliationLinkHint: 'Endast Aesir-intern administratör.',
            featureLabels: {
                chat: 'Chatta',
                workflow: 'Arbetsflödeskörning',
                tabular: 'Tabellextraktion',
                redline: 'Redline recension',
                title: 'Konversationstitel',
                unknown: 'Annat',
            },
        },
        reconciliation: {
            title: 'Forseti-kvotavstämning',
            subtitle: 'Sväva mellan den snabba kvoträknarens cache och den auktoritativa faktureringsreskontran. Avstämningsenheten körs var 5:e minut; den här sidan visar den senaste körningen och historien. Endast Aesir-intern administratör.',
            backLink: 'Tillbaka till Forseti Usage',
            stubHeading: 'Avstämningshistorik kommer snart',
            stubBody: 'Avstämningsarbetarloggarna driver via den strukturerade loggkanalen. En backend-lässlutpunkt som exponerar de senaste 30 avstämningskörningarna är under omfattning (uppskjuten från Sprint 47.5.9.6 – se arbetsfil). När slutpunkten landar kommer den här sidan att visa körhistoriktabellen + P0-driftbannern.',
            stubBackendOwner: 'Backend-uppskjutning: kvarstående avstämningskörningar i en ny samling + lägg till rutt `GET /llm-relay/quota/reconciliation`.',
            permissionDenied: 'Denna sida är begränsad till Aesir-interna administratörer. Om du anser att du borde ha tillgång, kontakta din [[TOK_0]]-representant.',
        },
        projects: {
            title: 'Projekt',
            subtitle: 'Arbetsytor för dokument, konversationer, arbetsflöden och recensioner.',
            modeLabel: 'Visa',
            tabMine: 'Mina projekt',
            tabShared: 'Delade med mig',
            searchLabel: 'Sök efter projekt',
            searchPlaceholder: 'Sök...',
            newButton: 'Nytt projekt',
            colName: 'Namn',
            colVisibility: 'Synlighet',
            colDocs: 'Dokument',
            colMembers: 'Medlemmar',
            colUpdated: 'Uppdaterad',
            visibilityOwn: 'Endast egna',
            visibilityShared: 'Delad',
            emptyMine: 'Inga projekt ännu. Skapa en för att komma igång.',
            emptyShared: 'Inga projekt har delats med dig.',
            pageHint: 'Visar [[TOK_2]] av [[TOK_3]].',
            createTitle: 'Nytt projekt',
            createSubmit: 'Skapa projekt',
            fieldName: 'Namn',
            fieldDescription: 'Beskrivning (valfritt)',
            fieldCmNumber: 'Ärendenummer (valfritt)',
            fieldVisibility: 'Synlighet',
            errorNameRequired: 'Namn krävs.',
            errorSelectorRequired: 'Välj en användare eller organisationsgrupp att lägga till.',
            renameButton: 'Byt namn',
            renamePrompt: 'Byt namn på projektet',
            deleteButton: 'Ta bort',
            deleteConfirm: 'Vill du ta bort det här projektet? Det kommer att bevaras i 30 dagar innan permanent borttagning.',
            deleteFolderConfirm: 'Ta bort den här mappen? Dokument inuti kommer att finnas kvar i projektet, bara oarkiverade.',
            removeMemberConfirm: 'Vill du ta bort den här medlemmen?',
            foldersHeading: 'Mappar',
            foldersEmpty: 'Inga mappar ännu.',
            addFolderButton: 'Ny mapp',
            addFolderTitle: 'Ny mapp',
            documentsHeading: 'Dokument',
            documentsEmpty: 'Inga dokument bifogade ännu.',
            colFilename: 'Filnamn',
            colAdded: 'Tillagd',
            unattachButton: 'Lossa',
            membersHeading: 'Medlemmar',
            membersEmpty: 'Endast ägare.',
            addMemberButton: 'Lägg till medlem',
            addMemberTitle: 'Lägg till medlem',
            addMemberSubmit: 'Lägg till medlem',
            colMember: 'Medlem',
            colRole: 'Roll',
            selectorTypeLabel: 'Lägg till av',
            selectorUser: 'Användar-ID',
            selectorGroup: 'Organisationsgrupp-ID',
            fieldUserId: 'Användare',
            fieldGroupId: 'Organisationsgrupp',
            fieldRole: 'Roll',
            roleAdmin: 'Admin',
            roleEditor: 'Redaktör',
            roleViewer: 'Tittare',
            notFound: 'Projektet hittades inte.',
            selectUserPlaceholder: 'Välj en användare...',
            selectGroupPlaceholder: 'Välj en organisationsgrupp...',
            noUsersAvailable: 'Inga användare tillgängliga.',
            noGroupsAvailable: 'Inga tillgängliga organisationsgrupper.',
            loadFailed: 'Det gick inte att läsa in alternativ.',
            deleteProjectTitle: 'Ta bort projekt?',
            deleteFolderTitle: 'Ta bort mapp?',
            removeMemberTitle: 'Ta bort medlem?',
            removeMemberConfirmGeneric: 'Vill du ta bort den här medlemmen från projektet?',
            addDocumentButton: 'Lägg till dokument',
            addDocumentTitle: 'Lägg till dokument i projektet',
            fieldDocument: 'Välj dokument',
            selectDocPlaceholder: 'Sök efter ett dokument...',
            ownerLabel: 'Systemägare',
        },
        chat: {
            sidebarLabel: 'Chattar',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Din [[TOK_0]] juridiska och efterlevnadsrådgivare – grundad i dina hyresgästdata och dina installerade regulatoriska paket.',
            personaSelectorLabel: 'Persona',
            personaHeading: 'Välj en persona',
            startChatButton: 'Starta en ny chatt',
            startingChat: 'Startar chatt...',
            recentHeading: 'Senaste chattar',
            recentEmpty: 'Inga chattar än – starta en ovan.',
            untitledChat: 'Ny chatt',
            messageListLabel: 'Konversation',
            detailSubtitle: 'Persona: [[TOK_1]]',
            composeHeading: 'Skicka ett meddelande',
            composeLabel: 'Meddelande Forseti',
            composeDisabledPlaceholder: 'Meddelandesammansättningen landar i nästa sprint (47.5.4b — SSE-streaming + verktygs-anropsslinga).',
            composeDisabledHint: 'Skrivskyddad förhandsvisning levereras i 47.5.4a. Streaming + verktygsanrop landar i 47.5.4b.',
            switchPersonaHeading: 'Persona',
            presetPersona: 'Förinställd persona',
            changePersona: 'Byt persona',
            hidePersonaOptions: 'Dölj personaval',
            starterHeading: 'Börja med någon av dessa åtgärder',
            renameButton: 'Byt namn',
            renamePrompt: 'Byt namn på chatten',
            deleteButton: 'Ta bort',
            deleteConfirm: 'Ta bort den här chatten? Det kommer att bevaras i 30 dagar innan permanent borttagning.',
            notFound: 'Chatten hittades inte.',
            emptyChat: 'Inga meddelanden än – säg hej för att starta en konversation.',
            roleUser: 'Du',
            roleAssistant: 'Forseti',
            roleSystem: 'System',
            thinkingLabel: 'Tänker',
            toolCallPlaceholder: 'Verktygsanrop: ',
            toolResultPlaceholder: 'Verktygsresultatet är dolt — hela användargränssnittet landar i 47.5.4b.',
            docEditPlaceholder: 'Dokumentredigeringar föreslagna (V[[TOK_1]]).',
            disclaimer: 'Forseti stödjer din bedömning – den ersätter inte licensierad ombud.',
            sendButton: 'Skicka',
            sending: 'Skickar...',
            composePlaceholder: 'Fråga Forseti...',
            composingPlaceholder: 'Forseti svarar...',
            streamingPlaceholder: 'Forseti skriver...',
            promptInjectionTitle: 'Forseti tappade några kontrolltokens.',
            promptInjectionBody: 'Avskalade mönster: [[TOK_1]]. Forseti ser bara din meddelandetext.',
            promptInjectionInline: 'Forseti tappade kontrolltokens ([[TOK_1]]) från ditt meddelande.',
            rateLimitTitle: 'Du skickar meddelanden för snabbt.',
            rateLimitRetryAfter: 'Försök igen om [[TOK_1]]s.',
            counselReviewTitle: 'Forseti är osäker här.',
            counselReviewBody: 'Bekräfta med en auktoriserad advokat innan du agerar på det här svaret.',
            legalConclusionRefused: 'Forseti vägrade att utfärda en juridisk slutsats utan grund. Försök med search_regulatory först eller gå vidare till rådgivning.',
            toolCallDone: 'Klart.',
            toolCallArgsLabel: 'Argument',
            toolCallResultLabel: 'Resultat',
            toolResultLogged: 'Verktygsresultat fångat i granskningsloggen.',
            toolResultAria: 'verktygsresultat',
            documentEditAria: 'dokumentredigering',
            createTaskFromMessage: 'Skapa uppgift från detta',
            createTaskHeading: 'Skapa uppgift från detta meddelande',
            createTaskTitleLabel: 'Titel',
            createTaskTitleRequired: 'Titel krävs.',
            createTaskDescriptionLabel: 'Beskrivning',
            createTaskAssigneeLabel: 'Uppdragstagare',
            createTaskAssigneePlaceholder: 'Välj tilldelad...',
            createTaskAssigneeNone: '— otilldelad —',
            createTaskDueDateLabel: 'Förfallodatum',
            createTaskWorkflowLabel: 'Länkat arbetsflöde (valfritt)',
            createTaskWorkflowPlaceholder: 'Välj ett arbetsflöde...',
            createTaskWorkflowNone: '— ingen —',
            renameModalSubmit: 'Byt namn',
            renameModalSaving: 'Sparar...',
            deleteConfirmTitle: 'Ta bort chatten?',
            createTaskSubmit: 'Skapa uppgift',
            createTaskSubmitting: 'Skapar...',
            cancelButton: 'Avbryt',
            autoRouteHintMessage: 'Den här frågan finns mer i [[TOK_1]]s styrhytt.',
            autoRouteSwitchButton: 'Byt till [[TOK_1]]',
            autoRouteSwitching: 'Byter...',
            handoffSuggestionMessage: 'Eller öppna en ny chatt med [[TOK_1]] och för denna fråga vidare.',
            handoffSuggestionButton: 'Starta ny chatt med [[TOK_1]]',
            handoffSuggestionWorking: 'Öppnar...',
            handoffSuggestionDismiss: 'Inte nu',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Compliance-specialist',
                'forseti-legal': 'Juridisk rådgivare',
                'forseti-dpo': 'Dataskyddsombud-rådgivare',
                'forseti-risk': 'Riskanalytiker',
                'forseti-auditor': 'Revisorns blick',
            },
            exportButton: 'Exportera PDF',
            exportRunning: 'Exporterar…',
            exportSuccess: 'Exporterad: {filename} (öppna filhanteraren).',
            citation: {
                verifyBadge: '[VERIFIERA]',
                verifyAria: 'citat kunde inte verifieras – granska innan du förlitar dig',
                popoverAria: 'Källa för [[TOK_1]]',
                openSource: 'Sida med öppen källkod',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: '[[TOK_0]]-genererad händelse från Forseti revisionsspår.',
        },
        rowAction: {
            ask: 'Fråga Forseti',
            tooltipOpen: 'Fråga Forseti om detta [[TOK_1]]',
            tooltipLocked: 'Denna [[TOK_1]] är låst — Forseti kan svara på frågor men kan inte göra ändringar.',
        },
        advisorRunPanel: {
            title: 'Forseti — om denna post',
            heading: 'Forseti — [[TOK_1]]',
            summaryLabel: 'Sammanfattning',
            suggestedPersona: 'Föreslagen persona',
            askForseti: 'Fråga Forseti',
            runWorkflow: 'Kör ett arbetsflöde',
            viewLineage: 'Visa revisionslinje',
            createPdplEvidencePack: 'Skapa PDPL-bevispaket',
            prepareBreachDraft: 'Förbered utkast till underrättelse',
            primaryActions: {
                projectSummary: 'Sammanfatta projektdokument',
                supplementSummary: 'Sammanfatta kompletteringsbegäran',
                authoritySummary: 'Sammanfatta myndighetsbegäran',
                rightsRequestResponse: 'Utkast till DSR-svar',
                dpiaQuickReview: 'Kör snabb DPIA-granskning',
                taskControlWalkthrough: 'Gå igenom kontrollevidens',
                vendorRiskNarrative: 'Generera leverantörsriskberättelse',
                incidentLetter: 'Utkast till PDPL-incidentbrev',
                ropaSufficiency: 'Kör RoPA-tillräcklighetskontroll',
                vendorDpaReview: 'Kör leverantörs-DPA-granskning',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'Forseti förbereder endast utkast för det länkade Mẫu số 08. Det avgör inte om anmälan krävs och lämnar inte in eller skickar formuläret.',
            breachDraftReady: 'Utkast till Mẫu số 08 klart för granskning',
            breachDraftReviewBeforeSelecting: 'Granska före val',
            workflowHeading: 'Relevanta arbetsflöden',
            workflowLoading: 'Läser in relevanta arbetsflöden…',
            workflowEmpty: 'Inget lämpligt arbetsflöde hittades. Skapa ett guidat arbetsflöde för den här posten.',
            workflowError: 'Det gick inte att läsa in relevanta arbetsflöden.',
            selectWorkflow: 'Välj {title}',
            workflowSelected: 'Arbetsflödet är valt och klart att köras för den här posten.',
            workflowRunSelected: 'Kör valt arbetsflöde',
            workflowStarting: 'Startar arbetsflöde…',
            workflowRunError: 'Det gick inte att starta arbetsflödet.',
            workflowQuotaExhausted: 'Din Forseti-kvot är för låg för att starta arbetsflödet.',
            workflowTopUp: 'Granska användningen och begär en påfyllning',
            workflowCreateGuided: 'Skapa ett guidat arbetsflöde för den här posten',
            lineageHeading: 'Granskningsspår för den här posten',
            lineageLoading: 'Läser in granskningsspår…',
            lineageEmpty: 'Inga Forseti-spårhändelser har registrerats för den här posten.',
            lineageError: 'Det gick inte att läsa in granskningsspår.',
            retry: 'Försök igen',
            chatContextLoading: 'Läser in postens sammanhang…',
            chatGuidance: {
                general: 'Forseti kan sammanfatta posten, identifiera information som saknas och föreslå granskningssteg.',
                privacy: 'Forseti kan granska integritetsuppgifter, kontrollera skyldigheter i installerade regelverk och hjälpa till att ta fram ett utkast för mänsklig granskning.',
                compliance: 'Forseti kan identifiera efterlevnadsluckor, förankra krav i installerade källor och föreslå ansvariga nästa steg.',
                legal: 'Forseti kan sammanfatta posten, hitta underbyggt källmaterial och hjälpa till att ta fram ett utkast för juridisk granskning.',
                risk: 'Forseti kan bedöma registrerade risker, markera fakta som saknas och föreslå proportionerliga granskningssteg.',
                audit: 'Forseti kan undersöka luckor i bevisningen, koppla posten till installerade kontroller och föreslå revisionsklara uppföljningar.',
            },
            starterPrompts: {
                identifyGaps: 'Vilken information eller bevisning saknas i den här posten?',
                reviewFrameworks: 'Vilka skyldigheter i våra installerade regelverk bör jag granska för den här posten?',
                prepareDraft: 'Hjälp mig att ta fram ett utkast som endast bygger på den här posten och underbyggda installerade källor.',
                nextSteps: 'Vilka granskningssteg bör jag ta härnäst?',
                summarizeRecord: 'Sammanfatta posten och markera punkter som kräver mänsklig granskning.',
                assessRisk: 'Bedöm de registrerade riskerna, identifiera fakta som saknas och föreslå granskningssteg.',
            },
            disclaimer: 'Forseti stödjer din bedömning – den ersätter inte licensierad ombud.',
            recordType: {
                project: 'Projekt',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Dossierarkivering',
                transfer_assessment: 'Överföring över gränserna',
                vendor: 'Försäljare',
                vendor_contract: 'Leverantörskontrakt',
                vendor_acceptance: 'Leverantörsriskacceptans',
                incident: 'Incident',
                incident_op: 'Incident Operation',
                breach_notification: 'Avisering om intrång',
                authority_request: 'Myndighetsbegäran',
                supplement_request: 'Tilläggsbegäran',
                rights_request: 'Rättighetsbegäran',
                contract: 'Kontrakt',
                task: 'Uppgift',
                data_mapping_activity: 'RoPA-aktivitet',
                compliance_rule: 'Efterlevnadsregel',
                program: 'Program',
                governance_document: 'Styrningsdokument',
                remediation_plan: 'Saneringsplan',
                cross_border_filing: 'Gränsöverskridande arkivering',
            },
        },
        autocomplete: {
            button_label: 'Be Forseti utarbeta detta',
            drafting: 'Utarbetar...',
            hint_pick_activity: 'Välj en länkad bearbetningsaktivitet för att aktivera Forseti-utkast.',
            draft_origin_label: 'Forseti utkast — granskning per fält',
            tokens_label: '≈ [[TOK_1]] tokens från din månatliga hink',
            accept_selected: 'Acceptera valt',
            reject_all: 'Avvisa utkastet',
            field_checkbox_label: 'Ansök Forseti-utkast för [[TOK_1]]',
            field_labels: {
                description: 'Beskrivning',
                purpose: 'Syfte',
                data_subjects: 'registrerade',
                data_types: 'Datatyper',
                necessity_justification: 'Nödvändighet & proportionalitet',
                consultation_notes: 'Samrådsanteckningar',
                dpo_opinion: '[[TOK_0]] åsikt',
                system_ids: 'Länkade system',
                vendor_ids: 'Länkade leverantörer',
            },
            error_generic: 'Forseti kunde inte skriva ut detta [[TOK_0]]. Försök igen eller förfina aktivitetsposten.',
            variant_legend: 'Ram ram',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'ISO 27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Obs: [[TOK_1]] gränsöverskridande konflikt(er) gäller för denna variant. Granska innan du accepterar.',
        },
        tia: {
            button_label: 'Be Forseti att utarbeta denna TIA',
            drafting: 'Utarbetar TIA...',
            hint_pick_destination: 'Ange destinationslandet på överföringsposten innan Forseti kan dra.',
            draft_origin_label: 'Forseti TIA-utkast — granskning per fält',
            tokens_label: '≈ [[TOK_1]] tokens från din månatliga hink',
            accept_selected: 'Acceptera valt',
            reject_all: 'Avvisa utkastet',
            field_checkbox_label: 'Ansök Forseti-utkast för [[TOK_1]]',
            error_generic: 'Forseti kunde inte utarbeta denna TIA. Försök igen eller förfina överföringsposten.',
            usage_details: 'Detaljer om AI-användning',
            applied_status: 'Utkast godkänt. Granska de ifyllda fälten och välj sedan Uppdatera.',
            recommended_updates_title: 'Rekommenderade postuppdateringar',
            mechanism_recommendation: 'Överföringsmekanism: {value}',
            dpo_signoff_recommendation: 'Kräv DPO-godkännande för denna känsliga överföring.',
            review_date_warning: 'Ange en granskningsfrist innan du uppdaterar denna känsliga överföring.',
            processing_activity_warning: 'Länka minst en behandlingsaktivitet / ROPA-post innan du slutför TIA:n.',
            go_to_field: 'Gå till fält',
            adequacy_label: 'Destinationsregimen',
            adequacy_status_adequacy_decision: 'Beslut om tillräcklighet',
            adequacy_status_non_adequacy_with_sccs: 'Otillräcklighet – SCC krävs',
            adequacy_status_derogation: 'Art.49 undantag',
            adequacy_status_transitional: 'Övergångs-/EES-genväg',
            adequacy_status_unknown: 'Okänd — ange destination',
            conflict_banner: 'Observera: [[TOK_1]] gränsöverskridande konflikt(er) gäller för denna överföringsregim. Granska innan du accepterar.',
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Saknade obligatoriska uppgifter',
            missing_facts_hint: 'Forseti flaggade uppgifter som inte finns i posten. Fält som beror på dem är inte förvalda — ange uppgifterna eller acceptera fältet medvetet.',
            risk_label: 'Kalibrerad risk',
            risk_low: 'Låg',
            risk_medium: 'Medel',
            risk_high: 'Hög',
            jurisdiction_label: 'Jurisdiktionsutlösare',
            jurisdiction_gdpr: 'GDPR',
            jurisdiction_vn_pdpl: 'PDPL (Vietnam)',
            trigger_applicable: 'Gäller',
            trigger_not_applicable: 'Inte utlöst',
            trigger_unknown: 'Okänt — uppgift saknas',
            recipient_role_label: 'Mottagarens roll',
            recipient_role_controller: 'Personuppgiftsansvarig',
            recipient_role_processor: 'Personuppgiftsbiträde',
            recipient_role_joint_controller: 'Gemensamt ansvarig',
            recipient_role_unknown: 'Okänt — ej angivet',
            opt_in_hint: 'Juridisk slutsats — välj endast om du accepterar den med tillgängliga fakta.',
        },
        mcp: {
            pageTitle: 'MCP-kontaktnycklar',
            pageSubtitle: 'Ge [[TOK_0]] nycklar så att externa Claude-klienter kan anropa skrivskyddade Forseti-verktyg (föreskriftssökning, dokumentläsning, modulsökning). Fas 1 — skrivskyddad. Skrivverktyg landar i 48.3.0.',
            issueButton: 'Utfärda ny nyckel',
            issueModalTitle: 'Utfärda MCP-nyckeln [[TOK_0]]',
            labelField: 'Etikett',
            labelHint: 'En kort beskrivning (t.ex. "[[TOK_0]] kapacitetslabb — regulatorisk forskning").',
            permittedToolsField: 'Tillåtna verktyg',
            expiresAtField: 'Upphör att gälla (valfritt)',
            expiresAtHint: 'Lämna tomt för aldrig upphör.',
            submit: 'Utfärda nyckel',
            cancel: 'Avbryt',
            keyDisplayedOnce: 'Kopiera den här nyckeln nu - du kommer INTE att kunna se den igen. Lagra det i din hemliga manager (1Password, AWS Secrets Manager, Vault, etc.).',
            keyDisplayedOnceClose: 'Jag kopierade det - nära',
            colLabel: 'Etikett',
            colPrefix: 'Prefix',
            colStatus: 'Status',
            colTools: 'Verktyg',
            colCreatedAt: 'Skapad',
            colLastUsed: 'Senast använd',
            colCalls: 'Samtal',
            colActions: 'Åtgärder',
            statusActive: 'Aktiv',
            statusRevoked: 'Återkallad',
            statusExpired: 'Utgått',
            revokeAction: 'Återkalla',
            rotateAction: 'Rotera',
            confirmRevokeTitle: 'Återkalla denna MCP-nyckel?',
            confirmRevokeBody: 'Externa Claude-klienter som använder denna nyckel kommer att förlora åtkomst omedelbart. Detta kan inte ångras.',
            confirmRevoke: 'Återkalla nyckel',
            rotatedTitle: 'Nyckeln roterad',
            rotatedBody: 'Den nya klartextnyckeln finns nedan. Den gamla nyckeln fortsätter att fungera i 5 minuter så alla samtal om flyget avslutas.',
            emptyState: 'Inga MCP-nycklar har utfärdats ännu.',
            errorIssue: 'Det gick inte att utfärda MCP-nyckeln.',
            errorList: 'Det gick inte att ladda MCP-nycklar.',
            errorRevoke: 'Det gick inte att återkalla nyckeln.',
            errorRotate: 'Kunde inte rotera nyckeln.',
            neverUsed: '—',
            neverExpires: 'Aldrig',
        },
        memory: {
            pageTitle: 'Forseti minne',
            pageSubtitle: 'Bläddra och kurera den organisationsspecifika kontexten Forseti har samlat på sig över konversationer och beslut. Utvalda poster låser sig mot kvarhållande nattetid och förblir tillgängliga för varje person.',
            filterCategory: 'Kategori',
            filterAllCategories: 'Alla kategorier',
            totalCount: '[[TOK_1]] inlägg',
            colAnchor: 'Ankare',
            colCategory: 'Kategori',
            colSource: 'Källa',
            colContent: 'Innehåll',
            colCreatedAt: 'Skapad',
            colActions: 'Åtgärder',
            editButton: 'Redigera',
            deleteButton: 'Ta bort',
            promoteButton: 'Främja till kurerad',
            emptyState: 'Inga minnen ännu — Forseti kommer att samla på sig sammanhang när du chattar.',
            categories: {
                framework_interpretation: 'Ramtolkning',
                process_preference: 'Processpreferens',
                escalation_threshold: 'Eskaleringströskel',
                decision_context: 'Beslutssammanhang',
                glossary_term: 'Ordlista term',
                auto_inferred: 'Automatiskt härledd',
            },
            sources: {
                admin_curated: 'Kurerad',
                user_explicit: 'Explicit',
                auto: 'Antagna',
            },
            deleteConfirmTitle: 'Vill du radera detta minne?',
            deleteConfirmBody: 'Om du raderar tas detta ankare bort från varje framtida Forseti-chattstart. Ankare: [[TOK_1]]',
            deleteConfirmLabel: 'Ta bort',
            deleteCancelLabel: 'Avbryt',
            editModalTitle: 'Redigera minne',
            editAnchorLabel: 'Ankare',
            editCategoryLabel: 'Kategori',
            editContentLabel: 'Innehåll',
            editContentCount: '[[TOK_2]]/[[TOK_3]] tecken',
            editEmptyError: 'Innehållet får inte vara tomt.',
            editTooLongError: 'Innehållet måste vara ≤1 000 tecken.',
            editAutoPromoteHint: 'Om du sparar detta automatiskt härledda minne kommer det att markeras som användarbekräftat och ta bort det från retentionssvepet.',
            editCancelButton: 'Avbryt',
            editSaveButton: 'Spara',
            editSaving: 'Sparar...',
        },
        auditLineage: {
            title: 'Granska härstamning',
            subtitle: 'Spåra varje [[TOK_0]]-genererad artefakt som är kopplad till en post. Chattar, verktygsanrop, uppgifter, bevisutkast och dokumentversioner.',
            filterForm: 'Filter',
            recordType: 'Rekordtyp',
            recordId: 'Record ID',
            dateStart: 'Från',
            dateEnd: 'Till',
            search: 'Sök',
            loading: 'Laddar...',
            exportPdf: 'Exportera [[TOK_0]]',
            exportCsv: 'Exportera [[TOK_0]]',
            nodesHeading: 'Linjenoder',
            colType: 'Typ',
            colLabel: 'Etikett',
            colOccurredAt: 'Inträffade kl',
            colActor: 'Skådespelare',
            colId: 'ID',
            noResults: 'Ingen rådgivareaktivitet för denna post.',
            draftBadge: '[[TOK_0]]-genererat utkast',
            prev: 'Föregående',
            next: 'Nästa',
            viewToggleTable: 'Visa som tabell',
            viewToggleGraph: 'Visa som graf',
            graphAriaLabel: 'Linjediagram (visuellt). Använd tabellvyn för hjälpmedel.',
            graphLegendDraft: 'Utkast till [[TOK_0]] bevis',
            graphEmpty: 'Inga noder att plotta.',
            paginationAriaLabel: 'Paginering',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_3]]',
            exportErrorTemplate: 'Exporten misslyckades: [[TOK_1]]',
            recordTypes: {
                project: 'Projekt',
                dpia: '[[TOK_0]]',
                vendor: 'Försäljare',
                incident: 'Incident',
                incident_op: 'Incident operation',
                rights_request: 'Rättighetsbegäran',
                contract: 'Kontrakt',
                task: 'Uppgift',
                data_mapping_activity: 'Datakartläggningsaktivitet',
                compliance_rule: 'Regel efterlevnad',
                program: 'Program',
            },
            nodeTypes: {
                chat: 'Chatta',
                tool_call: 'Verktygsanrop',
                workflow_run: 'Arbetsflödeskörning',
                task: 'Uppgift',
                evidence: 'Bevis',
                document_version: 'Dokumentversion',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: 'OK',
                drifted: 'Drifted',
                hash_mismatch: 'Hash-felmatchning',
                merkle_mismatch: 'Merkle missmatchar',
                source_missing: 'Källa saknas',
                not_found: 'Hittade inte',
                chain_unreachable: 'Kedjan går inte att nå',
                service_unreachable: 'Tjänsten går inte att nå',
                pending: 'Väntar på förankring',
            },
        },
        evidenceDraft: {
            draftBadge: '[[TOK_0]]-genererat UTKAST',
            pendingReviewBadge: 'Väntar på granskning',
            approvedBadge: 'Godkänd',
            rejectedBadge: 'Avvisad',
            moveToReviewButton: 'Markera redo för granskning',
            approveButton: 'Godkänn',
            rejectButton: 'Avvisa',
            rejectReasonLabel: 'Orsak till avslag',
            humanSignoffBanner: 'Forseti stödjer din bedömning – den ersätter inte licensierad ombud. [[TOK_0]]-genererade bevis kräver mänskligt godkännande innan det räknas som formellt bevis.',
            pageTitle: '[[TOK_0]] bevisutkast',
            pageSubtitle: 'Granska, godkänn eller avvisa [[TOK_0]]-genererade bevis. Utkast måste godkännas av en människa innan de räknas som formellt bevis.',
            filterAll: 'Alla handlingsbara',
            filterDrafts: 'Endast utkast',
            filterPending: 'Väntar på granskning',
            filterApproved: 'Nyligen godkänd',
            filterRejected: 'Nyligen avvisad',
            colId: 'Bevis ID',
            colStatus: 'Status',
            colSource: 'Källa',
            colCreatedAt: 'Skapad',
            colActions: 'Åtgärder',
            empty: 'Inga [[TOK_0]] bevisutkast i denna status.',
            confirmApprove: 'Godkänna detta [[TOK_0]]-genererade bevis som formellt?',
            confirmReject: 'Avvisa detta bevisutkast. Detta kan inte ångras.',
            reasonRequired: 'En avvisningsskäl krävs.',
            rejectModalTitle: 'Avvisa utkast till bevis',
            approveModalTitle: 'Godkänn utkast till bevis',
            operationFailed: 'Åtgärden misslyckades. Försök igen.',
            moveToReviewSuccess: 'Markerad redo för granskning.',
            approveSuccess: 'Godkänd.',
            rejectSuccess: 'Avvisad.',
            sourceLabelWorkflowRunTitle: 'Arbetsflöde: [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Arbetsflödeskörning [[TOK_1]]',
            sourceLabelChatTitle: 'Chatt: [[TOK_1]]',
            sourceLabelChatId: 'Forseti chatt [[TOK_1]]',
            sourceLabelEmpty: '—',
            filtersAriaLabel: 'Filterstatus',
        },
        workflows: {
            pageTitle: 'AI-arbetsflöden',
            pageSubtitle: 'Sparade AI-promptmallar som producerar uppgifter och utkast till bevis.',
            newWorkflow: 'Nytt arbetsflöde',
            newWorkflowHeading: 'Nytt AI-arbetsflöde',
            tabAll: 'Alla',
            tabBuiltin: 'Inbyggt paket',
            tabMine: 'Mina arbetsflöden',
            tabDetail: 'Detaljer',
            tabLinkedTasks: 'Länkade uppgifter',
            builtinBadge: 'Inbyggt',
            builtinSubtitle: 'Inbyggt arbetsflöde.',
            userSubtitle: 'Anpassat arbetsflöde.',
            emptyHint: 'Inga arbetsflöden ännu.',
            loadTimeoutError: 'Kunde inte ladda arbetsflöden efter 10 sekunder. Försök igen, eller kontrollera webbläsarens nätverksflik för en hängande begäran.',
            loadError: 'Kunde inte ladda arbetsflöden.',
            hideError: 'Misslyckades att dölja.',
            unhideError: 'Misslyckades att visa.',
            retry: 'Försök igen',
            producesTasks: 'Producerar uppgifter',
            producesEvidence: 'Producerar utkast till bevis',
            hideButton: 'Dölj från min lista',
            unhideButton: 'Visa igen',
            runButton: 'Kör',
            editButton: 'Redigera',
            shareButton: 'Dela',
            backToList: 'Tillbaka till listan',
            requireTitleAndPrompt: 'Titel och prompt krävs.',
            fieldTitle: 'Titel',
            fieldDescription: 'Beskrivning',
            fieldType: 'Typ',
            fieldPersona: 'Persona-affinitet',
            fieldPractice: 'Praxis',
            fieldPrompt: 'Uppmaning (Markdown)',
            fieldProducesTasks: 'Producerar uppgifter',
            fieldProducesEvidence: 'Producerar utkast till bevis',
            fieldProjectId: 'Projekt (valfritt)',
            fieldAttachmentIds: 'Bilagor',
            fieldParentRecord: 'Överordnad post (valfritt)',
            fieldPersonaOverride: 'Persona-åsidosättning (valfritt)',
            typeAssistant: 'Assistent',
            typeTabular: 'Tabellform',
            personaNone: '— ingen —',
            parentNone: '— ingen —',
            parentIdPlaceholder: 'ID för överordnad post',
            selectProjectPlaceholder: 'Välj ett projekt…',
            selectProjectFirst: 'Välj ett projekt för att välja bilagor.',
            selectAttachmentsPlaceholder: 'Välj dokument…',
            noAttachmentsInProject: 'Detta projekt har inga bifogade dokument.',
            selectParentRecordPlaceholder: 'Välj en post…',
            selectParentRecordFirst: 'Välj först en posttyp.',
            noRecordsForType: 'Inga poster av denna typ är tillgängliga.',
            shareUserSelectorLabel: 'Mottagare (användare)',
            shareGroupSelectorLabel: 'Mottagare (organisationsgrupper)',
            selectUsersPlaceholder: 'Välj användare…',
            selectOrgGroupsPlaceholder: 'Välj organisationsgrupper…',
            loadingOptions: 'Laddar…',
            loadFailed: 'Kunde inte ladda alternativ.',
            parentRecordTypes: {
                dpia: 'DPIA',
                vendor: 'Leverantör',
                incident: 'Incident',
                rights_request: 'Rättighetsbegäran',
                contract: 'Kontrakt',
                data_mapping_activity: 'RoPA-aktivitet',
                compliance_rule: 'Compliance-regel',
                program: 'Program',
            },
            cancelButton: 'Avbryt',
            closeButton: 'Stäng',
            createButton: 'Skapa',
            creating: 'Skapar…',
            saveButton: 'Spara',
            saving: 'Sparar…',
            shareWorkflowHeading: 'Dela arbetsflöde',
            shareIntro: 'Delar: {title}',
            shareUserIds: 'Användar-ID:n (separerade med mellanslag eller komma)',
            shareGroupIds: 'Organisationsgrupp-ID:n (separerade med mellanslag eller komma)',
            shareAllowEdit: 'Tillåt mottagare att redigera',
            shareRequireRecipient: 'Ange minst ett användar-ID eller grupp-ID.',
            shareSuccess: 'Delat.',
            sharing: 'Delar…',
            runWorkflowHeading: 'Kör: {title}',
            runStarting: 'Startar…',
            runStatusLabel: 'Status: [[TOK_1]]',
            runProducedCounts: 'Uppgifter: {tasks} · Utkast till bevis: {evidence} · Bilagor: {attachments}',
            runPanelHeading: 'Arbetsflödeskörning',
            runPanelHeadingWithTitle: 'Arbetsflödeskörning: {title}',
            runViewTasks: 'Visa genererade uppgifter',
            runLoadFailed: 'Det gick inte att läsa in arbetsflödeskörningen.',
            runStreamFailed: 'Anslutningen till arbetsflödets förlopp misslyckades.',
            runStatusValues: {
                pending: 'Väntar',
                running: 'Kör',
                completed: 'Slutförd',
                succeeded: 'Lyckades',
                failed: 'Misslyckades',
                cancelled: 'Avbruten',
            },
            runProgressStatus: 'Status: [[TOK_1]]',
            runProgressTaskCreated: 'Uppgift skapad.',
            runProgressEvidenceDrafted: 'Utkast till bevis skapat.',
            runProgressAttachmentGenerated: 'Bilaga genererad.',
            guidedWorkflowTitle: 'Guidat arbetsflöde för {recordType}',
            guidedWorkflowDescription: 'Skapat för poster av typen {recordType}. Granska och anpassa arbetsflödet innan du sparar.',
            guidedWorkflowPrompt: 'Granska den angivna posten av typen {recordType}, identifiera fakta som saknas och föreslå underbyggda nästa steg för mänsklig granskning.',
            costHint: 'Förkvotskontroll utlöses vid inlämning; körningar över kvoten returnerar 402 med en påfyllnings-CTA.',
            quotaExhausted: 'Token-bucket låg. Fyll på före omkörning.',
            promptHeading: 'Fråga',
            editWorkflowHeading: 'Redigera arbetsflöde',
            linkedTasksHint: 'Uppgifter skapade av detta arbetsflöde visas i uppgiftslistan filtrerade efter detta arbetsflödes-ID. Korslänkning kommer i 47.5.8.',
            notFound: 'Arbetsflöde hittades inte.',
            schedules: {
                tabTitle: 'Scheman',
                sectionHeading: 'Schemalagda körningar',
                empty: 'Inga scheman ännu. Skapa ett för att köra detta arbetsflöde automatiskt.',
                addButton: 'Lägg till schema',
                addHeading: 'Schemalägg arbetsflöde',
                editHeading: 'Redigera schema',
                fieldFrequency: 'Frekvens',
                fieldDayOfWeek: 'Veckodag',
                fieldDayOfMonth: 'Dag i månaden',
                fieldTime: 'Tid (UTC)',
                fieldTimezone: 'Tidszon',
                fieldProject: 'Projekt (valfritt)',
                fieldAttachments: 'Standardbilagor',
                fieldPersonaOverride: 'Persona-åsidosättning (valfritt)',
                frequencyDaily: 'Dagligen',
                frequencyWeekly: 'Veckovis',
                frequencyMonthly: 'Månadsvis',
                weekdaySun: 'Söndag',
                weekdayMon: 'Måndag',
                weekdayTue: 'Tisdag',
                weekdayWed: 'Onsdag',
                weekdayThu: 'Torsdag',
                weekdayFri: 'Fredag',
                weekdaySat: 'Lördag',
                statusActive: 'Aktiv',
                statusPaused: 'Pausad',
                nextRunLabel: 'Nästa körning',
                lastRunLabel: 'Senaste körning',
                pauseButton: 'Pausa',
                resumeButton: 'Återuppta',
                deleteButton: 'Ta bort',
                triggerButton: 'Kör nu',
                savingButton: 'Sparar…',
                saveButton: 'Spara',
                triggered: 'Körning startad — kontrollera körningshistoriken.',
            },
            branching: {
                helpHeading: 'Villkorlig prompt-syntax',
                helpBody: 'Använd {% if attachment.framework_code == "vn-pdpl" %}…{% endif %} för att variera prompten efter sammanhang. Tillåtna variabler: attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Nästlade {% if %}-block stöds inte.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Ramöverskridande konflikter',
            pageSubtitle: 'Utvald katalog över var dina installerade regulatoriska paket interagerar på motstridiga sätt. Forseti ytor; människor bestämmer.',
            noInstalledPacks: 'Inga regulatoriska paket installerade för den här organisationen – installera minst två paket för att hantera konflikter mellan ramar.',
            noConflicts: 'Inga konflikter matchar de aktuella filtren.',
            allAcknowledged: 'Varje synlig konflikt har erkänts. Bra jobbat.',
            columnSeverity: 'Allvarlighet',
            columnTitle: 'Titel',
            columnFrameworks: 'Ramar',
            columnTopic: 'Ämne',
            columnStatus: 'Status',
            filterFrameworkPlaceholder: 'Alla ramar',
            filterTopicPlaceholder: 'Alla ämnen',
            filterSeverityPlaceholder: 'Alla svårighetsgrader',
            filterStatusPlaceholder: 'Alla statusar',
            filterStatusAcknowledged: 'Erkänt',
            filterStatusUnacknowledged: 'Oerkänd',
            severityCritical: 'Kritisk',
            severityHigh: 'Hög',
            severityMedium: 'Medium',
            severityLow: 'Låg',
            statusAcknowledged: 'Erkänt',
            statusInReview: 'I recension',
            statusResolved: 'Löst',
            statusWontFix: 'Kommer inte att fixa',
            statusUnacknowledged: 'Oerkänd',
            drawerSummaryHeading: 'Sammanfattning',
            drawerSideAHeading: 'Sida A',
            drawerSideBHeading: 'Sida B',
            drawerRequirementsLabel: 'Angivna krav',
            drawerSuggestedResolutionHeading: 'Föreslagen upplösning',
            drawerLegalCounselBadge: 'Juridisk granskning krävs',
            drawerAckHeading: 'Bekräftelse',
            drawerAckStatusLabel: 'Status',
            drawerAckAssigneeLabel: 'Tilldelad till',
            drawerAckDueDateLabel: 'Förfallodatum',
            drawerAckNotesLabel: 'Anteckningar',
            drawerAckButtonAcknowledge: 'Bekräfta',
            drawerAckButtonUpdate: 'Uppdatering',
            drawerAckButtonUnacknowledge: 'Ta bort erkännande',
            searchPlaceholder: 'Sök efter titel eller sammanfattning...',
            searchButton: 'Sök',
            searchButtonAriaLabel: 'Kör konfliktsökning',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]]: [[TOK_1]]',
            exportErrorTemplate: 'Exporten misslyckades: [[TOK_1]]',
            exportAriaLabel: 'Exportkonflikter',
        },
        tabularReviews: {
            pageTitle: 'Tabulariska granskningar',
            pageSubtitle: 'Jämför N dokument över M attribut med underbyggda citat.',
            newReview: 'Ny granskning',
            newReviewHeading: 'Ny tabularisk granskning',
            emptyHint: 'Inga tabulariska granskningar ännu.',
            docsLabel: '{n} dokument',
            colsLabel: '{n} kolumner',
            detailSubtitle: '{docs} dokument · {cols} kolumner',
            addColumn: 'Lägg till kolumn',
            addColumnHeading: 'Lägg till kolumn',
            columnInfo: 'Visa prompt och format',
            columnInfoAria: 'Visa prompt och format för kolumnen {name}',
            columnInfoPrompt: 'Prompt',
            columnInfoFormat: 'Returformat',
            columnInfoPresets: 'Tillåtna värden',
            columnInfoCitations: 'Källhänvisningar',
            columnInfoCitationsRequired: 'Obligatoriskt',
            removeColumn: 'Ta bort kolumn',
            removeColumnAria: 'Ta bort kolumn {name}',
            removeColumnConfirm: 'Ta bort kolumnen "{name}"? Dess extraherade celler raderas.',
            deleteReview: 'Radera',
            deleteReviewAria: 'Radera granskning {title}',
            deleteReviewConfirm: 'Radera granskningen "{title}"? Detta tar permanent bort dess kolumner, celler och diskussioner.',
            runAll: 'Kör alla',
            running: 'Kör…',
            cancel: 'Avbryt',
            exportXlsx: 'Exportera Excel',
            exportCsv: 'Exportera CSV',
            exporting: 'Exporterar…',
            backToList: 'Tillbaka till listan',
            notFound: 'Tabularisk granskning hittades inte.',
            noDocuments: 'Bifoga dokument för att starta granskningen.',
            noColumns: 'Lägg till kolumner för att definiera vad som ska extraheras.',
            tableAriaLabel: 'Extraktionsrutnät',
            threadsCountAria: '{n} diskussionsinlägg',
            startDiscussionAria: 'Starta diskussion',
            docColumn: 'Dokument',
            statusPending: 'Väntar',
            statusRunning: 'Kör…',
            statusFailed: 'Misslyckades: {msg}',
            statusCancelled: 'Avbruten',
            citationsCount: '{n} citat',
            citationsView: 'Visa källutdrag',
            citationPage: 'Sida {n}',
            titleRequired: 'Titel krävs.',
            fieldTitle: 'Titel',
            fieldProjectId: 'Projekt (valfritt)',
            fieldAttachmentIds: 'Bilagor',
            fieldColumnName: 'Kolumnnamn',
            fieldColumnNameHelp: 'En kort, beskrivande etikett för denna kolumn i extraktionsrutnätet.',
            columnNamePlaceholder: 't.ex. Startdatum för avtal',
            fieldExtractionPrompt: 'Extraktionsprompt',
            fieldExtractionPromptHelp: 'Beskriv informationen du vill extrahera. Var specifik för att få bättre resultat.',
            columnPromptPlaceholder: 'Vad ska Forseti leta efter i dokumenten?',
            fieldReturnFormat: 'Returformat',
            fieldReturnFormatHelp: 'Styr hur AI:n formaterar sitt svar (t.ex. som ett datum eller ett tal).',
            fieldPresets: 'Tillåtna värden (ett per rad)',
            fieldPresetsPlaceholder: 'ja\nnej\ndelvis',
            fieldCitationsRequired: 'Citat krävs',
            formatShortText: 'Kort text',
            formatLongText: 'Lång text',
            formatEnum: 'Enum',
            formatNumber: 'Tal',
            formatDate: 'Datum',
            formatList: 'Lista',
            columnRequireFields: 'Namn och prompt krävs.',
            addColumnError: 'Det gick inte att lägga till kolumnen.',
            cancelButton: 'Avbryt',
            createButton: 'Skapa',
            creating: 'Skapar…',
            addButton: 'Lägg till',
            adding: 'Lägger till…',
            runConfirmHeading: 'Kör extraktion',
            estimateBody: 'Uppskattat ~{units} fakturerbara enheter ({confidence} förtroende).',
            costHint: 'Förkvotskontroll utlöses vid bekräftelse; körningar över kvoten returnerar 402 med en påfyllnings-CTA.',
            quotaExhausted: 'Token-bucket låg. Fyll på före omkörning.',
            starting: 'Startar…',
            confirmRun: 'Bekräfta körning',
            charts: {
                title: 'Kolumndiagram',
                tabsAria: 'Diagramkolumner',
                enumAria: 'Fördelning av enum-värden',
                numberAria: 'Histogram över talfördelning',
                dateAria: 'Datumtidslinje',
                enumEmpty: 'Inga slutförda celler.',
                numberEmpty: 'Inga numeriska värden.',
                numberExcluded: '{n} cell(er) uteslutna (tomma / icke-numeriska / ej slutförda).',
                dateEmpty: 'Inga datumvärden.',
                dateExcluded: '{n} cell(er) uteslutna.',
                unsupportedFormat: 'Kolumnformat stöds inte.',
            },
            threads: {
                drawerTitle: 'Diskussion',
                loading: 'Laddar…',
                empty: 'Inga inlägg ännu. Starta konversationen.',
                composerLabel: 'Ny kommentar',
                composerPlaceholder: 'Lägg till en kommentar…',
                post: 'Publicera',
                posting: 'Publicerar…',
                edit: 'Redigera',
                editLabel: 'Redigera inlägg',
                delete: 'Ta bort',
                save: 'Spara',
                cancel: 'Avbryt',
                close: 'Stäng',
                editedBadge: 'redigerat',
                loadError: 'Kunde inte ladda tråden',
                postError: 'Kunde inte publicera',
                editError: 'Kunde inte redigera',
                deleteError: 'Kunde inte ta bort',
            },
            compare: {
                pageTitle: 'Jämför granskningar',
                leftReviewLabel: 'Vänster granskning',
                rightReviewLabel: 'Höger granskning',
                pickReview: 'Välj en granskning att jämföra med',
                noSharedDocuments: 'Dessa granskningar delar inga dokument — jämförelse kräver minst en gemensam bilaga.',
                sharedDocumentsHeading: 'Delade dokument',
                leftOnlyHeading: 'Kolumner endast i vänster granskning',
                rightOnlyHeading: 'Kolumner endast i höger granskning',
                differs: 'Skiljer sig',
                identical: 'Identiska',
                emptyValue: '—',
                compareButton: 'Jämför med…',
                documentHeading: 'Dokument',
                errorMissingIds: 'Både vänster och höger gransknings-ID:n krävs.',
                errorComparisonFailed: 'Jämförelsen misslyckades.',
                errorLoadFailed: 'Kunde inte ladda granskningar.',
                pickerLoading: 'Laddar…',
                pickerNoOtherReviews: 'Inga andra granskningar tillgängliga att jämföra med.',
                pickerCancel: 'Avbryt',
            },
        },
        documentReview: {
            pageTitle: 'Dokumentgranskning',
            pageSubtitle: 'Acceptera eller avvisa [[TOK_0]]-föreslagna ändringar av detta dokument.',
            sidePanelLabel: '[[TOK_0]] röda linjer',
            sidePanelHeading: '[[TOK_0]] röda linjer',
            noPendingEdits: 'Inga väntande redigeringar.',
            pendingCount: '[[TOK_1]] väntar',
            acceptAllButton: 'Acceptera alla',
            rejectAllButton: 'Avvisa alla',
            acceptAllTitle: 'Acceptera alla väntande redigeringar?',
            acceptAllConfirm: 'Detta kommer att acceptera [[TOK_1]] väntande redigeringar och skapa en eller flera nya versioner. Fortsätta?',
            editsHeading: 'Redigeringar',
            editsEmpty: 'Inga ändringar att granska.',
            versionsHeading: 'Versionshistorik',
            versionsEmpty: 'Inga versioner ännu.',
            editLabel: 'Redigera',
            editLabelWithId: 'Redigera #{id}',
            acceptButton: 'Acceptera',
            rejectButton: 'Avvisa',
            accepting: 'Accepterar...',
            rejecting: 'Avvisar...',
            diffDeletedAria: 'Raderad',
            diffInsertedAria: 'Insatt',
            statusPending: 'Väntar',
            statusAccepted: 'Godkänd',
            statusRejected: 'Avvisad',
            versionLabel: 'Version',
            versionAriaLabel: 'Version [[TOK_1]]',
            versionAriaLabelCurrent: 'Version [[TOK_2]] ([[TOK_3]])',
            versionCurrentTag: 'nuvarande',
            versionSourceLabel: 'Källa',
            versionCreatedLabel: 'Skapad',
            versionModelLabel: 'Modell',
            sourceUpload: 'Ladda upp',
            sourceUserUpload: 'Användaruppladdning',
            sourceAssistantEdit: 'Assistent redigering',
            sourceUserAccept: 'Användaren accepterade redigeringen',
            sourceUserReject: 'Användaren avvisade redigeringen',
            sourceGenerated: 'Genererad',
        },
        documentReviewIndex: {
            sidebarLabel: 'Dokumentgranskning',
            pageTitle: 'Dokumentgranskning',
            pageSubtitle: 'Dokument i din organisation som har AI-föreslagna redigeringar väntande på granskning eller Forseti-källversioner.',
            colDocument: 'Dokument',
            colLinkedRecord: 'Länkad post',
            colPendingEdits: 'Väntande redigeringar',
            colLastActivity: 'Senaste aktivitet',
            colOpen: 'Öppna',
            open: 'Öppna',
            empty: 'Inga dokument under Forseti-granskning ännu. Dokument kommer in i denna kö när Forseti föreslår en redigering under en chatt, när ett AI-arbetsflöde producerar en redline, eller när du skickar ett dokument för granskning med knappen ovan.',
            loading: 'Laddar…',
            loadError: 'Kunde inte ladda dokument under granskning.',
            retryButton: 'Försök igen',
            noLinkedRecord: '—',
            pendingZero: 'Inga',
            sendForReviewButton: 'Skicka ett dokument för granskning',
            sendForReviewTitle: 'Skicka ett dokument för granskning',
            sendForReviewSubtitle: 'Välj en befintlig bilaga från denna organisation, eller ladda upp en ny fil. Dokumentet läggs till i granskningskön och Forseti kommer att utföra en redline-genomgång på det.',
            sendForReviewTabPick: 'Välj befintlig',
            sendForReviewTabUpload: 'Ladda upp ny',
            sendForReviewPickerLabel: 'Sök bilagor',
            sendForReviewPickerPlaceholder: 'Skriv för att söka…',
            sendForReviewPickerEmpty: 'Inga matchande bilagor. Försök med en annan sökning.',
            sendForReviewSubmit: 'Skicka för granskning',
            sendForReviewCancel: 'Avbryt',
            sendForReviewSubmitting: 'Skickar…',
            sendForReviewError: 'Kunde inte skicka dokumentet för granskning. Försök igen.',
            sendForReviewSuccess: 'Dokument skickat för granskning.',
            sendForReviewAcceptedExt: 'Accepterade: {ext}.',
            sendForReviewMaxSize: 'Maxstorlek {mb} MB.',
        },
        chats: {
            exportError: 'Export misslyckades.',
        },
    },
    pdplEvidencePacks: {
        title: 'PDPL-bevispaket',
        subtitle: 'Kundkontrollerad inlämning till MoPS A05',
        nav: { emailProviders: 'E-postleverantörer' },
        providers: {
            pageTitle: 'E-postleverantörer',
            pageSubtitle: 'Konfigurera organisationens utgående e-postleverantör för PDPL-bevispaket till MoPS A05.',
            architectureRuleHeading: 'Arkitekturregel (låst)',
            architectureRuleBody: 'AesirX är inte avsändare av bevispostmeddelanden. Varje sändning använder en leverantör som du äger och kontrollerar. AesirX skickar aldrig för din räkning.',
            empty: 'Inga leverantörer är konfigurerade ännu.',
            createCta: 'Skapa leverantör',
            statusPendingConsent: 'Väntar på samtycke',
            statusPendingConnectionCheck: 'Väntar på anslutningstest',
            statusActive: 'Aktiv',
            statusConnectionCheckFailed: 'Anslutningstestet misslyckades',
            statusDisabled: 'Inaktiverad',
            acceptConsentCta: 'Acceptera samtycke',
            runConnectionCheckCta: 'Kör anslutningstest',
            disableCta: 'Inaktivera',
            disableConfirm: 'Att inaktivera den här leverantören stoppar direktsändningar tills en ny leverantör är konfigurerad och samtycket bekräftats på nytt. Fortsätta?',
            columnDisplayName: 'Namn',
            columnFromAddress: 'Avsändaradress',
            columnStatus: 'Status',
            columnLastCheck: 'Senaste test',
            columnActions: 'Åtgärder',
            createModalTitle: 'Ny SMTP-leverantör',
            createDisplayNameLabel: 'Visningsnamn',
            createFromAddressLabel: 'Avsändaradress',
            createReplyToLabel: 'Svarsadress (valfritt)',
            createSmtpHostLabel: 'SMTP-värd',
            createSmtpPortLabel: 'SMTP-port',
            createSmtpUsernameLabel: 'SMTP-användarnamn',
            createSmtpPasswordLabel: 'SMTP-lösenord',
            createSmtpEncryptionLabel: 'Kryptering',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (implicit)',
            createSmtpEncryptionNone: 'Ingen',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Kommer snart',
            createOauthDisabledHint: 'OAuth-leverantörer är ännu inte aktiverade. Använd SMTP tills vidare.',
            createSubmitCta: 'Skapa leverantör',
            createCancelCta: 'Avbryt',
            createErrorInvalidFromAddress: 'Avsändaradressen måste vara en giltig e-postlåda.',
            createErrorDuplicateFromAddress: 'En annan leverantör är redan konfigurerad för denna avsändaradress.',
            createErrorGeneric: 'Det gick inte att skapa leverantören. Granska formuläret och försök igen.',
            consentModalTitle: 'Bekräfta arkitekturregel',
            consentLocaleToggleEn: 'Engelska',
            consentLocaleToggleVi: 'Vietnamesiska',
            consentAcknowledgeCta: 'Jag bekräftar — acceptera samtycke',
            consentCancelCta: 'Avbryt',
            consentErrorMismatch: 'Samtyckestexten har ändrats och matchar inte längre den ursprungliga friskrivningen. Öppna dialogen igen och skicka in på nytt.',
            testModalTitle: 'Anslutningstest',
            testRunningCta: 'Testar anslutning…',
            testRunCta: 'Kör anslutningstest',
            testRetryCta: 'Försök igen',
            testSuccessHeading: 'Anslutning klar',
            testSuccessBody: 'Autentiserad mot {host}:{port} på {latencyMs} ms. Leverantören är redo för direktsändning.',
            testFailureHeading: 'Anslutning misslyckades',
            testFailureBody: 'Testet kunde inte slutföras. Granska orsaken nedan och försök igen när den är åtgärdad.',
            testFailureReasonLabel: 'Felorsak',
            testCloseCta: 'Stäng',
            detailDrawerTitle: 'Leverantörsinformation',
            detailDrawerHistoryHeading: 'Historik för anslutningstest',
            detailDrawerConsentHeading: 'Samtyckesbekräftelse',
            detailDrawerNoHistory: 'Inga anslutningstest registrerade ännu.',
            detailDrawerNoConsent: 'Samtycke har inte bekräftats.',
            outcomeSuccess: 'Lyckades',
            outcomeFailure: 'Misslyckades',
        },
        builder: {
            pageTitle: 'Montera bevispaket',
            pageSubtitle: 'Ladda upp de 6 delfilerna, välj pakettyp och montera den deterministiska 8-delars ZIP för inlämning.',
            packTypeLabel: 'Pakettyp',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Del 01 — Följebrev (PDF)',
            part02AuthorityForm: 'Del 02 — Myndighetsformulär (PDF)',
            part03Supporting: 'Del 03 — Stödjande bevis (≥1)',
            part04Safeguards: 'Del 04 — Skyddsåtgärder',
            part04SafeguardsRequiredOtia: '(krävs för OTIA)',
            part05PriorCorrespondence: 'Del 05 — Tidigare korrespondens (valfri)',
            part06Signature: 'Del 06 — Underskrift + stämpelbevis (≥1)',
            uploadPickFile: 'Välj fil',
            uploadPickFiles: 'Välj filer',
            uploadRemoveFile: 'Ta bort',
            requiredMissing: 'Obligatorisk del saknas',
            assembleCta: 'Montera paket',
            assembling: 'Monterar…',
            assembleSuccessHeading: 'Paket monterat',
            assembleSuccessSummary: '{fileCount} filer · {bytes} byte · SHA-256 {shaPrefix}…',
            composeNextCta: 'Skriv e-postutkast',
            warningsHeading: 'Valideringsvarningar',
            assembleError: 'Det gick inte att montera paketet. Granska indata och försök igen.',
            forsetiAssistHeading: 'Forseti AI-assistans (valfri)',
            forsetiAssistHint: 'Kör PDPL Evidence Pack Assembly Advisor för att lyfta saknade delar, utarbeta följebrevsprosa och flagga skyddsluckor. AesirX är inte avsändaren — AI-n rådger endast; du godkänner varje artefakt.',
            forsetiAssistCta: 'Öppna Forseti workflow-bibliotek',
            forsetiAiRunIdLabel: 'Länkat Forseti AI-körnings-id (klistra in för att registrera AI-assistans)',
        },
        draft: {
            pageTitle: 'E-postutkast',
            pageSubtitle: 'Skriv och redigera e-postutkastet. Direktsändning kommer i en senare release.',
            composeCta: 'Skriv utkast',
            composing: 'Skriver…',
            noDraftYet: 'Inget utkast ännu. Skriv ett för att komma igång.',
            localeToggleLabel: 'Språk',
            localeEn: 'Engelska',
            localeVi: 'Vietnamesiska',
            subjectLabel: 'Ämne',
            bodyLabel: 'Brödtext',
            saveCta: 'Spara ändringar',
            saving: 'Sparar…',
            saveError: 'Det gick inte att spara utkastet. Försök igen.',
            manifestSummaryLabel: 'Manifest-sammanfattning',
            coverLetterLabel: 'Följebrev (PDF)',
            coverLetterDownloadCta: 'Hämta PDF',
            editHistoryHeading: 'Redigeringshistorik',
            editHistoryEmpty: 'Inga redigeringar ännu.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 inofficiell kanal-notis',
            uploadSentProofCta: 'Ladda upp manuellt sändningsbevis',
            versionLabel: 'Version',
            statusDraft: 'Utkast',
            statusEdited: 'Redigerad',
            statusFinalized: 'Slutförd',
        },
        sentProof: {
            modalTitle: 'Ladda upp manuellt sändningsbevis',
            architectureLockNote: 'AesirX är inte avsändaren. Detta bevis fångar den manuella sändning du genomförde via ditt eget mejlprogram.',
            fileLabel: 'Bevisfil (.eml, .png, .jpg)',
            envelopeFromLabel: 'Från',
            envelopeToLabel: 'Till',
            envelopeSubjectLabel: 'Ämne (vid sändning)',
            envelopeSentAtLabel: 'Skickad',
            envelopeAttachmentShaLabel: 'Bilaga SHA-256 (vid sändning)',
            uploadCta: 'Ladda upp bevis',
            uploading: 'Laddar upp…',
            uploadSuccess: 'Sändningsbevis uppladdat.',
            uploadErrorInvalidMime: 'Filtyp inte tillåten. Använd .eml, .png, .jpg eller .jpeg.',
            uploadErrorGeneric: 'Det gick inte att ladda upp beviset. Försök igen.',
            existingProofsHeading: 'Registrerade sändningsbevis',
            existingProofsEmpty: 'Inga sändningsbevis registrerade ännu.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Bevispaket',
            notFoundMessage: 'Paketet hittades inte — det kan ha tagits bort eller länken är felaktig.',
            manifestHeading: 'Manifest',
            dossierLabel: 'Ärende',
            packShaLabel: 'Paket-SHA-256',
            fileCountLabel: 'Filer',
            bytesLabel: 'Storlek',
            composeDraftCta: 'Skriv utkast',
            sendComingSoonCta: 'Direktsändning: kommer snart',
            sendComingSoonHint: 'Direktsändningsflödet utvecklas aktivt. Använd "Ladda upp manuellt sändningsbevis" på utkastsidan tills det levereras.',
            sendCta: 'Skicka via konfigurerad leverantör',
            sendDisabledNoProviderHint: 'Konfigurera först en kundstyrd e-postleverantör. AesirX skickar aldrig å dina vägnar.',
            timelineHeading: 'Sändningshistorik',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Skicka bevispaket',
            providerPickerLabel: 'Konfigurerad e-postleverantör',
            providerPickerHint: 'AesirX skickar aldrig å dina vägnar. Välj en av dina konfigurerade leverantörer nedan.',
            providerPickerEmpty: 'Inga aktiva leverantörer är konfigurerade. Konfigurera en på sidan E-postleverantörer innan du skickar.',
            providerPickerEmptyCta: 'Öppna E-postleverantörer',
            draftPickerLabel: 'E-postutkast',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: 'Inga utkast har skrivits för detta paket ännu. Skriv ett först på utkastsidan.',
            recipientToLabel: 'Till',
            recipientToHint: 'En eller flera e-postadresser, separerade med komma.',
            recipientCcLabel: 'Kopia (kommaseparerat)',
            recipientCcHint: 'Valfritt. Kommaseparerad lista över e-postadresser.',
            recipientBccLabel: 'Hemlig kopia (kommaseparerat)',
            recipientBccHint: 'Valfritt. Kommaseparerad lista över e-postadresser.',
            consentReaffirmHeading: 'Bekräfta leverantörssamtycke på nytt',
            submitCta: 'Skicka nu',
            sending: 'Skickar…',
            cancelCta: 'Avbryt',
            sendSuccess: 'Sändning registrerad. Paketet har överförts via din konfigurerade leverantör.',
            sendErrorGeneric: 'Paketet kunde inte skickas. Granska felet nedan och försök igen.',
            sendErrorAlreadyFinalized: 'Detta utkast har redan använts för en lyckad sändning. Skriv ett nytt utkast innan du skickar igen.',
            sendErrorInvalidRecipients: 'En eller flera mottagaradresser är inte giltiga e-postlådor.',
            // Timeline
            timelineEmpty: 'Inga sändningar är registrerade ännu. Använd "Skicka via konfigurerad leverantör" ovan för att överföra via din kundstyrda SMTP / Microsoft 365 / Google Workspace-leverantör.',
            timelineProviderLabel: 'Skickat via din konfigurerade leverantör',
            timelineSentAtLabel: 'Skickat',
            timelineRecipientLabel: 'Mottagare',
            timelineOutcomeSent: 'Skickat',
            timelineOutcomeFailed: 'Misslyckades',
            timelineViewDetailsCta: 'Visa detaljer',
            // Authority-response chips
            authorityChipNone: 'Väntar på svar',
            authorityChipAcknowledgement: 'Bekräftelse',
            authorityChipAcceptance: 'Godkännande',
            authorityChipRejection: 'Avslag',
            authorityChipSupplementRequest: 'Begäran om komplettering',
            authorityChipNoResponse: 'Inget svar',
            // Hard-copy chips
            hardCopyChipNone: 'Ingen fysisk uppföljning',
            hardCopyChipPending: 'Postad — leverans väntar',
            hardCopyChipDelivered: 'Levererad',
            // Drawer
            drawerTitle: 'Sändningspost',
            drawerEnvelopeHeading: 'Kuvert',
            drawerEnvelopeFromLabel: 'Från',
            drawerEnvelopeToLabel: 'Till',
            drawerEnvelopeCcLabel: 'Kopia',
            drawerEnvelopeBccLabel: 'Hemlig kopia',
            drawerEnvelopeSubjectLabel: 'Ämne',
            drawerEnvelopeMessageIdLabel: 'Meddelande-ID',
            drawerOutcomeHeading: 'Resultat',
            drawerSnapshotHeading: 'Ögonblicksbild av förvaringskedja',
            drawerSnapshotPackShaLabel: 'Paket-SHA-256 vid sändning',
            drawerSnapshotDraftVersionLabel: 'Utkastversion vid sändning',
            drawerSnapshotAttachmentLabel: 'Överförd ZIP',
            drawerSnapshotAttachmentDownloadCta: 'Ladda ner ZIP',
            drawerAuthorityResponseHeading: 'Myndighetssvar',
            drawerHardCopyHeading: 'Fysisk uppföljning',
            drawerSentByLabel: 'Skickat av',
            drawerSendIdLabel: 'Sändnings-id',
            drawerSmtpResponseLabel: 'SMTP-svar',
            drawerFailureReasonLabel: 'Felorsak',
            drawerLatencyLabel: 'Latens',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Accepterad',
            drawerRejectedLabel: 'Avvisad',
            drawerCloseCta: 'Stäng',
            // Authority-response panel
            authorityRecordCta: 'Registrera svar',
            authorityReclassifyCta: 'Omklassificera',
            authorityClassificationLabel: 'Klassificering',
            authorityReceivedAtLabel: 'Mottaget',
            authorityFreeTextLabel: 'Anteckningar (valfritt)',
            authorityEvidenceLabel: 'Bevisfil (.eml / .pdf / .png / .jpg — valfritt)',
            authorityReasonLabel: 'Skäl för omklassificering',
            authorityHistoryHeading: 'Historik för omklassificering',
            authorityHistoryEmpty: 'Inga omklassificeringar har registrerats.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Spara svar',
            authoritySubmitting: 'Sparar…',
            authorityErrorInvalidMime: 'Bevisfiltyp tillåts inte. Använd .eml, .pdf, .png eller .jpg.',
            authorityErrorGeneric: 'Svaret kunde inte sparas. Försök igen.',
            authorityRecordedAtLabel: 'Registrerat',
            authorityRecordedByLabel: 'Registrerat av',
            authorityEvidenceFilenameLabel: 'Bevis',
            authorityEvidenceDownloadCta: 'Ladda ner bevis',
            // Hard-copy panel
            hardCopyRecordCta: 'Logga fysisk uppföljning',
            hardCopyConfirmCta: 'Bekräfta leverans',
            hardCopyEditNotesCta: 'Redigera leveransanteckningar',
            hardCopyPostedAtLabel: 'Postat',
            hardCopyCourierLabel: 'Kurir',
            hardCopyTrackingLabel: 'Spårningsnummer',
            hardCopyRecipientLabel: 'Mottagare på etiketten',
            hardCopyReceiptLabel: 'Kvittobevis (.pdf / .png / .jpg — valfritt)',
            hardCopyReceiptDownloadCta: 'Ladda ner kvitto',
            hardCopyDeliveredAtLabel: 'Levererat',
            hardCopyDeliveryNotesLabel: 'Leveransanteckningar (valfritt)',
            hardCopySubmitCta: 'Spara uppföljning',
            hardCopySubmitting: 'Sparar…',
            hardCopyErrorInvalidMime: 'Kvittofiltyp tillåts inte. Använd .pdf, .png eller .jpg.',
            hardCopyErrorGeneric: 'Uppföljningen kunde inte sparas. Försök igen.',
        },
    },
};
//# sourceMappingURL=sv.js.map